
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire00a9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire00a9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4uHIT", function(module, exports) {
module.exports = $parcel$resolve("l7xLV");

});

parcelRegister("hPrdo", function(module, exports) {
module.exports = $parcel$resolve("i2Em1");

});

parcelRegister("LhvME", function(module, exports) {
module.exports = $parcel$resolve("gTZfs");

});

parcelRegister("kLkjS", function(module, exports) {
module.exports = $parcel$resolve("aLOKL");

});

parcelRegister("kAdE5", function(module, exports) {
module.exports = $parcel$resolve("b3JhR");

});

var $bdf076e33916a74a$exports = {};
$parcel$extendImportMap({
    "l7xLV": "sg-rail.geo.8647379a.json",
    "i2Em1": "exit.e26c7e09.png",
    "gTZfs": "stations.7a17ff55.png",
    "aLOKL": "sg-rail-walks.geo.c174585d.json",
    "b3JhR": "walk.334861b6.png",
    "hmE4i": "sw.js"
});

// https://github.com/parcel-bundler/parcel/issues/3375#issuecomment-599160200
function $8903e050be105bd4$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $51d5724a731318ae$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $51d5724a731318ae$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $51d5724a731318ae$exports));
try {
    regeneratorRuntime = $51d5724a731318ae$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $51d5724a731318ae$var$runtime;
    else Function("r", "regeneratorRuntime = r")($51d5724a731318ae$var$runtime);
}


/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ 
function $af1de73228d7b2e0$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $8903e050be105bd4$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $a986e50c62b713b0$var$isArray(value) {
    return !Array.isArray ? $a986e50c62b713b0$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $a986e50c62b713b0$var$INFINITY = 1 / 0;
function $a986e50c62b713b0$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$a986e50c62b713b0$var$INFINITY ? '-0' : result;
}
function $a986e50c62b713b0$var$toString(value) {
    return value == null ? '' : $a986e50c62b713b0$var$baseToString(value);
}
function $a986e50c62b713b0$var$isString(value) {
    return typeof value === 'string';
}
function $a986e50c62b713b0$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $a986e50c62b713b0$var$isBoolean(value) {
    return value === true || value === false || $a986e50c62b713b0$var$isObjectLike(value) && $a986e50c62b713b0$var$getTag(value) == '[object Boolean]';
}
function $a986e50c62b713b0$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $a986e50c62b713b0$var$isObjectLike(value) {
    return $a986e50c62b713b0$var$isObject(value) && value !== null;
}
function $a986e50c62b713b0$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $a986e50c62b713b0$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $a986e50c62b713b0$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $a986e50c62b713b0$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $a986e50c62b713b0$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $a986e50c62b713b0$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $a986e50c62b713b0$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $a986e50c62b713b0$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $a986e50c62b713b0$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $a986e50c62b713b0$var$hasOwn = Object.prototype.hasOwnProperty;
class $a986e50c62b713b0$var$KeyStore {
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $a986e50c62b713b0$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
}
function $a986e50c62b713b0$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($a986e50c62b713b0$var$isString(key) || $a986e50c62b713b0$var$isArray(key)) {
        src = key;
        path = $a986e50c62b713b0$var$createKeyPath(key);
        id = $a986e50c62b713b0$var$createKeyId(key);
    } else {
        if (!$a986e50c62b713b0$var$hasOwn.call(key, 'name')) throw new Error($a986e50c62b713b0$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($a986e50c62b713b0$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($a986e50c62b713b0$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $a986e50c62b713b0$var$createKeyPath(name);
        id = $a986e50c62b713b0$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $a986e50c62b713b0$var$createKeyPath(key) {
    return $a986e50c62b713b0$var$isArray(key) ? key : key.split('.');
}
function $a986e50c62b713b0$var$createKeyId(key) {
    return $a986e50c62b713b0$var$isArray(key) ? key.join('.') : key;
}
function $a986e50c62b713b0$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$a986e50c62b713b0$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$a986e50c62b713b0$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($a986e50c62b713b0$var$isString(value) || $a986e50c62b713b0$var$isNumber(value) || $a986e50c62b713b0$var$isBoolean(value))) list.push($a986e50c62b713b0$var$toString(value));
            else if ($a986e50c62b713b0$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $a986e50c62b713b0$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $a986e50c62b713b0$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $a986e50c62b713b0$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $a986e50c62b713b0$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $a986e50c62b713b0$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $a986e50c62b713b0$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $a986e50c62b713b0$var$Config = (0, $af1de73228d7b2e0$export$71511d61b312f219)({}, $a986e50c62b713b0$var$BasicOptions, $a986e50c62b713b0$var$MatchOptions, $a986e50c62b713b0$var$FuzzyOptions, $a986e50c62b713b0$var$AdvancedOptions);
const $a986e50c62b713b0$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $a986e50c62b713b0$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($a986e50c62b713b0$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $a986e50c62b713b0$var$FuseIndex {
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($a986e50c62b713b0$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($a986e50c62b713b0$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$a986e50c62b713b0$var$isDefined(doc) || $a986e50c62b713b0$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$a986e50c62b713b0$var$isDefined(value)) return;
            if ($a986e50c62b713b0$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$a986e50c62b713b0$var$isDefined(value)) continue;
                    if ($a986e50c62b713b0$var$isString(value) && !$a986e50c62b713b0$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($a986e50c62b713b0$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($a986e50c62b713b0$var$isString(value) && !$a986e50c62b713b0$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
    constructor({ getFn: getFn = $a986e50c62b713b0$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a986e50c62b713b0$var$Config.fieldNormWeight } = {}){
        this.norm = $a986e50c62b713b0$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
}
function $a986e50c62b713b0$var$createIndex(keys, docs, { getFn: getFn = $a986e50c62b713b0$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a986e50c62b713b0$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $a986e50c62b713b0$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($a986e50c62b713b0$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $a986e50c62b713b0$var$parseIndex(data, { getFn: getFn = $a986e50c62b713b0$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a986e50c62b713b0$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $a986e50c62b713b0$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $a986e50c62b713b0$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $a986e50c62b713b0$var$Config.distance, ignoreLocation: ignoreLocation = $a986e50c62b713b0$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $a986e50c62b713b0$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $a986e50c62b713b0$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $a986e50c62b713b0$var$MAX_BITS = 32;
function $a986e50c62b713b0$var$search(text, pattern, patternAlphabet, { location: location = $a986e50c62b713b0$var$Config.location, distance: distance = $a986e50c62b713b0$var$Config.distance, threshold: threshold = $a986e50c62b713b0$var$Config.threshold, findAllMatches: findAllMatches = $a986e50c62b713b0$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a986e50c62b713b0$var$Config.minMatchCharLength, includeMatches: includeMatches = $a986e50c62b713b0$var$Config.includeMatches, ignoreLocation: ignoreLocation = $a986e50c62b713b0$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $a986e50c62b713b0$var$MAX_BITS) throw new Error($a986e50c62b713b0$var$PATTERN_LENGTH_TOO_LARGE($a986e50c62b713b0$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $a986e50c62b713b0$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $a986e50c62b713b0$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $a986e50c62b713b0$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $a986e50c62b713b0$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $a986e50c62b713b0$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $a986e50c62b713b0$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $a986e50c62b713b0$var$BitapSearch {
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $a986e50c62b713b0$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
    constructor(pattern, { location: location = $a986e50c62b713b0$var$Config.location, threshold: threshold = $a986e50c62b713b0$var$Config.threshold, distance: distance = $a986e50c62b713b0$var$Config.distance, includeMatches: includeMatches = $a986e50c62b713b0$var$Config.includeMatches, findAllMatches: findAllMatches = $a986e50c62b713b0$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a986e50c62b713b0$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $a986e50c62b713b0$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $a986e50c62b713b0$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $a986e50c62b713b0$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $a986e50c62b713b0$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $a986e50c62b713b0$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $a986e50c62b713b0$var$MAX_BITS), i);
                i += $a986e50c62b713b0$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $a986e50c62b713b0$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
}
class $a986e50c62b713b0$var$BaseMatch {
    static isMultiMatch(pattern) {
        return $a986e50c62b713b0$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $a986e50c62b713b0$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
    constructor(pattern){
        this.pattern = pattern;
    }
}
function $a986e50c62b713b0$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $a986e50c62b713b0$var$ExactMatch extends $a986e50c62b713b0$var$BaseMatch {
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !fire
class $a986e50c62b713b0$var$InverseExactMatch extends $a986e50c62b713b0$var$BaseMatch {
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: ^file
class $a986e50c62b713b0$var$PrefixExactMatch extends $a986e50c62b713b0$var$BaseMatch {
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !^fire
class $a986e50c62b713b0$var$InversePrefixExactMatch extends $a986e50c62b713b0$var$BaseMatch {
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: .file$
class $a986e50c62b713b0$var$SuffixExactMatch extends $a986e50c62b713b0$var$BaseMatch {
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !.file$
class $a986e50c62b713b0$var$InverseSuffixExactMatch extends $a986e50c62b713b0$var$BaseMatch {
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
class $a986e50c62b713b0$var$FuzzyMatch extends $a986e50c62b713b0$var$BaseMatch {
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
    constructor(pattern, { location: location = $a986e50c62b713b0$var$Config.location, threshold: threshold = $a986e50c62b713b0$var$Config.threshold, distance: distance = $a986e50c62b713b0$var$Config.distance, includeMatches: includeMatches = $a986e50c62b713b0$var$Config.includeMatches, findAllMatches: findAllMatches = $a986e50c62b713b0$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a986e50c62b713b0$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $a986e50c62b713b0$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $a986e50c62b713b0$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $a986e50c62b713b0$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
}
// Token: 'file
class $a986e50c62b713b0$var$IncludeMatch extends $a986e50c62b713b0$var$BaseMatch {
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// ❗Order is important. DO NOT CHANGE.
const $a986e50c62b713b0$var$searchers = [
    $a986e50c62b713b0$var$ExactMatch,
    $a986e50c62b713b0$var$IncludeMatch,
    $a986e50c62b713b0$var$PrefixExactMatch,
    $a986e50c62b713b0$var$InversePrefixExactMatch,
    $a986e50c62b713b0$var$InverseSuffixExactMatch,
    $a986e50c62b713b0$var$SuffixExactMatch,
    $a986e50c62b713b0$var$InverseExactMatch,
    $a986e50c62b713b0$var$FuzzyMatch
];
const $a986e50c62b713b0$var$searchersLen = $a986e50c62b713b0$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $a986e50c62b713b0$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $a986e50c62b713b0$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $a986e50c62b713b0$var$parseQuery(pattern, options = {}) {
    return pattern.split($a986e50c62b713b0$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($a986e50c62b713b0$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $a986e50c62b713b0$var$searchersLen){
                const searcher = $a986e50c62b713b0$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $a986e50c62b713b0$var$searchersLen){
                const searcher = $a986e50c62b713b0$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $a986e50c62b713b0$var$MultiMatchSet = new Set([
    $a986e50c62b713b0$var$FuzzyMatch.type,
    $a986e50c62b713b0$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $a986e50c62b713b0$var$ExtendedSearch {
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($a986e50c62b713b0$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $a986e50c62b713b0$var$Config.isCaseSensitive, includeMatches: includeMatches = $a986e50c62b713b0$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $a986e50c62b713b0$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $a986e50c62b713b0$var$Config.ignoreLocation, findAllMatches: findAllMatches = $a986e50c62b713b0$var$Config.findAllMatches, location: location = $a986e50c62b713b0$var$Config.location, threshold: threshold = $a986e50c62b713b0$var$Config.threshold, distance: distance = $a986e50c62b713b0$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $a986e50c62b713b0$var$parseQuery(this.pattern, this.options);
    }
}
const $a986e50c62b713b0$var$registeredSearchers = [];
function $a986e50c62b713b0$var$register(...args) {
    $a986e50c62b713b0$var$registeredSearchers.push(...args);
}
function $a986e50c62b713b0$var$createSearcher(pattern, options) {
    for(let i = 0, len = $a986e50c62b713b0$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $a986e50c62b713b0$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $a986e50c62b713b0$var$BitapSearch(pattern, options);
}
const $a986e50c62b713b0$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $a986e50c62b713b0$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $a986e50c62b713b0$var$isExpression = (query)=>!!(query[$a986e50c62b713b0$var$LogicalOperator.AND] || query[$a986e50c62b713b0$var$LogicalOperator.OR]);
const $a986e50c62b713b0$var$isPath = (query)=>!!query[$a986e50c62b713b0$var$KeyType.PATH];
const $a986e50c62b713b0$var$isLeaf = (query)=>!$a986e50c62b713b0$var$isArray(query) && $a986e50c62b713b0$var$isObject(query) && !$a986e50c62b713b0$var$isExpression(query);
const $a986e50c62b713b0$var$convertToExplicit = (query)=>({
        [$a986e50c62b713b0$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $a986e50c62b713b0$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $a986e50c62b713b0$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$a986e50c62b713b0$var$isExpression(query)) return next($a986e50c62b713b0$var$convertToExplicit(query));
        if ($a986e50c62b713b0$var$isLeaf(query)) {
            const key = isQueryPath ? query[$a986e50c62b713b0$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$a986e50c62b713b0$var$KeyType.PATTERN] : query[key];
            if (!$a986e50c62b713b0$var$isString(pattern)) throw new Error($a986e50c62b713b0$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $a986e50c62b713b0$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $a986e50c62b713b0$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($a986e50c62b713b0$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$a986e50c62b713b0$var$isExpression(query)) query = $a986e50c62b713b0$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $a986e50c62b713b0$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $a986e50c62b713b0$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $a986e50c62b713b0$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$a986e50c62b713b0$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$a986e50c62b713b0$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $a986e50c62b713b0$var$transformScore(result, data) {
    data.score = result.score;
}
function $a986e50c62b713b0$var$format(results, docs, { includeMatches: includeMatches = $a986e50c62b713b0$var$Config.includeMatches, includeScore: includeScore = $a986e50c62b713b0$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($a986e50c62b713b0$var$transformMatches);
    if (includeScore) transformers.push($a986e50c62b713b0$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $a986e50c62b713b0$export$2e2bcd8739ae039 {
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $a986e50c62b713b0$var$FuseIndex)) throw new Error($a986e50c62b713b0$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $a986e50c62b713b0$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$a986e50c62b713b0$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $a986e50c62b713b0$var$isString(query) ? $a986e50c62b713b0$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $a986e50c62b713b0$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($a986e50c62b713b0$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $a986e50c62b713b0$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $a986e50c62b713b0$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$a986e50c62b713b0$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $a986e50c62b713b0$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $a986e50c62b713b0$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($a986e50c62b713b0$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $a986e50c62b713b0$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$a986e50c62b713b0$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$a986e50c62b713b0$var$isDefined(value)) return [];
        let matches = [];
        if ($a986e50c62b713b0$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$a986e50c62b713b0$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
    constructor(docs, options = {}, index){
        this.options = (0, $af1de73228d7b2e0$export$71511d61b312f219)({}, $a986e50c62b713b0$var$Config, options);
        this.options.useExtendedSearch;
        this._keyStore = new $a986e50c62b713b0$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
}
$a986e50c62b713b0$export$2e2bcd8739ae039.version = '6.6.2';
$a986e50c62b713b0$export$2e2bcd8739ae039.createIndex = $a986e50c62b713b0$var$createIndex;
$a986e50c62b713b0$export$2e2bcd8739ae039.parseIndex = $a986e50c62b713b0$var$parseIndex;
$a986e50c62b713b0$export$2e2bcd8739ae039.config = $a986e50c62b713b0$var$Config;
$a986e50c62b713b0$export$2e2bcd8739ae039.parseQuery = $a986e50c62b713b0$var$parse;
$a986e50c62b713b0$var$register($a986e50c62b713b0$var$ExtendedSearch);


var $512f0610cec951ce$exports = {};
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */ (function(global, factory) {
    $512f0610cec951ce$exports = factory();
})($512f0610cec951ce$exports, function() {
    'use strict';
    /* eslint-disable */ var shared, worker, mapboxgl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
            var sharedChunk = {};
            shared(sharedChunk);
            mapboxgl = chunk(sharedChunk);
            if (typeof window !== 'undefined' && window && window.URL && window.URL.createObjectURL) mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: 'text/javascript'
            }));
        }
    }
    define([
        "exports"
    ], function(t1) {
        "use strict";
        var e1 = "undefined" != typeof self ? self : {}, r = n;
        function n(t1, e1, r, n) {
            this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = n, this.p2x = r, this.p2y = n;
        }
        n.prototype.sampleCurveX = function(t1) {
            return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
        }, n.prototype.sampleCurveY = function(t1) {
            return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
        }, n.prototype.sampleCurveDerivativeX = function(t1) {
            return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
        }, n.prototype.solveCurveX = function(t1, e1) {
            var r, n, i, s, a;
            for(void 0 === e1 && (e1 = 1e-6), i = t1, a = 0; a < 8; a++){
                if (s = this.sampleCurveX(i) - t1, Math.abs(s) < e1) return i;
                var o = this.sampleCurveDerivativeX(i);
                if (Math.abs(o) < 1e-6) break;
                i -= s / o;
            }
            if ((i = t1) < (r = 0)) return r;
            if (i > (n = 1)) return n;
            for(; r < n;){
                if (s = this.sampleCurveX(i), Math.abs(s - t1) < e1) return i;
                t1 > s ? r = i : n = i, i = .5 * (n - r) + r;
            }
            return i;
        }, n.prototype.solve = function(t1, e1) {
            return this.sampleCurveY(this.solveCurveX(t1, e1));
        };
        var i = s;
        function s(t1, e1) {
            this.x = t1, this.y = e1;
        }
        s.prototype = {
            clone: function() {
                return new s(this.x, this.y);
            },
            add: function(t1) {
                return this.clone()._add(t1);
            },
            sub: function(t1) {
                return this.clone()._sub(t1);
            },
            multByPoint: function(t1) {
                return this.clone()._multByPoint(t1);
            },
            divByPoint: function(t1) {
                return this.clone()._divByPoint(t1);
            },
            mult: function(t1) {
                return this.clone()._mult(t1);
            },
            div: function(t1) {
                return this.clone()._div(t1);
            },
            rotate: function(t1) {
                return this.clone()._rotate(t1);
            },
            rotateAround: function(t1, e1) {
                return this.clone()._rotateAround(t1, e1);
            },
            matMult: function(t1) {
                return this.clone()._matMult(t1);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(t1) {
                return this.x === t1.x && this.y === t1.y;
            },
            dist: function(t1) {
                return Math.sqrt(this.distSqr(t1));
            },
            distSqr: function(t1) {
                var e1 = t1.x - this.x, r = t1.y - this.y;
                return e1 * e1 + r * r;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(t1) {
                return Math.atan2(this.y - t1.y, this.x - t1.x);
            },
            angleWith: function(t1) {
                return this.angleWithSep(t1.x, t1.y);
            },
            angleWithSep: function(t1, e1) {
                return Math.atan2(this.x * e1 - this.y * t1, this.x * t1 + this.y * e1);
            },
            _matMult: function(t1) {
                var e1 = t1[2] * this.x + t1[3] * this.y;
                return this.x = t1[0] * this.x + t1[1] * this.y, this.y = e1, this;
            },
            _add: function(t1) {
                return this.x += t1.x, this.y += t1.y, this;
            },
            _sub: function(t1) {
                return this.x -= t1.x, this.y -= t1.y, this;
            },
            _mult: function(t1) {
                return this.x *= t1, this.y *= t1, this;
            },
            _div: function(t1) {
                return this.x /= t1, this.y /= t1, this;
            },
            _multByPoint: function(t1) {
                return this.x *= t1.x, this.y *= t1.y, this;
            },
            _divByPoint: function(t1) {
                return this.x /= t1.x, this.y /= t1.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var t1 = this.y;
                return this.y = this.x, this.x = -t1, this;
            },
            _rotate: function(t1) {
                var e1 = Math.cos(t1), r = Math.sin(t1), n = r * this.x + e1 * this.y;
                return this.x = e1 * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround: function(t1, e1) {
                var r = Math.cos(t1), n = Math.sin(t1), i = e1.y + n * (this.x - e1.x) + r * (this.y - e1.y);
                return this.x = e1.x + r * (this.x - e1.x) - n * (this.y - e1.y), this.y = i, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
        }, s.convert = function(t1) {
            return t1 instanceof s ? t1 : Array.isArray(t1) ? new s(t1[0], t1[1]) : t1;
        };
        const a = Math.PI / 180, o = 180 / Math.PI;
        function l(t1) {
            return t1 * a;
        }
        function u(t1) {
            return t1 * o;
        }
        const c = [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ];
        function h(t1) {
            if (t1 <= 0) return 0;
            if (t1 >= 1) return 1;
            const e1 = t1 * t1, r = e1 * t1;
            return 4 * (t1 < .5 ? r : 3 * (t1 - e1) + r - .75);
        }
        function p(t1, e1, n, i) {
            const s = new r(t1, e1, n, i);
            return function(t1) {
                return s.solve(t1);
            };
        }
        const f = p(.25, .1, .25, 1);
        function d(t1, e1, r) {
            return Math.min(r, Math.max(e1, t1));
        }
        function y(t1, e1, r) {
            return (r = d((r - t1) / (e1 - t1), 0, 1)) * r * (3 - 2 * r);
        }
        function m(t1, e1, r) {
            const n = r - e1, i = ((t1 - e1) % n + n) % n + e1;
            return i === e1 ? r : i;
        }
        function g(t1, e1, r) {
            if (!t1.length) return r(null, []);
            let n = t1.length;
            const i = new Array(t1.length);
            let s = null;
            t1.forEach((t1, a)=>{
                e1(t1, (t1, e1)=>{
                    t1 && (s = t1), i[a] = e1, 0 == --n && r(s, i);
                });
            });
        }
        function x(t1) {
            const e1 = [];
            for(const r in t1)e1.push(t1[r]);
            return e1;
        }
        function v(t1, ...e1) {
            for (const r of e1)for(const e1 in r)t1[e1] = r[e1];
            return t1;
        }
        let b = 1;
        function _() {
            return b++;
        }
        function w() {
            return function t1(e1) {
                return e1 ? (e1 ^ Math.random() * (16 >> e1 / 4)).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, t1);
            }();
        }
        function A(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }
        function S(t1) {
            return !!t1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t1);
        }
        function k(t1, e1) {
            t1.forEach((t1)=>{
                e1[t1] && (e1[t1] = e1[t1].bind(e1));
            });
        }
        function I(t1, e1) {
            return -1 !== t1.indexOf(e1, t1.length - e1.length);
        }
        function M(t1, e1, r) {
            const n = {};
            for(const i in t1)n[i] = e1.call(r || this, t1[i], i, t1);
            return n;
        }
        function z(t1, e1, r) {
            const n = {};
            for(const i in t1)e1.call(r || this, t1[i], i, t1) && (n[i] = t1[i]);
            return n;
        }
        function T(t1) {
            return Array.isArray(t1) ? t1.map(T) : "object" == typeof t1 && t1 ? M(t1, T) : t1;
        }
        const B = {};
        function E(t1) {
            B[t1] || ("undefined" != typeof console && console.warn(t1), B[t1] = !0);
        }
        function C(t1, e1, r) {
            return (r.y - t1.y) * (e1.x - t1.x) > (e1.y - t1.y) * (r.x - t1.x);
        }
        function P(t1) {
            let e1 = 0;
            for(let r, n, i = 0, s = t1.length, a = s - 1; i < s; a = i++)r = t1[i], n = t1[a], e1 += (n.x - r.x) * (r.y + n.y);
            return e1;
        }
        function D() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        function V(t1) {
            const e1 = {};
            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t1, r, n, i)=>{
                const s = n || i;
                return e1[r] = !s || s.toLowerCase(), "";
            }), e1["max-age"]) {
                const t1 = parseInt(e1["max-age"], 10);
                isNaN(t1) ? delete e1["max-age"] : e1["max-age"] = t1;
            }
            return e1;
        }
        let F = null;
        function L(t1) {
            if (null == F) {
                const e1 = t1.navigator ? t1.navigator.userAgent : null;
                F = !!t1.safari || !(!e1 || !(/\b(iPad|iPhone|iPod)\b/.test(e1) || e1.match("Safari") && !e1.match("Chrome")));
            }
            return F;
        }
        function R(t1) {
            try {
                const r = e1[t1];
                return r.setItem("_mapbox_test_", 1), r.removeItem("_mapbox_test_"), !0;
            } catch (t1) {
                return !1;
            }
        }
        function U(t1, e1) {
            return [
                t1[4 * e1],
                t1[4 * e1 + 1],
                t1[4 * e1 + 2],
                t1[4 * e1 + 3]
            ];
        }
        const j = e1.performance;
        function $(t1) {
            const e1 = t1 ? t1.url.toString() : void 0;
            return j.getEntriesByName(e1);
        }
        var O = "2.10.0";
        let q, N, G, Z;
        const X = {
            now: ()=>void 0 !== G ? G : e1.performance.now(),
            setNow (t1) {
                G = t1;
            },
            restoreNow () {
                G = void 0;
            },
            frame (t1) {
                const r = e1.requestAnimationFrame(t1);
                return {
                    cancel: ()=>e1.cancelAnimationFrame(r)
                };
            },
            getImageData (t1, r = 0) {
                const { width: n, height: i } = t1;
                Z || (Z = e1.document.createElement("canvas"));
                const s = Z.getContext("2d");
                if (!s) throw new Error("failed to create canvas 2d context");
                return (n > Z.width || i > Z.height) && (Z.width = n, Z.height = i), s.clearRect(-r, -r, n + 2 * r, i + 2 * r), s.drawImage(t1, 0, 0, n, i), s.getImageData(-r, -r, n + 2 * r, i + 2 * r);
            },
            resolveURL: (t1)=>(q || (q = e1.document.createElement("a")), q.href = t1, q.href),
            get devicePixelRatio () {
                return e1.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!e1.matchMedia && (null == N && (N = e1.matchMedia("(prefers-reduced-motion: reduce)")), N.matches);
            }
        };
        let K;
        const H = {
            API_URL: "https://api.mapbox.com",
            get API_URL_REGEX () {
                if (null == K) {
                    const t1 = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
                    try {
                        K = t1;
                    } catch (e1) {
                        K = t1;
                    }
                }
                return K;
            },
            get EVENTS_URL () {
                return this.API_URL ? 0 === this.API_URL.indexOf("https://api.mapbox.cn") ? "https://events.mapbox.cn/events/v2" : 0 === this.API_URL.indexOf("https://api.mapbox.com") ? "https://events.mapbox.com/events/v2" : null : null;
            },
            SESSION_PATH: "/map-sessions/v1",
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            TILE_URL_VERSION: "v4",
            RASTER_URL_PREFIX: "raster/v1",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            MAX_PARALLEL_IMAGE_REQUESTS: 16
        }, Y = {
            supported: !1,
            testSupport: function(t1) {
                !Q && J && (tt ? et(t1) : W = t1);
            }
        };
        let W, J, Q = !1, tt = !1;
        function et(t1) {
            const e1 = t1.createTexture();
            t1.bindTexture(t1.TEXTURE_2D, e1);
            try {
                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, J), t1.isContextLost()) return;
                Y.supported = !0;
            } catch (t1) {}
            t1.deleteTexture(e1), Q = !0;
        }
        e1.document && (J = e1.document.createElement("img"), J.onload = function() {
            W && et(W), W = null, tt = !0;
        }, J.onerror = function() {
            Q = !0, W = null;
        }, J.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        const rt = "01", nt = "NO_ACCESS_TOKEN";
        function it(t1) {
            return 0 === t1.indexOf("mapbox:");
        }
        function st(t1) {
            return H.API_URL_REGEX.test(t1);
        }
        const at = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function ot(t1) {
            const e1 = t1.match(at);
            if (!e1) throw new Error("Unable to parse URL object");
            return {
                protocol: e1[1],
                authority: e1[2],
                path: e1[3] || "/",
                params: e1[4] ? e1[4].split("&") : []
            };
        }
        function lt(t1) {
            const e1 = t1.params.length ? `?${t1.params.join("&")}` : "";
            return `${t1.protocol}://${t1.authority}${t1.path}${e1}`;
        }
        function ut(t1) {
            if (!t1) return null;
            const r = t1.split(".");
            if (!r || 3 !== r.length) return null;
            try {
                return JSON.parse(decodeURIComponent(e1.atob(r[1]).split("").map((t1)=>"%" + ("00" + t1.charCodeAt(0).toString(16)).slice(-2)).join("")));
            } catch (t1) {
                return null;
            }
        }
        class ct {
            getStorageKey(t1) {
                const r = ut(H.ACCESS_TOKEN);
                let n = "";
                return n = r && r.u ? e1.btoa(encodeURIComponent(r.u).replace(/%([0-9A-F]{2})/g, (t1, e1)=>String.fromCharCode(Number("0x" + e1)))) : H.ACCESS_TOKEN || "", t1 ? `mapbox.eventData.${t1}:${n}` : `mapbox.eventData:${n}`;
            }
            fetchEventData() {
                const t1 = R("localStorage"), r = this.getStorageKey(), n = this.getStorageKey("uuid");
                if (t1) try {
                    const t1 = e1.localStorage.getItem(r);
                    t1 && (this.eventData = JSON.parse(t1));
                    const i = e1.localStorage.getItem(n);
                    i && (this.anonId = i);
                } catch (t1) {
                    E("Unable to read from LocalStorage");
                }
            }
            saveEventData() {
                const t1 = R("localStorage"), r = this.getStorageKey(), n = this.getStorageKey("uuid");
                if (t1) try {
                    e1.localStorage.setItem(n, this.anonId), Object.keys(this.eventData).length >= 1 && e1.localStorage.setItem(r, JSON.stringify(this.eventData));
                } catch (t1) {
                    E("Unable to write to LocalStorage");
                }
            }
            processRequests(t1) {}
            postEvent(t1, e1, r, n) {
                if (!H.EVENTS_URL) return;
                const i = ot(H.EVENTS_URL);
                i.params.push(`access_token=${n || H.ACCESS_TOKEN || ""}`);
                const s = {
                    event: this.type,
                    created: new Date(t1).toISOString(),
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: O,
                    skuId: rt,
                    userId: this.anonId
                }, a = e1 ? v(s, e1) : s, o = {
                    url: lt(i),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        a
                    ])
                };
                this.pendingRequest = Pt(o, (t1)=>{
                    this.pendingRequest = null, r(t1), this.saveEventData(), this.processRequests(n);
                });
            }
            queueRequest(t1, e1) {
                this.queue.push(t1), this.processRequests(e1);
            }
            constructor(t1){
                this.type = t1, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
            }
        }
        const ht = new class extends ct {
            postTurnstileEvent(t1, e1) {
                H.EVENTS_URL && H.ACCESS_TOKEN && Array.isArray(t1) && t1.some((t1)=>it(t1) || st(t1)) && this.queueRequest(Date.now(), e1);
            }
            processRequests(t1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                const e1 = ut(H.ACCESS_TOKEN), r = e1 ? e1.u : H.ACCESS_TOKEN;
                let n = r !== this.eventData.tokenU;
                S(this.anonId) || (this.anonId = w(), n = !0);
                const i = this.queue.shift();
                if (this.eventData.lastSuccess) {
                    const t1 = new Date(this.eventData.lastSuccess), e1 = new Date(i), r = (i - this.eventData.lastSuccess) / 864e5;
                    n = n || r >= 1 || r < -1 || t1.getDate() !== e1.getDate();
                } else n = !0;
                n ? this.postEvent(i, {
                    "enabled.telemetry": !1
                }, (t1)=>{
                    t1 || (this.eventData.lastSuccess = i, this.eventData.tokenU = r);
                }, t1) : this.processRequests();
            }
            constructor(t1){
                super("appUserTurnstile"), this._customAccessToken = t1;
            }
        }, pt = ht.postTurnstileEvent.bind(ht), ft = new class extends ct {
            postMapLoadEvent(t1, e1, r, n) {
                this.skuToken = e1, this.errorCb = n, H.EVENTS_URL && (r || H.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, r) : this.errorCb(new Error(nt)));
            }
            processRequests(t1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: e1, timestamp: r } = this.queue.shift();
                e1 && this.success[e1] || (this.anonId || this.fetchEventData(), S(this.anonId) || (this.anonId = w()), this.postEvent(r, {
                    skuToken: this.skuToken
                }, (t1)=>{
                    t1 ? this.errorCb(t1) : e1 && (this.success[e1] = !0);
                }, t1));
            }
            constructor(){
                super("map.load"), this.success = {}, this.skuToken = "";
            }
        }, dt = ft.postMapLoadEvent.bind(ft), yt = new class extends ct {
            getSession(t1, e1, r, n) {
                if (!H.API_URL || !H.SESSION_PATH) return;
                const i = ot(H.API_URL + H.SESSION_PATH);
                i.params.push(`sku=${e1 || ""}`), i.params.push(`access_token=${n || H.ACCESS_TOKEN || ""}`);
                const s = {
                    url: lt(i),
                    headers: {
                        "Content-Type": "text/plain"
                    }
                };
                this.pendingRequest = Dt(s, (t1)=>{
                    this.pendingRequest = null, r(t1), this.saveEventData(), this.processRequests(n);
                });
            }
            getSessionAPI(t1, e1, r, n) {
                this.skuToken = e1, this.errorCb = n, H.SESSION_PATH && H.API_URL && (r || H.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, r) : this.errorCb(new Error(nt)));
            }
            processRequests(t1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: e1, timestamp: r } = this.queue.shift();
                e1 && this.success[e1] || this.getSession(r, this.skuToken, (t1)=>{
                    t1 ? this.errorCb(t1) : e1 && (this.success[e1] = !0);
                }, t1);
            }
            constructor(){
                super("map.auth"), this.success = {}, this.skuToken = "";
            }
        }, mt = yt.getSessionAPI.bind(yt), gt = new Set;
        let xt, vt = 500, bt = 50, _t = {};
        function wt(t1) {
            const e1 = kt(t1);
            let r, n;
            e1 && e1.forEach((t1)=>{
                const e1 = t1.split("=");
                "language" === e1[0] ? r = e1[1] : "worldview" === e1[0] && (n = e1[1]);
            });
            let i = "mapbox-tiles";
            return r && (i += `-${r}`), n && (i += `-${n}`), i;
        }
        function At() {
            try {
                return e1.caches;
            } catch (t1) {}
        }
        function St(t1) {
            const e1 = At();
            e1 && !_t[t1] && (_t[t1] = e1.open(t1));
        }
        function kt(t1) {
            const e1 = t1.indexOf("?");
            return e1 > 0 ? t1.slice(e1 + 1).split("&") : [];
        }
        function It(t1) {
            const e1 = t1.indexOf("?");
            if (e1 < 0) return t1;
            const r = kt(t1).filter((t1)=>{
                const e1 = t1.split("=");
                return "language" === e1[0] || "worldview" === e1[0];
            });
            return r.length ? `${t1.slice(0, e1)}?${r.join("&")}` : t1.slice(0, e1);
        }
        let Mt = 1 / 0;
        const zt = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Image: "Image"
        };
        "function" == typeof Object.freeze && Object.freeze(zt);
        class Tt extends Error {
            toString() {
                return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
            constructor(t1, e1, r){
                401 === e1 && st(r) && (t1 += ": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"), super(t1), this.status = e1, this.url = r;
            }
        }
        const Bt = D() ? ()=>self.worker && self.worker.referrer : ()=>("blob:" === e1.location.protocol ? e1.parent : e1).location.href;
        const Et = function(t1, r) {
            if (!(/^file:/.test(n = t1.url) || /^file:/.test(Bt()) && !/^\w+:/.test(n))) {
                if (e1.fetch && e1.Request && e1.AbortController && e1.Request.prototype.hasOwnProperty("signal")) return function(t1, r) {
                    const n = new e1.AbortController, i = new e1.Request(t1.url, {
                        method: t1.method || "GET",
                        body: t1.body,
                        credentials: t1.credentials,
                        headers: t1.headers,
                        referrer: Bt(),
                        signal: n.signal
                    });
                    let s = !1, a = !1;
                    const o = (l = i.url).indexOf("sku=") > 0 && st(l);
                    var l;
                    "json" === t1.type && i.headers.set("Accept", "application/json");
                    const u = (n, s, l)=>{
                        if (a) return;
                        if (n && "SecurityError" !== n.message && E(n), s && l) return c(s);
                        const u = Date.now();
                        e1.fetch(i).then((e1)=>{
                            if (e1.ok) {
                                const t1 = o ? e1.clone() : null;
                                return c(e1, t1, u);
                            }
                            return r(new Tt(e1.statusText, e1.status, t1.url));
                        }).catch((t1)=>{
                            20 !== t1.code && r(new Error(t1.message));
                        });
                    }, c = (n, o, l)=>{
                        ("arrayBuffer" === t1.type ? n.arrayBuffer() : "json" === t1.type ? n.json() : n.text()).then((t1)=>{
                            a || (o && l && function(t1, r, n) {
                                const i = wt(t1.url);
                                if (St(i), !_t[i]) return;
                                const s = {
                                    status: r.status,
                                    statusText: r.statusText,
                                    headers: new e1.Headers
                                };
                                r.headers.forEach((t1, e1)=>s.headers.set(e1, t1));
                                const a = V(r.headers.get("Cache-Control") || "");
                                if (a["no-store"]) return;
                                a["max-age"] && s.headers.set("Expires", new Date(n + 1e3 * a["max-age"]).toUTCString());
                                const o = s.headers.get("Expires");
                                o && (new Date(o).getTime() - n < 42e4 || function(t1, e1) {
                                    if (void 0 === xt) try {
                                        new Response(new ReadableStream), xt = !0;
                                    } catch (t1) {
                                        xt = !1;
                                    }
                                    xt ? e1(t1.body) : t1.blob().then(e1);
                                }(r, (r)=>{
                                    const n = new e1.Response(r, s);
                                    St(i), _t[i] && _t[i].then((e1)=>e1.put(It(t1.url), n)).catch((t1)=>E(t1.message));
                                }));
                            }(i, o, l), s = !0, r(null, t1, n.headers.get("Cache-Control"), n.headers.get("Expires")));
                        }).catch((t1)=>{
                            a || r(new Error(t1.message));
                        });
                    };
                    return o ? function(t1, e1) {
                        const r = wt(t1.url);
                        if (St(r), !_t[r]) return e1(null);
                        const n = It(t1.url);
                        _t[r].then((t1)=>{
                            t1.match(n).then((r)=>{
                                const i = function(t1) {
                                    if (!t1) return !1;
                                    const e1 = new Date(t1.headers.get("Expires") || 0), r = V(t1.headers.get("Cache-Control") || "");
                                    return e1 > Date.now() && !r["no-cache"];
                                }(r);
                                t1.delete(n), i && t1.put(n, r.clone()), e1(null, r, i);
                            }).catch(e1);
                        }).catch(e1);
                    }(i, u) : u(null, null), {
                        cancel: ()=>{
                            a = !0, s || n.abort();
                        }
                    };
                }(t1, r);
                if (D() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, r, void 0, !0);
            }
            var n;
            return function(t1, r) {
                const n = new e1.XMLHttpRequest;
                n.open(t1.method || "GET", t1.url, !0), "arrayBuffer" === t1.type && (n.responseType = "arraybuffer");
                for(const e1 in t1.headers)n.setRequestHeader(e1, t1.headers[e1]);
                return "json" === t1.type && (n.responseType = "text", n.setRequestHeader("Accept", "application/json")), n.withCredentials = "include" === t1.credentials, n.onerror = ()=>{
                    r(new Error(n.statusText));
                }, n.onload = ()=>{
                    if ((n.status >= 200 && n.status < 300 || 0 === n.status) && null !== n.response) {
                        let e1 = n.response;
                        if ("json" === t1.type) try {
                            e1 = JSON.parse(n.response);
                        } catch (t1) {
                            return r(t1);
                        }
                        r(null, e1, n.getResponseHeader("Cache-Control"), n.getResponseHeader("Expires"));
                    } else r(new Tt(n.statusText, n.status, t1.url));
                }, n.send(t1.body), {
                    cancel: ()=>n.abort()
                };
            }(t1, r);
        }, Ct = function(t1, e1) {
            return Et(v(t1, {
                type: "arrayBuffer"
            }), e1);
        }, Pt = function(t1, e1) {
            return Et(v(t1, {
                method: "POST"
            }), e1);
        }, Dt = function(t1, e1) {
            return Et(v(t1, {
                method: "GET"
            }), e1);
        };
        function Vt(t1) {
            const r = e1.document.createElement("a");
            return r.href = t1, r.protocol === e1.document.location.protocol && r.host === e1.document.location.host;
        }
        const Ft = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        let Lt, Rt;
        Lt = [], Rt = 0;
        const Ut = function(t1, r) {
            if (Y.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*"), Rt >= H.MAX_PARALLEL_IMAGE_REQUESTS) {
                const e1 = {
                    requestParameters: t1,
                    callback: r,
                    cancelled: !1,
                    cancel () {
                        this.cancelled = !0;
                    }
                };
                return Lt.push(e1), e1;
            }
            Rt++;
            let n = !1;
            const i = ()=>{
                if (!n) for(n = !0, Rt--; Lt.length && Rt < H.MAX_PARALLEL_IMAGE_REQUESTS;){
                    const t1 = Lt.shift(), { requestParameters: e1, callback: r, cancelled: n } = t1;
                    n || (t1.cancel = Ut(e1, r).cancel);
                }
            }, s = Ct(t1, (t1, n, s, a)=>{
                i(), t1 ? r(t1) : n && (e1.createImageBitmap ? function(t1, r) {
                    const n = new e1.Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    e1.createImageBitmap(n).then((t1)=>{
                        r(null, t1);
                    }).catch((t1)=>{
                        r(new Error(`Could not load image because of ${t1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
                    });
                }(n, (t1, e1)=>r(t1, e1, s, a)) : function(t1, r) {
                    const n = new e1.Image, i = e1.URL;
                    n.onload = ()=>{
                        r(null, n), i.revokeObjectURL(n.src), n.onload = null, e1.requestAnimationFrame(()=>{
                            n.src = Ft;
                        });
                    }, n.onerror = ()=>r(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    const s = new e1.Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    n.src = t1.byteLength ? i.createObjectURL(s) : Ft;
                }(n, (t1, e1)=>r(t1, e1, s, a)));
            });
            return {
                cancel: ()=>{
                    s.cancel(), i();
                }
            };
        };
        function jt(t1, e1, r) {
            r[t1] && -1 !== r[t1].indexOf(e1) || (r[t1] = r[t1] || [], r[t1].push(e1));
        }
        function $t(t1, e1, r) {
            if (r && r[t1]) {
                const n = r[t1].indexOf(e1);
                -1 !== n && r[t1].splice(n, 1);
            }
        }
        class Ot {
            constructor(t1, e1 = {}){
                v(this, e1), this.type = t1;
            }
        }
        class qt extends Ot {
            constructor(t1, e1 = {}){
                super("error", v({
                    error: t1
                }, e1));
            }
        }
        class Nt {
            on(t1, e1) {
                return this._listeners = this._listeners || {}, jt(t1, e1, this._listeners), this;
            }
            off(t1, e1) {
                return $t(t1, e1, this._listeners), $t(t1, e1, this._oneTimeListeners), this;
            }
            once(t1, e1) {
                return e1 ? (this._oneTimeListeners = this._oneTimeListeners || {}, jt(t1, e1, this._oneTimeListeners), this) : new Promise((e1)=>this.once(t1, e1));
            }
            fire(t1, e1) {
                "string" == typeof t1 && (t1 = new Ot(t1, e1 || {}));
                const r = t1.type;
                if (this.listens(r)) {
                    t1.target = this;
                    const e1 = this._listeners && this._listeners[r] ? this._listeners[r].slice() : [];
                    for (const r of e1)r.call(this, t1);
                    const n = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : [];
                    for (const e1 of n)$t(r, e1, this._oneTimeListeners), e1.call(this, t1);
                    const i = this._eventedParent;
                    i && (v(t1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(t1));
                } else t1 instanceof qt && console.error(t1.error);
                return this;
            }
            listens(t1) {
                return !!(this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1));
            }
            setEventedParent(t1, e1) {
                return this._eventedParent = t1, this._eventedParentData = e1, this;
            }
        }
        var Gt = JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360,"units":"degrees"},"pitch":{"type":"number","default":0,"units":"degrees"},"light":{"type":"light"},"terrain":{"type":"terrain"},"fog":{"type":"fog"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":{},"tms":{}},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"scheme":{"type":"enum","values":{"xyz":{},"tms":{}},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":{},"mapbox":{}},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":{}}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":{}}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":{}}},"url":{"required":true,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"hillshade":{},"background":{},"sky":{}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background","layout_sky"],"layout_background":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","private":true,"default":0,"minimum":0,"maximum":1,"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":{},"round":{},"square":{}},"default":"butt","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":{},"round":{},"miter":{}},"default":"miter","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"requires":[{"line-join":"miter"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"requires":[{"line-join":"round"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":{},"line":{},"line-center":{}},"default":"point","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"units":"pixels","requires":[{"symbol-placement":"line"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":{},"viewport-y":{},"source":{}},"default":"auto","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"requires":["icon-image","text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"units":"factor of the original icon size","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{"type":"enum","values":{"none":{},"width":{},"height":{},"both":{}},"default":"none","requires":["icon-image","text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"units":"pixels","requires":["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"units":"degrees","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"requires":["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{"type":"number","default":10,"minimum":0,"units":"ems","requires":["text-field",{"symbol-placement":["point"]}],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"units":"ems","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"units":"ems","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":{},"left":{},"center":{},"right":{}},"default":"center","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","units":"ems","default":0,"requires":["text-field"],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"requires":["text-field",{"symbol-placement":["point"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["text-field",{"!":"text-variable-anchor"}],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"units":"degrees","requires":["text-field",{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":{},"vertical":{}},"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"units":"degrees","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"requires":["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":{},"uppercase":{},"lowercase":{}},"default":"none","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","units":"ems","length":2,"default":[0,0],"requires":["text-field",{"!":"text-radial-offset"}],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"requires":["text-field","icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},"in":{},"!in":{},"all":{},"any":{},"none":{},"has":{},"!has":{},"within":{}}},"geometry_type":{"type":"enum","values":{"Point":{},"LineString":{},"Polygon":{}}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":{},"exponential":{},"interval":{},"categorical":{}},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":{},"lab":{},"hcl":{}},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":{},"viewport":{}},"property-type":"data-constant","transition":false,"expression":{"interpolated":false,"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":{},"equalEarth":{},"equirectangular":{},"lambertConformalConic":{},"mercator":{},"naturalEarth":{},"winkelTripel":{},"globe":{}},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90],"transition":false,"requires":[{"name":["albers","lambertConformalConic"]}]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90],"transition":false,"requires":[{"name":["albers","lambertConformalConic"]}]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"requires":["source"]}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background","paint_sky"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"fill-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"requires":[{"!":"fill-pattern"},{"fill-antialias":true}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["fill-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"fill-extrusion-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["fill-extrusion-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"units":"meters","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"units":"meters","transition":true,"requires":["fill-extrusion-height"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","private":true,"default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","private":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"line-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["line-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"transition":true,"units":"line widths","requires":[{"!":"line-pattern"}],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-gradient":{"type":"color","transition":false,"requires":[{"!":"line-pattern"},{"source":"geojson","has":{"lineMetrics":true}}],"expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"transition":false,"requires":[{"source":"geojson","has":{"lineMetrics":true}}],"property-type":"constant"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["circle-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{}},"default":"viewport","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"transition":false,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"transition":false,"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["icon-image","icon-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["text-field","text-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"units":"degrees","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":{},"nearest":{}},"default":"linear","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"transition":false,"units":"milliseconds","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"transition":false,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"viewport","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_background":{"background-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"background-pattern"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"cross-faded"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":{},"atmosphere":{}},"default":"atmosphere","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"units":"degrees","minimum":[0,0],"maximum":[360,180],"transition":false,"requires":[{"sky-type":"atmosphere"}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","requires":[{"sky-type":"atmosphere"}],"default":10,"minimum":0,"maximum":100,"transition":false,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","requires":[{"sky-type":"gradient"}],"value":"number","default":[0,0],"length":2,"units":"degrees","minimum":[0,0],"maximum":[360,180],"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","requires":[{"sky-type":"gradient"}],"default":90,"minimum":0,"maximum":180,"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"transition":false,"requires":[{"sky-type":"gradient"}],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","transition":false,"requires":[{"sky-type":"atmosphere"}],"property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","transition":false,"requires":[{"sky-type":"atmosphere"}],"property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"transition":{"duration":{"type":"number","default":300,"minimum":0,"units":"milliseconds"},"delay":{"type":"number","default":0,"minimum":0,"units":"milliseconds"}},"property-type":{"data-driven":{"type":"property-type"},"cross-faded":{"type":"property-type"},"cross-faded-data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');
        function Zt(t1, ...e1) {
            for (const r of e1)for(const e1 in r)t1[e1] = r[e1];
            return t1;
        }
        function Xt(t1) {
            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
        }
        function Kt(t1) {
            if (Array.isArray(t1)) return t1.map(Kt);
            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                const e1 = {};
                for(const r in t1)e1[r] = Kt(t1[r]);
                return e1;
            }
            return Xt(t1);
        }
        class Ht extends Error {
            constructor(t1, e1){
                super(e1), this.message = e1, this.key = t1;
            }
        }
        var Yt = Ht;
        class Wt {
            concat(t1) {
                return new Wt(this, t1);
            }
            get(t1) {
                if (this.bindings[t1]) return this.bindings[t1];
                if (this.parent) return this.parent.get(t1);
                throw new Error(`${t1} not found in scope.`);
            }
            has(t1) {
                return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
            }
            constructor(t1, e1 = []){
                this.parent = t1, this.bindings = {};
                for (const [t1, r] of e1)this.bindings[t1] = r;
            }
        }
        var Jt = Wt;
        const Qt = {
            kind: "null"
        }, te = {
            kind: "number"
        }, ee = {
            kind: "string"
        }, re = {
            kind: "boolean"
        }, ne = {
            kind: "color"
        }, ie = {
            kind: "object"
        }, se = {
            kind: "value"
        }, ae = {
            kind: "collator"
        }, oe = {
            kind: "formatted"
        }, le = {
            kind: "resolvedImage"
        };
        function ue(t1, e1) {
            return {
                kind: "array",
                itemType: t1,
                N: e1
            };
        }
        function ce(t1) {
            if ("array" === t1.kind) {
                const e1 = ce(t1.itemType);
                return "number" == typeof t1.N ? `array<${e1}, ${t1.N}>` : "value" === t1.itemType.kind ? "array" : `array<${e1}>`;
            }
            return t1.kind;
        }
        const he = [
            Qt,
            te,
            ee,
            re,
            ne,
            oe,
            ie,
            ue(se),
            le
        ];
        function pe(t1, e1) {
            if ("error" === e1.kind) return null;
            if ("array" === t1.kind) {
                if ("array" === e1.kind && (0 === e1.N && "value" === e1.itemType.kind || !pe(t1.itemType, e1.itemType)) && ("number" != typeof t1.N || t1.N === e1.N)) return null;
            } else {
                if (t1.kind === e1.kind) return null;
                if ("value" === t1.kind) {
                    for (const t1 of he)if (!pe(t1, e1)) return null;
                }
            }
            return `Expected ${ce(t1)} but found ${ce(e1)} instead.`;
        }
        function fe(t1, e1) {
            return e1.some((e1)=>e1.kind === t1.kind);
        }
        function de(t1, e1) {
            return e1.some((e1)=>"null" === e1 ? null === t1 : "array" === e1 ? Array.isArray(t1) : "object" === e1 ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e1 === typeof t1);
        }
        function ye(t1) {
            var e1 = {
                exports: {}
            };
            return t1(e1, e1.exports), e1.exports;
        }
        var me = ye(function(t1, e1) {
            var r = {
                transparent: [
                    0,
                    0,
                    0,
                    0
                ],
                aliceblue: [
                    240,
                    248,
                    255,
                    1
                ],
                antiquewhite: [
                    250,
                    235,
                    215,
                    1
                ],
                aqua: [
                    0,
                    255,
                    255,
                    1
                ],
                aquamarine: [
                    127,
                    255,
                    212,
                    1
                ],
                azure: [
                    240,
                    255,
                    255,
                    1
                ],
                beige: [
                    245,
                    245,
                    220,
                    1
                ],
                bisque: [
                    255,
                    228,
                    196,
                    1
                ],
                black: [
                    0,
                    0,
                    0,
                    1
                ],
                blanchedalmond: [
                    255,
                    235,
                    205,
                    1
                ],
                blue: [
                    0,
                    0,
                    255,
                    1
                ],
                blueviolet: [
                    138,
                    43,
                    226,
                    1
                ],
                brown: [
                    165,
                    42,
                    42,
                    1
                ],
                burlywood: [
                    222,
                    184,
                    135,
                    1
                ],
                cadetblue: [
                    95,
                    158,
                    160,
                    1
                ],
                chartreuse: [
                    127,
                    255,
                    0,
                    1
                ],
                chocolate: [
                    210,
                    105,
                    30,
                    1
                ],
                coral: [
                    255,
                    127,
                    80,
                    1
                ],
                cornflowerblue: [
                    100,
                    149,
                    237,
                    1
                ],
                cornsilk: [
                    255,
                    248,
                    220,
                    1
                ],
                crimson: [
                    220,
                    20,
                    60,
                    1
                ],
                cyan: [
                    0,
                    255,
                    255,
                    1
                ],
                darkblue: [
                    0,
                    0,
                    139,
                    1
                ],
                darkcyan: [
                    0,
                    139,
                    139,
                    1
                ],
                darkgoldenrod: [
                    184,
                    134,
                    11,
                    1
                ],
                darkgray: [
                    169,
                    169,
                    169,
                    1
                ],
                darkgreen: [
                    0,
                    100,
                    0,
                    1
                ],
                darkgrey: [
                    169,
                    169,
                    169,
                    1
                ],
                darkkhaki: [
                    189,
                    183,
                    107,
                    1
                ],
                darkmagenta: [
                    139,
                    0,
                    139,
                    1
                ],
                darkolivegreen: [
                    85,
                    107,
                    47,
                    1
                ],
                darkorange: [
                    255,
                    140,
                    0,
                    1
                ],
                darkorchid: [
                    153,
                    50,
                    204,
                    1
                ],
                darkred: [
                    139,
                    0,
                    0,
                    1
                ],
                darksalmon: [
                    233,
                    150,
                    122,
                    1
                ],
                darkseagreen: [
                    143,
                    188,
                    143,
                    1
                ],
                darkslateblue: [
                    72,
                    61,
                    139,
                    1
                ],
                darkslategray: [
                    47,
                    79,
                    79,
                    1
                ],
                darkslategrey: [
                    47,
                    79,
                    79,
                    1
                ],
                darkturquoise: [
                    0,
                    206,
                    209,
                    1
                ],
                darkviolet: [
                    148,
                    0,
                    211,
                    1
                ],
                deeppink: [
                    255,
                    20,
                    147,
                    1
                ],
                deepskyblue: [
                    0,
                    191,
                    255,
                    1
                ],
                dimgray: [
                    105,
                    105,
                    105,
                    1
                ],
                dimgrey: [
                    105,
                    105,
                    105,
                    1
                ],
                dodgerblue: [
                    30,
                    144,
                    255,
                    1
                ],
                firebrick: [
                    178,
                    34,
                    34,
                    1
                ],
                floralwhite: [
                    255,
                    250,
                    240,
                    1
                ],
                forestgreen: [
                    34,
                    139,
                    34,
                    1
                ],
                fuchsia: [
                    255,
                    0,
                    255,
                    1
                ],
                gainsboro: [
                    220,
                    220,
                    220,
                    1
                ],
                ghostwhite: [
                    248,
                    248,
                    255,
                    1
                ],
                gold: [
                    255,
                    215,
                    0,
                    1
                ],
                goldenrod: [
                    218,
                    165,
                    32,
                    1
                ],
                gray: [
                    128,
                    128,
                    128,
                    1
                ],
                green: [
                    0,
                    128,
                    0,
                    1
                ],
                greenyellow: [
                    173,
                    255,
                    47,
                    1
                ],
                grey: [
                    128,
                    128,
                    128,
                    1
                ],
                honeydew: [
                    240,
                    255,
                    240,
                    1
                ],
                hotpink: [
                    255,
                    105,
                    180,
                    1
                ],
                indianred: [
                    205,
                    92,
                    92,
                    1
                ],
                indigo: [
                    75,
                    0,
                    130,
                    1
                ],
                ivory: [
                    255,
                    255,
                    240,
                    1
                ],
                khaki: [
                    240,
                    230,
                    140,
                    1
                ],
                lavender: [
                    230,
                    230,
                    250,
                    1
                ],
                lavenderblush: [
                    255,
                    240,
                    245,
                    1
                ],
                lawngreen: [
                    124,
                    252,
                    0,
                    1
                ],
                lemonchiffon: [
                    255,
                    250,
                    205,
                    1
                ],
                lightblue: [
                    173,
                    216,
                    230,
                    1
                ],
                lightcoral: [
                    240,
                    128,
                    128,
                    1
                ],
                lightcyan: [
                    224,
                    255,
                    255,
                    1
                ],
                lightgoldenrodyellow: [
                    250,
                    250,
                    210,
                    1
                ],
                lightgray: [
                    211,
                    211,
                    211,
                    1
                ],
                lightgreen: [
                    144,
                    238,
                    144,
                    1
                ],
                lightgrey: [
                    211,
                    211,
                    211,
                    1
                ],
                lightpink: [
                    255,
                    182,
                    193,
                    1
                ],
                lightsalmon: [
                    255,
                    160,
                    122,
                    1
                ],
                lightseagreen: [
                    32,
                    178,
                    170,
                    1
                ],
                lightskyblue: [
                    135,
                    206,
                    250,
                    1
                ],
                lightslategray: [
                    119,
                    136,
                    153,
                    1
                ],
                lightslategrey: [
                    119,
                    136,
                    153,
                    1
                ],
                lightsteelblue: [
                    176,
                    196,
                    222,
                    1
                ],
                lightyellow: [
                    255,
                    255,
                    224,
                    1
                ],
                lime: [
                    0,
                    255,
                    0,
                    1
                ],
                limegreen: [
                    50,
                    205,
                    50,
                    1
                ],
                linen: [
                    250,
                    240,
                    230,
                    1
                ],
                magenta: [
                    255,
                    0,
                    255,
                    1
                ],
                maroon: [
                    128,
                    0,
                    0,
                    1
                ],
                mediumaquamarine: [
                    102,
                    205,
                    170,
                    1
                ],
                mediumblue: [
                    0,
                    0,
                    205,
                    1
                ],
                mediumorchid: [
                    186,
                    85,
                    211,
                    1
                ],
                mediumpurple: [
                    147,
                    112,
                    219,
                    1
                ],
                mediumseagreen: [
                    60,
                    179,
                    113,
                    1
                ],
                mediumslateblue: [
                    123,
                    104,
                    238,
                    1
                ],
                mediumspringgreen: [
                    0,
                    250,
                    154,
                    1
                ],
                mediumturquoise: [
                    72,
                    209,
                    204,
                    1
                ],
                mediumvioletred: [
                    199,
                    21,
                    133,
                    1
                ],
                midnightblue: [
                    25,
                    25,
                    112,
                    1
                ],
                mintcream: [
                    245,
                    255,
                    250,
                    1
                ],
                mistyrose: [
                    255,
                    228,
                    225,
                    1
                ],
                moccasin: [
                    255,
                    228,
                    181,
                    1
                ],
                navajowhite: [
                    255,
                    222,
                    173,
                    1
                ],
                navy: [
                    0,
                    0,
                    128,
                    1
                ],
                oldlace: [
                    253,
                    245,
                    230,
                    1
                ],
                olive: [
                    128,
                    128,
                    0,
                    1
                ],
                olivedrab: [
                    107,
                    142,
                    35,
                    1
                ],
                orange: [
                    255,
                    165,
                    0,
                    1
                ],
                orangered: [
                    255,
                    69,
                    0,
                    1
                ],
                orchid: [
                    218,
                    112,
                    214,
                    1
                ],
                palegoldenrod: [
                    238,
                    232,
                    170,
                    1
                ],
                palegreen: [
                    152,
                    251,
                    152,
                    1
                ],
                paleturquoise: [
                    175,
                    238,
                    238,
                    1
                ],
                palevioletred: [
                    219,
                    112,
                    147,
                    1
                ],
                papayawhip: [
                    255,
                    239,
                    213,
                    1
                ],
                peachpuff: [
                    255,
                    218,
                    185,
                    1
                ],
                peru: [
                    205,
                    133,
                    63,
                    1
                ],
                pink: [
                    255,
                    192,
                    203,
                    1
                ],
                plum: [
                    221,
                    160,
                    221,
                    1
                ],
                powderblue: [
                    176,
                    224,
                    230,
                    1
                ],
                purple: [
                    128,
                    0,
                    128,
                    1
                ],
                rebeccapurple: [
                    102,
                    51,
                    153,
                    1
                ],
                red: [
                    255,
                    0,
                    0,
                    1
                ],
                rosybrown: [
                    188,
                    143,
                    143,
                    1
                ],
                royalblue: [
                    65,
                    105,
                    225,
                    1
                ],
                saddlebrown: [
                    139,
                    69,
                    19,
                    1
                ],
                salmon: [
                    250,
                    128,
                    114,
                    1
                ],
                sandybrown: [
                    244,
                    164,
                    96,
                    1
                ],
                seagreen: [
                    46,
                    139,
                    87,
                    1
                ],
                seashell: [
                    255,
                    245,
                    238,
                    1
                ],
                sienna: [
                    160,
                    82,
                    45,
                    1
                ],
                silver: [
                    192,
                    192,
                    192,
                    1
                ],
                skyblue: [
                    135,
                    206,
                    235,
                    1
                ],
                slateblue: [
                    106,
                    90,
                    205,
                    1
                ],
                slategray: [
                    112,
                    128,
                    144,
                    1
                ],
                slategrey: [
                    112,
                    128,
                    144,
                    1
                ],
                snow: [
                    255,
                    250,
                    250,
                    1
                ],
                springgreen: [
                    0,
                    255,
                    127,
                    1
                ],
                steelblue: [
                    70,
                    130,
                    180,
                    1
                ],
                tan: [
                    210,
                    180,
                    140,
                    1
                ],
                teal: [
                    0,
                    128,
                    128,
                    1
                ],
                thistle: [
                    216,
                    191,
                    216,
                    1
                ],
                tomato: [
                    255,
                    99,
                    71,
                    1
                ],
                turquoise: [
                    64,
                    224,
                    208,
                    1
                ],
                violet: [
                    238,
                    130,
                    238,
                    1
                ],
                wheat: [
                    245,
                    222,
                    179,
                    1
                ],
                white: [
                    255,
                    255,
                    255,
                    1
                ],
                whitesmoke: [
                    245,
                    245,
                    245,
                    1
                ],
                yellow: [
                    255,
                    255,
                    0,
                    1
                ],
                yellowgreen: [
                    154,
                    205,
                    50,
                    1
                ]
            };
            function n(t1) {
                return (t1 = Math.round(t1)) < 0 ? 0 : t1 > 255 ? 255 : t1;
            }
            function i(t1) {
                return n("%" === t1[t1.length - 1] ? parseFloat(t1) / 100 * 255 : parseInt(t1));
            }
            function s(t1) {
                var e1;
                return (e1 = "%" === t1[t1.length - 1] ? parseFloat(t1) / 100 : parseFloat(t1)) < 0 ? 0 : e1 > 1 ? 1 : e1;
            }
            function a(t1, e1, r) {
                return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t1 + (e1 - t1) * r * 6 : 2 * r < 1 ? e1 : 3 * r < 2 ? t1 + (e1 - t1) * (2 / 3 - r) * 6 : t1;
            }
            try {
                e1.parseCSSColor = function(t1) {
                    var e1, o = t1.replace(/ /g, "").toLowerCase();
                    if (o in r) return r[o].slice();
                    if ("#" === o[0]) return 4 === o.length ? (e1 = parseInt(o.substr(1), 16)) >= 0 && e1 <= 4095 ? [
                        (3840 & e1) >> 4 | (3840 & e1) >> 8,
                        240 & e1 | (240 & e1) >> 4,
                        15 & e1 | (15 & e1) << 4,
                        1
                    ] : null : 7 === o.length && (e1 = parseInt(o.substr(1), 16)) >= 0 && e1 <= 16777215 ? [
                        (16711680 & e1) >> 16,
                        (65280 & e1) >> 8,
                        255 & e1,
                        1
                    ] : null;
                    var l = o.indexOf("("), u = o.indexOf(")");
                    if (-1 !== l && u + 1 === o.length) {
                        var c = o.substr(0, l), h = o.substr(l + 1, u - (l + 1)).split(","), p = 1;
                        switch(c){
                            case "rgba":
                                if (4 !== h.length) return null;
                                p = s(h.pop());
                            case "rgb":
                                return 3 !== h.length ? null : [
                                    i(h[0]),
                                    i(h[1]),
                                    i(h[2]),
                                    p
                                ];
                            case "hsla":
                                if (4 !== h.length) return null;
                                p = s(h.pop());
                            case "hsl":
                                if (3 !== h.length) return null;
                                var f = (parseFloat(h[0]) % 360 + 360) % 360 / 360, d = s(h[1]), y = s(h[2]), m = y <= .5 ? y * (d + 1) : y + d - y * d, g = 2 * y - m;
                                return [
                                    n(255 * a(g, m, f + 1 / 3)),
                                    n(255 * a(g, m, f)),
                                    n(255 * a(g, m, f - 1 / 3)),
                                    p
                                ];
                            default:
                                return null;
                        }
                    }
                    return null;
                };
            } catch (t1) {}
        });
        class ge {
            static parse(t1) {
                if (!t1) return;
                if (t1 instanceof ge) return t1;
                if ("string" != typeof t1) return;
                const e1 = me.parseCSSColor(t1);
                return e1 ? new ge(e1[0] / 255 * e1[3], e1[1] / 255 * e1[3], e1[2] / 255 * e1[3], e1[3]) : void 0;
            }
            toString() {
                const [t1, e1, r, n] = this.toArray();
                return `rgba(${Math.round(t1)},${Math.round(e1)},${Math.round(r)},${n})`;
            }
            toArray() {
                const { r: t1, g: e1, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    255 * t1 / n,
                    255 * e1 / n,
                    255 * r / n,
                    n
                ];
            }
            toArray01() {
                const { r: t1, g: e1, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    t1 / n,
                    e1 / n,
                    r / n,
                    n
                ];
            }
            toArray01PremultipliedAlpha() {
                const { r: t1, g: e1, b: r, a: n } = this;
                return [
                    t1,
                    e1,
                    r,
                    n
                ];
            }
            constructor(t1, e1, r, n = 1){
                this.r = t1, this.g = e1, this.b = r, this.a = n;
            }
        }
        ge.black = new ge(0, 0, 0, 1), ge.white = new ge(1, 1, 1, 1), ge.transparent = new ge(0, 0, 0, 0), ge.red = new ge(1, 0, 0, 1), ge.blue = new ge(0, 0, 1, 1);
        var xe = ge;
        class ve {
            compare(t1, e1) {
                return this.collator.compare(t1, e1);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
            constructor(t1, e1, r){
                this.sensitivity = t1 ? e1 ? "variant" : "case" : e1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
        }
        class be {
            constructor(t1, e1, r, n, i){
                this.text = t1.normalize ? t1.normalize() : t1, this.image = e1, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class _e {
            static fromString(t1) {
                return new _e([
                    new be(t1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t1)=>0 !== t1.text.length || t1.image && 0 !== t1.image.name.length);
            }
            static factory(t1) {
                return t1 instanceof _e ? t1 : _e.fromString(t1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t1)=>t1.text).join("");
            }
            serialize() {
                const t1 = [
                    "format"
                ];
                for (const e1 of this.sections){
                    if (e1.image) {
                        t1.push([
                            "image",
                            e1.image.name
                        ]);
                        continue;
                    }
                    t1.push(e1.text);
                    const r = {};
                    e1.fontStack && (r["text-font"] = [
                        "literal",
                        e1.fontStack.split(",")
                    ]), e1.scale && (r["font-scale"] = e1.scale), e1.textColor && (r["text-color"] = [
                        "rgba"
                    ].concat(e1.textColor.toArray())), t1.push(r);
                }
                return t1;
            }
            constructor(t1){
                this.sections = t1;
            }
        }
        class we {
            toString() {
                return this.name;
            }
            static fromString(t1) {
                return t1 ? new we({
                    name: t1,
                    available: !1
                }) : null;
            }
            serialize() {
                return [
                    "image",
                    this.name
                ];
            }
            constructor(t1){
                this.name = t1.name, this.available = t1.available;
            }
        }
        function Ae(t1, e1, r, n) {
            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                t1,
                e1,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                t1,
                e1,
                r,
                n
            ] : [
                t1,
                e1,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function Se(t1) {
            if (null === t1) return !0;
            if ("string" == typeof t1) return !0;
            if ("boolean" == typeof t1) return !0;
            if ("number" == typeof t1) return !0;
            if (t1 instanceof xe) return !0;
            if (t1 instanceof ve) return !0;
            if (t1 instanceof _e) return !0;
            if (t1 instanceof we) return !0;
            if (Array.isArray(t1)) {
                for (const e1 of t1)if (!Se(e1)) return !1;
                return !0;
            }
            if ("object" == typeof t1) {
                for(const e1 in t1)if (!Se(t1[e1])) return !1;
                return !0;
            }
            return !1;
        }
        function ke(t1) {
            if (null === t1) return Qt;
            if ("string" == typeof t1) return ee;
            if ("boolean" == typeof t1) return re;
            if ("number" == typeof t1) return te;
            if (t1 instanceof xe) return ne;
            if (t1 instanceof ve) return ae;
            if (t1 instanceof _e) return oe;
            if (t1 instanceof we) return le;
            if (Array.isArray(t1)) {
                const e1 = t1.length;
                let r;
                for (const e1 of t1){
                    const t1 = ke(e1);
                    if (r) {
                        if (r === t1) continue;
                        r = se;
                        break;
                    }
                    r = t1;
                }
                return ue(r || se, e1);
            }
            return ie;
        }
        function Ie(t1) {
            const e1 = typeof t1;
            return null === t1 ? "" : "string" === e1 || "number" === e1 || "boolean" === e1 ? String(t1) : t1 instanceof xe || t1 instanceof _e || t1 instanceof we ? t1.toString() : JSON.stringify(t1);
        }
        class Me {
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`'literal' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (!Se(t1[1])) return e1.error("invalid value");
                const r = t1[1];
                let n = ke(r);
                const i = e1.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new Me(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return "array" === this.type.kind || "object" === this.type.kind ? [
                    "literal",
                    this.value
                ] : this.value instanceof xe ? [
                    "rgba"
                ].concat(this.value.toArray()) : this.value instanceof _e ? this.value.serialize() : this.value;
            }
            constructor(t1, e1){
                this.type = t1, this.value = e1;
            }
        }
        var ze = Me, Te = class {
            toJSON() {
                return this.message;
            }
            constructor(t1){
                this.name = "ExpressionEvaluationError", this.message = t1;
            }
        };
        const Be = {
            string: ee,
            number: te,
            boolean: re,
            object: ie
        };
        class Ee {
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                let r, n = 1;
                const i = t1[0];
                if ("array" === i) {
                    let i, s;
                    if (t1.length > 2) {
                        const r = t1[1];
                        if ("string" != typeof r || !(r in Be) || "object" === r) return e1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = Be[r], n++;
                    } else i = se;
                    if (t1.length > 3) {
                        if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e1.error('The length argument to "array" must be a positive integer literal', 2);
                        s = t1[2], n++;
                    }
                    r = ue(i, s);
                } else r = Be[i];
                const s = [];
                for(; n < t1.length; n++){
                    const r = e1.parse(t1[n], n, se);
                    if (!r) return null;
                    s.push(r);
                }
                return new Ee(r, s);
            }
            evaluate(t1) {
                for(let e1 = 0; e1 < this.args.length; e1++){
                    const r = this.args[e1].evaluate(t1);
                    if (!pe(this.type, ke(r))) return r;
                    if (e1 === this.args.length - 1) throw new Te(`Expected value to be of type ${ce(this.type)}, but found ${ce(ke(r))} instead.`);
                }
                return null;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = this.type, e1 = [
                    t1.kind
                ];
                if ("array" === t1.kind) {
                    const r = t1.itemType;
                    if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                        e1.push(r.kind);
                        const n = t1.N;
                        ("number" == typeof n || this.args.length > 1) && e1.push(n);
                    }
                }
                return e1.concat(this.args.map((t1)=>t1.serialize()));
            }
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
        }
        var Ce = Ee;
        class Pe {
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                const r = t1[1];
                if (!Array.isArray(r) && "object" == typeof r) return e1.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= t1.length - 1; ++r){
                    const s = t1[r];
                    if (i && "object" == typeof s && !Array.isArray(s)) {
                        i = !1;
                        let t1 = null;
                        if (s["font-scale"] && (t1 = e1.parse(s["font-scale"], 1, te), !t1)) return null;
                        let r = null;
                        if (s["text-font"] && (r = e1.parse(s["text-font"], 1, ue(ee)), !r)) return null;
                        let a = null;
                        if (s["text-color"] && (a = e1.parse(s["text-color"], 1, ne), !a)) return null;
                        const o = n[n.length - 1];
                        o.scale = t1, o.font = r, o.textColor = a;
                    } else {
                        const s = e1.parse(t1[r], 1, se);
                        if (!s) return null;
                        const a = s.type.kind;
                        if ("string" !== a && "value" !== a && "null" !== a && "resolvedImage" !== a) return e1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: s,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new Pe(n);
            }
            evaluate(t1) {
                return new _e(this.sections.map((e1)=>{
                    const r = e1.content.evaluate(t1);
                    return ke(r) === le ? new be("", r, null, null, null) : new be(Ie(r), null, e1.scale ? e1.scale.evaluate(t1) : null, e1.font ? e1.font.evaluate(t1).join(",") : null, e1.textColor ? e1.textColor.evaluate(t1) : null);
                }));
            }
            eachChild(t1) {
                for (const e1 of this.sections)t1(e1.content), e1.scale && t1(e1.scale), e1.font && t1(e1.font), e1.textColor && t1(e1.textColor);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "format"
                ];
                for (const e1 of this.sections){
                    t1.push(e1.content.serialize());
                    const r = {};
                    e1.scale && (r["font-scale"] = e1.scale.serialize()), e1.font && (r["text-font"] = e1.font.serialize()), e1.textColor && (r["text-color"] = e1.textColor.serialize()), t1.push(r);
                }
                return t1;
            }
            constructor(t1){
                this.type = oe, this.sections = t1;
            }
        }
        class De {
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error("Expected two arguments.");
                const r = e1.parse(t1[1], 1, ee);
                return r ? new De(r) : e1.error("No image name provided.");
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1), r = we.fromString(e1);
                return r && t1.availableImages && (r.available = t1.availableImages.indexOf(e1) > -1), r;
            }
            eachChild(t1) {
                t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "image",
                    this.input.serialize()
                ];
            }
            constructor(t1){
                this.type = le, this.input = t1;
            }
        }
        const Ve = {
            "to-boolean": re,
            "to-color": ne,
            "to-number": te,
            "to-string": ee
        };
        class Fe {
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                const r = t1[0];
                if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e1.error("Expected one argument.");
                const n = Ve[r], i = [];
                for(let r = 1; r < t1.length; r++){
                    const n = e1.parse(t1[r], r, se);
                    if (!n) return null;
                    i.push(n);
                }
                return new Fe(n, i);
            }
            evaluate(t1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t1));
                if ("color" === this.type.kind) {
                    let e1, r;
                    for (const n of this.args){
                        if (e1 = n.evaluate(t1), r = null, e1 instanceof xe) return e1;
                        if ("string" == typeof e1) {
                            const r = t1.parseColor(e1);
                            if (r) return r;
                        } else if (Array.isArray(e1) && (r = e1.length < 3 || e1.length > 4 ? `Invalid rbga value ${JSON.stringify(e1)}: expected an array containing either three or four numeric values.` : Ae(e1[0], e1[1], e1[2], e1[3]), !r)) return new xe(e1[0] / 255, e1[1] / 255, e1[2] / 255, e1[3]);
                    }
                    throw new Te(r || `Could not parse color from value '${"string" == typeof e1 ? e1 : String(JSON.stringify(e1))}'`);
                }
                if ("number" === this.type.kind) {
                    let e1 = null;
                    for (const r of this.args){
                        if (e1 = r.evaluate(t1), null === e1) return 0;
                        const n = Number(e1);
                        if (!isNaN(n)) return n;
                    }
                    throw new Te(`Could not convert ${JSON.stringify(e1)} to number.`);
                }
                return "formatted" === this.type.kind ? _e.fromString(Ie(this.args[0].evaluate(t1))) : "resolvedImage" === this.type.kind ? we.fromString(Ie(this.args[0].evaluate(t1))) : Ie(this.args[0].evaluate(t1));
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                if ("formatted" === this.type.kind) return new Pe([
                    {
                        content: this.args[0],
                        scale: null,
                        font: null,
                        textColor: null
                    }
                ]).serialize();
                if ("resolvedImage" === this.type.kind) return new De(this.args[0]).serialize();
                const t1 = [
                    `to-${this.type.kind}`
                ];
                return this.eachChild((e1)=>{
                    t1.push(e1.serialize());
                }), t1;
            }
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
        }
        var Le = Fe;
        const Re = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        var Ue = class {
            id() {
                return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? Re[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            distanceFromCenter() {
                if (this.featureTileCoord && this.featureDistanceData) {
                    const t1 = this.featureDistanceData.center, e1 = this.featureDistanceData.scale, { x: r, y: n } = this.featureTileCoord;
                    return this.featureDistanceData.bearing[0] * (r * e1 - t1[0]) + this.featureDistanceData.bearing[1] * (n * e1 - t1[1]);
                }
                return 0;
            }
            parseColor(t1) {
                let e1 = this._parseColorCache[t1];
                return e1 || (e1 = this._parseColorCache[t1] = xe.parse(t1)), e1;
            }
            constructor(){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null;
            }
        };
        class je {
            evaluate(t1) {
                return this._evaluate(t1, this.args);
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    this.name
                ].concat(this.args.map((t1)=>t1.serialize()));
            }
            static parse(t1, e1) {
                const r = t1[0], n = je.definitions[r];
                if (!n) return e1.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, s = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, a = s.filter(([e1])=>!Array.isArray(e1) || e1.length === t1.length - 1);
                let o = null;
                for (const [n, s] of a){
                    o = new fr(e1.registry, e1.path, null, e1.scope);
                    const a = [];
                    let l = !1;
                    for(let e1 = 1; e1 < t1.length; e1++){
                        const r = t1[e1], i = Array.isArray(n) ? n[e1 - 1] : n.type, s = o.parse(r, 1 + a.length, i);
                        if (!s) {
                            l = !0;
                            break;
                        }
                        a.push(s);
                    }
                    if (!l) {
                        if (Array.isArray(n) && n.length !== a.length) o.error(`Expected ${n.length} arguments, but found ${a.length} instead.`);
                        else {
                            for(let t1 = 0; t1 < a.length; t1++){
                                const e1 = Array.isArray(n) ? n[t1] : n.type, r = a[t1];
                                o.concat(t1 + 1).checkSubtype(e1, r.type);
                            }
                            if (0 === o.errors.length) return new je(r, i, s, a);
                        }
                    }
                }
                if (1 === a.length) e1.errors.push(...o.errors);
                else {
                    const r = (a.length ? a : s).map(([t1])=>{
                        var e1;
                        return e1 = t1, Array.isArray(e1) ? `(${e1.map(ce).join(", ")})` : `(${ce(e1.type)}...)`;
                    }).join(" | "), n = [];
                    for(let r = 1; r < t1.length; r++){
                        const i = e1.parse(t1[r], 1 + n.length);
                        if (!i) return null;
                        n.push(ce(i.type));
                    }
                    e1.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t1, e1) {
                je.definitions = e1;
                for(const r in e1)t1[r] = je;
            }
            constructor(t1, e1, r, n){
                this.name = t1, this.type = e1, this._evaluate = r, this.args = n;
            }
        }
        var $e = je;
        class Oe {
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error("Expected one argument.");
                const r = t1[1];
                if ("object" != typeof r || Array.isArray(r)) return e1.error("Collator options argument must be an object.");
                const n = e1.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, re);
                if (!n) return null;
                const i = e1.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, re);
                if (!i) return null;
                let s = null;
                return r.locale && (s = e1.parse(r.locale, 1, ee), !s) ? null : new Oe(n, i, s);
            }
            evaluate(t1) {
                return new ve(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
            }
            eachChild(t1) {
                t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = {};
                return t1["case-sensitive"] = this.caseSensitive.serialize(), t1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t1.locale = this.locale.serialize()), [
                    "collator",
                    t1
                ];
            }
            constructor(t1, e1, r){
                this.type = ae, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e1;
            }
        }
        const qe = 8192;
        function Ne(t1, e1) {
            t1[0] = Math.min(t1[0], e1[0]), t1[1] = Math.min(t1[1], e1[1]), t1[2] = Math.max(t1[2], e1[0]), t1[3] = Math.max(t1[3], e1[1]);
        }
        function Ge(t1, e1) {
            return !(t1[0] <= e1[0] || t1[2] >= e1[2] || t1[1] <= e1[1] || t1[3] >= e1[3]);
        }
        function Ze(t1, e1) {
            const r = (180 + t1[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1[1] * Math.PI / 360))) / 360, i = Math.pow(2, e1.z);
            return [
                Math.round(r * i * qe),
                Math.round(n * i * qe)
            ];
        }
        function Xe(t1, e1, r) {
            const n = t1[0] - e1[0], i = t1[1] - e1[1], s = t1[0] - r[0], a = t1[1] - r[1];
            return n * a - s * i == 0 && n * s <= 0 && i * a <= 0;
        }
        function Ke(t1, e1) {
            let r = !1;
            for(let a = 0, o = e1.length; a < o; a++){
                const o = e1[a];
                for(let e1 = 0, a = o.length; e1 < a - 1; e1++){
                    if (Xe(t1, o[e1], o[e1 + 1])) return !1;
                    (i = o[e1])[1] > (n = t1)[1] != (s = o[e1 + 1])[1] > n[1] && n[0] < (s[0] - i[0]) * (n[1] - i[1]) / (s[1] - i[1]) + i[0] && (r = !r);
                }
            }
            var n, i, s;
            return r;
        }
        function He(t1, e1) {
            for(let r = 0; r < e1.length; r++)if (Ke(t1, e1[r])) return !0;
            return !1;
        }
        function Ye(t1, e1, r, n) {
            const i = n[0] - r[0], s = n[1] - r[1], a = (t1[0] - r[0]) * s - i * (t1[1] - r[1]), o = (e1[0] - r[0]) * s - i * (e1[1] - r[1]);
            return a > 0 && o < 0 || a < 0 && o > 0;
        }
        function We(t1, e1, r) {
            for (const u of r)for(let r = 0; r < u.length - 1; ++r)if (0 != (o = [
                (a = u[r + 1])[0] - (s = u[r])[0],
                a[1] - s[1]
            ])[0] * (l = [
                (i = e1)[0] - (n = t1)[0],
                i[1] - n[1]
            ])[1] - o[1] * l[0] && Ye(n, i, s, a) && Ye(s, a, n, i)) return !0;
            var n, i, s, a, o, l;
            return !1;
        }
        function Je(t1, e1) {
            for(let r = 0; r < t1.length; ++r)if (!Ke(t1[r], e1)) return !1;
            for(let r = 0; r < t1.length - 1; ++r)if (We(t1[r], t1[r + 1], e1)) return !1;
            return !0;
        }
        function Qe(t1, e1) {
            for(let r = 0; r < e1.length; r++)if (Je(t1, e1[r])) return !0;
            return !1;
        }
        function tr(t1, e1, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const s = [];
                for(let n = 0; n < t1[i].length; n++){
                    const a = Ze(t1[i][n], r);
                    Ne(e1, a), s.push(a);
                }
                n.push(s);
            }
            return n;
        }
        function er(t1, e1, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const s = tr(t1[i], e1, r);
                n.push(s);
            }
            return n;
        }
        function rr(t1, e1, r, n) {
            if (t1[0] < r[0] || t1[0] > r[2]) {
                const e1 = .5 * n;
                let i = t1[0] - r[0] > e1 ? -n : r[0] - t1[0] > e1 ? n : 0;
                0 === i && (i = t1[0] - r[2] > e1 ? -n : r[2] - t1[0] > e1 ? n : 0), t1[0] += i;
            }
            Ne(e1, t1);
        }
        function nr(t1, e1, r, n) {
            const i = Math.pow(2, n.z) * qe, s = [
                n.x * qe,
                n.y * qe
            ], a = [];
            if (!t1) return a;
            for (const n of t1)for (const t1 of n){
                const n = [
                    t1.x + s[0],
                    t1.y + s[1]
                ];
                rr(n, e1, r, i), a.push(n);
            }
            return a;
        }
        function ir(t1, e1, r, n) {
            const i = Math.pow(2, n.z) * qe, s = [
                n.x * qe,
                n.y * qe
            ], a = [];
            if (!t1) return a;
            for (const r of t1){
                const t1 = [];
                for (const n of r){
                    const r = [
                        n.x + s[0],
                        n.y + s[1]
                    ];
                    Ne(e1, r), t1.push(r);
                }
                a.push(t1);
            }
            if (e1[2] - e1[0] <= i / 2) {
                (o = e1)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                for (const t1 of a)for (const n of t1)rr(n, e1, r, i);
            }
            var o;
            return a;
        }
        class sr {
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`'within' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (Se(t1[1])) {
                    const e1 = t1[1];
                    if ("FeatureCollection" === e1.type) for(let t1 = 0; t1 < e1.features.length; ++t1){
                        const r = e1.features[t1].geometry.type;
                        if ("Polygon" === r || "MultiPolygon" === r) return new sr(e1, e1.features[t1].geometry);
                    }
                    else if ("Feature" === e1.type) {
                        const t1 = e1.geometry.type;
                        if ("Polygon" === t1 || "MultiPolygon" === t1) return new sr(e1, e1.geometry);
                    } else if ("Polygon" === e1.type || "MultiPolygon" === e1.type) return new sr(e1, e1);
                }
                return e1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t1) {
                if (null != t1.geometry() && null != t1.canonicalID()) {
                    if ("Point" === t1.geometryType()) return function(t1, e1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === e1.type) {
                            const s = tr(e1.coordinates, n, i), a = nr(t1.geometry(), r, n, i);
                            if (!Ge(r, n)) return !1;
                            for (const t1 of a)if (!Ke(t1, s)) return !1;
                        }
                        if ("MultiPolygon" === e1.type) {
                            const s = er(e1.coordinates, n, i), a = nr(t1.geometry(), r, n, i);
                            if (!Ge(r, n)) return !1;
                            for (const t1 of a)if (!He(t1, s)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                    if ("LineString" === t1.geometryType()) return function(t1, e1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === e1.type) {
                            const s = tr(e1.coordinates, n, i), a = ir(t1.geometry(), r, n, i);
                            if (!Ge(r, n)) return !1;
                            for (const t1 of a)if (!Je(t1, s)) return !1;
                        }
                        if ("MultiPolygon" === e1.type) {
                            const s = er(e1.coordinates, n, i), a = ir(t1.geometry(), r, n, i);
                            if (!Ge(r, n)) return !1;
                            for (const t1 of a)if (!Qe(t1, s)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "within",
                    this.geojson
                ];
            }
            constructor(t1, e1){
                this.type = re, this.geojson = t1, this.geometries = e1;
            }
        }
        var ar = sr;
        function or(t1) {
            if (t1 instanceof $e) {
                if ("get" === t1.name && 1 === t1.args.length) return !1;
                if ("feature-state" === t1.name) return !1;
                if ("has" === t1.name && 1 === t1.args.length) return !1;
                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                if (/^filter-/.test(t1.name)) return !1;
            }
            if (t1 instanceof ar) return !1;
            let e1 = !0;
            return t1.eachChild((t1)=>{
                e1 && !or(t1) && (e1 = !1);
            }), e1;
        }
        function lr(t1) {
            if (t1 instanceof $e && "feature-state" === t1.name) return !1;
            let e1 = !0;
            return t1.eachChild((t1)=>{
                e1 && !lr(t1) && (e1 = !1);
            }), e1;
        }
        function ur(t1, e1) {
            if (t1 instanceof $e && e1.indexOf(t1.name) >= 0) return !1;
            let r = !0;
            return t1.eachChild((t1)=>{
                r && !ur(t1, e1) && (r = !1);
            }), r;
        }
        class cr {
            static parse(t1, e1) {
                if (2 !== t1.length || "string" != typeof t1[1]) return e1.error("'var' expression requires exactly one string literal argument.");
                const r = t1[1];
                return e1.scope.has(r) ? new cr(r, e1.scope.get(r)) : e1.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t1) {
                return this.boundExpression.evaluate(t1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "var",
                    this.name
                ];
            }
            constructor(t1, e1){
                this.type = e1.type, this.name = t1, this.boundExpression = e1;
            }
        }
        var hr = cr;
        class pr {
            parse(t1, e1, r, n, i = {}) {
                return e1 ? this.concat(e1, r, n)._parse(t1, i) : this._parse(t1, i);
            }
            _parse(t1, e1) {
                function r(t1, e1, r) {
                    return "assert" === r ? new Ce(e1, [
                        t1
                    ]) : "coerce" === r ? new Le(e1, [
                        t1
                    ]) : t1;
                }
                if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                    "literal",
                    t1
                ]), Array.isArray(t1)) {
                    if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = t1[0];
                    if ("string" != typeof n) return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                    const i = this.registry[n];
                    if (i) {
                        let n = i.parse(t1, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const t1 = this.expectedType, i = n.type;
                            if ("string" !== t1.kind && "number" !== t1.kind && "boolean" !== t1.kind && "object" !== t1.kind && "array" !== t1.kind || "value" !== i.kind) {
                                if ("color" !== t1.kind && "formatted" !== t1.kind && "resolvedImage" !== t1.kind || "value" !== i.kind && "string" !== i.kind) {
                                    if (this.checkSubtype(t1, i)) return null;
                                } else n = r(n, t1, e1.typeAnnotation || "coerce");
                            } else n = r(n, t1, e1.typeAnnotation || "assert");
                        }
                        if (!(n instanceof ze) && "resolvedImage" !== n.type.kind && dr(n)) {
                            const t1 = new Ue;
                            try {
                                n = new ze(n.type, n.evaluate(t1));
                            } catch (t1) {
                                return this.error(t1.message), null;
                            }
                        }
                        return n;
                    }
                    return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
                }
                return this.error(void 0 === t1 ? "'undefined' value invalid. Use null instead." : "object" == typeof t1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t1} instead.`);
            }
            concat(t1, e1, r) {
                const n = "number" == typeof t1 ? this.path.concat(t1) : this.path, i = r ? this.scope.concat(r) : this.scope;
                return new pr(this.registry, n, e1 || null, i, this.errors);
            }
            error(t1, ...e1) {
                const r = `${this.key}${e1.map((t1)=>`[${t1}]`).join("")}`;
                this.errors.push(new Yt(r, t1));
            }
            checkSubtype(t1, e1) {
                const r = pe(t1, e1);
                return r && this.error(r), r;
            }
            constructor(t1, e1 = [], r, n = new Jt, i = []){
                this.registry = t1, this.path = e1, this.key = e1.map((t1)=>`[${t1}]`).join(""), this.scope = n, this.errors = i, this.expectedType = r;
            }
        }
        var fr = pr;
        function dr(t1) {
            if (t1 instanceof hr) return dr(t1.boundExpression);
            if (t1 instanceof $e && "error" === t1.name) return !1;
            if (t1 instanceof Oe) return !1;
            if (t1 instanceof ar) return !1;
            const e1 = t1 instanceof Le || t1 instanceof Ce;
            let r = !0;
            return t1.eachChild((t1)=>{
                r = e1 ? r && dr(t1) : r && t1 instanceof ze;
            }), !!r && or(t1) && ur(t1, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "sky-radial-progress",
                "accumulated",
                "is-supported-script",
                "pitch",
                "distance-from-center"
            ]);
        }
        function yr(t1, e1) {
            const r = t1.length - 1;
            let n, i, s = 0, a = r, o = 0;
            for(; s <= a;)if (o = Math.floor((s + a) / 2), n = t1[o], i = t1[o + 1], n <= e1) {
                if (o === r || e1 < i) return o;
                s = o + 1;
            } else {
                if (!(n > e1)) throw new Te("Input is not a number.");
                a = o - 1;
            }
            return 0;
        }
        class mr {
            static parse(t1, e1) {
                if (t1.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                const r = e1.parse(t1[1], 1, te);
                if (!r) return null;
                const n = [];
                let i = null;
                e1.expectedType && "value" !== e1.expectedType.kind && (i = e1.expectedType);
                for(let r = 1; r < t1.length; r += 2){
                    const s = 1 === r ? -1 / 0 : t1[r], a = t1[r + 1], o = r, l = r + 1;
                    if ("number" != typeof s) return e1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                    if (n.length && n[n.length - 1][0] >= s) return e1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                    const u = e1.parse(a, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        s,
                        u
                    ]);
                }
                return new mr(i, r, n);
            }
            evaluate(t1) {
                const e1 = this.labels, r = this.outputs;
                if (1 === e1.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e1[0]) return r[0].evaluate(t1);
                const i = e1.length;
                return n >= e1[i - 1] ? r[i - 1].evaluate(t1) : r[yr(e1, n)].evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input);
                for (const e1 of this.outputs)t1(e1);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = [
                    "step",
                    this.input.serialize()
                ];
                for(let e1 = 0; e1 < this.labels.length; e1++)e1 > 0 && t1.push(this.labels[e1]), t1.push(this.outputs[e1].serialize());
                return t1;
            }
            constructor(t1, e1, r){
                this.type = t1, this.input = e1, this.labels = [], this.outputs = [];
                for (const [t1, e1] of r)this.labels.push(t1), this.outputs.push(e1);
            }
        }
        var gr = mr;
        function xr(t1, e1, r) {
            return t1 * (1 - r) + e1 * r;
        }
        function vr(t1, e1, r) {
            return t1.map((t1, n)=>xr(t1, e1[n], r));
        }
        var br = Object.freeze({
            __proto__: null,
            number: xr,
            color: function(t1, e1, r) {
                return new xe(xr(t1.r, e1.r, r), xr(t1.g, e1.g, r), xr(t1.b, e1.b, r), xr(t1.a, e1.a, r));
            },
            array: vr
        });
        const _r = .95047, wr = 1.08883, Ar = 4 / 29, Sr = 6 / 29, kr = 3 * Sr * Sr, Ir = Math.PI / 180, Mr = 180 / Math.PI;
        function zr(t1) {
            return t1 > .008856451679035631 ? Math.pow(t1, 1 / 3) : t1 / kr + Ar;
        }
        function Tr(t1) {
            return t1 > Sr ? t1 * t1 * t1 : kr * (t1 - Ar);
        }
        function Br(t1) {
            return 255 * (t1 <= .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055);
        }
        function Er(t1) {
            return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
        }
        function Cr(t1) {
            const e1 = Er(t1.r), r = Er(t1.g), n = Er(t1.b), i = zr((.4124564 * e1 + .3575761 * r + .1804375 * n) / _r), s = zr((.2126729 * e1 + .7151522 * r + .072175 * n) / 1);
            return {
                l: 116 * s - 16,
                a: 500 * (i - s),
                b: 200 * (s - zr((.0193339 * e1 + .119192 * r + .9503041 * n) / wr)),
                alpha: t1.a
            };
        }
        function Pr(t1) {
            let e1 = (t1.l + 16) / 116, r = isNaN(t1.a) ? e1 : e1 + t1.a / 500, n = isNaN(t1.b) ? e1 : e1 - t1.b / 200;
            return e1 = 1 * Tr(e1), r = _r * Tr(r), n = wr * Tr(n), new xe(Br(3.2404542 * r - 1.5371385 * e1 - .4985314 * n), Br(-0.969266 * r + 1.8760108 * e1 + .041556 * n), Br(.0556434 * r - .2040259 * e1 + 1.0572252 * n), t1.alpha);
        }
        function Dr(t1, e1, r) {
            const n = e1 - t1;
            return t1 + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        const Vr = {
            forward: Cr,
            reverse: Pr,
            interpolate: function(t1, e1, r) {
                return {
                    l: xr(t1.l, e1.l, r),
                    a: xr(t1.a, e1.a, r),
                    b: xr(t1.b, e1.b, r),
                    alpha: xr(t1.alpha, e1.alpha, r)
                };
            }
        }, Fr = {
            forward: function(t1) {
                const { l: e1, a: r, b: n } = Cr(t1), i = Math.atan2(n, r) * Mr;
                return {
                    h: i < 0 ? i + 360 : i,
                    c: Math.sqrt(r * r + n * n),
                    l: e1,
                    alpha: t1.a
                };
            },
            reverse: function(t1) {
                const e1 = t1.h * Ir, r = t1.c;
                return Pr({
                    l: t1.l,
                    a: Math.cos(e1) * r,
                    b: Math.sin(e1) * r,
                    alpha: t1.alpha
                });
            },
            interpolate: function(t1, e1, r) {
                return {
                    h: Dr(t1.h, e1.h, r),
                    c: xr(t1.c, e1.c, r),
                    l: xr(t1.l, e1.l, r),
                    alpha: xr(t1.alpha, e1.alpha, r)
                };
            }
        };
        var Lr = Object.freeze({
            __proto__: null,
            lab: Vr,
            hcl: Fr
        });
        class Rr {
            static interpolationFactor(t1, e1, n, i) {
                let s = 0;
                if ("exponential" === t1.name) s = Ur(e1, t1.base, n, i);
                else if ("linear" === t1.name) s = Ur(e1, 1, n, i);
                else if ("cubic-bezier" === t1.name) {
                    const a = t1.controlPoints;
                    s = new r(a[0], a[1], a[2], a[3]).solve(Ur(e1, 1, n, i));
                }
                return s;
            }
            static parse(t1, e1) {
                let [r, n, i, ...s] = t1;
                if (!Array.isArray(n) || 0 === n.length) return e1.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const t1 = n[1];
                    if ("number" != typeof t1) return e1.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: t1
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return e1.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const t1 = n.slice(1);
                        if (4 !== t1.length || t1.some((t1)=>"number" != typeof t1 || t1 < 0 || t1 > 1)) return e1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: t1
                        };
                    }
                }
                if (t1.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                if (i = e1.parse(i, 2, te), !i) return null;
                const a = [];
                let o = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? o = ne : e1.expectedType && "value" !== e1.expectedType.kind && (o = e1.expectedType);
                for(let t1 = 0; t1 < s.length; t1 += 2){
                    const r = s[t1], n = s[t1 + 1], i = t1 + 3, l = t1 + 4;
                    if ("number" != typeof r) return e1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (a.length && a[a.length - 1][0] >= r) return e1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e1.parse(n, l, o);
                    if (!u) return null;
                    o = o || u.type, a.push([
                        r,
                        u
                    ]);
                }
                return "number" === o.kind || "color" === o.kind || "array" === o.kind && "number" === o.itemType.kind && "number" == typeof o.N ? new Rr(o, r, n, i, a) : e1.error(`Type ${ce(o)} is not interpolatable.`);
            }
            evaluate(t1) {
                const e1 = this.labels, r = this.outputs;
                if (1 === e1.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e1[0]) return r[0].evaluate(t1);
                const i = e1.length;
                if (n >= e1[i - 1]) return r[i - 1].evaluate(t1);
                const s = yr(e1, n), a = Rr.interpolationFactor(this.interpolation, n, e1[s], e1[s + 1]), o = r[s].evaluate(t1), l = r[s + 1].evaluate(t1);
                return "interpolate" === this.operator ? br[this.type.kind.toLowerCase()](o, l, a) : "interpolate-hcl" === this.operator ? Fr.reverse(Fr.interpolate(Fr.forward(o), Fr.forward(l), a)) : Vr.reverse(Vr.interpolate(Vr.forward(o), Vr.forward(l), a));
            }
            eachChild(t1) {
                t1(this.input);
                for (const e1 of this.outputs)t1(e1);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            serialize() {
                let t1;
                t1 = "linear" === this.interpolation.name ? [
                    "linear"
                ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                    "linear"
                ] : [
                    "exponential",
                    this.interpolation.base
                ] : [
                    "cubic-bezier"
                ].concat(this.interpolation.controlPoints);
                const e1 = [
                    this.operator,
                    t1,
                    this.input.serialize()
                ];
                for(let t1 = 0; t1 < this.labels.length; t1++)e1.push(this.labels[t1], this.outputs[t1].serialize());
                return e1;
            }
            constructor(t1, e1, r, n, i){
                this.type = t1, this.operator = e1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [t1, e1] of i)this.labels.push(t1), this.outputs.push(e1);
            }
        }
        function Ur(t1, e1, r, n) {
            const i = n - r, s = t1 - r;
            return 0 === i ? 0 : 1 === e1 ? s / i : (Math.pow(e1, s) - 1) / (Math.pow(e1, i) - 1);
        }
        var jr = Rr;
        class $r {
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expectected at least one argument.");
                let r = null;
                const n = e1.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of t1.slice(1)){
                    const t1 = e1.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t1) return null;
                    r = r || t1.type, i.push(t1);
                }
                const s = n && i.some((t1)=>pe(n, t1.type));
                return new $r(s ? se : r, i);
            }
            evaluate(t1) {
                let e1, r = null, n = 0;
                for (const i of this.args){
                    if (n++, r = i.evaluate(t1), r && r instanceof we && !r.available && (e1 || (e1 = r), r = null, n === this.args.length)) return e1;
                    if (null !== r) break;
                }
                return r;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = [
                    "coalesce"
                ];
                return this.eachChild((e1)=>{
                    t1.push(e1.serialize());
                }), t1;
            }
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
        }
        var Or = $r;
        class qr {
            evaluate(t1) {
                return this.result.evaluate(t1);
            }
            eachChild(t1) {
                for (const e1 of this.bindings)t1(e1[1]);
                t1(this.result);
            }
            static parse(t1, e1) {
                if (t1.length < 4) return e1.error(`Expected at least 3 arguments, but found ${t1.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < t1.length - 1; n += 2){
                    const i = t1[n];
                    if ("string" != typeof i) return e1.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const s = e1.parse(t1[n + 1], n + 1);
                    if (!s) return null;
                    r.push([
                        i,
                        s
                    ]);
                }
                const n = e1.parse(t1[t1.length - 1], t1.length - 1, e1.expectedType, r);
                return n ? new qr(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            serialize() {
                const t1 = [
                    "let"
                ];
                for (const [e1, r] of this.bindings)t1.push(e1, r.serialize());
                return t1.push(this.result.serialize()), t1;
            }
            constructor(t1, e1){
                this.type = e1.type, this.bindings = [].concat(t1), this.result = e1;
            }
        }
        var Nr = qr;
        class Gr {
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, te), n = e1.parse(t1[2], 2, ue(e1.expectedType || se));
                return r && n ? new Gr(n.type.itemType, r, n) : null;
            }
            evaluate(t1) {
                const e1 = this.index.evaluate(t1), r = this.input.evaluate(t1);
                if (e1 < 0) throw new Te(`Array index out of bounds: ${e1} < 0.`);
                if (e1 >= r.length) throw new Te(`Array index out of bounds: ${e1} > ${r.length - 1}.`);
                if (e1 !== Math.floor(e1)) throw new Te(`Array index must be an integer, but found ${e1} instead.`);
                return r[e1];
            }
            eachChild(t1) {
                t1(this.index), t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
            constructor(t1, e1, r){
                this.type = t1, this.index = e1, this.input = r;
            }
        }
        var Zr = Gr;
        class Xr {
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, se), n = e1.parse(t1[2], 2, se);
                return r && n ? fe(r.type, [
                    re,
                    ee,
                    te,
                    Qt,
                    se
                ]) ? new Xr(r, n) : e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${ce(r.type)} instead`) : null;
            }
            evaluate(t1) {
                const e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (null == r) return !1;
                if (!de(e1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Te(`Expected first argument to be of type boolean, string, number or null, but found ${ce(ke(e1))} instead.`);
                if (!de(r, [
                    "string",
                    "array"
                ])) throw new Te(`Expected second argument to be of type array or string, but found ${ce(ke(r))} instead.`);
                return r.indexOf(e1) >= 0;
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "in",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
            constructor(t1, e1){
                this.type = re, this.needle = t1, this.haystack = e1;
            }
        }
        var Kr = Xr;
        class Hr {
            static parse(t1, e1) {
                if (t1.length <= 2 || t1.length >= 5) return e1.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, se), n = e1.parse(t1[2], 2, se);
                if (!r || !n) return null;
                if (!fe(r.type, [
                    re,
                    ee,
                    te,
                    Qt,
                    se
                ])) return e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${ce(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e1.parse(t1[3], 3, te);
                    return i ? new Hr(r, n, i) : null;
                }
                return new Hr(r, n);
            }
            evaluate(t1) {
                const e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (!de(e1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Te(`Expected first argument to be of type boolean, string, number or null, but found ${ce(ke(e1))} instead.`);
                if (!de(r, [
                    "string",
                    "array"
                ])) throw new Te(`Expected second argument to be of type array or string, but found ${ce(ke(r))} instead.`);
                if (this.fromIndex) {
                    const n = this.fromIndex.evaluate(t1);
                    return r.indexOf(e1, n);
                }
                return r.indexOf(e1);
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.fromIndex && void 0 !== this.fromIndex) {
                    const t1 = this.fromIndex.serialize();
                    return [
                        "index-of",
                        this.needle.serialize(),
                        this.haystack.serialize(),
                        t1
                    ];
                }
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
            constructor(t1, e1, r){
                this.type = te, this.needle = t1, this.haystack = e1, this.fromIndex = r;
            }
        }
        var Yr = Hr;
        class Wr {
            static parse(t1, e1) {
                if (t1.length < 5) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 1) return e1.error("Expected an even number of arguments.");
                let r, n;
                e1.expectedType && "value" !== e1.expectedType.kind && (n = e1.expectedType);
                const i = {}, s = [];
                for(let a = 2; a < t1.length - 1; a += 2){
                    let o = t1[a];
                    const l = t1[a + 1];
                    Array.isArray(o) || (o = [
                        o
                    ]);
                    const u = e1.concat(a);
                    if (0 === o.length) return u.error("Expected at least one branch label.");
                    for (const t1 of o){
                        if ("number" != typeof t1 && "string" != typeof t1) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t1 && Math.abs(t1) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t1 && Math.floor(t1) !== t1) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, ke(t1))) return null;
                        } else r = ke(t1);
                        if (void 0 !== i[String(t1)]) return u.error("Branch labels must be unique.");
                        i[String(t1)] = s.length;
                    }
                    const c = e1.parse(l, a, n);
                    if (!c) return null;
                    n = n || c.type, s.push(c);
                }
                const a = e1.parse(t1[1], 1, se);
                if (!a) return null;
                const o = e1.parse(t1[t1.length - 1], t1.length - 1, n);
                return o ? "value" !== a.type.kind && e1.concat(1).checkSubtype(r, a.type) ? null : new Wr(r, n, a, i, s, o) : null;
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1);
                return (ke(e1) === this.inputType && this.outputs[this.cases[e1]] || this.otherwise).evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const t1 = [
                    "match",
                    this.input.serialize()
                ], e1 = Object.keys(this.cases).sort(), r = [], n = {};
                for (const t1 of e1){
                    const e1 = n[this.cases[t1]];
                    void 0 === e1 ? (n[this.cases[t1]] = r.length, r.push([
                        this.cases[t1],
                        [
                            t1
                        ]
                    ])) : r[e1][1].push(t1);
                }
                const i = (t1)=>"number" === this.inputType.kind ? Number(t1) : t1;
                for (const [e1, n] of r)t1.push(1 === n.length ? i(n[0]) : n.map(i)), t1.push(this.outputs[e1].serialize());
                return t1.push(this.otherwise.serialize()), t1;
            }
            constructor(t1, e1, r, n, i, s){
                this.inputType = t1, this.type = e1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = s;
            }
        }
        var Jr = Wr;
        class Qr {
            static parse(t1, e1) {
                if (t1.length < 4) return e1.error(`Expected at least 3 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 0) return e1.error("Expected an odd number of arguments.");
                let r;
                e1.expectedType && "value" !== e1.expectedType.kind && (r = e1.expectedType);
                const n = [];
                for(let i = 1; i < t1.length - 1; i += 2){
                    const s = e1.parse(t1[i], i, re);
                    if (!s) return null;
                    const a = e1.parse(t1[i + 1], i + 1, r);
                    if (!a) return null;
                    n.push([
                        s,
                        a
                    ]), r = r || a.type;
                }
                const i = e1.parse(t1[t1.length - 1], t1.length - 1, r);
                return i ? new Qr(r, n, i) : null;
            }
            evaluate(t1) {
                for (const [e1, r] of this.branches)if (e1.evaluate(t1)) return r.evaluate(t1);
                return this.otherwise.evaluate(t1);
            }
            eachChild(t1) {
                for (const [e1, r] of this.branches)t1(e1), t1(r);
                t1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t1, e1])=>e1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const t1 = [
                    "case"
                ];
                return this.eachChild((e1)=>{
                    t1.push(e1.serialize());
                }), t1;
            }
            constructor(t1, e1, r){
                this.type = t1, this.branches = e1, this.otherwise = r;
            }
        }
        var tn = Qr;
        class en {
            static parse(t1, e1) {
                if (t1.length <= 2 || t1.length >= 5) return e1.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, se), n = e1.parse(t1[2], 2, te);
                if (!r || !n) return null;
                if (!fe(r.type, [
                    ue(se),
                    ee,
                    se
                ])) return e1.error(`Expected first argument to be of type array or string, but found ${ce(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e1.parse(t1[3], 3, te);
                    return i ? new en(r.type, r, n, i) : null;
                }
                return new en(r.type, r, n);
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
                if (!de(e1, [
                    "string",
                    "array"
                ])) throw new Te(`Expected first argument to be of type array or string, but found ${ce(ke(e1))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(t1);
                    return e1.slice(r, n);
                }
                return e1.slice(r);
            }
            eachChild(t1) {
                t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.endIndex && void 0 !== this.endIndex) {
                    const t1 = this.endIndex.serialize();
                    return [
                        "slice",
                        this.input.serialize(),
                        this.beginIndex.serialize(),
                        t1
                    ];
                }
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize()
                ];
            }
            constructor(t1, e1, r, n){
                this.type = t1, this.input = e1, this.beginIndex = r, this.endIndex = n;
            }
        }
        var rn = en;
        function nn(t1, e1) {
            return "==" === t1 || "!=" === t1 ? "boolean" === e1.kind || "string" === e1.kind || "number" === e1.kind || "null" === e1.kind || "value" === e1.kind : "string" === e1.kind || "number" === e1.kind || "value" === e1.kind;
        }
        function sn(t1, e1, r, n) {
            return 0 === n.compare(e1, r);
        }
        function an(t1, e1, r) {
            const n = "==" !== t1 && "!=" !== t1;
            return class i {
                static parse(t1, e1) {
                    if (3 !== t1.length && 4 !== t1.length) return e1.error("Expected two or three arguments.");
                    const r = t1[0];
                    let s = e1.parse(t1[1], 1, se);
                    if (!s) return null;
                    if (!nn(r, s.type)) return e1.concat(1).error(`"${r}" comparisons are not supported for type '${ce(s.type)}'.`);
                    let a = e1.parse(t1[2], 2, se);
                    if (!a) return null;
                    if (!nn(r, a.type)) return e1.concat(2).error(`"${r}" comparisons are not supported for type '${ce(a.type)}'.`);
                    if (s.type.kind !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e1.error(`Cannot compare types '${ce(s.type)}' and '${ce(a.type)}'.`);
                    n && ("value" === s.type.kind && "value" !== a.type.kind ? s = new Ce(a.type, [
                        s
                    ]) : "value" !== s.type.kind && "value" === a.type.kind && (a = new Ce(s.type, [
                        a
                    ])));
                    let o = null;
                    if (4 === t1.length) {
                        if ("string" !== s.type.kind && "string" !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e1.error("Cannot use collator to compare non-string types.");
                        if (o = e1.parse(t1[3], 3, ae), !o) return null;
                    }
                    return new i(s, a, o);
                }
                evaluate(i) {
                    const s = this.lhs.evaluate(i), a = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const e1 = ke(s), r = ke(a);
                        if (e1.kind !== r.kind || "string" !== e1.kind && "number" !== e1.kind) throw new Te(`Expected arguments for "${t1}" to be (string, string) or (number, number), but found (${e1.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const t1 = ke(s), r = ke(a);
                        if ("string" !== t1.kind || "string" !== r.kind) return e1(i, s, a);
                    }
                    return this.collator ? r(i, s, a, this.collator.evaluate(i)) : e1(i, s, a);
                }
                eachChild(t1) {
                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                serialize() {
                    const e1 = [
                        t1
                    ];
                    return this.eachChild((t1)=>{
                        e1.push(t1.serialize());
                    }), e1;
                }
                constructor(t1, e1, r){
                    this.type = re, this.lhs = t1, this.rhs = e1, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e1.type.kind;
                }
            };
        }
        const on = an("==", function(t1, e1, r) {
            return e1 === r;
        }, sn), ln = an("!=", function(t1, e1, r) {
            return e1 !== r;
        }, function(t1, e1, r, n) {
            return !sn(0, e1, r, n);
        }), un = an("<", function(t1, e1, r) {
            return e1 < r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) < 0;
        }), cn = an(">", function(t1, e1, r) {
            return e1 > r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) > 0;
        }), hn = an("<=", function(t1, e1, r) {
            return e1 <= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) <= 0;
        }), pn = an(">=", function(t1, e1, r) {
            return e1 >= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) >= 0;
        });
        class fn {
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error("Expected two arguments.");
                const r = e1.parse(t1[1], 1, te);
                if (!r) return null;
                const n = t1[2];
                if ("object" != typeof n || Array.isArray(n)) return e1.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = e1.parse(n.locale, 1, ee), !i)) return null;
                let s = null;
                if (n.currency && (s = e1.parse(n.currency, 1, ee), !s)) return null;
                let a = null;
                if (n.unit && (a = e1.parse(n.unit, 1, ee), !a)) return null;
                let o = null;
                if (n["min-fraction-digits"] && (o = e1.parse(n["min-fraction-digits"], 1, te), !o)) return null;
                let l = null;
                return n["max-fraction-digits"] && (l = e1.parse(n["max-fraction-digits"], 1, te), !l) ? null : new fn(r, i, s, a, o, l);
            }
            evaluate(t1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                    style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                    currency: this.currency ? this.currency.evaluate(t1) : void 0,
                    unit: this.unit ? this.unit.evaluate(t1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
                }).format(this.number.evaluate(t1));
            }
            eachChild(t1) {
                t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.unit && t1(this.unit), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = {};
                return this.locale && (t1.locale = this.locale.serialize()), this.currency && (t1.currency = this.currency.serialize()), this.unit && (t1.unit = this.unit.serialize()), this.minFractionDigits && (t1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                    "number-format",
                    this.number.serialize(),
                    t1
                ];
            }
            constructor(t1, e1, r, n, i, s){
                this.type = ee, this.number = t1, this.locale = e1, this.currency = r, this.unit = n, this.minFractionDigits = i, this.maxFractionDigits = s;
            }
        }
        class dn {
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`Expected 1 argument, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e1.error(`Expected argument of type string or array, but found ${ce(r.type)} instead.`) : new dn(r) : null;
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1);
                if ("string" == typeof e1) return e1.length;
                if (Array.isArray(e1)) return e1.length;
                throw new Te(`Expected value to be of type string or array, but found ${ce(ke(e1))} instead.`);
            }
            eachChild(t1) {
                t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "length"
                ];
                return this.eachChild((e1)=>{
                    t1.push(e1.serialize());
                }), t1;
            }
            constructor(t1){
                this.type = te, this.input = t1;
            }
        }
        const yn = {
            "==": on,
            "!=": ln,
            ">": cn,
            "<": un,
            ">=": pn,
            "<=": hn,
            array: Ce,
            at: Zr,
            boolean: Ce,
            case: tn,
            coalesce: Or,
            collator: Oe,
            format: Pe,
            image: De,
            in: Kr,
            "index-of": Yr,
            interpolate: jr,
            "interpolate-hcl": jr,
            "interpolate-lab": jr,
            length: dn,
            let: Nr,
            literal: ze,
            match: Jr,
            number: Ce,
            "number-format": fn,
            object: Ce,
            slice: rn,
            step: gr,
            string: Ce,
            "to-boolean": Le,
            "to-color": Le,
            "to-number": Le,
            "to-string": Le,
            var: hr,
            within: ar
        };
        function mn(t1, [e1, r, n, i]) {
            e1 = e1.evaluate(t1), r = r.evaluate(t1), n = n.evaluate(t1);
            const s = i ? i.evaluate(t1) : 1, a = Ae(e1, r, n, s);
            if (a) throw new Te(a);
            return new xe(e1 / 255 * s, r / 255 * s, n / 255 * s, s);
        }
        function gn(t1, e1) {
            return t1 in e1;
        }
        function xn(t1, e1) {
            const r = e1[t1];
            return void 0 === r ? null : r;
        }
        function vn(t1) {
            return {
                type: t1
            };
        }
        $e.register(yn, {
            error: [
                {
                    kind: "error"
                },
                [
                    ee
                ],
                (t1, [e1])=>{
                    throw new Te(e1.evaluate(t1));
                }
            ],
            typeof: [
                ee,
                [
                    se
                ],
                (t1, [e1])=>ce(ke(e1.evaluate(t1)))
            ],
            "to-rgba": [
                ue(te, 4),
                [
                    ne
                ],
                (t1, [e1])=>e1.evaluate(t1).toArray()
            ],
            rgb: [
                ne,
                [
                    te,
                    te,
                    te
                ],
                mn
            ],
            rgba: [
                ne,
                [
                    te,
                    te,
                    te,
                    te
                ],
                mn
            ],
            has: {
                type: re,
                overloads: [
                    [
                        [
                            ee
                        ],
                        (t1, [e1])=>gn(e1.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            ee,
                            ie
                        ],
                        (t1, [e1, r])=>gn(e1.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            get: {
                type: se,
                overloads: [
                    [
                        [
                            ee
                        ],
                        (t1, [e1])=>xn(e1.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            ee,
                            ie
                        ],
                        (t1, [e1, r])=>xn(e1.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            "feature-state": [
                se,
                [
                    ee
                ],
                (t1, [e1])=>xn(e1.evaluate(t1), t1.featureState || {})
            ],
            properties: [
                ie,
                [],
                (t1)=>t1.properties()
            ],
            "geometry-type": [
                ee,
                [],
                (t1)=>t1.geometryType()
            ],
            id: [
                se,
                [],
                (t1)=>t1.id()
            ],
            zoom: [
                te,
                [],
                (t1)=>t1.globals.zoom
            ],
            pitch: [
                te,
                [],
                (t1)=>t1.globals.pitch || 0
            ],
            "distance-from-center": [
                te,
                [],
                (t1)=>t1.distanceFromCenter()
            ],
            "heatmap-density": [
                te,
                [],
                (t1)=>t1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                te,
                [],
                (t1)=>t1.globals.lineProgress || 0
            ],
            "sky-radial-progress": [
                te,
                [],
                (t1)=>t1.globals.skyRadialProgress || 0
            ],
            accumulated: [
                se,
                [],
                (t1)=>void 0 === t1.globals.accumulated ? null : t1.globals.accumulated
            ],
            "+": [
                te,
                vn(te),
                (t1, e1)=>{
                    let r = 0;
                    for (const n of e1)r += n.evaluate(t1);
                    return r;
                }
            ],
            "*": [
                te,
                vn(te),
                (t1, e1)=>{
                    let r = 1;
                    for (const n of e1)r *= n.evaluate(t1);
                    return r;
                }
            ],
            "-": {
                type: te,
                overloads: [
                    [
                        [
                            te,
                            te
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) - r.evaluate(t1)
                    ],
                    [
                        [
                            te
                        ],
                        (t1, [e1])=>-e1.evaluate(t1)
                    ]
                ]
            },
            "/": [
                te,
                [
                    te,
                    te
                ],
                (t1, [e1, r])=>e1.evaluate(t1) / r.evaluate(t1)
            ],
            "%": [
                te,
                [
                    te,
                    te
                ],
                (t1, [e1, r])=>e1.evaluate(t1) % r.evaluate(t1)
            ],
            ln2: [
                te,
                [],
                ()=>Math.LN2
            ],
            pi: [
                te,
                [],
                ()=>Math.PI
            ],
            e: [
                te,
                [],
                ()=>Math.E
            ],
            "^": [
                te,
                [
                    te,
                    te
                ],
                (t1, [e1, r])=>Math.pow(e1.evaluate(t1), r.evaluate(t1))
            ],
            sqrt: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.sqrt(e1.evaluate(t1))
            ],
            log10: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1)) / Math.LN10
            ],
            ln: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1))
            ],
            log2: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1)) / Math.LN2
            ],
            sin: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.sin(e1.evaluate(t1))
            ],
            cos: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.cos(e1.evaluate(t1))
            ],
            tan: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.tan(e1.evaluate(t1))
            ],
            asin: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.asin(e1.evaluate(t1))
            ],
            acos: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.acos(e1.evaluate(t1))
            ],
            atan: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.atan(e1.evaluate(t1))
            ],
            min: [
                te,
                vn(te),
                (t1, e1)=>Math.min(...e1.map((e1)=>e1.evaluate(t1)))
            ],
            max: [
                te,
                vn(te),
                (t1, e1)=>Math.max(...e1.map((e1)=>e1.evaluate(t1)))
            ],
            abs: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.abs(e1.evaluate(t1))
            ],
            round: [
                te,
                [
                    te
                ],
                (t1, [e1])=>{
                    const r = e1.evaluate(t1);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.floor(e1.evaluate(t1))
            ],
            ceil: [
                te,
                [
                    te
                ],
                (t1, [e1])=>Math.ceil(e1.evaluate(t1))
            ],
            "filter-==": [
                re,
                [
                    ee,
                    se
                ],
                (t1, [e1, r])=>t1.properties()[e1.value] === r.value
            ],
            "filter-id-==": [
                re,
                [
                    se
                ],
                (t1, [e1])=>t1.id() === e1.value
            ],
            "filter-type-==": [
                re,
                [
                    ee
                ],
                (t1, [e1])=>t1.geometryType() === e1.value
            ],
            "filter-<": [
                re,
                [
                    ee,
                    se
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                re,
                [
                    se
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                re,
                [
                    ee,
                    se
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                re,
                [
                    se
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                re,
                [
                    ee,
                    se
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                re,
                [
                    se
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                re,
                [
                    ee,
                    se
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                re,
                [
                    se
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                re,
                [
                    se
                ],
                (t1, [e1])=>e1.value in t1.properties()
            ],
            "filter-has-id": [
                re,
                [],
                (t1)=>null !== t1.id() && void 0 !== t1.id()
            ],
            "filter-type-in": [
                re,
                [
                    ue(ee)
                ],
                (t1, [e1])=>e1.value.indexOf(t1.geometryType()) >= 0
            ],
            "filter-id-in": [
                re,
                [
                    ue(se)
                ],
                (t1, [e1])=>e1.value.indexOf(t1.id()) >= 0
            ],
            "filter-in-small": [
                re,
                [
                    ee,
                    ue(se)
                ],
                (t1, [e1, r])=>r.value.indexOf(t1.properties()[e1.value]) >= 0
            ],
            "filter-in-large": [
                re,
                [
                    ee,
                    ue(se)
                ],
                (t1, [e1, r])=>(function(t1, e1, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (e1[i] === t1) return !0;
                            e1[i] > t1 ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(t1.properties()[e1.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: re,
                overloads: [
                    [
                        [
                            re,
                            re
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) && r.evaluate(t1)
                    ],
                    [
                        vn(re),
                        (t1, e1)=>{
                            for (const r of e1)if (!r.evaluate(t1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: re,
                overloads: [
                    [
                        [
                            re,
                            re
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) || r.evaluate(t1)
                    ],
                    [
                        vn(re),
                        (t1, e1)=>{
                            for (const r of e1)if (r.evaluate(t1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                re,
                [
                    re
                ],
                (t1, [e1])=>!e1.evaluate(t1)
            ],
            "is-supported-script": [
                re,
                [
                    ee
                ],
                (t1, [e1])=>{
                    const r = t1.globals && t1.globals.isSupportedScript;
                    return !r || r(e1.evaluate(t1));
                }
            ],
            upcase: [
                ee,
                [
                    ee
                ],
                (t1, [e1])=>e1.evaluate(t1).toUpperCase()
            ],
            downcase: [
                ee,
                [
                    ee
                ],
                (t1, [e1])=>e1.evaluate(t1).toLowerCase()
            ],
            concat: [
                ee,
                vn(se),
                (t1, e1)=>e1.map((e1)=>Ie(e1.evaluate(t1))).join("")
            ],
            "resolved-locale": [
                ee,
                [
                    ae
                ],
                (t1, [e1])=>e1.evaluate(t1).resolvedLocale()
            ]
        });
        var bn = yn;
        function _n(t1) {
            return {
                result: "success",
                value: t1
            };
        }
        function wn(t1) {
            return {
                result: "error",
                value: t1
            };
        }
        function An(t1) {
            return "data-driven" === t1["property-type"] || "cross-faded-data-driven" === t1["property-type"];
        }
        function Sn(t1) {
            return !!t1.expression && t1.expression.parameters.indexOf("zoom") > -1;
        }
        function kn(t1) {
            return !!t1.expression && t1.expression.interpolated;
        }
        function In(t1) {
            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
        }
        function Mn(t1) {
            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
        }
        function zn(t1) {
            return t1;
        }
        function Tn(t1, e1) {
            const r = "color" === e1.type, n = t1.stops && "object" == typeof t1.stops[0][0], i = n || !(n || void 0 !== t1.property), s = t1.type || (kn(e1) ? "exponential" : "interval");
            if (r && ((t1 = Zt({}, t1)).stops && (t1.stops = t1.stops.map((t1)=>[
                    t1[0],
                    xe.parse(t1[1])
                ])), t1.default = xe.parse(t1.default ? t1.default : e1.default)), t1.colorSpace && "rgb" !== t1.colorSpace && !Lr[t1.colorSpace]) throw new Error(`Unknown color space: ${t1.colorSpace}`);
            let a, o, l;
            if ("exponential" === s) a = Pn;
            else if ("interval" === s) a = Cn;
            else if ("categorical" === s) {
                a = En, o = Object.create(null);
                for (const e1 of t1.stops)o[e1[0]] = e1[1];
                l = typeof t1.stops[0][0];
            } else {
                if ("identity" !== s) throw new Error(`Unknown function type "${s}"`);
                a = Dn;
            }
            if (n) {
                const r = {}, n = [];
                for(let e1 = 0; e1 < t1.stops.length; e1++){
                    const i = t1.stops[e1], s = i[0].zoom;
                    void 0 === r[s] && (r[s] = {
                        zoom: s,
                        type: t1.type,
                        property: t1.property,
                        default: t1.default,
                        stops: []
                    }, n.push(s)), r[s].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t1 of n)i.push([
                    r[t1].zoom,
                    Tn(r[t1], e1)
                ]);
                const s = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: s,
                    interpolationFactor: jr.interpolationFactor.bind(void 0, s),
                    zoomStops: i.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r }, n)=>Pn({
                            stops: i,
                            base: t1.base
                        }, e1, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === s ? {
                    name: "exponential",
                    base: void 0 !== t1.base ? t1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: jr.interpolationFactor.bind(void 0, r),
                    zoomStops: t1.stops.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r })=>a(t1, e1, r, o, l)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[t1.property] : void 0;
                    return void 0 === i ? Bn(t1.default, e1.default) : a(t1, e1, i, o, l);
                }
            };
        }
        function Bn(t1, e1, r) {
            return void 0 !== t1 ? t1 : void 0 !== e1 ? e1 : void 0 !== r ? r : void 0;
        }
        function En(t1, e1, r, n, i) {
            return Bn(typeof r === i ? n[r] : void 0, t1.default, e1.default);
        }
        function Cn(t1, e1, r) {
            if ("number" !== In(r)) return Bn(t1.default, e1.default);
            const n = t1.stops.length;
            if (1 === n) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
            const i = yr(t1.stops.map((t1)=>t1[0]), r);
            return t1.stops[i][1];
        }
        function Pn(t1, e1, r) {
            const n = void 0 !== t1.base ? t1.base : 1;
            if ("number" !== In(r)) return Bn(t1.default, e1.default);
            const i = t1.stops.length;
            if (1 === i) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
            const s = yr(t1.stops.map((t1)=>t1[0]), r), a = function(t1, e1, r, n) {
                const i = n - r, s = t1 - r;
                return 0 === i ? 0 : 1 === e1 ? s / i : (Math.pow(e1, s) - 1) / (Math.pow(e1, i) - 1);
            }(r, n, t1.stops[s][0], t1.stops[s + 1][0]), o = t1.stops[s][1], l = t1.stops[s + 1][1];
            let u = br[e1.type] || zn;
            if (t1.colorSpace && "rgb" !== t1.colorSpace) {
                const e1 = Lr[t1.colorSpace];
                u = (t1, r)=>e1.reverse(e1.interpolate(e1.forward(t1), e1.forward(r), a));
            }
            return "function" == typeof o.evaluate ? {
                evaluate (...t1) {
                    const e1 = o.evaluate.apply(void 0, t1), r = l.evaluate.apply(void 0, t1);
                    if (void 0 !== e1 && void 0 !== r) return u(e1, r, a);
                }
            } : u(o, l, a);
        }
        function Dn(t1, e1, r) {
            return "color" === e1.type ? r = xe.parse(r) : "formatted" === e1.type ? r = _e.fromString(r.toString()) : "resolvedImage" === e1.type ? r = we.fromString(r.toString()) : In(r) === e1.type || "enum" === e1.type && e1.values[r] || (r = void 0), Bn(r, t1.default, e1.default);
        }
        class Vn {
            evaluateWithoutErrorHandling(t1, e1, r, n, i, s, a, o) {
                return this._evaluator.globals = t1, this._evaluator.feature = e1, this._evaluator.featureState = r, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = o || null, this.expression.evaluate(this._evaluator);
            }
            evaluate(t1, e1, r, n, i, s, a, o) {
                this._evaluator.globals = t1, this._evaluator.feature = e1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = o || null;
                try {
                    const t1 = this.expression.evaluate(this._evaluator);
                    if (null == t1 || "number" == typeof t1 && t1 != t1) return this._defaultValue;
                    if (this._enumValues && !(t1 in this._enumValues)) throw new Te(`Expected value to be one of ${Object.keys(this._enumValues).map((t1)=>JSON.stringify(t1)).join(", ")}, but found ${JSON.stringify(t1)} instead.`);
                    return t1;
                } catch (t1) {
                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(t1.message)), this._defaultValue;
                }
            }
            constructor(t1, e1){
                this.expression = t1, this._warningHistory = {}, this._evaluator = new Ue, this._defaultValue = e1 ? function(t1) {
                    return "color" === t1.type && (Mn(t1.default) || Array.isArray(t1.default)) ? new xe(0, 0, 0, 0) : "color" === t1.type ? xe.parse(t1.default) || null : void 0 === t1.default ? null : t1.default;
                }(e1) : null, this._enumValues = e1 && "enum" === e1.type ? e1.values : null;
            }
        }
        function Fn(t1) {
            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in bn;
        }
        function Ln(t1, e1) {
            const r = new fr(bn, [], e1 ? function(t1) {
                const e1 = {
                    color: ne,
                    string: ee,
                    number: te,
                    enum: ee,
                    boolean: re,
                    formatted: oe,
                    resolvedImage: le
                };
                return "array" === t1.type ? ue(e1[t1.value] || se, t1.length) : e1[t1.type];
            }(e1) : void 0), n = r.parse(t1, void 0, void 0, void 0, e1 && "string" === e1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? _n(new Vn(n, e1)) : wn(r.errors);
        }
        class Rn {
            evaluateWithoutErrorHandling(t1, e1, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, s);
            }
            evaluate(t1, e1, r, n, i, s) {
                return this._styleExpression.evaluate(t1, e1, r, n, i, s);
            }
            constructor(t1, e1){
                this.kind = t1, this._styleExpression = e1, this.isStateDependent = "constant" !== t1 && !lr(e1.expression);
            }
        }
        class Un {
            evaluateWithoutErrorHandling(t1, e1, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, s);
            }
            evaluate(t1, e1, r, n, i, s) {
                return this._styleExpression.evaluate(t1, e1, r, n, i, s);
            }
            interpolationFactor(t1, e1, r) {
                return this.interpolationType ? jr.interpolationFactor(this.interpolationType, t1, e1, r) : 0;
            }
            constructor(t1, e1, r, n){
                this.kind = t1, this.zoomStops = r, this._styleExpression = e1, this.isStateDependent = "camera" !== t1 && !lr(e1.expression), this.interpolationType = n;
            }
        }
        function jn(t1, e1) {
            if ("error" === (t1 = Ln(t1, e1)).result) return t1;
            const r = t1.value.expression, n = or(r);
            if (!n && !An(e1)) return wn([
                new Yt("", "data expressions not supported")
            ]);
            const i = ur(r, [
                "zoom",
                "pitch",
                "distance-from-center"
            ]);
            if (!i && !Sn(e1)) return wn([
                new Yt("", "zoom expressions not supported")
            ]);
            const s = On(r);
            return s || i ? s instanceof Yt ? wn([
                s
            ]) : s instanceof jr && !kn(e1) ? wn([
                new Yt("", '"interpolate" expressions cannot be used with this property')
            ]) : _n(s ? new Un(n ? "camera" : "composite", t1.value, s.labels, s instanceof jr ? s.interpolation : void 0) : new Rn(n ? "constant" : "source", t1.value)) : wn([
                new Yt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        class $n {
            static deserialize(t1) {
                return new $n(t1._parameters, t1._specification);
            }
            static serialize(t1) {
                return {
                    _parameters: t1._parameters,
                    _specification: t1._specification
                };
            }
            constructor(t1, e1){
                this._parameters = t1, this._specification = e1, Zt(this, Tn(this._parameters, this._specification));
            }
        }
        function On(t1) {
            let e1 = null;
            if (t1 instanceof Nr) e1 = On(t1.result);
            else if (t1 instanceof Or) {
                for (const r of t1.args)if (e1 = On(r), e1) break;
            } else (t1 instanceof gr || t1 instanceof jr) && t1.input instanceof $e && "zoom" === t1.input.name && (e1 = t1);
            return e1 instanceof Yt || t1.eachChild((t1)=>{
                const r = On(t1);
                r instanceof Yt ? e1 = r : !e1 && r ? e1 = new Yt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e1 && r && e1 !== r && (e1 = new Yt("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e1;
        }
        class qn {
            constructor(t1, e1, r, n){
                this.message = (t1 ? `${t1}: ` : "") + r, n && (this.identifier = n), null != e1 && e1.__line__ && (this.line = e1.__line__);
            }
        }
        function Nn(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec || {}, i = t1.objectElementValidators || {}, s = t1.style, a = t1.styleSpec;
            let o = [];
            const l = In(r);
            if ("object" !== l) return [
                new qn(e1, r, `object expected, ${l} found`)
            ];
            for(const t1 in r){
                const l = t1.split(".")[0], u = n[l] || n["*"];
                let c;
                i[l] ? c = i[l] : n[l] ? c = Ai : i["*"] ? c = i["*"] : n["*"] && (c = Ai), c ? o = o.concat(c({
                    key: (e1 ? `${e1}.` : e1) + t1,
                    value: r[t1],
                    valueSpec: u,
                    style: s,
                    styleSpec: a,
                    object: r,
                    objectKey: t1
                }, r)) : o.push(new qn(e1, r[t1], `unknown property "${t1}"`));
            }
            for(const t1 in n)i[t1] || n[t1].required && void 0 === n[t1].default && void 0 === r[t1] && o.push(new qn(e1, r, `missing required property "${t1}"`));
            return o;
        }
        function Gn(t1) {
            const e1 = t1.value, r = t1.valueSpec, n = t1.style, i = t1.styleSpec, s = t1.key, a = t1.arrayElementValidator || Ai;
            if ("array" !== In(e1)) return [
                new qn(s, e1, `array expected, ${In(e1)} found`)
            ];
            if (r.length && e1.length !== r.length) return [
                new qn(s, e1, `array length ${r.length} expected, length ${e1.length} found`)
            ];
            if (r["min-length"] && e1.length < r["min-length"]) return [
                new qn(s, e1, `array length at least ${r["min-length"]} expected, length ${e1.length} found`)
            ];
            let o = {
                type: r.value,
                values: r.values,
                minimum: r.minimum,
                maximum: r.maximum,
                function: void 0
            };
            i.$version < 7 && (o.function = r.function), "object" === In(r.value) && (o = r.value);
            let l = [];
            for(let t1 = 0; t1 < e1.length; t1++)l = l.concat(a({
                array: e1,
                arrayIndex: t1,
                value: e1[t1],
                valueSpec: o,
                style: n,
                styleSpec: i,
                key: `${s}[${t1}]`
            }));
            return l;
        }
        function Zn(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec;
            let i = In(r);
            if ("number" === i && r != r && (i = "NaN"), "number" !== i) return [
                new qn(e1, r, `number expected, ${i} found`)
            ];
            if ("minimum" in n) {
                let i = n.minimum;
                if ("array" === In(n.minimum) && (i = n.minimum[t1.arrayIndex]), r < i) return [
                    new qn(e1, r, `${r} is less than the minimum value ${i}`)
                ];
            }
            if ("maximum" in n) {
                let i = n.maximum;
                if ("array" === In(n.maximum) && (i = n.maximum[t1.arrayIndex]), r > i) return [
                    new qn(e1, r, `${r} is greater than the maximum value ${i}`)
                ];
            }
            return [];
        }
        function Xn(t1) {
            const e1 = t1.valueSpec, r = Xt(t1.value.type);
            let n, i, s, a = {};
            const o = "categorical" !== r && void 0 === t1.value.property, l = !o, u = "array" === In(t1.value.stops) && "array" === In(t1.value.stops[0]) && "object" === In(t1.value.stops[0][0]), c = Nn({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(t1) {
                        if ("identity" === r) return [
                            new qn(t1.key, t1.value, 'identity function may not have a "stops" property')
                        ];
                        let e1 = [];
                        const n = t1.value;
                        return e1 = e1.concat(Gn({
                            key: t1.key,
                            value: n,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: h
                        })), "array" === In(n) && 0 === n.length && e1.push(new qn(t1.key, n, "array must have at least one stop")), e1;
                    },
                    default: function(t1) {
                        return Ai({
                            key: t1.key,
                            value: t1.value,
                            valueSpec: e1,
                            style: t1.style,
                            styleSpec: t1.styleSpec
                        });
                    }
                }
            });
            return "identity" === r && o && c.push(new qn(t1.key, t1.value, 'missing required property "property"')), "identity" === r || t1.value.stops || c.push(new qn(t1.key, t1.value, 'missing required property "stops"')), "exponential" === r && t1.valueSpec.expression && !kn(t1.valueSpec) && c.push(new qn(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (l && !An(t1.valueSpec) ? c.push(new qn(t1.key, t1.value, "property functions not supported")) : o && !Sn(t1.valueSpec) && c.push(new qn(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== r && !u || void 0 !== t1.value.property || c.push(new qn(t1.key, t1.value, '"property" property is required')), c;
            function h(t1) {
                let r = [];
                const n = t1.value, o = t1.key;
                if ("array" !== In(n)) return [
                    new qn(o, n, `array expected, ${In(n)} found`)
                ];
                if (2 !== n.length) return [
                    new qn(o, n, `array length 2 expected, length ${n.length} found`)
                ];
                if (u) {
                    if ("object" !== In(n[0])) return [
                        new qn(o, n, `object expected, ${In(n[0])} found`)
                    ];
                    if (void 0 === n[0].zoom) return [
                        new qn(o, n, "object stop key must have zoom")
                    ];
                    if (void 0 === n[0].value) return [
                        new qn(o, n, "object stop key must have value")
                    ];
                    const e1 = Xt(n[0].zoom);
                    if ("number" != typeof e1) return [
                        new qn(o, n[0].zoom, "stop zoom values must be numbers")
                    ];
                    if (s && s > e1) return [
                        new qn(o, n[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    e1 !== s && (s = e1, i = void 0, a = {}), r = r.concat(Nn({
                        key: `${o}[0]`,
                        value: n[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: Zn,
                            value: p
                        }
                    }));
                } else r = r.concat(p({
                    key: `${o}[0]`,
                    value: n[0],
                    valueSpec: {},
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, n));
                return Fn(Kt(n[1])) ? r.concat([
                    new qn(`${o}[1]`, n[1], "expressions are not allowed in function stops.")
                ]) : r.concat(Ai({
                    key: `${o}[1]`,
                    value: n[1],
                    valueSpec: e1,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function p(t1, s) {
                const o = In(t1.value), l = Xt(t1.value), u = null !== t1.value ? t1.value : s;
                if (n) {
                    if (o !== n) return [
                        new qn(t1.key, u, `${o} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = o;
                if ("number" !== o && "string" !== o && "boolean" !== o && "number" != typeof l && "string" != typeof l && "boolean" != typeof l) return [
                    new qn(t1.key, u, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== o && "categorical" !== r) {
                    let n = `number expected, ${o} found`;
                    return An(e1) && void 0 === r && (n += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new qn(t1.key, u, n)
                    ];
                }
                return "categorical" !== r || "number" !== o || "number" == typeof l && isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === o && "number" == typeof l && "number" == typeof i && void 0 !== i && l < i ? [
                    new qn(t1.key, u, "stop domain values must appear in ascending order")
                ] : (i = l, "categorical" === r && l in a ? [
                    new qn(t1.key, u, "stop domain values must be unique")
                ] : (a[l] = !0, [])) : [
                    new qn(t1.key, u, `integer expected, found ${String(l)}`)
                ];
            }
        }
        function Kn(t1) {
            const e1 = ("property" === t1.expressionContext ? jn : Ln)(Kt(t1.value), t1.valueSpec);
            if ("error" === e1.result) return e1.value.map((e1)=>new qn(`${t1.key}${e1.key}`, t1.value, e1.message));
            const r = e1.value.expression || e1.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !r.outputDefined()) return [
                new qn(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !lr(r)) return [
                new qn(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext) return Hn(r, t1);
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!ur(r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new qn(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !or(r)) return [
                    new qn(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function Hn(t1, e1) {
            const r = new Set([
                "zoom",
                "feature-state",
                "pitch",
                "distance-from-center"
            ]);
            if (e1.valueSpec && e1.valueSpec.expression) for (const t1 of e1.valueSpec.expression.parameters)r.delete(t1);
            if (0 === r.size) return [];
            const n = [];
            return t1 instanceof $e && r.has(t1.name) ? [
                new qn(e1.key, e1.value, `["${t1.name}"] expression is not supported in a filter for a ${e1.object.type} layer with id: ${e1.object.id}`)
            ] : (t1.eachChild((t1)=>{
                n.push(...Hn(t1, e1));
            }), n);
        }
        function Yn(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec, i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(Xt(r)) && i.push(new qn(e1, r, `expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)) : -1 === Object.keys(n.values).indexOf(Xt(r)) && i.push(new qn(e1, r, `expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)), i;
        }
        function Wn(t1) {
            if (!0 === t1 || !1 === t1) return !0;
            if (!Array.isArray(t1) || 0 === t1.length) return !1;
            switch(t1[0]){
                case "has":
                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                case "in":
                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                case "any":
                case "all":
                    for (const e1 of t1.slice(1))if (!Wn(e1) && "boolean" != typeof e1) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        function Jn(t1, e1 = "fill") {
            if (null == t1) return {
                filter: ()=>!0,
                needGeometry: !1,
                needFeature: !1
            };
            Wn(t1) || (t1 = si(t1));
            const r = t1;
            let n = !0;
            try {
                n = function(t1) {
                    if (!ei(t1)) return t1;
                    let e1 = Kt(t1);
                    return ti(e1), e1 = Qn(e1), e1;
                }(r);
            } catch (t1) {
                console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(r, null, 2)}\n        `);
            }
            const i = Gt[`filter_${e1}`], s = Ln(n, i);
            let a = null;
            if ("error" === s.result) throw new Error(s.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
            a = (t1, e1, r)=>s.value.evaluate(t1, e1, {}, r);
            let o = null, l = null;
            if (n !== r) {
                const t1 = Ln(r, i);
                if ("error" === t1.result) throw new Error(t1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                o = (e1, r, n, i, s)=>t1.value.evaluate(e1, r, {}, n, void 0, void 0, i, s), l = !or(t1.value.expression);
            }
            return a, {
                filter: a,
                dynamicFilter: o || void 0,
                needGeometry: ii(n),
                needFeature: !!l
            };
        }
        function Qn(t1) {
            if (!Array.isArray(t1)) return t1;
            const e1 = function(t1) {
                if (ri.has(t1[0])) {
                    for(let e1 = 1; e1 < t1.length; e1++)if (ei(t1[e1])) return !0;
                }
                return t1;
            }(t1);
            return !0 === e1 ? e1 : e1.map((t1)=>Qn(t1));
        }
        function ti(t1) {
            let e1 = !1;
            const r = [];
            if ("case" === t1[0]) {
                for(let n = 1; n < t1.length - 1; n += 2)e1 = e1 || ei(t1[n]), r.push(t1[n + 1]);
                r.push(t1[t1.length - 1]);
            } else if ("match" === t1[0]) {
                e1 = e1 || ei(t1[1]);
                for(let e1 = 2; e1 < t1.length - 1; e1 += 2)r.push(t1[e1 + 1]);
                r.push(t1[t1.length - 1]);
            } else if ("step" === t1[0]) {
                e1 = e1 || ei(t1[1]);
                for(let e1 = 1; e1 < t1.length - 1; e1 += 2)r.push(t1[e1 + 1]);
            }
            e1 && (t1.length = 0, t1.push("any", ...r));
            for(let e1 = 1; e1 < t1.length; e1++)ti(t1[e1]);
        }
        function ei(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("pitch" === (e1 = t1[0]) || "distance-from-center" === e1) return !0;
            var e1;
            for(let e1 = 1; e1 < t1.length; e1++)if (ei(t1[e1])) return !0;
            return !1;
        }
        const ri = new Set([
            "in",
            "==",
            "!=",
            ">",
            ">=",
            "<",
            "<=",
            "to-boolean"
        ]);
        function ni(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function ii(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("within" === t1[0]) return !0;
            for(let e1 = 1; e1 < t1.length; e1++)if (ii(t1[e1])) return !0;
            return !1;
        }
        function si(t1) {
            if (!t1) return !0;
            const e1 = t1[0];
            var r;
            return t1.length <= 1 ? "any" !== e1 : "==" === e1 ? ai(t1[1], t1[2], "==") : "!=" === e1 ? ui(ai(t1[1], t1[2], "==")) : "<" === e1 || ">" === e1 || "<=" === e1 || ">=" === e1 ? ai(t1[1], t1[2], e1) : "any" === e1 ? (r = t1.slice(1), [
                "any"
            ].concat(r.map(si))) : "all" === e1 ? [
                "all"
            ].concat(t1.slice(1).map(si)) : "none" === e1 ? [
                "all"
            ].concat(t1.slice(1).map(si).map(ui)) : "in" === e1 ? oi(t1[1], t1.slice(2)) : "!in" === e1 ? ui(oi(t1[1], t1.slice(2))) : "has" === e1 ? li(t1[1]) : "!has" === e1 ? ui(li(t1[1])) : "within" !== e1 || t1;
        }
        function ai(t1, e1, r) {
            switch(t1){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        e1
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        e1
                    ];
                default:
                    return [
                        `filter-${r}`,
                        t1,
                        e1
                    ];
            }
        }
        function oi(t1, e1) {
            if (0 === e1.length) return !1;
            switch(t1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                default:
                    return e1.length > 200 && !e1.some((t1)=>typeof t1 != typeof e1[0]) ? [
                        "filter-in-large",
                        t1,
                        [
                            "literal",
                            e1.sort(ni)
                        ]
                    ] : [
                        "filter-in-small",
                        t1,
                        [
                            "literal",
                            e1
                        ]
                    ];
            }
        }
        function li(t1) {
            switch(t1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t1
                    ];
            }
        }
        function ui(t1) {
            return [
                "!",
                t1
            ];
        }
        function ci(t1) {
            return Wn(Kt(t1.value)) ? Kn(Zt({}, t1, {
                expressionContext: "filter",
                valueSpec: t1.styleSpec[`filter_${t1.layerType || "fill"}`]
            })) : hi(t1);
        }
        function hi(t1) {
            const e1 = t1.value, r = t1.key;
            if ("array" !== In(e1)) return [
                new qn(r, e1, `array expected, ${In(e1)} found`)
            ];
            const n = t1.styleSpec;
            let i, s = [];
            if (e1.length < 1) return [
                new qn(r, e1, "filter array must have at least 1 element")
            ];
            switch(s = s.concat(Yn({
                key: `${r}[0]`,
                value: e1[0],
                valueSpec: n.filter_operator,
                style: t1.style,
                styleSpec: t1.styleSpec
            })), Xt(e1[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    e1.length >= 2 && "$type" === Xt(e1[1]) && s.push(new qn(r, e1, `"$type" cannot be use with operator "${e1[0]}"`));
                case "==":
                case "!=":
                    3 !== e1.length && s.push(new qn(r, e1, `filter array for operator "${e1[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    e1.length >= 2 && (i = In(e1[1]), "string" !== i && s.push(new qn(`${r}[1]`, e1[1], `string expected, ${i} found`)));
                    for(let a = 2; a < e1.length; a++)i = In(e1[a]), "$type" === Xt(e1[1]) ? s = s.concat(Yn({
                        key: `${r}[${a}]`,
                        value: e1[a],
                        valueSpec: n.geometry_type,
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && s.push(new qn(`${r}[${a}]`, e1[a], `string, number, or boolean expected, ${i} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let n = 1; n < e1.length; n++)s = s.concat(hi({
                        key: `${r}[${n}]`,
                        value: e1[n],
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    i = In(e1[1]), 2 !== e1.length ? s.push(new qn(r, e1, `filter array for "${e1[0]}" operator must have 2 elements`)) : "string" !== i && s.push(new qn(`${r}[1]`, e1[1], `string expected, ${i} found`));
                    break;
                case "within":
                    i = In(e1[1]), 2 !== e1.length ? s.push(new qn(r, e1, `filter array for "${e1[0]}" operator must have 2 elements`)) : "object" !== i && s.push(new qn(`${r}[1]`, e1[1], `object expected, ${i} found`));
            }
            return s;
        }
        function pi(t1, e1) {
            const r = t1.key, n = t1.style, i = t1.styleSpec, s = t1.value, a = t1.objectKey, o = i[`${e1}_${t1.layerType}`];
            if (!o) return [];
            const l = a.match(/^(.*)-transition$/);
            if ("paint" === e1 && l && o[l[1]] && o[l[1]].transition) return Ai({
                key: r,
                value: s,
                valueSpec: i.transition,
                style: n,
                styleSpec: i
            });
            const u = t1.valueSpec || o[a];
            if (!u) return [
                new qn(r, s, `unknown property "${a}"`)
            ];
            let c;
            if ("string" === In(s) && An(u) && !u.tokens && (c = /^{([^}]+)}$/.exec(s))) return [
                new qn(r, s, `"${a}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(c[1])} }\`.`)
            ];
            const h = [];
            return "symbol" === t1.layerType && ("text-field" === a && n && !n.glyphs && h.push(new qn(r, s, 'use of "text-field" requires a style "glyphs" property')), "text-font" === a && Mn(Kt(s)) && "identity" === Xt(s.type) && h.push(new qn(r, s, '"text-font" does not support identity functions'))), h.concat(Ai({
                key: t1.key,
                value: s,
                valueSpec: u,
                style: n,
                styleSpec: i,
                expressionContext: "property",
                propertyType: e1,
                propertyKey: a
            }));
        }
        function fi(t1) {
            return pi(t1, "paint");
        }
        function di(t1) {
            return pi(t1, "layout");
        }
        function yi(t1) {
            let e1 = [];
            const r = t1.value, n = t1.key, i = t1.style, s = t1.styleSpec;
            r.type || r.ref || e1.push(new qn(n, r, 'either "type" or "ref" is required'));
            let a = Xt(r.type);
            const o = Xt(r.ref);
            if (r.id) {
                const s = Xt(r.id);
                for(let a = 0; a < t1.arrayIndex; a++){
                    const t1 = i.layers[a];
                    Xt(t1.id) === s && e1.push(new qn(n, r.id, `duplicate layer id "${r.id}", previously used at line ${t1.id.__line__}`));
                }
            }
            if ("ref" in r) {
                let t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t1)=>{
                    t1 in r && e1.push(new qn(n, r[t1], `"${t1}" is prohibited for ref layers`));
                }), i.layers.forEach((e1)=>{
                    Xt(e1.id) === o && (t1 = e1);
                }), t1 ? t1.ref ? e1.push(new qn(n, r.ref, "ref cannot reference another ref layer")) : a = Xt(t1.type) : "string" == typeof o && e1.push(new qn(n, r.ref, `ref layer "${o}" not found`));
            } else if ("background" !== a && "sky" !== a) {
                if (r.source) {
                    const t1 = i.sources && i.sources[r.source], s = t1 && Xt(t1.type);
                    t1 ? "vector" === s && "raster" === a ? e1.push(new qn(n, r.source, `layer "${r.id}" requires a raster source`)) : "raster" === s && "raster" !== a ? e1.push(new qn(n, r.source, `layer "${r.id}" requires a vector source`)) : "vector" !== s || r["source-layer"] ? "raster-dem" === s && "hillshade" !== a ? e1.push(new qn(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== a || !r.paint || !r.paint["line-gradient"] && !r.paint["line-trim-offset"] || "geojson" === s && t1.lineMetrics || e1.push(new qn(n, r, `layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : e1.push(new qn(n, r, `layer "${r.id}" must specify a "source-layer"`)) : e1.push(new qn(n, r.source, `source "${r.source}" not found`));
                } else e1.push(new qn(n, r, 'missing required property "source"'));
            }
            return e1 = e1.concat(Nn({
                key: n,
                value: r,
                valueSpec: s.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>Ai({
                            key: `${n}.type`,
                            value: r.type,
                            valueSpec: s.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: r,
                            objectKey: "type"
                        }),
                    filter: (t1)=>ci(Zt({
                            layerType: a
                        }, t1)),
                    layout: (t1)=>Nn({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            valueSpec: {},
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>di(Zt({
                                        layerType: a
                                    }, t1))
                            }
                        }),
                    paint: (t1)=>Nn({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            valueSpec: {},
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>fi(Zt({
                                        layerType: a
                                    }, t1))
                            }
                        })
                }
            })), e1;
        }
        function mi(t1) {
            const e1 = t1.value, r = t1.key, n = In(e1);
            return "string" !== n ? [
                new qn(r, e1, `string expected, ${n} found`)
            ] : [];
        }
        const gi = {
            promoteId: function({ key: t1, value: e1 }) {
                if ("string" === In(e1)) return mi({
                    key: t1,
                    value: e1
                });
                {
                    const r = [];
                    for(const n in e1)r.push(...mi({
                        key: `${t1}.${n}`,
                        value: e1[n]
                    }));
                    return r;
                }
            }
        };
        function xi(t1) {
            const e1 = t1.value, r = t1.key, n = t1.styleSpec, i = t1.style;
            if (!e1.type) return [
                new qn(r, e1, '"type" is required')
            ];
            const s = Xt(e1.type);
            let a;
            switch(s){
                case "vector":
                case "raster":
                case "raster-dem":
                    return a = Nn({
                        key: r,
                        value: e1,
                        valueSpec: n[`source_${s.replace("-", "_")}`],
                        style: t1.style,
                        styleSpec: n,
                        objectElementValidators: gi
                    }), a;
                case "geojson":
                    if (a = Nn({
                        key: r,
                        value: e1,
                        valueSpec: n.source_geojson,
                        style: i,
                        styleSpec: n,
                        objectElementValidators: gi
                    }), e1.cluster) for(const t1 in e1.clusterProperties){
                        const [n, i] = e1.clusterProperties[t1], s = "string" == typeof n ? [
                            n,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                t1
                            ]
                        ] : n;
                        a.push(...Kn({
                            key: `${r}.${t1}.map`,
                            value: i,
                            expressionContext: "cluster-map"
                        })), a.push(...Kn({
                            key: `${r}.${t1}.reduce`,
                            value: s,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return a;
                case "video":
                    return Nn({
                        key: r,
                        value: e1,
                        valueSpec: n.source_video,
                        style: i,
                        styleSpec: n
                    });
                case "image":
                    return Nn({
                        key: r,
                        value: e1,
                        valueSpec: n.source_image,
                        style: i,
                        styleSpec: n
                    });
                case "canvas":
                    return [
                        new qn(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return Yn({
                        key: `${r}.type`,
                        value: e1.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        },
                        style: i,
                        styleSpec: n
                    });
            }
        }
        function vi(t1) {
            const e1 = t1.value, r = t1.styleSpec, n = r.light, i = t1.style;
            let s = [];
            const a = In(e1);
            if (void 0 === e1) return s;
            if ("object" !== a) return s = s.concat([
                new qn("light", e1, `object expected, ${a} found`)
            ]), s;
            for(const t1 in e1){
                const a = t1.match(/^(.*)-transition$/);
                s = s.concat(a && n[a[1]] && n[a[1]].transition ? Ai({
                    key: t1,
                    value: e1[t1],
                    valueSpec: r.transition,
                    style: i,
                    styleSpec: r
                }) : n[t1] ? Ai({
                    key: t1,
                    value: e1[t1],
                    valueSpec: n[t1],
                    style: i,
                    styleSpec: r
                }) : [
                    new qn(t1, e1[t1], `unknown property "${t1}"`)
                ]);
            }
            return s;
        }
        function bi(t1) {
            const e1 = t1.value, r = t1.key, n = t1.style, i = t1.styleSpec, s = i.terrain;
            let a = [];
            const o = In(e1);
            if (void 0 === e1) return a;
            if ("object" !== o) return a = a.concat([
                new qn("terrain", e1, `object expected, ${o} found`)
            ]), a;
            for(const t1 in e1){
                const r = t1.match(/^(.*)-transition$/);
                a = a.concat(r && s[r[1]] && s[r[1]].transition ? Ai({
                    key: t1,
                    value: e1[t1],
                    valueSpec: i.transition,
                    style: n,
                    styleSpec: i
                }) : s[t1] ? Ai({
                    key: t1,
                    value: e1[t1],
                    valueSpec: s[t1],
                    style: n,
                    styleSpec: i
                }) : [
                    new qn(t1, e1[t1], `unknown property "${t1}"`)
                ]);
            }
            if (e1.source) {
                const t1 = n.sources && n.sources[e1.source], i = t1 && Xt(t1.type);
                t1 ? "raster-dem" !== i && a.push(new qn(r, e1.source, `terrain cannot be used with a source of type ${String(i)}, it only be used with a "raster-dem" source type`)) : a.push(new qn(r, e1.source, `source "${e1.source}" not found`));
            } else a.push(new qn(r, e1, 'terrain is missing required property "source"'));
            return a;
        }
        function _i(t1) {
            const e1 = t1.value, r = t1.style, n = t1.styleSpec, i = n.fog;
            let s = [];
            const a = In(e1);
            if (void 0 === e1) return s;
            if ("object" !== a) return s = s.concat([
                new qn("fog", e1, `object expected, ${a} found`)
            ]), s;
            for(const t1 in e1){
                const a = t1.match(/^(.*)-transition$/);
                s = s.concat(a && i[a[1]] && i[a[1]].transition ? Ai({
                    key: t1,
                    value: e1[t1],
                    valueSpec: n.transition,
                    style: r,
                    styleSpec: n
                }) : i[t1] ? Ai({
                    key: t1,
                    value: e1[t1],
                    valueSpec: i[t1],
                    style: r,
                    styleSpec: n
                }) : [
                    new qn(t1, e1[t1], `unknown property "${t1}"`)
                ]);
            }
            return s;
        }
        const wi = {
            "*": ()=>[],
            array: Gn,
            boolean: function(t1) {
                const e1 = t1.value, r = t1.key, n = In(e1);
                return "boolean" !== n ? [
                    new qn(r, e1, `boolean expected, ${n} found`)
                ] : [];
            },
            number: Zn,
            color: function(t1) {
                const e1 = t1.key, r = t1.value, n = In(r);
                return "string" !== n ? [
                    new qn(e1, r, `color expected, ${n} found`)
                ] : null === me.parseCSSColor(r) ? [
                    new qn(e1, r, `color expected, "${r}" found`)
                ] : [];
            },
            enum: Yn,
            filter: ci,
            function: Xn,
            layer: yi,
            object: Nn,
            source: xi,
            light: vi,
            terrain: bi,
            fog: _i,
            string: mi,
            formatted: function(t1) {
                return 0 === mi(t1).length ? [] : Kn(t1);
            },
            resolvedImage: function(t1) {
                return 0 === mi(t1).length ? [] : Kn(t1);
            },
            projection: function(t1) {
                const e1 = t1.value, r = t1.styleSpec, n = r.projection, i = t1.style;
                let s = [];
                const a = In(e1);
                if ("object" === a) for(const t1 in e1)s = s.concat(Ai({
                    key: t1,
                    value: e1[t1],
                    valueSpec: n[t1],
                    style: i,
                    styleSpec: r
                }));
                else "string" !== a && (s = s.concat([
                    new qn("projection", e1, `object or string expected, ${a} found`)
                ]));
                return s;
            }
        };
        function Ai(t1) {
            const e1 = t1.value, r = t1.valueSpec, n = t1.styleSpec;
            return r.expression && Mn(Xt(e1)) ? Xn(t1) : r.expression && Fn(Kt(e1)) ? Kn(t1) : r.type && wi[r.type] ? wi[r.type](t1) : Nn(Zt({}, t1, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function Si(t1) {
            const e1 = t1.value, r = t1.key, n = mi(t1);
            return n.length || (-1 === e1.indexOf("{fontstack}") && n.push(new qn(r, e1, '"glyphs" url must include a "{fontstack}" token')), -1 === e1.indexOf("{range}") && n.push(new qn(r, e1, '"glyphs" url must include a "{range}" token'))), n;
        }
        function ki(t1, e1 = Gt) {
            return zi(Ai({
                key: "",
                value: t1,
                valueSpec: e1.$root,
                styleSpec: e1,
                style: t1,
                objectElementValidators: {
                    glyphs: Si,
                    "*": ()=>[]
                }
            }));
        }
        const Ii = (t1)=>zi(fi(t1)), Mi = (t1)=>zi(di(t1));
        function zi(t1) {
            return t1.slice().sort((t1, e1)=>t1.line && e1.line ? t1.line - e1.line : 0);
        }
        function Ti(t1, e1) {
            let r = !1;
            if (e1 && e1.length) for (const n of e1)t1.fire(new qt(new Error(n.message))), r = !0;
            return r;
        }
        var Bi = Ei;
        function Ei(t1, e1, r) {
            var n = this.cells = [];
            if (t1 instanceof ArrayBuffer) {
                this.arrayBuffer = t1;
                var i = new Int32Array(this.arrayBuffer);
                t1 = i[0], this.d = (e1 = i[1]) + 2 * (r = i[2]);
                for(var s = 0; s < this.d * this.d; s++){
                    var a = i[3 + s], o = i[3 + s + 1];
                    n.push(a === o ? null : i.subarray(a, o));
                }
                var l = i[3 + n.length + 1];
                this.keys = i.subarray(i[3 + n.length], l), this.bboxes = i.subarray(l), this.insert = this._insertReadonly;
            } else {
                this.d = e1 + 2 * r;
                for(var u = 0; u < this.d * this.d; u++)n.push([]);
                this.keys = [], this.bboxes = [];
            }
            this.n = e1, this.extent = t1, this.padding = r, this.scale = e1 / t1, this.uid = 0;
            var c = r / e1 * t1;
            this.min = -c, this.max = t1 + c;
        }
        Ei.prototype.insert = function(t1, e1, r, n, i) {
            this._forEachCell(e1, r, n, i, this._insertCell, this.uid++), this.keys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
        }, Ei.prototype._insertReadonly = function() {
            throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
        }, Ei.prototype._insertCell = function(t1, e1, r, n, i, s) {
            this.cells[i].push(s);
        }, Ei.prototype.query = function(t1, e1, r, n, i) {
            var s = this.min, a = this.max;
            if (t1 <= s && e1 <= s && a <= r && a <= n && !i) return Array.prototype.slice.call(this.keys);
            var o = [];
            return this._forEachCell(t1, e1, r, n, this._queryCell, o, {}, i), o;
        }, Ei.prototype._queryCell = function(t1, e1, r, n, i, s, a, o) {
            var l = this.cells[i];
            if (null !== l) for(var u = this.keys, c = this.bboxes, h = 0; h < l.length; h++){
                var p = l[h];
                if (void 0 === a[p]) {
                    var f = 4 * p;
                    (o ? o(c[f + 0], c[f + 1], c[f + 2], c[f + 3]) : t1 <= c[f + 2] && e1 <= c[f + 3] && r >= c[f + 0] && n >= c[f + 1]) ? (a[p] = !0, s.push(u[p])) : a[p] = !1;
                }
            }
        }, Ei.prototype._forEachCell = function(t1, e1, r, n, i, s, a, o) {
            for(var l = this._convertToCellCoord(t1), u = this._convertToCellCoord(e1), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n), p = l; p <= c; p++)for(var f = u; f <= h; f++){
                var d = this.d * f + p;
                if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(f), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(f + 1))) && i.call(this, t1, e1, r, n, d, s, a, o)) return;
            }
        }, Ei.prototype._convertFromCellCoord = function(t1) {
            return (t1 - this.padding) / this.scale;
        }, Ei.prototype._convertToCellCoord = function(t1) {
            return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
        }, Ei.prototype.toArrayBuffer = function() {
            if (this.arrayBuffer) return this.arrayBuffer;
            for(var t1 = this.cells, e1 = 3 + this.cells.length + 1 + 1, r = 0, n = 0; n < this.cells.length; n++)r += this.cells[n].length;
            var i = new Int32Array(e1 + r + this.keys.length + this.bboxes.length);
            i[0] = this.extent, i[1] = this.n, i[2] = this.padding;
            for(var s = e1, a = 0; a < t1.length; a++){
                var o = t1[a];
                i[3 + a] = s, i.set(o, s), s += o.length;
            }
            return i[3 + t1.length] = s, i.set(this.keys, s), i[3 + t1.length + 1] = s += this.keys.length, i.set(this.bboxes, s), s += this.bboxes.length, i.buffer;
        };
        const Ci = {};
        function Pi(t1, e1, r = {}) {
            Object.defineProperty(t1, "_classRegistryKey", {
                value: e1,
                writeable: !1
            }), Ci[e1] = {
                klass: t1,
                omit: r.omit || []
            };
        }
        Pi(Object, "Object"), Bi.serialize = function(t1, e1) {
            const r = t1.toArrayBuffer();
            return e1 && e1.push(r), {
                buffer: r
            };
        }, Bi.deserialize = function(t1) {
            return new Bi(t1.buffer);
        }, Object.defineProperty(Bi, "name", {
            value: "Grid"
        }), Pi(Bi, "Grid"), Pi(xe, "Color"), Pi(Error, "Error"), Pi(Tt, "AJAXError"), Pi(we, "ResolvedImage"), Pi($n, "StylePropertyFunction"), Pi(Vn, "StyleExpression", {
            omit: [
                "_evaluator"
            ]
        }), Pi(Un, "ZoomDependentExpression"), Pi(Rn, "ZoomConstantExpression"), Pi($e, "CompoundExpression", {
            omit: [
                "_evaluate"
            ]
        });
        for(const t1 in bn)Ci[bn[t1]._classRegistryKey] || Pi(bn[t1], `Expression${t1}`);
        function Di(t1) {
            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
        }
        function Vi(t1) {
            return e1.ImageBitmap && t1 instanceof e1.ImageBitmap;
        }
        function Fi(t1, r) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp) return t1;
            if (Di(t1) || Vi(t1)) return r && r.push(t1), t1;
            if (ArrayBuffer.isView(t1)) {
                const e1 = t1;
                return r && r.push(e1.buffer), e1;
            }
            if (t1 instanceof e1.ImageData) return r && r.push(t1.data.buffer), t1;
            if (Array.isArray(t1)) {
                const e1 = [];
                for (const n of t1)e1.push(Fi(n, r));
                return e1;
            }
            if ("object" == typeof t1) {
                const e1 = t1.constructor, n = e1._classRegistryKey;
                if (!n) throw new Error(`can't serialize object of unregistered class ${n}`);
                const i = e1.serialize ? e1.serialize(t1, r) : {};
                if (!e1.serialize) {
                    for(const e1 in t1)t1.hasOwnProperty(e1) && (Ci[n].omit.indexOf(e1) >= 0 || (i[e1] = Fi(t1[e1], r)));
                    t1 instanceof Error && (i.message = t1.message);
                }
                if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== n && (i.$name = n), i;
            }
            throw new Error("can't serialize object of type " + typeof t1);
        }
        function Li(t1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || Di(t1) || Vi(t1) || ArrayBuffer.isView(t1) || t1 instanceof e1.ImageData) return t1;
            if (Array.isArray(t1)) return t1.map(Li);
            if ("object" == typeof t1) {
                const e1 = t1.$name || "Object", { klass: r } = Ci[e1];
                if (!r) throw new Error(`can't deserialize unregistered class ${e1}`);
                if (r.deserialize) return r.deserialize(t1);
                const n = Object.create(r.prototype);
                for (const e1 of Object.keys(t1))"$name" !== e1 && (n[e1] = Li(t1[e1]));
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof t1);
        }
        class Ri {
            update(t1, e1) {
                const r = Math.floor(t1);
                return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t1, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e1) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e1), t1 !== this.lastZoom && (this.lastZoom = t1, this.lastFloorZoom = r, !0));
            }
            constructor(){
                this.first = !0;
            }
        }
        const Ui = (t1)=>t1 >= 1536 && t1 <= 1791, ji = (t1)=>t1 >= 1872 && t1 <= 1919, $i = (t1)=>t1 >= 2208 && t1 <= 2303, Oi = (t1)=>t1 >= 11904 && t1 <= 12031, qi = (t1)=>t1 >= 12032 && t1 <= 12255, Ni = (t1)=>t1 >= 12272 && t1 <= 12287, Gi = (t1)=>t1 >= 12288 && t1 <= 12351, Zi = (t1)=>t1 >= 12352 && t1 <= 12447, Xi = (t1)=>t1 >= 12448 && t1 <= 12543, Ki = (t1)=>t1 >= 12544 && t1 <= 12591, Hi = (t1)=>t1 >= 12704 && t1 <= 12735, Yi = (t1)=>t1 >= 12736 && t1 <= 12783, Wi = (t1)=>t1 >= 12784 && t1 <= 12799, Ji = (t1)=>t1 >= 12800 && t1 <= 13055, Qi = (t1)=>t1 >= 13056 && t1 <= 13311, ts = (t1)=>t1 >= 13312 && t1 <= 19903, es = (t1)=>t1 >= 19968 && t1 <= 40959, rs = (t1)=>t1 >= 40960 && t1 <= 42127, ns = (t1)=>t1 >= 42128 && t1 <= 42191, is = (t1)=>t1 >= 44032 && t1 <= 55215, ss = (t1)=>t1 >= 63744 && t1 <= 64255, as = (t1)=>t1 >= 64336 && t1 <= 65023, os = (t1)=>t1 >= 65040 && t1 <= 65055, ls = (t1)=>t1 >= 65072 && t1 <= 65103, us = (t1)=>t1 >= 65104 && t1 <= 65135, cs = (t1)=>t1 >= 65136 && t1 <= 65279, hs = (t1)=>t1 >= 65280 && t1 <= 65519;
        function ps(t1) {
            for (const e1 of t1)if (ys(e1.charCodeAt(0))) return !0;
            return !1;
        }
        function fs(t1) {
            for (const e1 of t1)if (!ds(e1.charCodeAt(0))) return !1;
            return !0;
        }
        function ds(t1) {
            return !(Ui(t1) || ji(t1) || $i(t1) || as(t1) || cs(t1));
        }
        function ys(t1) {
            return !(746 !== t1 && 747 !== t1 && (t1 < 4352 || !(Hi(t1) || Ki(t1) || ls(t1) && !(t1 >= 65097 && t1 <= 65103) || ss(t1) || Qi(t1) || Oi(t1) || Yi(t1) || !(!Gi(t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || ts(t1) || es(t1) || Ji(t1) || ((t1)=>t1 >= 12592 && t1 <= 12687)(t1) || ((t1)=>t1 >= 43360 && t1 <= 43391)(t1) || ((t1)=>t1 >= 55216 && t1 <= 55295)(t1) || ((t1)=>t1 >= 4352 && t1 <= 4607)(t1) || is(t1) || Zi(t1) || Ni(t1) || ((t1)=>t1 >= 12688 && t1 <= 12703)(t1) || qi(t1) || Wi(t1) || Xi(t1) && 12540 !== t1 || !(!hs(t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!us(t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || ((t1)=>t1 >= 5120 && t1 <= 5759)(t1) || ((t1)=>t1 >= 6320 && t1 <= 6399)(t1) || os(t1) || ((t1)=>t1 >= 19904 && t1 <= 19967)(t1) || rs(t1) || ns(t1))));
        }
        function ms(t1) {
            return !(ys(t1) || function(t1) {
                return !!(((t1)=>t1 >= 128 && t1 <= 255)(t1) && (167 === t1 || 169 === t1 || 174 === t1 || 177 === t1 || 188 === t1 || 189 === t1 || 190 === t1 || 215 === t1 || 247 === t1) || ((t1)=>t1 >= 8192 && t1 <= 8303)(t1) && (8214 === t1 || 8224 === t1 || 8225 === t1 || 8240 === t1 || 8241 === t1 || 8251 === t1 || 8252 === t1 || 8258 === t1 || 8263 === t1 || 8264 === t1 || 8265 === t1 || 8273 === t1) || ((t1)=>t1 >= 8448 && t1 <= 8527)(t1) || ((t1)=>t1 >= 8528 && t1 <= 8591)(t1) || ((t1)=>t1 >= 8960 && t1 <= 9215)(t1) && (t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215) || ((t1)=>t1 >= 9216 && t1 <= 9279)(t1) && 9251 !== t1 || ((t1)=>t1 >= 9280 && t1 <= 9311)(t1) || ((t1)=>t1 >= 9312 && t1 <= 9471)(t1) || ((t1)=>t1 >= 9632 && t1 <= 9727)(t1) || ((t1)=>t1 >= 9728 && t1 <= 9983)(t1) && !(t1 >= 9754 && t1 <= 9759) || ((t1)=>t1 >= 11008 && t1 <= 11263)(t1) && (t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243) || Gi(t1) || Xi(t1) || ((t1)=>t1 >= 57344 && t1 <= 63743)(t1) || ls(t1) || us(t1) || hs(t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1);
            }(t1));
        }
        function gs(t1) {
            return t1 >= 1424 && t1 <= 2303 || as(t1) || cs(t1);
        }
        function xs(t1, e1) {
            return !(!e1 && gs(t1) || t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || ((t1)=>t1 >= 6016 && t1 <= 6143)(t1));
        }
        function vs(t1) {
            for (const e1 of t1)if (gs(e1.charCodeAt(0))) return !0;
            return !1;
        }
        const bs = "deferred", _s = "loading", ws = "loaded";
        let As = null, Ss = "unavailable", ks = null;
        const Is = function(t1) {
            t1 && "string" == typeof t1 && t1.indexOf("NetworkError") > -1 && (Ss = "error"), As && As(t1);
        };
        function Ms() {
            zs.fire(new Ot("pluginStateChange", {
                pluginStatus: Ss,
                pluginURL: ks
            }));
        }
        const zs = new Nt, Ts = function() {
            return Ss;
        }, Bs = function() {
            if (Ss !== bs || !ks) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Ss = _s, Ms(), ks && Ct({
                url: ks
            }, (t1)=>{
                t1 ? Is(t1) : (Ss = ws, Ms());
            });
        }, Es = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>Ss === ws || null != Es.applyArabicShaping,
            isLoading: ()=>Ss === _s,
            setState (t1) {
                Ss = t1.pluginStatus, ks = t1.pluginURL;
            },
            isParsed: ()=>null != Es.applyArabicShaping && null != Es.processBidirectionalText && null != Es.processStyledBidirectionalText,
            getPluginURL: ()=>ks
        };
        class Cs {
            isSupportedScript(t1) {
                return function(t1, e1) {
                    for (const r of t1)if (!xs(r.charCodeAt(0), e1)) return !1;
                    return !0;
                }(t1, Es.isLoaded());
            }
            crossFadingFactor() {
                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
            }
            getCrossfadeParameters() {
                const t1 = this.zoom, e1 = t1 - Math.floor(t1), r = this.crossFadingFactor();
                return t1 > this.zoomHistory.lastIntegerZoom ? {
                    fromScale: 2,
                    toScale: 1,
                    t: e1 + (1 - e1) * r
                } : {
                    fromScale: .5,
                    toScale: 1,
                    t: 1 - (1 - r) * e1
                };
            }
            constructor(t1, e1){
                this.zoom = t1, e1 ? (this.now = e1.now, this.fadeDuration = e1.fadeDuration, this.zoomHistory = e1.zoomHistory, this.transition = e1.transition, this.pitch = e1.pitch) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Ri, this.transition = {}, this.pitch = 0);
            }
        }
        class Ps {
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t1, e1, r) {
                return this.property.possiblyEvaluate(this, t1, e1, r);
            }
            constructor(t1, e1){
                this.property = t1, this.value = e1, this.expression = function(t1, e1) {
                    if (Mn(t1)) return new $n(t1, e1);
                    if (Fn(t1)) {
                        const r = jn(t1, e1);
                        if ("error" === r.result) throw new Error(r.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                        return r.value;
                    }
                    {
                        let r = t1;
                        return "string" == typeof t1 && "color" === e1.type && (r = xe.parse(t1)), {
                            kind: "constant",
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === e1 ? t1.specification.default : e1, t1.specification);
            }
        }
        class Ds {
            transitioned(t1, e1) {
                return new Fs(this.property, this.value, e1, v({}, t1.transition, this.transition), t1.now);
            }
            untransitioned() {
                return new Fs(this.property, this.value, null, {}, 0);
            }
            constructor(t1){
                this.property = t1, this.value = new Ps(t1, void 0);
            }
        }
        class Vs {
            getValue(t1) {
                return T(this._values[t1].value.value);
            }
            setValue(t1, e1) {
                this._values.hasOwnProperty(t1) || (this._values[t1] = new Ds(this._values[t1].property)), this._values[t1].value = new Ps(this._values[t1].property, null === e1 ? void 0 : T(e1));
            }
            getTransition(t1) {
                return T(this._values[t1].transition);
            }
            setTransition(t1, e1) {
                this._values.hasOwnProperty(t1) || (this._values[t1] = new Ds(this._values[t1].property)), this._values[t1].transition = T(e1) || void 0;
            }
            serialize() {
                const t1 = {};
                for (const e1 of Object.keys(this._values)){
                    const r = this.getValue(e1);
                    void 0 !== r && (t1[e1] = r);
                    const n = this.getTransition(e1);
                    void 0 !== n && (t1[`${e1}-transition`] = n);
                }
                return t1;
            }
            transitioned(t1, e1) {
                const r = new Ls(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t1, e1._values[n]);
                return r;
            }
            untransitioned() {
                const t1 = new Ls(this._properties);
                for (const e1 of Object.keys(this._values))t1._values[e1] = this._values[e1].untransitioned();
                return t1;
            }
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues);
            }
        }
        class Fs {
            possiblyEvaluate(t1, e1, r) {
                const n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e1, r), s = this.prior;
                if (s) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return s.possiblyEvaluate(t1, e1, r);
                    {
                        const a = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(s.possiblyEvaluate(t1, e1, r), i, h(a));
                    }
                }
                return i;
            }
            constructor(t1, e1, r, n, i){
                const s = n.delay || 0, a = n.duration || 0;
                i = i || 0, this.property = t1, this.value = e1, this.begin = i + s, this.end = this.begin + a, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
        }
        class Ls {
            possiblyEvaluate(t1, e1, r) {
                const n = new js(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e1, r);
                return n;
            }
            hasTransition() {
                for (const t1 of Object.keys(this._values))if (this._values[t1].prior) return !0;
                return !1;
            }
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
            }
        }
        class Rs {
            getValue(t1) {
                return T(this._values[t1].value);
            }
            setValue(t1, e1) {
                this._values[t1] = new Ps(this._values[t1].property, null === e1 ? void 0 : T(e1));
            }
            serialize() {
                const t1 = {};
                for (const e1 of Object.keys(this._values)){
                    const r = this.getValue(e1);
                    void 0 !== r && (t1[e1] = r);
                }
                return t1;
            }
            possiblyEvaluate(t1, e1, r) {
                const n = new js(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e1, r);
                return n;
            }
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultPropertyValues);
            }
        }
        class Us {
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t1) {
                return "constant" === this.value.kind ? this.value.value : t1;
            }
            evaluate(t1, e1, r, n) {
                return this.property.evaluate(this.value, this.parameters, t1, e1, r, n);
            }
            constructor(t1, e1, r){
                this.property = t1, this.value = e1, this.parameters = r;
            }
        }
        class js {
            get(t1) {
                return this._values[t1];
            }
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
            }
        }
        class $s {
            possiblyEvaluate(t1, e1) {
                return t1.expression.evaluate(e1);
            }
            interpolate(t1, e1, r) {
                const n = br[this.specification.type];
                return n ? n(t1, e1, r) : t1;
            }
            constructor(t1){
                this.specification = t1;
            }
        }
        class Os {
            possiblyEvaluate(t1, e1, r, n) {
                return new Us(this, "constant" === t1.expression.kind || "camera" === t1.expression.kind ? {
                    kind: "constant",
                    value: t1.expression.evaluate(e1, null, {}, r, n)
                } : t1.expression, e1);
            }
            interpolate(t1, e1, r) {
                if ("constant" !== t1.value.kind || "constant" !== e1.value.kind) return t1;
                if (void 0 === t1.value.value || void 0 === e1.value.value) return new Us(this, {
                    kind: "constant",
                    value: void 0
                }, t1.parameters);
                const n = br[this.specification.type];
                return n ? new Us(this, {
                    kind: "constant",
                    value: n(t1.value.value, e1.value.value, r)
                }, t1.parameters) : t1;
            }
            evaluate(t1, e1, r, n, i, s) {
                return "constant" === t1.kind ? t1.value : t1.evaluate(e1, r, n, i, s);
            }
            constructor(t1, e1){
                this.specification = t1, this.overrides = e1;
            }
        }
        class qs extends Os {
            possiblyEvaluate(t1, e1, r, n) {
                if (void 0 === t1.value) return new Us(this, {
                    kind: "constant",
                    value: void 0
                }, e1);
                if ("constant" === t1.expression.kind) {
                    const i = t1.expression.evaluate(e1, null, {}, r, n), s = "resolvedImage" === t1.property.specification.type && "string" != typeof i ? i.name : i, a = this._calculate(s, s, s, e1);
                    return new Us(this, {
                        kind: "constant",
                        value: a
                    }, e1);
                }
                if ("camera" === t1.expression.kind) {
                    const r = this._calculate(t1.expression.evaluate({
                        zoom: e1.zoom - 1
                    }), t1.expression.evaluate({
                        zoom: e1.zoom
                    }), t1.expression.evaluate({
                        zoom: e1.zoom + 1
                    }), e1);
                    return new Us(this, {
                        kind: "constant",
                        value: r
                    }, e1);
                }
                return new Us(this, t1.expression, e1);
            }
            evaluate(t1, e1, r, n, i, s) {
                if ("source" === t1.kind) {
                    const a = t1.evaluate(e1, r, n, i, s);
                    return this._calculate(a, a, a, e1);
                }
                return "composite" === t1.kind ? this._calculate(t1.evaluate({
                    zoom: Math.floor(e1.zoom) - 1
                }, r, n), t1.evaluate({
                    zoom: Math.floor(e1.zoom)
                }, r, n), t1.evaluate({
                    zoom: Math.floor(e1.zoom) + 1
                }, r, n), e1) : t1.value;
            }
            _calculate(t1, e1, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t1,
                    to: e1,
                    other: r
                } : {
                    from: r,
                    to: e1,
                    other: t1
                };
            }
            interpolate(t1) {
                return t1;
            }
        }
        class Ns {
            possiblyEvaluate(t1, e1, r, n) {
                if (void 0 !== t1.value) {
                    if ("constant" === t1.expression.kind) {
                        const i = t1.expression.evaluate(e1, null, {}, r, n);
                        return this._calculate(i, i, i, e1);
                    }
                    return this._calculate(t1.expression.evaluate(new Cs(Math.floor(e1.zoom - 1), e1)), t1.expression.evaluate(new Cs(Math.floor(e1.zoom), e1)), t1.expression.evaluate(new Cs(Math.floor(e1.zoom + 1), e1)), e1);
                }
            }
            _calculate(t1, e1, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t1,
                    to: e1
                } : {
                    from: r,
                    to: e1
                };
            }
            interpolate(t1) {
                return t1;
            }
            constructor(t1){
                this.specification = t1;
            }
        }
        class Gs {
            possiblyEvaluate(t1, e1, r, n) {
                return !!t1.expression.evaluate(e1, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
            constructor(t1){
                this.specification = t1;
            }
        }
        class Zs {
            constructor(t1){
                this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                const e1 = new Cs(0, {});
                for(const r in t1){
                    const n = t1[r];
                    n.specification.overridable && this.overridableProperties.push(r);
                    const i = this.defaultPropertyValues[r] = new Ps(n, void 0), s = this.defaultTransitionablePropertyValues[r] = new Ds(n);
                    this.defaultTransitioningPropertyValues[r] = s.untransitioned(), this.defaultPossiblyEvaluatedValues[r] = i.possiblyEvaluate(e1);
                }
            }
        }
        function Xs(t1, e1) {
            return 256 * (t1 = d(Math.floor(t1), 0, 255)) + d(Math.floor(e1), 0, 255);
        }
        Pi(Os, "DataDrivenProperty"), Pi($s, "DataConstantProperty"), Pi(qs, "CrossFadedDataDrivenProperty"), Pi(Ns, "CrossFadedProperty"), Pi(Gs, "ColorRampProperty");
        const Ks = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class Hs {
            constructor(t1, e1){
                this._structArray = t1, this._pos1 = e1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class Ys {
            static serialize(t1, e1) {
                return t1._trim(), e1 && (t1.isTransferred = !0, e1.push(t1.arrayBuffer)), {
                    length: t1.length,
                    arrayBuffer: t1.arrayBuffer
                };
            }
            static deserialize(t1) {
                const e1 = Object.create(this.prototype);
                return e1.arrayBuffer = t1.arrayBuffer, e1.length = t1.length, e1.capacity = t1.arrayBuffer.byteLength / e1.bytesPerElement, e1._refreshViews(), e1;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t1) {
                this.reserve(t1), this.length = t1;
            }
            reserve(t1) {
                if (t1 > this.capacity) {
                    this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e1 = this.uint8;
                    this._refreshViews(), e1 && this.uint8.set(e1);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
            destroy() {
                this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
        }
        function Ws(t1, e1 = 1) {
            let r = 0, n = 0;
            return {
                members: t1.map((t1)=>{
                    const i = Ks[t1.type].BYTES_PER_ELEMENT, s = r = Js(r, Math.max(e1, i)), a = t1.components || 1;
                    return n = Math.max(n, i), r += i * a, {
                        name: t1.name,
                        type: t1.type,
                        components: a,
                        offset: s
                    };
                }),
                size: Js(r, Math.max(n, e1)),
                alignment: e1
            };
        }
        function Js(t1, e1) {
            return Math.ceil(t1 / e1) * e1;
        }
        class Qs extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.int16[n + 0] = e1, this.int16[n + 1] = r, t1;
            }
        }
        Qs.prototype.bytesPerElement = 4, Pi(Qs, "StructArrayLayout2i4");
        class ta extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.int16[i + 0] = e1, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
            }
        }
        ta.prototype.bytesPerElement = 6, Pi(ta, "StructArrayLayout3i6");
        class ea extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const s = 4 * t1;
                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, t1;
            }
        }
        ea.prototype.bytesPerElement = 8, Pi(ea, "StructArrayLayout4i8");
        class ra extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, s, a);
            }
            emplace(t1, e1, r, n, i, s, a, o) {
                const l = 6 * t1, u = 12 * t1, c = 3 * t1;
                return this.int16[l + 0] = e1, this.int16[l + 1] = r, this.uint8[u + 4] = n, this.uint8[u + 5] = i, this.uint8[u + 6] = s, this.uint8[u + 7] = a, this.float32[c + 2] = o, t1;
            }
        }
        ra.prototype.bytesPerElement = 12, Pi(ra, "StructArrayLayout2i4ub1f12");
        class na extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const s = 4 * t1;
                return this.float32[s + 0] = e1, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, t1;
            }
        }
        na.prototype.bytesPerElement = 16, Pi(na, "StructArrayLayout4f16");
        class ia extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a, o, l, u) {
                const c = this.length;
                return this.resize(c + 1), this.emplace(c, t1, e1, r, n, i, s, a, o, l, u);
            }
            emplace(t1, e1, r, n, i, s, a, o, l, u, c) {
                const h = 10 * t1;
                return this.uint16[h + 0] = e1, this.uint16[h + 1] = r, this.uint16[h + 2] = n, this.uint16[h + 3] = i, this.uint16[h + 4] = s, this.uint16[h + 5] = a, this.uint16[h + 6] = o, this.uint16[h + 7] = l, this.uint16[h + 8] = u, this.uint16[h + 9] = c, t1;
            }
        }
        ia.prototype.bytesPerElement = 20, Pi(ia, "StructArrayLayout10ui20");
        class sa extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a, o) {
                const l = this.length;
                return this.resize(l + 1), this.emplace(l, t1, e1, r, n, i, s, a, o);
            }
            emplace(t1, e1, r, n, i, s, a, o, l) {
                const u = 8 * t1;
                return this.uint16[u + 0] = e1, this.uint16[u + 1] = r, this.uint16[u + 2] = n, this.uint16[u + 3] = i, this.uint16[u + 4] = s, this.uint16[u + 5] = a, this.uint16[u + 6] = o, this.uint16[u + 7] = l, t1;
            }
        }
        sa.prototype.bytesPerElement = 16, Pi(sa, "StructArrayLayout8ui16");
        class aa extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e1, r, n, i, s);
            }
            emplace(t1, e1, r, n, i, s, a) {
                const o = 6 * t1;
                return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, this.int16[o + 5] = a, t1;
            }
        }
        aa.prototype.bytesPerElement = 12, Pi(aa, "StructArrayLayout6i12");
        class oa extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a, o, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t1, e1, r, n, i, s, a, o, l, u, c, h);
            }
            emplace(t1, e1, r, n, i, s, a, o, l, u, c, h, p) {
                const f = 12 * t1;
                return this.int16[f + 0] = e1, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = s, this.uint16[f + 5] = a, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t1;
            }
        }
        oa.prototype.bytesPerElement = 24, Pi(oa, "StructArrayLayout4i4ui4i24");
        class la extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e1, r, n, i, s);
            }
            emplace(t1, e1, r, n, i, s, a) {
                const o = 10 * t1, l = 5 * t1;
                return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.float32[l + 2] = i, this.float32[l + 3] = s, this.float32[l + 4] = a, t1;
            }
        }
        la.prototype.bytesPerElement = 20, Pi(la, "StructArrayLayout3i3f20");
        class ua extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.uint32[1 * t1 + 0] = e1, t1;
            }
        }
        ua.prototype.bytesPerElement = 4, Pi(ua, "StructArrayLayout1ul4");
        class ca extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a, o, l, u, c, h, p) {
                const f = this.length;
                return this.resize(f + 1), this.emplace(f, t1, e1, r, n, i, s, a, o, l, u, c, h, p);
            }
            emplace(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f) {
                const d = 20 * t1, y = 10 * t1;
                return this.int16[d + 0] = e1, this.int16[d + 1] = r, this.int16[d + 2] = n, this.int16[d + 3] = i, this.int16[d + 4] = s, this.float32[y + 3] = a, this.float32[y + 4] = o, this.float32[y + 5] = l, this.float32[y + 6] = u, this.int16[d + 14] = c, this.uint32[y + 8] = h, this.uint16[d + 18] = p, this.uint16[d + 19] = f, t1;
            }
        }
        ca.prototype.bytesPerElement = 40, Pi(ca, "StructArrayLayout5i4f1i1ul2ui40");
        class ha extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, s, a);
            }
            emplace(t1, e1, r, n, i, s, a, o) {
                const l = 8 * t1;
                return this.int16[l + 0] = e1, this.int16[l + 1] = r, this.int16[l + 2] = n, this.int16[l + 4] = i, this.int16[l + 5] = s, this.int16[l + 6] = a, this.int16[l + 7] = o, t1;
            }
        }
        ha.prototype.bytesPerElement = 16, Pi(ha, "StructArrayLayout3i2i2i16");
        class pa extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e1, r, n, i);
            }
            emplace(t1, e1, r, n, i, s) {
                const a = 4 * t1, o = 8 * t1;
                return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = s, t1;
            }
        }
        pa.prototype.bytesPerElement = 16, Pi(pa, "StructArrayLayout2f1f2i16");
        class fa extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const s = 12 * t1, a = 3 * t1;
                return this.uint8[s + 0] = e1, this.uint8[s + 1] = r, this.float32[a + 1] = n, this.float32[a + 2] = i, t1;
            }
        }
        fa.prototype.bytesPerElement = 12, Pi(fa, "StructArrayLayout2ub2f12");
        class da extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.float32[i + 0] = e1, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
            }
        }
        da.prototype.bytesPerElement = 12, Pi(da, "StructArrayLayout3f12");
        class ya extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.uint16[i + 0] = e1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
            }
        }
        ya.prototype.bytesPerElement = 6, Pi(ya, "StructArrayLayout3ui6");
        class ma extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b) {
                const _ = this.length;
                return this.resize(_ + 1), this.emplace(_, t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b);
            }
            emplace(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, _) {
                const w = 30 * t1, A = 15 * t1, S = 60 * t1;
                return this.int16[w + 0] = e1, this.int16[w + 1] = r, this.int16[w + 2] = n, this.float32[A + 2] = i, this.float32[A + 3] = s, this.uint16[w + 8] = a, this.uint16[w + 9] = o, this.uint32[A + 5] = l, this.uint32[A + 6] = u, this.uint32[A + 7] = c, this.uint16[w + 16] = h, this.uint16[w + 17] = p, this.uint16[w + 18] = f, this.float32[A + 10] = d, this.float32[A + 11] = y, this.uint8[S + 48] = m, this.uint8[S + 49] = g, this.uint8[S + 50] = x, this.uint32[A + 13] = v, this.int16[w + 28] = b, this.uint8[S + 58] = _, t1;
            }
        }
        ma.prototype.bytesPerElement = 60, Pi(ma, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class ga extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, _, w, A, S, k, I, M, z, T) {
                const B = this.length;
                return this.resize(B + 1), this.emplace(B, t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, _, w, A, S, k, I, M, z, T);
            }
            emplace(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, _, w, A, S, k, I, M, z, T, B) {
                const E = 38 * t1, C = 19 * t1;
                return this.int16[E + 0] = e1, this.int16[E + 1] = r, this.int16[E + 2] = n, this.float32[C + 2] = i, this.float32[C + 3] = s, this.int16[E + 8] = a, this.int16[E + 9] = o, this.int16[E + 10] = l, this.int16[E + 11] = u, this.int16[E + 12] = c, this.int16[E + 13] = h, this.uint16[E + 14] = p, this.uint16[E + 15] = f, this.uint16[E + 16] = d, this.uint16[E + 17] = y, this.uint16[E + 18] = m, this.uint16[E + 19] = g, this.uint16[E + 20] = x, this.uint16[E + 21] = v, this.uint16[E + 22] = b, this.uint16[E + 23] = _, this.uint16[E + 24] = w, this.uint16[E + 25] = A, this.uint16[E + 26] = S, this.uint16[E + 27] = k, this.uint16[E + 28] = I, this.uint32[C + 15] = M, this.float32[C + 16] = z, this.float32[C + 17] = T, this.float32[C + 18] = B, t1;
            }
        }
        ga.prototype.bytesPerElement = 76, Pi(ga, "StructArrayLayout3i2f6i15ui1ul3f76");
        class xa extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.float32[1 * t1 + 0] = e1, t1;
            }
        }
        xa.prototype.bytesPerElement = 4, Pi(xa, "StructArrayLayout1f4");
        class va extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e1, r, n, i);
            }
            emplace(t1, e1, r, n, i, s) {
                const a = 5 * t1;
                return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, this.float32[a + 4] = s, t1;
            }
        }
        va.prototype.bytesPerElement = 20, Pi(va, "StructArrayLayout5f20");
        class ba extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const s = 6 * t1;
                return this.uint32[3 * t1 + 0] = e1, this.uint16[s + 2] = r, this.uint16[s + 3] = n, this.uint16[s + 4] = i, t1;
            }
        }
        ba.prototype.bytesPerElement = 12, Pi(ba, "StructArrayLayout1ul3ui12");
        class _a extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.uint16[n + 0] = e1, this.uint16[n + 1] = r, t1;
            }
        }
        _a.prototype.bytesPerElement = 4, Pi(_a, "StructArrayLayout2ui4");
        class wa extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.uint16[1 * t1 + 0] = e1, t1;
            }
        }
        wa.prototype.bytesPerElement = 2, Pi(wa, "StructArrayLayout1ui2");
        class Aa extends Ys {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.float32[n + 0] = e1, this.float32[n + 1] = r, t1;
            }
        }
        Aa.prototype.bytesPerElement = 8, Pi(Aa, "StructArrayLayout2f8");
        class Sa extends Hs {
            get a_pos_30() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get a_pos_31() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get a_pos_32() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get a_pos_normal_30() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get a_pos_normal_31() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get a_pos_normal_32() {
                return this._structArray.int16[this._pos2 + 5];
            }
        }
        Sa.prototype.size = 12;
        class ka extends aa {
            get(t1) {
                return new Sa(this, t1);
            }
        }
        Pi(ka, "FillExtrusionExtArray");
        class Ia extends Hs {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
                return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
                return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
                return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
                return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
        }
        Ia.prototype.size = 40;
        class Ma extends ca {
            get(t1) {
                return new Ia(this, t1);
            }
        }
        Pi(Ma, "CollisionBoxArray");
        class za extends Hs {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(t1) {
                this._structArray.uint8[this._pos1 + 49] = t1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(t1) {
                this._structArray.uint8[this._pos1 + 50] = t1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 13] = t1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
                return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(t1) {
                this._structArray.uint8[this._pos1 + 58] = t1;
            }
        }
        za.prototype.size = 60;
        class Ta extends ma {
            get(t1) {
                return new za(this, t1);
            }
        }
        Pi(Ta, "PlacedSymbolArray");
        class Ba extends Hs {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 8];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 9];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 10];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 11];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 12];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 13];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 23];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 24];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 25];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 26];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 27];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 28];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 15];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 15] = t1;
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 16];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 17];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 18];
            }
        }
        Ba.prototype.size = 76;
        class Ea extends ga {
            get(t1) {
                return new Ba(this, t1);
            }
        }
        Pi(Ea, "SymbolInstanceArray");
        class Ca extends xa {
            getoffsetX(t1) {
                return this.float32[1 * t1 + 0];
            }
        }
        Pi(Ca, "GlyphOffsetArray");
        class Pa extends ta {
            getx(t1) {
                return this.int16[3 * t1 + 0];
            }
            gety(t1) {
                return this.int16[3 * t1 + 1];
            }
            gettileUnitDistanceFromAnchor(t1) {
                return this.int16[3 * t1 + 2];
            }
        }
        Pi(Pa, "SymbolLineVertexArray");
        class Da extends Hs {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
                return this._structArray.uint16[this._pos2 + 4];
            }
        }
        Da.prototype.size = 12;
        class Va extends ba {
            get(t1) {
                return new Da(this, t1);
            }
        }
        Pi(Va, "FeatureIndexArray");
        class Fa extends Hs {
            get a_centroid_pos0() {
                return this._structArray.uint16[this._pos2 + 0];
            }
            get a_centroid_pos1() {
                return this._structArray.uint16[this._pos2 + 1];
            }
        }
        Fa.prototype.size = 4;
        class La extends _a {
            get(t1) {
                return new Fa(this, t1);
            }
        }
        Pi(La, "FillExtrusionCentroidArray");
        class Ra extends Hs {
            get a_pos_30() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get a_pos_31() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get a_pos_32() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get a_pos_normal_30() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get a_pos_normal_31() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get a_pos_normal_32() {
                return this._structArray.int16[this._pos2 + 5];
            }
        }
        Ra.prototype.size = 12;
        class Ua extends aa {
            get(t1) {
                return new Ra(this, t1);
            }
        }
        Pi(Ua, "CircleGlobeExtArray");
        const ja = Ws([
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            }
        ]), $a = Ws([
            {
                name: "a_dash_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_dash_from",
                components: 4,
                type: "Uint16"
            }
        ]);
        var Oa = ye(function(t1) {
            t1.exports = function(t1, e1) {
                var r, n, i, s, a, o, l, u;
                for(n = t1.length - (r = 3 & t1.length), i = e1, a = 3432918353, o = 461845907, u = 0; u < n;)l = 255 & t1.charCodeAt(u) | (255 & t1.charCodeAt(++u)) << 8 | (255 & t1.charCodeAt(++u)) << 16 | (255 & t1.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s >>> 16) & 65535) << 16);
                switch(l = 0, r){
                    case 3:
                        l ^= (255 & t1.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & t1.charCodeAt(u + 1)) << 8;
                    case 1:
                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t1.charCodeAt(u))) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
                }
                return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            };
        }), qa = ye(function(t1) {
            t1.exports = function(t1, e1) {
                for(var r, n = t1.length, i = e1 ^ n, s = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(s) | (255 & t1.charCodeAt(++s)) << 8 | (255 & t1.charCodeAt(++s)) << 16 | (255 & t1.charCodeAt(++s)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++s;
                switch(n){
                    case 3:
                        i ^= (255 & t1.charCodeAt(s + 2)) << 16;
                    case 2:
                        i ^= (255 & t1.charCodeAt(s + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            };
        }), Na = Oa, Ga = qa;
        Na.murmur3 = Oa, Na.murmur2 = Ga;
        class Za {
            add(t1, e1, r, n) {
                this.ids.push(Xa(t1)), this.positions.push(e1, r, n);
            }
            getPositions(t1) {
                const e1 = Xa(t1);
                let r = 0, n = this.ids.length - 1;
                for(; r < n;){
                    const t1 = r + n >> 1;
                    this.ids[t1] >= e1 ? n = t1 : r = t1 + 1;
                }
                const i = [];
                for(; this.ids[r] === e1;)i.push({
                    index: this.positions[3 * r],
                    start: this.positions[3 * r + 1],
                    end: this.positions[3 * r + 2]
                }), r++;
                return i;
            }
            static serialize(t1, e1) {
                const r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
                return Ka(r, n, 0, r.length - 1), e1 && e1.push(r.buffer, n.buffer), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(t1) {
                const e1 = new Za;
                return e1.ids = t1.ids, e1.positions = t1.positions, e1.indexed = !0, e1;
            }
            constructor(){
                this.ids = [], this.positions = [], this.indexed = !1;
            }
        }
        function Xa(t1) {
            const e1 = +t1;
            return !isNaN(e1) && Number.MIN_SAFE_INTEGER <= e1 && e1 <= Number.MAX_SAFE_INTEGER ? e1 : Na(String(t1));
        }
        function Ka(t1, e1, r, n) {
            for(; r < n;){
                const i = t1[r + n >> 1];
                let s = r - 1, a = n + 1;
                for(;;){
                    do s++;
                    while (t1[s] < i);
                    do a--;
                    while (t1[a] > i);
                    if (s >= a) break;
                    Ha(t1, s, a), Ha(e1, 3 * s, 3 * a), Ha(e1, 3 * s + 1, 3 * a + 1), Ha(e1, 3 * s + 2, 3 * a + 2);
                }
                a - r < n - a ? (Ka(t1, e1, r, a), r = a + 1) : (Ka(t1, e1, a + 1, n), n = a);
            }
        }
        function Ha(t1, e1, r) {
            const n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        Pi(Za, "FeaturePositionMap");
        class Ya {
            fetchUniformLocation(t1, e1) {
                return this.location || this.initialized || (this.location = this.gl.getUniformLocation(t1, e1), this.initialized = !0), !!this.location;
            }
            constructor(t1){
                this.gl = t1.gl, this.initialized = !1;
            }
        }
        class Wa extends Ya {
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && this.current !== r && (this.current = r, this.gl.uniform1f(this.location, r));
            }
            constructor(t1){
                super(t1), this.current = 0;
            }
        }
        class Ja extends Ya {
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] && r[3] === this.current[3] || (this.current = r, this.gl.uniform4f(this.location, r[0], r[1], r[2], r[3])));
            }
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
        }
        class Qa extends Ya {
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && (r.r === this.current.r && r.g === this.current.g && r.b === this.current.b && r.a === this.current.a || (this.current = r, this.gl.uniform4f(this.location, r.r, r.g, r.b, r.a)));
            }
            constructor(t1){
                super(t1), this.current = xe.transparent;
            }
        }
        const to = new Float32Array(16), eo = new Float32Array(9), ro = new Float32Array(4);
        function no(t1) {
            return [
                Xs(255 * t1.r, 255 * t1.g),
                Xs(255 * t1.b, 255 * t1.a)
            ];
        }
        class io {
            setUniform(t1, e1, r, n, i) {
                e1.set(t1, i, n.constantOr(this.value));
            }
            getBinding(t1, e1) {
                return "color" === this.type ? new Qa(t1) : new Wa(t1);
            }
            constructor(t1, e1, r){
                this.value = t1, this.uniformNames = e1.map((t1)=>`u_${t1}`), this.type = r;
            }
        }
        class so {
            setConstantPatternPositions(t1, e1) {
                this.pixelRatioFrom = e1.pixelRatio || 1, this.pixelRatioTo = t1.pixelRatio || 1, this.patternFrom = e1.tl.concat(e1.br), this.patternTo = t1.tl.concat(t1.br);
            }
            setUniform(t1, e1, r, n, i) {
                const s = "u_pattern_to" === i || "u_dash_to" === i ? this.patternTo : "u_pattern_from" === i || "u_dash_from" === i ? this.patternFrom : "u_pixel_ratio_to" === i ? this.pixelRatioTo : "u_pixel_ratio_from" === i ? this.pixelRatioFrom : null;
                s && e1.set(t1, i, s);
            }
            getBinding(t1, e1) {
                return "u_pattern_from" === e1 || "u_pattern_to" === e1 || "u_dash_from" === e1 || "u_dash_to" === e1 ? new Ja(t1) : new Wa(t1);
            }
            constructor(t1, e1){
                this.uniformNames = e1.map((t1)=>`u_${t1}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
            }
        }
        class ao {
            populatePaintArray(t1, e1, r, n, i, s) {
                const a = this.paintVertexArray.length, o = this.expression.evaluate(new Cs(0), e1, {}, i, n, s);
                this.paintVertexArray.resize(t1), this._setPaintValue(a, t1, o);
            }
            updatePaintArray(t1, e1, r, n, i) {
                const s = this.expression.evaluate({
                    zoom: 0
                }, r, n, void 0, i);
                this._setPaintValue(t1, e1, s);
            }
            _setPaintValue(t1, e1, r) {
                if ("color" === this.type) {
                    const n = no(r);
                    for(let r = t1; r < e1; r++)this.paintVertexArray.emplace(r, n[0], n[1]);
                } else {
                    for(let n = t1; n < e1; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            constructor(t1, e1, r, n){
                this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e1.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
        }
        class oo {
            populatePaintArray(t1, e1, r, n, i, s) {
                const a = this.expression.evaluate(new Cs(this.zoom), e1, {}, i, n, s), o = this.expression.evaluate(new Cs(this.zoom + 1), e1, {}, i, n, s), l = this.paintVertexArray.length;
                this.paintVertexArray.resize(t1), this._setPaintValue(l, t1, a, o);
            }
            updatePaintArray(t1, e1, r, n, i) {
                const s = this.expression.evaluate({
                    zoom: this.zoom
                }, r, n, void 0, i), a = this.expression.evaluate({
                    zoom: this.zoom + 1
                }, r, n, void 0, i);
                this._setPaintValue(t1, e1, s, a);
            }
            _setPaintValue(t1, e1, r, n) {
                if ("color" === this.type) {
                    const i = no(r), s = no(n);
                    for(let r = t1; r < e1; r++)this.paintVertexArray.emplace(r, i[0], i[1], s[0], s[1]);
                } else {
                    for(let i = t1; i < e1; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t1, e1, r, n, i) {
                const s = this.useIntegerZoom ? Math.floor(r.zoom) : r.zoom, a = d(this.expression.interpolationFactor(s, this.zoom, this.zoom + 1), 0, 1);
                e1.set(t1, i, a);
            }
            getBinding(t1, e1) {
                return new Wa(t1);
            }
            constructor(t1, e1, r, n, i, s){
                this.expression = t1, this.uniformNames = e1.map((t1)=>`u_${t1}_t`), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e1.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new s;
            }
        }
        class lo {
            populatePaintArray(t1, e1, r) {
                const n = this.zoomInPaintVertexArray.length;
                this.zoomInPaintVertexArray.resize(t1), this.zoomOutPaintVertexArray.resize(t1), this._setPaintValues(n, t1, e1.patterns && e1.patterns[this.layerId], r);
            }
            updatePaintArray(t1, e1, r, n, i, s) {
                this._setPaintValues(t1, e1, r.patterns && r.patterns[this.layerId], s);
            }
            _setPaintValues(t1, e1, r, n) {
                if (!n || !r) return;
                const { min: i, mid: s, max: a } = r, o = n[i], l = n[s], u = n[a];
                if (o && l && u) for(let r = t1; r < e1; r++)this._setPaintValue(this.zoomInPaintVertexArray, r, l, o), this._setPaintValue(this.zoomOutPaintVertexArray, r, l, u);
            }
            _setPaintValue(t1, e1, r, n) {
                t1.emplace(e1, r.tl[0], r.tl[1], r.br[0], r.br[1], n.tl[0], n.tl[1], n.br[0], n.br[1], r.pixelRatio, n.pixelRatio);
            }
            upload(t1) {
                this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t1.createVertexBuffer(this.zoomInPaintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t1.createVertexBuffer(this.zoomOutPaintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
            }
            constructor(t1, e1, r, n, i, s, a){
                this.expression = t1, this.type = r, this.useIntegerZoom = n, this.zoom = i, this.layerId = a, this.paintVertexAttributes = ("array" === r ? $a : ja).members;
                for(let t1 = 0; t1 < e1.length; ++t1);
                this.zoomInPaintVertexArray = new s, this.zoomOutPaintVertexArray = new s;
            }
        }
        class uo {
            getMaxValue(t1) {
                const e1 = this.binders[t1];
                return e1 instanceof ao || e1 instanceof oo ? e1.maxValue : 0;
            }
            populatePaintArrays(t1, e1, r, n, i, s) {
                for(const a in this.binders){
                    const o = this.binders[a];
                    (o instanceof ao || o instanceof oo || o instanceof lo) && o.populatePaintArray(t1, e1, r, n, i, s);
                }
            }
            setConstantPatternPositions(t1, e1) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof so && n.setConstantPatternPositions(t1, e1);
                }
            }
            updatePaintArrays(t1, e1, r, n, i, s) {
                let a = !1;
                for(const o in t1){
                    const l = e1.getPositions(o);
                    for (const e1 of l){
                        const l = r.feature(e1.index);
                        for(const r in this.binders){
                            const u = this.binders[r];
                            if ((u instanceof ao || u instanceof oo || u instanceof lo) && !0 === u.expression.isStateDependent) {
                                const c = n.paint.get(r);
                                u.expression = c.value, u.updatePaintArray(e1.start, e1.end, l, t1[o], i, s), a = !0;
                            }
                        }
                    }
                }
                return a;
            }
            defines() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    (r instanceof io || r instanceof so) && t1.push(...r.uniformNames.map((t1)=>`#define HAS_UNIFORM_${t1}`));
                }
                return t1;
            }
            getBinderAttributes() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    if (r instanceof ao || r instanceof oo || r instanceof lo) for(let e1 = 0; e1 < r.paintVertexAttributes.length; e1++)t1.push(r.paintVertexAttributes[e1].name);
                }
                return t1;
            }
            getBinderUniforms() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    if (r instanceof io || r instanceof so || r instanceof oo) for (const e1 of r.uniformNames)t1.push(e1);
                }
                return t1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t1) {
                const e1 = [];
                for(const r in this.binders){
                    const n = this.binders[r];
                    if (n instanceof io || n instanceof so || n instanceof oo) for (const i of n.uniformNames)e1.push({
                        name: i,
                        property: r,
                        binding: n.getBinding(t1, i)
                    });
                }
                return e1;
            }
            setUniforms(t1, e1, r, n, i) {
                for (const { name: e1, property: s, binding: a } of r)this.binders[s].setUniform(t1, a, i, n.get(s), e1);
            }
            updatePaintBuffers(t1) {
                this._buffers = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    if (t1 && r instanceof lo) {
                        const e1 = 2 === t1.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                        e1 && this._buffers.push(e1);
                    } else (r instanceof ao || r instanceof oo) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
                }
            }
            upload(t1) {
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    (r instanceof ao || r instanceof oo || r instanceof lo) && r.upload(t1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t1 in this.binders){
                    const e1 = this.binders[t1];
                    (e1 instanceof ao || e1 instanceof oo || e1 instanceof lo) && e1.destroy();
                }
            }
            constructor(t1, e1, r = ()=>!0){
                this.binders = {}, this._buffers = [];
                const n = [];
                for(const i in t1.paint._values){
                    if (!r(i)) continue;
                    const s = t1.paint.get(i);
                    if (!(s instanceof Us && An(s.property.specification))) continue;
                    const a = po(i, t1.type), o = s.value, l = s.property.specification.type, u = s.property.useIntegerZoom, c = s.property.specification["property-type"], h = "cross-faded" === c || "cross-faded-data-driven" === c, p = "line-dasharray" === String(i) && "constant" !== t1.layout.get("line-cap").value.kind;
                    if ("constant" !== o.kind || p) {
                        if ("source" === o.kind || p || h) {
                            const r = mo(i, l, "source");
                            this.binders[i] = h ? new lo(o, a, l, u, e1, r, t1.id) : new ao(o, a, l, r), n.push(`/a_${i}`);
                        } else {
                            const t1 = mo(i, l, "composite");
                            this.binders[i] = new oo(o, a, l, u, e1, t1), n.push(`/z_${i}`);
                        }
                    } else this.binders[i] = h ? new so(o.value, a) : new io(o.value, a, l), n.push(`/u_${i}`);
                }
                this.cacheKey = n.sort().join("");
            }
        }
        class co {
            populatePaintArrays(t1, e1, r, n, i, s, a) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t1, e1, n, i, s, a);
                void 0 !== e1.id && this._featureMap.add(e1.id, r, this._bufferOffset, t1), this._bufferOffset = t1, this.needsUpload = !0;
            }
            updatePaintArrays(t1, e1, r, n, i) {
                for (const s of r)this.needsUpload = this.programConfigurations[s.id].updatePaintArrays(t1, this._featureMap, e1, s, n, i) || this.needsUpload;
            }
            get(t1) {
                return this.programConfigurations[t1];
            }
            upload(t1) {
                if (this.needsUpload) {
                    for(const e1 in this.programConfigurations)this.programConfigurations[e1].upload(t1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
            }
            constructor(t1, e1, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of t1)this.programConfigurations[n.id] = new uo(n, e1, r);
                this.needsUpload = !1, this._featureMap = new Za, this._bufferOffset = 0;
            }
        }
        const ho = {
            "text-opacity": [
                "opacity"
            ],
            "icon-opacity": [
                "opacity"
            ],
            "text-color": [
                "fill_color"
            ],
            "icon-color": [
                "fill_color"
            ],
            "text-halo-color": [
                "halo_color"
            ],
            "icon-halo-color": [
                "halo_color"
            ],
            "text-halo-blur": [
                "halo_blur"
            ],
            "icon-halo-blur": [
                "halo_blur"
            ],
            "text-halo-width": [
                "halo_width"
            ],
            "icon-halo-width": [
                "halo_width"
            ],
            "line-gap-width": [
                "gapwidth"
            ],
            "line-pattern": [
                "pattern_to",
                "pattern_from",
                "pixel_ratio_to",
                "pixel_ratio_from"
            ],
            "fill-pattern": [
                "pattern_to",
                "pattern_from",
                "pixel_ratio_to",
                "pixel_ratio_from"
            ],
            "fill-extrusion-pattern": [
                "pattern_to",
                "pattern_from",
                "pixel_ratio_to",
                "pixel_ratio_from"
            ],
            "line-dasharray": [
                "dash_to",
                "dash_from"
            ]
        };
        function po(t1, e1) {
            return ho[t1] || [
                t1.replace(`${e1}-`, "").replace(/-/g, "_")
            ];
        }
        const fo = {
            "line-pattern": {
                source: ia,
                composite: ia
            },
            "fill-pattern": {
                source: ia,
                composite: ia
            },
            "fill-extrusion-pattern": {
                source: ia,
                composite: ia
            },
            "line-dasharray": {
                source: sa,
                composite: sa
            }
        }, yo = {
            color: {
                source: Aa,
                composite: na
            },
            number: {
                source: xa,
                composite: Aa
            }
        };
        function mo(t1, e1, r) {
            const n = fo[t1];
            return n && n[r] || yo[e1][r];
        }
        Pi(io, "ConstantBinder"), Pi(so, "CrossFadedConstantBinder"), Pi(ao, "SourceExpressionBinder"), Pi(lo, "CrossFadedCompositeBinder"), Pi(oo, "CompositeExpressionBinder"), Pi(uo, "ProgramConfiguration", {
            omit: [
                "_buffers"
            ]
        }), Pi(co, "ProgramConfigurationSet");
        const go = "-transition";
        class xo extends Nt {
            getCrossfadeParameters() {
                return this._crossfadeParameters;
            }
            getLayoutProperty(t1) {
                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
            }
            setLayoutProperty(t1, e1, r = {}) {
                null != e1 && this._validate(Mi, `layers.${this.id}.layout.${t1}`, t1, e1, r) || ("visibility" !== t1 ? this._unevaluatedLayout.setValue(t1, e1) : this.visibility = e1);
            }
            getPaintProperty(t1) {
                return I(t1, go) ? this._transitionablePaint.getTransition(t1.slice(0, -go.length)) : this._transitionablePaint.getValue(t1);
            }
            setPaintProperty(t1, e1, r = {}) {
                if (null != e1 && this._validate(Ii, `layers.${this.id}.paint.${t1}`, t1, e1, r)) return !1;
                if (I(t1, go)) return this._transitionablePaint.setTransition(t1.slice(0, -go.length), e1 || void 0), !1;
                {
                    const r = this._transitionablePaint._values[t1], n = "cross-faded-data-driven" === r.property.specification["property-type"], i = r.value.isDataDriven(), s = r.value;
                    this._transitionablePaint.setValue(t1, e1), this._handleSpecialPaintPropertyUpdate(t1);
                    const a = this._transitionablePaint._values[t1].value;
                    return a.isDataDriven() || i || n || this._handleOverridablePaintPropertyUpdate(t1, s, a);
                }
            }
            _handleSpecialPaintPropertyUpdate(t1) {}
            getProgramIds() {
                return null;
            }
            getProgramConfiguration(t1) {
                return null;
            }
            _handleOverridablePaintPropertyUpdate(t1, e1, r) {
                return !1;
            }
            isHidden(t1) {
                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(t1, e1) {
                t1.getCrossfadeParameters && (this._crossfadeParameters = t1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e1)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e1);
            }
            serialize() {
                const t1 = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return this.visibility && (t1.layout = t1.layout || {}, t1.layout.visibility = this.visibility), z(t1, (t1, e1)=>!(void 0 === t1 || "layout" === e1 && !Object.keys(t1).length || "paint" === e1 && !Object.keys(t1).length));
            }
            _validate(t1, e1, r, n, i = {}) {
                return (!i || !1 !== i.validate) && Ti(this, t1.call(ki, {
                    key: e1,
                    layerType: this.type,
                    objectKey: r,
                    value: n,
                    styleSpec: Gt,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isSky() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            resize() {}
            isStateDependent() {
                for(const t1 in this.paint._values){
                    const e1 = this.paint.get(t1);
                    if (e1 instanceof Us && An(e1.property.specification) && ("source" === e1.value.kind || "composite" === e1.value.kind) && e1.value.isStateDependent) return !0;
                }
                return !1;
            }
            compileFilter() {
                this._filterCompiled || (this._featureFilter = Jn(this.filter), this._filterCompiled = !0);
            }
            invalidateCompiledFilter() {
                this._filterCompiled = !1;
            }
            dynamicFilter() {
                return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
                return this._featureFilter.needFeature;
            }
            constructor(t1, e1){
                if (super(), this.id = t1.id, this.type = t1.type, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    needFeature: !1
                }, this._filterCompiled = !1, "custom" !== t1.type && (this.metadata = t1.metadata, this.minzoom = t1.minzoom, this.maxzoom = t1.maxzoom, "background" !== t1.type && "sky" !== t1.type && (this.source = t1.source, this.sourceLayer = t1["source-layer"], this.filter = t1.filter), e1.layout && (this._unevaluatedLayout = new Rs(e1.layout)), e1.paint)) {
                    this._transitionablePaint = new Vs(e1.paint);
                    for(const e1 in t1.paint)this.setPaintProperty(e1, t1.paint[e1], {
                        validate: !1
                    });
                    for(const e1 in t1.layout)this.setLayoutProperty(e1, t1.layout[e1], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new js(e1.paint);
                }
            }
        }
        const vo = Ws([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), bo = Ws([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]);
        class _o {
            prepareSegment(t1, e1, r, n) {
                let i = this.segments[this.segments.length - 1];
                return t1 > _o.MAX_VERTEX_ARRAY_LENGTH && E(`Max vertices per segment is ${_o.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t1}`), (!i || i.vertexLength + t1 > _o.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                    vertexOffset: e1.length,
                    primitiveOffset: r.length,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t1 of this.segments)for(const e1 in t1.vaos)t1.vaos[e1].destroy();
            }
            static simpleSegment(t1, e1, r, n) {
                return new _o([
                    {
                        vertexOffset: t1,
                        primitiveOffset: e1,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
            constructor(t1 = []){
                this.segments = t1;
            }
        }
        _o.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Pi(_o, "SegmentVector");
        var wo = 8192;
        class Ao {
            setNorthEast(t1) {
                return this._ne = t1 instanceof ko ? new ko(t1.lng, t1.lat) : ko.convert(t1), this;
            }
            setSouthWest(t1) {
                return this._sw = t1 instanceof ko ? new ko(t1.lng, t1.lat) : ko.convert(t1), this;
            }
            extend(t1) {
                const e1 = this._sw, r = this._ne;
                let n, i;
                if (t1 instanceof ko) n = t1, i = t1;
                else {
                    if (!(t1 instanceof Ao)) return Array.isArray(t1) ? 4 === t1.length || t1.every(Array.isArray) ? this.extend(Ao.convert(t1)) : this.extend(ko.convert(t1)) : this;
                    if (n = t1._sw, i = t1._ne, !n || !i) return this;
                }
                return e1 || r ? (e1.lng = Math.min(n.lng, e1.lng), e1.lat = Math.min(n.lat, e1.lat), r.lng = Math.max(i.lng, r.lng), r.lat = Math.max(i.lat, r.lat)) : (this._sw = new ko(n.lng, n.lat), this._ne = new ko(i.lng, i.lat)), this;
            }
            getCenter() {
                return new ko((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new ko(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new ko(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(t1) {
                const { lng: e1, lat: r } = ko.convert(t1);
                let n = this._sw.lng <= e1 && e1 <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (n = this._sw.lng >= e1 && e1 >= this._ne.lng), this._sw.lat <= r && r <= this._ne.lat && n;
            }
            static convert(t1) {
                return !t1 || t1 instanceof Ao ? t1 : new Ao(t1);
            }
            constructor(t1, e1){
                t1 && (e1 ? this.setSouthWest(t1).setNorthEast(e1) : 4 === t1.length ? this.setSouthWest([
                    t1[0],
                    t1[1]
                ]).setNorthEast([
                    t1[2],
                    t1[3]
                ]) : this.setSouthWest(t1[0]).setNorthEast(t1[1]));
            }
        }
        const So = 6371008.8;
        class ko {
            wrap() {
                return new ko(m(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t1) {
                const e1 = Math.PI / 180, r = this.lat * e1, n = t1.lat * e1, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e1);
                return So * Math.acos(Math.min(i, 1));
            }
            toBounds(t1 = 0) {
                const e1 = 360 * t1 / 40075017, r = e1 / Math.cos(Math.PI / 180 * this.lat);
                return new Ao(new ko(this.lng - r, this.lat - e1), new ko(this.lng + r, this.lat + e1));
            }
            static convert(t1) {
                if (t1 instanceof ko) return t1;
                if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new ko(Number(t1[0]), Number(t1[1]));
                if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new ko(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
            constructor(t1, e1){
                if (isNaN(t1) || isNaN(e1)) throw new Error(`Invalid LngLat object: (${t1}, ${e1})`);
                if (this.lng = +t1, this.lat = +e1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
        }
        const Io = 2 * Math.PI * So;
        function Mo(t1) {
            return Io * Math.cos(t1 * Math.PI / 180);
        }
        function zo(t1) {
            return (180 + t1) / 360;
        }
        function To(t1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
        }
        function Bo(t1, e1) {
            return t1 / Mo(e1);
        }
        function Eo(t1) {
            return 360 * t1 - 180;
        }
        function Co(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        function Po(t1, e1) {
            return t1 * Mo(Co(e1));
        }
        const Do = 85.051129;
        function Vo(t1) {
            return 1 / Math.cos(t1 * Math.PI / 180);
        }
        class Fo {
            static fromLngLat(t1, e1 = 0) {
                const r = ko.convert(t1);
                return new Fo(zo(r.lng), To(r.lat), Bo(e1, r.lat));
            }
            toLngLat() {
                return new ko(Eo(this.x), Co(this.y));
            }
            toAltitude() {
                return Po(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                return 1 / Io * Vo(Co(this.y));
            }
            constructor(t1, e1, r = 0){
                this.x = +t1, this.y = +e1, this.z = +r;
            }
        }
        function Lo(t1, e1, r, n, s, a, o, l, u) {
            const c = (e1 + n) / 2, h = (r + s) / 2, p = new i(c, h);
            l(p), function(t1, e1, r, n, i, s) {
                const a = r - i, o = n - s;
                return Math.abs((n - e1) * a - (r - t1) * o) / Math.hypot(a, o);
            }(p.x, p.y, a.x, a.y, o.x, o.y) >= u ? (Lo(t1, e1, r, c, h, a, p, l, u), Lo(t1, c, h, n, s, p, o, l, u)) : t1.push(o);
        }
        function Ro(t1, e1, r) {
            let n = t1[0], i = n.x, s = n.y;
            e1(n);
            const a = [
                n
            ];
            for(let o = 1; o < t1.length; o++){
                const l = t1[o], { x: u, y: c } = l;
                e1(l), Lo(a, i, s, u, c, n, l, e1, r), i = u, s = c, n = l;
            }
            return a;
        }
        function Uo(t1, e1, r, n, i) {
            if (i(e1, r)) {
                const s = e1.add(r).mult(.5);
                n(s), Uo(t1, e1, s, n, i), Uo(t1, s, r, n, i);
            } else t1.push(r);
        }
        function jo(t1, e1, r) {
            let n = t1[0];
            e1(n);
            const i = [
                n
            ];
            for(let s = 1; s < t1.length; s++){
                const a = t1[s];
                e1(a), Uo(i, n, a, e1, r), n = a;
            }
            return i;
        }
        const $o = Math.pow(2, 14) - 1, Oo = -$o - 1;
        function qo(t1, e1) {
            const r = Math.round(t1.x * e1), n = Math.round(t1.y * e1);
            return t1.x = d(r, Oo, $o), t1.y = d(n, Oo, $o), (r < t1.x || r > t1.x + 1 || n < t1.y || n > t1.y + 1) && E("Geometry exceeds allowed extent, reduce your vector tile buffer size"), t1;
        }
        function No(t1, e1, r) {
            const n = t1.loadGeometry(), i = t1.extent, s = wo / i;
            if (e1 && r && r.projection.isReprojectedInTileSpace) {
                const s = 1 << e1.z, { scale: a, x: o, y: l, projection: u } = r, c = (t1)=>{
                    const r = Eo((e1.x + t1.x / i) / s), n = Co((e1.y + t1.y / i) / s), c = u.project(r, n);
                    t1.x = (c.x * a - o) * i, t1.y = (c.y * a - l) * i;
                };
                for(let e1 = 0; e1 < n.length; e1++)if (1 !== t1.type) n[e1] = Ro(n[e1], c, 1);
                else {
                    const t1 = [];
                    for (const r of n[e1])r.x < 0 || r.x >= i || r.y < 0 || r.y >= i || (c(r), t1.push(r));
                    n[e1] = t1;
                }
            }
            for (const t1 of n)for (const e1 of t1)qo(e1, s);
            return n;
        }
        function Go(t1, e1) {
            return {
                type: t1.type,
                id: t1.id,
                properties: t1.properties,
                geometry: e1 ? No(t1) : []
            };
        }
        function Zo(t1, e1, r, n, i) {
            t1.emplaceBack(2 * e1 + (n + 1) / 2, 2 * r + (i + 1) / 2);
        }
        function Xo(t1, e1, r) {
            const n = 16384;
            t1.emplaceBack(e1.x, e1.y, e1.z, r[0] * n, r[1] * n, r[2] * n);
        }
        class Ko {
            populate(t1, e1, r, n) {
                const i = this.layers[0], s = [];
                let a = null;
                "circle" === i.type && (a = i.layout.get("circle-sort-key"));
                for (const { feature: e1, id: i, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = Go(e1, t1);
                    if (!this.layers[0]._featureFilter.filter(new Cs(this.zoom), u, r)) continue;
                    const c = a ? a.evaluate(u, {}, r) : void 0, h = {
                        id: i,
                        properties: e1.properties,
                        type: e1.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : No(e1, r, n),
                        patterns: {},
                        sortKey: c
                    };
                    s.push(h);
                }
                a && s.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                let o = null;
                "globe" === n.projection.name && (this.globeExtVertexArray = new Ua, o = n.projection);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n, l = t1[s].feature;
                    this.addFeature(n, i, s, e1.availableImages, r, o), e1.featureIndex.insert(l, i, s, a, this.index);
                }
            }
            update(t1, e1, r, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, vo.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = t1.createVertexBuffer(this.globeExtVertexArray, bo.members))), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
            }
            addFeature(t1, e1, r, n, i, s) {
                for (const r of e1)for (const e1 of r){
                    const r = e1.x, n = e1.y;
                    if (r < 0 || r >= wo || n < 0 || n >= wo) continue;
                    if (s) {
                        const t1 = s.projectTilePoint(r, n, i), e1 = s.upVector(i, r, n), a = this.globeExtVertexArray;
                        Xo(a, t1, e1), Xo(a, t1, e1), Xo(a, t1, e1), Xo(a, t1, e1);
                    }
                    const a = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), o = a.vertexLength;
                    Zo(this.layoutVertexArray, r, n, -1, -1), Zo(this.layoutVertexArray, r, n, 1, -1), Zo(this.layoutVertexArray, r, n, 1, 1), Zo(this.layoutVertexArray, r, n, -1, 1), this.indexArray.emplaceBack(o, o + 1, o + 2), this.indexArray.emplaceBack(o, o + 2, o + 3), a.vertexLength += 4, a.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n, i);
            }
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.projection = t1.projection, this.layoutVertexArray = new Qs, this.indexArray = new ya, this.segments = new _o, this.programConfigurations = new co(t1.layers, t1.zoom), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
        }
        function Ho(t1, e1) {
            for(let r = 0; r < t1.length; r++)if (il(e1, t1[r])) return !0;
            for(let r = 0; r < e1.length; r++)if (il(t1, e1[r])) return !0;
            return !!Qo(t1, e1);
        }
        function Yo(t1, e1, r) {
            return !!il(t1, e1) || !!el(e1, t1, r);
        }
        function Wo(t1, e1) {
            if (1 === t1.length) return nl(e1, t1[0]);
            for(let r = 0; r < e1.length; r++){
                const n = e1[r];
                for(let e1 = 0; e1 < n.length; e1++)if (il(t1, n[e1])) return !0;
            }
            for(let r = 0; r < t1.length; r++)if (nl(e1, t1[r])) return !0;
            for(let r = 0; r < e1.length; r++)if (Qo(t1, e1[r])) return !0;
            return !1;
        }
        function Jo(t1, e1, r) {
            if (t1.length > 1) {
                if (Qo(t1, e1)) return !0;
                for(let n = 0; n < e1.length; n++)if (el(e1[n], t1, r)) return !0;
            }
            for(let n = 0; n < t1.length; n++)if (el(t1[n], e1, r)) return !0;
            return !1;
        }
        function Qo(t1, e1) {
            if (0 === t1.length || 0 === e1.length) return !1;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1];
                for(let t1 = 0; t1 < e1.length - 1; t1++)if (tl(n, i, e1[t1], e1[t1 + 1])) return !0;
            }
            return !1;
        }
        function tl(t1, e1, r, n) {
            return C(t1, r, n) !== C(e1, r, n) && C(t1, e1, r) !== C(t1, e1, n);
        }
        function el(t1, e1, r) {
            const n = r * r;
            if (1 === e1.length) return t1.distSqr(e1[0]) < n;
            for(let r = 1; r < e1.length; r++)if (rl(t1, e1[r - 1], e1[r]) < n) return !0;
            return !1;
        }
        function rl(t1, e1, r) {
            const n = e1.distSqr(r);
            if (0 === n) return t1.distSqr(e1);
            const i = ((t1.x - e1.x) * (r.x - e1.x) + (t1.y - e1.y) * (r.y - e1.y)) / n;
            return t1.distSqr(i < 0 ? e1 : i > 1 ? r : r.sub(e1)._mult(i)._add(e1));
        }
        function nl(t1, e1) {
            let r, n, i, s = !1;
            for(let a = 0; a < t1.length; a++){
                r = t1[a];
                for(let t1 = 0, a = r.length - 1; t1 < r.length; a = t1++)n = r[t1], i = r[a], n.y > e1.y != i.y > e1.y && e1.x < (i.x - n.x) * (e1.y - n.y) / (i.y - n.y) + n.x && (s = !s);
            }
            return s;
        }
        function il(t1, e1) {
            let r = !1;
            for(let n = 0, i = t1.length - 1; n < t1.length; i = n++){
                const s = t1[n], a = t1[i];
                s.y > e1.y != a.y > e1.y && e1.x < (a.x - s.x) * (e1.y - s.y) / (a.y - s.y) + s.x && (r = !r);
            }
            return r;
        }
        function sl(t1, e1, r, n, s) {
            for (const i of t1)if (e1 <= i.x && r <= i.y && n >= i.x && s >= i.y) return !0;
            const a = [
                new i(e1, r),
                new i(e1, s),
                new i(n, s),
                new i(n, r)
            ];
            if (t1.length > 2) {
                for (const e1 of a)if (il(t1, e1)) return !0;
            }
            for(let e1 = 0; e1 < t1.length - 1; e1++)if (al(t1[e1], t1[e1 + 1], a)) return !0;
            return !1;
        }
        function al(t1, e1, r) {
            const n = r[0], i = r[2];
            if (t1.x < n.x && e1.x < n.x || t1.x > i.x && e1.x > i.x || t1.y < n.y && e1.y < n.y || t1.y > i.y && e1.y > i.y) return !1;
            const s = C(t1, e1, r[0]);
            return s !== C(t1, e1, r[1]) || s !== C(t1, e1, r[2]) || s !== C(t1, e1, r[3]);
        }
        function ol(t1, e1, r) {
            const n = e1.paint.get(t1).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e1.id).getMaxValue(t1);
        }
        function ll(t1) {
            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
        }
        function ul(t1, e1, r, n, s) {
            if (!e1[0] && !e1[1]) return t1;
            const a = i.convert(e1)._mult(s);
            "viewport" === r && a._rotate(-n);
            const o = [];
            for(let e1 = 0; e1 < t1.length; e1++)o.push(t1[e1].sub(a));
            return o;
        }
        function cl(t1, e1, r, n) {
            const s = i.convert(t1)._mult(n);
            return "viewport" === e1 && s._rotate(-r), s;
        }
        Pi(Ko, "CircleBucket", {
            omit: [
                "layers"
            ]
        });
        const hl = new Zs({
            "circle-sort-key": new Os(Gt.layout_circle["circle-sort-key"])
        });
        var pl = {
            paint: new Zs({
                "circle-radius": new Os(Gt.paint_circle["circle-radius"]),
                "circle-color": new Os(Gt.paint_circle["circle-color"]),
                "circle-blur": new Os(Gt.paint_circle["circle-blur"]),
                "circle-opacity": new Os(Gt.paint_circle["circle-opacity"]),
                "circle-translate": new $s(Gt.paint_circle["circle-translate"]),
                "circle-translate-anchor": new $s(Gt.paint_circle["circle-translate-anchor"]),
                "circle-pitch-scale": new $s(Gt.paint_circle["circle-pitch-scale"]),
                "circle-pitch-alignment": new $s(Gt.paint_circle["circle-pitch-alignment"]),
                "circle-stroke-width": new Os(Gt.paint_circle["circle-stroke-width"]),
                "circle-stroke-color": new Os(Gt.paint_circle["circle-stroke-color"]),
                "circle-stroke-opacity": new Os(Gt.paint_circle["circle-stroke-opacity"])
            }),
            layout: hl
        }, fl = 1e-6, dl = "undefined" != typeof Float32Array ? Float32Array : Array;
        function yl() {
            var t1 = new dl(9);
            return dl != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[0] = 1, t1[4] = 1, t1[8] = 1, t1;
        }
        function ml(t1) {
            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }
        function gl(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], s = e1[3], a = e1[4], o = e1[5], l = e1[6], u = e1[7], c = e1[8], h = e1[9], p = e1[10], f = e1[11], d = e1[12], y = e1[13], m = e1[14], g = e1[15], x = r * o - n * a, v = r * l - i * a, b = r * u - s * a, _ = n * l - i * o, w = n * u - s * o, A = i * u - s * l, S = c * y - h * d, k = c * m - p * d, I = c * g - f * d, M = h * m - p * y, z = h * g - f * y, T = p * g - f * m, B = x * T - v * z + b * M + _ * I - w * k + A * S;
            return B ? (t1[0] = (o * T - l * z + u * M) * (B = 1 / B), t1[1] = (i * z - n * T - s * M) * B, t1[2] = (y * A - m * w + g * _) * B, t1[3] = (p * w - h * A - f * _) * B, t1[4] = (l * I - a * T - u * k) * B, t1[5] = (r * T - i * I + s * k) * B, t1[6] = (m * b - d * A - g * v) * B, t1[7] = (c * A - p * b + f * v) * B, t1[8] = (a * z - o * I + u * S) * B, t1[9] = (n * I - r * z - s * S) * B, t1[10] = (d * w - y * b + g * x) * B, t1[11] = (h * b - c * w - f * x) * B, t1[12] = (o * k - a * M - l * S) * B, t1[13] = (r * M - n * k + i * S) * B, t1[14] = (y * v - d * _ - m * x) * B, t1[15] = (c * _ - h * v + p * x) * B, t1) : null;
        }
        function xl(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3], o = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = e1[9], f = e1[10], d = e1[11], y = e1[12], m = e1[13], g = e1[14], x = e1[15], v = r[0], b = r[1], _ = r[2], w = r[3];
            return t1[0] = v * n + b * o + _ * h + w * y, t1[1] = v * i + b * l + _ * p + w * m, t1[2] = v * s + b * u + _ * f + w * g, t1[3] = v * a + b * c + _ * d + w * x, t1[4] = (v = r[4]) * n + (b = r[5]) * o + (_ = r[6]) * h + (w = r[7]) * y, t1[5] = v * i + b * l + _ * p + w * m, t1[6] = v * s + b * u + _ * f + w * g, t1[7] = v * a + b * c + _ * d + w * x, t1[8] = (v = r[8]) * n + (b = r[9]) * o + (_ = r[10]) * h + (w = r[11]) * y, t1[9] = v * i + b * l + _ * p + w * m, t1[10] = v * s + b * u + _ * f + w * g, t1[11] = v * a + b * c + _ * d + w * x, t1[12] = (v = r[12]) * n + (b = r[13]) * o + (_ = r[14]) * h + (w = r[15]) * y, t1[13] = v * i + b * l + _ * p + w * m, t1[14] = v * s + b * u + _ * f + w * g, t1[15] = v * a + b * c + _ * d + w * x, t1;
        }
        function vl(t1, e1, r) {
            var n, i, s, a, o, l, u, c, h, p, f, d, y = r[0], m = r[1], g = r[2];
            return e1 === t1 ? (t1[12] = e1[0] * y + e1[4] * m + e1[8] * g + e1[12], t1[13] = e1[1] * y + e1[5] * m + e1[9] * g + e1[13], t1[14] = e1[2] * y + e1[6] * m + e1[10] * g + e1[14], t1[15] = e1[3] * y + e1[7] * m + e1[11] * g + e1[15]) : (i = e1[1], s = e1[2], a = e1[3], o = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = e1[9], f = e1[10], d = e1[11], t1[0] = n = e1[0], t1[1] = i, t1[2] = s, t1[3] = a, t1[4] = o, t1[5] = l, t1[6] = u, t1[7] = c, t1[8] = h, t1[9] = p, t1[10] = f, t1[11] = d, t1[12] = n * y + o * m + h * g + e1[12], t1[13] = i * y + l * m + p * g + e1[13], t1[14] = s * y + u * m + f * g + e1[14], t1[15] = a * y + c * m + d * g + e1[15]), t1;
        }
        function bl(t1, e1, r) {
            var n = r[0], i = r[1], s = r[2];
            return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * s, t1[9] = e1[9] * s, t1[10] = e1[10] * s, t1[11] = e1[11] * s, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
        }
        function _l(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e1[4], a = e1[5], o = e1[6], l = e1[7], u = e1[8], c = e1[9], h = e1[10], p = e1[11];
            return e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[4] = s * i + u * n, t1[5] = a * i + c * n, t1[6] = o * i + h * n, t1[7] = l * i + p * n, t1[8] = u * i - s * n, t1[9] = c * i - a * n, t1[10] = h * i - o * n, t1[11] = p * i - l * n, t1;
        }
        function wl(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e1[0], a = e1[1], o = e1[2], l = e1[3], u = e1[8], c = e1[9], h = e1[10], p = e1[11];
            return e1 !== t1 && (t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = s * i - u * n, t1[1] = a * i - c * n, t1[2] = o * i - h * n, t1[3] = l * i - p * n, t1[8] = s * n + u * i, t1[9] = a * n + c * i, t1[10] = o * n + h * i, t1[11] = l * n + p * i, t1;
        }
        function Al(t1, e1) {
            return t1[0] = e1[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = e1[1], t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = e1[2], t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }
        function Sl(t1, e1, r) {
            var n, i, s, a = r[0], o = r[1], l = r[2], u = Math.hypot(a, o, l);
            return u < fl ? null : (a *= u = 1 / u, o *= u, l *= u, n = Math.sin(e1), i = Math.cos(e1), t1[0] = a * a * (s = 1 - i) + i, t1[1] = o * a * s + l * n, t1[2] = l * a * s - o * n, t1[3] = 0, t1[4] = a * o * s - l * n, t1[5] = o * o * s + i, t1[6] = l * o * s + a * n, t1[7] = 0, t1[8] = a * l * s + o * n, t1[9] = o * l * s - a * n, t1[10] = l * l * s + i, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1);
        }
        Math.hypot || (Math.hypot = function() {
            for(var t1 = 0, e1 = arguments.length; e1--;)t1 += arguments[e1] * arguments[e1];
            return Math.sqrt(t1);
        });
        var kl = xl;
        function Il() {
            var t1 = new dl(3);
            return dl != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1;
        }
        function Ml(t1) {
            var e1 = new dl(3);
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1;
        }
        function zl(t1) {
            return Math.hypot(t1[0], t1[1], t1[2]);
        }
        function Tl(t1, e1, r) {
            var n = new dl(3);
            return n[0] = t1, n[1] = e1, n[2] = r, n;
        }
        function Bl(t1, e1, r) {
            return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1;
        }
        function El(t1, e1, r) {
            return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1;
        }
        function Cl(t1, e1, r) {
            return t1[0] = e1[0] * r[0], t1[1] = e1[1] * r[1], t1[2] = e1[2] * r[2], t1;
        }
        function Pl(t1, e1, r) {
            return t1[0] = Math.min(e1[0], r[0]), t1[1] = Math.min(e1[1], r[1]), t1[2] = Math.min(e1[2], r[2]), t1;
        }
        function Dl(t1, e1, r) {
            return t1[0] = Math.max(e1[0], r[0]), t1[1] = Math.max(e1[1], r[1]), t1[2] = Math.max(e1[2], r[2]), t1;
        }
        function Vl(t1, e1, r) {
            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1;
        }
        function Fl(t1, e1, r, n) {
            return t1[0] = e1[0] + r[0] * n, t1[1] = e1[1] + r[1] * n, t1[2] = e1[2] + r[2] * n, t1;
        }
        function Ll(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], s = r * r + n * n + i * i;
            return s > 0 && (s = 1 / Math.sqrt(s)), t1[0] = e1[0] * s, t1[1] = e1[1] * s, t1[2] = e1[2] * s, t1;
        }
        function Rl(t1, e1) {
            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2];
        }
        function Ul(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2], a = r[0], o = r[1], l = r[2];
            return t1[0] = i * l - s * o, t1[1] = s * a - n * l, t1[2] = n * o - i * a, t1;
        }
        function jl(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2], a = r[3] * n + r[7] * i + r[11] * s + r[15];
            return t1[0] = (r[0] * n + r[4] * i + r[8] * s + r[12]) / (a = a || 1), t1[1] = (r[1] * n + r[5] * i + r[9] * s + r[13]) / a, t1[2] = (r[2] * n + r[6] * i + r[10] * s + r[14]) / a, t1;
        }
        function $l(t1, e1, r) {
            var n = r[0], i = r[1], s = r[2], a = e1[0], o = e1[1], l = e1[2], u = i * l - s * o, c = s * a - n * l, h = n * o - i * a, p = i * h - s * c, f = s * u - n * h, d = n * c - i * u, y = 2 * r[3];
            return c *= y, h *= y, f *= 2, d *= 2, t1[0] = a + (u *= y) + (p *= 2), t1[1] = o + c + f, t1[2] = l + h + d, t1;
        }
        var Ol, ql = El, Nl = Cl, Gl = zl;
        function Zl(t1, e1, r) {
            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1[3] = e1[3] * r, t1;
        }
        function Xl(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3];
            return t1[0] = r[0] * n + r[4] * i + r[8] * s + r[12] * a, t1[1] = r[1] * n + r[5] * i + r[9] * s + r[13] * a, t1[2] = r[2] * n + r[6] * i + r[10] * s + r[14] * a, t1[3] = r[3] * n + r[7] * i + r[11] * s + r[15] * a, t1;
        }
        function Kl() {
            var t1 = new dl(4);
            return dl != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1[3] = 1, t1;
        }
        function Hl(t1) {
            return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1;
        }
        function Yl(t1, e1, r) {
            r *= .5;
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3], o = Math.sin(r), l = Math.cos(r);
            return t1[0] = n * l + a * o, t1[1] = i * l + s * o, t1[2] = s * l - i * o, t1[3] = a * l - n * o, t1;
        }
        function Wl(t1, e1, r) {
            r *= .5;
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3], o = Math.sin(r), l = Math.cos(r);
            return t1[0] = n * l - s * o, t1[1] = i * l + a * o, t1[2] = s * l + n * o, t1[3] = a * l - i * o, t1;
        }
        Il(), Ol = new dl(4), dl != Float32Array && (Ol[0] = 0, Ol[1] = 0, Ol[2] = 0, Ol[3] = 0), Il(), Tl(1, 0, 0), Tl(0, 1, 0), Kl(), Kl(), yl();
        class Jl {
            intersectsPlane(t1, e1, r) {
                const n = Rl(e1, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const i = ((t1[0] - this.pos[0]) * e1[0] + (t1[1] - this.pos[1]) * e1[1] + (t1[2] - this.pos[2]) * e1[2]) / n;
                return r[0] = this.pos[0] + this.dir[0] * i, r[1] = this.pos[1] + this.dir[1] * i, r[2] = this.pos[2] + this.dir[2] * i, !0;
            }
            closestPointOnSphere(t1, e1, r) {
                if (function(t1, e1) {
                    var r = t1[0], n = t1[1], i = t1[2], s = e1[0], a = e1[1], o = e1[2];
                    return Math.abs(r - s) <= fl * Math.max(1, Math.abs(r), Math.abs(s)) && Math.abs(n - a) <= fl * Math.max(1, Math.abs(n), Math.abs(a)) && Math.abs(i - o) <= fl * Math.max(1, Math.abs(i), Math.abs(o));
                }(this.pos, t1) || 0 === e1) return r[0] = r[1] = r[2] = 0, !1;
                const [n, i, s] = this.dir, a = this.pos[0] - t1[0], o = this.pos[1] - t1[1], l = this.pos[2] - t1[2], u = n * n + i * i + s * s, c = 2 * (a * n + o * i + l * s), h = c * c - 4 * u * (a * a + o * o + l * l - e1 * e1);
                if (h < 0) {
                    const t1 = Math.max(-c / 2, 0), u = a + n * t1, h = o + i * t1, p = l + s * t1, f = Math.hypot(u, h, p);
                    return r[0] = u * e1 / f, r[1] = h * e1 / f, r[2] = p * e1 / f, !1;
                }
                {
                    const t1 = (-c - Math.sqrt(h)) / (2 * u);
                    if (t1 < 0) {
                        const t1 = Math.hypot(a, o, l);
                        return r[0] = a * e1 / t1, r[1] = o * e1 / t1, r[2] = l * e1 / t1, !1;
                    }
                    return r[0] = a + n * t1, r[1] = o + i * t1, r[2] = l + s * t1, !0;
                }
            }
            constructor(t1, e1){
                this.pos = t1, this.dir = e1;
            }
        }
        class Ql {
            static fromInvProjectionMatrix(t1, e1, r) {
                const n = [
                    -1,
                    1,
                    1
                ], i = [
                    1,
                    1,
                    1
                ], s = [
                    1,
                    -1,
                    1
                ], a = [
                    -1,
                    -1,
                    1
                ], o = jl(n, n, t1), l = jl(i, i, t1), u = jl(s, s, t1), c = jl(a, a, t1);
                return new Ql(o, l, u, c, e1 / r);
            }
            constructor(t1, e1, r, n, i){
                this.TL = t1, this.TR = e1, this.BR = r, this.BL = n, this.horizon = i;
            }
        }
        class tu {
            static fromInvProjectionMatrix(t1, e1, r, n) {
                const i = Math.pow(2, r), s = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((r)=>{
                    const s = Xl([], r, t1), a = 1 / s[3] / e1 * i;
                    return function(t1, e1, r) {
                        return t1[0] = e1[0] * r[0], t1[1] = e1[1] * r[1], t1[2] = e1[2] * r[2], t1[3] = e1[3] * r[3], t1;
                    }(s, s, [
                        a,
                        a,
                        n ? 1 / s[3] : a,
                        a
                    ]);
                }), a = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((t1)=>{
                    const e1 = Ll([], Ul([], ql([], s[t1[0]], s[t1[1]]), ql([], s[t1[2]], s[t1[1]]))), r = -Rl(e1, s[t1[1]]);
                    return e1.concat(r);
                });
                return new tu(s, a);
            }
            constructor(t1, e1){
                this.points = t1, this.planes = e1;
            }
        }
        class eu {
            static fromPoints(t1) {
                const e1 = [
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE
                ], r = [
                    Number.MIN_VALUE,
                    Number.MIN_VALUE,
                    Number.MIN_VALUE
                ];
                for (const n of t1)e1[0] = Math.min(e1[0], n[0]), e1[1] = Math.min(e1[1], n[1]), e1[2] = Math.min(e1[2], n[2]), r[0] = Math.max(r[0], n[0]), r[1] = Math.max(r[1], n[1]), r[2] = Math.max(r[2], n[2]);
                return new eu(e1, r);
            }
            quadrant(t1) {
                const e1 = [
                    t1 % 2 == 0,
                    t1 < 2
                ], r = Ml(this.min), n = Ml(this.max);
                for(let t1 = 0; t1 < e1.length; t1++)r[t1] = e1[t1] ? this.min[t1] : this.center[t1], n[t1] = e1[t1] ? this.center[t1] : this.max[t1];
                return n[2] = this.max[2], new eu(r, n);
            }
            distanceX(t1) {
                return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
            }
            distanceY(t1) {
                return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
            }
            distanceZ(t1) {
                return Math.max(Math.min(this.max[2], t1[2]), this.min[2]) - t1[2];
            }
            getCorners() {
                const t1 = this.min, e1 = this.max;
                return [
                    [
                        t1[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e1[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e1[0],
                        e1[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        e1[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        t1[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t1[0],
                        e1[1],
                        e1[2]
                    ]
                ];
            }
            intersects(t1) {
                const e1 = this.getCorners();
                let r = !0;
                for(let n = 0; n < t1.planes.length; n++){
                    const i = t1.planes[n];
                    let s = 0;
                    for(let t1 = 0; t1 < e1.length; t1++)s += Rl(i, e1[t1]) + i[3] >= 0;
                    if (0 === s) return 0;
                    s !== e1.length && (r = !1);
                }
                if (r) return 2;
                for(let e1 = 0; e1 < 3; e1++){
                    let r = Number.MAX_VALUE, n = -Number.MAX_VALUE;
                    for(let i = 0; i < t1.points.length; i++){
                        const s = t1.points[i][e1] - this.min[e1];
                        r = Math.min(r, s), n = Math.max(n, s);
                    }
                    if (n < 0 || r > this.max[e1] - this.min[e1]) return 0;
                }
                return 1;
            }
            constructor(t1, e1){
                this.min = t1, this.max = e1, this.center = Vl([], Bl([], this.min, this.max), .5);
            }
        }
        function ru(t1, e1, r, n, i, s, a, o, l) {
            if (s && t1.queryGeometry.isAboveHorizon) return !1;
            s && (l *= t1.pixelToTileUnitsFactor);
            const u = t1.tileID.canonical, c = r.projection.upVectorScale(u, r.center.lat, r.worldSize).metersToTile;
            for (const h of e1)for (const e1 of h){
                const h = e1.add(o), p = i && r.elevation ? r.elevation.exaggeration() * i.getElevationAt(h.x, h.y, !0) : 0, f = r.projection.projectTilePoint(h.x, h.y, u);
                if (p > 0) {
                    const t1 = r.projection.upVector(u, h.x, h.y);
                    f.x += t1[0] * c * p, f.y += t1[1] * c * p, f.z += t1[2] * c * p;
                }
                const d = s ? h : nu(f.x, f.y, f.z, n), y = s ? t1.tilespaceRays.map((t1)=>au(t1, p)) : t1.queryGeometry.screenGeometry, m = Xl([], [
                    f.x,
                    f.y,
                    f.z,
                    1
                ], n);
                if (!a && s ? l *= m[3] / r.cameraToCenterDistance : a && !s && (l *= r.cameraToCenterDistance / m[3]), s) {
                    const t1 = Co((e1.y / wo + u.y) / (1 << u.z));
                    l /= r.projection.pixelsPerMeter(t1, 1) / Bo(1, t1);
                }
                if (Yo(y, d, l)) return !0;
            }
            return !1;
        }
        function nu(t1, e1, r, n) {
            const s = Xl([], [
                t1,
                e1,
                r,
                1
            ], n);
            return new i(s[0] / s[3], s[1] / s[3]);
        }
        const iu = Tl(0, 0, 0), su = Tl(0, 0, 1);
        function au(t1, e1) {
            const r = Il();
            return iu[2] = e1, t1.intersectsPlane(iu, su, r), new i(r[0], r[1]);
        }
        class ou extends Ko {
        }
        function lu(t1, { width: e1, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e1 * r * n) throw new RangeError("mismatched image size");
            } else i = new Uint8Array(e1 * r * n);
            return t1.width = e1, t1.height = r, t1.data = i, t1;
        }
        function uu(t1, e1, r) {
            const { width: n, height: i } = e1;
            n === t1.width && i === t1.height || (cu(t1, e1, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t1.width, n),
                height: Math.min(t1.height, i)
            }, r), t1.width = n, t1.height = i, t1.data = e1.data);
        }
        function cu(t1, e1, r, n, i, s) {
            if (0 === i.width || 0 === i.height) return e1;
            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e1.width || i.height > e1.height || n.x > e1.width - i.width || n.y > e1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const a = t1.data, o = e1.data;
            for(let l = 0; l < i.height; l++){
                const u = ((r.y + l) * t1.width + r.x) * s, c = ((n.y + l) * e1.width + n.x) * s;
                for(let t1 = 0; t1 < i.width * s; t1++)o[c + t1] = a[u + t1];
            }
            return e1;
        }
        Pi(ou, "HeatmapBucket", {
            omit: [
                "layers"
            ]
        });
        class hu {
            resize(t1) {
                uu(this, new hu(t1), 1);
            }
            clone() {
                return new hu({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e1, r, n, i) {
                cu(t1, e1, r, n, i, 1);
            }
            constructor(t1, e1){
                lu(this, t1, 1, e1);
            }
        }
        class pu {
            resize(t1) {
                uu(this, new pu(t1), 4);
            }
            replace(t1, e1) {
                e1 ? this.data.set(t1) : this.data = t1 instanceof Uint8ClampedArray ? new Uint8Array(t1.buffer) : t1;
            }
            clone() {
                return new pu({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e1, r, n, i) {
                cu(t1, e1, r, n, i, 4);
            }
            constructor(t1, e1){
                lu(this, t1, 4, e1);
            }
        }
        Pi(hu, "AlphaImage"), Pi(pu, "RGBAImage");
        var fu = {
            paint: new Zs({
                "heatmap-radius": new Os(Gt.paint_heatmap["heatmap-radius"]),
                "heatmap-weight": new Os(Gt.paint_heatmap["heatmap-weight"]),
                "heatmap-intensity": new $s(Gt.paint_heatmap["heatmap-intensity"]),
                "heatmap-color": new Gs(Gt.paint_heatmap["heatmap-color"]),
                "heatmap-opacity": new $s(Gt.paint_heatmap["heatmap-opacity"])
            })
        };
        function du(t1) {
            const e1 = {}, r = t1.resolution || 256, n = t1.clips ? t1.clips.length : 1, i = t1.image || new pu({
                width: r,
                height: n
            }), s = (r, n, s)=>{
                e1[t1.evaluationKey] = s;
                const a = t1.expression.evaluate(e1);
                i.data[r + n + 0] = Math.floor(255 * a.r / a.a), i.data[r + n + 1] = Math.floor(255 * a.g / a.a), i.data[r + n + 2] = Math.floor(255 * a.b / a.a), i.data[r + n + 3] = Math.floor(255 * a.a);
            };
            if (t1.clips) for(let e1 = 0, i = 0; e1 < n; ++e1, i += 4 * r)for(let n = 0, a = 0; n < r; n++, a += 4){
                const o = n / (r - 1), { start: l, end: u } = t1.clips[e1];
                s(i, a, l * (1 - o) + u * o);
            }
            else for(let t1 = 0, e1 = 0; t1 < r; t1++, e1 += 4)s(0, e1, t1 / (r - 1));
            return i;
        }
        var yu = {
            paint: new Zs({
                "hillshade-illumination-direction": new $s(Gt.paint_hillshade["hillshade-illumination-direction"]),
                "hillshade-illumination-anchor": new $s(Gt.paint_hillshade["hillshade-illumination-anchor"]),
                "hillshade-exaggeration": new $s(Gt.paint_hillshade["hillshade-exaggeration"]),
                "hillshade-shadow-color": new $s(Gt.paint_hillshade["hillshade-shadow-color"]),
                "hillshade-highlight-color": new $s(Gt.paint_hillshade["hillshade-highlight-color"]),
                "hillshade-accent-color": new $s(Gt.paint_hillshade["hillshade-accent-color"])
            })
        };
        const mu = Ws([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: gu } = mu;
        var xu = bu, vu = bu;
        function bu(t1, e1, r) {
            r = r || 2;
            var n, i, s, a, o, l, u, c = e1 && e1.length, h = c ? e1[0] * r : t1.length, p = _u(t1, 0, h, r, !0), f = [];
            if (!p || p.next === p.prev) return f;
            if (c && (p = function(t1, e1, r, n) {
                var i, s, a, o = [];
                for(i = 0, s = e1.length; i < s; i++)(a = _u(t1, e1[i] * n, i < s - 1 ? e1[i + 1] * n : t1.length, n, !1)) === a.next && (a.steiner = !0), o.push(Cu(a));
                for(o.sort(zu), i = 0; i < o.length; i++)r = Tu(o[i], r);
                return r;
            }(t1, e1, p, r)), t1.length > 80 * r) {
                n = s = t1[0], i = a = t1[1];
                for(var d = r; d < h; d += r)(o = t1[d]) < n && (n = o), (l = t1[d + 1]) < i && (i = l), o > s && (s = o), l > a && (a = l);
                u = 0 !== (u = Math.max(s - n, a - i)) ? 32767 / u : 0;
            }
            return Au(p, f, r, n, i, u, 0), f;
        }
        function _u(t1, e1, r, n, i) {
            var s, a;
            if (i === Gu(t1, e1, r, n) > 0) for(s = e1; s < r; s += n)a = Ou(s, t1[s], t1[s + 1], a);
            else for(s = r - n; s >= e1; s -= n)a = Ou(s, t1[s], t1[s + 1], a);
            return a && Fu(a, a.next) && (qu(a), a = a.next), a;
        }
        function wu(t1, e1) {
            if (!t1) return t1;
            e1 || (e1 = t1);
            var r, n = t1;
            do if (r = !1, n.steiner || !Fu(n, n.next) && 0 !== Vu(n.prev, n, n.next)) n = n.next;
            else {
                if (qu(n), (n = e1 = n.prev) === n.next) break;
                r = !0;
            }
            while (r || n !== e1);
            return e1;
        }
        function Au(t1, e1, r, n, i, s, a) {
            if (t1) {
                !a && s && function(t1, e1, r, n) {
                    var i = t1;
                    do 0 === i.z && (i.z = Eu(i.x, i.y, e1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                    while (i !== t1);
                    i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                        var e1, r, n, i, s, a, o, l, u = 1;
                        do {
                            for(r = t1, t1 = null, s = null, a = 0; r;){
                                for(a++, n = r, o = 0, e1 = 0; e1 < u && (o++, n = n.nextZ); e1++);
                                for(l = u; o > 0 || l > 0 && n;)0 !== o && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, o--) : (i = n, n = n.nextZ, l--), s ? s.nextZ = i : t1 = i, i.prevZ = s, s = i;
                                r = n;
                            }
                            s.nextZ = null, u *= 2;
                        }while (a > 1);
                    }(i);
                }(t1, n, i, s);
                for(var o, l, u = t1; t1.prev !== t1.next;)if (o = t1.prev, l = t1.next, s ? ku(t1, n, i, s) : Su(t1)) e1.push(o.i / r | 0), e1.push(t1.i / r | 0), e1.push(l.i / r | 0), qu(t1), t1 = l.next, u = l.next;
                else if ((t1 = l) === u) {
                    a ? 1 === a ? Au(t1 = Iu(wu(t1), e1, r), e1, r, n, i, s, 2) : 2 === a && Mu(t1, e1, r, n, i, s) : Au(wu(t1), e1, r, n, i, s, 1);
                    break;
                }
            }
        }
        function Su(t1) {
            var e1 = t1.prev, r = t1, n = t1.next;
            if (Vu(e1, r, n) >= 0) return !1;
            for(var i = e1.x, s = r.x, a = n.x, o = e1.y, l = r.y, u = n.y, c = i < s ? i < a ? i : a : s < a ? s : a, h = o < l ? o < u ? o : u : l < u ? l : u, p = i > s ? i > a ? i : a : s > a ? s : a, f = o > l ? o > u ? o : u : l > u ? l : u, d = n.next; d !== e1;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && Pu(i, o, s, l, a, u, d.x, d.y) && Vu(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function ku(t1, e1, r, n) {
            var i = t1.prev, s = t1, a = t1.next;
            if (Vu(i, s, a) >= 0) return !1;
            for(var o = i.x, l = s.x, u = a.x, c = i.y, h = s.y, p = a.y, f = o < l ? o < u ? o : u : l < u ? l : u, d = c < h ? c < p ? c : p : h < p ? h : p, y = o > l ? o > u ? o : u : l > u ? l : u, m = c > h ? c > p ? c : p : h > p ? h : p, g = Eu(f, d, e1, r, n), x = Eu(y, m, e1, r, n), v = t1.prevZ, b = t1.nextZ; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== a && Pu(o, c, l, h, u, p, v.x, v.y) && Vu(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== a && Pu(o, c, l, h, u, p, b.x, b.y) && Vu(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== a && Pu(o, c, l, h, u, p, v.x, v.y) && Vu(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== a && Pu(o, c, l, h, u, p, b.x, b.y) && Vu(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function Iu(t1, e1, r) {
            var n = t1;
            do {
                var i = n.prev, s = n.next.next;
                !Fu(i, s) && Lu(i, n, n.next, s) && ju(i, s) && ju(s, i) && (e1.push(i.i / r | 0), e1.push(n.i / r | 0), e1.push(s.i / r | 0), qu(n), qu(n.next), n = t1 = s), n = n.next;
            }while (n !== t1);
            return wu(n);
        }
        function Mu(t1, e1, r, n, i, s) {
            var a = t1;
            do {
                for(var o = a.next.next; o !== a.prev;){
                    if (a.i !== o.i && Du(a, o)) {
                        var l = $u(a, o);
                        return a = wu(a, a.next), l = wu(l, l.next), Au(a, e1, r, n, i, s, 0), void Au(l, e1, r, n, i, s, 0);
                    }
                    o = o.next;
                }
                a = a.next;
            }while (a !== t1);
        }
        function zu(t1, e1) {
            return t1.x - e1.x;
        }
        function Tu(t1, e1) {
            var r = function(t1, e1) {
                var r, n = e1, i = t1.x, s = t1.y, a = -1 / 0;
                do {
                    if (s <= n.y && s >= n.next.y && n.next.y !== n.y) {
                        var o = n.x + (s - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (o <= i && o > a && (a = o, r = n.x < n.next.x ? n : n.next, o === i)) return r;
                    }
                    n = n.next;
                }while (n !== e1);
                if (!r) return null;
                var l, u = r, c = r.x, h = r.y, p = 1 / 0;
                n = r;
                do i >= n.x && n.x >= c && i !== n.x && Pu(s < h ? i : a, s, c, h, s < h ? a : i, s, n.x, n.y) && (l = Math.abs(s - n.y) / (i - n.x), ju(n, t1) && (l < p || l === p && (n.x > r.x || n.x === r.x && Bu(r, n))) && (r = n, p = l)), n = n.next;
                while (n !== u);
                return r;
            }(t1, e1);
            if (!r) return e1;
            var n = $u(r, t1);
            return wu(n, n.next), wu(r, r.next);
        }
        function Bu(t1, e1) {
            return Vu(t1.prev, t1, e1.prev) < 0 && Vu(e1.next, t1, t1.next) < 0;
        }
        function Eu(t1, e1, r, n, i) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - r) * i | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - n) * i | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
        }
        function Cu(t1) {
            var e1 = t1, r = t1;
            do (e1.x < r.x || e1.x === r.x && e1.y < r.y) && (r = e1), e1 = e1.next;
            while (e1 !== t1);
            return r;
        }
        function Pu(t1, e1, r, n, i, s, a, o) {
            return (i - a) * (e1 - o) >= (t1 - a) * (s - o) && (t1 - a) * (n - o) >= (r - a) * (e1 - o) && (r - a) * (s - o) >= (i - a) * (n - o);
        }
        function Du(t1, e1) {
            return t1.next.i !== e1.i && t1.prev.i !== e1.i && !function(t1, e1) {
                var r = t1;
                do {
                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e1.i && r.next.i !== e1.i && Lu(r, r.next, t1, e1)) return !0;
                    r = r.next;
                }while (r !== t1);
                return !1;
            }(t1, e1) && (ju(t1, e1) && ju(e1, t1) && function(t1, e1) {
                var r = t1, n = !1, i = (t1.x + e1.x) / 2, s = (t1.y + e1.y) / 2;
                do r.y > s != r.next.y > s && r.next.y !== r.y && i < (r.next.x - r.x) * (s - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t1);
                return n;
            }(t1, e1) && (Vu(t1.prev, t1, e1.prev) || Vu(t1, e1.prev, e1)) || Fu(t1, e1) && Vu(t1.prev, t1, t1.next) > 0 && Vu(e1.prev, e1, e1.next) > 0);
        }
        function Vu(t1, e1, r) {
            return (e1.y - t1.y) * (r.x - e1.x) - (e1.x - t1.x) * (r.y - e1.y);
        }
        function Fu(t1, e1) {
            return t1.x === e1.x && t1.y === e1.y;
        }
        function Lu(t1, e1, r, n) {
            var i = Uu(Vu(t1, e1, r)), s = Uu(Vu(t1, e1, n)), a = Uu(Vu(r, n, t1)), o = Uu(Vu(r, n, e1));
            return i !== s && a !== o || !(0 !== i || !Ru(t1, r, e1)) || !(0 !== s || !Ru(t1, n, e1)) || !(0 !== a || !Ru(r, t1, n)) || !(0 !== o || !Ru(r, e1, n));
        }
        function Ru(t1, e1, r) {
            return e1.x <= Math.max(t1.x, r.x) && e1.x >= Math.min(t1.x, r.x) && e1.y <= Math.max(t1.y, r.y) && e1.y >= Math.min(t1.y, r.y);
        }
        function Uu(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function ju(t1, e1) {
            return Vu(t1.prev, t1, t1.next) < 0 ? Vu(t1, e1, t1.next) >= 0 && Vu(t1, t1.prev, e1) >= 0 : Vu(t1, e1, t1.prev) < 0 || Vu(t1, t1.next, e1) < 0;
        }
        function $u(t1, e1) {
            var r = new Nu(t1.i, t1.x, t1.y), n = new Nu(e1.i, e1.x, e1.y), i = t1.next, s = e1.prev;
            return t1.next = e1, e1.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, s.next = n, n.prev = s, n;
        }
        function Ou(t1, e1, r, n) {
            var i = new Nu(t1, e1, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function qu(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function Nu(t1, e1, r) {
            this.i = t1, this.x = e1, this.y = r, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        function Gu(t1, e1, r, n) {
            for(var i = 0, s = e1, a = r - n; s < r; s += n)i += (t1[a] - t1[s]) * (t1[s + 1] + t1[a + 1]), a = s;
            return i;
        }
        function Zu(t1, e1, r, n, i) {
            Xu(t1, e1, r || 0, n || t1.length - 1, i || Hu);
        }
        function Xu(t1, e1, r, n, i) {
            for(; n > r;){
                if (n - r > 600) {
                    var s = n - r + 1, a = e1 - r + 1, o = Math.log(s), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (s - l) / s) * (a - s / 2 < 0 ? -1 : 1);
                    Xu(t1, e1, Math.max(r, Math.floor(e1 - a * l / s + u)), Math.min(n, Math.floor(e1 + (s - a) * l / s + u)), i);
                }
                var c = t1[e1], h = r, p = n;
                for(Ku(t1, r, e1), i(t1[n], c) > 0 && Ku(t1, r, n); h < p;){
                    for(Ku(t1, h, p), h++, p--; i(t1[h], c) < 0;)h++;
                    for(; i(t1[p], c) > 0;)p--;
                }
                0 === i(t1[r], c) ? Ku(t1, r, p) : Ku(t1, ++p, n), p <= e1 && (r = p + 1), e1 <= p && (n = p - 1);
            }
        }
        function Ku(t1, e1, r) {
            var n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        function Hu(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function Yu(t1, e1) {
            const r = t1.length;
            if (r <= 1) return [
                t1
            ];
            const n = [];
            let i, s;
            for(let e1 = 0; e1 < r; e1++){
                const r = P(t1[e1]);
                0 !== r && (t1[e1].area = Math.abs(r), void 0 === s && (s = r < 0), s === r < 0 ? (i && n.push(i), i = [
                    t1[e1]
                ]) : i.push(t1[e1]));
            }
            if (i && n.push(i), e1 > 1) for(let t1 = 0; t1 < n.length; t1++)n[t1].length <= e1 || (Zu(n[t1], e1, 1, n[t1].length - 1, Wu), n[t1] = n[t1].slice(0, e1));
            return n;
        }
        function Wu(t1, e1) {
            return e1.area - t1.area;
        }
        function Ju(t1, e1, r) {
            const n = r.patternDependencies;
            let i = !1;
            for (const r of e1){
                const e1 = r.paint.get(`${t1}-pattern`);
                e1.isConstant() || (i = !0);
                const s = e1.constantOr(null);
                s && (i = !0, n[s.to] = !0, n[s.from] = !0);
            }
            return i;
        }
        function Qu(t1, e1, r, n, i) {
            const s = i.patternDependencies;
            for (const a of e1){
                const e1 = a.paint.get(`${t1}-pattern`).value;
                if ("constant" !== e1.kind) {
                    let t1 = e1.evaluate({
                        zoom: n - 1
                    }, r, {}, i.availableImages), o = e1.evaluate({
                        zoom: n
                    }, r, {}, i.availableImages), l = e1.evaluate({
                        zoom: n + 1
                    }, r, {}, i.availableImages);
                    t1 = t1 && t1.name ? t1.name : t1, o = o && o.name ? o.name : o, l = l && l.name ? l.name : l, s[t1] = !0, s[o] = !0, s[l] = !0, r.patterns[a.id] = {
                        min: t1,
                        mid: o,
                        max: l
                    };
                }
            }
            return r;
        }
        bu.deviation = function(t1, e1, r, n) {
            var i = e1 && e1.length, s = Math.abs(Gu(t1, 0, i ? e1[0] * r : t1.length, r));
            if (i) for(var a = 0, o = e1.length; a < o; a++)s -= Math.abs(Gu(t1, e1[a] * r, a < o - 1 ? e1[a + 1] * r : t1.length, r));
            var l = 0;
            for(a = 0; a < n.length; a += 3){
                var u = n[a] * r, c = n[a + 1] * r, h = n[a + 2] * r;
                l += Math.abs((t1[u] - t1[h]) * (t1[c + 1] - t1[u + 1]) - (t1[u] - t1[c]) * (t1[h + 1] - t1[u + 1]));
            }
            return 0 === s && 0 === l ? 0 : Math.abs((l - s) / s);
        }, bu.flatten = function(t1) {
            for(var e1 = t1[0][0].length, r = {
                vertices: [],
                holes: [],
                dimensions: e1
            }, n = 0, i = 0; i < t1.length; i++){
                for(var s = 0; s < t1[i].length; s++)for(var a = 0; a < e1; a++)r.vertices.push(t1[i][s][a]);
                i > 0 && r.holes.push(n += t1[i - 1].length);
            }
            return r;
        }, xu.default = vu;
        class tc {
            populate(t1, e1, r, n) {
                this.hasPattern = Ju("fill", this.layers, e1);
                const i = this.layers[0].layout.get("fill-sort-key"), s = [];
                for (const { feature: a, id: o, index: l, sourceLayerIndex: u } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, c = Go(a, t1);
                    if (!this.layers[0]._featureFilter.filter(new Cs(this.zoom), c, r)) continue;
                    const h = i ? i.evaluate(c, {}, r, e1.availableImages) : void 0, p = {
                        id: o,
                        properties: a.properties,
                        type: a.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t1 ? c.geometry : No(a, r, n),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(p);
                }
                i && s.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    if (this.hasPattern) {
                        const t1 = Qu("fill", this.layers, n, this.zoom, e1);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, s, r, {}, e1.availableImages);
                    e1.featureIndex.insert(t1[s].feature, i, s, a, this.index);
                }
            }
            update(t1, e1, r, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r, n);
            }
            addFeatures(t1, e1, r, n, i) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e1, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, gu), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.indexBuffer2 = t1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(t1, e1, r, n, i, s = []) {
                for (const t1 of Yu(e1, 500)){
                    let e1 = 0;
                    for (const r of t1)e1 += r.length;
                    const r = this.segments.prepareSegment(e1, this.layoutVertexArray, this.indexArray), n = r.vertexLength, i = [], s = [];
                    for (const e1 of t1){
                        if (0 === e1.length) continue;
                        e1 !== t1[0] && s.push(i.length / 2);
                        const r = this.segments2.prepareSegment(e1.length, this.layoutVertexArray, this.indexArray2), n = r.vertexLength;
                        this.layoutVertexArray.emplaceBack(e1[0].x, e1[0].y), this.indexArray2.emplaceBack(n + e1.length - 1, n), i.push(e1[0].x), i.push(e1[0].y);
                        for(let t1 = 1; t1 < e1.length; t1++)this.layoutVertexArray.emplaceBack(e1[t1].x, e1[t1].y), this.indexArray2.emplaceBack(n + t1 - 1, n + t1), i.push(e1[t1].x), i.push(e1[t1].y);
                        r.vertexLength += e1.length, r.primitiveLength += e1.length;
                    }
                    const a = xu(i, s);
                    for(let t1 = 0; t1 < a.length; t1 += 3)this.indexArray.emplaceBack(n + a[t1], n + a[t1 + 1], n + a[t1 + 2]);
                    r.vertexLength += e1, r.primitiveLength += a.length / 3;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, s, n);
            }
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new Qs, this.indexArray = new ya, this.indexArray2 = new _a, this.programConfigurations = new co(t1.layers, t1.zoom), this.segments = new _o, this.segments2 = new _o, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.projection = t1.projection;
            }
        }
        Pi(tc, "FillBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        const ec = new Zs({
            "fill-sort-key": new Os(Gt.layout_fill["fill-sort-key"])
        });
        var rc = {
            paint: new Zs({
                "fill-antialias": new $s(Gt.paint_fill["fill-antialias"]),
                "fill-opacity": new Os(Gt.paint_fill["fill-opacity"]),
                "fill-color": new Os(Gt.paint_fill["fill-color"]),
                "fill-outline-color": new Os(Gt.paint_fill["fill-outline-color"]),
                "fill-translate": new $s(Gt.paint_fill["fill-translate"]),
                "fill-translate-anchor": new $s(Gt.paint_fill["fill-translate-anchor"]),
                "fill-pattern": new qs(Gt.paint_fill["fill-pattern"])
            }),
            layout: ec
        };
        const nc = Ws([
            {
                name: "a_pos_normal_ed",
                components: 4,
                type: "Int16"
            }
        ]), ic = Ws([
            {
                name: "a_centroid_pos",
                components: 2,
                type: "Uint16"
            }
        ]), sc = Ws([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), { members: ac } = nc;
        var oc = lc;
        function lc(t1, e1, r, n, i) {
            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = n, this._values = i, t1.readFields(uc, this, e1);
        }
        function uc(t1, e1, r) {
            1 == t1 ? e1.id = r.readVarint() : 2 == t1 ? function(t1, e1) {
                for(var r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = e1._keys[t1.readVarint()], i = e1._values[t1.readVarint()];
                    e1.properties[n] = i;
                }
            }(r, e1) : 3 == t1 ? e1.type = r.readVarint() : 4 == t1 && (e1._geometry = r.pos);
        }
        function cc(t1) {
            for(var e1, r, n = 0, i = 0, s = t1.length, a = s - 1; i < s; a = i++)n += ((r = t1[a]).x - (e1 = t1[i]).x) * (e1.y + r.y);
            return n;
        }
        lc.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], lc.prototype.loadGeometry = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1, r = t1.readVarint() + t1.pos, n = 1, s = 0, a = 0, o = 0, l = []; t1.pos < r;){
                if (s <= 0) {
                    var u = t1.readVarint();
                    n = 7 & u, s = u >> 3;
                }
                if (s--, 1 === n || 2 === n) a += t1.readSVarint(), o += t1.readSVarint(), 1 === n && (e1 && l.push(e1), e1 = []), e1.push(new i(a, o));
                else {
                    if (7 !== n) throw new Error("unknown command " + n);
                    e1 && e1.push(e1[0].clone());
                }
            }
            return e1 && l.push(e1), l;
        }, lc.prototype.bbox = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1 = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, s = 0, a = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0; t1.pos < e1;){
                if (n <= 0) {
                    var c = t1.readVarint();
                    r = 7 & c, n = c >> 3;
                }
                if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < a && (a = i), i > o && (o = i), (s += t1.readSVarint()) < l && (l = s), s > u && (u = s);
                else if (7 !== r) throw new Error("unknown command " + r);
            }
            return [
                a,
                l,
                o,
                u
            ];
        }, lc.prototype.toGeoJSON = function(t1, e1, r) {
            var n, i, s = this.extent * Math.pow(2, r), a = this.extent * t1, o = this.extent * e1, l = this.loadGeometry(), u = lc.types[this.type];
            function c(t1) {
                for(var e1 = 0; e1 < t1.length; e1++){
                    var r = t1[e1];
                    t1[e1] = [
                        360 * (r.x + a) / s - 180,
                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + o) / s) * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var h = [];
                    for(n = 0; n < l.length; n++)h[n] = l[n][0];
                    c(l = h);
                    break;
                case 2:
                    for(n = 0; n < l.length; n++)c(l[n]);
                    break;
                case 3:
                    for(l = function(t1) {
                        var e1 = t1.length;
                        if (e1 <= 1) return [
                            t1
                        ];
                        for(var r, n, i = [], s = 0; s < e1; s++){
                            var a = cc(t1[s]);
                            0 !== a && (void 0 === n && (n = a < 0), n === a < 0 ? (r && i.push(r), r = [
                                t1[s]
                            ]) : r.push(t1[s]));
                        }
                        return r && i.push(r), i;
                    }(l), n = 0; n < l.length; n++)for(i = 0; i < l[n].length; i++)c(l[n][i]);
            }
            1 === l.length ? l = l[0] : u = "Multi" + u;
            var p = {
                type: "Feature",
                geometry: {
                    type: u,
                    coordinates: l
                },
                properties: this.properties
            };
            return "id" in this && (p.id = this.id), p;
        };
        var hc = pc;
        function pc(t1, e1) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(fc, this, e1), this.length = this._features.length;
        }
        function fc(t1, e1, r) {
            15 === t1 ? e1.version = r.readVarint() : 1 === t1 ? e1.name = r.readString() : 5 === t1 ? e1.extent = r.readVarint() : 2 === t1 ? e1._features.push(r.pos) : 3 === t1 ? e1._keys.push(r.readString()) : 4 === t1 && e1._values.push(function(t1) {
                for(var e1 = null, r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = t1.readVarint() >> 3;
                    e1 = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                }
                return e1;
            }(r));
        }
        function dc(t1, e1, r) {
            if (3 === t1) {
                var n = new hc(r, r.readVarint() + r.pos);
                n.length && (e1[n.name] = n);
            }
        }
        pc.prototype.feature = function(t1) {
            if (t1 < 0 || t1 >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[t1];
            var e1 = this._pbf.readVarint() + this._pbf.pos;
            return new oc(this._pbf, e1, this.extent, this._keys, this._values);
        };
        var yc = {
            VectorTile: function(t1, e1) {
                this.layers = t1.readFields(dc, {}, e1);
            },
            VectorTileFeature: oc,
            VectorTileLayer: hc
        };
        function mc(t1, e1, r, n) {
            const s = [], a = 0 === n ? (t1, e1, r, n, s, a)=>{
                t1.push(new i(a, r + (a - e1) / (n - e1) * (s - r)));
            } : (t1, e1, r, n, s, a)=>{
                t1.push(new i(e1 + (a - r) / (s - r) * (n - e1), a));
            };
            for (const i of t1){
                const t1 = [];
                for (const s of i){
                    if (s.length <= 2) continue;
                    const i = [];
                    for(let t1 = 0; t1 < s.length - 1; t1++){
                        const o = s[t1].x, l = s[t1].y, u = s[t1 + 1].x, c = s[t1 + 1].y, h = 0 === n ? o : l, p = 0 === n ? u : c;
                        h < e1 ? p > e1 && a(i, o, l, u, c, e1) : h > r ? p < r && a(i, o, l, u, c, r) : i.push(s[t1]), p < e1 && h >= e1 && a(i, o, l, u, c, e1), p > r && h <= r && a(i, o, l, u, c, r);
                    }
                    let o = s[s.length - 1];
                    const l = 0 === n ? o.x : o.y;
                    l >= e1 && l <= r && i.push(o), i.length && (o = i[i.length - 1], i[0].x === o.x && i[0].y === o.y || i.push(i[0]), t1.push(i));
                }
                t1.length && s.push(t1);
            }
            return s;
        }
        const gc = yc.VectorTileFeature.types, xc = Math.pow(2, 13);
        function vc(t1, e1, r, n, i, s, a, o) {
            t1.emplaceBack((e1 << 1) + a, (r << 1) + s, (Math.floor(n * xc) << 1) + i, Math.round(o));
        }
        function bc(t1, e1, r) {
            const n = 16384;
            t1.emplaceBack(e1.x, e1.y, e1.z, r[0] * n, r[1] * n, r[2] * n);
        }
        class _c {
            startRing(t1) {
                this.currentPolyCount = {
                    edges: 0,
                    top: 0
                }, this.polyCount.push(this.currentPolyCount), this.min || (this.min = new i(t1.x, t1.y), this.max = new i(t1.x, t1.y));
            }
            append(t1, e1) {
                this.currentPolyCount.edges++, this.acc._add(t1);
                const r = this.min, n = this.max;
                t1.x < r.x ? r.x = t1.x : t1.x > n.x && (n.x = t1.x), t1.y < r.y ? r.y = t1.y : t1.y > n.y && (n.y = t1.y), ((0 === t1.x || t1.x === wo) && t1.x === e1.x) != ((0 === t1.y || t1.y === wo) && t1.y === e1.y) && this.processBorderOverlap(t1, e1), e1.x < 0 != t1.x < 0 && this.addBorderIntersection(0, xr(e1.y, t1.y, (0 - e1.x) / (t1.x - e1.x))), e1.x > wo != t1.x > wo && this.addBorderIntersection(1, xr(e1.y, t1.y, (wo - e1.x) / (t1.x - e1.x))), e1.y < 0 != t1.y < 0 && this.addBorderIntersection(2, xr(e1.x, t1.x, (0 - e1.y) / (t1.y - e1.y))), e1.y > wo != t1.y > wo && this.addBorderIntersection(3, xr(e1.x, t1.x, (wo - e1.y) / (t1.y - e1.y)));
            }
            addBorderIntersection(t1, e1) {
                this.borders || (this.borders = [
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ]
                ]);
                const r = this.borders[t1];
                e1 < r[0] && (r[0] = e1), e1 > r[1] && (r[1] = e1);
            }
            processBorderOverlap(t1, e1) {
                if (t1.x === e1.x) {
                    if (t1.y === e1.y) return;
                    const r = 0 === t1.x ? 0 : 1;
                    this.addBorderIntersection(r, e1.y), this.addBorderIntersection(r, t1.y);
                } else {
                    const r = 0 === t1.y ? 2 : 3;
                    this.addBorderIntersection(r, e1.x), this.addBorderIntersection(r, t1.x);
                }
            }
            centroid() {
                const t1 = this.polyCount.reduce((t1, e1)=>t1 + e1.edges, 0);
                return 0 !== t1 ? this.acc.div(t1)._round() : new i(0, 0);
            }
            span() {
                return new i(this.max.x - this.min.x, this.max.y - this.min.y);
            }
            intersectsCount() {
                return this.borders.reduce((t1, e1)=>t1 + +(e1[0] !== Number.MAX_VALUE), 0);
            }
            constructor(){
                this.acc = new i(0, 0), this.polyCount = [];
            }
        }
        class wc {
            populate(t1, e1, r, n) {
                this.features = [], this.hasPattern = Ju("fill-extrusion", this.layers, e1), this.featuresOnBorder = [], this.borders = [
                    [],
                    [],
                    [],
                    []
                ], this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ], this.tileToMeter = function(t1) {
                    const e1 = Math.exp(Math.PI * (1 - t1.y / (1 << t1.z) * 2));
                    return 80150034 * e1 / (e1 * e1 + 1) / wo / (1 << t1.z);
                }(r), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter;
                for (const { feature: i, id: s, index: a, sourceLayerIndex: o } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, l = Go(i, t1);
                    if (!this.layers[0]._featureFilter.filter(new Cs(this.zoom), l, r)) continue;
                    const u = {
                        id: s,
                        sourceLayerIndex: o,
                        index: a,
                        geometry: t1 ? l.geometry : No(i, r, n),
                        properties: i.properties,
                        type: i.type,
                        patterns: {}
                    }, c = this.layoutVertexArray.length;
                    this.hasPattern ? this.features.push(Qu("fill-extrusion", this.layers, u, this.zoom, e1)) : this.addFeature(u, u.geometry, a, r, {}, e1.availableImages, n), e1.featureIndex.insert(i, u.geometry, a, o, this.index, c);
                }
                this.sortBorders();
            }
            addFeatures(t1, e1, r, n, i) {
                for (const t1 of this.features){
                    const { geometry: s } = t1;
                    this.addFeature(t1, s, t1.index, e1, r, n, i);
                }
                this.sortBorders();
            }
            update(t1, e1, r, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, ac), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = t1.createVertexBuffer(this.layoutVertexExtArray, sc.members, !0))), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            uploadCentroid(t1) {
                0 !== this.centroidVertexArray.length && (this.centroidVertexBuffer ? this.needsCentroidUpdate && this.centroidVertexBuffer.updateData(this.centroidVertexArray) : this.centroidVertexBuffer = t1.createVertexBuffer(this.centroidVertexArray, ic.members, !0), this.needsCentroidUpdate = !1);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t1, e1, r, n, s, a, o) {
                const l = [
                    new i(0, 0),
                    new i(wo, wo)
                ], u = o.projection, c = "globe" === u.name, h = this.enableTerrain && !c ? new _c : null, p = "Polygon" === gc[t1.type];
                c && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new ka);
                const f = Yu(e1, 500);
                for(let t1 = f.length - 1; t1 >= 0; t1--){
                    const e1 = f[t1];
                    (0 === e1.length || (d = e1[0]).every((t1)=>t1.x <= 0) || d.every((t1)=>t1.x >= wo) || d.every((t1)=>t1.y <= 0) || d.every((t1)=>t1.y >= wo)) && f.splice(t1, 1);
                }
                var d;
                let y;
                if (c) y = Bc(f, l, n);
                else {
                    y = [];
                    for (const t1 of f)y.push({
                        polygon: t1,
                        bounds: l
                    });
                }
                const m = p ? this.edgeRadius : 0;
                for (const { polygon: t1, bounds: e1 } of y){
                    let r = 0, i = 0;
                    for (const e1 of t1)p && !e1[0].equals(e1[e1.length - 1]) && e1.push(e1[0]), i += p ? e1.length - 1 : e1.length;
                    const s = this.segments.prepareSegment((p ? 5 : 4) * i, this.layoutVertexArray, this.indexArray);
                    if (p) {
                        const e1 = [], i = [];
                        r = s.vertexLength;
                        for (const r of t1){
                            let a, o;
                            r.length && r !== t1[0] && i.push(e1.length / 2), a = r[1].sub(r[0])._perp()._unit();
                            for(let t1 = 1; t1 < r.length; t1++){
                                const i = r[t1], l = r[t1 === r.length - 1 ? 1 : t1 + 1];
                                let { x: h, y: p } = i;
                                if (m) {
                                    o = l.sub(i)._perp()._unit();
                                    const t1 = a.add(o)._unit(), e1 = m * Math.min(4, 1 / (a.x * t1.x + a.y * t1.y));
                                    h += e1 * t1.x, p += e1 * t1.y, a = o;
                                }
                                vc(this.layoutVertexArray, h, p, 0, 0, 1, 1, 0), s.vertexLength++, e1.push(i.x, i.y), c && bc(this.layoutVertexExtArray, u.projectTilePoint(h, p, n), u.upVector(n, h, p));
                            }
                        }
                        const a = xu(e1, i);
                        for(let t1 = 0; t1 < a.length; t1 += 3)this.indexArray.emplaceBack(r + a[t1], r + a[t1 + 2], r + a[t1 + 1]), s.primitiveLength++;
                    }
                    for (const i of t1){
                        h && i.length && h.startRing(i[0]);
                        let t1, a, o, l = i.length > 4 && Mc(i[i.length - 2], i[0], i[1]), f = m ? Sc(i[i.length - 2], i[0], i[1], m) : 0;
                        a = i[1].sub(i[0])._perp()._unit();
                        for(let d = 1, y = 0; d < i.length; d++){
                            let g = i[d - 1], x = i[d];
                            const v = i[d === i.length - 1 ? 1 : d + 1];
                            if (h && p && h.currentPolyCount.top++, Ic(x, g, e1)) {
                                m && (a = v.sub(x)._perp()._unit());
                                continue;
                            }
                            h && h.append(x, g);
                            const b = x.sub(g)._perp(), _ = b.x / (Math.abs(b.x) + Math.abs(b.y)), w = b.y > 0 ? 1 : 0, A = g.dist(x);
                            if (y + A > 32768 && (y = 0), m) {
                                o = v.sub(x)._perp()._unit();
                                let t1 = kc(g, x, v, Ac(a, o), m);
                                isNaN(t1) && (t1 = 0);
                                const e1 = x.sub(g)._unit();
                                g = g.add(e1.mult(f))._round(), x = x.add(e1.mult(-t1))._round(), f = t1, a = o;
                            }
                            const S = s.vertexLength, k = i.length > 4 && Mc(g, x, v);
                            let I = zc(y, l, !0);
                            if (vc(this.layoutVertexArray, g.x, g.y, _, w, 0, 0, I), vc(this.layoutVertexArray, g.x, g.y, _, w, 0, 1, I), y += A, I = zc(y, k, !1), l = k, vc(this.layoutVertexArray, x.x, x.y, _, w, 0, 0, I), vc(this.layoutVertexArray, x.x, x.y, _, w, 0, 1, I), s.vertexLength += 4, this.indexArray.emplaceBack(S + 0, S + 1, S + 2), this.indexArray.emplaceBack(S + 1, S + 3, S + 2), s.primitiveLength += 2, m) {
                                const n = r + (1 === d ? i.length - 2 : d - 2), a = 1 === d ? r : n + 1;
                                if (this.indexArray.emplaceBack(S + 1, n, S + 3), this.indexArray.emplaceBack(n, a, S + 3), s.primitiveLength += 2, void 0 === t1 && (t1 = S), !Ic(v, i[d], e1)) {
                                    const e1 = d === i.length - 1 ? t1 : s.vertexLength;
                                    this.indexArray.emplaceBack(S + 2, S + 3, e1), this.indexArray.emplaceBack(S + 3, e1 + 1, e1), this.indexArray.emplaceBack(S + 3, a, e1 + 1), s.primitiveLength += 3;
                                }
                            }
                            if (c) {
                                const t1 = this.layoutVertexExtArray, e1 = u.projectTilePoint(g.x, g.y, n), r = u.projectTilePoint(x.x, x.y, n), i = u.upVector(n, g.x, g.y), s = u.upVector(n, x.x, x.y);
                                bc(t1, e1, i), bc(t1, e1, i), bc(t1, r, s), bc(t1, r, s);
                            }
                        }
                        p && (r += i.length - 1);
                    }
                }
                if (h && h.polyCount.length > 0) {
                    if (h.borders) {
                        h.vertexArrayOffset = this.centroidVertexArray.length;
                        const t1 = h.borders, e1 = this.featuresOnBorder.push(h) - 1;
                        for(let r = 0; r < 4; r++)t1[r][0] !== Number.MAX_VALUE && this.borders[r].push(e1);
                    }
                    this.encodeCentroid(h.borders ? void 0 : h.centroid(), h);
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, s, a, n);
            }
            sortBorders() {
                for(let t1 = 0; t1 < 4; t1++)this.borders[t1].sort((e1, r)=>this.featuresOnBorder[e1].borders[t1][0] - this.featuresOnBorder[r].borders[t1][0]);
            }
            encodeCentroid(t1, e1, r = !0) {
                let n, i;
                if (t1) {
                    if (0 !== t1.y) {
                        const r = e1.span()._mult(this.tileToMeter);
                        n = (Math.max(t1.x, 1) << 3) + Math.min(7, Math.round(r.x / 10)), i = (Math.max(t1.y, 1) << 3) + Math.min(7, Math.round(r.y / 10));
                    } else n = Math.ceil(7 * (t1.x + 450)), i = 0;
                } else n = 0, i = +r;
                let s = r ? this.centroidVertexArray.length : e1.vertexArrayOffset;
                for (const t1 of e1.polyCount){
                    r && this.centroidVertexArray.resize(this.centroidVertexArray.length + 4 * t1.edges + t1.top);
                    for(let e1 = 0; e1 < t1.top; e1++)this.centroidVertexArray.emplace(s++, n, i);
                    for(let e1 = 0; e1 < 2 * t1.edges; e1++)this.centroidVertexArray.emplace(s++, 0, i), this.centroidVertexArray.emplace(s++, n, i);
                }
            }
            constructor(t1){
                this.zoom = t1.zoom, this.canonical = t1.canonical, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = t1.projection, this.layoutVertexArray = new ea, this.centroidVertexArray = new La, this.indexArray = new ya, this.programConfigurations = new co(t1.layers, t1.zoom), this.segments = new _o, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.enableTerrain = t1.enableTerrain;
            }
        }
        function Ac(t1, e1) {
            const r = t1.add(e1)._unit();
            return t1.x * r.x + t1.y * r.y;
        }
        function Sc(t1, e1, r, n) {
            const i = e1.sub(t1)._perp()._unit(), s = r.sub(e1)._perp()._unit();
            return kc(t1, e1, r, Ac(i, s), n);
        }
        function kc(t1, e1, r, n, i) {
            const s = Math.sqrt(1 - n * n);
            return Math.min(t1.dist(e1) / 3, e1.dist(r) / 3, i * s / n);
        }
        function Ic(t1, e1, r) {
            return t1.x < r[0].x && e1.x < r[0].x || t1.x > r[1].x && e1.x > r[1].x || t1.y < r[0].y && e1.y < r[0].y || t1.y > r[1].y && e1.y > r[1].y;
        }
        function Mc(t1, e1, r) {
            if (t1.x < 0 || t1.x >= wo || e1.x < 0 || e1.x >= wo || r.x < 0 || r.x >= wo) return !1;
            const n = r.sub(e1), i = n.perp(), s = t1.sub(e1);
            return (n.x * s.x + n.y * s.y) / Math.sqrt((n.x * n.x + n.y * n.y) * (s.x * s.x + s.y * s.y)) > -0.866 && i.x * s.x + i.y * s.y < 0;
        }
        function zc(t1, e1, r) {
            const n = e1 ? 2 | t1 : -3 & t1;
            return r ? 1 | n : -2 & n;
        }
        function Tc() {
            const t1 = Math.PI / 32, e1 = Math.tan(t1), r = So;
            return r * Math.sqrt(1 + 2 * e1 * e1) - r;
        }
        function Bc(t1, e1, r) {
            const n = 1 << r.z, s = Eo(r.x / n), a = Eo((r.x + 1) / n), o = Co(r.y / n), l = Co((r.y + 1) / n);
            return function(t1, e1, r, n, s = 0, a) {
                const o = [];
                if (!t1.length || !r || !n) return o;
                const l = (t1, e1)=>{
                    for (const r of t1)o.push({
                        polygon: r,
                        bounds: e1
                    });
                }, u = Math.ceil(Math.log2(r)), c = Math.ceil(Math.log2(n)), h = u - c, p = [];
                for(let t1 = 0; t1 < Math.abs(h); t1++)p.push(h > 0 ? 0 : 1);
                for(let t1 = 0; t1 < Math.min(u, c); t1++)p.push(0), p.push(1);
                let f = t1;
                if (f = mc(f, e1[0].y - s, e1[1].y + s, 1), f = mc(f, e1[0].x - s, e1[1].x + s, 0), !f.length) return o;
                const d = [];
                for(p.length ? d.push({
                    polygons: f,
                    bounds: e1,
                    depth: 0
                }) : l(f, e1); d.length;){
                    const t1 = d.pop(), e1 = t1.depth, r = p[e1], n = t1.bounds[0], o = t1.bounds[1], u = 0 === r ? n.x : n.y, c = 0 === r ? o.x : o.y, h = a ? a(r, u, c) : .5 * (u + c), f = mc(t1.polygons, u - s, h + s, r), y = mc(t1.polygons, h - s, c + s, r);
                    if (f.length) {
                        const t1 = [
                            n,
                            new i(0 === r ? h : o.x, 1 === r ? h : o.y)
                        ];
                        p.length > e1 + 1 ? d.push({
                            polygons: f,
                            bounds: t1,
                            depth: e1 + 1
                        }) : l(f, t1);
                    }
                    if (y.length) {
                        const t1 = [
                            new i(0 === r ? h : n.x, 1 === r ? h : n.y),
                            o
                        ];
                        p.length > e1 + 1 ? d.push({
                            polygons: y,
                            bounds: t1,
                            depth: e1 + 1
                        }) : l(y, t1);
                    }
                }
                return o;
            }(t1, e1, Math.ceil((a - s) / 11.25), Math.ceil((o - l) / 11.25), 1, (t1, e1, i)=>{
                if (0 === t1) return .5 * (e1 + i);
                {
                    const t1 = Co((r.y + e1 / wo) / n);
                    return (To(.5 * (Co((r.y + i / wo) / n) + t1)) * n - r.y) * wo;
                }
            });
        }
        Pi(wc, "FillExtrusionBucket", {
            omit: [
                "layers",
                "features"
            ]
        }), Pi(_c, "PartMetadata");
        const Ec = new Zs({
            "fill-extrusion-edge-radius": new $s(Gt["layout_fill-extrusion"]["fill-extrusion-edge-radius"])
        });
        var Cc = {
            paint: new Zs({
                "fill-extrusion-opacity": new $s(Gt["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                "fill-extrusion-color": new Os(Gt["paint_fill-extrusion"]["fill-extrusion-color"]),
                "fill-extrusion-translate": new $s(Gt["paint_fill-extrusion"]["fill-extrusion-translate"]),
                "fill-extrusion-translate-anchor": new $s(Gt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                "fill-extrusion-pattern": new qs(Gt["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                "fill-extrusion-height": new Os(Gt["paint_fill-extrusion"]["fill-extrusion-height"]),
                "fill-extrusion-base": new Os(Gt["paint_fill-extrusion"]["fill-extrusion-base"]),
                "fill-extrusion-vertical-gradient": new $s(Gt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
                "fill-extrusion-ambient-occlusion-intensity": new $s(Gt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
                "fill-extrusion-ambient-occlusion-radius": new $s(Gt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"])
            }),
            layout: Ec
        };
        function Pc(t1, e1, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t1 * n - 2 * Math.PI * 6378137 / 2,
                e1 * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        class Dc {
            equals(t1) {
                return this.z === t1.z && this.x === t1.x && this.y === t1.y;
            }
            url(t1, e1) {
                const r = function(t1, e1, r) {
                    var n = Pc(256 * t1, 256 * (e1 = Math.pow(2, r) - e1 - 1), r), i = Pc(256 * (t1 + 1), 256 * (e1 + 1), r);
                    return n[0] + "," + n[1] + "," + i[0] + "," + i[1];
                }(this.x, this.y, this.z), n = function(t1, e1, r) {
                    let n, i = "";
                    for(let s = t1; s > 0; s--)n = 1 << s - 1, i += (e1 & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return t1[(this.x + this.y) % t1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === e1 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n).replace("{bbox-epsg-3857}", r);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
            constructor(t1, e1, r){
                this.z = t1, this.x = e1, this.y = r, this.key = Lc(0, t1, t1, e1, r);
            }
        }
        class Vc {
            constructor(t1, e1){
                this.wrap = t1, this.canonical = e1, this.key = Lc(t1, e1.z, e1.z, e1.x, e1.y);
            }
        }
        class Fc {
            equals(t1) {
                return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
            }
            scaledTo(t1) {
                const e1 = this.canonical.z - t1;
                return t1 > this.canonical.z ? new Fc(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Fc(t1, this.wrap, t1, this.canonical.x >> e1, this.canonical.y >> e1);
            }
            calculateScaledKey(t1, e1 = !0) {
                if (this.overscaledZ === t1 && e1) return this.key;
                if (t1 > this.canonical.z) return Lc(this.wrap * +e1, t1, this.canonical.z, this.canonical.x, this.canonical.y);
                {
                    const r = this.canonical.z - t1;
                    return Lc(this.wrap * +e1, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
                }
            }
            isChildOf(t1) {
                if (t1.wrap !== this.wrap) return !1;
                const e1 = this.canonical.z - t1.canonical.z;
                return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.x === this.canonical.x >> e1 && t1.canonical.y === this.canonical.y >> e1;
            }
            children(t1) {
                if (this.overscaledZ >= t1) return [
                    new Fc(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e1 = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new Fc(e1, this.wrap, e1, r, n),
                    new Fc(e1, this.wrap, e1, r + 1, n),
                    new Fc(e1, this.wrap, e1, r, n + 1),
                    new Fc(e1, this.wrap, e1, r + 1, n + 1)
                ];
            }
            isLessThan(t1) {
                return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
            }
            wrapped() {
                return new Fc(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t1) {
                return new Fc(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new Vc(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
            constructor(t1, e1, r, n, i){
                this.overscaledZ = t1, this.wrap = e1, this.canonical = new Dc(r, +n, +i), this.key = 0 === e1 && t1 === r ? this.canonical.key : Lc(e1, t1, r, n, i);
            }
        }
        function Lc(t1, e1, r, n, i) {
            const s = 1 << Math.min(r, 22);
            let a = s * (i % s) + n % s;
            return t1 && r < 22 && (a += s * s * ((t1 < 0 ? -2 * t1 - 1 : 2 * t1) % (1 << 2 * (22 - r)))), 16 * (32 * a + r) + (e1 - r);
        }
        function Rc(t1, e1) {
            return t1.x * e1.x + t1.y * e1.y;
        }
        function Uc(t1, e1) {
            if (1 === t1.length) {
                let r = 0;
                const n = e1[r++];
                let i;
                for(; !i || n.equals(i);)if (i = e1[r++], !i) return 1 / 0;
                for(; r < e1.length; r++){
                    const s = e1[r], a = t1[0], o = i.sub(n), l = s.sub(n), u = a.sub(n), c = Rc(o, o), h = Rc(o, l), p = Rc(l, l), f = Rc(u, o), d = Rc(u, l), y = c * p - h * h, m = (p * f - h * d) / y, g = (c * d - h * f) / y, x = n.z * (1 - m - g) + i.z * m + s.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t1 = 1 / 0;
                for (const r of e1)t1 = Math.min(t1, r.z);
                return t1;
            }
        }
        function jc(t1) {
            const e1 = new i(t1[0], t1[1]);
            return e1.z = t1[2], e1;
        }
        function $c(t1, e1, r, n, i, s, a, o) {
            const l = a * i.getElevationAt(t1, e1, !0, !0), u = 0 !== s[0], c = u ? 0 === s[1] ? a * (s[0] / 7 - 450) : a * function(t1, e1, r) {
                const n = Math.floor(e1[0] / 8), i = Math.floor(e1[1] / 8), s = 10 * (e1[0] - 8 * n), a = 10 * (e1[1] - 8 * i), o = t1.getElevationAt(n, i, !0, !0), l = t1.getMeterToDEM(r), u = Math.floor(.5 * (s * l - 1)), c = Math.floor(.5 * (a * l - 1)), h = t1.tileCoordToPixel(n, i), p = 2 * u + 1, f = 2 * c + 1, d = function(t1, e1, r, n, i) {
                    return [
                        t1.getElevationAtPixel(e1, r, !0),
                        t1.getElevationAtPixel(e1 + i, r, !0),
                        t1.getElevationAtPixel(e1, r + i, !0),
                        t1.getElevationAtPixel(e1 + n, r + i, !0)
                    ];
                }(t1, h.x - u, h.y - c, p, f), y = Math.abs(d[0] - d[1]), m = Math.abs(d[2] - d[3]), g = Math.abs(d[0] - d[2]) + Math.abs(d[1] - d[3]), x = Math.min(.25, .5 * l * (y + m) / p), v = Math.min(.25, .5 * l * g / f);
                return o + Math.max(x * s, v * a);
            }(i, s, o) : l;
            return {
                base: l + (0 === r) ? -1 : r,
                top: u ? Math.max(c + n, l + r + 2) : l + n
            };
        }
        Pi(Dc, "CanonicalTileID"), Pi(Fc, "OverscaledTileID", {
            omit: [
                "projMatrix"
            ]
        });
        const Oc = Ws([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            },
            {
                name: "a_linesofar",
                components: 1,
                type: "Float32"
            }
        ], 4), { members: qc } = Oc, Nc = Ws([
            {
                name: "a_packed",
                components: 4,
                type: "Float32"
            }
        ]), { members: Gc } = Nc, Zc = yc.VectorTileFeature.types, Xc = Math.cos(Math.PI / 180 * 37.5);
        class Kc {
            populate(t1, e1, r, n) {
                this.hasPattern = Ju("line", this.layers, e1);
                const i = this.layers[0].layout.get("line-sort-key"), s = [];
                for (const { feature: e1, id: a, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = Go(e1, t1);
                    if (!this.layers[0]._featureFilter.filter(new Cs(this.zoom), u, r)) continue;
                    const c = i ? i.evaluate(u, {}, r) : void 0, h = {
                        id: a,
                        properties: e1.properties,
                        type: e1.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : No(e1, r, n),
                        patterns: {},
                        sortKey: c
                    };
                    s.push(h);
                }
                i && s.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                const { lineAtlas: a, featureIndex: o } = e1, l = this.addConstantDashes(a);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: u } = n;
                    if (l && this.addFeatureDashes(n, a), this.hasPattern) {
                        const t1 = Qu("line", this.layers, n, this.zoom, e1);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, s, r, a.positions, e1.availableImages);
                    o.insert(t1[s].feature, i, s, u, this.index);
                }
            }
            addConstantDashes(t1) {
                let e1 = !1;
                for (const r of this.layers){
                    const n = r.paint.get("line-dasharray").value, i = r.layout.get("line-cap").value;
                    if ("constant" !== n.kind || "constant" !== i.kind) e1 = !0;
                    else {
                        const e1 = i.value, r = n.value;
                        if (!r) continue;
                        t1.addDash(r.from, e1), t1.addDash(r.to, e1), r.other && t1.addDash(r.other, e1);
                    }
                }
                return e1;
            }
            addFeatureDashes(t1, e1) {
                const r = this.zoom;
                for (const n of this.layers){
                    const i = n.paint.get("line-dasharray").value, s = n.layout.get("line-cap").value;
                    if ("constant" === i.kind && "constant" === s.kind) continue;
                    let a, o, l, u, c, h;
                    if ("constant" === i.kind) {
                        const t1 = i.value;
                        if (!t1) continue;
                        a = t1.other || t1.to, o = t1.to, l = t1.from;
                    } else a = i.evaluate({
                        zoom: r - 1
                    }, t1), o = i.evaluate({
                        zoom: r
                    }, t1), l = i.evaluate({
                        zoom: r + 1
                    }, t1);
                    "constant" === s.kind ? u = c = h = s.value : (u = s.evaluate({
                        zoom: r - 1
                    }, t1), c = s.evaluate({
                        zoom: r
                    }, t1), h = s.evaluate({
                        zoom: r + 1
                    }, t1)), e1.addDash(a, u), e1.addDash(o, c), e1.addDash(l, h);
                    const p = e1.getKey(a, u), f = e1.getKey(o, c), d = e1.getKey(l, h);
                    t1.patterns[n.id] = {
                        min: p,
                        mid: f,
                        max: d
                    };
                }
            }
            update(t1, e1, r, n) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r, n);
            }
            addFeatures(t1, e1, r, n, i) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e1, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t1.createVertexBuffer(this.layoutVertexArray2, Gc)), this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, qc), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t1) {
                if (t1.properties && t1.properties.hasOwnProperty("mapbox_clip_start") && t1.properties.hasOwnProperty("mapbox_clip_end")) return {
                    start: +t1.properties.mapbox_clip_start,
                    end: +t1.properties.mapbox_clip_end
                };
            }
            addFeature(t1, e1, r, n, i, s) {
                const a = this.layers[0].layout, o = a.get("line-join").evaluate(t1, {}), l = a.get("line-cap").evaluate(t1, {}), u = a.get("line-miter-limit"), c = a.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(t1);
                for (const r of e1)this.addLine(r, t1, o, l, u, c);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, s, n);
            }
            addLine(t1, e1, r, n, i, s) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineSoFar = 0, this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let e1 = 0; e1 < t1.length - 1; e1++)this.totalDistance += t1[e1].dist(t1[e1 + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const a = "Polygon" === Zc[e1.type];
                let o = t1.length;
                for(; o >= 2 && t1[o - 1].equals(t1[o - 2]);)o--;
                let l = 0;
                for(; l < o - 1 && t1[l].equals(t1[l + 1]);)l++;
                if (o < (a ? 3 : 2)) return;
                "bevel" === r && (i = 1.05);
                const u = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, c = this.segments.prepareSegment(10 * o, this.layoutVertexArray, this.indexArray);
                let h, p, f, d, y;
                this.e1 = this.e2 = -1, a && (h = t1[o - 2], y = t1[l].sub(h)._unit()._perp());
                for(let e1 = l; e1 < o; e1++){
                    if (f = e1 === o - 1 ? a ? t1[l + 1] : void 0 : t1[e1 + 1], f && t1[e1].equals(f)) continue;
                    y && (d = y), h && (p = h), h = t1[e1], y = f ? f.sub(h)._unit()._perp() : d, d = d || y;
                    let m = d.add(y);
                    0 === m.x && 0 === m.y || m._unit();
                    const g = d.x * y.x + d.y * y.y, x = m.x * y.x + m.y * y.y, v = 0 !== x ? 1 / x : 1 / 0, b = 2 * Math.sqrt(2 - 2 * x), _ = x < Xc && p && f, w = d.x * y.y - d.y * y.x > 0;
                    if (_ && e1 > l) {
                        const t1 = h.dist(p);
                        if (t1 > 2 * u) {
                            const e1 = h.sub(h.sub(p)._mult(u / t1)._round());
                            this.updateDistance(p, e1), this.addCurrentVertex(e1, d, 0, 0, c), p = e1;
                        }
                    }
                    const A = p && f;
                    let S = A ? r : a ? "butt" : n;
                    if (A && "round" === S && (v < s ? S = "miter" : v <= 2 && (S = "fakeround")), "miter" === S && v > i && (S = "bevel"), "bevel" === S && (v > 2 && (S = "flipbevel"), v < i && (S = "miter")), p && this.updateDistance(p, h), "miter" === S) m._mult(v), this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("flipbevel" === S) {
                        if (v > 100) m = y.mult(-1);
                        else {
                            const t1 = v * d.add(y).mag() / d.sub(y).mag();
                            m._perp()._mult(t1 * (w ? -1 : 1));
                        }
                        this.addCurrentVertex(h, m, 0, 0, c), this.addCurrentVertex(h, m.mult(-1), 0, 0, c);
                    } else if ("bevel" === S || "fakeround" === S) {
                        const t1 = -Math.sqrt(v * v - 1), e1 = w ? t1 : 0, r = w ? 0 : t1;
                        if (p && this.addCurrentVertex(h, d, e1, r, c), "fakeround" === S) {
                            const t1 = Math.round(180 * b / Math.PI / 20);
                            for(let e1 = 1; e1 < t1; e1++){
                                let r = e1 / t1;
                                if (.5 !== r) {
                                    const t1 = r - .5;
                                    r += r * t1 * (r - 1) * ((1.0904 + g * (g * (3.55645 - 1.43519 * g) - 3.2452)) * t1 * t1 + (.848013 + g * (.215638 * g - 1.06021)));
                                }
                                const n = y.sub(d)._mult(r)._add(d)._unit()._mult(w ? -1 : 1);
                                this.addHalfVertex(h, n.x, n.y, !1, w, 0, c);
                            }
                        }
                        f && this.addCurrentVertex(h, y, -e1, -r, c);
                    } else if ("butt" === S) this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("square" === S) {
                        const t1 = p ? 1 : -1;
                        p || this.addCurrentVertex(h, m, t1, t1, c), this.addCurrentVertex(h, m, 0, 0, c), p && this.addCurrentVertex(h, m, t1, t1, c);
                    } else "round" === S && (p && (this.addCurrentVertex(h, d, 0, 0, c), this.addCurrentVertex(h, d, 1, 1, c, !0)), f && (this.addCurrentVertex(h, y, -1, -1, c, !0), this.addCurrentVertex(h, y, 0, 0, c)));
                    if (_ && e1 < o - 1) {
                        const t1 = h.dist(f);
                        if (t1 > 2 * u) {
                            const e1 = h.add(f.sub(h)._mult(u / t1)._round());
                            this.updateDistance(h, e1), this.addCurrentVertex(e1, y, 0, 0, c), h = e1;
                        }
                    }
                }
            }
            addCurrentVertex(t1, e1, r, n, i, s = !1) {
                const a = e1.y * n - e1.x, o = -e1.y - e1.x * n;
                this.addHalfVertex(t1, e1.x + e1.y * r, e1.y - e1.x * r, s, !1, r, i), this.addHalfVertex(t1, a, o, s, !0, -n, i);
            }
            addHalfVertex({ x: t1, y: e1 }, r, n, i, s, a, o) {
                this.layoutVertexArray.emplaceBack((t1 << 1) + (i ? 1 : 0), (e1 << 1) + (s ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1), 0, this.lineSoFar), this.lineClips && this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, this.lineClips.start, this.lineClips.end);
                const l = o.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, l), o.primitiveLength++), s ? this.e2 = l : this.e1 = l;
            }
            updateScaledDistance() {
                if (this.lineClips) {
                    const t1 = this.totalDistance / (this.lineClips.end - this.lineClips.start);
                    this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = t1 * this.lineClips.start + this.distance;
                } else this.lineSoFar = this.distance;
            }
            updateDistance(t1, e1) {
                this.distance += t1.dist(e1), this.updateScaledDistance();
            }
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.projection = t1.projection, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t1)=>{
                    this.gradients[t1.id] = {};
                }), this.layoutVertexArray = new ra, this.layoutVertexArray2 = new na, this.indexArray = new ya, this.programConfigurations = new co(t1.layers, t1.zoom), this.segments = new _o, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
        }
        Pi(Kc, "LineBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        const Hc = new Zs({
            "line-cap": new Os(Gt.layout_line["line-cap"]),
            "line-join": new Os(Gt.layout_line["line-join"]),
            "line-miter-limit": new $s(Gt.layout_line["line-miter-limit"]),
            "line-round-limit": new $s(Gt.layout_line["line-round-limit"]),
            "line-sort-key": new Os(Gt.layout_line["line-sort-key"])
        });
        var Yc = {
            paint: new Zs({
                "line-opacity": new Os(Gt.paint_line["line-opacity"]),
                "line-color": new Os(Gt.paint_line["line-color"]),
                "line-translate": new $s(Gt.paint_line["line-translate"]),
                "line-translate-anchor": new $s(Gt.paint_line["line-translate-anchor"]),
                "line-width": new Os(Gt.paint_line["line-width"]),
                "line-gap-width": new Os(Gt.paint_line["line-gap-width"]),
                "line-offset": new Os(Gt.paint_line["line-offset"]),
                "line-blur": new Os(Gt.paint_line["line-blur"]),
                "line-dasharray": new qs(Gt.paint_line["line-dasharray"]),
                "line-pattern": new qs(Gt.paint_line["line-pattern"]),
                "line-gradient": new Gs(Gt.paint_line["line-gradient"]),
                "line-trim-offset": new $s(Gt.paint_line["line-trim-offset"])
            }),
            layout: Hc
        };
        const Wc = new class extends Os {
            possiblyEvaluate(t1, e1) {
                return e1 = new Cs(Math.floor(e1.zoom), {
                    now: e1.now,
                    fadeDuration: e1.fadeDuration,
                    zoomHistory: e1.zoomHistory,
                    transition: e1.transition
                }), super.possiblyEvaluate(t1, e1);
            }
            evaluate(t1, e1, r, n) {
                return e1 = v({}, e1, {
                    zoom: Math.floor(e1.zoom)
                }), super.evaluate(t1, e1, r, n);
            }
        }(Yc.paint.properties["line-width"].specification);
        function Jc(t1, e1) {
            return e1 > 0 ? e1 + 2 * t1 : t1;
        }
        Wc.useIntegerZoom = !0;
        const Qc = Ws([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_tex_size",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), th = Ws([
            {
                name: "a_globe_anchor",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_globe_normal",
                components: 3,
                type: "Float32"
            }
        ], 4), eh = Ws([
            {
                name: "a_projected_pos",
                components: 4,
                type: "Float32"
            }
        ], 4);
        Ws([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const rh = Ws([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            }
        ]), nh = Ws([
            {
                name: "a_size_scale",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_padding",
                components: 2,
                type: "Float32"
            }
        ]);
        Ws([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "tileAnchorX"
            },
            {
                type: "Int16",
                name: "tileAnchorY"
            },
            {
                type: "Float32",
                name: "x1"
            },
            {
                type: "Float32",
                name: "y1"
            },
            {
                type: "Float32",
                name: "x2"
            },
            {
                type: "Float32",
                name: "y2"
            },
            {
                type: "Int16",
                name: "padding"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const ih = Ws([
            {
                name: "a_pos",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), sh = Ws([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        Ws([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Ws([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            },
            {
                type: "Uint8",
                name: "flipState"
            }
        ]), Ws([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            }
        ]), Ws([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Ws([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]);
        var ah = 24;
        const oh = 128;
        function lh(t1, e1) {
            const { expression: r } = e1;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new Cs(t1 + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e1, interpolationType: n } = r;
                let i = 0;
                for(; i < e1.length && e1[i] <= t1;)i++;
                i = Math.max(0, i - 1);
                let s = i;
                for(; s < e1.length && e1[s] < t1 + 1;)s++;
                s = Math.min(e1.length - 1, s);
                const a = e1[i], o = e1[s];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: a,
                    maxZoom: o,
                    interpolationType: n
                } : {
                    kind: "camera",
                    minZoom: a,
                    maxZoom: o,
                    minSize: r.evaluate(new Cs(a)),
                    maxSize: r.evaluate(new Cs(o)),
                    interpolationType: n
                };
            }
        }
        function uh(t1, { uSize: e1, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === t1.kind ? n / oh : "composite" === t1.kind ? xr(n / oh, i / oh, r) : e1;
        }
        function ch(t1, e1) {
            let r = 0, n = 0;
            if ("constant" === t1.kind) n = t1.layoutSize;
            else if ("source" !== t1.kind) {
                const { interpolationType: i, minZoom: s, maxZoom: a } = t1, o = i ? d(jr.interpolationFactor(i, e1, s, a), 0, 1) : 0;
                "camera" === t1.kind ? n = xr(t1.minSize, t1.maxSize, o) : r = o;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }
        var hh = Object.freeze({
            __proto__: null,
            getSizeData: lh,
            evaluateSizeForFeature: uh,
            evaluateSizeForZoom: ch,
            SIZE_PACK_FACTOR: oh
        });
        function ph(t1, e1, r) {
            return t1.sections.forEach((t1)=>{
                t1.text = function(t1, e1, r) {
                    const n = e1.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), Es.applyArabicShaping && (t1 = Es.applyArabicShaping(t1)), t1;
                }(t1.text, e1, r);
            }), t1;
        }
        const fh = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        };
        function dh(t1) {
            return "\uFE36" === t1 || "\uFE48" === t1 || "\uFE38" === t1 || "\uFE44" === t1 || "\uFE42" === t1 || "\uFE3E" === t1 || "\uFE3C" === t1 || "\uFE3A" === t1 || "\uFE18" === t1 || "\uFE40" === t1 || "\uFE10" === t1 || "\uFE13" === t1 || "\uFE14" === t1 || "\uFF40" === t1 || "\uFFE3" === t1 || "\uFE11" === t1 || "\uFE12" === t1;
        }
        function yh(t1) {
            return "\uFE35" === t1 || "\uFE47" === t1 || "\uFE37" === t1 || "\uFE43" === t1 || "\uFE41" === t1 || "\uFE3D" === t1 || "\uFE3B" === t1 || "\uFE39" === t1 || "\uFE17" === t1 || "\uFE3F" === t1;
        }
        var mh = function(t1, e1, r, n, i) {
            var s, a, o = 8 * i - n - 1, l = (1 << o) - 1, u = l >> 1, c = -7, h = r ? i - 1 : 0, p = r ? -1 : 1, f = t1[e1 + h];
            for(h += p, s = f & (1 << -c) - 1, f >>= -c, c += o; c > 0; s = 256 * s + t1[e1 + h], h += p, c -= 8);
            for(a = s & (1 << -c) - 1, s >>= -c, c += n; c > 0; a = 256 * a + t1[e1 + h], h += p, c -= 8);
            if (0 === s) s = 1 - u;
            else {
                if (s === l) return a ? NaN : 1 / 0 * (f ? -1 : 1);
                a += Math.pow(2, n), s -= u;
            }
            return (f ? -1 : 1) * a * Math.pow(2, s - n);
        }, gh = function(t1, e1, r, n, i, s) {
            var a, o, l, u = 8 * s - i - 1, c = (1 << u) - 1, h = c >> 1, p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : s - 1, d = n ? 1 : -1, y = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
            for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (o = isNaN(e1) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e1) / Math.LN2), e1 * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), (e1 += a + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (a++, l /= 2), a + h >= c ? (o = 0, a = c) : a + h >= 1 ? (o = (e1 * l - 1) * Math.pow(2, i), a += h) : (o = e1 * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; t1[r + f] = 255 & o, f += d, o /= 256, i -= 8);
            for(a = a << i | o, u += i; u > 0; t1[r + f] = 255 & a, f += d, a /= 256, u -= 8);
            t1[r + f - d] |= 128 * y;
        }, xh = vh;
        function vh(t1) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        vh.Varint = 0, vh.Fixed64 = 1, vh.Bytes = 2, vh.Fixed32 = 5;
        var bh = 4294967296, _h = 1 / bh, wh = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function Ah(t1) {
            return t1.type === vh.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
        }
        function Sh(t1, e1, r) {
            return r ? 4294967296 * e1 + (t1 >>> 0) : 4294967296 * (e1 >>> 0) + (t1 >>> 0);
        }
        function kh(t1, e1, r) {
            var n = e1 <= 16383 ? 1 : e1 <= 2097151 ? 2 : e1 <= 268435455 ? 3 : Math.floor(Math.log(e1) / (7 * Math.LN2));
            r.realloc(n);
            for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
        }
        function Ih(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeVarint(t1[r]);
        }
        function Mh(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSVarint(t1[r]);
        }
        function zh(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFloat(t1[r]);
        }
        function Th(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeDouble(t1[r]);
        }
        function Bh(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeBoolean(t1[r]);
        }
        function Eh(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed32(t1[r]);
        }
        function Ch(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed32(t1[r]);
        }
        function Ph(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed64(t1[r]);
        }
        function Dh(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed64(t1[r]);
        }
        function Vh(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + 16777216 * t1[e1 + 3];
        }
        function Fh(t1, e1, r) {
            t1[r] = e1, t1[r + 1] = e1 >>> 8, t1[r + 2] = e1 >>> 16, t1[r + 3] = e1 >>> 24;
        }
        function Lh(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + (t1[e1 + 3] << 24);
        }
        function Rh(t1, e1, r) {
            e1.glyphs = [], 1 === t1 && r.readMessage(Uh, e1);
        }
        function Uh(t1, e1, r) {
            if (3 === t1) {
                const { id: t1, bitmap: n, width: i, height: s, left: a, top: o, advance: l } = r.readMessage(jh, {});
                e1.glyphs.push({
                    id: t1,
                    bitmap: new hu({
                        width: i + 6,
                        height: s + 6
                    }, n),
                    metrics: {
                        width: i,
                        height: s,
                        left: a,
                        top: o,
                        advance: l
                    }
                });
            } else 4 === t1 ? e1.ascender = r.readSVarint() : 5 === t1 && (e1.descender = r.readSVarint());
        }
        function jh(t1, e1, r) {
            1 === t1 ? e1.id = r.readVarint() : 2 === t1 ? e1.bitmap = r.readBytes() : 3 === t1 ? e1.width = r.readVarint() : 4 === t1 ? e1.height = r.readVarint() : 5 === t1 ? e1.left = r.readSVarint() : 6 === t1 ? e1.top = r.readSVarint() : 7 === t1 && (e1.advance = r.readVarint());
        }
        function $h(t1) {
            let e1 = 0, r = 0;
            for (const n of t1)e1 += n.w * n.h, r = Math.max(r, n.w);
            t1.sort((t1, e1)=>e1.h - t1.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e1 / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, s = 0;
            for (const e1 of t1)for(let t1 = n.length - 1; t1 >= 0; t1--){
                const r = n[t1];
                if (!(e1.w > r.w || e1.h > r.h)) {
                    if (e1.x = r.x, e1.y = r.y, s = Math.max(s, e1.y + e1.h), i = Math.max(i, e1.x + e1.w), e1.w === r.w && e1.h === r.h) {
                        const e1 = n.pop();
                        t1 < n.length && (n[t1] = e1);
                    } else e1.h === r.h ? (r.x += e1.w, r.w -= e1.w) : e1.w === r.w ? (r.y += e1.h, r.h -= e1.h) : (n.push({
                        x: r.x + e1.w,
                        y: r.y,
                        w: r.w - e1.w,
                        h: e1.h
                    }), r.y += e1.h, r.h -= e1.h);
                    break;
                }
            }
            return {
                w: i,
                h: s,
                fill: e1 / (i * s) || 0
            };
        }
        vh.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(t1, e1, r) {
                for(r = r || this.length; this.pos < r;){
                    var n = this.readVarint(), i = n >> 3, s = this.pos;
                    this.type = 7 & n, t1(i, e1, this), this.pos === s && this.skip(n);
                }
                return e1;
            },
            readMessage: function(t1, e1) {
                return this.readFields(t1, e1, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var t1 = Vh(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readSFixed32: function() {
                var t1 = Lh(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readFixed64: function() {
                var t1 = Vh(this.buf, this.pos) + Vh(this.buf, this.pos + 4) * bh;
                return this.pos += 8, t1;
            },
            readSFixed64: function() {
                var t1 = Vh(this.buf, this.pos) + Lh(this.buf, this.pos + 4) * bh;
                return this.pos += 8, t1;
            },
            readFloat: function() {
                var t1 = mh(this.buf, this.pos, !0, 23, 4);
                return this.pos += 4, t1;
            },
            readDouble: function() {
                var t1 = mh(this.buf, this.pos, !0, 52, 8);
                return this.pos += 8, t1;
            },
            readVarint: function(t1) {
                var e1, r, n = this.buf;
                return e1 = 127 & (r = n[this.pos++]), r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e1 : function(t1, e1, r) {
                    var n, i, s = r.buf;
                    if (n = (112 & (i = s[r.pos++])) >> 4, i < 128) return Sh(t1, n, e1);
                    if (n |= (127 & (i = s[r.pos++])) << 3, i < 128) return Sh(t1, n, e1);
                    if (n |= (127 & (i = s[r.pos++])) << 10, i < 128) return Sh(t1, n, e1);
                    if (n |= (127 & (i = s[r.pos++])) << 17, i < 128) return Sh(t1, n, e1);
                    if (n |= (127 & (i = s[r.pos++])) << 24, i < 128) return Sh(t1, n, e1);
                    if (n |= (1 & (i = s[r.pos++])) << 31, i < 128) return Sh(t1, n, e1);
                    throw new Error("Expected varint not more than 10 bytes");
                }(e1 |= (15 & (r = n[this.pos])) << 28, t1, this))));
            },
            readVarint64: function() {
                return this.readVarint(!0);
            },
            readSVarint: function() {
                var t1 = this.readVarint();
                return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.pos;
                return this.pos = t1, t1 - e1 >= 12 && wh ? function(t1, e1, r) {
                    return wh.decode(t1.subarray(e1, r));
                }(this.buf, e1, t1) : function(t1, e1, r) {
                    for(var n = "", i = e1; i < r;){
                        var s, a, o, l = t1[i], u = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                        if (i + c > r) break;
                        1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (s = t1[i + 1])) && (u = (31 & l) << 6 | 63 & s) <= 127 && (u = null) : 3 === c ? (a = t1[i + 2], 128 == (192 & (s = t1[i + 1])) && 128 == (192 & a) && ((u = (15 & l) << 12 | (63 & s) << 6 | 63 & a) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (a = t1[i + 2], o = t1[i + 3], 128 == (192 & (s = t1[i + 1])) && 128 == (192 & a) && 128 == (192 & o) && ((u = (15 & l) << 18 | (63 & s) << 12 | (63 & a) << 6 | 63 & o) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
                    }
                    return n;
                }(this.buf, e1, t1);
            },
            readBytes: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.buf.subarray(this.pos, t1);
                return this.pos = t1, e1;
            },
            readPackedVarint: function(t1, e1) {
                if (this.type !== vh.Bytes) return t1.push(this.readVarint(e1));
                var r = Ah(this);
                for(t1 = t1 || []; this.pos < r;)t1.push(this.readVarint(e1));
                return t1;
            },
            readPackedSVarint: function(t1) {
                if (this.type !== vh.Bytes) return t1.push(this.readSVarint());
                var e1 = Ah(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSVarint());
                return t1;
            },
            readPackedBoolean: function(t1) {
                if (this.type !== vh.Bytes) return t1.push(this.readBoolean());
                var e1 = Ah(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readBoolean());
                return t1;
            },
            readPackedFloat: function(t1) {
                if (this.type !== vh.Bytes) return t1.push(this.readFloat());
                var e1 = Ah(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFloat());
                return t1;
            },
            readPackedDouble: function(t1) {
                if (this.type !== vh.Bytes) return t1.push(this.readDouble());
                var e1 = Ah(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readDouble());
                return t1;
            },
            readPackedFixed32: function(t1) {
                if (this.type !== vh.Bytes) return t1.push(this.readFixed32());
                var e1 = Ah(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed32());
                return t1;
            },
            readPackedSFixed32: function(t1) {
                if (this.type !== vh.Bytes) return t1.push(this.readSFixed32());
                var e1 = Ah(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed32());
                return t1;
            },
            readPackedFixed64: function(t1) {
                if (this.type !== vh.Bytes) return t1.push(this.readFixed64());
                var e1 = Ah(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed64());
                return t1;
            },
            readPackedSFixed64: function(t1) {
                if (this.type !== vh.Bytes) return t1.push(this.readSFixed64());
                var e1 = Ah(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed64());
                return t1;
            },
            skip: function(t1) {
                var e1 = 7 & t1;
                if (e1 === vh.Varint) for(; this.buf[this.pos++] > 127;);
                else if (e1 === vh.Bytes) this.pos = this.readVarint() + this.pos;
                else if (e1 === vh.Fixed32) this.pos += 4;
                else {
                    if (e1 !== vh.Fixed64) throw new Error("Unimplemented type: " + e1);
                    this.pos += 8;
                }
            },
            writeTag: function(t1, e1) {
                this.writeVarint(t1 << 3 | e1);
            },
            realloc: function(t1) {
                for(var e1 = this.length || 16; e1 < this.pos + t1;)e1 *= 2;
                if (e1 !== this.length) {
                    var r = new Uint8Array(e1);
                    r.set(this.buf), this.buf = r, this.length = e1;
                }
            },
            finish: function() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function(t1) {
                this.realloc(4), Fh(this.buf, t1, this.pos), this.pos += 4;
            },
            writeSFixed32: function(t1) {
                this.realloc(4), Fh(this.buf, t1, this.pos), this.pos += 4;
            },
            writeFixed64: function(t1) {
                this.realloc(8), Fh(this.buf, -1 & t1, this.pos), Fh(this.buf, Math.floor(t1 * _h), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function(t1) {
                this.realloc(8), Fh(this.buf, -1 & t1, this.pos), Fh(this.buf, Math.floor(t1 * _h), this.pos + 4), this.pos += 8;
            },
            writeVarint: function(t1) {
                (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e1) {
                    var r, n;
                    if (t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    e1.realloc(10), function(t1, e1, r) {
                        r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, r.buf[r.pos] = 127 & (t1 >>>= 7);
                    }(r, 0, e1), function(t1, e1) {
                        var r = (7 & t1) << 4;
                        e1.buf[e1.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1)))));
                    }(n, e1);
                }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
            },
            writeSVarint: function(t1) {
                this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
            },
            writeBoolean: function(t1) {
                this.writeVarint(Boolean(t1));
            },
            writeString: function(t1) {
                t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                var e1 = this.pos;
                this.pos = function(t1, e1, r) {
                    for(var n, i, s = 0; s < e1.length; s++){
                        if ((n = e1.charCodeAt(s)) > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || s + 1 === e1.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                        n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, t1, this.pos);
                var r = this.pos - e1;
                r >= 128 && kh(e1, r, this), this.pos = e1 - 1, this.writeVarint(r), this.pos += r;
            },
            writeFloat: function(t1) {
                this.realloc(4), gh(this.buf, t1, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function(t1) {
                this.realloc(8), gh(this.buf, t1, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function(t1) {
                var e1 = t1.length;
                this.writeVarint(e1), this.realloc(e1);
                for(var r = 0; r < e1; r++)this.buf[this.pos++] = t1[r];
            },
            writeRawMessage: function(t1, e1) {
                this.pos++;
                var r = this.pos;
                t1(e1, this);
                var n = this.pos - r;
                n >= 128 && kh(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            },
            writeMessage: function(t1, e1, r) {
                this.writeTag(t1, vh.Bytes), this.writeRawMessage(e1, r);
            },
            writePackedVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, Ih, e1);
            },
            writePackedSVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, Mh, e1);
            },
            writePackedBoolean: function(t1, e1) {
                e1.length && this.writeMessage(t1, Bh, e1);
            },
            writePackedFloat: function(t1, e1) {
                e1.length && this.writeMessage(t1, zh, e1);
            },
            writePackedDouble: function(t1, e1) {
                e1.length && this.writeMessage(t1, Th, e1);
            },
            writePackedFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, Eh, e1);
            },
            writePackedSFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, Ch, e1);
            },
            writePackedFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, Ph, e1);
            },
            writePackedSFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, Dh, e1);
            },
            writeBytesField: function(t1, e1) {
                this.writeTag(t1, vh.Bytes), this.writeBytes(e1);
            },
            writeFixed32Field: function(t1, e1) {
                this.writeTag(t1, vh.Fixed32), this.writeFixed32(e1);
            },
            writeSFixed32Field: function(t1, e1) {
                this.writeTag(t1, vh.Fixed32), this.writeSFixed32(e1);
            },
            writeFixed64Field: function(t1, e1) {
                this.writeTag(t1, vh.Fixed64), this.writeFixed64(e1);
            },
            writeSFixed64Field: function(t1, e1) {
                this.writeTag(t1, vh.Fixed64), this.writeSFixed64(e1);
            },
            writeVarintField: function(t1, e1) {
                this.writeTag(t1, vh.Varint), this.writeVarint(e1);
            },
            writeSVarintField: function(t1, e1) {
                this.writeTag(t1, vh.Varint), this.writeSVarint(e1);
            },
            writeStringField: function(t1, e1) {
                this.writeTag(t1, vh.Bytes), this.writeString(e1);
            },
            writeFloatField: function(t1, e1) {
                this.writeTag(t1, vh.Fixed32), this.writeFloat(e1);
            },
            writeDoubleField: function(t1, e1) {
                this.writeTag(t1, vh.Fixed64), this.writeDouble(e1);
            },
            writeBooleanField: function(t1, e1) {
                this.writeVarintField(t1, Boolean(e1));
            }
        };
        class Oh {
            get tl() {
                return [
                    this.paddedRect.x + 1,
                    this.paddedRect.y + 1
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - 1,
                    this.paddedRect.y + this.paddedRect.h - 1
                ];
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2) / this.pixelRatio,
                    (this.paddedRect.h - 2) / this.pixelRatio
                ];
            }
            constructor(t1, { pixelRatio: e1, version: r, stretchX: n, stretchY: i, content: s }){
                this.paddedRect = t1, this.pixelRatio = e1, this.stretchX = n, this.stretchY = i, this.content = s, this.version = r;
            }
        }
        class qh {
            addImages(t1, e1, r) {
                for(const n in t1){
                    const i = t1[n], s = {
                        x: 0,
                        y: 0,
                        w: i.data.width + 2,
                        h: i.data.height + 2
                    };
                    r.push(s), e1[n] = new Oh(s, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                }
            }
            patchUpdatedImages(t1, e1) {
                this.haveRenderCallbacks = this.haveRenderCallbacks.filter((e1)=>t1.hasImage(e1)), t1.dispatchRenderCallbacks(this.haveRenderCallbacks);
                for(const r in t1.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t1.getImage(r), e1), this.patchUpdatedImage(this.patternPositions[r], t1.getImage(r), e1);
            }
            patchUpdatedImage(t1, e1, r) {
                if (!t1 || !e1) return;
                if (t1.version === e1.version) return;
                t1.version = e1.version;
                const [n, i] = t1.tl;
                r.update(e1.data, void 0, {
                    x: n,
                    y: i
                });
            }
            constructor(t1, e1){
                const r = {}, n = {};
                this.haveRenderCallbacks = [];
                const i = [];
                this.addImages(t1, r, i), this.addImages(e1, n, i);
                const { w: s, h: a } = $h(i), o = new pu({
                    width: s || 1,
                    height: a || 1
                });
                for(const e1 in t1){
                    const n = t1[e1], i = r[e1].paddedRect;
                    pu.copy(n.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + 1,
                        y: i.y + 1
                    }, n.data);
                }
                for(const t1 in e1){
                    const r = e1[t1], i = n[t1].paddedRect, s = i.x + 1, a = i.y + 1, l = r.data.width, u = r.data.height;
                    pu.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: a
                    }, r.data), pu.copy(r.data, o, {
                        x: 0,
                        y: u - 1
                    }, {
                        x: s,
                        y: a - 1
                    }, {
                        width: l,
                        height: 1
                    }), pu.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: a + u
                    }, {
                        width: l,
                        height: 1
                    }), pu.copy(r.data, o, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: s - 1,
                        y: a
                    }, {
                        width: 1,
                        height: u
                    }), pu.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + l,
                        y: a
                    }, {
                        width: 1,
                        height: u
                    });
                }
                this.image = o, this.iconPositions = r, this.patternPositions = n;
            }
        }
        Pi(Oh, "ImagePosition"), Pi(qh, "ImageAtlas");
        const Nh = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        };
        class Gh {
            static forText(t1, e1) {
                const r = new Gh;
                return r.scale = t1 || 1, r.fontStack = e1, r;
            }
            static forImage(t1) {
                const e1 = new Gh;
                return e1.imageName = t1, e1;
            }
            constructor(){
                this.scale = 1, this.fontStack = "", this.imageName = null;
            }
        }
        class Zh {
            static fromFeature(t1, e1) {
                const r = new Zh;
                for(let n = 0; n < t1.sections.length; n++){
                    const i = t1.sections[n];
                    i.image ? r.addImageSection(i) : r.addTextSection(i, e1);
                }
                return r;
            }
            length() {
                return this.text.length;
            }
            getSection(t1) {
                return this.sections[this.sectionIndex[t1]];
            }
            getSections() {
                return this.sections;
            }
            getSectionIndex(t1) {
                return this.sectionIndex[t1];
            }
            getCharCode(t1) {
                return this.text.charCodeAt(t1);
            }
            verticalizePunctuation(t1) {
                this.text = function(t1, e1) {
                    let r = "";
                    for(let n = 0; n < t1.length; n++){
                        const i = t1.charCodeAt(n + 1) || null, s = t1.charCodeAt(n - 1) || null;
                        r += !e1 && (i && ms(i) && !fh[t1[n + 1]] || s && ms(s) && !fh[t1[n - 1]]) || !fh[t1[n]] ? t1[n] : fh[t1[n]];
                    }
                    return r;
                }(this.text, t1);
            }
            trim() {
                let t1 = 0;
                for(let e1 = 0; e1 < this.text.length && Kh[this.text.charCodeAt(e1)]; e1++)t1++;
                let e1 = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= t1 && Kh[this.text.charCodeAt(r)]; r--)e1--;
                this.text = this.text.substring(t1, e1), this.sectionIndex = this.sectionIndex.slice(t1, e1);
            }
            substring(t1, e1) {
                const r = new Zh;
                return r.text = this.text.substring(t1, e1), r.sectionIndex = this.sectionIndex.slice(t1, e1), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t1, e1)=>Math.max(t1, this.sections[e1].scale), 0);
            }
            addTextSection(t1, e1) {
                this.text += t1.text, this.sections.push(Gh.forText(t1.scale, t1.fontStack || e1));
                const r = this.sections.length - 1;
                for(let e1 = 0; e1 < t1.text.length; ++e1)this.sectionIndex.push(r);
            }
            addImageSection(t1) {
                const e1 = t1.image ? t1.image.name : "";
                if (0 === e1.length) return void E("Can't add FormattedSection with an empty image.");
                const r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCharCode(r), this.sections.push(Gh.forImage(e1)), this.sectionIndex.push(this.sections.length - 1)) : E("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
        }
        function Xh(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y) {
            const m = Zh.fromFeature(t1, i);
            let g;
            h === Nh.vertical && m.verticalizePunctuation(p);
            const { processBidirectionalText: x, processStyledBidirectionalText: v } = Es;
            if (x && 1 === m.sections.length) {
                g = [];
                const t1 = x(m.toString(), ep(m, u, s, e1, n, f, d));
                for (const e1 of t1){
                    const t1 = new Zh;
                    t1.text = e1, t1.sections = m.sections;
                    for(let r = 0; r < e1.length; r++)t1.sectionIndex.push(0);
                    g.push(t1);
                }
            } else if (v) {
                g = [];
                const t1 = v(m.text, m.sectionIndex, ep(m, u, s, e1, n, f, d));
                for (const e1 of t1){
                    const t1 = new Zh;
                    t1.text = e1[0], t1.sectionIndex = e1[1], t1.sections = m.sections, g.push(t1);
                }
            } else g = function(t1, e1) {
                const r = [], n = t1.text;
                let i = 0;
                for (const n of e1)r.push(t1.substring(i, n)), i = n;
                return i < n.length && r.push(t1.substring(i, n.length)), r;
            }(m, ep(m, u, s, e1, n, f, d));
            const b = [], _ = {
                positionedLines: b,
                text: m.toString(),
                top: c[1],
                bottom: c[1],
                left: c[0],
                right: c[0],
                writingMode: h,
                iconsInText: !1,
                verticalizable: !1,
                hasBaseline: !1
            };
            return function(t1, e1, r, n, i, s, a, o, l, u, c, h) {
                let p = 0, f = 0, d = 0;
                const y = "right" === o ? 1 : "left" === o ? 0 : .5;
                let m = !1;
                for (const t1 of i){
                    const r = t1.getSections();
                    for (const t1 of r){
                        if (t1.imageName) continue;
                        const r = e1[t1.fontStack];
                        if (r && (m = void 0 !== r.ascender && void 0 !== r.descender, !m)) break;
                    }
                    if (!m) break;
                }
                let g = 0;
                for (const a of i){
                    a.trim();
                    const i = a.getMaxScale(), o = (i - 1) * ah, v = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    t1.positionedLines[g] = v;
                    const b = v.positionedGlyphs;
                    let _ = 0;
                    if (!a.length()) {
                        f += s, ++g;
                        continue;
                    }
                    let w = 0, A = 0;
                    for(let s = 0; s < a.length(); s++){
                        const o = a.getSection(s), d = a.getSectionIndex(s), y = a.getCharCode(s);
                        let g = o.scale, v = null, S = null, k = null, I = ah, M = 0;
                        const z = !(l === Nh.horizontal || !c && !ys(y) || c && (Kh[y] || (x = y, Ui(x) || ji(x) || $i(x) || as(x) || cs(x))));
                        if (o.imageName) {
                            const e1 = n[o.imageName];
                            if (!e1) continue;
                            k = o.imageName, t1.iconsInText = t1.iconsInText || !0, S = e1.paddedRect;
                            const r = e1.displaySize;
                            g = g * ah / h, v = {
                                width: r[0],
                                height: r[1],
                                left: 1,
                                top: -3,
                                advance: z ? r[1] : r[0],
                                localGlyph: !1
                            }, M = m ? -v.height * g : i * ah - 17 - r[1] * g, I = v.advance;
                            const s = (z ? r[0] : r[1]) * g - ah * i;
                            s > 0 && s > _ && (_ = s);
                        } else {
                            const t1 = r[o.fontStack];
                            if (!t1) continue;
                            t1[y] && (S = t1[y]);
                            const n = e1[o.fontStack];
                            if (!n) continue;
                            const s = n.glyphs[y];
                            if (!s) continue;
                            if (v = s.metrics, I = 8203 !== y ? ah : 0, m) {
                                const t1 = void 0 !== n.ascender ? Math.abs(n.ascender) : 0, e1 = void 0 !== n.descender ? Math.abs(n.descender) : 0, r = (t1 + e1) * g;
                                w < r && (w = r, A = (t1 - e1) / 2 * g), M = -t1 * g;
                            } else M = (i - g) * ah - 17;
                        }
                        z ? (t1.verticalizable = !0, b.push({
                            glyph: y,
                            imageName: k,
                            x: p,
                            y: f + M,
                            vertical: z,
                            scale: g,
                            localGlyph: v.localGlyph,
                            fontStack: o.fontStack,
                            sectionIndex: d,
                            metrics: v,
                            rect: S
                        }), p += I * g + u) : (b.push({
                            glyph: y,
                            imageName: k,
                            x: p,
                            y: f + M,
                            vertical: z,
                            scale: g,
                            localGlyph: v.localGlyph,
                            fontStack: o.fontStack,
                            sectionIndex: d,
                            metrics: v,
                            rect: S
                        }), p += v.advance * g + u);
                    }
                    0 !== b.length && (d = Math.max(p - u, d), m ? np(b, y, _, A, s * i / 2) : np(b, y, _, 0, s / 2)), p = 0;
                    const S = s * i + _;
                    v.lineOffset = Math.max(_, o), f += S, ++g;
                }
                var x;
                const v = f, { horizontalAlign: b, verticalAlign: _ } = rp(a);
                (function(t1, e1, r, n, i, s) {
                    const a = (e1 - r) * i, o = -s * n;
                    for (const e1 of t1)for (const t1 of e1.positionedGlyphs)t1.x += a, t1.y += o;
                })(t1.positionedLines, y, b, _, d, v), t1.top += -_ * v, t1.bottom = t1.top + v, t1.left += -b * d, t1.right = t1.left + d, t1.hasBaseline = m;
            }(_, e1, r, n, g, a, o, l, h, u, p, y), !function(t1) {
                for (const e1 of t1)if (0 !== e1.positionedGlyphs.length) return !1;
                return !0;
            }(b) && _;
        }
        const Kh = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, Hh = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function Yh(t1, e1, r, n, i, s) {
            if (e1.imageName) {
                const t1 = n[e1.imageName];
                return t1 ? t1.displaySize[0] * e1.scale * ah / s + i : 0;
            }
            {
                const n = r[e1.fontStack], s = n && n.glyphs[t1];
                return s ? s.metrics.advance * e1.scale + i : 0;
            }
        }
        function Wh(t1, e1, r, n) {
            const i = Math.pow(t1 - e1, 2);
            return n ? t1 < e1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function Jh(t1, e1, r) {
            let n = 0;
            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e1 && 65289 !== e1 || (n += 50), n;
        }
        function Qh(t1, e1, r, n, i, s) {
            let a = null, o = Wh(e1, r, i, s);
            for (const t1 of n){
                const n = Wh(e1 - t1.x, r, i, s) + t1.badness;
                n <= o && (a = t1, o = n);
            }
            return {
                index: t1,
                x: e1,
                priorBreak: a,
                badness: o
            };
        }
        function tp(t1) {
            return t1 ? tp(t1.priorBreak).concat(t1.index) : [];
        }
        function ep(t1, e1, r, n, i, s, a) {
            if ("point" !== s) return [];
            if (!t1) return [];
            const o = [], l = function(t1, e1, r, n, i, s) {
                let a = 0;
                for(let r = 0; r < t1.length(); r++){
                    const o = t1.getSection(r);
                    a += Yh(t1.getCharCode(r), o, n, i, e1, s);
                }
                return a / Math.max(1, Math.ceil(a / r));
            }(t1, e1, r, n, i, a), u = t1.text.indexOf("\u200B") >= 0;
            let c = 0;
            for(let r = 0; r < t1.length(); r++){
                const s = t1.getSection(r), p = t1.getCharCode(r);
                if (Kh[p] || (c += Yh(p, s, n, i, e1, a)), r < t1.length() - 1) {
                    const e1 = !((h = p) < 11904 || !(Hi(h) || Ki(h) || ls(h) || ss(h) || Qi(h) || Oi(h) || Yi(h) || Gi(h) || ts(h) || es(h) || Ji(h) || hs(h) || Zi(h) || Ni(h) || qi(h) || Wi(h) || Xi(h) || os(h) || ns(h) || rs(h)));
                    (Hh[p] || e1 || s.imageName) && o.push(Qh(r + 1, c, l, o, Jh(p, t1.getCharCode(r + 1), e1 && u), !1));
                }
            }
            var h;
            return tp(Qh(t1.length(), c, l, o, 0, !0));
        }
        function rp(t1) {
            let e1 = .5, r = .5;
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    e1 = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e1 = 0;
            }
            switch(t1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e1,
                verticalAlign: r
            };
        }
        function np(t1, e1, r, n, i) {
            if (!(e1 || r || n || i)) return;
            const s = t1.length - 1, a = t1[s], o = (a.x + a.metrics.advance * a.scale) * e1;
            for(let e1 = 0; e1 <= s; e1++)t1[e1].x -= o, t1[e1].y += r + n + i;
        }
        function ip(t1, e1, r) {
            const { horizontalAlign: n, verticalAlign: i } = rp(r), s = e1[0] - t1.displaySize[0] * n, a = e1[1] - t1.displaySize[1] * i;
            return {
                image: t1,
                top: a,
                bottom: a + t1.displaySize[1],
                left: s,
                right: s + t1.displaySize[0]
            };
        }
        function sp(t1, e1, r, n, i, s) {
            const a = t1.image;
            let o;
            if (a.content) {
                const t1 = a.content, e1 = a.pixelRatio || 1;
                o = [
                    t1[0] / e1,
                    t1[1] / e1,
                    a.displaySize[0] - t1[2] / e1,
                    a.displaySize[1] - t1[3] / e1
                ];
            }
            const l = e1.left * s, u = e1.right * s;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - a.displaySize[0]) / 2, h = f + a.displaySize[0]);
            const d = e1.top * s, y = e1.bottom * s;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + y + n[2]) : (c = i[1] + (d + y - a.displaySize[1]) / 2, p = c + a.displaySize[1]), {
                image: a,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: o
            };
        }
        class ap extends i {
            clone() {
                return new ap(this.x, this.y, this.z, this.angle, this.segment);
            }
            constructor(t1, e1, r, n, i){
                super(t1, e1), this.angle = n, this.z = r, void 0 !== i && (this.segment = i);
            }
        }
        function op(t1, e1, r, n, i) {
            if (void 0 === e1.segment) return !0;
            let s = e1, a = e1.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (a--, a < 0) return !1;
                o -= t1[a].dist(s), s = t1[a];
            }
            o += t1[a].dist(t1[a + 1]), a++;
            const l = [];
            let u = 0;
            for(; o < r / 2;){
                const e1 = t1[a], r = t1[a + 1];
                if (!r) return !1;
                let s = t1[a - 1].angleTo(e1) - e1.angleTo(r);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: s
                }), u += s; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                a++, o += e1.dist(r);
            }
            return !0;
        }
        function lp(t1) {
            let e1 = 0;
            for(let r = 0; r < t1.length - 1; r++)e1 += t1[r].dist(t1[r + 1]);
            return e1;
        }
        function up(t1, e1, r) {
            return t1 ? .6 * e1 * r : 0;
        }
        function cp(t1, e1) {
            return Math.max(t1 ? t1.right - t1.left : 0, e1 ? e1.right - e1.left : 0);
        }
        function hp(t1, e1, r, n, i, s) {
            const a = up(r, i, s), o = cp(r, n) * s;
            let l = 0;
            const u = lp(t1) / 2;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1], s = n.dist(i);
                if (l + s > u) {
                    const c = (u - l) / s, h = xr(n.x, i.x, c), p = xr(n.y, i.y, c), f = new ap(h, p, 0, i.angleTo(n), r);
                    return !a || op(t1, f, o, a, e1) ? f : void 0;
                }
                l += s;
            }
        }
        function pp(t1, e1, r, n, i, s, a, o, l) {
            const u = up(n, s, a), c = cp(n, i), h = c * a, p = 0 === t1[0].x || t1[0].x === l || 0 === t1[0].y || t1[0].y === l;
            return e1 - h < e1 / 4 && (e1 = h + e1 / 4), fp(t1, p ? e1 / 2 * o % e1 : (c / 2 + 2 * s) * a * o % e1, e1, u, r, h, p, !1, l);
        }
        function fp(t1, e1, r, n, i, s, a, o, l) {
            const u = s / 2, c = lp(t1);
            let h = 0, p = e1 - r, f = [];
            for(let e1 = 0; e1 < t1.length - 1; e1++){
                const a = t1[e1], o = t1[e1 + 1], d = a.dist(o), y = o.angleTo(a);
                for(; p + r < h + d;){
                    p += r;
                    const m = (p - h) / d, g = xr(a.x, o.x, m), x = xr(a.y, o.y, m);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new ap(g, x, 0, y, e1);
                        r._round(), n && !op(t1, r, s, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return o || f.length || a || (f = fp(t1, h / 2, r, n, i, s, a, !0, l)), f;
        }
        function dp(t1, e1, r, n, s) {
            const a = [];
            for(let o = 0; o < t1.length; o++){
                const l = t1[o];
                let u;
                for(let t1 = 0; t1 < l.length - 1; t1++){
                    let o = l[t1], c = l[t1 + 1];
                    o.x < e1 && c.x < e1 || (o.x < e1 ? o = new i(e1, o.y + (e1 - o.x) / (c.x - o.x) * (c.y - o.y))._round() : c.x < e1 && (c = new i(e1, o.y + (e1 - o.x) / (c.x - o.x) * (c.y - o.y))._round()), o.y < r && c.y < r || (o.y < r ? o = new i(o.x + (r - o.y) / (c.y - o.y) * (c.x - o.x), r)._round() : c.y < r && (c = new i(o.x + (r - o.y) / (c.y - o.y) * (c.x - o.x), r)._round()), o.x >= n && c.x >= n || (o.x >= n ? o = new i(n, o.y + (n - o.x) / (c.x - o.x) * (c.y - o.y))._round() : c.x >= n && (c = new i(n, o.y + (n - o.x) / (c.x - o.x) * (c.y - o.y))._round()), o.y >= s && c.y >= s || (o.y >= s ? o = new i(o.x + (s - o.y) / (c.y - o.y) * (c.x - o.x), s)._round() : c.y >= s && (c = new i(o.x + (s - o.y) / (c.y - o.y) * (c.x - o.x), s)._round()), u && o.equals(u[u.length - 1]) || (u = [
                        o
                    ], a.push(u)), u.push(c)))));
                }
            }
            return a;
        }
        Pi(ap, "Anchor");
        const yp = 1e20;
        function mp(t1, e1, r, n, i, s, a, o, l) {
            for(let u = e1; u < e1 + n; u++)gp(t1, r * s + u, s, i, a, o, l);
            for(let u = r; u < r + i; u++)gp(t1, u * s + e1, 1, n, a, o, l);
        }
        function gp(t1, e1, r, n, i, s, a) {
            s[0] = 0, a[0] = -yp, a[1] = yp, i[0] = t1[e1];
            for(let o = 1, l = 0, u = 0; o < n; o++){
                i[o] = t1[e1 + o * r];
                const n = o * o;
                do {
                    const t1 = s[l];
                    u = (i[o] - i[t1] + n - t1 * t1) / (o - t1) / 2;
                }while (u <= a[l] && --l > -1);
                l++, s[l] = o, a[l] = u, a[l + 1] = yp;
            }
            for(let o = 0, l = 0; o < n; o++){
                for(; a[l + 1] < o;)l++;
                const n = s[l], u = o - n;
                t1[e1 + o * r] = i[n] + u * u;
            }
        }
        const xp = {
            none: 0,
            ideographs: 1,
            all: 2
        };
        class vp {
            setURL(t1) {
                this.url = t1;
            }
            getGlyphs(t1, e1) {
                const r = [];
                for(const e1 in t1)for (const n of t1[e1])r.push({
                    stack: e1,
                    id: n
                });
                g(r, ({ stack: t1, id: e1 }, r)=>{
                    let n = this.entries[t1];
                    n || (n = this.entries[t1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {},
                        ascender: void 0,
                        descender: void 0
                    });
                    let i = n.glyphs[e1];
                    if (void 0 !== i) return void r(null, {
                        stack: t1,
                        id: e1,
                        glyph: i
                    });
                    if (i = this._tinySDF(n, t1, e1), i) return n.glyphs[e1] = i, void r(null, {
                        stack: t1,
                        id: e1,
                        glyph: i
                    });
                    const s = Math.floor(e1 / 256);
                    if (256 * s > 65535) return void r(new Error("glyphs > 65535 not supported"));
                    if (n.ranges[s]) return void r(null, {
                        stack: t1,
                        id: e1,
                        glyph: i
                    });
                    let a = n.requests[s];
                    a || (a = n.requests[s] = [], vp.loadGlyphRange(t1, s, this.url, this.requestManager, (t1, e1)=>{
                        if (e1) {
                            n.ascender = e1.ascender, n.descender = e1.descender;
                            for(const t1 in e1.glyphs)this._doesCharSupportLocalGlyph(+t1) || (n.glyphs[+t1] = e1.glyphs[+t1]);
                            n.ranges[s] = !0;
                        }
                        for (const r of a)r(t1, e1);
                        delete n.requests[s];
                    })), a.push((n, i)=>{
                        n ? r(n) : i && r(null, {
                            stack: t1,
                            id: e1,
                            glyph: i.glyphs[e1] || null
                        });
                    });
                }, (t1, r)=>{
                    if (t1) e1(t1);
                    else if (r) {
                        const t1 = {};
                        for (const { stack: e1, id: n, glyph: i } of r)void 0 === t1[e1] && (t1[e1] = {}), void 0 === t1[e1].glyphs && (t1[e1].glyphs = {}), t1[e1].glyphs[n] = i && {
                            id: i.id,
                            bitmap: i.bitmap.clone(),
                            metrics: i.metrics
                        }, t1[e1].ascender = this.entries[e1].ascender, t1[e1].descender = this.entries[e1].descender;
                        e1(null, t1);
                    }
                });
            }
            _doesCharSupportLocalGlyph(t1) {
                return this.localGlyphMode !== xp.none && (this.localGlyphMode === xp.all ? !!this.localFontFamily : !!this.localFontFamily && (es(t1) || is(t1) || Zi(t1) || Xi(t1) || Gi(t1)));
            }
            _tinySDF(t1, e1, r) {
                const n = this.localFontFamily;
                if (!n || !this._doesCharSupportLocalGlyph(r)) return;
                let i = t1.tinySDF;
                if (!i) {
                    let r = "400";
                    /bold/i.test(e1) ? r = "900" : /medium/i.test(e1) ? r = "500" : /light/i.test(e1) && (r = "200"), i = t1.tinySDF = new vp.TinySDF({
                        fontFamily: n,
                        fontWeight: r,
                        fontSize: 48,
                        buffer: 6,
                        radius: 16
                    }), i.fontWeight = r;
                }
                if (this.localGlyphs[i.fontWeight][r]) return this.localGlyphs[i.fontWeight][r];
                const s = String.fromCharCode(r), { data: a, width: o, height: l, glyphWidth: u, glyphHeight: c, glyphLeft: h, glyphTop: p, glyphAdvance: f } = i.draw(s);
                return this.localGlyphs[i.fontWeight][r] = {
                    id: r,
                    bitmap: new hu({
                        width: o,
                        height: l
                    }, a),
                    metrics: {
                        width: u / 2,
                        height: c / 2,
                        left: h / 2,
                        top: p / 2 - 27,
                        advance: f / 2,
                        localGlyph: !0
                    }
                };
            }
            constructor(t1, e1, r){
                this.requestManager = t1, this.localGlyphMode = e1, this.localFontFamily = r, this.entries = {}, this.localGlyphs = {
                    200: {},
                    400: {},
                    500: {},
                    900: {}
                };
            }
        }
        function bp(t1, e1, r, n) {
            const s = [], a = t1.image, o = a.pixelRatio, l = a.paddedRect.w - 2, u = a.paddedRect.h - 2, c = t1.right - t1.left, h = t1.bottom - t1.top, p = a.stretchX || [
                [
                    0,
                    l
                ]
            ], f = a.stretchY || [
                [
                    0,
                    u
                ]
            ], d = (t1, e1)=>t1 + e1[1] - e1[0], y = p.reduce(d, 0), m = f.reduce(d, 0), g = l - y, x = u - m;
            let v = 0, b = y, _ = 0, w = m, A = 0, S = g, k = 0, I = x;
            if (a.content && n) {
                const t1 = a.content;
                v = _p(p, 0, t1[0]), _ = _p(f, 0, t1[1]), b = _p(p, t1[0], t1[2]), w = _p(f, t1[1], t1[3]), A = t1[0] - v, k = t1[1] - _, S = t1[2] - t1[0] - b, I = t1[3] - t1[1] - w;
            }
            const M = (n, s, l, u)=>{
                const p = Ap(n.stretch - v, b, c, t1.left), f = Sp(n.fixed - A, S, n.stretch, y), d = Ap(s.stretch - _, w, h, t1.top), g = Sp(s.fixed - k, I, s.stretch, m), x = Ap(l.stretch - v, b, c, t1.left), M = Sp(l.fixed - A, S, l.stretch, y), z = Ap(u.stretch - _, w, h, t1.top), T = Sp(u.fixed - k, I, u.stretch, m), B = new i(p, d), E = new i(x, d), C = new i(x, z), P = new i(p, z), D = new i(f / o, g / o), V = new i(M / o, T / o), F = e1 * Math.PI / 180;
                if (F) {
                    const t1 = Math.sin(F), e1 = Math.cos(F), r = [
                        e1,
                        -t1,
                        t1,
                        e1
                    ];
                    B._matMult(r), E._matMult(r), P._matMult(r), C._matMult(r);
                }
                const L = n.stretch + n.fixed, R = s.stretch + s.fixed;
                return {
                    tl: B,
                    tr: E,
                    bl: P,
                    br: C,
                    tex: {
                        x: a.paddedRect.x + 1 + L,
                        y: a.paddedRect.y + 1 + R,
                        w: l.stretch + l.fixed - L,
                        h: u.stretch + u.fixed - R
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: D,
                    pixelOffsetBR: V,
                    minFontScaleX: S / o / c,
                    minFontScaleY: I / o / h,
                    isSDF: r
                };
            };
            if (n && (a.stretchX || a.stretchY)) {
                const t1 = wp(p, g, y), e1 = wp(f, x, m);
                for(let r = 0; r < t1.length - 1; r++){
                    const n = t1[r], i = t1[r + 1];
                    for(let t1 = 0; t1 < e1.length - 1; t1++)s.push(M(n, e1[t1], i, e1[t1 + 1]));
                }
            } else s.push(M({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return s;
        }
        function _p(t1, e1, r) {
            let n = 0;
            for (const i of t1)n += Math.max(e1, Math.min(r, i[1])) - Math.max(e1, Math.min(r, i[0]));
            return n;
        }
        function wp(t1, e1, r) {
            const n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            for (const [e1, r] of t1){
                const t1 = n[n.length - 1];
                n.push({
                    fixed: e1 - t1.stretch,
                    stretch: t1.stretch
                }), n.push({
                    fixed: e1 - t1.stretch,
                    stretch: t1.stretch + (r - e1)
                });
            }
            return n.push({
                fixed: e1 + 1,
                stretch: r
            }), n;
        }
        function Ap(t1, e1, r, n) {
            return t1 / e1 * r + n;
        }
        function Sp(t1, e1, r, n) {
            return t1 - e1 * r / n;
        }
        function kp(t1, e1, r, n) {
            const i = e1 + t1.positionedLines[n].lineOffset;
            return 0 === n ? r + i / 2 : r + (i + (e1 + t1.positionedLines[n - 1].lineOffset)) / 2;
        }
        vp.loadGlyphRange = function(t1, e1, r, n, i) {
            const s = 256 * e1, a = s + 255, o = n.transformRequest(n.normalizeGlyphsURL(r).replace("{fontstack}", t1).replace("{range}", `${s}-${a}`), zt.Glyphs);
            Ct(o, (t1, e1)=>{
                if (t1) i(t1);
                else if (e1) {
                    const t1 = {}, r = function(t1) {
                        return new xh(t1).readFields(Rh, {});
                    }(e1);
                    for (const e1 of r.glyphs)t1[e1.id] = e1;
                    i(null, {
                        glyphs: t1,
                        ascender: r.ascender,
                        descender: r.descender
                    });
                }
            });
        }, vp.TinySDF = class {
            _createCanvas(t1) {
                const e1 = document.createElement("canvas");
                return e1.width = e1.height = t1, e1;
            }
            draw(t1) {
                const { width: e1, actualBoundingBoxAscent: r, actualBoundingBoxDescent: n, actualBoundingBoxLeft: i, actualBoundingBoxRight: s } = this.ctx.measureText(t1), a = Math.ceil(r), o = Math.min(this.size - this.buffer, Math.ceil(s - i)), l = Math.min(this.size - this.buffer, a + Math.ceil(n)), u = o + 2 * this.buffer, c = l + 2 * this.buffer, h = Math.max(u * c, 0), p = new Uint8ClampedArray(h), f = {
                    data: p,
                    width: u,
                    height: c,
                    glyphWidth: o,
                    glyphHeight: l,
                    glyphTop: a,
                    glyphLeft: 0,
                    glyphAdvance: e1
                };
                if (0 === o || 0 === l) return f;
                const { ctx: d, buffer: y, gridInner: m, gridOuter: g } = this;
                d.clearRect(y, y, o, l), d.fillText(t1, y, y + a);
                const x = d.getImageData(y, y, o, l);
                g.fill(yp, 0, h), m.fill(0, 0, h);
                for(let t1 = 0; t1 < l; t1++)for(let e1 = 0; e1 < o; e1++){
                    const r = x.data[4 * (t1 * o + e1) + 3] / 255;
                    if (0 === r) continue;
                    const n = (t1 + y) * u + e1 + y;
                    if (1 === r) g[n] = 0, m[n] = yp;
                    else {
                        const t1 = .5 - r;
                        g[n] = t1 > 0 ? t1 * t1 : 0, m[n] = t1 < 0 ? t1 * t1 : 0;
                    }
                }
                mp(g, 0, 0, u, c, u, this.f, this.v, this.z), mp(m, y, y, o, l, u, this.f, this.v, this.z);
                for(let t1 = 0; t1 < h; t1++){
                    const e1 = Math.sqrt(g[t1]) - Math.sqrt(m[t1]);
                    p[t1] = Math.round(255 - 255 * (e1 / this.radius + this.cutoff));
                }
                return f;
            }
            constructor({ fontSize: t1 = 24, buffer: e1 = 3, radius: r = 8, cutoff: n = .25, fontFamily: i = "sans-serif", fontWeight: s = "normal", fontStyle: a = "normal" } = {}){
                this.buffer = e1, this.cutoff = n, this.radius = r;
                const o = this.size = t1 + 4 * e1, l = this._createCanvas(o), u = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                u.font = `${a} ${s} ${t1}px ${i}`, u.textBaseline = "alphabetic", u.textAlign = "left", u.fillStyle = "black", this.gridOuter = new Float64Array(o * o), this.gridInner = new Float64Array(o * o), this.f = new Float64Array(o), this.z = new Float64Array(o + 1), this.v = new Uint16Array(o);
            }
        };
        class Ip {
            push(t1) {
                this.data.push(t1), this.length++, this._up(this.length - 1);
            }
            pop() {
                if (0 === this.length) return;
                const t1 = this.data[0], e1 = this.data.pop();
                return this.length--, this.length > 0 && (this.data[0] = e1, this._down(0)), t1;
            }
            peek() {
                return this.data[0];
            }
            _up(t1) {
                const { data: e1, compare: r } = this, n = e1[t1];
                for(; t1 > 0;){
                    const i = t1 - 1 >> 1, s = e1[i];
                    if (r(n, s) >= 0) break;
                    e1[t1] = s, t1 = i;
                }
                e1[t1] = n;
            }
            _down(t1) {
                const { data: e1, compare: r } = this, n = this.length >> 1, i = e1[t1];
                for(; t1 < n;){
                    let n = 1 + (t1 << 1), s = e1[n];
                    const a = n + 1;
                    if (a < this.length && r(e1[a], s) < 0 && (n = a, s = e1[a]), r(s, i) >= 0) break;
                    e1[t1] = s, t1 = n;
                }
                e1[t1] = i;
            }
            constructor(t1 = [], e1 = Mp){
                if (this.data = t1, this.length = this.data.length, this.compare = e1, this.length > 0) for(let t1 = (this.length >> 1) - 1; t1 >= 0; t1--)this._down(t1);
            }
        }
        function Mp(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function zp(t1, e1 = 1, r = !1) {
            let n = 1 / 0, s = 1 / 0, a = -1 / 0, o = -1 / 0;
            const l = t1[0];
            for(let t1 = 0; t1 < l.length; t1++){
                const e1 = l[t1];
                (!t1 || e1.x < n) && (n = e1.x), (!t1 || e1.y < s) && (s = e1.y), (!t1 || e1.x > a) && (a = e1.x), (!t1 || e1.y > o) && (o = e1.y);
            }
            const u = Math.min(a - n, o - s);
            let c = u / 2;
            const h = new Ip([], Tp);
            if (0 === u) return new i(n, s);
            for(let e1 = n; e1 < a; e1 += u)for(let r = s; r < o; r += u)h.push(new Bp(e1 + c, r + c, c, t1));
            let p = function(t1) {
                let e1 = 0, r = 0, n = 0;
                const i = t1[0];
                for(let t1 = 0, s = i.length, a = s - 1; t1 < s; a = t1++){
                    const s = i[t1], o = i[a], l = s.x * o.y - o.x * s.y;
                    r += (s.x + o.x) * l, n += (s.y + o.y) * l, e1 += 3 * l;
                }
                return new Bp(r / e1, n / e1, 0, t1);
            }(t1), f = h.length;
            for(; h.length;){
                const n = h.pop();
                (n.d > p.d || !p.d) && (p = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, f)), n.max - p.d <= e1 || (c = n.h / 2, h.push(new Bp(n.p.x - c, n.p.y - c, c, t1)), h.push(new Bp(n.p.x + c, n.p.y - c, c, t1)), h.push(new Bp(n.p.x - c, n.p.y + c, c, t1)), h.push(new Bp(n.p.x + c, n.p.y + c, c, t1)), f += 4);
            }
            return r && (console.log(`num probes: ${f}`), console.log(`best distance: ${p.d}`)), p.p;
        }
        function Tp(t1, e1) {
            return e1.max - t1.max;
        }
        function Bp(t1, e1, r, n) {
            this.p = new i(t1, e1), this.h = r, this.d = function(t1, e1) {
                let r = !1, n = 1 / 0;
                for(let i = 0; i < e1.length; i++){
                    const s = e1[i];
                    for(let e1 = 0, i = s.length, a = i - 1; e1 < i; a = e1++){
                        const i = s[e1], o = s[a];
                        i.y > t1.y != o.y > t1.y && t1.x < (o.x - i.x) * (t1.y - i.y) / (o.y - i.y) + i.x && (r = !r), n = Math.min(n, rl(t1, i, o));
                    }
                }
                return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
        }
        const Ep = Number.POSITIVE_INFINITY, Cp = Math.sqrt(2);
        function Pp(t1, e1) {
            return e1[1] !== Ep ? function(t1, e1, r) {
                let n = 0, i = 0;
                switch(e1 = Math.abs(e1), r = Math.abs(r), t1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e1;
                }
                return [
                    n,
                    i
                ];
            }(t1, e1[0], e1[1]) : function(t1, e1) {
                let r = 0, n = 0;
                e1 < 0 && (e1 = 0);
                const i = e1 / Cp;
                switch(t1){
                    case "top-right":
                    case "top-left":
                        n = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = 7 - i;
                        break;
                    case "bottom":
                        n = 7 - e1;
                        break;
                    case "top":
                        n = e1 - 7;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = e1;
                        break;
                    case "right":
                        r = -e1;
                }
                return [
                    r,
                    n
                ];
            }(t1, e1[0]);
        }
        function Dp(t1, e1, r, n, i, s, a, o, l, u) {
            t1.createArrays(), t1.tilePixelRatio = wo / (512 * t1.overscaling), t1.compareText = {}, t1.iconsNeedLinear = !1;
            const c = t1.layers[0].layout, h = t1.layers[0]._unevaluatedLayout._values, p = {};
            if ("composite" === t1.textSizeData.kind) {
                const { minZoom: e1, maxZoom: r } = t1.textSizeData;
                p.compositeTextSizes = [
                    h["text-size"].possiblyEvaluate(new Cs(e1), o),
                    h["text-size"].possiblyEvaluate(new Cs(r), o)
                ];
            }
            if ("composite" === t1.iconSizeData.kind) {
                const { minZoom: e1, maxZoom: r } = t1.iconSizeData;
                p.compositeIconSizes = [
                    h["icon-size"].possiblyEvaluate(new Cs(e1), o),
                    h["icon-size"].possiblyEvaluate(new Cs(r), o)
                ];
            }
            p.layoutTextSize = h["text-size"].possiblyEvaluate(new Cs(l + 1), o), p.layoutIconSize = h["icon-size"].possiblyEvaluate(new Cs(l + 1), o), p.textMaxSize = h["text-size"].possiblyEvaluate(new Cs(18), o);
            const f = "map" === c.get("text-rotation-alignment") && "point" !== c.get("symbol-placement"), d = c.get("text-size");
            for (const s of t1.features){
                const l = c.get("text-font").evaluate(s, {}, o).join(","), h = d.evaluate(s, {}, o), y = p.layoutTextSize.evaluate(s, {}, o), m = (p.layoutIconSize.evaluate(s, {}, o), {
                    horizontal: {},
                    vertical: void 0
                }), g = s.text;
                let x, v = [
                    0,
                    0
                ];
                if (g) {
                    const n = g.toString(), a = c.get("text-letter-spacing").evaluate(s, {}, o) * ah, u = c.get("text-line-height").evaluate(s, {}, o) * ah, p = fs(n) ? a : 0, d = c.get("text-anchor").evaluate(s, {}, o), x = c.get("text-variable-anchor");
                    if (!x) {
                        const t1 = c.get("text-radial-offset").evaluate(s, {}, o);
                        v = t1 ? Pp(d, [
                            t1 * ah,
                            Ep
                        ]) : c.get("text-offset").evaluate(s, {}, o).map((t1)=>t1 * ah);
                    }
                    let b = f ? "center" : c.get("text-justify").evaluate(s, {}, o);
                    const _ = c.get("symbol-placement"), w = "point" === _, A = "point" === _ ? c.get("text-max-width").evaluate(s, {}, o) * ah : 0, S = (s)=>{
                        t1.allowVerticalPlacement && ps(n) && (m.vertical = Xh(g, e1, r, i, l, A, u, d, s, p, v, Nh.vertical, !0, _, y, h));
                    };
                    if (!f && x) {
                        const t1 = "auto" === b ? x.map((t1)=>Vp(t1)) : [
                            b
                        ];
                        let n = !1;
                        for(let s = 0; s < t1.length; s++){
                            const a = t1[s];
                            if (!m.horizontal[a]) {
                                if (n) m.horizontal[a] = m.horizontal[0];
                                else {
                                    const t1 = Xh(g, e1, r, i, l, A, u, "center", a, p, v, Nh.horizontal, !1, _, y, h);
                                    t1 && (m.horizontal[a] = t1, n = 1 === t1.positionedLines.length);
                                }
                            }
                        }
                        S("left");
                    } else {
                        if ("auto" === b && (b = Vp(d)), w || c.get("text-writing-mode").indexOf("horizontal") >= 0 || !ps(n)) {
                            const t1 = Xh(g, e1, r, i, l, A, u, d, b, p, v, Nh.horizontal, !1, _, y, h);
                            t1 && (m.horizontal[b] = t1);
                        }
                        S("point" === _ ? "left" : b);
                    }
                }
                let b = !1;
                if (s.icon && s.icon.name) {
                    const e1 = n[s.icon.name];
                    e1 && (x = ip(i[s.icon.name], c.get("icon-offset").evaluate(s, {}, o), c.get("icon-anchor").evaluate(s, {}, o)), b = e1.sdf, void 0 === t1.sdfIcons ? t1.sdfIcons = e1.sdf : t1.sdfIcons !== e1.sdf && E("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (e1.pixelRatio !== t1.pixelRatio || 0 !== c.get("icon-rotate").constantOr(1)) && (t1.iconsNeedLinear = !0));
                }
                const _ = Up(m.horizontal) || m.vertical;
                t1.iconsInText || (t1.iconsInText = !!_ && _.iconsInText), (_ || x) && Fp(t1, s, m, x, n, p, y, 0, v, b, a, o, u);
            }
            s && t1.generateCollisionDebugBuffers(l, t1.collisionBoxArray);
        }
        function Vp(t1) {
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function Fp(t1, e1, r, n, i, s, a, o, u, c, h, p, f) {
            let d = s.textMaxSize.evaluate(e1, {}, p);
            void 0 === d && (d = a);
            const y = t1.layers[0].layout, m = y.get("icon-offset").evaluate(e1, {}, p), g = Up(r.horizontal) || r.vertical, x = "globe" === f.name, v = a / 24, b = t1.tilePixelRatio * d / 24, _ = (T = t1.overscaling, t1.zoom > 18 && T > 2 && (T >>= 1), Math.max(wo / (512 * T), 1) * y.get("symbol-spacing")), w = y.get("text-padding") * t1.tilePixelRatio, A = y.get("icon-padding") * t1.tilePixelRatio, S = l(y.get("text-max-angle")), k = "map" === y.get("text-rotation-alignment") && "point" !== y.get("symbol-placement"), I = "map" === y.get("icon-rotation-alignment") && "point" !== y.get("symbol-placement"), M = y.get("symbol-placement"), z = _ / 2;
            var T;
            const B = y.get("icon-text-fit");
            let C;
            n && "none" !== B && (t1.allowVerticalPlacement && r.vertical && (C = sp(n, r.vertical, B, y.get("icon-text-fit-padding"), m, v)), g && (n = sp(n, g, B, y.get("icon-text-fit-padding"), m, v)));
            const P = (a, o, l)=>{
                if (o.x < 0 || o.x >= wo || o.y < 0 || o.y >= wo) return;
                let d = null;
                if (x) {
                    const { x: t1, y: e1, z: r } = f.projectTilePoint(o.x, o.y, l);
                    d = {
                        anchor: new ap(t1, e1, r, 0, void 0),
                        up: f.upVector(l, o.x, o.y)
                    };
                }
                !function(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, _, w, A, S) {
                    const k = t1.addToLineVertexArray(e1, n);
                    let I, M, z, T, B, C, P, D = 0, V = 0, F = 0, L = 0, R = -1, U = -1;
                    const j = {};
                    let $ = Na("");
                    const O = r ? r.anchor : e1;
                    let q = 0, N = 0;
                    if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset") ? [q, N] = l.layout.get("text-offset").evaluate(b, {}, S).map((t1)=>t1 * ah) : (q = l.layout.get("text-radial-offset").evaluate(b, {}, S) * ah, N = Ep), t1.allowVerticalPlacement && i.vertical) {
                        const t1 = i.vertical;
                        if (d) C = $p(t1), o && (P = $p(o));
                        else {
                            const r = l.layout.get("text-rotate").evaluate(b, {}, S) + 90;
                            z = jp(u, O, e1, c, h, p, t1, f, r, y), o && (T = jp(u, O, e1, c, h, p, o, g, r));
                        }
                    }
                    if (s) {
                        const n = l.layout.get("icon-rotate").evaluate(b, {}, S), i = "none" !== l.layout.get("icon-text-fit"), a = bp(s, n, w, i), f = o ? bp(o, n, w, i) : void 0;
                        M = jp(u, O, e1, c, h, p, s, g, n), D = 4 * a.length;
                        const d = t1.iconSizeData;
                        let y = null;
                        "source" === d.kind ? (y = [
                            oh * l.layout.get("icon-size").evaluate(b, {}, S)
                        ], y[0] > Lp && E(`${t1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : "composite" === d.kind && (y = [
                            oh * _.compositeIconSizes[0].evaluate(b, {}, S),
                            oh * _.compositeIconSizes[1].evaluate(b, {}, S)
                        ], (y[0] > Lp || y[1] > Lp) && E(`${t1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), t1.addSymbols(t1.icon, a, y, v, x, b, !1, r, e1, k.lineStartIndex, k.lineLength, -1, A, S), R = t1.icon.placedSymbolArray.length - 1, f && (V = 4 * f.length, t1.addSymbols(t1.icon, f, y, v, x, b, Nh.vertical, r, e1, k.lineStartIndex, k.lineLength, -1, A, S), U = t1.icon.placedSymbolArray.length - 1);
                    }
                    for(const n in i.horizontal){
                        const s = i.horizontal[n];
                        I || ($ = Na(s.text), d ? B = $p(s) : I = jp(u, O, e1, c, h, p, s, f, l.layout.get("text-rotate").evaluate(b, {}, S), y));
                        const o = 1 === s.positionedLines.length;
                        if (F += Rp(t1, r, e1, s, a, l, d, b, y, k, i.vertical ? Nh.horizontal : Nh.horizontalOnly, o ? Object.keys(i.horizontal) : [
                            n
                        ], j, R, _, A, S), o) break;
                    }
                    i.vertical && (L += Rp(t1, r, e1, i.vertical, a, l, d, b, y, k, Nh.vertical, [
                        "vertical"
                    ], j, U, _, A, S));
                    let G = -1;
                    const Z = (t1, e1)=>t1 ? Math.max(t1, e1) : e1;
                    G = Z(B, G), G = Z(C, G), G = Z(P, G);
                    const X = G > -1 ? 1 : 0;
                    t1.glyphOffsetArray.length >= Qf.MAX_GLYPHS && E("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b.sortKey && t1.addToSortKeyRanges(t1.symbolInstances.length, b.sortKey), t1.symbolInstances.emplaceBack(O.x, O.y, O.z, e1.x, e1.y, j.right >= 0 ? j.right : -1, j.center >= 0 ? j.center : -1, j.left >= 0 ? j.left : -1, j.vertical >= 0 ? j.vertical : -1, R, U, $, void 0 !== I ? I : t1.collisionBoxArray.length, void 0 !== I ? I + 1 : t1.collisionBoxArray.length, void 0 !== z ? z : t1.collisionBoxArray.length, void 0 !== z ? z + 1 : t1.collisionBoxArray.length, void 0 !== M ? M : t1.collisionBoxArray.length, void 0 !== M ? M + 1 : t1.collisionBoxArray.length, T || t1.collisionBoxArray.length, T ? T + 1 : t1.collisionBoxArray.length, c, F, L, D, V, X, 0, q, N, G);
                }(t1, o, d, a, r, n, i, C, t1.layers[0], t1.collisionBoxArray, e1.index, e1.sourceLayerIndex, t1.index, w, k, u, 0, A, I, m, e1, s, c, h, p);
            };
            if ("line" === M) for (const i of dp(e1.geometry, 0, 0, wo, wo)){
                const e1 = pp(i, _, S, r.vertical || g, n, 24, b, t1.overscaling, wo);
                for (const r of e1){
                    const e1 = g;
                    e1 && Op(t1, e1.text, z, r) || P(i, r, p);
                }
            }
            else if ("line-center" === M) {
                for (const t1 of e1.geometry)if (t1.length > 1) {
                    const e1 = hp(t1, S, r.vertical || g, n, 24, b);
                    e1 && P(t1, e1, p);
                }
            } else if ("Polygon" === e1.type) for (const t1 of Yu(e1.geometry, 0)){
                const e1 = zp(t1, 16);
                P(t1[0], new ap(e1.x, e1.y, 0, 0, void 0), p);
            }
            else if ("LineString" === e1.type) for (const t1 of e1.geometry)P(t1, new ap(t1[0].x, t1[0].y, 0, 0, void 0), p);
            else if ("Point" === e1.type) for (const t1 of e1.geometry)for (const e1 of t1)P([
                e1
            ], new ap(e1.x, e1.y, 0, 0, void 0), p);
        }
        const Lp = 32640;
        function Rp(t1, e1, r, n, s, a, o, l, u, c, h, p, f, d, y, m, g) {
            const x = function(t1, e1, r, n, s, a, o, l) {
                const u = [];
                if (0 === e1.positionedLines.length) return u;
                const c = n.layout.get("text-rotate").evaluate(a, {}) * Math.PI / 180, h = function(t1) {
                    const e1 = t1[0], r = t1[1], n = e1 * r;
                    return n > 0 ? [
                        e1,
                        -r
                    ] : n < 0 ? [
                        -e1,
                        r
                    ] : 0 === e1 ? [
                        r,
                        e1
                    ] : [
                        r,
                        -e1
                    ];
                }(r);
                let p = Math.abs(e1.top - e1.bottom);
                for (const t1 of e1.positionedLines)p -= t1.lineOffset;
                const f = e1.positionedLines.length, d = p / f;
                let y = e1.top - r[1];
                for(let t1 = 0; t1 < f; ++t1){
                    const n = e1.positionedLines[t1];
                    y = kp(e1, d, y, t1);
                    for (const t1 of n.positionedGlyphs){
                        if (!t1.rect) continue;
                        const n = t1.rect || {};
                        let a = 4, p = !0, f = 1, d = 0;
                        if (t1.imageName) {
                            const e1 = o[t1.imageName];
                            if (!e1) continue;
                            if (e1.sdf) {
                                E("SDF images are not supported in formatted text and will be ignored.");
                                continue;
                            }
                            p = !1, f = e1.pixelRatio, a = 1 / f;
                        }
                        const m = (s || l) && t1.vertical, g = t1.metrics.advance * t1.scale / 2, x = t1.metrics, v = t1.rect;
                        if (null === v) continue;
                        l && e1.verticalizable && (d = t1.imageName ? g - t1.metrics.width * t1.scale / 2 : 0);
                        const b = s ? [
                            t1.x + g,
                            t1.y
                        ] : [
                            0,
                            0
                        ];
                        let _ = [
                            0,
                            0
                        ], w = [
                            0,
                            0
                        ], A = !1;
                        s || (m ? (w = [
                            t1.x + g + h[0],
                            t1.y + h[1] - d
                        ], A = !0) : _ = [
                            t1.x + g + r[0],
                            t1.y + r[1] - d
                        ]);
                        const S = v.w * t1.scale / (f * (t1.localGlyph ? 2 : 1)), k = v.h * t1.scale / (f * (t1.localGlyph ? 2 : 1));
                        let I, M, z, T;
                        if (m) {
                            const e1 = t1.y - y, r = new i(-g, g - e1), n = -Math.PI / 2, s = new i(...w);
                            I = new i(-g + _[0], _[1]), I._rotateAround(n, r)._add(s), I.x += -e1 + g, I.y -= (x.left - a) * t1.scale;
                            const o = t1.imageName ? x.advance * t1.scale : ah * t1.scale, l = String.fromCharCode(t1.glyph);
                            dh(l) ? I.x += (1 - a) * t1.scale : yh(l) ? I.x += o - x.height * t1.scale + (-a - 1) * t1.scale : I.x += t1.imageName || x.width + 2 * a === v.w && x.height + 2 * a === v.h ? (o - k) / 2 : (o - (x.height + 2 * a) * t1.scale) / 2, M = new i(I.x, I.y - S), z = new i(I.x + k, I.y), T = new i(I.x + k, I.y - S);
                        } else {
                            const e1 = (x.left - a) * t1.scale - g + _[0], r = (-x.top - a) * t1.scale + _[1], n = e1 + S, s = r + k;
                            I = new i(e1, r), M = new i(n, r), z = new i(e1, s), T = new i(n, s);
                        }
                        if (c) {
                            let t1;
                            t1 = s ? new i(0, 0) : A ? new i(h[0], h[1]) : new i(r[0], r[1]), I._rotateAround(c, t1), M._rotateAround(c, t1), z._rotateAround(c, t1), T._rotateAround(c, t1);
                        }
                        const B = new i(0, 0), C = new i(0, 0);
                        u.push({
                            tl: I,
                            tr: M,
                            bl: z,
                            br: T,
                            tex: n,
                            writingMode: e1.writingMode,
                            glyphOffset: b,
                            sectionIndex: t1.sectionIndex,
                            isSDF: p,
                            pixelOffsetTL: B,
                            pixelOffsetBR: C,
                            minFontScaleX: 0,
                            minFontScaleY: 0
                        });
                    }
                }
                return u;
            }(0, n, u, a, o, l, s, t1.allowVerticalPlacement), v = t1.textSizeData;
            let b = null;
            "source" === v.kind ? (b = [
                oh * a.layout.get("text-size").evaluate(l, {}, g)
            ], b[0] > Lp && E(`${t1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : "composite" === v.kind && (b = [
                oh * y.compositeTextSizes[0].evaluate(l, {}, g),
                oh * y.compositeTextSizes[1].evaluate(l, {}, g)
            ], (b[0] > Lp || b[1] > Lp) && E(`${t1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), t1.addSymbols(t1.text, x, b, u, o, l, h, e1, r, c.lineStartIndex, c.lineLength, d, m, g);
            for (const e1 of p)f[e1] = t1.text.placedSymbolArray.length - 1;
            return 4 * x.length;
        }
        function Up(t1) {
            for(const e1 in t1)return t1[e1];
            return null;
        }
        function jp(t1, e1, r, n, s, a, o, u, c, h) {
            let p = o.top, f = o.bottom, d = o.left, y = o.right;
            const m = o.collisionPadding;
            if (m && (d -= m[0], p -= m[1], y += m[2], f += m[3]), c) {
                const t1 = new i(d, p), e1 = new i(y, p), r = new i(d, f), n = new i(y, f), s = l(c);
                let a = new i(0, 0);
                h && (a = new i(h[0], h[1])), t1._rotateAround(s, a), e1._rotateAround(s, a), r._rotateAround(s, a), n._rotateAround(s, a), d = Math.min(t1.x, e1.x, r.x, n.x), y = Math.max(t1.x, e1.x, r.x, n.x), p = Math.min(t1.y, e1.y, r.y, n.y), f = Math.max(t1.y, e1.y, r.y, n.y);
            }
            return t1.emplaceBack(e1.x, e1.y, e1.z, r.x, r.y, d, p, y, f, u, n, s, a), t1.length - 1;
        }
        function $p(t1) {
            t1.collisionPadding && (t1.top -= t1.collisionPadding[1], t1.bottom += t1.collisionPadding[3]);
            const e1 = t1.bottom - t1.top;
            return e1 > 0 ? Math.max(10, e1) : null;
        }
        function Op(t1, e1, r, n) {
            const i = t1.compareText;
            if (e1 in i) {
                const t1 = i[e1];
                for(let e1 = t1.length - 1; e1 >= 0; e1--)if (n.dist(t1[e1]) < r) return !0;
            } else i[e1] = [];
            return i[e1].push(n), !1;
        }
        const qp = Ws([
            {
                type: "Float32",
                name: "a_globe_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]), { members: Np } = qp, Gp = Ws([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            }
        ]);
        var Zp = Ws([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        const Xp = wo / Math.PI / 2, Kp = 2 * Bo(1, 0) * Xp * Math.PI, Hp = [
            64,
            32,
            16
        ], Yp = -Xp, Wp = Xp, Jp = [
            new eu([
                Yp,
                Yp,
                Yp
            ], [
                Wp,
                Wp,
                Wp
            ]),
            new eu([
                Yp,
                Yp,
                Yp
            ], [
                0,
                0,
                Wp
            ]),
            new eu([
                0,
                Yp,
                Yp
            ], [
                Wp,
                0,
                Wp
            ]),
            new eu([
                Yp,
                0,
                Yp
            ], [
                0,
                Wp,
                Wp
            ]),
            new eu([
                0,
                0,
                Yp
            ], [
                Wp,
                Wp,
                Wp
            ])
        ];
        function Qp(t1, e1, r, n = !0) {
            const i = Vl([], t1._camera.position, t1.worldSize), s = [
                e1,
                r,
                1,
                1
            ];
            Xl(s, s, t1.pixelMatrixInverse), Zl(s, s, 1 / s[3]);
            const a = Ll([], ql([], s, i)), o = t1.globeMatrix, l = [
                o[12],
                o[13],
                o[14]
            ], c = ql([], l, i), h = zl(c), p = Ll([], c), f = t1.worldSize / (2 * Math.PI), y = Rl(p, a), m = Math.asin(f / h);
            if (m < Math.acos(y)) {
                if (!n) return null;
                const t1 = [], e1 = [];
                Vl(t1, a, h / y), Ll(e1, ql(e1, t1, c)), Ll(a, Bl(a, c, Vl(a, e1, Math.tan(m) * h)));
            }
            const g = [];
            new Jl(i, a).closestPointOnSphere(l, f, g);
            const x = Ll([], U(o, 0)), v = Ll([], U(o, 1)), b = Ll([], U(o, 2)), _ = Rl(x, g), w = Rl(v, g), A = Rl(b, g), S = u(Math.asin(-w / f));
            let k = u(Math.atan2(_, A));
            k = t1.center.lng + function(t1, e1) {
                const r = (e1 - t1 + 180) % 360 - 180;
                return r < -180 ? r + 360 : r;
            }(t1.center.lng, k);
            const I = zo(k), M = d(To(S), 0, 1);
            return new Fo(I, M);
        }
        class tf {
            constructor(t1, e1, r){
                this.a = ql([], t1, r), this.b = ql([], e1, r), this.center = r;
                const n = Ll([], this.a), i = Ll([], this.b);
                this.angle = Math.acos(Rl(n, i));
            }
        }
        function ef(t1, e1) {
            if (0 === t1.angle) return null;
            let r;
            return r = 0 === t1.a[e1] ? 1 / t1.angle * .5 * Math.PI : 1 / t1.angle * Math.atan(t1.b[e1] / t1.a[e1] / Math.sin(t1.angle) - 1 / Math.tan(t1.angle)), r < 0 || r > 1 ? null : function(t1, e1, r, n) {
                const i = Math.sin(r);
                return t1 * (Math.sin((1 - n) * r) / i) + e1 * (Math.sin(n * r) / i);
            }(t1.a[e1], t1.b[e1], t1.angle, d(r, 0, 1)) + t1.center[e1];
        }
        function rf(t1) {
            if (t1.z <= 1) return Jp[t1.z + 2 * t1.y + t1.x];
            const e1 = lf(of(t1));
            return eu.fromPoints(e1);
        }
        function nf(t1, e1) {
            const r = gf(e1.zoom);
            if (0 === r) return rf(t1);
            const n = of(t1), i = lf(n), s = zo(n.getWest()) * e1.worldSize, a = zo(n.getEast()) * e1.worldSize, o = To(n.getNorth()) * e1.worldSize, l = To(n.getSouth()) * e1.worldSize, u = [
                s,
                o,
                0
            ], c = [
                a,
                o,
                0
            ], h = [
                s,
                l,
                0
            ], p = [
                a,
                l,
                0
            ], f = gl([], e1.globeMatrix);
            return jl(u, u, f), jl(c, c, f), jl(h, h, f), jl(p, p, f), i[0] = vr(i[0], h, r), i[1] = vr(i[1], p, r), i[2] = vr(i[2], c, r), i[3] = vr(i[3], u, r), eu.fromPoints(i);
        }
        function sf(t1, e1, r, n, i) {
            for (const s of r)jl(s, s, n), Vl(s, s, i), Pl(t1, t1, s), Dl(e1, e1, s);
        }
        function af(t1, e1, r) {
            const n = e1 / t1.worldSize, i = Number.MAX_VALUE, s = [
                -i,
                -i,
                -i
            ], a = [
                i,
                i,
                i
            ], o = t1.globeMatrix;
            if (r.z <= 1) return sf(a, s, rf(r).getCorners(), o, n), new eu(a, s);
            const u = of(r), c = lf(u);
            if (sf(a, s, c, o, n), u.contains(t1.center)) {
                s[2] = 0;
                const e1 = t1.point, r = [
                    e1.x * n,
                    e1.y * n,
                    0
                ];
                return Pl(a, a, r), Dl(s, s, r), new eu(a, s);
            }
            const h = [
                o[12] * n,
                o[13] * n,
                o[14] * n
            ], p = u.getCenter(), f = d(t1.center.lat, -85.051129, Do), y = d(p.lat, -85.051129, Do), m = zo(t1.center.lng), g = To(f);
            let x = m - zo(p.lng);
            const v = g - To(y);
            x > .5 ? x -= 1 : x < -0.5 && (x += 1);
            let b = 0;
            Math.abs(x) > Math.abs(v) ? b = x >= 0 ? 1 : 3 : (b = v >= 0 ? 0 : 2, Fl(h, h, [
                o[4] * n,
                o[5] * n,
                o[6] * n
            ], -Math.sin(l(v >= 0 ? u.getSouth() : u.getNorth())) * Xp));
            const _ = c[b], w = c[(b + 1) % 4], A = new tf(_, w, h), S = [
                ef(A, 0) || _[0],
                ef(A, 1) || _[1],
                ef(A, 2) || _[2]
            ];
            return a[2] = Math.min(_[2], w[2]), Pl(a, a, S), Dl(s, s, S), new eu(a, s);
        }
        function of({ x: t1, y: e1, z: r }) {
            const n = 1 / (1 << r), i = new ko(Eo(t1 * n), Co((e1 + 1) * n)), s = new ko(Eo((t1 + 1) * n), Co(e1 * n));
            return new Ao(i, s);
        }
        function lf(t1) {
            const e1 = l(t1.getNorth()), r = l(t1.getSouth()), n = Math.cos(e1), i = Math.cos(r), s = Math.sin(e1), a = Math.sin(r), o = t1.getWest(), u = t1.getEast();
            return [
                uf(i, a, o),
                uf(i, a, u),
                uf(n, s, u),
                uf(n, s, o)
            ];
        }
        function uf(t1, e1, r, n = Xp) {
            return r = l(r), [
                t1 * Math.sin(r) * n,
                -e1 * n,
                t1 * Math.cos(r) * n
            ];
        }
        function cf(t1, e1, r) {
            return uf(Math.cos(l(t1)), Math.sin(l(t1)), e1, r);
        }
        function hf(t1, e1, r, n) {
            const i = 1 << r.z, s = (t1 / wo + r.x) / i;
            return cf(Co((e1 / wo + r.y) / i), Eo(s), n);
        }
        function pf({ min: t1, max: e1 }) {
            return 16383 / Math.max(e1[0] - t1[0], e1[1] - t1[1], e1[2] - t1[2]);
        }
        const ff = new Float64Array(16);
        function df(t1) {
            const e1 = pf(t1), r = Al(ff, [
                e1,
                e1,
                e1
            ]);
            var n, i;
            return vl(r, r, ((n = [])[0] = -(i = t1.min)[0], n[1] = -i[1], n[2] = -i[2], n));
        }
        function yf(t1) {
            const e1 = (n = t1.min, (r = ff)[0] = 1, r[1] = 0, r[2] = 0, r[3] = 0, r[4] = 0, r[5] = 1, r[6] = 0, r[7] = 0, r[8] = 0, r[9] = 0, r[10] = 1, r[11] = 0, r[12] = n[0], r[13] = n[1], r[14] = n[2], r[15] = 1, r);
            var r, n;
            const i = 1 / pf(t1);
            return bl(e1, e1, [
                i,
                i,
                i
            ]);
        }
        function mf(t1, e1, r, n, i) {
            const s = function(t1) {
                const e1 = wo / (2 * Math.PI);
                return t1 / (2 * Math.PI) / e1;
            }(r), a = [
                t1,
                e1,
                -r / (2 * Math.PI)
            ], o = ml(new Float64Array(16));
            return vl(o, o, a), bl(o, o, [
                s,
                s,
                s
            ]), _l(o, o, l(-i)), wl(o, o, l(-n)), o;
        }
        function gf(t1) {
            return y(5, 6, t1);
        }
        function xf(t1, e1) {
            const r = cf(e1.lat, e1.lng);
            var n, i, s, a, o, l, u, c, h, p;
            return s = (n = El([], function(t1) {
                const e1 = cf(t1._center.lat, t1._center.lng);
                let r = Ul([], Tl(0, 1, 0), e1);
                const n = Sl([], -t1.angle, e1);
                r = jl(r, r, n), Sl(n, -t1._pitch, r);
                const i = Ll([], e1);
                return Vl(i, i, t1.cameraToCenterDistance / t1.pixelsPerMeter * Kp), jl(i, i, n), Bl([], e1, i);
            }(t1), r))[0], a = n[1], o = n[2], l = (i = r)[0], u = i[1], c = i[2], p = (h = Math.sqrt(s * s + a * a + o * o) * Math.sqrt(l * l + u * u + c * c)) && Rl(n, i) / h, Math.acos(Math.min(Math.max(p, -1), 1));
        }
        const vf = l(85), bf = Math.cos(vf), _f = Math.sin(vf);
        function wf(t1, e1) {
            const r = t1.fovAboveCenter, n = t1.elevation ? t1.elevation.getMinElevationBelowMSL() * e1 : 0, i = (t1._camera.position[2] * t1.worldSize - n) / Math.cos(t1._pitch), s = Math.sin(r) * i / Math.sin(Math.max(Math.PI / 2 - t1._pitch - r, .01)), a = Math.sin(t1._pitch) * s + i;
            return Math.min(1.01 * a, i * (1 / t1._horizonShift));
        }
        function Af(t1, e1) {
            if (!e1.isReprojectedInTileSpace) return {
                scale: 1 << t1.z,
                x: t1.x,
                y: t1.y,
                x2: t1.x + 1,
                y2: t1.y + 1,
                projection: e1
            };
            const r = Math.pow(2, -t1.z), n = t1.x * r, i = (t1.x + 1) * r, s = t1.y * r, a = (t1.y + 1) * r, o = Eo(n), l = Eo(i), u = Co(s), c = Co(a), h = e1.project(o, u), p = e1.project(l, u), f = e1.project(l, c), d = e1.project(o, c);
            let y = Math.min(h.x, p.x, f.x, d.x), m = Math.min(h.y, p.y, f.y, d.y), g = Math.max(h.x, p.x, f.x, d.x), x = Math.max(h.y, p.y, f.y, d.y);
            const v = r / 16;
            function b(t1, r, n, i, s, a) {
                const o = (n + s) / 2, l = (i + a) / 2, u = e1.project(Eo(o), Co(l)), c = Math.max(0, y - u.x, m - u.y, u.x - g, u.y - x);
                y = Math.min(y, u.x), g = Math.max(g, u.x), m = Math.min(m, u.y), x = Math.max(x, u.y), c > v && (b(t1, u, n, i, o, l), b(u, r, o, l, s, a));
            }
            b(h, p, n, s, i, s), b(p, f, i, s, i, a), b(f, d, i, a, n, a), b(d, h, n, a, n, s), y -= v, m -= v, g += v, x += v;
            const _ = 1 / Math.max(g - y, x - m);
            return {
                scale: _,
                x: y * _,
                y: m * _,
                x2: g * _,
                y2: x * _,
                projection: e1
            };
        }
        const Sf = ml(new Float32Array(16));
        class kf {
            project(t1, e1) {
                return {
                    x: 0,
                    y: 0,
                    z: 0
                };
            }
            unproject(t1, e1) {
                return new ko(0, 0);
            }
            projectTilePoint(t1, e1, r) {
                return {
                    x: t1,
                    y: e1,
                    z: 0
                };
            }
            locationPoint(t1, e1, r = !0) {
                return t1._coordinatePoint(t1.locationCoordinate(e1), r);
            }
            pixelsPerMeter(t1, e1) {
                return Bo(1, t1) * e1;
            }
            pixelSpaceConversion(t1, e1, r) {
                return 1;
            }
            farthestPixelDistance(t1) {
                return wf(t1, t1.pixelsPerMeter);
            }
            pointCoordinate(t1, e1, r, n) {
                const s = t1.horizonLineFromTop(!1), a = new i(e1, Math.max(s, r));
                return t1.rayIntersectionCoordinate(t1.pointRayIntersection(a, n));
            }
            pointCoordinate3D(t1, e1, r) {
                const n = new i(e1, r);
                if (t1.elevation) return t1.elevation.pointCoordinate(n);
                {
                    const e1 = this.pointCoordinate(t1, n.x, n.y, 0);
                    return [
                        e1.x,
                        e1.y,
                        e1.z
                    ];
                }
            }
            isPointAboveHorizon(t1, e1) {
                if (t1.elevation) return !this.pointCoordinate3D(t1, e1.x, e1.y);
                const r = t1.horizonLineFromTop();
                return e1.y < r;
            }
            createInversionMatrix(t1, e1) {
                return Sf;
            }
            createTileMatrix(t1, e1, r) {
                let n, i, s;
                const a = r.canonical, o = ml(new Float64Array(16));
                if (this.isReprojectedInTileSpace) {
                    const l = Af(a, this);
                    n = 1, i = l.x + r.wrap * l.scale, s = l.y, bl(o, o, [
                        n / l.scale,
                        n / l.scale,
                        t1.pixelsPerMeter / e1
                    ]);
                } else n = e1 / t1.zoomScale(a.z), i = (a.x + Math.pow(2, a.z) * r.wrap) * n, s = a.y * n;
                return vl(o, o, [
                    i,
                    s,
                    0
                ]), bl(o, o, [
                    n / wo,
                    n / wo,
                    1
                ]), o;
            }
            upVector(t1, e1, r) {
                return [
                    0,
                    0,
                    1
                ];
            }
            upVectorScale(t1, e1, r) {
                return {
                    metersToTile: 1
                };
            }
            constructor(t1){
                this.spec = t1, this.name = t1.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = [
                    "custom"
                ], this.center = [
                    0,
                    0
                ], this.range = [
                    3.5,
                    7
                ];
            }
        }
        class If extends kf {
            project(t1, e1) {
                const { n: r, c: n, r0: i } = this, s = l(t1 - this.center[0]), a = l(e1), o = Math.sqrt(n - 2 * r * Math.sin(a)) / r;
                return {
                    x: o * Math.sin(s * r),
                    y: o * Math.cos(s * r) - i,
                    z: 0
                };
            }
            unproject(t1, e1) {
                const { n: r, c: n, r0: i } = this, s = i + e1;
                let a = Math.atan2(t1, Math.abs(s)) * Math.sign(s);
                s * r < 0 && (a -= Math.PI * Math.sign(t1) * Math.sign(s));
                const o = l(this.center[0]) * r;
                a = m(a, -Math.PI - o, Math.PI - o);
                const c = u(a / r) + this.center[0], h = Math.asin(d((n - (t1 * t1 + s * s) * r * r) / (2 * r), -1, 1)), p = d(u(h), -85.051129, Do);
                return new ko(c, p);
            }
            constructor(t1){
                super(t1), this.range = [
                    4,
                    7
                ], this.center = t1.center || [
                    -96,
                    37.5
                ];
                const [e1, r] = this.parallels = t1.parallels || [
                    29.5,
                    45.5
                ], n = Math.sin(l(e1));
                this.n = (n + Math.sin(l(r))) / 2, this.c = 1 + n * (2 * this.n - n), this.r0 = Math.sqrt(this.c) / this.n;
            }
        }
        const Mf = 1.340264, zf = -0.081106, Tf = 893e-6, Bf = .003796, Ef = Math.sqrt(3) / 2;
        class Cf extends kf {
            project(t1, e1) {
                e1 = e1 / 180 * Math.PI, t1 = t1 / 180 * Math.PI;
                const r = Math.asin(Ef * Math.sin(e1)), n = r * r, i = n * n * n;
                return {
                    x: .5 * (t1 * Math.cos(r) / (Ef * (Mf + 3 * zf * n + i * (7 * Tf + 9 * Bf * n))) / Math.PI + .5),
                    y: 1 - .5 * (r * (Mf + zf * n + i * (Tf + Bf * n)) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e1) {
                t1 = (2 * t1 - .5) * Math.PI;
                let r = e1 = (2 * (1 - e1) - 1) * Math.PI, n = r * r, i = n * n * n;
                for(let t1, s, a, o = 0; o < 12 && (s = r * (Mf + zf * n + i * (Tf + Bf * n)) - e1, a = Mf + 3 * zf * n + i * (7 * Tf + 9 * Bf * n), t1 = s / a, r = d(r - t1, -Math.PI / 3, Math.PI / 3), n = r * r, i = n * n * n, !(Math.abs(t1) < 1e-12)); ++o);
                const s = Ef * t1 * (Mf + 3 * zf * n + i * (7 * Tf + 9 * Bf * n)) / Math.cos(r), a = Math.asin(Math.sin(r) / Ef), o = d(180 * s / Math.PI, -180, 180), l = d(180 * a / Math.PI, -85.051129, Do);
                return new ko(o, l);
            }
        }
        class Pf extends kf {
            project(t1, e1) {
                return {
                    x: .5 + t1 / 360,
                    y: .5 - e1 / 360,
                    z: 0
                };
            }
            unproject(t1, e1) {
                const r = 360 * (t1 - .5), n = d(360 * (.5 - e1), -85.051129, Do);
                return new ko(r, n);
            }
            constructor(t1){
                super(t1), this.wrap = !0, this.supportsWorldCopies = !0;
            }
        }
        const Df = Math.PI / 2;
        function Vf(t1) {
            return Math.tan((Df + t1) / 2);
        }
        class Ff extends kf {
            project(t1, e1) {
                e1 = l(e1), t1 = l(t1 - this.center[0]);
                const r = 1e-6, { n: n, f: i } = this;
                i > 0 ? e1 < -Df + r && (e1 = -Df + r) : e1 > Df - r && (e1 = Df - r);
                const s = i / Math.pow(Vf(e1), n), a = s * Math.sin(n * t1), o = i - s * Math.cos(n * t1);
                return {
                    x: .5 * (a / Math.PI + .5),
                    y: 1 - .5 * (o / Math.PI + .5),
                    z: 0
                };
            }
            unproject(t1, e1) {
                t1 = (2 * t1 - .5) * Math.PI, e1 = (2 * (1 - e1) - .5) * Math.PI;
                const { n: r, f: n } = this, i = n - e1, s = Math.sign(i), a = Math.sign(r) * Math.sqrt(t1 * t1 + i * i);
                let o = Math.atan2(t1, Math.abs(i)) * s;
                i * r < 0 && (o -= Math.PI * Math.sign(t1) * s);
                const l = d(u(o / r) + this.center[0], -180, 180), c = d(u(2 * Math.atan(Math.pow(n / a, 1 / r)) - Df), -85.051129, Do);
                return new ko(l, c);
            }
            constructor(t1){
                super(t1), this.center = t1.center || [
                    0,
                    30
                ];
                const [e1, r] = this.parallels = t1.parallels || [
                    30,
                    30
                ], n = l(e1), i = l(r), s = Math.cos(n);
                this.n = n === i ? Math.sin(n) : Math.log(s / Math.cos(i)) / Math.log(Vf(i) / Vf(n)), this.f = s * Math.pow(Vf(n), this.n) / this.n;
            }
        }
        class Lf extends kf {
            project(t1, e1) {
                return {
                    x: zo(t1),
                    y: To(e1),
                    z: 0
                };
            }
            unproject(t1, e1) {
                const r = Eo(t1), n = Co(e1);
                return new ko(r, n);
            }
            constructor(t1){
                super(t1), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
            }
        }
        const Rf = l(Do);
        class Uf extends kf {
            project(t1, e1) {
                const r = (e1 = l(e1)) * e1, n = r * r;
                return {
                    x: .5 * ((t1 = l(t1)) * (.8707 - .131979 * r + n * (n * (.003971 * r - .001529 * n) - .013791)) / Math.PI + .5),
                    y: 1 - .5 * (e1 * (1.007226 + r * (.015085 + n * (.028874 * r - .044475 - .005916 * n))) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e1) {
                t1 = (2 * t1 - .5) * Math.PI;
                let r = e1 = (2 * (1 - e1) - 1) * Math.PI, n = 25, i = 0, s = r * r;
                do {
                    s = r * r;
                    const t1 = s * s;
                    i = (r * (1.007226 + s * (.015085 + t1 * (.028874 * s - .044475 - .005916 * t1))) - e1) / (1.007226 + s * (.045255 + t1 * (.259866 * s - .311325 - .005916 * 11 * t1))), r = d(r - i, -Rf, Rf);
                }while (Math.abs(i) > 1e-6 && --n > 0);
                s = r * r;
                const a = d(u(t1 / (.8707 + s * (s * (s * s * s * (.003971 - .001529 * s) - .013791) - .131979))), -180, 180), o = u(r);
                return new ko(a, o);
            }
        }
        const jf = l(Do);
        class $f extends kf {
            project(t1, e1) {
                e1 = l(e1), t1 = l(t1);
                const r = Math.cos(e1), n = 2 / Math.PI, i = Math.acos(r * Math.cos(t1 / 2)), s = Math.sin(i) / i, a = .5 * (t1 * n + 2 * r * Math.sin(t1 / 2) / s) || 0, o = .5 * (e1 + Math.sin(e1) / s) || 0;
                return {
                    x: .5 * (a / Math.PI + .5),
                    y: 1 - .5 * (o / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e1) {
                let r = t1 = (2 * t1 - .5) * Math.PI, n = e1 = (2 * (1 - e1) - 1) * Math.PI, i = 25;
                const s = 1e-6;
                let a = 0, o = 0;
                do {
                    const i = Math.cos(n), s = Math.sin(n), l = 2 * s * i, u = s * s, c = i * i, h = Math.cos(r / 2), p = Math.sin(r / 2), f = 2 * h * p, y = p * p, m = 1 - c * h * h, g = m ? 1 / m : 0, x = m ? Math.acos(i * h) * Math.sqrt(1 / m) : 0, v = .5 * (2 * x * i * p + 2 * r / Math.PI) - t1, b = .5 * (x * s + n) - e1, _ = .5 * g * (c * y + x * i * h * u) + 1 / Math.PI, w = g * (f * l / 4 - x * s * p), A = .125 * g * (l * p - x * s * c * f), S = .5 * g * (u * h + x * y * i) + .5, k = w * A - S * _;
                    a = (b * w - v * S) / k, o = (v * A - b * _) / k, r = d(r - a, -Math.PI, Math.PI), n = d(n - o, -jf, jf);
                }while ((Math.abs(a) > s || Math.abs(o) > s) && --i > 0);
                return new ko(u(r), u(n));
            }
        }
        class Of extends kf {
            project(t1, e1) {
                const { scale: r, cosPhi: n } = this;
                return {
                    x: l(t1) * n * r + .5,
                    y: -Math.sin(l(e1)) / n * r + .5,
                    z: 0
                };
            }
            unproject(t1, e1) {
                const { scale: r, cosPhi: n } = this, i = -(e1 - .5) / r, s = d(u((t1 - .5) / r) / n, -180, 180), a = Math.asin(d(i * n, -1, 1)), o = d(u(a), -85.051129, Do);
                return new ko(s, o);
            }
            constructor(t1){
                super(t1), this.center = t1.center || [
                    0,
                    0
                ], this.parallels = t1.parallels || [
                    0,
                    0
                ], this.cosPhi = Math.max(.01, Math.cos(l(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
            }
        }
        class qf extends Lf {
            projectTilePoint(t1, e1, r) {
                const n = hf(t1, e1, r);
                return jl(n, n, df(rf(r))), {
                    x: n[0],
                    y: n[1],
                    z: n[2]
                };
            }
            locationPoint(t1, e1) {
                const r = cf(e1.lat, e1.lng), n = Ll([], r), s = t1.elevation ? t1.elevation.getAtPointOrZero(t1.locationCoordinate(e1), t1._centerAltitude) : t1._centerAltitude;
                Fl(r, r, n, Bo(1, 0) * wo * s);
                const a = ml(new Float64Array(16));
                return xl(a, t1.pixelMatrix, t1.globeMatrix), jl(r, r, a), new i(r[0], r[1]);
            }
            pixelsPerMeter(t1, e1) {
                return Bo(1, 0) * e1;
            }
            pixelSpaceConversion(t1, e1, r) {
                const n = xr(Bo(1, 45) * e1, Bo(1, t1) * e1, r);
                return this.pixelsPerMeter(t1, e1) / n;
            }
            createTileMatrix(t1, e1, r) {
                const n = yf(rf(r.canonical));
                return xl(new Float64Array(16), t1.globeMatrix, n);
            }
            createInversionMatrix(t1, e1) {
                const { center: r } = t1, n = df(rf(e1));
                return wl(n, n, l(r.lng)), _l(n, n, l(r.lat)), bl(n, n, [
                    t1._pixelsPerMercatorPixel,
                    t1._pixelsPerMercatorPixel,
                    1
                ]), Float32Array.from(n);
            }
            pointCoordinate(t1, e1, r, n) {
                return Qp(t1, e1, r, !0) || new Fo(0, 0);
            }
            pointCoordinate3D(t1, e1, r) {
                const n = this.pointCoordinate(t1, e1, r, 0);
                return [
                    n.x,
                    n.y,
                    n.z
                ];
            }
            isPointAboveHorizon(t1, e1) {
                return !Qp(t1, e1.x, e1.y, !1);
            }
            farthestPixelDistance(t1) {
                const e1 = function(t1, e1) {
                    const r = t1.cameraToCenterDistance, n = t1._centerAltitude * e1, i = t1._camera, s = t1._camera.forward(), a = Bl([], Vl([], s, -r), [
                        0,
                        0,
                        n
                    ]), o = t1.worldSize / (2 * Math.PI), l = [
                        0,
                        0,
                        -o
                    ], u = t1.width / t1.height, c = Math.tan(t1.fovAboveCenter), h = Vl([], i.up(), c), p = Vl([], i.right(), c * u), f = Ll([], Bl([], Bl([], s, h), p)), d = [];
                    let y;
                    if (new Jl(a, f).closestPointOnSphere(l, o, d)) {
                        const e1 = Bl([], d, l), r = ql([], e1, a);
                        y = Math.cos(t1.fovAboveCenter) * zl(r);
                    } else {
                        const t1 = ql([], a, l), e1 = ql([], l, a);
                        Ll(e1, e1);
                        const r = zl(t1) - o;
                        y = Math.sqrt(r * (r + 2 * o));
                        const n = Math.acos(y / (o + r)) - Math.acos(Rl(s, e1));
                        y *= Math.cos(n);
                    }
                    return 1.01 * y;
                }(t1, this.pixelsPerMeter(t1.center.lat, t1.worldSize)), r = gf(t1.zoom);
                if (r > 0) {
                    const n = wf(t1, Bo(1, t1.center.lat) * t1.worldSize), i = t1.worldSize / (2 * Math.PI), s = Math.max(t1.width, t1.height) / t1.worldSize * Math.PI;
                    return xr(e1, n + i * (1 - Math.cos(s)), Math.pow(r, 10));
                }
                return e1;
            }
            upVector(t1, e1, r) {
                return hf(e1, r, t1, 1);
            }
            upVectorScale(t1) {
                return {
                    metersToTile: Kp * pf(rf(t1))
                };
            }
            constructor(t1){
                super(t1), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = [
                    "debug",
                    "custom"
                ], this.range = [
                    3,
                    5
                ];
            }
        }
        function Nf(t1) {
            const e1 = t1.parallels, r = !!e1 && Math.abs(e1[0] + e1[1]) < .01;
            switch(t1.name){
                case "mercator":
                    return new Lf(t1);
                case "equirectangular":
                    return new Pf(t1);
                case "naturalEarth":
                    return new Uf(t1);
                case "equalEarth":
                    return new Cf(t1);
                case "winkelTripel":
                    return new $f(t1);
                case "albers":
                    return r ? new Of(t1) : new If(t1);
                case "lambertConformalConic":
                    return r ? new Of(t1) : new Ff(t1);
                case "globe":
                    return new qf(t1);
            }
            throw new Error(`Invalid projection name: ${t1.name}`);
        }
        const Gf = yc.VectorTileFeature.types, Zf = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function Xf(t1, e1, r, n, i, s, a, o, l, u, c, h, p) {
            const f = o ? Math.min(Lp, Math.round(o[0])) : 0, d = o ? Math.min(Lp, Math.round(o[1])) : 0;
            t1.emplaceBack(e1, r, Math.round(32 * n), Math.round(32 * i), s, a, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function Kf(t1, e1, r, n, i, s, a) {
            t1.emplaceBack(e1, r, n, i, s, a);
        }
        function Hf(t1, e1, r, n, i) {
            t1.emplaceBack(e1, r, n, i), t1.emplaceBack(e1, r, n, i), t1.emplaceBack(e1, r, n, i), t1.emplaceBack(e1, r, n, i);
        }
        function Yf(t1) {
            for (const e1 of t1.sections)if (vs(e1.text)) return !0;
            return !1;
        }
        class Wf {
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
            }
            upload(t1, e1, r, n) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Qc.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e1), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, eh.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, Zf, !0), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = t1.createVertexBuffer(this.globeExtVertexArray, th.members, !0)), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
            }
            constructor(t1){
                this.layoutVertexArray = new oa, this.indexArray = new ya, this.programConfigurations = t1, this.segments = new _o, this.dynamicLayoutVertexArray = new na, this.opacityVertexArray = new ua, this.placedSymbolArray = new Ta, this.globeExtVertexArray = new la;
            }
        }
        Pi(Wf, "SymbolBuffers");
        class Jf {
            upload(t1) {
                this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, rh.members, !0), this.collisionVertexBufferExt = t1.createVertexBuffer(this.collisionVertexArrayExt, nh.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
            constructor(t1, e1, r){
                this.layoutVertexArray = new t1, this.layoutAttributes = e1, this.indexArray = new r, this.segments = new _o, this.collisionVertexArray = new fa, this.collisionVertexArrayExt = new da;
            }
        }
        Pi(Jf, "CollisionBuffers");
        class Qf {
            createArrays() {
                this.text = new Wf(new co(this.layers, this.zoom, (t1)=>/^text/.test(t1))), this.icon = new Wf(new co(this.layers, this.zoom, (t1)=>/^icon/.test(t1))), this.glyphOffsetArray = new Ca, this.lineVertexArray = new Pa, this.symbolInstances = new Ea;
            }
            calculateGlyphDependencies(t1, e1, r, n, i) {
                for(let r = 0; r < t1.length; r++)if (e1[t1.charCodeAt(r)] = !0, n && i) {
                    const n = fh[t1.charAt(r)];
                    n && (e1[n.charCodeAt(0)] = !0);
                }
            }
            populate(t1, e1, r, n) {
                const i = this.layers[0], s = i.layout, a = "globe" === this.projection.name, o = s.get("text-font"), l = s.get("text-field"), u = s.get("icon-image"), c = ("constant" !== l.value.kind || l.value.value instanceof _e && !l.value.value.isEmpty() || l.value.value.toString().length > 0) && ("constant" !== o.value.kind || o.value.value.length > 0), h = "constant" !== u.value.kind || !!u.value.value || Object.keys(u.parameters).length > 0, p = s.get("symbol-sort-key");
                if (this.features = [], !c && !h) return;
                const f = e1.iconDependencies, d = e1.glyphDependencies, y = e1.availableImages, m = new Cs(this.zoom);
                for (const { feature: e1, id: l, index: u, sourceLayerIndex: g } of t1){
                    const t1 = i._featureFilter.needGeometry, x = Go(e1, t1);
                    if (!i._featureFilter.filter(m, x, r)) continue;
                    if (t1 || (x.geometry = No(e1, r, n)), a && 1 !== e1.type && r.z <= 5) {
                        const t1 = x.geometry, e1 = .98078528056;
                        for(let n = 0; n < t1.length; n++)t1[n] = jo(t1[n], (t1)=>t1, (t1, n)=>Rl(hf(t1.x, t1.y, r, 1), hf(n.x, n.y, r, 1)) < e1);
                    }
                    let v, b;
                    if (c) {
                        const t1 = i.getValueAndResolveTokens("text-field", x, r, y), e1 = _e.factory(t1);
                        Yf(e1) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === Ts() || this.hasRTLText && Es.isParsed()) && (v = ph(e1, i, x));
                    }
                    if (h) {
                        const t1 = i.getValueAndResolveTokens("icon-image", x, r, y);
                        b = t1 instanceof we ? t1 : we.fromString(t1);
                    }
                    if (!v && !b) continue;
                    const _ = this.sortFeaturesByKey ? p.evaluate(x, {}, r) : void 0;
                    if (this.features.push({
                        id: l,
                        text: v,
                        icon: b,
                        index: u,
                        sourceLayerIndex: g,
                        geometry: x.geometry,
                        properties: e1.properties,
                        type: Gf[e1.type],
                        sortKey: _
                    }), b && (f[b.name] = !0), v) {
                        const t1 = o.evaluate(x, {}, r).join(","), e1 = "map" === s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(Nh.vertical) >= 0;
                        for (const r of v.sections)if (r.image) f[r.image.name] = !0;
                        else {
                            const n = ps(v.toString()), i = r.fontStack || t1, s = d[i] = d[i] || {};
                            this.calculateGlyphDependencies(r.text, s, e1, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === s.get("symbol-placement") && (this.features = function(t1) {
                    const e1 = {}, r = {}, n = [];
                    let i = 0;
                    function s(e1) {
                        n.push(t1[e1]), i++;
                    }
                    function a(t1, e1, i) {
                        const s = r[t1];
                        return delete r[t1], r[e1] = s, n[s].geometry[0].pop(), n[s].geometry[0] = n[s].geometry[0].concat(i[0]), s;
                    }
                    function o(t1, r, i) {
                        const s = e1[r];
                        return delete e1[r], e1[t1] = s, n[s].geometry[0].shift(), n[s].geometry[0] = i[0].concat(n[s].geometry[0]), s;
                    }
                    function l(t1, e1, r) {
                        const n = r ? e1[0][e1[0].length - 1] : e1[0][0];
                        return `${t1}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < t1.length; u++){
                        const c = t1[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            s(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in e1 && r[f] !== e1[d]) {
                            const t1 = o(f, d, h), i = a(f, d, n[t1].geometry);
                            delete e1[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[t1].geometry = null;
                        } else f in r ? a(f, d, h) : d in e1 ? o(f, d, h) : (s(u), e1[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((t1)=>t1.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((t1, e1)=>t1.sortKey - e1.sortKey);
            }
            update(t1, e1, r, n) {
                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t1, e1, this.layers, r, n), this.icon.programConfigurations.updatePaintArrays(t1, e1, this.layers, r, n));
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t1) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
                return this.projectionInstance || (this.projectionInstance = Nf(this.projection)), this.projectionInstance;
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t1, e1) {
                const r = this.lineVertexArray.length, n = t1.segment;
                if (void 0 !== n) {
                    let r = t1.dist(e1[n + 1]), i = t1.dist(e1[n]);
                    const s = {};
                    for(let t1 = n + 1; t1 < e1.length; t1++)s[t1] = {
                        x: e1[t1].x,
                        y: e1[t1].y,
                        tileUnitDistanceFromAnchor: r
                    }, t1 < e1.length - 1 && (r += e1[t1 + 1].dist(e1[t1]));
                    for(let t1 = n || 0; t1 >= 0; t1--)s[t1] = {
                        x: e1[t1].x,
                        y: e1[t1].y,
                        tileUnitDistanceFromAnchor: i
                    }, t1 > 0 && (i += e1[t1 - 1].dist(e1[t1]));
                    for(let t1 = 0; t1 < e1.length; t1++){
                        const e1 = s[t1];
                        this.lineVertexArray.emplaceBack(e1.x, e1.y, e1.tileUnitDistanceFromAnchor);
                    }
                }
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(t1, e1, r, n, i, s, a, o, l, u, c, h, p, f) {
                const d = t1.indexArray, y = t1.layoutVertexArray, m = t1.globeExtVertexArray, g = t1.segments.prepareSegment(4 * e1.length, y, d, this.canOverlap ? s.sortKey : void 0), x = this.glyphOffsetArray.length, v = g.vertexLength, b = this.allowVerticalPlacement && a === Nh.vertical ? Math.PI / 2 : 0, _ = s.text && s.text.sections;
                for(let n = 0; n < e1.length; n++){
                    const { tl: i, tr: a, bl: u, br: c, tex: h, pixelOffsetTL: x, pixelOffsetBR: v, minFontScaleX: w, minFontScaleY: A, glyphOffset: S, isSDF: k, sectionIndex: I } = e1[n], M = g.vertexLength, z = S[1];
                    if (Xf(y, l.x, l.y, i.x, z + i.y, h.x, h.y, r, k, x.x, x.y, w, A), Xf(y, l.x, l.y, a.x, z + a.y, h.x + h.w, h.y, r, k, v.x, x.y, w, A), Xf(y, l.x, l.y, u.x, z + u.y, h.x, h.y + h.h, r, k, x.x, v.y, w, A), Xf(y, l.x, l.y, c.x, z + c.y, h.x + h.w, h.y + h.h, r, k, v.x, v.y, w, A), o) {
                        const e1 = o.anchor, r = o.up;
                        Kf(m, e1.x, e1.y, e1.z, r[0], r[1], r[2]), Kf(m, e1.x, e1.y, e1.z, r[0], r[1], r[2]), Kf(m, e1.x, e1.y, e1.z, r[0], r[1], r[2]), Kf(m, e1.x, e1.y, e1.z, r[0], r[1], r[2]), Hf(t1.dynamicLayoutVertexArray, e1.x, e1.y, e1.z, b);
                    } else Hf(t1.dynamicLayoutVertexArray, l.x, l.y, l.z, b);
                    d.emplaceBack(M, M + 1, M + 2), d.emplaceBack(M + 1, M + 2, M + 3), g.vertexLength += 4, g.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(S[0]), n !== e1.length - 1 && I === e1[n + 1].sectionIndex || t1.programConfigurations.populatePaintArrays(y.length, s, s.index, {}, p, f, _ && _[I]);
                }
                const w = o ? o.anchor : l;
                t1.placedSymbolArray.emplaceBack(w.x, w.y, w.z, l.x, l.y, x, this.glyphOffsetArray.length - x, v, u, c, l.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], a, 0, !1, 0, h, 0);
            }
            _commitLayoutVertex(t1, e1, r, n, i, s, a) {
                t1.emplaceBack(e1, r, n, i, s, Math.round(a.x), Math.round(a.y));
            }
            _addCollisionDebugVertices(t1, e1, r, n, s, a, o) {
                const l = r.segments.prepareSegment(4, r.layoutVertexArray, r.indexArray), u = l.vertexLength, c = o.tileAnchorX, h = o.tileAnchorY;
                for(let t1 = 0; t1 < 4; t1++)r.collisionVertexArray.emplaceBack(0, 0, 0, 0);
                r.collisionVertexArrayExt.emplaceBack(e1, -t1.padding, -t1.padding), r.collisionVertexArrayExt.emplaceBack(e1, t1.padding, -t1.padding), r.collisionVertexArrayExt.emplaceBack(e1, t1.padding, t1.padding), r.collisionVertexArrayExt.emplaceBack(e1, -t1.padding, t1.padding), this._commitLayoutVertex(r.layoutVertexArray, n, s, a, c, h, new i(t1.x1, t1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, s, a, c, h, new i(t1.x2, t1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, s, a, c, h, new i(t1.x2, t1.y2)), this._commitLayoutVertex(r.layoutVertexArray, n, s, a, c, h, new i(t1.x1, t1.y2)), l.vertexLength += 4;
                const p = r.indexArray;
                p.emplaceBack(u, u + 1), p.emplaceBack(u + 1, u + 2), p.emplaceBack(u + 2, u + 3), p.emplaceBack(u + 3, u), l.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(t1, e1, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceTextSize(t1, s, e1, a);
                    this._addCollisionDebugVertices(n, i, this.textCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            _addIconDebugCollisionBoxes(t1, e1, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceIconSize(t1, e1, a);
                    this._addCollisionDebugVertices(n, i, this.iconCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            generateCollisionDebugBuffers(t1, e1) {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Jf(ha, ih.members, _a), this.iconCollisionBox = new Jf(ha, ih.members, _a);
                const r = ch(this.iconSizeData, t1), n = ch(this.textSizeData, t1);
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const s = this.symbolInstances.get(i);
                    this._addTextDebugCollisionBoxes(n, t1, e1, s.textBoxStartIndex, s.textBoxEndIndex, s), this._addTextDebugCollisionBoxes(n, t1, e1, s.verticalTextBoxStartIndex, s.verticalTextBoxEndIndex, s), this._addIconDebugCollisionBoxes(r, t1, e1, s.iconBoxStartIndex, s.iconBoxEndIndex, s), this._addIconDebugCollisionBoxes(r, t1, e1, s.verticalIconBoxStartIndex, s.verticalIconBoxEndIndex, s);
                }
            }
            getSymbolInstanceTextSize(t1, e1, r, n) {
                const i = this.text.placedSymbolArray.get(e1.rightJustifiedTextSymbolIndex >= 0 ? e1.rightJustifiedTextSymbolIndex : e1.centerJustifiedTextSymbolIndex >= 0 ? e1.centerJustifiedTextSymbolIndex : e1.leftJustifiedTextSymbolIndex >= 0 ? e1.leftJustifiedTextSymbolIndex : e1.verticalPlacedTextSymbolIndex >= 0 ? e1.verticalPlacedTextSymbolIndex : n), s = uh(this.textSizeData, t1, i) / ah;
                return this.tilePixelRatio * s;
            }
            getSymbolInstanceIconSize(t1, e1, r) {
                const n = this.icon.placedSymbolArray.get(r), i = uh(this.iconSizeData, t1, n);
                return this.tilePixelRatio * i;
            }
            _commitDebugCollisionVertexUpdate(t1, e1, r) {
                t1.emplaceBack(e1, -r, -r), t1.emplaceBack(e1, r, -r), t1.emplaceBack(e1, r, r), t1.emplaceBack(e1, -r, r);
            }
            _updateTextDebugCollisionBoxes(t1, e1, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceTextSize(t1, s, e1, a);
                    this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, i, n.padding);
                }
            }
            _updateIconDebugCollisionBoxes(t1, e1, r, n, i) {
                for(let s = n; s < i; s++){
                    const n = r.get(s), i = this.getSymbolInstanceIconSize(t1, e1, s);
                    this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, i, n.padding);
                }
            }
            updateCollisionDebugBuffers(t1, e1) {
                if (!this.hasDebugData()) return;
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
                const r = ch(this.iconSizeData, t1), n = ch(this.textSizeData, t1);
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const s = this.symbolInstances.get(i);
                    this._updateTextDebugCollisionBoxes(n, t1, e1, s.textBoxStartIndex, s.textBoxEndIndex, s), this._updateTextDebugCollisionBoxes(n, t1, e1, s.verticalTextBoxStartIndex, s.verticalTextBoxEndIndex, s), this._updateIconDebugCollisionBoxes(r, t1, e1, s.iconBoxStartIndex, s.iconBoxEndIndex), this._updateIconDebugCollisionBoxes(r, t1, e1, s.verticalIconBoxStartIndex, s.verticalIconBoxEndIndex);
                }
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            _deserializeCollisionBoxesForSymbol(t1, e1, r, n, i, s, a, o, l) {
                const u = {};
                for(let n = e1; n < r; n++){
                    const e1 = t1.get(n);
                    u.textBox = {
                        x1: e1.x1,
                        y1: e1.y1,
                        x2: e1.x2,
                        y2: e1.y2,
                        padding: e1.padding,
                        projectedAnchorX: e1.projectedAnchorX,
                        projectedAnchorY: e1.projectedAnchorY,
                        projectedAnchorZ: e1.projectedAnchorZ,
                        tileAnchorX: e1.tileAnchorX,
                        tileAnchorY: e1.tileAnchorY
                    }, u.textFeatureIndex = e1.featureIndex;
                    break;
                }
                for(let e1 = n; e1 < i; e1++){
                    const r = t1.get(e1);
                    u.verticalTextBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        padding: r.padding,
                        projectedAnchorX: r.projectedAnchorX,
                        projectedAnchorY: r.projectedAnchorY,
                        projectedAnchorZ: r.projectedAnchorZ,
                        tileAnchorX: r.tileAnchorX,
                        tileAnchorY: r.tileAnchorY
                    }, u.verticalTextFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e1 = s; e1 < a; e1++){
                    const r = t1.get(e1);
                    u.iconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        padding: r.padding,
                        projectedAnchorX: r.projectedAnchorX,
                        projectedAnchorY: r.projectedAnchorY,
                        projectedAnchorZ: r.projectedAnchorZ,
                        tileAnchorX: r.tileAnchorX,
                        tileAnchorY: r.tileAnchorY
                    }, u.iconFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e1 = o; e1 < l; e1++){
                    const r = t1.get(e1);
                    u.verticalIconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        padding: r.padding,
                        projectedAnchorX: r.projectedAnchorX,
                        projectedAnchorY: r.projectedAnchorY,
                        projectedAnchorZ: r.projectedAnchorZ,
                        tileAnchorX: r.tileAnchorX,
                        tileAnchorY: r.tileAnchorY
                    }, u.verticalIconFeatureIndex = r.featureIndex;
                    break;
                }
                return u;
            }
            deserializeCollisionBoxes(t1) {
                this.collisionArrays = [];
                for(let e1 = 0; e1 < this.symbolInstances.length; e1++){
                    const r = this.symbolInstances.get(e1);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            addIndicesForPlacedSymbol(t1, e1) {
                const r = t1.placedSymbolArray.get(e1), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let e1 = r.vertexStartIndex; e1 < n; e1 += 4)t1.indexArray.emplaceBack(e1, e1 + 1, e1 + 2), t1.indexArray.emplaceBack(e1 + 1, e1 + 2, e1 + 3);
            }
            getSortedSymbolIndexes(t1) {
                if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e1 = Math.sin(t1), r = Math.cos(t1), n = [], i = [], s = [];
                for(let t1 = 0; t1 < this.symbolInstances.length; ++t1){
                    s.push(t1);
                    const a = this.symbolInstances.get(t1);
                    n.push(0 | Math.round(e1 * a.tileAnchorX + r * a.tileAnchorY)), i.push(a.featureIndex);
                }
                return s.sort((t1, e1)=>n[t1] - n[e1] || i[e1] - i[t1]), s;
            }
            addToSortKeyRanges(t1, e1) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === e1 ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                    sortKey: e1,
                    symbolInstanceStart: t1,
                    symbolInstanceEnd: t1 + 1
                });
            }
            sortFeatures(t1) {
                if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t1 of this.symbolInstanceIndexes){
                        const e1 = this.symbolInstances.get(t1);
                        this.featureSortOrder.push(e1.featureIndex), [
                            e1.rightJustifiedTextSymbolIndex,
                            e1.centerJustifiedTextSymbolIndex,
                            e1.leftJustifiedTextSymbolIndex
                        ].forEach((t1, e1, r)=>{
                            t1 >= 0 && r.indexOf(t1) === e1 && this.addIndicesForPlacedSymbol(this.text, t1);
                        }), e1.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, e1.verticalPlacedTextSymbolIndex), e1.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e1.placedIconSymbolIndex), e1.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e1.verticalPlacedIconSymbolIndex);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
            constructor(t1){
                this.collisionBoxArray = t1.collisionBoxArray, this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.pixelRatio = t1.pixelRatio, this.sourceLayerIndex = t1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = ml([]), this.placementViewportMatrix = ml([]);
                const e1 = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = lh(this.zoom, e1["text-size"]), this.iconSizeData = lh(this.zoom, e1["icon-size"]);
                const r = this.layers[0].layout, n = r.get("symbol-sort-key"), i = r.get("symbol-z-order");
                this.canOverlap = r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1), this.sortFeaturesByY = ("viewport-y" === i || "auto" === i && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = r.get("text-writing-mode").map((t1)=>Nh[t1]), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.sourceID = t1.sourceID, this.projection = t1.projection;
            }
        }
        Pi(Qf, "SymbolBucket", {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), Qf.MAX_GLYPHS = 65535, Qf.addDynamicAttributes = Hf;
        const td = new Zs({
            "symbol-placement": new $s(Gt.layout_symbol["symbol-placement"]),
            "symbol-spacing": new $s(Gt.layout_symbol["symbol-spacing"]),
            "symbol-avoid-edges": new $s(Gt.layout_symbol["symbol-avoid-edges"]),
            "symbol-sort-key": new Os(Gt.layout_symbol["symbol-sort-key"]),
            "symbol-z-order": new $s(Gt.layout_symbol["symbol-z-order"]),
            "icon-allow-overlap": new $s(Gt.layout_symbol["icon-allow-overlap"]),
            "icon-ignore-placement": new $s(Gt.layout_symbol["icon-ignore-placement"]),
            "icon-optional": new $s(Gt.layout_symbol["icon-optional"]),
            "icon-rotation-alignment": new $s(Gt.layout_symbol["icon-rotation-alignment"]),
            "icon-size": new Os(Gt.layout_symbol["icon-size"]),
            "icon-text-fit": new $s(Gt.layout_symbol["icon-text-fit"]),
            "icon-text-fit-padding": new $s(Gt.layout_symbol["icon-text-fit-padding"]),
            "icon-image": new Os(Gt.layout_symbol["icon-image"]),
            "icon-rotate": new Os(Gt.layout_symbol["icon-rotate"]),
            "icon-padding": new $s(Gt.layout_symbol["icon-padding"]),
            "icon-keep-upright": new $s(Gt.layout_symbol["icon-keep-upright"]),
            "icon-offset": new Os(Gt.layout_symbol["icon-offset"]),
            "icon-anchor": new Os(Gt.layout_symbol["icon-anchor"]),
            "icon-pitch-alignment": new $s(Gt.layout_symbol["icon-pitch-alignment"]),
            "text-pitch-alignment": new $s(Gt.layout_symbol["text-pitch-alignment"]),
            "text-rotation-alignment": new $s(Gt.layout_symbol["text-rotation-alignment"]),
            "text-field": new Os(Gt.layout_symbol["text-field"]),
            "text-font": new Os(Gt.layout_symbol["text-font"]),
            "text-size": new Os(Gt.layout_symbol["text-size"]),
            "text-max-width": new Os(Gt.layout_symbol["text-max-width"]),
            "text-line-height": new Os(Gt.layout_symbol["text-line-height"]),
            "text-letter-spacing": new Os(Gt.layout_symbol["text-letter-spacing"]),
            "text-justify": new Os(Gt.layout_symbol["text-justify"]),
            "text-radial-offset": new Os(Gt.layout_symbol["text-radial-offset"]),
            "text-variable-anchor": new $s(Gt.layout_symbol["text-variable-anchor"]),
            "text-anchor": new Os(Gt.layout_symbol["text-anchor"]),
            "text-max-angle": new $s(Gt.layout_symbol["text-max-angle"]),
            "text-writing-mode": new $s(Gt.layout_symbol["text-writing-mode"]),
            "text-rotate": new Os(Gt.layout_symbol["text-rotate"]),
            "text-padding": new $s(Gt.layout_symbol["text-padding"]),
            "text-keep-upright": new $s(Gt.layout_symbol["text-keep-upright"]),
            "text-transform": new Os(Gt.layout_symbol["text-transform"]),
            "text-offset": new Os(Gt.layout_symbol["text-offset"]),
            "text-allow-overlap": new $s(Gt.layout_symbol["text-allow-overlap"]),
            "text-ignore-placement": new $s(Gt.layout_symbol["text-ignore-placement"]),
            "text-optional": new $s(Gt.layout_symbol["text-optional"])
        });
        var ed = {
            paint: new Zs({
                "icon-opacity": new Os(Gt.paint_symbol["icon-opacity"]),
                "icon-color": new Os(Gt.paint_symbol["icon-color"]),
                "icon-halo-color": new Os(Gt.paint_symbol["icon-halo-color"]),
                "icon-halo-width": new Os(Gt.paint_symbol["icon-halo-width"]),
                "icon-halo-blur": new Os(Gt.paint_symbol["icon-halo-blur"]),
                "icon-translate": new $s(Gt.paint_symbol["icon-translate"]),
                "icon-translate-anchor": new $s(Gt.paint_symbol["icon-translate-anchor"]),
                "text-opacity": new Os(Gt.paint_symbol["text-opacity"]),
                "text-color": new Os(Gt.paint_symbol["text-color"], {
                    runtimeType: ne,
                    getOverride: (t1)=>t1.textColor,
                    hasOverride: (t1)=>!!t1.textColor
                }),
                "text-halo-color": new Os(Gt.paint_symbol["text-halo-color"]),
                "text-halo-width": new Os(Gt.paint_symbol["text-halo-width"]),
                "text-halo-blur": new Os(Gt.paint_symbol["text-halo-blur"]),
                "text-translate": new $s(Gt.paint_symbol["text-translate"]),
                "text-translate-anchor": new $s(Gt.paint_symbol["text-translate-anchor"])
            }),
            layout: td
        };
        class rd {
            evaluate(t1) {
                if (t1.formattedSection) {
                    const e1 = this.defaultValue.property.overrides;
                    if (e1 && e1.hasOverride(t1.formattedSection)) return e1.getOverride(t1.formattedSection);
                }
                return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t1) {
                this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
            constructor(t1){
                this.type = t1.property.overrides ? t1.property.overrides.runtimeType : Qt, this.defaultValue = t1;
            }
        }
        Pi(rd, "FormatSectionOverride", {
            omit: [
                "defaultValue"
            ]
        });
        class nd extends xo {
            recalculate(t1, e1) {
                super.recalculate(t1, e1), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
                const r = this.layout.get("text-writing-mode");
                if (r) {
                    const t1 = [];
                    for (const e1 of r)t1.indexOf(e1) < 0 && t1.push(e1);
                    this.layout._values["text-writing-mode"] = t1;
                } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? [
                    "horizontal"
                ] : [
                    "horizontal",
                    "vertical"
                ];
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(t1, e1, r, n) {
                const i = this.layout.get(t1).evaluate(e1, {}, r, n), s = this._unevaluatedLayout._values[t1];
                return s.isDataDriven() || Fn(s.value) || !i ? i : function(t1, e1) {
                    return e1.replace(/{([^{}]+)}/g, (e1, r)=>r in t1 ? String(t1[r]) : "");
                }(e1.properties, i);
            }
            createBucket(t1) {
                return new Qf(t1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            _setPaintOverrides() {
                for (const t1 of ed.paint.overridableProperties){
                    if (!nd.hasPaintOverride(this.layout, t1)) continue;
                    const e1 = this.paint.get(t1), r = new rd(e1), n = new Vn(r, e1.property.specification);
                    let i = null;
                    i = "constant" === e1.value.kind || "source" === e1.value.kind ? new Rn("source", n) : new Un("composite", n, e1.value.zoomStops, e1.value._interpolationType), this.paint._values[t1] = new Us(e1.property, i, e1.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t1, e1, r) {
                return !(!this.layout || e1.isDataDriven() || r.isDataDriven()) && nd.hasPaintOverride(this.layout, t1);
            }
            static hasPaintOverride(t1, e1) {
                const r = t1.get("text-field"), n = ed.paint.properties[e1];
                let i = !1;
                const s = (t1)=>{
                    for (const e1 of t1)if (n.overrides && n.overrides.hasOverride(e1)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof _e) s(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const t1 = (e1)=>{
                        i || (e1 instanceof ze && ke(e1.value) === oe ? s(e1.value.sections) : e1 instanceof Pe ? s(e1.sections) : e1.eachChild(t1));
                    }, e1 = r.value;
                    e1._styleExpression && t1(e1._styleExpression.expression);
                }
                return i;
            }
            getProgramConfiguration(t1) {
                return new uo(this, t1);
            }
            constructor(t1){
                super(t1, ed);
            }
        }
        var id = {
            paint: new Zs({
                "background-color": new $s(Gt.paint_background["background-color"]),
                "background-pattern": new Ns(Gt.paint_background["background-pattern"]),
                "background-opacity": new $s(Gt.paint_background["background-opacity"])
            })
        }, sd = {
            paint: new Zs({
                "raster-opacity": new $s(Gt.paint_raster["raster-opacity"]),
                "raster-hue-rotate": new $s(Gt.paint_raster["raster-hue-rotate"]),
                "raster-brightness-min": new $s(Gt.paint_raster["raster-brightness-min"]),
                "raster-brightness-max": new $s(Gt.paint_raster["raster-brightness-max"]),
                "raster-saturation": new $s(Gt.paint_raster["raster-saturation"]),
                "raster-contrast": new $s(Gt.paint_raster["raster-contrast"]),
                "raster-resampling": new $s(Gt.paint_raster["raster-resampling"]),
                "raster-fade-duration": new $s(Gt.paint_raster["raster-fade-duration"])
            })
        };
        class ad extends xo {
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {}
            onAdd(t1) {
                this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
            }
            onRemove(t1) {
                this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
            }
            constructor(t1){
                super(t1, {}), this.implementation = t1;
            }
        }
        var od = {
            paint: new Zs({
                "sky-type": new $s(Gt.paint_sky["sky-type"]),
                "sky-atmosphere-sun": new $s(Gt.paint_sky["sky-atmosphere-sun"]),
                "sky-atmosphere-sun-intensity": new $s(Gt.paint_sky["sky-atmosphere-sun-intensity"]),
                "sky-gradient-center": new $s(Gt.paint_sky["sky-gradient-center"]),
                "sky-gradient-radius": new $s(Gt.paint_sky["sky-gradient-radius"]),
                "sky-gradient": new Gs(Gt.paint_sky["sky-gradient"]),
                "sky-atmosphere-halo-color": new $s(Gt.paint_sky["sky-atmosphere-halo-color"]),
                "sky-atmosphere-color": new $s(Gt.paint_sky["sky-atmosphere-color"]),
                "sky-opacity": new $s(Gt.paint_sky["sky-opacity"])
            })
        };
        function ld(t1, e1, r) {
            const n = [
                0,
                0,
                1
            ], i = Hl([]);
            return Wl(i, i, r ? -l(t1) + Math.PI : l(t1)), Yl(i, i, -l(e1)), $l(n, n, i), Ll(n, n);
        }
        const ud = {
            circle: class extends xo {
                createBucket(t1) {
                    return new Ko(t1);
                }
                queryRadius(t1) {
                    const e1 = t1;
                    return ol("circle-radius", this, e1) + ol("circle-stroke-width", this, e1) + ll(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, i, s, a, o) {
                    const l = cl(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), u = this.paint.get("circle-radius").evaluate(e1, r) + this.paint.get("circle-stroke-width").evaluate(e1, r);
                    return ru(t1, n, s, a, o, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, u);
                }
                getProgramIds() {
                    return [
                        "circle"
                    ];
                }
                getProgramConfiguration(t1) {
                    return new uo(this, t1);
                }
                constructor(t1){
                    super(t1, pl);
                }
            },
            heatmap: class extends xo {
                createBucket(t1) {
                    return new ou(t1);
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    "heatmap-color" === t1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = du({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                queryRadius(t1) {
                    return ol("heatmap-radius", this, t1);
                }
                queryIntersectsFeature(t1, e1, r, n, s, a, o, l) {
                    const u = this.paint.get("heatmap-radius").evaluate(e1, r);
                    return ru(t1, n, a, o, l, !0, !0, new i(0, 0), u);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "heatmap",
                        "heatmapTexture"
                    ];
                }
                getProgramConfiguration(t1) {
                    return new uo(this, t1);
                }
                constructor(t1){
                    super(t1, fu), this._updateColorRamp();
                }
            },
            hillshade: class extends xo {
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "hillshade",
                        "hillshadePrepare"
                    ];
                }
                constructor(t1){
                    super(t1, yu);
                }
            },
            fill: class extends xo {
                getProgramIds() {
                    const t1 = this.paint.get("fill-pattern"), e1 = t1 && t1.constantOr(1), r = [
                        e1 ? "fillPattern" : "fill"
                    ];
                    return this.paint.get("fill-antialias") && r.push(e1 && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r;
                }
                getProgramConfiguration(t1) {
                    return new uo(this, t1);
                }
                recalculate(t1, e1) {
                    super.recalculate(t1, e1);
                    const r = this.paint._values["fill-outline-color"];
                    "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(t1) {
                    return new tc(t1);
                }
                queryRadius() {
                    return ll(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, i, s) {
                    return !t1.queryGeometry.isAboveHorizon && Wo(ul(t1.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), s.angle, t1.pixelToTileUnitsFactor), n);
                }
                isTileClipped() {
                    return !0;
                }
                constructor(t1){
                    super(t1, rc);
                }
            },
            "fill-extrusion": class extends xo {
                createBucket(t1) {
                    return new wc(t1);
                }
                queryRadius() {
                    return ll(this.paint.get("fill-extrusion-translate"));
                }
                is3D() {
                    return !0;
                }
                getProgramIds() {
                    return [
                        this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"
                    ];
                }
                getProgramConfiguration(t1) {
                    return new uo(this, t1);
                }
                queryIntersectsFeature(t1, e1, r, n, s, a, o, l, u) {
                    const c = cl(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), a.angle, t1.pixelToTileUnitsFactor), h = this.paint.get("fill-extrusion-height").evaluate(e1, r), p = this.paint.get("fill-extrusion-base").evaluate(e1, r), f = [
                        0,
                        0
                    ], d = l && a.elevation, y = a.elevation ? a.elevation.exaggeration() : 1, m = t1.tile.getBucket(this);
                    if (d && m instanceof wc) {
                        const t1 = m.centroidVertexArray, e1 = u + 1;
                        if (e1 < t1.length) {
                            const r = t1.get(e1);
                            f[0] = r.a_centroid_pos0, f[1] = r.a_centroid_pos1;
                        }
                    }
                    if (0 === f[0] && 1 === f[1]) return !1;
                    "globe" === a.projection.name && (n = Bc([
                        n
                    ], [
                        new i(0, 0),
                        new i(wo, wo)
                    ], t1.tileID.canonical).map((t1)=>t1.polygon).flat());
                    const g = function(t1, e1, r, n, s, a, o, l, u, c, h) {
                        return "globe" === t1.projection.name ? function(t1, e1, r, n, i, s, a, o, l, u, c) {
                            const h = [], p = [], f = t1.projection.upVectorScale(c, t1.center.lat, t1.worldSize).metersToTile, d = [
                                0,
                                0,
                                0,
                                1
                            ], y = [
                                0,
                                0,
                                0,
                                1
                            ], m = (t1, e1, r, n)=>{
                                t1[0] = e1, t1[1] = r, t1[2] = n, t1[3] = 1;
                            }, g = Tc();
                            r > 0 && (r += g), n += g;
                            for (const g of e1){
                                const e1 = [], x = [];
                                for (const h of g){
                                    const p = h.x + i.x, g = h.y + i.y, v = t1.projection.projectTilePoint(p, g, c), b = t1.projection.upVector(c, h.x, h.y);
                                    let _ = r, w = n;
                                    if (a) {
                                        const t1 = $c(p, g, r, n, a, o, l, u);
                                        _ += t1.base, w += t1.top;
                                    }
                                    0 !== r ? m(d, v.x + b[0] * f * _, v.y + b[1] * f * _, v.z + b[2] * f * _) : m(d, v.x, v.y, v.z), m(y, v.x + b[0] * f * w, v.y + b[1] * f * w, v.z + b[2] * f * w), jl(d, d, s), jl(y, y, s), e1.push(jc(d)), x.push(jc(y));
                                }
                                h.push(e1), p.push(x);
                            }
                            return [
                                h,
                                p
                            ];
                        }(t1, e1, r, n, s, a, o, l, u, c, h) : o ? function(t1, e1, r, n, i, s, a, o, l) {
                            const u = [], c = [], h = [
                                0,
                                0,
                                0,
                                1
                            ];
                            for (const p of t1){
                                const t1 = [], f = [];
                                for (const u of p){
                                    const c = u.x + n.x, p = u.y + n.y, d = $c(c, p, e1, r, s, a, o, l);
                                    h[0] = c, h[1] = p, h[2] = d.base, h[3] = 1, Xl(h, h, i), h[3] = Math.max(h[3], 1e-5);
                                    const y = jc([
                                        h[0] / h[3],
                                        h[1] / h[3],
                                        h[2] / h[3]
                                    ]);
                                    h[0] = c, h[1] = p, h[2] = d.top, h[3] = 1, Xl(h, h, i), h[3] = Math.max(h[3], 1e-5);
                                    const m = jc([
                                        h[0] / h[3],
                                        h[1] / h[3],
                                        h[2] / h[3]
                                    ]);
                                    t1.push(y), f.push(m);
                                }
                                u.push(t1), c.push(f);
                            }
                            return [
                                u,
                                c
                            ];
                        }(e1, r, n, s, a, o, l, u, c) : function(t1, e1, r, n, s) {
                            const a = [], o = [], l = s[8] * e1, u = s[9] * e1, c = s[10] * e1, h = s[11] * e1, p = s[8] * r, f = s[9] * r, d = s[10] * r, y = s[11] * r;
                            for (const e1 of t1){
                                const t1 = [], r = [];
                                for (const a of e1){
                                    const e1 = a.x + n.x, o = a.y + n.y, m = s[0] * e1 + s[4] * o + s[12], g = s[1] * e1 + s[5] * o + s[13], x = s[2] * e1 + s[6] * o + s[14], v = s[3] * e1 + s[7] * o + s[15], b = m + l, _ = g + u, w = x + c, A = Math.max(v + h, 1e-5), S = m + p, k = g + f, I = x + d, M = Math.max(v + y, 1e-5), z = new i(b / A, _ / A);
                                    z.z = w / A, t1.push(z);
                                    const T = new i(S / M, k / M);
                                    T.z = I / M, r.push(T);
                                }
                                a.push(t1), o.push(r);
                            }
                            return [
                                a,
                                o
                            ];
                        }(e1, r, n, s, a);
                    }(a, n, p, h, c, o, d ? l : null, f, y, a.center.lat, t1.tileID.canonical), x = t1.queryGeometry;
                    return function(t1, e1, r) {
                        let n = 1 / 0;
                        Wo(r, e1) && (n = Uc(r, e1[0]));
                        for(let i = 0; i < e1.length; i++){
                            const s = e1[i], a = t1[i];
                            for(let t1 = 0; t1 < s.length - 1; t1++){
                                const e1 = s[t1], i = [
                                    e1,
                                    s[t1 + 1],
                                    a[t1 + 1],
                                    a[t1],
                                    e1
                                ];
                                Ho(r, i) && (n = Math.min(n, Uc(r, i)));
                            }
                        }
                        return n !== 1 / 0 && n;
                    }(g[0], g[1], x.isPointQuery() ? x.screenBounds : x.screenGeometry);
                }
                constructor(t1){
                    super(t1, Cc);
                }
            },
            line: class extends xo {
                _handleSpecialPaintPropertyUpdate(t1) {
                    if ("line-gradient" === t1) {
                        const t1 = this._transitionablePaint._values["line-gradient"].value.expression;
                        this.stepInterpolant = t1._styleExpression && t1._styleExpression.expression instanceof gr, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    }
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                recalculate(t1, e1) {
                    super.recalculate(t1, e1), this.paint._values["line-floorwidth"] = Wc.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t1);
                }
                createBucket(t1) {
                    return new Kc(t1);
                }
                getProgramIds() {
                    return [
                        this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"
                    ];
                }
                getProgramConfiguration(t1) {
                    return new uo(this, t1);
                }
                queryRadius(t1) {
                    const e1 = t1, r = Jc(ol("line-width", this, e1), ol("line-gap-width", this, e1)), n = ol("line-offset", this, e1);
                    return r / 2 + Math.abs(n) + ll(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, s, a) {
                    if (t1.queryGeometry.isAboveHorizon) return !1;
                    const o = ul(t1.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), a.angle, t1.pixelToTileUnitsFactor), l = t1.pixelToTileUnitsFactor / 2 * Jc(this.paint.get("line-width").evaluate(e1, r), this.paint.get("line-gap-width").evaluate(e1, r)), u = this.paint.get("line-offset").evaluate(e1, r);
                    return u && (n = function(t1, e1) {
                        const r = [], n = new i(0, 0);
                        for(let i = 0; i < t1.length; i++){
                            const s = t1[i], a = [];
                            for(let t1 = 0; t1 < s.length; t1++){
                                const r = s[t1 - 1], i = s[t1], o = s[t1 + 1], l = 0 === t1 ? n : i.sub(r)._unit()._perp(), u = t1 === s.length - 1 ? n : o.sub(i)._unit()._perp(), c = l._add(u)._unit();
                                c._mult(1 / (c.x * u.x + c.y * u.y)), a.push(c._mult(e1)._add(i));
                            }
                            r.push(a);
                        }
                        return r;
                    }(n, u * t1.pixelToTileUnitsFactor)), function(t1, e1, r) {
                        for(let n = 0; n < e1.length; n++){
                            const i = e1[n];
                            if (t1.length >= 3) {
                                for(let e1 = 0; e1 < i.length; e1++)if (il(t1, i[e1])) return !0;
                            }
                            if (Jo(t1, i, r)) return !0;
                        }
                        return !1;
                    }(o, n, l);
                }
                isTileClipped() {
                    return !0;
                }
                constructor(t1){
                    super(t1, Yc), this.gradientVersion = 0;
                }
            },
            symbol: nd,
            background: class extends xo {
                getProgramIds() {
                    return [
                        this.paint.get("background-pattern") ? "backgroundPattern" : "background"
                    ];
                }
                constructor(t1){
                    super(t1, id);
                }
            },
            raster: class extends xo {
                getProgramIds() {
                    return [
                        "raster"
                    ];
                }
                constructor(t1){
                    super(t1, sd);
                }
            },
            sky: class extends xo {
                _handleSpecialPaintPropertyUpdate(t1) {
                    "sky-gradient" === t1 ? this._updateColorRamp() : "sky-atmosphere-sun" !== t1 && "sky-atmosphere-halo-color" !== t1 && "sky-atmosphere-color" !== t1 && "sky-atmosphere-sun-intensity" !== t1 || (this._skyboxInvalidated = !0);
                }
                _updateColorRamp() {
                    this.colorRamp = du({
                        expression: this._transitionablePaint._values["sky-gradient"].value.expression,
                        evaluationKey: "skyRadialProgress"
                    }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                needsSkyboxCapture(t1) {
                    if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
                    if (!this.paint.get("sky-atmosphere-sun")) {
                        const e1 = t1.style.light.properties.get("position");
                        return this._lightPosition.azimuthal !== e1.azimuthal || this._lightPosition.polar !== e1.polar;
                    }
                    return !1;
                }
                getCenter(t1, e1) {
                    if ("atmosphere" === this.paint.get("sky-type")) {
                        const r = this.paint.get("sky-atmosphere-sun"), n = !r, i = t1.style.light, s = i.properties.get("position");
                        return n && "viewport" === i.properties.get("anchor") && E("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n ? ld(s.azimuthal, 90 - s.polar, e1) : ld(r[0], 90 - r[1], e1);
                    }
                    const r = this.paint.get("sky-gradient-center");
                    return ld(r[0], 90 - r[1], e1);
                }
                is3D() {
                    return !1;
                }
                isSky() {
                    return !0;
                }
                markSkyboxValid(t1) {
                    this._skyboxInvalidated = !1, this._lightPosition = t1.style.light.properties.get("position");
                }
                hasOffscreenPass() {
                    return !0;
                }
                getProgramIds() {
                    const t1 = this.paint.get("sky-type");
                    return "atmosphere" === t1 ? [
                        "skyboxCapture",
                        "skybox"
                    ] : "gradient" === t1 ? [
                        "skyboxGradient"
                    ] : null;
                }
                constructor(t1){
                    super(t1, od), this._updateColorRamp();
                }
            }
        };
        class cd {
            update(t1, r, n) {
                const { width: i, height: s } = t1, { context: a } = this, { gl: o } = a, { HTMLImageElement: l, HTMLCanvasElement: u, HTMLVideoElement: c, ImageData: h, ImageBitmap: p } = e1;
                if (o.bindTexture(o.TEXTURE_2D, this.texture), a.pixelStoreUnpackFlipY.set(!1), a.pixelStoreUnpack.set(1), a.pixelStoreUnpackPremultiplyAlpha.set(this.format === o.RGBA && (!r || !1 !== r.premultiply)), n || this.size && this.size[0] === i && this.size[1] === s) {
                    const { x: e1, y: r } = n || {
                        x: 0,
                        y: 0
                    };
                    t1 instanceof l || t1 instanceof u || t1 instanceof c || t1 instanceof h || p && t1 instanceof p ? o.texSubImage2D(o.TEXTURE_2D, 0, e1, r, o.RGBA, o.UNSIGNED_BYTE, t1) : o.texSubImage2D(o.TEXTURE_2D, 0, e1, r, i, s, o.RGBA, o.UNSIGNED_BYTE, t1.data);
                } else this.size = [
                    i,
                    s
                ], t1 instanceof l || t1 instanceof u || t1 instanceof c || t1 instanceof h || p && t1 instanceof p ? o.texImage2D(o.TEXTURE_2D, 0, this.format, this.format, o.UNSIGNED_BYTE, t1) : o.texImage2D(o.TEXTURE_2D, 0, this.format, i, s, 0, this.format, o.UNSIGNED_BYTE, t1.data);
                this.useMipmap = Boolean(r && r.useMipmap && this.isSizePowerOfTwo()), this.useMipmap && o.generateMipmap(o.TEXTURE_2D);
            }
            bind(t1, e1) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_2D, this.texture), t1 !== this.filter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, this.useMipmap ? t1 === n.NEAREST ? n.NEAREST_MIPMAP_NEAREST : n.LINEAR_MIPMAP_NEAREST : t1), this.filter = t1), e1 !== this.wrap && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, e1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, e1), this.wrap = e1);
            }
            isSizePowerOfTwo() {
                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
            }
            destroy() {
                const { gl: t1 } = this.context;
                t1.deleteTexture(this.texture), this.texture = null;
            }
            constructor(t1, e1, r, n){
                this.context = t1, this.format = r, this.texture = t1.gl.createTexture(), this.update(e1, n);
            }
        }
        class hd {
            getDash(t1, e1) {
                const r = this.getKey(t1, e1);
                return this.positions[r];
            }
            trim() {
                const t1 = this.width, e1 = this.height = A(this.nextRow);
                this.image.resize({
                    width: t1,
                    height: e1
                });
            }
            getKey(t1, e1) {
                return t1.join(",") + e1;
            }
            getDashRanges(t1, e1, r) {
                const n = [];
                let i = t1.length % 2 == 1 ? -t1[t1.length - 1] * r : 0, s = t1[0] * r, a = !0;
                n.push({
                    left: i,
                    right: s,
                    isDash: a,
                    zeroLength: 0 === t1[0]
                });
                let o = t1[0];
                for(let e1 = 1; e1 < t1.length; e1++){
                    a = !a;
                    const l = t1[e1];
                    i = o * r, o += l, s = o * r, n.push({
                        left: i,
                        right: s,
                        isDash: a,
                        zeroLength: 0 === l
                    });
                }
                return n;
            }
            addRoundDash(t1, e1, r) {
                const n = e1 / 2;
                for(let e1 = -r; e1 <= r; e1++){
                    const i = this.width * (this.nextRow + r + e1);
                    let s = 0, a = t1[s];
                    for(let o = 0; o < this.width; o++){
                        o / a.right > 1 && (a = t1[++s]);
                        const l = Math.abs(o - a.left), u = Math.abs(o - a.right), c = Math.min(l, u);
                        let h;
                        const p = e1 / r * (n + 1);
                        if (a.isDash) {
                            const t1 = n - Math.abs(p);
                            h = Math.sqrt(c * c + t1 * t1);
                        } else h = n - Math.sqrt(c * c + p * p);
                        this.image.data[i + o] = Math.max(0, Math.min(255, h + 128));
                    }
                }
            }
            addRegularDash(t1, e1) {
                for(let e1 = t1.length - 1; e1 >= 0; --e1){
                    const r = t1[e1], n = t1[e1 + 1];
                    r.zeroLength ? t1.splice(e1, 1) : n && n.isDash === r.isDash && (n.left = r.left, t1.splice(e1, 1));
                }
                const r = t1[0], n = t1[t1.length - 1];
                r.isDash === n.isDash && (r.left = n.left - this.width, n.right = r.right + this.width);
                const i = this.width * this.nextRow;
                let s = 0, a = t1[s];
                for(let r = 0; r < this.width; r++){
                    r / a.right > 1 && (a = t1[++s]);
                    const n = Math.abs(r - a.left), o = Math.abs(r - a.right), l = Math.min(n, o);
                    this.image.data[i + r] = Math.max(0, Math.min(255, (a.isDash ? l : -l) + e1 + 128));
                }
            }
            addDash(t1, e1) {
                const r = this.getKey(t1, e1);
                if (this.positions[r]) return this.positions[r];
                const n = "round" === e1, i = n ? 7 : 0, s = 2 * i + 1;
                if (this.nextRow + s > this.height) return E("LineAtlas out of space"), null;
                0 === t1.length && t1.push(1);
                let a = 0;
                for(let e1 = 0; e1 < t1.length; e1++)t1[e1] < 0 && (E("Negative value is found in line dasharray, replacing values with 0"), t1[e1] = 0), a += t1[e1];
                if (0 !== a) {
                    const r = this.width / a, s = this.getDashRanges(t1, this.width, r);
                    n ? this.addRoundDash(s, r, i) : this.addRegularDash(s, "square" === e1 ? .5 * r : 0);
                }
                const o = this.nextRow + i;
                this.nextRow += s;
                const l = {
                    tl: [
                        o,
                        i
                    ],
                    br: [
                        a,
                        0
                    ]
                };
                return this.positions[r] = l, l;
            }
            constructor(t1, e1){
                this.width = t1, this.height = e1, this.nextRow = 0, this.image = new hu({
                    width: t1,
                    height: e1
                }), this.positions = {}, this.uploaded = !1;
            }
        }
        Pi(hd, "LineAtlas");
        class pd {
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                this._channel = void 0, this._callback = ()=>{};
            }
            constructor(t1){
                this._callback = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
        }
        class fd {
            add(t1, e1) {
                const r = this.nextId++, n = function({ type: t1, isSymbolTile: e1, zoom: r }) {
                    return r = r || 0, "message" === t1 ? 0 : "maybePrepare" !== t1 || e1 ? "parseTile" !== t1 || e1 ? "parseTile" === t1 && e1 ? 300 - r : "maybePrepare" === t1 && e1 ? 400 - r : 500 : 200 - r : 100 - r;
                }(e1);
                if (0 === n) {
                    D();
                    t1();
                    return {
                        cancel: ()=>{}
                    };
                }
                return this.tasks[r] = {
                    fn: t1,
                    metadata: e1,
                    priority: n,
                    id: r
                }, this.taskQueue.push(r), this.invoker.trigger(), {
                    cancel: ()=>{
                        delete this.tasks[r];
                    }
                };
            }
            process() {
                D();
                {
                    if (this.taskQueue = this.taskQueue.filter((t1)=>!!this.tasks[t1]), !this.taskQueue.length) return;
                    const t1 = this.pick();
                    if (null === t1) return;
                    const e1 = this.tasks[t1];
                    if (delete this.tasks[t1], this.taskQueue.length && this.invoker.trigger(), !e1) return;
                    e1.fn();
                }
            }
            pick() {
                let t1 = null, e1 = 1 / 0;
                for(let r = 0; r < this.taskQueue.length; r++){
                    const n = this.tasks[this.taskQueue[r]];
                    n.priority < e1 && (e1 = n.priority, t1 = r);
                }
                if (null === t1) return null;
                const r = this.taskQueue[t1];
                return this.taskQueue.splice(t1, 1), r;
            }
            remove() {
                this.invoker.remove();
            }
            constructor(){
                this.tasks = {}, this.taskQueue = [], k([
                    "process"
                ], this), this.invoker = new pd(this.process), this.nextId = 0;
            }
        }
        class dd {
            encode(t1) {
                return this._stringToNumber[t1];
            }
            decode(t1) {
                return this._numberToString[t1];
            }
            constructor(t1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e1 = 0; e1 < t1.length; e1++){
                    const r = t1[e1];
                    this._stringToNumber[r] = e1, this._numberToString[e1] = r;
                }
            }
        }
        const yd = [
            "tile",
            "layer",
            "source",
            "sourceLayer",
            "state"
        ];
        class md {
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(t1) {
                this._geometry = t1;
            }
            toJSON() {
                const t1 = {
                    type: "Feature",
                    geometry: this.geometry,
                    properties: this.properties
                };
                void 0 !== this.id && (t1.id = this.id);
                for (const e1 of yd)void 0 !== this[e1] && (t1[e1] = this[e1]);
                return t1;
            }
            constructor(t1, e1, r, n, i){
                this.type = "Feature", this._vectorTileFeature = t1, this._z = e1, this._x = r, this._y = n, this.properties = t1.properties, this.id = i;
            }
        }
        const gd = 32, xd = 33, vd = new Uint16Array(8184);
        for(let t1 = 0; t1 < 2046; t1++){
            let e1 = t1 + 2, r = 0, n = 0, i = 0, s = 0, a = 0, o = 0;
            for(1 & e1 ? i = s = a = gd : r = n = o = gd; (e1 >>= 1) > 1;){
                const t1 = r + i >> 1, l = n + s >> 1;
                1 & e1 ? (i = r, s = n, r = a, n = o) : (r = i, n = s, i = a, s = o), a = t1, o = l;
            }
            const l = 4 * t1;
            vd[l + 0] = r, vd[l + 1] = n, vd[l + 2] = i, vd[l + 3] = s;
        }
        const bd = new Uint16Array(2178), _d = new Uint8Array(1089), wd = new Uint16Array(1089);
        function Ad(t1) {
            return 0 === t1 ? -0.03125 : 32 === t1 ? .03125 : 0;
        }
        var Sd = Ws([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        const kd = {
            type: 2,
            extent: wo,
            loadGeometry: ()=>[
                    [
                        new i(0, 0),
                        new i(8193, 0),
                        new i(8193, 8193),
                        new i(0, 8193),
                        new i(0, 0)
                    ]
                ]
        };
        class Id {
            registerFadeDuration(t1) {
                const e1 = t1 + this.timeAdded;
                e1 < X.now() || this.fadeEndTime && e1 < this.fadeEndTime || (this.fadeEndTime = e1);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
                return this._tileTransform || (this._tileTransform = Af(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(t1, e1, r) {
                if (this.unloadVectorData(), this.state = "loaded", t1) {
                    t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = function(t1, e1) {
                        const r = {};
                        if (!e1) return r;
                        for (const n of t1){
                            const t1 = n.layerIds.map((t1)=>e1.getLayer(t1)).filter(Boolean);
                            if (0 !== t1.length) {
                                n.layers = t1, n.stateDependentLayerIds && (n.stateDependentLayers = n.stateDependentLayerIds.map((e1)=>t1.filter((t1)=>t1.id === e1)[0]));
                                for (const e1 of t1)r[e1.id] = n;
                            }
                        }
                        return r;
                    }(t1.buckets, e1.style), this.hasSymbolBuckets = !1;
                    for(const t1 in this.buckets){
                        const e1 = this.buckets[t1];
                        if (e1 instanceof Qf) {
                            if (this.hasSymbolBuckets = !0, !r) break;
                            e1.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const t1 in this.buckets){
                        const e1 = this.buckets[t1];
                        if (e1 instanceof Qf && e1.hasRTLText) {
                            this.hasRTLText = !0, Es.isLoading() || Es.isLoaded() || "deferred" !== Ts() || Bs();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const t1 in this.buckets){
                        const r = this.buckets[t1];
                        this.queryPadding = Math.max(this.queryPadding, e1.style.getLayer(t1).queryRadius(r));
                    }
                    t1.imageAtlas && (this.imageAtlas = t1.imageAtlas), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage), t1.lineAtlas && (this.lineAtlas = t1.lineAtlas);
                } else this.collisionBoxArray = new Ma;
            }
            unloadVectorData() {
                if (this.hasData()) {
                    for(const t1 in this.buckets)this.buckets[t1].destroy();
                    this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
                }
            }
            getBucket(t1) {
                return this.buckets[t1.id];
            }
            upload(t1) {
                for(const e1 in this.buckets){
                    const r = this.buckets[e1];
                    r.uploadPending() && r.upload(t1);
                }
                const e1 = t1.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new cd(t1, this.imageAtlas.image, e1.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new cd(t1, this.glyphAtlasImage, e1.ALPHA), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new cd(t1, this.lineAtlas.image, e1.ALPHA), this.lineAtlas.uploaded = !0);
            }
            prepare(t1) {
                this.imageAtlas && this.imageAtlas.patchUpdatedImages(t1, this.imageAtlasTexture);
            }
            queryRenderedFeatures(t1, e1, r, n, i, s, a, o) {
                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                    tileResult: n,
                    pixelPosMatrix: a,
                    transform: s,
                    params: i,
                    tileTransform: this.tileTransform
                }, t1, e1, r) : {};
            }
            querySourceFeatures(t1, e1) {
                const r = this.latestFeatureIndex;
                if (!r || !r.rawTileData) return;
                const n = r.loadVTLayers(), i = e1 ? e1.sourceLayer : "", s = n._geojsonTileLayer || n[i];
                if (!s) return;
                const a = Jn(e1 && e1.filter), { z: o, x: l, y: u } = this.tileID.canonical, c = {
                    z: o,
                    x: l,
                    y: u
                };
                for(let e1 = 0; e1 < s.length; e1++){
                    const n = s.feature(e1);
                    if (a.needGeometry) {
                        const t1 = Go(n, !0);
                        if (!a.filter(new Cs(this.tileID.overscaledZ), t1, this.tileID.canonical)) continue;
                    } else if (!a.filter(new Cs(this.tileID.overscaledZ), n)) continue;
                    const h = r.getId(n, i), p = new md(n, o, l, u, h);
                    p.tile = c, t1.push(p);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return !!this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(t1) {
                const e1 = this.expirationTime;
                if (t1.cacheControl) {
                    const e1 = V(t1.cacheControl);
                    e1["max-age"] && (this.expirationTime = Date.now() + 1e3 * e1["max-age"]);
                } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
                if (this.expirationTime) {
                    const t1 = Date.now();
                    let r = !1;
                    if (this.expirationTime > t1) r = !1;
                    else if (e1) {
                        if (this.expirationTime < e1) r = !0;
                        else {
                            const n = this.expirationTime - e1;
                            n ? this.expirationTime = t1 + Math.max(n, 3e4) : r = !0;
                        }
                    } else r = !0;
                    r ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(t1, e1) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(t1).length || !e1) return;
                const r = this.latestFeatureIndex.loadVTLayers(), n = e1.style.listImages();
                for(const i in this.buckets){
                    if (!e1.style.hasLayer(i)) continue;
                    const s = this.buckets[i], a = s.layers[0].sourceLayer || "_geojsonTileLayer", o = r[a], l = t1[a];
                    if (!o || !l || 0 === Object.keys(l).length) continue;
                    if (s.update(l, o, n, this.imageAtlas && this.imageAtlas.patternPositions || {}), s instanceof Kc || s instanceof tc) {
                        const t1 = e1.style._getSourceCache(s.layers[0].source);
                        e1._terrain && e1._terrain.enabled && t1 && s.programConfigurations.needsUpload && e1._terrain._clearRenderCacheForTile(t1.id, this.tileID);
                    }
                    const u = e1 && e1.style && e1.style.getLayer(i);
                    u && (this.queryPadding = Math.max(this.queryPadding, u.queryRadius(s)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < X.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(t1) {
                this.symbolFadeHoldUntil = X.now() + t1;
            }
            setTexture(t1, e1) {
                const r = e1.context, n = r.gl;
                this.texture = e1.getTileTexture(t1.width), this.texture ? this.texture.update(t1, {
                    useMipmap: !0
                }) : (this.texture = new cd(r, t1, n.RGBA, {
                    useMipmap: !0
                }), this.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), r.extTextureFilterAnisotropic && n.texParameterf(n.TEXTURE_2D, r.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, r.extTextureFilterAnisotropicMax));
            }
            setDependencies(t1, e1) {
                const r = {};
                for (const t1 of e1)r[t1] = !0;
                this.dependencies[t1] = r;
            }
            hasDependency(t1, e1) {
                for (const r of t1){
                    const t1 = this.dependencies[r];
                    if (t1) {
                        for (const r of e1)if (t1[r]) return !0;
                    }
                }
                return !1;
            }
            clearQueryDebugViz() {}
            _makeDebugTileBoundsBuffers(t1, e1) {
                if (!e1 || "mercator" === e1.name || this._tileDebugBuffer) return;
                const r = No(kd, this.tileID.canonical, this.tileTransform)[0], n = new Qs, i = new wa;
                for(let t1 = 0; t1 < r.length; t1++){
                    const { x: e1, y: s } = r[t1];
                    n.emplaceBack(e1, s), i.emplaceBack(t1);
                }
                i.emplaceBack(0), this._tileDebugIndexBuffer = t1.createIndexBuffer(i), this._tileDebugBuffer = t1.createVertexBuffer(n, Zp.members), this._tileDebugSegments = _o.simpleSegment(0, 0, n.length, i.length);
            }
            _makeTileBoundsBuffers(t1, e1) {
                if (this._tileBoundsBuffer || !e1 || "mercator" === e1.name) return;
                const r = No(kd, this.tileID.canonical, this.tileTransform)[0];
                let n, i;
                if (this.isRaster) {
                    const t1 = function(t1, e1) {
                        const r = Af(t1, e1), n = Math.pow(2, t1.z);
                        for(let i = 0; i < xd; i++)for(let s = 0; s < xd; s++){
                            const a = Eo((t1.x + (s + Ad(s)) / gd) / n), o = Co((t1.y + (i + Ad(i)) / gd) / n), l = e1.project(a, o), u = i * xd + s;
                            bd[2 * u + 0] = Math.round((l.x * r.scale - r.x) * wo), bd[2 * u + 1] = Math.round((l.y * r.scale - r.y) * wo);
                        }
                        _d.fill(0), wd.fill(0);
                        for(let t1 = 2045; t1 >= 0; t1--){
                            const e1 = 4 * t1, r = vd[e1 + 0], n = vd[e1 + 1], i = vd[e1 + 2], s = vd[e1 + 3], a = r + i >> 1, o = n + s >> 1, l = a + o - n, u = o + r - a, c = n * xd + r, h = s * xd + i, p = o * xd + a, f = Math.hypot((bd[2 * c + 0] + bd[2 * h + 0]) / 2 - bd[2 * p + 0], (bd[2 * c + 1] + bd[2 * h + 1]) / 2 - bd[2 * p + 1]) >= 16;
                            if (_d[p] = _d[p] || (f ? 1 : 0), t1 < 1022) {
                                const t1 = (n + u >> 1) * xd + (r + l >> 1), e1 = (s + u >> 1) * xd + (i + l >> 1);
                                _d[p] = _d[p] || _d[t1] || _d[e1];
                            }
                        }
                        const i = new ea, s = new ya;
                        let a = 0;
                        function o(t1, e1) {
                            const r = e1 * xd + t1;
                            return 0 === wd[r] && (i.emplaceBack(bd[2 * r + 0], bd[2 * r + 1], t1 * wo / gd, e1 * wo / gd), wd[r] = ++a), wd[r] - 1;
                        }
                        function l(t1, e1, r, n, i, a) {
                            const u = t1 + r >> 1, c = e1 + n >> 1;
                            if (Math.abs(t1 - i) + Math.abs(e1 - a) > 1 && _d[c * xd + u]) l(i, a, t1, e1, u, c), l(r, n, i, a, u, c);
                            else {
                                const l = o(t1, e1), u = o(r, n), c = o(i, a);
                                s.emplaceBack(l, u, c);
                            }
                        }
                        return l(0, 0, gd, gd, gd, 0), l(gd, gd, 0, 0, 0, gd), {
                            vertices: i,
                            indices: s
                        };
                    }(this.tileID.canonical, e1);
                    n = t1.vertices, i = t1.indices;
                } else {
                    n = new ea, i = new ya;
                    for (const { x: t1, y: e1 } of r)n.emplaceBack(t1, e1, 0, 0);
                    const t1 = xu(n.int16, void 0, 4);
                    for(let e1 = 0; e1 < t1.length; e1 += 3)i.emplaceBack(t1[e1], t1[e1 + 1], t1[e1 + 2]);
                }
                this._tileBoundsBuffer = t1.createVertexBuffer(n, Sd.members), this._tileBoundsIndexBuffer = t1.createIndexBuffer(i), this._tileBoundsSegments = _o.simpleSegment(0, 0, n.length, i.length);
            }
            _makeGlobeTileDebugBuffers(t1, e1) {
                const r = e1.projection;
                if (!r || "globe" !== r.name || e1.freezeTileCoverage) return;
                const n = this.tileID.canonical, i = df(nf(n, e1)), s = gf(e1.zoom);
                let a;
                s > 0 && (a = gl(new Float64Array(16), e1.globeMatrix));
                const o = (n.x + .5) / (1 << n.z) - zo(e1.center.lng);
                let l = 0;
                o > .5 ? l = -1 : o < -0.5 && (l = 1), this._makeGlobeTileDebugBorderBuffer(t1, n, e1, i, a, s, l), this._makeGlobeTileDebugTextBuffer(t1, n, e1, i, a, s, l);
            }
            _globePoint(t1, e1, r, n, i, s, a, o) {
                let l = hf(t1, e1, r);
                if (s) {
                    const i = 1 << r.z, u = [
                        ((t1 / wo + r.x) / i + o) * n,
                        (e1 / wo + r.y) / i * n,
                        0
                    ];
                    jl(u, u, s), l = vr(l, u, a);
                }
                return jl(l, l, i);
            }
            _makeGlobeTileDebugBorderBuffer(t1, e1, r, n, i, s, a) {
                const o = new Qs, l = new wa, u = new ta, c = (t1, c, h, p, f)=>{
                    const d = (h - t1) / (f - 1), y = (p - c) / (f - 1), m = o.length;
                    for(let h = 0; h < f; h++){
                        const p = t1 + h * d, f = c + h * y;
                        o.emplaceBack(p, f);
                        const g = this._globePoint(p, f, e1, r.worldSize, n, i, s, a);
                        u.emplaceBack(g[0], g[1], g[2]), l.emplaceBack(m + h);
                    }
                }, h = wo;
                c(0, 0, h, 0, 16), c(h, 0, h, h, 16), c(h, h, 0, h, 16), c(0, h, 0, 0, 16), this._tileDebugIndexBuffer = t1.createIndexBuffer(l), this._tileDebugBuffer = t1.createVertexBuffer(o, Zp.members), this._globeTileDebugBorderBuffer = t1.createVertexBuffer(u, Gp.members), this._tileDebugSegments = _o.simpleSegment(0, 0, o.length, l.length);
            }
            _makeGlobeTileDebugTextBuffer(t1, e1, r, n, i, s, a) {
                const o = new Qs, l = new ya, u = new ta, c = 25;
                l.reserve(32), o.reserve(c), u.reserve(c);
                const h = (t1, e1)=>c * t1 + e1;
                for(let t1 = 0; t1 < c; t1++){
                    const l = 2048 * t1;
                    for(let t1 = 0; t1 < c; t1++){
                        const c = 2048 * t1;
                        o.emplaceBack(c, l);
                        const h = this._globePoint(c, l, e1, r.worldSize, n, i, s, a);
                        u.emplaceBack(h[0], h[1], h[2]);
                    }
                }
                for(let t1 = 0; t1 < 4; t1++)for(let e1 = 0; e1 < 4; e1++){
                    const r = h(t1, e1), n = h(t1, e1 + 1), i = h(t1 + 1, e1), s = h(t1 + 1, e1 + 1);
                    l.emplaceBack(r, n, i), l.emplaceBack(i, n, s);
                }
                this._tileDebugTextIndexBuffer = t1.createIndexBuffer(l), this._tileDebugTextBuffer = t1.createVertexBuffer(o, Zp.members), this._globeTileDebugTextBuffer = t1.createVertexBuffer(u, Gp.members), this._tileDebugTextSegments = _o.simpleSegment(0, 0, c, 32);
            }
            constructor(t1, e1, r, n, i){
                this.tileID = t1, this.uid = _(), this.uses = 0, this.tileSize = e1, this.tileZoom = r, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = i, this.expiredRequestCount = 0, this.state = "loading", n && n.transform && (this.projection = n.transform.projection);
            }
        }
        class Md {
            updateState(t1, e1, r) {
                const n = String(e1);
                if (this.stateChanges[t1] = this.stateChanges[t1] || {}, this.stateChanges[t1][n] = this.stateChanges[t1][n] || {}, v(this.stateChanges[t1][n], r), null === this.deletedStates[t1]) {
                    this.deletedStates[t1] = {};
                    for(const e1 in this.state[t1])e1 !== n && (this.deletedStates[t1][e1] = null);
                } else if (this.deletedStates[t1] && null === this.deletedStates[t1][n]) {
                    this.deletedStates[t1][n] = {};
                    for(const e1 in this.state[t1][n])r[e1] || (this.deletedStates[t1][n][e1] = null);
                } else for(const e1 in r)this.deletedStates[t1] && this.deletedStates[t1][n] && null === this.deletedStates[t1][n][e1] && delete this.deletedStates[t1][n][e1];
            }
            removeFeatureState(t1, e1, r) {
                if (null === this.deletedStates[t1]) return;
                const n = String(e1);
                if (this.deletedStates[t1] = this.deletedStates[t1] || {}, r && void 0 !== e1) null !== this.deletedStates[t1][n] && (this.deletedStates[t1][n] = this.deletedStates[t1][n] || {}, this.deletedStates[t1][n][r] = null);
                else if (void 0 !== e1) {
                    if (this.stateChanges[t1] && this.stateChanges[t1][n]) for(r in this.deletedStates[t1][n] = {}, this.stateChanges[t1][n])this.deletedStates[t1][n][r] = null;
                    else this.deletedStates[t1][n] = null;
                } else this.deletedStates[t1] = null;
            }
            getState(t1, e1) {
                const r = String(e1), n = v({}, (this.state[t1] || {})[r], (this.stateChanges[t1] || {})[r]);
                if (null === this.deletedStates[t1]) return {};
                if (this.deletedStates[t1]) {
                    const r = this.deletedStates[t1][e1];
                    if (null === r) return {};
                    for(const t1 in r)delete n[t1];
                }
                return n;
            }
            initializeTileState(t1, e1) {
                t1.setFeatureState(this.state, e1);
            }
            coalesceChanges(t1, e1) {
                const r = {};
                for(const t1 in this.stateChanges){
                    this.state[t1] = this.state[t1] || {};
                    const e1 = {};
                    for(const r in this.stateChanges[t1])this.state[t1][r] || (this.state[t1][r] = {}), v(this.state[t1][r], this.stateChanges[t1][r]), e1[r] = this.state[t1][r];
                    r[t1] = e1;
                }
                for(const t1 in this.deletedStates){
                    this.state[t1] = this.state[t1] || {};
                    const e1 = {};
                    if (null === this.deletedStates[t1]) for(const r in this.state[t1])e1[r] = {}, this.state[t1][r] = {};
                    else for(const r in this.deletedStates[t1]){
                        if (null === this.deletedStates[t1][r]) this.state[t1][r] = {};
                        else for (const e1 of Object.keys(this.deletedStates[t1][r]))delete this.state[t1][r][e1];
                        e1[r] = this.state[t1][r];
                    }
                    r[t1] = r[t1] || {}, v(r[t1], e1);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(r).length) for(const n in t1)t1[n].setFeatureState(r, e1);
            }
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
        }
        class zd {
            getElevation(t1, e1) {
                const r = this.toIdx(t1, e1);
                return {
                    min: this.minimums[r],
                    max: this.maximums[r]
                };
            }
            isLeaf(t1, e1) {
                return this.leaves[this.toIdx(t1, e1)];
            }
            toIdx(t1, e1) {
                return e1 * this.size + t1;
            }
            constructor(t1){
                this.size = t1, this.minimums = [], this.maximums = [], this.leaves = [];
            }
        }
        function Td(t1, e1, r, n) {
            let i = 0, s = Number.MAX_VALUE;
            for(let a = 0; a < 3; a++)if (Math.abs(n[a]) < 1e-15) {
                if (r[a] < t1[a] || r[a] > e1[a]) return null;
            } else {
                const o = 1 / n[a];
                let l = (t1[a] - r[a]) * o, u = (e1[a] - r[a]) * o;
                if (l > u) {
                    const t1 = l;
                    l = u, u = t1;
                }
                if (l > i && (i = l), u < s && (s = u), i > s) return null;
            }
            return i;
        }
        function Bd(t1, e1, r, n, i, s, a, o, l, u, c) {
            const h = n - t1, p = i - e1, f = s - r, d = a - t1, y = o - e1, m = l - r, g = c[1] * m - c[2] * y, x = c[2] * d - c[0] * m, v = c[0] * y - c[1] * d, b = h * g + p * x + f * v;
            if (Math.abs(b) < 1e-15) return null;
            const _ = 1 / b, w = u[0] - t1, A = u[1] - e1, S = u[2] - r, k = (w * g + A * x + S * v) * _;
            if (k < 0 || k > 1) return null;
            const I = A * f - S * p, M = S * h - w * f, z = w * p - A * h, T = (c[0] * I + c[1] * M + c[2] * z) * _;
            return T < 0 || k + T > 1 ? null : (d * I + y * M + m * z) * _;
        }
        function Ed(t1, e1, r) {
            return (t1 - e1) / (r - e1);
        }
        function Cd(t1, e1, r, n, i, s, a, o, l) {
            const u = 1 << r, c = s - n, h = a - i, p = (t1 + 1) / u * c + n, f = (e1 + 0) / u * h + i, d = (e1 + 1) / u * h + i;
            o[0] = (t1 + 0) / u * c + n, o[1] = f, l[0] = p, l[1] = d;
        }
        class Pd {
            raycastRoot(t1, e1, r, n, i, s, a = 1) {
                return Td([
                    t1,
                    e1,
                    -100
                ], [
                    r,
                    n,
                    this.maximums[0] * a
                ], i, s);
            }
            raycast(t1, e1, r, n, i, s, a = 1) {
                if (!this.nodeCount) return null;
                const o = this.raycastRoot(t1, e1, r, n, i, s, a);
                if (null == o) return null;
                const l = [], u = [], c = [], h = [], p = [
                    {
                        idx: 0,
                        t: o,
                        nodex: 0,
                        nodey: 0,
                        depth: 0
                    }
                ];
                for(; p.length > 0;){
                    const { idx: o, t: f, nodex: d, nodey: y, depth: m } = p.pop();
                    if (this.leaves[o]) {
                        Cd(d, y, m, t1, e1, r, n, c, h);
                        const o = 1 << m, l = (d + 0) / o, u = (d + 1) / o, p = (y + 0) / o, g = (y + 1) / o, x = Vd(l, p, this.dem) * a, v = Vd(u, p, this.dem) * a, b = Vd(u, g, this.dem) * a, _ = Vd(l, g, this.dem) * a, w = Bd(c[0], c[1], x, h[0], c[1], v, h[0], h[1], b, i, s), A = Bd(h[0], h[1], b, c[0], h[1], _, c[0], c[1], x, i, s), S = Math.min(null !== w ? w : Number.MAX_VALUE, null !== A ? A : Number.MAX_VALUE);
                        if (S !== Number.MAX_VALUE) return S;
                        {
                            const t1 = Fl([], i, s, f);
                            if (Dd(x, v, _, b, Ed(t1[0], c[0], h[0]), Ed(t1[1], c[1], h[1])) >= t1[2]) return f;
                        }
                        continue;
                    }
                    let g = 0;
                    for(let p = 0; p < this._siblingOffset.length; p++){
                        Cd((d << 1) + this._siblingOffset[p][0], (y << 1) + this._siblingOffset[p][1], m + 1, t1, e1, r, n, c, h), c[2] = -100, h[2] = this.maximums[this.childOffsets[o] + p] * a;
                        const f = Td(c, h, i, s);
                        if (null != f) {
                            const t1 = f;
                            l[p] = t1;
                            let e1 = !1;
                            for(let r = 0; r < g && !e1; r++)t1 >= l[u[r]] && (u.splice(r, 0, p), e1 = !0);
                            e1 || (u[g] = p), g++;
                        }
                    }
                    for(let t1 = 0; t1 < g; t1++){
                        const e1 = u[t1];
                        p.push({
                            idx: this.childOffsets[o] + e1,
                            t: l[e1],
                            nodex: (d << 1) + this._siblingOffset[e1][0],
                            nodey: (y << 1) + this._siblingOffset[e1][1],
                            depth: m + 1
                        });
                    }
                }
                return null;
            }
            _addNode(t1, e1, r) {
                return this.minimums.push(t1), this.maximums.push(e1), this.leaves.push(r), this.childOffsets.push(0), this.nodeCount++;
            }
            _construct(t1, e1, r, n, i) {
                if (1 === t1[n].isLeaf(e1, r)) return;
                this.childOffsets[i] || (this.childOffsets[i] = this.nodeCount);
                const s = n - 1, a = t1[s];
                let o = 0, l = 0;
                for(let t1 = 0; t1 < this._siblingOffset.length; t1++){
                    const n = 2 * e1 + this._siblingOffset[t1][0], i = 2 * r + this._siblingOffset[t1][1], s = a.getElevation(n, i), u = a.isLeaf(n, i), c = this._addNode(s.min, s.max, u);
                    u && (o |= 1 << t1), l || (l = c);
                }
                for(let n = 0; n < this._siblingOffset.length; n++)o & 1 << n || this._construct(t1, 2 * e1 + this._siblingOffset[n][0], 2 * r + this._siblingOffset[n][1], s, l + n);
            }
            constructor(t1){
                if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = t1, this._siblingOffset = [
                    [
                        0,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        1
                    ]
                ], !this.dem) return;
                const e1 = function(t1) {
                    const e1 = Math.ceil(Math.log2(t1.dim / 8)), r = [];
                    let n = Math.ceil(Math.pow(2, e1));
                    const i = 1 / n, s = (t1, e1, r, n, i)=>{
                        const s = n ? 1 : 0, a = (t1 + 1) * r - s, o = e1 * r, l = (e1 + 1) * r - s;
                        i[0] = t1 * r, i[1] = o, i[2] = a, i[3] = l;
                    };
                    let a = new zd(n);
                    const o = [];
                    for(let e1 = 0; e1 < n * n; e1++){
                        s(e1 % n, Math.floor(e1 / n), i, !1, o);
                        const r = Vd(o[0], o[1], t1), l = Vd(o[2], o[1], t1), u = Vd(o[2], o[3], t1), c = Vd(o[0], o[3], t1);
                        a.minimums.push(Math.min(r, l, u, c)), a.maximums.push(Math.max(r, l, u, c)), a.leaves.push(1);
                    }
                    for(r.push(a), n /= 2; n >= 1; n /= 2){
                        const t1 = r[r.length - 1];
                        a = new zd(n);
                        for(let e1 = 0; e1 < n * n; e1++){
                            s(e1 % n, Math.floor(e1 / n), 2, !0, o);
                            const r = t1.getElevation(o[0], o[1]), i = t1.getElevation(o[2], o[1]), l = t1.getElevation(o[2], o[3]), u = t1.getElevation(o[0], o[3]), c = t1.isLeaf(o[0], o[1]), h = t1.isLeaf(o[2], o[1]), p = t1.isLeaf(o[2], o[3]), f = t1.isLeaf(o[0], o[3]), d = Math.min(r.min, i.min, l.min, u.min), y = Math.max(r.max, i.max, l.max, u.max), m = c && h && p && f;
                            a.maximums.push(y), a.minimums.push(d), a.leaves.push(y - d <= 5 && m ? 1 : 0);
                        }
                        r.push(a);
                    }
                    return r;
                }(this.dem), r = e1.length - 1, n = e1[r];
                this._addNode(n.minimums[0], n.maximums[0], n.leaves[0]), this._construct(e1, 0, 0, r, 0);
            }
        }
        function Dd(t1, e1, r, n, i, s) {
            return xr(xr(t1, r, s), xr(e1, n, s), i);
        }
        function Vd(t1, e1, r) {
            const n = r.dim, i = d(t1 * n - .5, 0, n - 1), s = d(e1 * n - .5, 0, n - 1), a = Math.floor(i), o = Math.floor(s), l = Math.min(a + 1, n - 1), u = Math.min(o + 1, n - 1);
            return Dd(r.get(a, o), r.get(l, o), r.get(a, u), r.get(l, u), i - a, s - o);
        }
        const Fd = {
            mapbox: [
                6553.6,
                25.6,
                .1,
                1e4
            ],
            terrarium: [
                256,
                1,
                1 / 256,
                32768
            ]
        };
        class Ld {
            get tree() {
                return this._tree || this._buildQuadTree(), this._tree;
            }
            _buildQuadTree() {
                this._tree = new Pd(this);
            }
            get(t1, e1, r = !1) {
                r && (t1 = d(t1, -1, this.dim), e1 = d(e1, -1, this.dim));
                const n = 4 * this._idx(t1, e1);
                return ("terrarium" === this.encoding ? this._unpackTerrarium : this._unpackMapbox)(this.pixels[n], this.pixels[n + 1], this.pixels[n + 2]);
            }
            static getUnpackVector(t1) {
                return Fd[t1];
            }
            get unpackVector() {
                return Fd[this.encoding];
            }
            _idx(t1, e1) {
                if (t1 < -1 || t1 >= this.dim + 1 || e1 < -1 || e1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (e1 + 1) * this.stride + (t1 + 1);
            }
            _unpackMapbox(t1, e1, r) {
                return (256 * t1 * 256 + 256 * e1 + r) / 10 - 1e4;
            }
            _unpackTerrarium(t1, e1, r) {
                return 256 * t1 + e1 + r / 256 - 32768;
            }
            static pack(t1, e1) {
                const r = [
                    0,
                    0,
                    0,
                    0
                ], n = Ld.getUnpackVector(e1);
                let i = Math.floor((t1 + n[3]) / n[2]);
                return r[2] = i % 256, i = Math.floor(i / 256), r[1] = i % 256, i = Math.floor(i / 256), r[0] = i, r;
            }
            getPixels() {
                return new pu({
                    width: this.stride,
                    height: this.stride
                }, this.pixels);
            }
            backfillBorder(t1, e1, r) {
                if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
                let n = e1 * this.dim, i = e1 * this.dim + this.dim, s = r * this.dim, a = r * this.dim + this.dim;
                switch(e1){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        s = a - 1;
                        break;
                    case 1:
                        a = s + 1;
                }
                const o = -e1 * this.dim, l = -r * this.dim;
                for(let e1 = s; e1 < a; e1++)for(let r = n; r < i; r++){
                    const n = 4 * this._idx(r, e1), i = 4 * this._idx(r + o, e1 + l);
                    this.pixels[n + 0] = t1.pixels[i + 0], this.pixels[n + 1] = t1.pixels[i + 1], this.pixels[n + 2] = t1.pixels[i + 2], this.pixels[n + 3] = t1.pixels[i + 3];
                }
            }
            onDeserialize() {
                this._tree && (this._tree.dem = this);
            }
            constructor(t1, e1, r, n = !1, i = !1){
                if (this.uid = t1, e1.height !== e1.width) throw new RangeError("DEM tiles must be square");
                if (r && "mapbox" !== r && "terrarium" !== r) return E(`"${r}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = e1.height;
                const s = this.dim = e1.height - 2, a = new Uint32Array(e1.data.buffer);
                if (this.pixels = new Uint8Array(e1.data.buffer), this.encoding = r || "mapbox", this.borderReady = n, !n) {
                    for(let t1 = 0; t1 < s; t1++)a[this._idx(-1, t1)] = a[this._idx(0, t1)], a[this._idx(s, t1)] = a[this._idx(s - 1, t1)], a[this._idx(t1, -1)] = a[this._idx(t1, 0)], a[this._idx(t1, s)] = a[this._idx(t1, s - 1)];
                    a[this._idx(-1, -1)] = a[this._idx(0, 0)], a[this._idx(s, -1)] = a[this._idx(s - 1, 0)], a[this._idx(-1, s)] = a[this._idx(0, s - 1)], a[this._idx(s, s)] = a[this._idx(s - 1, s - 1)], i && this._buildQuadTree();
                }
            }
        }
        Pi(Ld, "DEMData"), Pi(Pd, "DemMinMaxQuadTree", {
            omit: [
                "dem"
            ]
        });
        class Rd {
            reset() {
                for(const t1 in this.data)for (const e1 of this.data[t1])e1.timeout && clearTimeout(e1.timeout), this.onRemove(e1.value);
                return this.data = {}, this.order = [], this;
            }
            add(t1, e1, r) {
                const n = t1.wrapped().key;
                void 0 === this.data[n] && (this.data[n] = []);
                const i = {
                    value: e1,
                    timeout: void 0
                };
                if (void 0 !== r && (i.timeout = setTimeout(()=>{
                    this.remove(t1, i);
                }, r)), this.data[n].push(i), this.order.push(n), this.order.length > this.max) {
                    const t1 = this._getAndRemoveByKey(this.order[0]);
                    t1 && this.onRemove(t1);
                }
                return this;
            }
            has(t1) {
                return t1.wrapped().key in this.data;
            }
            getAndRemove(t1) {
                return this.has(t1) ? this._getAndRemoveByKey(t1.wrapped().key) : null;
            }
            _getAndRemoveByKey(t1) {
                const e1 = this.data[t1].shift();
                return e1.timeout && clearTimeout(e1.timeout), 0 === this.data[t1].length && delete this.data[t1], this.order.splice(this.order.indexOf(t1), 1), e1.value;
            }
            getByKey(t1) {
                const e1 = this.data[t1];
                return e1 ? e1[0].value : null;
            }
            get(t1) {
                return this.has(t1) ? this.data[t1.wrapped().key][0].value : null;
            }
            remove(t1, e1) {
                if (!this.has(t1)) return this;
                const r = t1.wrapped().key, n = void 0 === e1 ? 0 : this.data[r].indexOf(e1), i = this.data[r][n];
                return this.data[r].splice(n, 1), i.timeout && clearTimeout(i.timeout), 0 === this.data[r].length && delete this.data[r], this.onRemove(i.value), this.order.splice(this.order.indexOf(r), 1), this;
            }
            setMaxSize(t1) {
                for(this.max = t1; this.order.length > this.max;){
                    const t1 = this._getAndRemoveByKey(this.order[0]);
                    t1 && this.onRemove(t1);
                }
                return this;
            }
            filter(t1) {
                const e1 = [];
                for(const r in this.data)for (const n of this.data[r])t1(n.value) || e1.push(n);
                for (const t1 of e1)this.remove(t1.value.tileID, t1);
            }
            constructor(t1, e1){
                this.max = t1, this.onRemove = e1, this.reset();
            }
        }
        class Ud {
            constructor(t1, e1, r){
                this.func = t1, this.mask = e1, this.range = r;
            }
        }
        Ud.ReadOnly = !1, Ud.ReadWrite = !0, Ud.disabled = new Ud(519, Ud.ReadOnly, [
            0,
            1
        ]);
        const jd = 7680;
        class $d {
            constructor(t1, e1, r, n, i, s){
                this.test = t1, this.ref = e1, this.mask = r, this.fail = n, this.depthFail = i, this.pass = s;
            }
        }
        $d.disabled = new $d({
            func: 519,
            mask: 0
        }, 0, 0, jd, jd, jd);
        class Od {
            constructor(t1, e1, r){
                this.blendFunction = t1, this.blendColor = e1, this.mask = r;
            }
        }
        Od.Replace = [
            1,
            0
        ], Od.disabled = new Od(Od.Replace, xe.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Od.unblended = new Od(Od.Replace, xe.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Od.alphaBlended = new Od([
            1,
            771
        ], xe.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        const qd = 1029, Nd = 2305;
        class Gd {
            constructor(t1, e1, r){
                this.enable = t1, this.mode = e1, this.frontFace = r;
            }
        }
        Gd.disabled = new Gd(!1, qd, Nd), Gd.backCCW = new Gd(!0, qd, Nd), Gd.backCW = new Gd(!0, qd, 2304), Gd.frontCW = new Gd(!0, 1028, 2304), Gd.frontCCW = new Gd(!0, 1028, Nd);
        class Zd extends Nt {
            onAdd(t1) {
                this.map = t1, this._minTileCacheSize = void 0 === this._minTileCacheSize && t1 ? t1._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && t1 ? t1._maxTileCacheSize : this._maxTileCacheSize;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(const t1 in this._tiles){
                    const e1 = this._tiles[t1];
                    if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const t1 = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, t1 && this.reload(), this.transform && this.update(this.transform);
            }
            _loadTile(t1, e1) {
                return t1.isSymbolTile = this._onlySymbols, this._source.loadTile(t1, e1);
            }
            _unloadTile(t1) {
                if (this._source.unloadTile) return this._source.unloadTile(t1, ()=>{});
            }
            _abortTile(t1) {
                if (this._source.abortTile) return this._source.abortTile(t1, ()=>{});
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(t1) {
                if (this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null), this._source.prepareTile) for(const e1 in this._tiles){
                    const r = this._tiles[e1];
                    this._source.prepareTile(r) && this.map.painter.terrain && this.map.painter.terrain._clearRenderCacheForTile(this.id, r.tileID), r.upload(t1), r.prepare(this.map.style.imageManager);
                }
                else for(const e1 in this._tiles){
                    const r = this._tiles[e1];
                    r.upload(t1), r.prepare(this.map.style.imageManager);
                }
            }
            getIds() {
                return x(this._tiles).map((t1)=>t1.tileID).sort(Xd).map((t1)=>t1.key);
            }
            getRenderableIds(t1) {
                const e1 = [];
                for(const r in this._tiles)this._isIdRenderable(+r, t1) && e1.push(this._tiles[r]);
                return t1 ? e1.sort((t1, e1)=>{
                    const r = t1.tileID, n = e1.tileID, s = new i(r.canonical.x, r.canonical.y)._rotate(this.transform.angle), a = new i(n.canonical.x, n.canonical.y)._rotate(this.transform.angle);
                    return r.overscaledZ - n.overscaledZ || a.y - s.y || a.x - s.x;
                }).map((t1)=>t1.tileID.key) : e1.map((t1)=>t1.tileID).sort(Xd).map((t1)=>t1.key);
            }
            hasRenderableParent(t1) {
                const e1 = this.findLoadedParent(t1, 0);
                return !!e1 && this._isIdRenderable(e1.tileID.key);
            }
            _isIdRenderable(t1, e1) {
                return this._tiles[t1] && this._tiles[t1].hasData() && !this._coveredTiles[t1] && (e1 || !this._tiles[t1].holdingForFade());
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const t1 in this._tiles)"errored" !== this._tiles[t1].state && this._reloadTile(+t1, "reloading");
                }
            }
            _reloadTile(t1, e1) {
                const r = this._tiles[t1];
                r && ("loading" !== r.state && (r.state = e1), this._loadTile(r, this._tileLoaded.bind(this, r, t1, e1)));
            }
            _tileLoaded(t1, e1, r, n) {
                if (n) {
                    if (t1.state = "errored", 404 !== n.status) this._source.fire(new qt(n, {
                        tile: t1
                    }));
                    else if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                        const t1 = this.map.painter.terrain;
                        this.update(this.transform, t1.getScaledDemTileSize(), !0), t1.resetTileLookupCache(this.id);
                    } else this.update(this.transform);
                } else t1.timeAdded = X.now(), "expired" === r && (t1.refreshedUponExpiration = !0), this._setTileReloadTimer(e1, t1), "raster-dem" === this._source.type && t1.dem && this._backfillDEM(t1), this._state.initializeTileState(t1, this.map ? this.map.painter : null), this._source.fire(new Ot("data", {
                    dataType: "source",
                    tile: t1,
                    coord: t1.tileID,
                    sourceCacheId: this.id
                }));
            }
            _backfillDEM(t1) {
                const e1 = this.getRenderableIds();
                for(let n = 0; n < e1.length; n++){
                    const i = e1[n];
                    if (t1.neighboringTiles && t1.neighboringTiles[i]) {
                        const e1 = this.getTileByID(i);
                        r(t1, e1), r(e1, t1);
                    }
                }
                function r(t1, e1) {
                    if (!t1.dem || t1.dem.borderReady) return;
                    t1.needsHillshadePrepare = !0, t1.needsDEMTextureUpload = !0;
                    let r = e1.tileID.canonical.x - t1.tileID.canonical.x;
                    const n = e1.tileID.canonical.y - t1.tileID.canonical.y, i = Math.pow(2, t1.tileID.canonical.z), s = e1.tileID.key;
                    0 === r && 0 === n || Math.abs(n) > 1 || (Math.abs(r) > 1 && (1 === Math.abs(r + i) ? r += i : 1 === Math.abs(r - i) && (r -= i)), e1.dem && t1.dem && (t1.dem.backfillBorder(e1.dem, r, n), t1.neighboringTiles && t1.neighboringTiles[s] && (t1.neighboringTiles[s].backfilled = !0)));
                }
            }
            getTile(t1) {
                return this.getTileByID(t1.key);
            }
            getTileByID(t1) {
                return this._tiles[t1];
            }
            _retainLoadedChildren(t1, e1, r, n) {
                for(const i in this._tiles){
                    let s = this._tiles[i];
                    if (n[i] || !s.hasData() || s.tileID.overscaledZ <= e1 || s.tileID.overscaledZ > r) continue;
                    let a = s.tileID;
                    for(; s && s.tileID.overscaledZ > e1 + 1;){
                        const t1 = s.tileID.scaledTo(s.tileID.overscaledZ - 1);
                        s = this._tiles[t1.key], s && s.hasData() && (a = t1);
                    }
                    let o = a;
                    for(; o.overscaledZ > e1;)if (o = o.scaledTo(o.overscaledZ - 1), t1[o.key]) {
                        n[a.key] = a;
                        break;
                    }
                }
            }
            findLoadedParent(t1, e1) {
                if (t1.key in this._loadedParentTiles) {
                    const r = this._loadedParentTiles[t1.key];
                    return r && r.tileID.overscaledZ >= e1 ? r : null;
                }
                for(let r = t1.overscaledZ - 1; r >= e1; r--){
                    const e1 = t1.scaledTo(r), n = this._getLoadedTile(e1);
                    if (n) return n;
                }
            }
            _getLoadedTile(t1) {
                const e1 = this._tiles[t1.key];
                return e1 && e1.hasData() ? e1 : this._cache.getByKey(this._source.reparseOverscaled ? t1.wrapped().key : t1.canonical.key);
            }
            updateCacheSize(t1, e1) {
                e1 = e1 || this._source.tileSize;
                const r = Math.ceil(t1.width / e1) + 1, n = Math.ceil(t1.height / e1) + 1, i = Math.floor(r * n * 5), s = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, i) : i, a = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, s) : s;
                this._cache.setMaxSize(a);
            }
            handleWrapJump(t1) {
                const e1 = Math.round((t1 - (void 0 === this._prevLng ? t1 : this._prevLng)) / 360);
                if (this._prevLng = t1, e1) {
                    const t1 = {};
                    for(const r in this._tiles){
                        const n = this._tiles[r];
                        n.tileID = n.tileID.unwrapTo(n.tileID.wrap + e1), t1[n.tileID.key] = n;
                    }
                    this._tiles = t1;
                    for(const t1 in this._timers)clearTimeout(this._timers[t1]), delete this._timers[t1];
                    for(const t1 in this._tiles)this._setTileReloadTimer(+t1, this._tiles[t1]);
                }
            }
            update(t1, e1, r) {
                if (this.transform = t1, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
                if (this.usedForTerrain && !r) return;
                let n;
                this.updateCacheSize(t1, e1), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? n = t1.getVisibleUnwrappedCoordinates(this._source.tileID).map((t1)=>new Fc(t1.canonical.z, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y)) : (n = t1.coveringTiles({
                    tileSize: e1 || this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom && !r,
                    reparseOverscaled: this._source.reparseOverscaled,
                    isTerrainDEM: this.usedForTerrain
                }), this._source.hasTile && (n = n.filter((t1)=>this._source.hasTile(t1)))) : n = [];
                const i = this._updateRetainedTiles(n);
                if (Kd(this._source.type) && 0 !== n.length) {
                    const t1 = {}, e1 = {}, r = Object.keys(i);
                    for (const n of r){
                        const r = i[n], s = this._tiles[n];
                        if (!s || s.fadeEndTime && s.fadeEndTime <= X.now()) continue;
                        const a = this.findLoadedParent(r, Math.max(r.overscaledZ - Zd.maxOverzooming, this._source.minzoom));
                        a && (this._addTile(a.tileID), t1[a.tileID.key] = a.tileID), e1[n] = r;
                    }
                    const s = n[n.length - 1].overscaledZ;
                    for(const t1 in this._tiles){
                        const r = this._tiles[t1];
                        if (i[t1] || !r.hasData()) continue;
                        let n = r.tileID;
                        for(; n.overscaledZ > s;){
                            n = n.scaledTo(n.overscaledZ - 1);
                            const s = this._tiles[n.key];
                            if (s && s.hasData() && e1[n.key]) {
                                i[t1] = r.tileID;
                                break;
                            }
                        }
                    }
                    for(const e1 in t1)i[e1] || (this._coveredTiles[e1] = !0, i[e1] = t1[e1]);
                }
                for(const t1 in i)this._tiles[t1].clearFadeHold();
                const s = function(t1, e1) {
                    const r = [];
                    for(const n in t1)n in e1 || r.push(n);
                    return r;
                }(this._tiles, i);
                for (const t1 of s){
                    const e1 = this._tiles[t1];
                    e1.hasSymbolBuckets && !e1.holdingForFade() ? e1.setHoldDuration(this.map._fadeDuration) : e1.hasSymbolBuckets && !e1.symbolFadeFinished() || this._removeTile(+t1);
                }
                this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
                for(const t1 in this._tiles)this._tiles[t1].holdingForFade() && this._removeTile(+t1);
            }
            _updateRetainedTiles(t1) {
                const e1 = {};
                if (0 === t1.length) return e1;
                const r = {}, n = t1.reduce((t1, e1)=>Math.min(t1, e1.overscaledZ), 1 / 0), i = t1[0].overscaledZ, s = Math.max(i - Zd.maxOverzooming, this._source.minzoom), a = Math.max(i + Zd.maxUnderzooming, this._source.minzoom), o = {};
                for (const r of t1){
                    const t1 = this._addTile(r);
                    e1[r.key] = r, t1.hasData() || n < this._source.maxzoom && (o[r.key] = r);
                }
                this._retainLoadedChildren(o, n, a, e1);
                for (const n of t1){
                    let t1 = this._tiles[n.key];
                    if (t1.hasData()) continue;
                    if (n.canonical.z >= this._source.maxzoom) {
                        const t1 = n.children(this._source.maxzoom)[0], r = this.getTile(t1);
                        if (r && r.hasData()) {
                            e1[t1.key] = t1;
                            continue;
                        }
                    } else {
                        const t1 = n.children(this._source.maxzoom);
                        if (e1[t1[0].key] && e1[t1[1].key] && e1[t1[2].key] && e1[t1[3].key]) continue;
                    }
                    let i = t1.wasRequested();
                    for(let a = n.overscaledZ - 1; a >= s; --a){
                        const s = n.scaledTo(a);
                        if (r[s.key]) break;
                        if (r[s.key] = !0, t1 = this.getTile(s), !t1 && i && (t1 = this._addTile(s)), t1 && (e1[s.key] = s, i = t1.wasRequested(), t1.hasData())) break;
                    }
                }
                return e1;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const t1 in this._tiles){
                    const e1 = [];
                    let r, n = this._tiles[t1].tileID;
                    for(; n.overscaledZ > 0;){
                        if (n.key in this._loadedParentTiles) {
                            r = this._loadedParentTiles[n.key];
                            break;
                        }
                        e1.push(n.key);
                        const t1 = n.scaledTo(n.overscaledZ - 1);
                        if (r = this._getLoadedTile(t1), r) break;
                        n = t1;
                    }
                    for (const t1 of e1)this._loadedParentTiles[t1] = r;
                }
            }
            _addTile(t1) {
                let e1 = this._tiles[t1.key];
                if (e1) return this._source.prepareTile && this._source.prepareTile(e1), e1;
                e1 = this._cache.getAndRemove(t1), e1 && (this._setTileReloadTimer(t1.key, e1), e1.tileID = t1, this._state.initializeTileState(e1, this.map ? this.map.painter : null), this._cacheTimers[t1.key] && (clearTimeout(this._cacheTimers[t1.key]), delete this._cacheTimers[t1.key], this._setTileReloadTimer(t1.key, e1)));
                const r = Boolean(e1);
                if (!r) {
                    const r = this.map ? this.map.painter : null;
                    e1 = new Id(t1, this._source.tileSize * t1.overscaleFactor(), this.transform.tileZoom, r, this._isRaster), this._source.prepareTile && this._source.prepareTile(e1) || this._loadTile(e1, this._tileLoaded.bind(this, e1, t1.key, e1.state));
                }
                return e1 ? (e1.uses++, this._tiles[t1.key] = e1, r || this._source.fire(new Ot("dataloading", {
                    tile: e1,
                    coord: e1.tileID,
                    dataType: "source"
                })), e1) : null;
            }
            _setTileReloadTimer(t1, e1) {
                t1 in this._timers && (clearTimeout(this._timers[t1]), delete this._timers[t1]);
                const r = e1.getExpiryTimeout();
                r && (this._timers[t1] = setTimeout(()=>{
                    this._reloadTile(t1, "expired"), delete this._timers[t1];
                }, r));
            }
            _removeTile(t1) {
                const e1 = this._tiles[t1];
                e1 && (e1.uses--, delete this._tiles[t1], this._timers[t1] && (clearTimeout(this._timers[t1]), delete this._timers[t1]), e1.uses > 0 || (e1.hasData() && "reloading" !== e1.state ? this._cache.add(e1.tileID, e1, e1.getExpiryTimeout()) : (e1.aborted = !0, this._abortTile(e1), this._unloadTile(e1))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const t1 in this._tiles)this._removeTile(+t1);
                this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(t1, e1, r) {
                const n = [], i = this.transform;
                if (!i) return n;
                const s = "globe" === i.projection.name, a = zo(i.center.lng);
                for(const o in this._tiles){
                    const l = this._tiles[o];
                    if (r && l.clearQueryDebugViz(), l.holdingForFade()) continue;
                    let u;
                    if (s) {
                        const t1 = l.tileID.canonical;
                        if (0 === t1.z) {
                            const e1 = [
                                Math.abs(d(a, ...Hd(t1, -1)) - a),
                                Math.abs(d(a, ...Hd(t1, 1)) - a)
                            ];
                            u = [
                                0,
                                2 * e1.indexOf(Math.min(...e1)) - 1
                            ];
                        } else {
                            const e1 = [
                                Math.abs(d(a, ...Hd(t1, -1)) - a),
                                Math.abs(d(a, ...Hd(t1, 0)) - a),
                                Math.abs(d(a, ...Hd(t1, 1)) - a)
                            ];
                            u = [
                                e1.indexOf(Math.min(...e1)) - 1
                            ];
                        }
                    } else u = [
                        0
                    ];
                    for (const r of u){
                        const s = t1.containsTile(l, i, e1, r);
                        s && n.push(s);
                    }
                }
                return n;
            }
            getVisibleCoordinates(t1) {
                const e1 = this.getRenderableIds(t1).map((t1)=>this._tiles[t1].tileID);
                for (const t1 of e1)t1.projMatrix = this.transform.calculateProjMatrix(t1.toUnwrapped());
                return e1;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (Kd(this._source.type)) for(const t1 in this._tiles){
                    const e1 = this._tiles[t1];
                    if (void 0 !== e1.fadeEndTime && e1.fadeEndTime >= X.now()) return !0;
                }
                return !1;
            }
            setFeatureState(t1, e1, r) {
                this._state.updateState(t1 = t1 || "_geojsonTileLayer", e1, r);
            }
            removeFeatureState(t1, e1, r) {
                this._state.removeFeatureState(t1 = t1 || "_geojsonTileLayer", e1, r);
            }
            getFeatureState(t1, e1) {
                return this._state.getState(t1 = t1 || "_geojsonTileLayer", e1);
            }
            setDependencies(t1, e1, r) {
                const n = this._tiles[t1];
                n && n.setDependencies(e1, r);
            }
            reloadTilesForDependencies(t1, e1) {
                for(const r in this._tiles)this._tiles[r].hasDependency(t1, e1) && this._reloadTile(+r, "reloading");
                this._cache.filter((r)=>!r.hasDependency(t1, e1));
            }
            _preloadTiles(t1, e1) {
                const r = new Map, n = Array.isArray(t1) ? t1 : [
                    t1
                ], i = this.map.painter.terrain, s = this.usedForTerrain && i ? i.getScaledDemTileSize() : this._source.tileSize;
                for (const t1 of n){
                    const e1 = t1.coveringTiles({
                        tileSize: s,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !this.usedForTerrain,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain
                    });
                    for (const t1 of e1)r.set(t1.key, t1);
                    this.usedForTerrain && t1.updateElevation(!1);
                }
                g(Array.from(r.values()), (t1, e1)=>{
                    const r = new Id(t1, this._source.tileSize * t1.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster);
                    this._loadTile(r, (t1)=>{
                        "raster-dem" === this._source.type && r.dem && this._backfillDEM(r), e1(t1, r);
                    });
                }, e1);
            }
            constructor(t1, e1, r){
                super(), this.id = t1, this._onlySymbols = r, e1.on("data", (t1)=>{
                    "source" === t1.dataType && "metadata" === t1.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === t1.dataType && "content" === t1.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
                }), e1.on("error", ()=>{
                    this._sourceErrored = !0;
                }), this._source = e1, this._tiles = {}, this._cache = new Rd(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = e1.minTileCacheSize, this._maxTileCacheSize = e1.maxTileCacheSize, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new Md, this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "custom" === this._source.type && "raster" === this._source._dataType;
            }
        }
        function Xd(t1, e1) {
            const r = Math.abs(2 * t1.wrap) - +(t1.wrap < 0), n = Math.abs(2 * e1.wrap) - +(e1.wrap < 0);
            return t1.overscaledZ - e1.overscaledZ || n - r || e1.canonical.y - t1.canonical.y || e1.canonical.x - t1.canonical.x;
        }
        function Kd(t1) {
            return "raster" === t1 || "image" === t1 || "video" === t1;
        }
        function Hd(t1, e1) {
            const r = 1 << t1.z;
            return [
                t1.x / r + e1,
                (t1.x + 1) / r + e1
            ];
        }
        Zd.maxOverzooming = 10, Zd.maxUnderzooming = 3;
        class Yd {
            static create(t1, e1, r) {
                const n = r || t1.findDEMTileFor(e1);
                if (!n || !n.dem) return;
                const i = n.dem, s = n.tileID, a = 1 << e1.canonical.z - s.canonical.z;
                return new Yd(n, n.tileSize / wo / a, [
                    (e1.canonical.x / a - s.canonical.x) * i.dim,
                    (e1.canonical.y / a - s.canonical.y) * i.dim
                ]);
            }
            tileCoordToPixel(t1, e1) {
                const r = e1 * this._scale + this._offset[1], n = Math.floor(t1 * this._scale + this._offset[0]), s = Math.floor(r);
                return new i(n, s);
            }
            getElevationAt(t1, e1, r, n) {
                const i = t1 * this._scale + this._offset[0], s = e1 * this._scale + this._offset[1], a = Math.floor(i), o = Math.floor(s), l = this._dem;
                return n = !!n, r ? xr(xr(l.get(a, o, n), l.get(a, o + 1, n), s - o), xr(l.get(a + 1, o, n), l.get(a + 1, o + 1, n), s - o), i - a) : l.get(a, o, n);
            }
            getElevationAtPixel(t1, e1, r) {
                return this._dem.get(t1, e1, !!r);
            }
            getMeterToDEM(t1) {
                return (1 << this._demTile.tileID.canonical.z) * Bo(1, t1) * this._dem.stride;
            }
            constructor(t1, e1, r){
                this._demTile = t1, this._dem = this._demTile.dem, this._scale = e1, this._offset = r;
            }
        }
        class Wd {
            insert(t1, e1, r, n, i, s = 0) {
                const a = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i, s);
                const o = this.grid;
                for(let t1 = 0; t1 < e1.length; t1++){
                    const r = e1[t1], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let t1 = 0; t1 < r.length; t1++){
                        const e1 = r[t1];
                        n[0] = Math.min(n[0], e1.x), n[1] = Math.min(n[1], e1.y), n[2] = Math.max(n[2], e1.x), n[3] = Math.max(n[3], e1.y);
                    }
                    n[0] < wo && n[1] < wo && n[2] >= 0 && n[3] >= 0 && o.insert(a, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                if (!this.vtLayers) {
                    this.vtLayers = new yc.VectorTile(new xh(this.rawTileData)).layers, this.sourceLayerCoder = new dd(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                        "_geojsonTileLayer"
                    ]), this.vtFeatures = {};
                    for(const t1 in this.vtLayers)this.vtFeatures[t1] = [];
                }
                return this.vtLayers;
            }
            query(t1, e1, r, n) {
                this.loadVTLayers();
                const i = t1.params || {}, s = Jn(i.filter), a = t1.tileResult, o = t1.transform, l = a.bufferedTilespaceBounds, u = this.grid.query(l.min.x, l.min.y, l.max.x, l.max.y, (t1, e1, r, n)=>sl(a.bufferedTilespaceGeometry, t1, e1, r, n));
                u.sort(Qd);
                let c = null;
                o.elevation && u.length > 0 && (c = Yd.create(o.elevation, this.tileID));
                const h = {};
                let p;
                for(let o = 0; o < u.length; o++){
                    const l = u[o];
                    if (l === p) continue;
                    p = l;
                    const f = this.featureIndexArray.get(l);
                    let d = null;
                    this.loadMatchingFeature(h, f, s, i.layers, i.availableImages, e1, r, n, (e1, r, n, i = 0)=>(d || (d = No(e1, this.tileID.canonical, t1.tileTransform)), r.queryIntersectsFeature(a, e1, n, d, this.z, t1.transform, t1.pixelPosMatrix, c, i)));
                }
                return h;
            }
            loadMatchingFeature(t1, e1, r, n, i, s, a, o, l) {
                const { featureIndex: u, bucketIndex: c, sourceLayerIndex: h, layoutVertexArrayOffset: p } = e1, f = this.bucketLayerIDs[c];
                if (n && !function(t1, e1) {
                    for(let r = 0; r < t1.length; r++)if (e1.indexOf(t1[r]) >= 0) return !0;
                    return !1;
                }(n, f)) return;
                const d = this.sourceLayerCoder.decode(h), y = this.vtLayers[d].feature(u);
                if (r.needGeometry) {
                    const t1 = Go(y, !0);
                    if (!r.filter(new Cs(this.tileID.overscaledZ), t1, this.tileID.canonical)) return;
                } else if (!r.filter(new Cs(this.tileID.overscaledZ), y)) return;
                const m = this.getId(y, d);
                for(let e1 = 0; e1 < f.length; e1++){
                    const r = f[e1];
                    if (n && n.indexOf(r) < 0) continue;
                    const c = s[r];
                    if (!c) continue;
                    let h = {};
                    void 0 !== m && o && (h = o.getState(c.sourceLayer || "_geojsonTileLayer", m));
                    const d = v({}, a[r]);
                    d.paint = Jd(d.paint, c.paint, y, h, i), d.layout = Jd(d.layout, c.layout, y, h, i);
                    const g = !l || l(y, c, h, p);
                    if (!g) continue;
                    const x = new md(y, this.z, this.x, this.y, m);
                    x.layer = d;
                    let b = t1[r];
                    void 0 === b && (b = t1[r] = []), b.push({
                        featureIndex: u,
                        feature: x,
                        intersectionZ: g
                    });
                }
            }
            lookupSymbolFeatures(t1, e1, r, n, i, s, a, o) {
                const l = {};
                this.loadVTLayers();
                const u = Jn(i);
                for (const i of t1)this.loadMatchingFeature(l, {
                    bucketIndex: r,
                    sourceLayerIndex: n,
                    featureIndex: i,
                    layoutVertexArrayOffset: 0
                }, u, s, a, o, e1);
                return l;
            }
            loadFeature(t1) {
                const { featureIndex: e1, sourceLayerIndex: r } = t1;
                this.loadVTLayers();
                const n = this.sourceLayerCoder.decode(r), i = this.vtFeatures[n];
                if (i[e1]) return i[e1];
                const s = this.vtLayers[n].feature(e1);
                return i[e1] = s, s;
            }
            hasLayer(t1) {
                for (const e1 of this.bucketLayerIDs)for (const r of e1)if (t1 === r) return !0;
                return !1;
            }
            getId(t1, e1) {
                let r = t1.id;
                return this.promoteId && (r = t1.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e1]], "boolean" == typeof r && (r = Number(r))), r;
            }
            constructor(t1, e1){
                this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new Bi(wo, 16, 0), this.featureIndexArray = new Va, this.promoteId = e1;
            }
        }
        function Jd(t1, e1, r, n, i) {
            return M(t1, (t1, s)=>{
                const a = e1 instanceof js ? e1.get(s) : null;
                return a && a.evaluate ? a.evaluate(r, n, i) : a;
            });
        }
        function Qd(t1, e1) {
            return e1 - t1;
        }
        Pi(Wd, "FeatureIndex", {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        class ty {
            constructor(t1){
                const e1 = {}, r = [];
                for(const n in t1){
                    const i = t1[n], s = e1[n] = {};
                    for(const t1 in i.glyphs){
                        const e1 = i.glyphs[+t1];
                        if (!e1 || 0 === e1.bitmap.width || 0 === e1.bitmap.height) continue;
                        const n = e1.metrics.localGlyph ? 2 : 1, a = {
                            x: 0,
                            y: 0,
                            w: e1.bitmap.width + 2 * n,
                            h: e1.bitmap.height + 2 * n
                        };
                        r.push(a), s[t1] = a;
                    }
                }
                const { w: n, h: i } = $h(r), s = new hu({
                    width: n || 1,
                    height: i || 1
                });
                for(const r in t1){
                    const n = t1[r];
                    for(const t1 in n.glyphs){
                        const i = n.glyphs[+t1];
                        if (!i || 0 === i.bitmap.width || 0 === i.bitmap.height) continue;
                        const a = e1[r][t1], o = i.metrics.localGlyph ? 2 : 1;
                        hu.copy(i.bitmap, s, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + o,
                            y: a.y + o
                        }, i.bitmap);
                    }
                }
                this.image = s, this.positions = e1;
            }
        }
        Pi(ty, "GlyphAtlas");
        class ey {
            parse(t1, e1, r, n, i) {
                this.status = "parsing", this.data = t1, this.collisionBoxArray = new Ma;
                const s = new dd(Object.keys(t1.layers).sort()), a = new Wd(this.tileID, this.promoteId);
                a.bucketLayerIDs = [];
                const o = {}, l = new hd(256, 256), u = {
                    featureIndex: a,
                    iconDependencies: {},
                    patternDependencies: {},
                    glyphDependencies: {},
                    lineAtlas: l,
                    availableImages: r
                }, c = e1.familiesBySource[this.source];
                for(const e1 in c){
                    const n = t1.layers[e1];
                    if (!n) continue;
                    let i = !1, l = !1;
                    for (const t1 of c[e1])"symbol" === t1[0].type ? i = !0 : l = !0;
                    if (!0 === this.isSymbolTile && !i) continue;
                    if (!1 === this.isSymbolTile && !l) continue;
                    1 === n.version && E(`Vector tile source "${this.source}" layer "${e1}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const h = s.encode(e1), p = [];
                    for(let t1 = 0; t1 < n.length; t1++){
                        const r = n.feature(t1), i = a.getId(r, e1);
                        p.push({
                            feature: r,
                            id: i,
                            index: t1,
                            sourceLayerIndex: h
                        });
                    }
                    for (const t1 of c[e1]){
                        const e1 = t1[0];
                        void 0 !== this.isSymbolTile && "symbol" === e1.type !== this.isSymbolTile || e1.minzoom && this.zoom < Math.floor(e1.minzoom) || e1.maxzoom && this.zoom >= e1.maxzoom || "none" !== e1.visibility && (ry(t1, this.zoom, r), (o[e1.id] = e1.createBucket({
                            index: a.bucketLayerIDs.length,
                            layers: t1,
                            zoom: this.zoom,
                            canonical: this.canonical,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: h,
                            sourceID: this.source,
                            enableTerrain: this.enableTerrain,
                            projection: this.projection.spec,
                            availableImages: r
                        })).populate(p, u, this.tileID.canonical, this.tileTransform), a.bucketLayerIDs.push(t1.map((t1)=>t1.id)));
                    }
                }
                let h, p, f, d;
                l.trim();
                const y = {
                    type: "maybePrepare",
                    isSymbolTile: this.isSymbolTile,
                    zoom: this.zoom
                }, m = M(u.glyphDependencies, (t1)=>Object.keys(t1).map(Number));
                Object.keys(m).length ? n.send("getGlyphs", {
                    uid: this.uid,
                    stacks: m
                }, (t1, e1)=>{
                    h || (h = t1, p = e1, b.call(this));
                }, void 0, !1, y) : p = {};
                const g = Object.keys(u.iconDependencies);
                g.length ? n.send("getImages", {
                    icons: g,
                    source: this.source,
                    tileID: this.tileID,
                    type: "icons"
                }, (t1, e1)=>{
                    h || (h = t1, f = e1, b.call(this));
                }, void 0, !1, y) : f = {};
                const v = Object.keys(u.patternDependencies);
                function b() {
                    if (h) return i(h);
                    if (p && f && d) {
                        const t1 = new ty(p), e1 = new qh(f, d);
                        for(const n in o){
                            const i = o[n];
                            i instanceof Qf ? (ry(i.layers, this.zoom, r), Dp(i, p, t1.positions, f, e1.iconPositions, this.showCollisionBoxes, r, this.tileID.canonical, this.tileZoom, this.projection)) : i.hasPattern && (i instanceof Kc || i instanceof tc || i instanceof wc) && (ry(i.layers, this.zoom, r), i.addFeatures(u, this.tileID.canonical, e1.patternPositions, r, this.tileTransform));
                        }
                        this.status = "done", i(null, {
                            buckets: x(o).filter((t1)=>!t1.isEmpty()),
                            featureIndex: a,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: t1.image,
                            lineAtlas: l,
                            imageAtlas: e1,
                            glyphMap: this.returnDependencies ? p : null,
                            iconMap: this.returnDependencies ? f : null,
                            glyphPositions: this.returnDependencies ? t1.positions : null
                        });
                    }
                }
                v.length ? n.send("getImages", {
                    icons: v,
                    source: this.source,
                    tileID: this.tileID,
                    type: "patterns"
                }, (t1, e1)=>{
                    h || (h = t1, d = e1, b.call(this));
                }, void 0, !1, y) : d = {}, b.call(this);
            }
            constructor(t1){
                this.tileID = new Fc(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t1.showCollisionBoxes, this.collectResourceTiming = !!t1.collectResourceTiming, this.returnDependencies = !!t1.returnDependencies, this.promoteId = t1.promoteId, this.enableTerrain = !!t1.enableTerrain, this.isSymbolTile = t1.isSymbolTile, this.tileTransform = Af(t1.tileID.canonical, t1.projection), this.projection = t1.projection;
            }
        }
        function ry(t1, e1, r) {
            const n = new Cs(e1);
            for (const e1 of t1)e1.recalculate(n, r);
        }
        class ny {
            request(t1, e1, r, n) {
                const i = this.entries[t1] = this.entries[t1] || {
                    callbacks: []
                };
                if (i.result) {
                    const [t1, r] = i.result;
                    return this.scheduler ? this.scheduler.add(()=>{
                        n(t1, r);
                    }, e1) : n(t1, r), ()=>{};
                }
                return i.callbacks.push(n), i.cancel || (i.cancel = r((r, n)=>{
                    i.result = [
                        r,
                        n
                    ];
                    for (const t1 of i.callbacks)this.scheduler ? this.scheduler.add(()=>{
                        t1(r, n);
                    }, e1) : t1(r, n);
                    setTimeout(()=>delete this.entries[t1], 3e3);
                })), ()=>{
                    i.result || (i.callbacks = i.callbacks.filter((t1)=>t1 !== n), i.callbacks.length || (i.cancel(), delete this.entries[t1]));
                };
            }
            constructor(t1){
                this.entries = {}, this.scheduler = t1;
            }
        }
        function iy(t1, e1, r) {
            const n = JSON.stringify(t1.request);
            return t1.data && (this.deduped.entries[n] = {
                result: [
                    null,
                    t1.data
                ]
            }), this.deduped.request(n, {
                type: "parseTile",
                isSymbolTile: t1.isSymbolTile,
                zoom: t1.tileZoom
            }, (e1)=>{
                const n = Ct(t1.request, (t1, n, i, s)=>{
                    t1 ? e1(t1) : n && e1(null, {
                        vectorTile: r ? void 0 : new yc.VectorTile(new xh(n)),
                        rawData: n,
                        cacheControl: i,
                        expires: s
                    });
                });
                return ()=>{
                    n.cancel(), e1();
                };
            }, e1);
        }
        t1.ARRAY_TYPE = dl, t1.AUTH_ERR_MSG = nt, t1.Aabb = eu, t1.Actor = class {
            send(t1, e1, r, n, i = !1, s) {
                const a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                r && (r.metadata = s, this.callbacks[a] = r);
                const o = L(this.globalScope) ? void 0 : [];
                return this.target.postMessage({
                    id: a,
                    type: t1,
                    hasCallback: !!r,
                    targetMapId: n,
                    mustQueue: i,
                    sourceMapId: this.mapId,
                    data: Fi(e1, o)
                }, o), {
                    cancel: ()=>{
                        r && delete this.callbacks[a], this.target.postMessage({
                            id: a,
                            type: "<cancel>",
                            targetMapId: n,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            receive(t1) {
                const e1 = t1.data, r = e1.id;
                if (r && (!e1.targetMapId || this.mapId === e1.targetMapId)) {
                    if ("<cancel>" === e1.type) {
                        const t1 = this.cancelCallbacks[r];
                        delete this.cancelCallbacks[r], t1 && t1.cancel();
                    } else if (e1.mustQueue || D()) {
                        const t1 = this.callbacks[r];
                        this.cancelCallbacks[r] = this.scheduler.add(()=>this.processTask(r, e1), t1 && t1.metadata || {
                            type: "message"
                        });
                    } else this.processTask(r, e1);
                }
            }
            processTask(t1, e1) {
                if ("<response>" === e1.type) {
                    const r = this.callbacks[t1];
                    delete this.callbacks[t1], r && (e1.error ? r(Li(e1.error)) : r(null, Li(e1.data)));
                } else {
                    const r = L(this.globalScope) ? void 0 : [], n = e1.hasCallback ? (e1, n)=>{
                        delete this.cancelCallbacks[t1], this.target.postMessage({
                            id: t1,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: e1 ? Fi(e1) : null,
                            data: Fi(n, r)
                        }, r);
                    } : (t1)=>{}, i = Li(e1.data);
                    if (this.parent[e1.type]) this.parent[e1.type](e1.sourceMapId, i, n);
                    else if (this.parent.getWorkerSource) {
                        const t1 = e1.type.split(".");
                        this.parent.getWorkerSource(e1.sourceMapId, t1[0], i.source)[t1[1]](i, n);
                    } else n(new Error(`Could not find function ${e1.type}`));
                }
            }
            remove() {
                this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
            constructor(t1, r, n){
                this.target = t1, this.parent = r, this.mapId = n, this.callbacks = {}, this.cancelCallbacks = {}, k([
                    "receive"
                ], this), this.target.addEventListener("message", this.receive, !1), this.globalScope = D() ? t1 : e1, this.scheduler = new fd;
            }
        }, t1.CanonicalTileID = Dc, t1.Color = xe, t1.ColorMode = Od, t1.CullFaceMode = Gd, t1.DEMData = Ld, t1.DataConstantProperty = $s, t1.DedupedRequest = ny, t1.DepthMode = Ud, t1.EXTENT = wo, t1.Elevation = class {
            isDataAvailableAtPoint(t1) {
                const e1 = this._source();
                if (!e1 || t1.y < 0 || t1.y > 1) return !1;
                const r = e1.getSource().maxzoom, n = 1 << r, i = Math.floor(t1.x), s = Math.floor((t1.x - i) * n), a = Math.floor(t1.y * n), o = this.findDEMTileFor(new Fc(r, i, r, s, a));
                return !(!o || !o.dem);
            }
            getAtPointOrZero(t1, e1 = 0) {
                return this.getAtPoint(t1, e1) || 0;
            }
            getAtPoint(t1, e1, r = !0) {
                null == e1 && (e1 = null);
                const n = this._source();
                if (!n) return e1;
                if (t1.y < 0 || t1.y > 1) return e1;
                const i = n.getSource().maxzoom, s = 1 << i, a = Math.floor(t1.x), o = t1.x - a, l = new Fc(i, a, i, Math.floor(o * s), Math.floor(t1.y * s)), u = this.findDEMTileFor(l);
                if (!u || !u.dem) return e1;
                const c = u.dem, h = 1 << u.tileID.canonical.z, p = (o * h - u.tileID.canonical.x) * c.dim, f = (t1.y * h - u.tileID.canonical.y) * c.dim, d = Math.floor(p), y = Math.floor(f);
                return (r ? this.exaggeration() : 1) * xr(xr(c.get(d, y), c.get(d, y + 1), f - y), xr(c.get(d + 1, y), c.get(d + 1, y + 1), f - y), p - d);
            }
            getAtTileOffset(t1, e1, r) {
                const n = 1 << t1.canonical.z;
                return this.getAtPointOrZero(new Fo(t1.wrap + (t1.canonical.x + e1 / wo) / n, (t1.canonical.y + r / wo) / n));
            }
            getAtTileOffsetFunc(t1, e1, r, n) {
                return (i)=>{
                    const s = this.getAtTileOffset(t1, i.x, i.y), a = n.upVector(t1.canonical, i.x, i.y);
                    return Vl(a, a, s * n.upVectorScale(t1.canonical, e1, r).metersToTile), a;
                };
            }
            getForTilePoints(t1, e1, r, n) {
                const i = Yd.create(this, t1, n);
                return !!i && (e1.forEach((t1)=>{
                    t1[2] = this.exaggeration() * i.getElevationAt(t1[0], t1[1], r);
                }), !0);
            }
            getMinMaxForTile(t1) {
                const e1 = this.findDEMTileFor(t1);
                if (!e1 || !e1.dem) return null;
                const r = e1.dem.tree, n = e1.tileID, i = 1 << t1.canonical.z - n.canonical.z;
                let s = t1.canonical.x / i - n.canonical.x, a = t1.canonical.y / i - n.canonical.y, o = 0;
                for(let e1 = 0; e1 < t1.canonical.z - n.canonical.z && !r.leaves[o]; e1++){
                    s *= 2, a *= 2;
                    const t1 = 2 * Math.floor(a) + Math.floor(s);
                    o = r.childOffsets[o] + t1, s %= 1, a %= 1;
                }
                return {
                    min: this.exaggeration() * r.minimums[o],
                    max: this.exaggeration() * r.maximums[o]
                };
            }
            getMinElevationBelowMSL() {
                throw new Error("Pure virtual method called.");
            }
            raycast(t1, e1, r) {
                throw new Error("Pure virtual method called.");
            }
            pointCoordinate(t1) {
                throw new Error("Pure virtual method called.");
            }
            _source() {
                throw new Error("Pure virtual method called.");
            }
            exaggeration() {
                throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(t1) {
                throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
                throw new Error("Getter must be implemented in subclass.");
            }
        }, t1.ErrorEvent = qt, t1.EvaluationParameters = Cs, t1.Event = Ot, t1.Evented = Nt, t1.FillExtrusionBucket = wc, t1.Frustum = tu, t1.FrustumCorners = Ql, t1.GLOBE_METERS_TO_ECEF = Kp, t1.GLOBE_RADIUS = Xp, t1.GLOBE_SCALE_MATCH_LATITUDE = 45, t1.GLOBE_ZOOM_THRESHOLD_MAX = 6, t1.GLOBE_ZOOM_THRESHOLD_MIN = 5, t1.GlobeSharedBuffers = class {
            destroy() {
                this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
                for (const t1 of this._poleSegments)t1.destroy();
                for (const t1 of this._gridSegments)t1.destroy();
                if (this._wireframeIndexBuffer) {
                    this._wireframeIndexBuffer.destroy();
                    for (const t1 of this._wireframeSegments)t1.destroy();
                }
            }
            _createGrid(t1) {
                const e1 = new Qs, r = new ya, n = 65;
                for(let t1 = 0; t1 < n; t1++)for(let r = 0; r < n; r++)e1.emplaceBack(r, t1);
                this._gridSegments = [];
                for(let t1 = 0, e1 = 0; t1 < Hp.length; t1++){
                    const i = Hp[t1];
                    for(let t1 = 0; t1 < i; t1++)for(let e1 = 0; e1 < 64; e1++){
                        const i = t1 * n + e1;
                        r.emplaceBack(i + 1, i, i + n), r.emplaceBack(i + n, i + n + 1, i + 1);
                    }
                    const s = 64 * i * 2;
                    this._gridSegments.push(_o.simpleSegment(0, e1, (i + 1) * n, s)), e1 += s;
                }
                this._gridBuffer = t1.createVertexBuffer(e1, Zp.members), this._gridIndexBuffer = t1.createIndexBuffer(r, !0);
            }
            _createPoles(t1) {
                const e1 = new ya;
                for(let t1 = 0; t1 <= 64; t1++)e1.emplaceBack(0, t1 + 1, t1 + 2);
                this._poleIndexBuffer = t1.createIndexBuffer(e1, !0);
                const r = new va, n = new va;
                this._poleSegments = [];
                for(let t1 = 0, e1 = 0; t1 < 5; t1++){
                    const i = 360 / (1 << t1);
                    r.emplaceBack(0, -Xp, 0, .5, 0), n.emplaceBack(0, -Xp, 0, .5, 1);
                    for(let t1 = 0; t1 <= 64; t1++){
                        const e1 = t1 / 64, s = xr(0, i, e1), [a, o, l] = uf(bf, _f, s, Xp);
                        r.emplaceBack(a, o, l, e1, 0), n.emplaceBack(a, o, l, e1, 1);
                    }
                    this._poleSegments.push(_o.simpleSegment(e1, 0, 66, 64)), e1 += 66;
                }
                this._poleNorthVertexBuffer = t1.createVertexBuffer(r, Np, !1), this._poleSouthVertexBuffer = t1.createVertexBuffer(n, Np, !1);
            }
            getGridBuffers(t1) {
                return [
                    this._gridBuffer,
                    this._gridIndexBuffer,
                    this._gridSegments[t1]
                ];
            }
            getPoleBuffers(t1) {
                return [
                    this._poleNorthVertexBuffer,
                    this._poleSouthVertexBuffer,
                    this._poleIndexBuffer,
                    this._poleSegments[t1]
                ];
            }
            getWirefameBuffers(t1, e1) {
                if (!this._wireframeSegments) {
                    const e1 = new _a, r = 64, n = r + 1;
                    this._wireframeSegments = [];
                    for(let t1 = 0, i = 0; t1 < Hp.length; t1++){
                        const s = Hp[t1];
                        for(let t1 = 0; t1 < s; t1++)for(let i = 0; i < r; i++){
                            const r = t1 * n + i;
                            e1.emplaceBack(r, r + 1), e1.emplaceBack(r, r + n), e1.emplaceBack(r, r + n + 1);
                        }
                        const a = s * r * 3;
                        this._wireframeSegments.push(_o.simpleSegment(0, i, (s + 1) * n, a)), i += a;
                    }
                    this._wireframeIndexBuffer = t1.createIndexBuffer(e1);
                }
                return [
                    this._gridBuffer,
                    this._wireframeIndexBuffer,
                    this._wireframeSegments[e1]
                ];
            }
            constructor(t1){
                this._createGrid(t1), this._createPoles(t1);
            }
        }, t1.GlyphManager = vp, t1.ImagePosition = Oh, t1.LineAtlas = hd, t1.LngLat = ko, t1.LngLatBounds = Ao, t1.LocalGlyphMode = xp, t1.MAX_MERCATOR_LATITUDE = Do, t1.MercatorCoordinate = Fo, t1.ONE_EM = ah, t1.OverscaledTileID = Fc, t1.Properties = Zs, t1.RGBAImage = pu, t1.Ray = Jl, t1.RequestManager = class {
            _createSkuToken() {
                const t1 = function() {
                    let t1 = "";
                    for(let e1 = 0; e1 < 10; e1++)t1 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                    return {
                        token: [
                            "1",
                            rt,
                            t1
                        ].join(""),
                        tokenExpiresAt: Date.now() + 432e5
                    };
                }();
                this._skuToken = t1.token, this._skuTokenExpiresAt = t1.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
                return Date.now() > this._skuTokenExpiresAt;
            }
            transformRequest(t1, e1) {
                return this._transformRequestFn && this._transformRequestFn(t1, e1) || {
                    url: t1
                };
            }
            normalizeStyleURL(t1, e1) {
                if (!it(t1)) return t1;
                const r = ot(t1);
                return r.path = `/styles/v1${r.path}`, this._makeAPIURL(r, this._customAccessToken || e1);
            }
            normalizeGlyphsURL(t1, e1) {
                if (!it(t1)) return t1;
                const r = ot(t1);
                return r.path = `/fonts/v1${r.path}`, this._makeAPIURL(r, this._customAccessToken || e1);
            }
            normalizeSourceURL(t1, e1, r, n) {
                if (!it(t1)) return t1;
                const i = ot(t1);
                return i.path = `/v4/${i.authority}.json`, i.params.push("secure"), r && i.params.push(`language=${r}`), n && i.params.push(`worldview=${n}`), this._makeAPIURL(i, this._customAccessToken || e1);
            }
            normalizeSpriteURL(t1, e1, r, n) {
                const i = ot(t1);
                return it(t1) ? (i.path = `/styles/v1${i.path}/sprite${e1}${r}`, this._makeAPIURL(i, this._customAccessToken || n)) : (i.path += `${e1}${r}`, lt(i));
            }
            normalizeTileURL(t1, e1, r) {
                if (this._isSkuTokenExpired() && this._createSkuToken(), t1 && !it(t1)) return t1;
                const n = ot(t1);
                n.path = n.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${e1 || r && "raster" !== n.authority && 512 === r ? "@2x" : ""}${Y.supported ? ".webp" : "$1"}`), "raster" === n.authority ? n.path = `/${H.RASTER_URL_PREFIX}${n.path}` : (n.path = n.path.replace(/^.+\/v4\//, "/"), n.path = `/${H.TILE_URL_VERSION}${n.path}`);
                const i = this._customAccessToken || function(t1) {
                    for (const e1 of t1){
                        const t1 = e1.match(/^access_token=(.*)$/);
                        if (t1) return t1[1];
                    }
                    return null;
                }(n.params) || H.ACCESS_TOKEN;
                return H.REQUIRE_ACCESS_TOKEN && i && this._skuToken && n.params.push(`sku=${this._skuToken}`), this._makeAPIURL(n, i);
            }
            canonicalizeTileURL(t1, e1) {
                const r = ot(t1);
                if (!r.path.match(/^(\/v4\/|\/raster\/v1\/)/) || !r.path.match(/\.[\w]+$/)) return t1;
                let n = "mapbox://";
                r.path.match(/^\/raster\/v1\//) ? n += `raster/${r.path.replace(`/${H.RASTER_URL_PREFIX}/`, "")}` : n += `tiles/${r.path.replace(`/${H.TILE_URL_VERSION}/`, "")}`;
                let i = r.params;
                return e1 && (i = i.filter((t1)=>!t1.match(/^access_token=/))), i.length && (n += `?${i.join("&")}`), n;
            }
            canonicalizeTileset(t1, e1) {
                const r = !!e1 && it(e1), n = [];
                for (const e1 of t1.tiles || [])st(e1) ? n.push(this.canonicalizeTileURL(e1, r)) : n.push(e1);
                return n;
            }
            _makeAPIURL(t1, e1) {
                const r = "See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes", n = ot(H.API_URL);
                if (t1.protocol = n.protocol, t1.authority = n.authority, "http" === t1.protocol) {
                    const e1 = t1.params.indexOf("secure");
                    e1 >= 0 && t1.params.splice(e1, 1);
                }
                if ("/" !== n.path && (t1.path = `${n.path}${t1.path}`), !H.REQUIRE_ACCESS_TOKEN) return lt(t1);
                if (e1 = e1 || H.ACCESS_TOKEN, !this._silenceAuthErrors) {
                    if (!e1) throw new Error(`An API access token is required to use Mapbox GL. ${r}`);
                    if ("s" === e1[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${r}`);
                }
                return t1.params = t1.params.filter((t1)=>-1 === t1.indexOf("access_token")), t1.params.push(`access_token=${e1 || ""}`), lt(t1);
            }
            constructor(t1, e1, r){
                this._transformRequestFn = t1, this._customAccessToken = e1, this._silenceAuthErrors = !!r, this._createSkuToken();
            }
        }, t1.ResourceType = zt, t1.SegmentVector = _o, t1.SourceCache = Zd, t1.StencilMode = $d, t1.StructArrayLayout1ui2 = wa, t1.StructArrayLayout2f1f2i16 = pa, t1.StructArrayLayout2i4 = Qs, t1.StructArrayLayout2ui4 = _a, t1.StructArrayLayout3f12 = da, t1.StructArrayLayout3ui6 = ya, t1.StructArrayLayout4i8 = ea, t1.StructArrayLayout5f20 = va, t1.Texture = cd, t1.Tile = Id, t1.Transitionable = Vs, t1.Uniform1f = Wa, t1.Uniform1i = class extends Ya {
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && this.current !== r && (this.current = r, this.gl.uniform1i(this.location, r));
            }
            constructor(t1){
                super(t1), this.current = 0;
            }
        }, t1.Uniform2f = class extends Ya {
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && (r[0] === this.current[0] && r[1] === this.current[1] || (this.current = r, this.gl.uniform2f(this.location, r[0], r[1])));
            }
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0
                ];
            }
        }, t1.Uniform3f = class extends Ya {
            set(t1, e1, r) {
                this.fetchUniformLocation(t1, e1) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] || (this.current = r, this.gl.uniform3f(this.location, r[0], r[1], r[2])));
            }
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0,
                    0
                ];
            }
        }, t1.Uniform4f = Ja, t1.UniformColor = Qa, t1.UniformMatrix2f = class extends Ya {
            set(t1, e1, r) {
                if (this.fetchUniformLocation(t1, e1)) {
                    for(let t1 = 0; t1 < 4; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix2fv(this.location, !1, r);
                        break;
                    }
                }
            }
            constructor(t1){
                super(t1), this.current = ro;
            }
        }, t1.UniformMatrix3f = class extends Ya {
            set(t1, e1, r) {
                if (this.fetchUniformLocation(t1, e1)) {
                    for(let t1 = 0; t1 < 9; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix3fv(this.location, !1, r);
                        break;
                    }
                }
            }
            constructor(t1){
                super(t1), this.current = eo;
            }
        }, t1.UniformMatrix4f = class extends Ya {
            set(t1, e1, r) {
                if (this.fetchUniformLocation(t1, e1)) {
                    if (r[12] !== this.current[12] || r[0] !== this.current[0]) return this.current = r, void this.gl.uniformMatrix4fv(this.location, !1, r);
                    for(let t1 = 1; t1 < 16; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix4fv(this.location, !1, r);
                        break;
                    }
                }
            }
            constructor(t1){
                super(t1), this.current = to;
            }
        }, t1.UnwrappedTileID = Vc, t1.ValidationError = qn, t1.VectorTileWorkerSource = class extends Nt {
            loadTile(t1, e1) {
                const r = t1.uid, n = t1 && t1.request, i = n && n.collectResourceTiming, s = this.loading[r] = new ey(t1);
                s.abort = this.loadVectorData(t1, (a, o)=>{
                    const l = !this.loading[r];
                    if (delete this.loading[r], l || a || !o) return s.status = "done", l || (this.loaded[r] = s), e1(a);
                    const u = o.rawData, c = {};
                    o.expires && (c.expires = o.expires), o.cacheControl && (c.cacheControl = o.cacheControl), s.vectorTile = o.vectorTile || new yc.VectorTile(new xh(u));
                    const h = ()=>{
                        s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.actor, (t1, r)=>{
                            if (t1 || !r) return e1(t1);
                            const s = {};
                            if (i) {
                                const t1 = $(n);
                                t1.length > 0 && (s.resourceTiming = JSON.parse(JSON.stringify(t1)));
                            }
                            e1(null, v({
                                rawTileData: u.slice(0)
                            }, r, c, s));
                        });
                    };
                    this.isSpriteLoaded ? h() : this.once("isSpriteLoaded", ()=>{
                        this.scheduler ? this.scheduler.add(h, {
                            type: "parseTile",
                            isSymbolTile: t1.isSymbolTile,
                            zoom: t1.tileZoom
                        }) : h();
                    }), this.loaded = this.loaded || {}, this.loaded[r] = s;
                });
            }
            reloadTile(t1, e1) {
                const r = this.loaded, n = t1.uid, i = this;
                if (r && r[n]) {
                    const s = r[n];
                    s.showCollisionBoxes = t1.showCollisionBoxes, s.enableTerrain = !!t1.enableTerrain, s.projection = t1.projection, s.tileTransform = Af(t1.tileID.canonical, t1.projection);
                    const a = (t1, r)=>{
                        const n = s.reloadCallback;
                        n && (delete s.reloadCallback, s.parse(s.vectorTile, i.layerIndex, this.availableImages, i.actor, n)), e1(t1, r);
                    };
                    "parsing" === s.status ? s.reloadCallback = a : "done" === s.status && (s.vectorTile ? s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.actor, a) : a());
                }
            }
            abortTile(t1, e1) {
                const r = t1.uid, n = this.loading[r];
                n && (n.abort && n.abort(), delete this.loading[r]), e1();
            }
            removeTile(t1, e1) {
                const r = this.loaded, n = t1.uid;
                r && r[n] && delete r[n], e1();
            }
            constructor(t1, e1, r, n, i){
                super(), this.actor = t1, this.layerIndex = e1, this.availableImages = r, this.loadVectorData = i || iy, this.loading = {}, this.loaded = {}, this.deduped = new ny(t1.scheduler), this.isSpriteLoaded = n, this.scheduler = t1.scheduler;
            }
        }, t1.WritingMode = Nh, t1.ZoomHistory = Ri, t1.add = Bl, t1.addDynamicAttributes = Hf, t1.adjoint = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], s = e1[3], a = e1[4], o = e1[5], l = e1[6], u = e1[7], c = e1[8];
            return t1[0] = a * c - o * u, t1[1] = i * u - n * c, t1[2] = n * o - i * a, t1[3] = o * l - s * c, t1[4] = r * c - i * l, t1[5] = i * s - r * o, t1[6] = s * u - a * l, t1[7] = n * l - r * u, t1[8] = r * a - n * s, t1;
        }, t1.asyncAll = g, t1.bezier = p, t1.bindAll = k, t1.boundsAttributes = Sd, t1.bufferConvexPolygon = function(t1, e1) {
            const r = [];
            for(let n = 0; n < t1.length; n++){
                const i = m(n - 1, -1, t1.length - 1), s = m(n + 1, -1, t1.length - 1), a = t1[n], o = t1[s], l = t1[i].sub(a).unit(), u = o.sub(a).unit(), c = u.angleWithSep(l.x, l.y), h = l.add(u).unit().mult(-1 * e1 / Math.sin(c / 2));
                r.push(a.add(h));
            }
            return r;
        }, t1.cacheEntryPossiblyAdded = function(t1) {
            Mt++, Mt > bt && (t1.getActor().send("enforceCacheSizeLimit", vt), Mt = 0);
        }, t1.calculateGlobeLabelMatrix = function(t1, e1) {
            const { x: r, y: n } = t1.point, i = mf(r, n, t1.worldSize / t1._pixelsPerMercatorPixel, 0, 0);
            return xl(i, i, yf(rf(e1)));
        }, t1.calculateGlobeMatrix = function(t1) {
            const { x: e1, y: r } = t1.point, { lng: n, lat: i } = t1._center;
            return mf(e1, r, t1.worldSize, n, i);
        }, t1.calculateGlobeMercatorMatrix = function(t1) {
            const e1 = t1.pixelsPerMeter, r = e1 / Bo(1, t1.center.lat), n = ml(new Float64Array(16));
            return vl(n, n, [
                t1.point.x,
                t1.point.y,
                0
            ]), bl(n, n, [
                r,
                r,
                e1
            ]), Float32Array.from(n);
        }, t1.circumferenceAtLatitude = Mo, t1.clamp = d, t1.clearTileCache = function(t1) {
            const e1 = At(), r = [];
            for(const t1 in _t)e1 && r.push(e1.delete(t1)), delete _t[t1];
            t1 && Promise.all(r).catch(t1).then(()=>t1());
        }, t1.clipLine = dp, t1.clone = function(t1) {
            var e1 = new dl(16);
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
        }, t1.clone$1 = T, t1.collisionCircleLayout = sh, t1.config = H, t1.conjugate = function(t1, e1) {
            return t1[0] = -e1[0], t1[1] = -e1[1], t1[2] = -e1[2], t1[3] = e1[3], t1;
        }, t1.create = function() {
            var t1 = new dl(16);
            return dl != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
        }, t1.create$1 = yl, t1.createExpression = Ln, t1.createLayout = Ws, t1.createStyleLayer = function(t1) {
            return "custom" === t1.type ? new ad(t1) : new ud[t1.type](t1);
        }, t1.cross = Ul, t1.degToRad = l, t1.distance = function(t1, e1) {
            return Math.hypot(e1[0] - t1[0], e1[1] - t1[1], e1[2] - t1[2]);
        }, t1.div = function(t1, e1, r) {
            return t1[0] = e1[0] / r[0], t1[1] = e1[1] / r[1], t1[2] = e1[2] / r[2], t1;
        }, t1.dot = Rl, t1.ease = f, t1.easeCubicInOut = h, t1.emitValidationErrors = Ti, t1.endsWith = I, t1.enforceCacheSizeLimit = function(t1) {
            for(const e1 in _t)St(e1), _t[e1].then((e1)=>{
                e1.keys().then((r)=>{
                    for(let n = 0; n < r.length - t1; n++)e1.delete(r[n]);
                });
            });
        }, t1.evaluateSizeForFeature = uh, t1.evaluateSizeForZoom = ch, t1.evaluateVariableOffset = Pp, t1.evented = zs, t1.exactEquals = function(t1, e1) {
            return t1[0] === e1[0] && t1[1] === e1[1] && t1[2] === e1[2] && t1[3] === e1[3];
        }, t1.exactEquals$1 = function(t1, e1) {
            return t1[0] === e1[0] && t1[1] === e1[1] && t1[2] === e1[2];
        }, t1.exported = X, t1.exported$1 = Y, t1.extend = v, t1.extend$1 = Zt, t1.fillExtrusionHeightLift = Tc, t1.filterObject = z, t1.fromMat4 = function(t1, e1) {
            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[4], t1[4] = e1[5], t1[5] = e1[6], t1[6] = e1[8], t1[7] = e1[9], t1[8] = e1[10], t1;
        }, t1.fromQuat = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], s = e1[3], a = r + r, o = n + n, l = i + i, u = r * a, c = n * a, h = n * o, p = i * a, f = i * o, d = i * l, y = s * a, m = s * o, g = s * l;
            return t1[0] = 1 - h - d, t1[1] = c + g, t1[2] = p - m, t1[3] = 0, t1[4] = c - g, t1[5] = 1 - u - d, t1[6] = f + y, t1[7] = 0, t1[8] = p + m, t1[9] = f - y, t1[10] = 1 - u - h, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }, t1.fromRotation = function(t1, e1) {
            var r = Math.sin(e1), n = Math.cos(e1);
            return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = -r, t1[4] = n, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
        }, t1.fromScaling = Al, t1.furthestTileCorner = function(t1) {
            const e1 = Math.round((t1 + 45 + 360) % 360 / 90) % 4;
            return c[e1];
        }, t1.getAABBPointSquareDist = function(t1, e1, r) {
            let n = 0;
            for(let i = 0; i < 2; ++i){
                const s = r ? r[i] : 0;
                t1[i] > s && (n += (t1[i] - s) * (t1[i] - s)), e1[i] < s && (n += (s - e1[i]) * (s - e1[i]));
            }
            return n;
        }, t1.getAnchorAlignment = rp, t1.getAnchorJustification = Vp, t1.getBounds = function(t1) {
            let e1 = 1 / 0, r = 1 / 0, n = -1 / 0, s = -1 / 0;
            for (const i of t1)e1 = Math.min(e1, i.x), r = Math.min(r, i.y), n = Math.max(n, i.x), s = Math.max(s, i.y);
            return {
                min: new i(e1, r),
                max: new i(n, s)
            };
        }, t1.getColumn = U, t1.getGridMatrix = function(t1, e1, r) {
            const n = e1.getNorth(), i = e1.getSouth(), s = e1.getWest(), a = .015625;
            return [
                0,
                (e1.getEast() - s) * a,
                1 << t1.z,
                (i - n) / Hp[r],
                0,
                t1.y,
                n,
                s,
                a
            ];
        }, t1.getImage = Ut, t1.getJSON = function(t1, e1) {
            return Et(v(t1, {
                type: "json"
            }), e1);
        }, t1.getLatitudinalLod = function(t1) {
            const e1 = 80.051129;
            t1 = d(t1, -80.051129, e1) / e1 * 90;
            const r = Math.pow(Math.abs(Math.sin(l(t1))), 3);
            return Math.round(r * (Hp.length - 1));
        }, t1.getMapSessionAPI = mt, t1.getPerformanceMeasurement = $, t1.getProjection = Nf, t1.getRTLTextPluginStatus = Ts, t1.getReferrer = Bt, t1.getTilePoint = function(t1, { x: e1, y: r }, n = 0) {
            return new i(((e1 - n) * t1.scale - t1.x) * wo, (r * t1.scale - t1.y) * wo);
        }, t1.getTileVec3 = function(t1, e1, r = 0) {
            return Tl(((e1.x - r) * t1.scale - t1.x) * wo, (e1.y * t1.scale - t1.y) * wo, Po(e1.z, e1.y));
        }, t1.getVideo = function(t1, r) {
            const n = e1.document.createElement("video");
            n.muted = !0, n.onloadstart = function() {
                r(null, n);
            };
            for(let r = 0; r < t1.length; r++){
                const i = e1.document.createElement("source");
                Vt(t1[r]) || (n.crossOrigin = "Anonymous"), i.src = t1[r], n.appendChild(i);
            }
            return {
                cancel: ()=>{}
            };
        }, t1.globeCenterToScreenPoint = function(t1) {
            const e1 = [
                0,
                0,
                0
            ], r = ml(new Float64Array(16));
            return xl(r, t1.pixelMatrix, t1.globeMatrix), jl(e1, e1, r), new i(e1[0], e1[1]);
        }, t1.globeDenormalizeECEF = yf, t1.globeECEFOrigin = function(t1, e1) {
            const r = [
                0,
                0,
                0
            ];
            return jl(r, r, df(rf(e1.canonical))), jl(r, r, t1), r;
        }, t1.globeNormalizeECEF = df, t1.globePixelsToTileUnits = function(t1, e1) {
            return wo / (512 * Math.pow(2, t1)) * pf(rf(e1));
        }, t1.globePoleMatrixForTile = function(t1, e1, r) {
            const n = ml(new Float64Array(16)), i = (e1 / (1 << t1) - .5) * Math.PI * 2;
            return wl(n, r.globeMatrix, i), Float32Array.from(n);
        }, t1.globeTileBounds = rf, t1.globeTiltAtLngLat = xf, t1.globeToMercatorTransition = gf, t1.globeUseCustomAntiAliasing = function(t1, e1, r) {
            const n = gf(r.zoom), i = t1.style.map._antialias, s = !!e1.extStandardDerivatives, a = e1.extStandardDerivativesForceOff || t1.terrain && t1.terrain.exaggeration() > 0;
            return 0 === n && !i && !a && s;
        }, t1.identity = ml, t1.identity$1 = Hl, t1.invert = gl, t1.isFullscreen = function() {
            return !!e1.document.fullscreenElement || !!e1.document.webkitFullscreenElement;
        }, t1.isLngLatBehindGlobe = function(t1, e1) {
            return xf(t1, e1) > Math.PI / 2 * 1.01;
        }, t1.isMapAuthenticated = function(t1) {
            return gt.has(t1);
        }, t1.isMapboxURL = it, t1.isSafariWithAntialiasingBug = function(t1) {
            const e1 = t1.navigator ? t1.navigator.userAgent : null;
            return !!L(t1) && e1 && (e1.match("Version/15.4") || e1.match("Version/15.5") || e1.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/));
        }, t1.latFromMercatorY = Co, t1.len = Gl, t1.length = zl, t1.length$1 = function(t1) {
            return Math.hypot(t1[0], t1[1], t1[2], t1[3]);
        }, t1.loadVectorTile = iy, t1.makeRequest = Et, t1.mapValue = function(t1, e1, r, n, i) {
            return d((t1 - e1) / (r - e1) * (i - n) + n, n, i);
        }, t1.mercatorScale = Vo, t1.mercatorXfromLng = zo, t1.mercatorYfromLat = To, t1.mercatorZfromAltitude = Bo, t1.mul = kl, t1.mul$1 = Nl, t1.multiply = xl, t1.multiply$1 = function(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3], o = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = r[0], f = r[1], d = r[2], y = r[3], m = r[4], g = r[5], x = r[6], v = r[7], b = r[8];
            return t1[0] = p * n + f * a + d * u, t1[1] = p * i + f * o + d * c, t1[2] = p * s + f * l + d * h, t1[3] = y * n + m * a + g * u, t1[4] = y * i + m * o + g * c, t1[5] = y * s + m * l + g * h, t1[6] = x * n + v * a + b * u, t1[7] = x * i + v * o + b * c, t1[8] = x * s + v * l + b * h, t1;
        }, t1.multiply$2 = Cl, t1.nextPowerOfTwo = A, t1.normalize = Ll, t1.normalize$1 = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], s = e1[3], a = r * r + n * n + i * i + s * s;
            return a > 0 && (a = 1 / Math.sqrt(a)), t1[0] = r * a, t1[1] = n * a, t1[2] = i * a, t1[3] = s * a, t1;
        }, t1.number = xr, t1.ortho = function(t1, e1, r, n, i, s, a) {
            var o = 1 / (e1 - r), l = 1 / (n - i), u = 1 / (s - a);
            return t1[0] = -2 * o, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * u, t1[11] = 0, t1[12] = (e1 + r) * o, t1[13] = (i + n) * l, t1[14] = (a + s) * u, t1[15] = 1, t1;
        }, t1.pbf = xh, t1.perspective = function(t1, e1, r, n, i) {
            var s, a = 1 / Math.tan(e1 / 2);
            return t1[0] = a / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = a, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (t1[10] = (i + n) * (s = 1 / (n - i)), t1[14] = 2 * i * n * s) : (t1[10] = -1, t1[14] = -2 * n), t1;
        }, t1.pick = function(t1, e1) {
            const r = {};
            for(let n = 0; n < e1.length; n++){
                const i = e1[n];
                i in t1 && (r[i] = t1[i]);
            }
            return r;
        }, t1.plugin = Es, t1.pointGeometry = i, t1.polygonContainsPoint = il, t1.polygonIntersectsBox = sl, t1.polygonIntersectsPolygon = Ho, t1.polygonizeBounds = function(t1, e1, r = 0, n = !0) {
            const s = new i(r, r), a = t1.sub(s), o = e1.add(s), l = [
                a,
                new i(o.x, a.y),
                o,
                new i(a.x, o.y)
            ];
            return n && l.push(a.clone()), l;
        }, t1.posAttributes = Zp, t1.postMapLoadEvent = dt, t1.postTurnstileEvent = pt, t1.potpack = $h, t1.prevPowerOfTwo = function(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(t1) / Math.LN2));
        }, t1.radToDeg = u, t1.refProperties = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], t1.registerForPluginStateChange = function(t1) {
            return t1({
                pluginStatus: Ss,
                pluginURL: ks
            }), zs.on("pluginStateChange", t1), t1;
        }, t1.removeAuthState = function(t1) {
            gt.delete(t1);
        }, t1.renderColorRamp = du, t1.resample = Ro, t1.rotateX = _l, t1.rotateX$1 = Yl, t1.rotateY = wl, t1.rotateY$1 = Wl, t1.rotateZ = function(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e1[0], a = e1[1], o = e1[2], l = e1[3], u = e1[4], c = e1[5], h = e1[6], p = e1[7];
            return e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = s * i + u * n, t1[1] = a * i + c * n, t1[2] = o * i + h * n, t1[3] = l * i + p * n, t1[4] = u * i - s * n, t1[5] = c * i - a * n, t1[6] = h * i - o * n, t1[7] = p * i - l * n, t1;
        }, t1.rotateZ$1 = function(t1, e1, r) {
            r *= .5;
            var n = e1[0], i = e1[1], s = e1[2], a = e1[3], o = Math.sin(r), l = Math.cos(r);
            return t1[0] = n * l + i * o, t1[1] = i * l - n * o, t1[2] = s * l + a * o, t1[3] = a * l - s * o, t1;
        }, t1.scale = bl, t1.scale$1 = Zl, t1.scale$2 = Vl, t1.scaleAndAdd = Fl, t1.setCacheLimits = function(t1, e1) {
            vt = t1, bt = e1;
        }, t1.setColumn = function(t1, e1, r) {
            t1[4 * e1 + 0] = r[0], t1[4 * e1 + 1] = r[1], t1[4 * e1 + 2] = r[2], t1[4 * e1 + 3] = r[3];
        }, t1.setRTLTextPlugin = function(t1, e1, r = !1) {
            if (Ss === bs || Ss === _s || Ss === ws) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            ks = X.resolveURL(t1), Ss = bs, As = e1, Ms(), r || Bs();
        }, t1.smoothstep = y, t1.spec = Gt, t1.storeAuthState = function(t1, e1) {
            e1 ? gt.add(t1) : gt.delete(t1);
        }, t1.sub = ql, t1.subtract = El, t1.symbolSize = hh, t1.tileAABB = function(t1, e1, r, n, i, s, a, o, l) {
            if ("globe" === l.name) return af(t1, e1, new Dc(r, n, i));
            const u = Af({
                z: r,
                x: n,
                y: i
            }, l);
            return new eu([
                (s + u.x / u.scale) * e1,
                e1 * (u.y / u.scale),
                a
            ], [
                (s + u.x2 / u.scale) * e1,
                e1 * (u.y2 / u.scale),
                o
            ]);
        }, t1.tileCornersToBounds = of, t1.tileTransform = Af, t1.transformMat3 = function(t1, e1, r) {
            var n = e1[0], i = e1[1], s = e1[2];
            return t1[0] = n * r[0] + i * r[3] + s * r[6], t1[1] = n * r[1] + i * r[4] + s * r[7], t1[2] = n * r[2] + i * r[5] + s * r[8], t1;
        }, t1.transformMat4 = jl, t1.transformMat4$1 = Xl, t1.transformQuat = $l, t1.transitionTileAABBinECEF = nf, t1.translate = vl, t1.transpose = function(t1, e1) {
            if (t1 === e1) {
                var r = e1[1], n = e1[2], i = e1[5];
                t1[1] = e1[3], t1[2] = e1[6], t1[3] = r, t1[5] = e1[7], t1[6] = n, t1[7] = i;
            } else t1[0] = e1[0], t1[1] = e1[3], t1[2] = e1[6], t1[3] = e1[1], t1[4] = e1[4], t1[5] = e1[7], t1[6] = e1[2], t1[7] = e1[5], t1[8] = e1[8];
            return t1;
        }, t1.triggerPluginCompletionEvent = Is, t1.uniqueId = _, t1.updateGlobeVertexNormal = function(t1, e1, r, n, i) {
            const s = 5 * e1 + 2;
            t1.float32[s + 0] = r, t1.float32[s + 1] = n, t1.float32[s + 2] = i;
        }, t1.validateCustomStyleLayer = function(t1) {
            const e1 = [], r = t1.id;
            return void 0 === r && e1.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === t1.render && e1.push({
                message: `layers.${r}: missing required method "render"`
            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e1.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), e1;
        }, t1.validateFilter = (t1)=>zi(ci(t1)), t1.validateFog = (t1)=>zi(_i(t1)), t1.validateLayer = (t1)=>zi(yi(t1)), t1.validateLight = (t1)=>zi(vi(t1)), t1.validateSource = (t1)=>zi(xi(t1)), t1.validateStyle = ki, t1.validateTerrain = (t1)=>zi(bi(t1)), t1.values = x, t1.vectorTile = yc, t1.version = O, t1.warnOnce = E, t1.window = e1, t1.wrap = m;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        function t1(e1) {
            if ("number" == typeof e1 || "boolean" == typeof e1 || "string" == typeof e1 || null == e1) return JSON.stringify(e1);
            if (Array.isArray(e1)) {
                let r = "[";
                for (const o of e1)r += `${t1(o)},`;
                return `${r}]`;
            }
            let r = "{";
            for (const o of Object.keys(e1).sort())r += `${o}:${t1(e1[o])},`;
            return `${r}}`;
        }
        function r(r) {
            let o = "";
            for (const n of e1.refProperties)o += `/${t1(r[n])}`;
            return o;
        }
        class o {
            replace(e1) {
                this._layerConfigs = {}, this._layers = {}, this.update(e1, []);
            }
            update(t1, o) {
                for (const r of t1)this._layerConfigs[r.id] = r, (this._layers[r.id] = e1.createStyleLayer(r)).compileFilter(), this.keyCache[r.id] && delete this.keyCache[r.id];
                for (const e1 of o)delete this.keyCache[e1], delete this._layerConfigs[e1], delete this._layers[e1];
                this.familiesBySource = {};
                const n = function(e1, t1) {
                    const o = {};
                    for(let n = 0; n < e1.length; n++){
                        const i = t1 && t1[e1[n].id] || r(e1[n]);
                        t1 && (t1[e1[n].id] = i);
                        let s = o[i];
                        s || (s = o[i] = []), s.push(e1[n]);
                    }
                    const n = [];
                    for(const e1 in o)n.push(o[e1]);
                    return n;
                }(e1.values(this._layerConfigs), this.keyCache);
                for (const e1 of n){
                    const t1 = e1.map((e1)=>this._layers[e1.id]), r = t1[0];
                    if ("none" === r.visibility) continue;
                    const o = r.source || "";
                    let n = this.familiesBySource[o];
                    n || (n = this.familiesBySource[o] = {});
                    const i = r.sourceLayer || "_geojsonTileLayer";
                    let s = n[i];
                    s || (s = n[i] = []), s.push(t1);
                }
            }
            constructor(e1){
                this.keyCache = {}, e1 && this.replace(e1);
            }
        }
        class n {
            loadTile(t1, r) {
                const { uid: o, encoding: n, rawImageData: i, padding: s, buildQuadTree: a } = t1, l = e1.window.ImageBitmap && i instanceof e1.window.ImageBitmap ? this.getImageData(i, s) : i;
                r(null, new e1.DEMData(o, l, n, s < 1, a));
            }
            getImageData(e1, t1) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e1.width, e1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d")), this.offscreenCanvas.width = e1.width, this.offscreenCanvas.height = e1.height, this.offscreenCanvasContext.drawImage(e1, 0, 0, e1.width, e1.height);
                const r = this.offscreenCanvasContext.getImageData(-t1, -t1, e1.width + 2 * t1, e1.height + 2 * t1);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), r;
            }
        }
        var i = function e1(t1, r) {
            var o, n = t1 && t1.type;
            if ("FeatureCollection" === n) for(o = 0; o < t1.features.length; o++)e1(t1.features[o], r);
            else if ("GeometryCollection" === n) for(o = 0; o < t1.geometries.length; o++)e1(t1.geometries[o], r);
            else if ("Feature" === n) e1(t1.geometry, r);
            else if ("Polygon" === n) s(t1.coordinates, r);
            else if ("MultiPolygon" === n) for(o = 0; o < t1.coordinates.length; o++)s(t1.coordinates[o], r);
            return t1;
        };
        function s(e1, t1) {
            if (0 !== e1.length) {
                a(e1[0], t1);
                for(var r = 1; r < e1.length; r++)a(e1[r], !t1);
            }
        }
        function a(e1, t1) {
            for(var r = 0, o = 0, n = 0, i = e1.length, s = i - 1; n < i; s = n++){
                var a = (e1[n][0] - e1[s][0]) * (e1[s][1] + e1[n][1]), l = r + a;
                o += Math.abs(r) >= Math.abs(a) ? r - l + a : a - l + r, r = l;
            }
            r + o >= 0 != !!t1 && e1.reverse();
        }
        const l = e1.vectorTile.VectorTileFeature.prototype.toGeoJSON;
        class u {
            loadGeometry() {
                if (1 === this._feature.type) {
                    const t1 = [];
                    for (const r of this._feature.geometry)t1.push([
                        new e1.pointGeometry(r[0], r[1])
                    ]);
                    return t1;
                }
                {
                    const t1 = [];
                    for (const r of this._feature.geometry){
                        const o = [];
                        for (const t1 of r)o.push(new e1.pointGeometry(t1[0], t1[1]));
                        t1.push(o);
                    }
                    return t1;
                }
            }
            toGeoJSON(e1, t1, r) {
                return l.call(this, e1, t1, r);
            }
            constructor(t1){
                this._feature = t1, this.extent = e1.EXTENT, this.type = t1.type, this.properties = t1.tags, "id" in t1 && !isNaN(t1.id) && (this.id = parseInt(t1.id, 10));
            }
        }
        class h {
            feature(e1) {
                return new u(this._features[e1]);
            }
            constructor(t1){
                this.layers = {
                    _geojsonTileLayer: this
                }, this.name = "_geojsonTileLayer", this.extent = e1.EXTENT, this.length = t1.length, this._features = t1;
            }
        }
        var c = e1.vectorTile.VectorTileFeature, f = p;
        function p(e1, t1) {
            this.options = t1 || {}, this.features = e1, this.length = e1.length;
        }
        function g(e1, t1) {
            this.id = "number" == typeof e1.id ? e1.id : void 0, this.type = e1.type, this.rawGeometry = 1 === e1.type ? [
                e1.geometry
            ] : e1.geometry, this.properties = e1.tags, this.extent = t1 || 4096;
        }
        p.prototype.feature = function(e1) {
            return new g(this.features[e1], this.options.extent);
        }, g.prototype.loadGeometry = function() {
            var t1 = this.rawGeometry;
            this.geometry = [];
            for(var r = 0; r < t1.length; r++){
                for(var o = t1[r], n = [], i = 0; i < o.length; i++)n.push(new e1.pointGeometry(o[i][0], o[i][1]));
                this.geometry.push(n);
            }
            return this.geometry;
        }, g.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for(var e1 = this.geometry, t1 = 1 / 0, r = -1 / 0, o = 1 / 0, n = -1 / 0, i = 0; i < e1.length; i++)for(var s = e1[i], a = 0; a < s.length; a++){
                var l = s[a];
                t1 = Math.min(t1, l.x), r = Math.max(r, l.x), o = Math.min(o, l.y), n = Math.max(n, l.y);
            }
            return [
                t1,
                o,
                r,
                n
            ];
        }, g.prototype.toGeoJSON = c.prototype.toGeoJSON;
        var d = y, m = f;
        function y(t1) {
            var r = new e1.pbf;
            return function(e1, t1) {
                for(var r in e1.layers)t1.writeMessage(3, v, e1.layers[r]);
            }(t1, r), r.finish();
        }
        function v(e1, t1) {
            var r;
            t1.writeVarintField(15, e1.version || 1), t1.writeStringField(1, e1.name || ""), t1.writeVarintField(5, e1.extent || 4096);
            var o = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(r = 0; r < e1.length; r++)o.feature = e1.feature(r), t1.writeMessage(2, x, o);
            var n = o.keys;
            for(r = 0; r < n.length; r++)t1.writeStringField(3, n[r]);
            var i = o.values;
            for(r = 0; r < i.length; r++)t1.writeMessage(4, b, i[r]);
        }
        function x(e1, t1) {
            var r = e1.feature;
            void 0 !== r.id && t1.writeVarintField(1, r.id), t1.writeMessage(2, w, e1), t1.writeVarintField(3, r.type), t1.writeMessage(4, P, r);
        }
        function w(e1, t1) {
            var r = e1.feature, o = e1.keys, n = e1.values, i = e1.keycache, s = e1.valuecache;
            for(var a in r.properties){
                var l = r.properties[a], u = i[a];
                if (null !== l) {
                    void 0 === u && (o.push(a), i[a] = u = o.length - 1), t1.writeVarint(u);
                    var h = typeof l;
                    "string" !== h && "boolean" !== h && "number" !== h && (l = JSON.stringify(l));
                    var c = h + ":" + l, f = s[c];
                    void 0 === f && (n.push(l), s[c] = f = n.length - 1), t1.writeVarint(f);
                }
            }
        }
        function S(e1, t1) {
            return (t1 << 3) + (7 & e1);
        }
        function M(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function P(e1, t1) {
            for(var r = e1.loadGeometry(), o = e1.type, n = 0, i = 0, s = r.length, a = 0; a < s; a++){
                var l = r[a], u = 1;
                1 === o && (u = l.length), t1.writeVarint(S(1, u));
                for(var h = 3 === o ? l.length - 1 : l.length, c = 0; c < h; c++){
                    1 === c && 1 !== o && t1.writeVarint(S(2, h - 1));
                    var f = l[c].x - n, p = l[c].y - i;
                    t1.writeVarint(M(f)), t1.writeVarint(M(p)), n += f, i += p;
                }
                3 === o && t1.writeVarint(S(7, 1));
            }
        }
        function b(e1, t1) {
            var r = typeof e1;
            "string" === r ? t1.writeStringField(1, e1) : "boolean" === r ? t1.writeBooleanField(7, e1) : "number" === r && (e1 % 1 != 0 ? t1.writeDoubleField(3, e1) : e1 < 0 ? t1.writeSVarintField(6, e1) : t1.writeVarintField(5, e1));
        }
        function T(e1, t1, r, o, n, i) {
            if (n - o <= r) return;
            const s = o + n >> 1;
            k(e1, t1, s, o, n, i % 2), T(e1, t1, r, o, s - 1, i + 1), T(e1, t1, r, s + 1, n, i + 1);
        }
        function k(e1, t1, r, o, n, i) {
            for(; n > o;){
                if (n - o > 600) {
                    const s = n - o + 1, a = r - o + 1, l = Math.log(s), u = .5 * Math.exp(2 * l / 3), h = .5 * Math.sqrt(l * u * (s - u) / s) * (a - s / 2 < 0 ? -1 : 1);
                    k(e1, t1, r, Math.max(o, Math.floor(r - a * u / s + h)), Math.min(n, Math.floor(r + (s - a) * u / s + h)), i);
                }
                const s = t1[2 * r + i];
                let a = o, l = n;
                for(I(e1, t1, o, r), t1[2 * n + i] > s && I(e1, t1, o, n); a < l;){
                    for(I(e1, t1, a, l), a++, l--; t1[2 * a + i] < s;)a++;
                    for(; t1[2 * l + i] > s;)l--;
                }
                t1[2 * o + i] === s ? I(e1, t1, o, l) : (l++, I(e1, t1, l, n)), l <= r && (o = l + 1), r <= l && (n = l - 1);
            }
        }
        function I(e1, t1, r, o) {
            _(e1, r, o), _(t1, 2 * r, 2 * o), _(t1, 2 * r + 1, 2 * o + 1);
        }
        function _(e1, t1, r) {
            const o = e1[t1];
            e1[t1] = e1[r], e1[r] = o;
        }
        function L(e1, t1, r, o) {
            const n = e1 - r, i = t1 - o;
            return n * n + i * i;
        }
        d.fromVectorTileJs = y, d.fromGeojsonVt = function(e1, t1) {
            t1 = t1 || {};
            var r = {};
            for(var o in e1)r[o] = new f(e1[o].features, t1), r[o].name = o, r[o].version = t1.version, r[o].extent = t1.extent;
            return y({
                layers: r
            });
        }, d.GeoJSONWrapper = m;
        const C = (e1)=>e1[0], O = (e1)=>e1[1];
        class z {
            range(e1, t1, r, o) {
                return function(e1, t1, r, o, n, i, s) {
                    const a = [
                        0,
                        e1.length - 1,
                        0
                    ], l = [];
                    let u, h;
                    for(; a.length;){
                        const c = a.pop(), f = a.pop(), p = a.pop();
                        if (f - p <= s) {
                            for(let s = p; s <= f; s++)u = t1[2 * s], h = t1[2 * s + 1], u >= r && u <= n && h >= o && h <= i && l.push(e1[s]);
                            continue;
                        }
                        const g = Math.floor((p + f) / 2);
                        u = t1[2 * g], h = t1[2 * g + 1], u >= r && u <= n && h >= o && h <= i && l.push(e1[g]);
                        const d = (c + 1) % 2;
                        (0 === c ? r <= u : o <= h) && (a.push(p), a.push(g - 1), a.push(d)), (0 === c ? n >= u : i >= h) && (a.push(g + 1), a.push(f), a.push(d));
                    }
                    return l;
                }(this.ids, this.coords, e1, t1, r, o, this.nodeSize);
            }
            within(e1, t1, r) {
                return function(e1, t1, r, o, n, i) {
                    const s = [
                        0,
                        e1.length - 1,
                        0
                    ], a = [], l = n * n;
                    for(; s.length;){
                        const u = s.pop(), h = s.pop(), c = s.pop();
                        if (h - c <= i) {
                            for(let n = c; n <= h; n++)L(t1[2 * n], t1[2 * n + 1], r, o) <= l && a.push(e1[n]);
                            continue;
                        }
                        const f = Math.floor((c + h) / 2), p = t1[2 * f], g = t1[2 * f + 1];
                        L(p, g, r, o) <= l && a.push(e1[f]);
                        const d = (u + 1) % 2;
                        (0 === u ? r - n <= p : o - n <= g) && (s.push(c), s.push(f - 1), s.push(d)), (0 === u ? r + n >= p : o + n >= g) && (s.push(f + 1), s.push(h), s.push(d));
                    }
                    return a;
                }(this.ids, this.coords, e1, t1, r, this.nodeSize);
            }
            constructor(e1, t1 = C, r = O, o = 64, n = Float64Array){
                this.nodeSize = o, this.points = e1;
                const i = e1.length < 65536 ? Uint16Array : Uint32Array, s = this.ids = new i(e1.length), a = this.coords = new n(2 * e1.length);
                for(let o = 0; o < e1.length; o++)s[o] = o, a[2 * o] = t1(e1[o]), a[2 * o + 1] = r(e1[o]);
                T(s, a, o, 0, s.length - 1, 0);
            }
        }
        const E = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e1)=>e1
        }, F = Math.fround || (N = new Float32Array(1), (e1)=>(N[0] = +e1, N[0]));
        var N;
        class j {
            load(e1) {
                const { log: t1, minZoom: r, maxZoom: o, nodeSize: n } = this.options;
                t1 && console.time("total time");
                const i = `prepare ${e1.length} points`;
                t1 && console.time(i), this.points = e1;
                let s = [];
                for(let t1 = 0; t1 < e1.length; t1++)e1[t1].geometry && s.push(G(e1[t1], t1));
                this.trees[o + 1] = new z(s, D, $, n, Float32Array), t1 && console.timeEnd(i);
                for(let e1 = o; e1 >= r; e1--){
                    const r = +Date.now();
                    s = this._cluster(s, e1), this.trees[e1] = new z(s, D, $, n, Float32Array), t1 && console.log("z%d: %d clusters in %dms", e1, s.length, +Date.now() - r);
                }
                return t1 && console.timeEnd("total time"), this;
            }
            getClusters(e1, t1) {
                let r = ((e1[0] + 180) % 360 + 360) % 360 - 180;
                const o = Math.max(-90, Math.min(90, e1[1]));
                let n = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
                const i = Math.max(-90, Math.min(90, e1[3]));
                if (e1[2] - e1[0] >= 360) r = -180, n = 180;
                else if (r > n) {
                    const e1 = this.getClusters([
                        r,
                        o,
                        180,
                        i
                    ], t1), s = this.getClusters([
                        -180,
                        o,
                        n,
                        i
                    ], t1);
                    return e1.concat(s);
                }
                const s = this.trees[this._limitZoom(t1)], a = s.range(Y(r), X(i), Y(n), X(o)), l = [];
                for (const e1 of a){
                    const t1 = s.points[e1];
                    l.push(t1.numPoints ? J(t1) : this.points[t1.index]);
                }
                return l;
            }
            getChildren(e1) {
                const t1 = this._getOriginId(e1), r = this._getOriginZoom(e1), o = "No cluster with the specified id.", n = this.trees[r];
                if (!n) throw new Error(o);
                const i = n.points[t1];
                if (!i) throw new Error(o);
                const s = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), a = n.within(i.x, i.y, s), l = [];
                for (const t1 of a){
                    const r = n.points[t1];
                    r.parentId === e1 && l.push(r.numPoints ? J(r) : this.points[r.index]);
                }
                if (0 === l.length) throw new Error(o);
                return l;
            }
            getLeaves(e1, t1, r) {
                const o = [];
                return this._appendLeaves(o, e1, t1 = t1 || 10, r = r || 0, 0), o;
            }
            getTile(e1, t1, r) {
                const o = this.trees[this._limitZoom(e1)], n = Math.pow(2, e1), { extent: i, radius: s } = this.options, a = s / i, l = (r - a) / n, u = (r + 1 + a) / n, h = {
                    features: []
                };
                return this._addTileFeatures(o.range((t1 - a) / n, l, (t1 + 1 + a) / n, u), o.points, t1, r, n, h), 0 === t1 && this._addTileFeatures(o.range(1 - a / n, l, 1, u), o.points, n, r, n, h), t1 === n - 1 && this._addTileFeatures(o.range(0, l, a / n, u), o.points, -1, r, n, h), h.features.length ? h : null;
            }
            getClusterExpansionZoom(e1) {
                let t1 = this._getOriginZoom(e1) - 1;
                for(; t1 <= this.options.maxZoom;){
                    const r = this.getChildren(e1);
                    if (t1++, 1 !== r.length) break;
                    e1 = r[0].properties.cluster_id;
                }
                return t1;
            }
            _appendLeaves(e1, t1, r, o, n) {
                const i = this.getChildren(t1);
                for (const t1 of i){
                    const i = t1.properties;
                    if (i && i.cluster ? n + i.point_count <= o ? n += i.point_count : n = this._appendLeaves(e1, i.cluster_id, r, o, n) : n < o ? n++ : e1.push(t1), e1.length === r) break;
                }
                return n;
            }
            _addTileFeatures(e1, t1, r, o, n, i) {
                for (const s of e1){
                    const e1 = t1[s], a = e1.numPoints;
                    let l, u, h;
                    if (a) l = W(e1), u = e1.x, h = e1.y;
                    else {
                        const t1 = this.points[e1.index];
                        l = t1.properties, u = Y(t1.geometry.coordinates[0]), h = X(t1.geometry.coordinates[1]);
                    }
                    const c = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (u * n - r)),
                                Math.round(this.options.extent * (h * n - o))
                            ]
                        ],
                        tags: l
                    };
                    let f;
                    a ? f = e1.id : this.options.generateId ? f = e1.index : this.points[e1.index].id && (f = this.points[e1.index].id), void 0 !== f && (c.id = f), i.features.push(c);
                }
            }
            _limitZoom(e1) {
                return Math.max(this.options.minZoom, Math.min(+e1, this.options.maxZoom + 1));
            }
            _cluster(e1, t1) {
                const r = [], { radius: o, extent: n, reduce: i, minPoints: s } = this.options, a = o / (n * Math.pow(2, t1));
                for(let o = 0; o < e1.length; o++){
                    const n = e1[o];
                    if (n.zoom <= t1) continue;
                    n.zoom = t1;
                    const l = this.trees[t1 + 1], u = l.within(n.x, n.y, a), h = n.numPoints || 1;
                    let c = h;
                    for (const e1 of u){
                        const r = l.points[e1];
                        r.zoom > t1 && (c += r.numPoints || 1);
                    }
                    if (c > h && c >= s) {
                        let e1 = n.x * h, s = n.y * h, a = i && h > 1 ? this._map(n, !0) : null;
                        const f = (o << 5) + (t1 + 1) + this.points.length;
                        for (const r of u){
                            const o = l.points[r];
                            if (o.zoom <= t1) continue;
                            o.zoom = t1;
                            const u = o.numPoints || 1;
                            e1 += o.x * u, s += o.y * u, o.parentId = f, i && (a || (a = this._map(n, !0)), i(a, this._map(o)));
                        }
                        n.parentId = f, r.push(Z(e1 / c, s / c, f, c, a));
                    } else if (r.push(n), c > 1) for (const e1 of u){
                        const o = l.points[e1];
                        o.zoom <= t1 || (o.zoom = t1, r.push(o));
                    }
                }
                return r;
            }
            _getOriginId(e1) {
                return e1 - this.points.length >> 5;
            }
            _getOriginZoom(e1) {
                return (e1 - this.points.length) % 32;
            }
            _map(e1, t1) {
                if (e1.numPoints) return t1 ? A({}, e1.properties) : e1.properties;
                const r = this.points[e1.index].properties, o = this.options.map(r);
                return t1 && o === r ? A({}, o) : o;
            }
            constructor(e1){
                this.options = A(Object.create(E), e1), this.trees = new Array(this.options.maxZoom + 1);
            }
        }
        function Z(e1, t1, r, o, n) {
            return {
                x: F(e1),
                y: F(t1),
                zoom: 1 / 0,
                id: r,
                parentId: -1,
                numPoints: o,
                properties: n
            };
        }
        function G(e1, t1) {
            const [r, o] = e1.geometry.coordinates;
            return {
                x: F(Y(r)),
                y: F(X(o)),
                zoom: 1 / 0,
                index: t1,
                parentId: -1
            };
        }
        function J(e1) {
            var t1;
            return {
                type: "Feature",
                id: e1.id,
                properties: W(e1),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (t1 = e1.x, 360 * (t1 - .5)),
                        V(e1.y)
                    ]
                }
            };
        }
        function W(e1) {
            const t1 = e1.numPoints, r = t1 >= 1e4 ? `${Math.round(t1 / 1e3)}k` : t1 >= 1e3 ? Math.round(t1 / 100) / 10 + "k" : t1;
            return A(A({}, e1.properties), {
                cluster: !0,
                cluster_id: e1.id,
                point_count: t1,
                point_count_abbreviated: r
            });
        }
        function Y(e1) {
            return e1 / 360 + .5;
        }
        function X(e1) {
            const t1 = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
        }
        function V(e1) {
            const t1 = (180 - 360 * e1) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t1)) / Math.PI - 90;
        }
        function A(e1, t1) {
            for(const r in t1)e1[r] = t1[r];
            return e1;
        }
        function D(e1) {
            return e1.x;
        }
        function $(e1) {
            return e1.y;
        }
        function B(e1, t1, r, o) {
            for(var n, i = o, s = r - t1 >> 1, a = r - t1, l = e1[t1], u = e1[t1 + 1], h = e1[r], c = e1[r + 1], f = t1 + 3; f < r; f += 3){
                var p = R(e1[f], e1[f + 1], l, u, h, c);
                if (p > i) n = f, i = p;
                else if (p === i) {
                    var g = Math.abs(f - s);
                    g < a && (n = f, a = g);
                }
            }
            i > o && (n - t1 > 3 && B(e1, t1, n, o), e1[n + 2] = i, r - n > 3 && B(e1, n, r, o));
        }
        function R(e1, t1, r, o, n, i) {
            var s = n - r, a = i - o;
            if (0 !== s || 0 !== a) {
                var l = ((e1 - r) * s + (t1 - o) * a) / (s * s + a * a);
                l > 1 ? (r = n, o = i) : l > 0 && (r += s * l, o += a * l);
            }
            return (s = e1 - r) * s + (a = t1 - o) * a;
        }
        function q(e1, t1, r, o) {
            var n = {
                id: void 0 === e1 ? null : e1,
                type: t1,
                geometry: r,
                tags: o,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            return function(e1) {
                var t1 = e1.geometry, r = e1.type;
                if ("Point" === r || "MultiPoint" === r || "LineString" === r) U(e1, t1);
                else if ("Polygon" === r || "MultiLineString" === r) for(var o = 0; o < t1.length; o++)U(e1, t1[o]);
                else if ("MultiPolygon" === r) for(o = 0; o < t1.length; o++)for(var n = 0; n < t1[o].length; n++)U(e1, t1[o][n]);
            }(n), n;
        }
        function U(e1, t1) {
            for(var r = 0; r < t1.length; r += 3)e1.minX = Math.min(e1.minX, t1[r]), e1.minY = Math.min(e1.minY, t1[r + 1]), e1.maxX = Math.max(e1.maxX, t1[r]), e1.maxY = Math.max(e1.maxY, t1[r + 1]);
        }
        function Q(e1, t1, r, o) {
            if (t1.geometry) {
                var n = t1.geometry.coordinates, i = t1.geometry.type, s = Math.pow(r.tolerance / ((1 << r.maxZoom) * r.extent), 2), a = [], l = t1.id;
                if (r.promoteId ? l = t1.properties[r.promoteId] : r.generateId && (l = o || 0), "Point" === i) H(n, a);
                else if ("MultiPoint" === i) for(var u = 0; u < n.length; u++)H(n[u], a);
                else if ("LineString" === i) K(n, a, s, !1);
                else if ("MultiLineString" === i) {
                    if (r.lineMetrics) {
                        for(u = 0; u < n.length; u++)K(n[u], a = [], s, !1), e1.push(q(l, "LineString", a, t1.properties));
                        return;
                    }
                    ee(n, a, s, !1);
                } else if ("Polygon" === i) ee(n, a, s, !0);
                else {
                    if ("MultiPolygon" !== i) {
                        if ("GeometryCollection" === i) {
                            for(u = 0; u < t1.geometry.geometries.length; u++)Q(e1, {
                                id: l,
                                geometry: t1.geometry.geometries[u],
                                properties: t1.properties
                            }, r, o);
                            return;
                        }
                        throw new Error("Input data is not a valid GeoJSON object.");
                    }
                    for(u = 0; u < n.length; u++){
                        var h = [];
                        ee(n[u], h, s, !0), a.push(h);
                    }
                }
                e1.push(q(l, i, a, t1.properties));
            }
        }
        function H(e1, t1) {
            t1.push(te(e1[0])), t1.push(re(e1[1])), t1.push(0);
        }
        function K(e1, t1, r, o) {
            for(var n, i, s = 0, a = 0; a < e1.length; a++){
                var l = te(e1[a][0]), u = re(e1[a][1]);
                t1.push(l), t1.push(u), t1.push(0), a > 0 && (s += o ? (n * u - l * i) / 2 : Math.sqrt(Math.pow(l - n, 2) + Math.pow(u - i, 2))), n = l, i = u;
            }
            var h = t1.length - 3;
            t1[2] = 1, B(t1, 0, h, r), t1[h + 2] = 1, t1.size = Math.abs(s), t1.start = 0, t1.end = t1.size;
        }
        function ee(e1, t1, r, o) {
            for(var n = 0; n < e1.length; n++){
                var i = [];
                K(e1[n], i, r, o), t1.push(i);
            }
        }
        function te(e1) {
            return e1 / 360 + .5;
        }
        function re(e1) {
            var t1 = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
        }
        function oe(e1, t1, r, o, n, i, s, a) {
            if (o /= t1, i >= (r /= t1) && s < o) return e1;
            if (s < r || i >= o) return null;
            for(var l = [], u = 0; u < e1.length; u++){
                var h = e1[u], c = h.geometry, f = h.type, p = 0 === n ? h.minX : h.minY, g = 0 === n ? h.maxX : h.maxY;
                if (p >= r && g < o) l.push(h);
                else if (!(g < r || p >= o)) {
                    var d = [];
                    if ("Point" === f || "MultiPoint" === f) ne(c, d, r, o, n);
                    else if ("LineString" === f) ie(c, d, r, o, n, !1, a.lineMetrics);
                    else if ("MultiLineString" === f) ae(c, d, r, o, n, !1);
                    else if ("Polygon" === f) ae(c, d, r, o, n, !0);
                    else if ("MultiPolygon" === f) for(var m = 0; m < c.length; m++){
                        var y = [];
                        ae(c[m], y, r, o, n, !0), y.length && d.push(y);
                    }
                    if (d.length) {
                        if (a.lineMetrics && "LineString" === f) {
                            for(m = 0; m < d.length; m++)l.push(q(h.id, f, d[m], h.tags));
                            continue;
                        }
                        "LineString" !== f && "MultiLineString" !== f || (1 === d.length ? (f = "LineString", d = d[0]) : f = "MultiLineString"), "Point" !== f && "MultiPoint" !== f || (f = 3 === d.length ? "Point" : "MultiPoint"), l.push(q(h.id, f, d, h.tags));
                    }
                }
            }
            return l.length ? l : null;
        }
        function ne(e1, t1, r, o, n) {
            for(var i = 0; i < e1.length; i += 3){
                var s = e1[i + n];
                s >= r && s <= o && (t1.push(e1[i]), t1.push(e1[i + 1]), t1.push(e1[i + 2]));
            }
        }
        function ie(e1, t1, r, o, n, i, s) {
            for(var a, l, u = se(e1), h = 0 === n ? ue : he, c = e1.start, f = 0; f < e1.length - 3; f += 3){
                var p = e1[f], g = e1[f + 1], d = e1[f + 2], m = e1[f + 3], y = e1[f + 4], v = 0 === n ? p : g, x = 0 === n ? m : y, w = !1;
                s && (a = Math.sqrt(Math.pow(p - m, 2) + Math.pow(g - y, 2))), v < r ? x > r && (l = h(u, p, g, m, y, r), s && (u.start = c + a * l)) : v > o ? x < o && (l = h(u, p, g, m, y, o), s && (u.start = c + a * l)) : le(u, p, g, d), x < r && v >= r && (l = h(u, p, g, m, y, r), w = !0), x > o && v <= o && (l = h(u, p, g, m, y, o), w = !0), !i && w && (s && (u.end = c + a * l), t1.push(u), u = se(e1)), s && (c += a);
            }
            var S = e1.length - 3;
            p = e1[S], g = e1[S + 1], d = e1[S + 2], (v = 0 === n ? p : g) >= r && v <= o && le(u, p, g, d), S = u.length - 3, i && S >= 3 && (u[S] !== u[0] || u[S + 1] !== u[1]) && le(u, u[0], u[1], u[2]), u.length && t1.push(u);
        }
        function se(e1) {
            var t1 = [];
            return t1.size = e1.size, t1.start = e1.start, t1.end = e1.end, t1;
        }
        function ae(e1, t1, r, o, n, i) {
            for(var s = 0; s < e1.length; s++)ie(e1[s], t1, r, o, n, i, !1);
        }
        function le(e1, t1, r, o) {
            e1.push(t1), e1.push(r), e1.push(o);
        }
        function ue(e1, t1, r, o, n, i) {
            var s = (i - t1) / (o - t1);
            return e1.push(i), e1.push(r + (n - r) * s), e1.push(1), s;
        }
        function he(e1, t1, r, o, n, i) {
            var s = (i - r) / (n - r);
            return e1.push(t1 + (o - t1) * s), e1.push(i), e1.push(1), s;
        }
        function ce(e1, t1) {
            for(var r = [], o = 0; o < e1.length; o++){
                var n, i = e1[o], s = i.type;
                if ("Point" === s || "MultiPoint" === s || "LineString" === s) n = fe(i.geometry, t1);
                else if ("MultiLineString" === s || "Polygon" === s) {
                    n = [];
                    for(var a = 0; a < i.geometry.length; a++)n.push(fe(i.geometry[a], t1));
                } else if ("MultiPolygon" === s) for(n = [], a = 0; a < i.geometry.length; a++){
                    for(var l = [], u = 0; u < i.geometry[a].length; u++)l.push(fe(i.geometry[a][u], t1));
                    n.push(l);
                }
                r.push(q(i.id, s, n, i.tags));
            }
            return r;
        }
        function fe(e1, t1) {
            var r = [];
            r.size = e1.size, void 0 !== e1.start && (r.start = e1.start, r.end = e1.end);
            for(var o = 0; o < e1.length; o += 3)r.push(e1[o] + t1, e1[o + 1], e1[o + 2]);
            return r;
        }
        function pe(e1, t1) {
            if (e1.transformed) return e1;
            var r, o, n, i = 1 << e1.z, s = e1.x, a = e1.y;
            for(r = 0; r < e1.features.length; r++){
                var l = e1.features[r], u = l.geometry, h = l.type;
                if (l.geometry = [], 1 === h) for(o = 0; o < u.length; o += 2)l.geometry.push(ge(u[o], u[o + 1], t1, i, s, a));
                else for(o = 0; o < u.length; o++){
                    var c = [];
                    for(n = 0; n < u[o].length; n += 2)c.push(ge(u[o][n], u[o][n + 1], t1, i, s, a));
                    l.geometry.push(c);
                }
            }
            return e1.transformed = !0, e1;
        }
        function ge(e1, t1, r, o, n, i) {
            return [
                Math.round(r * (e1 * o - n)),
                Math.round(r * (t1 * o - i))
            ];
        }
        function de(e1, t1, r, o, n) {
            for(var i = t1 === n.maxZoom ? 0 : n.tolerance / ((1 << t1) * n.extent), s = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: 0,
                source: null,
                x: r,
                y: o,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            }, a = 0; a < e1.length; a++){
                s.numFeatures++, me(s, e1[a], i, n);
                var l = e1[a].minX, u = e1[a].minY, h = e1[a].maxX, c = e1[a].maxY;
                l < s.minX && (s.minX = l), u < s.minY && (s.minY = u), h > s.maxX && (s.maxX = h), c > s.maxY && (s.maxY = c);
            }
            return s;
        }
        function me(e1, t1, r, o) {
            var n = t1.geometry, i = t1.type, s = [];
            if ("Point" === i || "MultiPoint" === i) for(var a = 0; a < n.length; a += 3)s.push(n[a]), s.push(n[a + 1]), e1.numPoints++, e1.numSimplified++;
            else if ("LineString" === i) ye(s, n, e1, r, !1, !1);
            else if ("MultiLineString" === i || "Polygon" === i) for(a = 0; a < n.length; a++)ye(s, n[a], e1, r, "Polygon" === i, 0 === a);
            else if ("MultiPolygon" === i) for(var l = 0; l < n.length; l++){
                var u = n[l];
                for(a = 0; a < u.length; a++)ye(s, u[a], e1, r, !0, 0 === a);
            }
            if (s.length) {
                var h = t1.tags || null;
                if ("LineString" === i && o.lineMetrics) {
                    for(var c in h = {}, t1.tags)h[c] = t1.tags[c];
                    h.mapbox_clip_start = n.start / n.size, h.mapbox_clip_end = n.end / n.size;
                }
                var f = {
                    geometry: s,
                    type: "Polygon" === i || "MultiPolygon" === i ? 3 : "LineString" === i || "MultiLineString" === i ? 2 : 1,
                    tags: h
                };
                null !== t1.id && (f.id = t1.id), e1.features.push(f);
            }
        }
        function ye(e1, t1, r, o, n, i) {
            var s = o * o;
            if (o > 0 && t1.size < (n ? s : o)) r.numPoints += t1.length / 3;
            else {
                for(var a = [], l = 0; l < t1.length; l += 3)(0 === o || t1[l + 2] > s) && (r.numSimplified++, a.push(t1[l]), a.push(t1[l + 1])), r.numPoints++;
                n && function(e1, t1) {
                    for(var r = 0, o = 0, n = e1.length, i = n - 2; o < n; i = o, o += 2)r += (e1[o] - e1[i]) * (e1[o + 1] + e1[i + 1]);
                    if (r > 0 === t1) for(o = 0, n = e1.length; o < n / 2; o += 2){
                        var s = e1[o], a = e1[o + 1];
                        e1[o] = e1[n - 2 - o], e1[o + 1] = e1[n - 1 - o], e1[n - 2 - o] = s, e1[n - 1 - o] = a;
                    }
                }(a, i), e1.push(a);
            }
        }
        function ve(e1, t1) {
            var r = (t1 = this.options = function(e1, t1) {
                for(var r in t1)e1[r] = t1[r];
                return e1;
            }(Object.create(this.options), t1)).debug;
            if (r && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
            if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
            var o = function(e1, t1) {
                var r = [];
                if ("FeatureCollection" === e1.type) for(var o = 0; o < e1.features.length; o++)Q(r, e1.features[o], t1, o);
                else Q(r, "Feature" === e1.type ? e1 : {
                    geometry: e1
                }, t1);
                return r;
            }(e1, t1);
            this.tiles = {}, this.tileCoords = [], r && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), (o = function(e1, t1) {
                var r = t1.buffer / t1.extent, o = e1, n = oe(e1, 1, -1 - r, r, 0, -1, 2, t1), i = oe(e1, 1, 1 - r, 2 + r, 0, -1, 2, t1);
                return (n || i) && (o = oe(e1, 1, -r, 1 + r, 0, -1, 2, t1) || [], n && (o = ce(n, 1).concat(o)), i && (o = o.concat(ce(i, -1)))), o;
            }(o, t1)).length && this.splitTile(o, 0, 0, 0), r && (o.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
        }
        function xe(e1, t1, r) {
            return 32 * ((1 << e1) * r + t1) + e1;
        }
        function we(e1, t1) {
            const r = e1.tileID.canonical;
            if (!this._geoJSONIndex) return t1(null, null);
            const o = this._geoJSONIndex.getTile(r.z, r.x, r.y);
            if (!o) return t1(null, null);
            const n = new h(o.features);
            let i = d(n);
            0 === i.byteOffset && i.byteLength === i.buffer.byteLength || (i = new Uint8Array(i)), t1(null, {
                vectorTile: n,
                rawData: i.buffer
            });
        }
        ve.prototype.options = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        }, ve.prototype.splitTile = function(e1, t1, r, o, n, i, s) {
            for(var a = [
                e1,
                t1,
                r,
                o
            ], l = this.options, u = l.debug; a.length;){
                o = a.pop(), r = a.pop(), t1 = a.pop(), e1 = a.pop();
                var h = 1 << t1, c = xe(t1, r, o), f = this.tiles[c];
                if (!f && (u > 1 && console.time("creation"), f = this.tiles[c] = de(e1, t1, r, o, l), this.tileCoords.push({
                    z: t1,
                    x: r,
                    y: o
                }), u)) {
                    u > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, r, o, f.numFeatures, f.numPoints, f.numSimplified), console.timeEnd("creation"));
                    var p = "z" + t1;
                    this.stats[p] = (this.stats[p] || 0) + 1, this.total++;
                }
                if (f.source = e1, n) {
                    if (t1 === l.maxZoom || t1 === n) continue;
                    var g = 1 << n - t1;
                    if (r !== Math.floor(i / g) || o !== Math.floor(s / g)) continue;
                } else if (t1 === l.indexMaxZoom || f.numPoints <= l.indexMaxPoints) continue;
                if (f.source = null, 0 !== e1.length) {
                    u > 1 && console.time("clipping");
                    var d, m, y, v, x, w, S = .5 * l.buffer / l.extent, M = .5 - S, P = .5 + S, b = 1 + S;
                    d = m = y = v = null, x = oe(e1, h, r - S, r + P, 0, f.minX, f.maxX, l), w = oe(e1, h, r + M, r + b, 0, f.minX, f.maxX, l), e1 = null, x && (d = oe(x, h, o - S, o + P, 1, f.minY, f.maxY, l), m = oe(x, h, o + M, o + b, 1, f.minY, f.maxY, l), x = null), w && (y = oe(w, h, o - S, o + P, 1, f.minY, f.maxY, l), v = oe(w, h, o + M, o + b, 1, f.minY, f.maxY, l), w = null), u > 1 && console.timeEnd("clipping"), a.push(d || [], t1 + 1, 2 * r, 2 * o), a.push(m || [], t1 + 1, 2 * r, 2 * o + 1), a.push(y || [], t1 + 1, 2 * r + 1, 2 * o), a.push(v || [], t1 + 1, 2 * r + 1, 2 * o + 1);
                }
            }
        }, ve.prototype.getTile = function(e1, t1, r) {
            var o = this.options, n = o.extent, i = o.debug;
            if (e1 < 0 || e1 > 24) return null;
            var s = 1 << e1, a = xe(e1, t1 = (t1 % s + s) % s, r);
            if (this.tiles[a]) return pe(this.tiles[a], n);
            i > 1 && console.log("drilling down to z%d-%d-%d", e1, t1, r);
            for(var l, u = e1, h = t1, c = r; !l && u > 0;)u--, h = Math.floor(h / 2), c = Math.floor(c / 2), l = this.tiles[xe(u, h, c)];
            return l && l.source ? (i > 1 && console.log("found parent tile z%d-%d-%d", u, h, c), i > 1 && console.time("drilling down"), this.splitTile(l.source, u, h, c, e1, t1, r), i > 1 && console.timeEnd("drilling down"), this.tiles[a] ? pe(this.tiles[a], n) : null) : null;
        };
        class Se extends e1.VectorTileWorkerSource {
            loadData(t1, r) {
                const o = t1 && t1.request, n = o && o.collectResourceTiming;
                this.loadGeoJSON(t1, (s, a)=>{
                    if (s || !a) return r(s);
                    if ("object" != typeof a) return r(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    {
                        i(a, !0);
                        try {
                            if (t1.filter) {
                                const r = e1.createExpression(t1.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === r.result) throw new Error(r.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                                const o = a.features.filter((e1)=>r.value.evaluate({
                                        zoom: 0
                                    }, e1));
                                a = {
                                    type: "FeatureCollection",
                                    features: o
                                };
                            }
                            this._geoJSONIndex = t1.cluster ? new j(function({ superclusterOptions: t1, clusterProperties: r }) {
                                if (!r || !t1) return t1;
                                const o = {}, n = {}, i = {
                                    accumulated: null,
                                    zoom: 0
                                }, s = {
                                    properties: null
                                }, a = Object.keys(r);
                                for (const t1 of a){
                                    const [i, s] = r[t1], a = e1.createExpression(s), l = e1.createExpression("string" == typeof i ? [
                                        i,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t1
                                        ]
                                    ] : i);
                                    o[t1] = a.value, n[t1] = l.value;
                                }
                                return t1.map = (e1)=>{
                                    s.properties = e1;
                                    const t1 = {};
                                    for (const e1 of a)t1[e1] = o[e1].evaluate(i, s);
                                    return t1;
                                }, t1.reduce = (e1, t1)=>{
                                    s.properties = t1;
                                    for (const t1 of a)i.accumulated = e1[t1], e1[t1] = n[t1].evaluate(i, s);
                                }, t1;
                            }(t1)).load(a.features) : function(e1, t1) {
                                return new ve(e1, t1);
                            }(a, t1.geojsonVtOptions);
                        } catch (s) {
                            return r(s);
                        }
                        this.loaded = {};
                        const l = {};
                        if (n) {
                            const r = e1.getPerformanceMeasurement(o);
                            r && (l.resourceTiming = {}, l.resourceTiming[t1.source] = JSON.parse(JSON.stringify(r)));
                        }
                        r(null, l);
                    }
                });
            }
            reloadTile(e1, t1) {
                const r = this.loaded;
                return r && r[e1.uid] ? super.reloadTile(e1, t1) : this.loadTile(e1, t1);
            }
            loadGeoJSON(t1, r) {
                if (t1.request) e1.getJSON(t1.request, r);
                else {
                    if ("string" != typeof t1.data) return r(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    try {
                        return r(null, JSON.parse(t1.data));
                    } catch (e1) {
                        return r(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    }
                }
            }
            getClusterExpansionZoom(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }
            getClusterChildren(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getChildren(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }
            getClusterLeaves(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset));
                } catch (e1) {
                    t1(e1);
                }
            }
            constructor(e1, t1, r, o, n){
                super(e1, t1, r, o, we), n && (this.loadGeoJSON = n);
            }
        }
        class Me {
            clearCaches(e1, t1, r) {
                delete this.layerIndexes[e1], delete this.availableImages[e1], delete this.workerSources[e1], delete this.demWorkerSources[e1], r();
            }
            checkIfReady(e1, t1, r) {
                r();
            }
            setReferrer(e1, t1) {
                this.referrer = t1;
            }
            spriteLoaded(t1, r) {
                this.isSpriteLoaded[t1] = r;
                for(const o in this.workerSources[t1]){
                    const n = this.workerSources[t1][o];
                    for(const t1 in n)n[t1] instanceof e1.VectorTileWorkerSource && (n[t1].isSpriteLoaded = r, n[t1].fire(new e1.Event("isSpriteLoaded")));
                }
            }
            setImages(e1, t1, r) {
                this.availableImages[e1] = t1;
                for(const r in this.workerSources[e1]){
                    const o = this.workerSources[e1][r];
                    for(const e1 in o)o[e1].availableImages = t1;
                }
                r();
            }
            enableTerrain(e1, t1, r) {
                this.terrain = t1, r();
            }
            setProjection(t1, r) {
                this.projections[t1] = e1.getProjection(r);
            }
            setLayers(e1, t1, r) {
                this.getLayerIndex(e1).replace(t1), r();
            }
            updateLayers(e1, t1, r) {
                this.getLayerIndex(e1).update(t1.layers, t1.removedIds), r();
            }
            loadTile(t1, r, o) {
                const n = this.enableTerrain ? e1.extend({
                    enableTerrain: this.terrain
                }, r) : r;
                n.projection = this.projections[t1] || this.defaultProjection, this.getWorkerSource(t1, r.type, r.source).loadTile(n, o);
            }
            loadDEMTile(t1, r, o) {
                const n = this.enableTerrain ? e1.extend({
                    buildQuadTree: this.terrain
                }, r) : r;
                this.getDEMWorkerSource(t1, r.source).loadTile(n, o);
            }
            reloadTile(t1, r, o) {
                const n = this.enableTerrain ? e1.extend({
                    enableTerrain: this.terrain
                }, r) : r;
                n.projection = this.projections[t1] || this.defaultProjection, this.getWorkerSource(t1, r.type, r.source).reloadTile(n, o);
            }
            abortTile(e1, t1, r) {
                this.getWorkerSource(e1, t1.type, t1.source).abortTile(t1, r);
            }
            removeTile(e1, t1, r) {
                this.getWorkerSource(e1, t1.type, t1.source).removeTile(t1, r);
            }
            removeSource(e1, t1, r) {
                if (!this.workerSources[e1] || !this.workerSources[e1][t1.type] || !this.workerSources[e1][t1.type][t1.source]) return;
                const o = this.workerSources[e1][t1.type][t1.source];
                delete this.workerSources[e1][t1.type][t1.source], void 0 !== o.removeSource ? o.removeSource(t1, r) : r();
            }
            loadWorkerSource(e1, t1, r) {
                try {
                    this.self.importScripts(t1.url), r();
                } catch (e1) {
                    r(e1.toString());
                }
            }
            syncRTLPluginState(t1, r, o) {
                try {
                    e1.plugin.setState(r);
                    const t1 = e1.plugin.getPluginURL();
                    if (e1.plugin.isLoaded() && !e1.plugin.isParsed() && null != t1) {
                        this.self.importScripts(t1);
                        const r = e1.plugin.isParsed();
                        o(r ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t1}`), r);
                    }
                } catch (e1) {
                    o(e1.toString());
                }
            }
            getAvailableImages(e1) {
                let t1 = this.availableImages[e1];
                return t1 || (t1 = []), t1;
            }
            getLayerIndex(e1) {
                let t1 = this.layerIndexes[e1];
                return t1 || (t1 = this.layerIndexes[e1] = new o), t1;
            }
            getWorkerSource(e1, t1, r) {
                return this.workerSources[e1] || (this.workerSources[e1] = {}), this.workerSources[e1][t1] || (this.workerSources[e1][t1] = {}), this.workerSources[e1][t1][r] || (this.workerSources[e1][t1][r] = new this.workerSourceTypes[t1]({
                    send: (t1, r, o, n, i, s)=>{
                        this.actor.send(t1, r, o, e1, i, s);
                    },
                    scheduler: this.actor.scheduler
                }, this.getLayerIndex(e1), this.getAvailableImages(e1), this.isSpriteLoaded[e1])), this.workerSources[e1][t1][r];
            }
            getDEMWorkerSource(e1, t1) {
                return this.demWorkerSources[e1] || (this.demWorkerSources[e1] = {}), this.demWorkerSources[e1][t1] || (this.demWorkerSources[e1][t1] = new n), this.demWorkerSources[e1][t1];
            }
            enforceCacheSizeLimit(t1, r) {
                e1.enforceCacheSizeLimit(r);
            }
            getWorkerPerformanceMetrics(e1, t1, r) {
                r(void 0, void 0);
            }
            constructor(t1){
                this.self = t1, this.actor = new e1.Actor(t1, this), this.layerIndexes = {}, this.availableImages = {}, this.isSpriteLoaded = {}, this.projections = {}, this.defaultProjection = e1.getProjection({
                    name: "mercator"
                }), this.workerSourceTypes = {
                    vector: e1.VectorTileWorkerSource,
                    geojson: Se
                }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e1, t1)=>{
                    if (this.workerSourceTypes[e1]) throw new Error(`Worker source with name "${e1}" already registered.`);
                    this.workerSourceTypes[e1] = t1;
                }, this.self.registerRTLTextPlugin = (t1)=>{
                    if (e1.plugin.isParsed()) throw new Error("RTL text plugin already registered.");
                    e1.plugin.applyArabicShaping = t1.applyArabicShaping, e1.plugin.processBidirectionalText = t1.processBidirectionalText, e1.plugin.processStyledBidirectionalText = t1.processStyledBidirectionalText;
                };
            }
        }
        return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new Me(self)), Me;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        function t1(e1, i) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(i) || e1.length !== i.length) return !1;
                for(let o = 0; o < e1.length; o++)if (!t1(e1[o], i[o])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== i) {
                if ("object" != typeof i) return !1;
                if (Object.keys(e1).length !== Object.keys(i).length) return !1;
                for(const o in e1)if (!t1(e1[o], i[o])) return !1;
                return !0;
            }
            return e1 === i;
        }
        var i = o;
        function o(e1) {
            return !function(e1) {
                var t1;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray ? Function.prototype && Function.prototype.bind ? Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions ? "JSON" in window && "parse" in JSON && "stringify" in JSON ? function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var e1, t1, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), o = URL.createObjectURL(i);
                    try {
                        t1 = new Worker(o), e1 = !0;
                    } catch (t1) {
                        e1 = !1;
                    }
                    return t1 && t1.terminate(), URL.revokeObjectURL(o), e1;
                }() ? "Uint8ClampedArray" in window ? ArrayBuffer.isView ? function() {
                    var e1 = document.createElement("canvas");
                    e1.width = e1.height = 1;
                    var t1 = e1.getContext("2d");
                    if (!t1) return !1;
                    var i = t1.getImageData(0, 0, 1, 1);
                    return i && i.width === e1.width;
                }() ? (void 0 === r[t1 = e1 && e1.failIfMajorPerformanceCaveat] && (r[t1] = function(e1) {
                    var t1, i = function(e1) {
                        var t1 = document.createElement("canvas"), i = Object.create(o.webGLContextAttributes);
                        return i.failIfMajorPerformanceCaveat = e1, t1.getContext("webgl", i) || t1.getContext("experimental-webgl", i);
                    }(e1);
                    if (!i) return !1;
                    try {
                        t1 = i.createShader(i.VERTEX_SHADER);
                    } catch (e1) {
                        return !1;
                    }
                    return !(!t1 || i.isContextLost()) && (i.shaderSource(t1, "void main() {}"), i.compileShader(t1), !0 === i.getShaderParameter(t1, i.COMPILE_STATUS));
                }(t1)), r[t1] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL support") : "insufficient Canvas/getImageData support" : "insufficient ArrayBuffer support" : "insufficient Uint8ClampedArray support" : "insufficient worker support" : "insufficient JSON support" : "insufficient Object support" : "insufficient Function support" : "insufficent Array support";
            }(e1);
        }
        var r = {};
        function n(t1, i, o) {
            const r = e1.window.document.createElement(t1);
            return void 0 !== i && (r.className = i), o && o.appendChild(r), r;
        }
        function a(t1, i, o) {
            const r = e1.window.document.createElementNS("http://www.w3.org/2000/svg", t1);
            for (const e1 of Object.keys(i))r.setAttributeNS(null, e1, i[e1]);
            return o && o.appendChild(r), r;
        }
        o.webGLContextAttributes = {
            antialias: !1,
            alpha: !0,
            stencil: !0,
            depth: !0
        };
        const s = e1.window.document && e1.window.document.documentElement.style, l = s && void 0 !== s.userSelect ? "userSelect" : "WebkitUserSelect";
        let c;
        function h() {
            s && l && (c = s[l], s[l] = "none");
        }
        function u() {
            s && l && (s[l] = c);
        }
        function _(t1) {
            t1.preventDefault(), t1.stopPropagation(), e1.window.removeEventListener("click", _, !0);
        }
        function d() {
            e1.window.addEventListener("click", _, !0), e1.window.setTimeout(()=>{
                e1.window.removeEventListener("click", _, !0);
            }, 0);
        }
        function p(e1, t1) {
            const i = e1.getBoundingClientRect();
            return g(e1, i, t1);
        }
        function m(e1, t1) {
            const i = e1.getBoundingClientRect(), o = [];
            for(let r = 0; r < t1.length; r++)o.push(g(e1, i, t1[r]));
            return o;
        }
        function f(t1) {
            return void 0 !== e1.window.InstallTrigger && 2 === t1.button && t1.ctrlKey && e1.window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : t1.button;
        }
        function g(t1, i, o) {
            const r = t1.offsetWidth === i.width ? 1 : t1.offsetWidth / i.width;
            return new e1.pointGeometry((o.clientX - i.left) * r, (o.clientY - i.top) * r);
        }
        function v(e1, t1) {
            var i = t1[0], o = t1[1], r = t1[2], n = t1[3], a = i * n - r * o;
            return a ? (e1[0] = n * (a = 1 / a), e1[1] = -o * a, e1[2] = -r * a, e1[3] = i * a, e1) : null;
        }
        function x(e1) {
            const { userImage: t1 } = e1;
            return !!(t1 && t1.render && t1.render()) && (e1.data.replace(new Uint8Array(t1.data.buffer)), !0);
        }
        class y extends e1.Evented {
            isLoaded() {
                return this.loaded;
            }
            setLoaded(e1) {
                if (this.loaded !== e1 && (this.loaded = e1, e1)) {
                    for (const { ids: e1, callback: t1 } of this.requestors)this._notify(e1, t1);
                    this.requestors = [];
                }
            }
            hasImage(e1) {
                return !!this.getImage(e1);
            }
            getImage(e1) {
                return this.images[e1];
            }
            addImage(e1, t1) {
                this._validate(e1, t1) && (this.images[e1] = t1);
            }
            _validate(t1, i) {
                let o = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new e1.ErrorEvent(new Error(`Image "${t1}" has invalid "stretchX" value`))), o = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new e1.ErrorEvent(new Error(`Image "${t1}" has invalid "stretchY" value`))), o = !1), this._validateContent(i.content, i) || (this.fire(new e1.ErrorEvent(new Error(`Image "${t1}" has invalid "content" value`))), o = !1), o;
            }
            _validateStretch(e1, t1) {
                if (!e1) return !0;
                let i = 0;
                for (const o of e1){
                    if (o[0] < i || o[1] < o[0] || t1 < o[1]) return !1;
                    i = o[1];
                }
                return !0;
            }
            _validateContent(e1, t1) {
                return !(e1 && (4 !== e1.length || e1[0] < 0 || t1.data.width < e1[0] || e1[1] < 0 || t1.data.height < e1[1] || e1[2] < 0 || t1.data.width < e1[2] || e1[3] < 0 || t1.data.height < e1[3] || e1[2] < e1[0] || e1[3] < e1[1]));
            }
            updateImage(e1, t1) {
                t1.version = this.images[e1].version + 1, this.images[e1] = t1, this.updatedImages[e1] = !0;
            }
            removeImage(e1) {
                const t1 = this.images[e1];
                delete this.images[e1], delete this.patterns[e1], t1.userImage && t1.userImage.onRemove && t1.userImage.onRemove();
            }
            listImages() {
                return Object.keys(this.images);
            }
            getImages(e1, t1) {
                let i = !0;
                if (!this.isLoaded()) for (const t1 of e1)this.images[t1] || (i = !1);
                this.isLoaded() || i ? this._notify(e1, t1) : this.requestors.push({
                    ids: e1,
                    callback: t1
                });
            }
            _notify(t1, i) {
                const o = {};
                for (const i of t1){
                    this.images[i] || this.fire(new e1.Event("styleimagemissing", {
                        id: i
                    }));
                    const t1 = this.images[i];
                    t1 ? o[i] = {
                        data: t1.data.clone(),
                        pixelRatio: t1.pixelRatio,
                        sdf: t1.sdf,
                        version: t1.version,
                        stretchX: t1.stretchX,
                        stretchY: t1.stretchY,
                        content: t1.content,
                        hasRenderCallback: Boolean(t1.userImage && t1.userImage.render)
                    } : e1.warnOnce(`Image "${i}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                i(null, o);
            }
            getPixelSize() {
                const { width: e1, height: t1 } = this.atlasImage;
                return {
                    width: e1,
                    height: t1
                };
            }
            getPattern(t1) {
                const i = this.patterns[t1], o = this.getImage(t1);
                if (!o) return null;
                if (i && i.position.version === o.version) return i.position;
                if (i) i.position.version = o.version;
                else {
                    const i = {
                        w: o.data.width + 2,
                        h: o.data.height + 2,
                        x: 0,
                        y: 0
                    }, r = new e1.ImagePosition(i, o);
                    this.patterns[t1] = {
                        bin: i,
                        position: r
                    };
                }
                return this._updatePatternAtlas(), this.patterns[t1].position;
            }
            bind(t1) {
                const i = t1.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new e1.Texture(t1, this.atlasImage, i.RGBA), this.atlasTexture.bind(i.LINEAR, i.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas() {
                const t1 = [];
                for(const e1 in this.patterns)t1.push(this.patterns[e1].bin);
                const { w: i, h: o } = e1.potpack(t1), r = this.atlasImage;
                r.resize({
                    width: i || 1,
                    height: o || 1
                });
                for(const t1 in this.patterns){
                    const { bin: i } = this.patterns[t1], o = i.x + 1, n = i.y + 1, a = this.images[t1].data, s = a.width, l = a.height;
                    e1.RGBAImage.copy(a, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: n
                    }, {
                        width: s,
                        height: l
                    }), e1.RGBAImage.copy(a, r, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: o,
                        y: n - 1
                    }, {
                        width: s,
                        height: 1
                    }), e1.RGBAImage.copy(a, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: n + l
                    }, {
                        width: s,
                        height: 1
                    }), e1.RGBAImage.copy(a, r, {
                        x: s - 1,
                        y: 0
                    }, {
                        x: o - 1,
                        y: n
                    }, {
                        width: 1,
                        height: l
                    }), e1.RGBAImage.copy(a, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + s,
                        y: n
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                this.callbackDispatchedThisFrame = {};
            }
            dispatchRenderCallbacks(e1) {
                for (const t1 of e1){
                    if (this.callbackDispatchedThisFrame[t1]) continue;
                    this.callbackDispatchedThisFrame[t1] = !0;
                    const e1 = this.images[t1];
                    x(e1) && this.updateImage(t1, e1);
                }
            }
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new e1.RGBAImage({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
        }
        const b = new e1.Properties({
            anchor: new e1.DataConstantProperty(e1.spec.light.anchor),
            position: new class {
                possiblyEvaluate(t1, i) {
                    return function([t1, i, o]) {
                        const r = e1.degToRad(i + 90), n = e1.degToRad(o);
                        return {
                            x: t1 * Math.cos(r) * Math.sin(n),
                            y: t1 * Math.sin(r) * Math.sin(n),
                            z: t1 * Math.cos(n),
                            azimuthal: i,
                            polar: o
                        };
                    }(t1.expression.evaluate(i));
                }
                interpolate(t1, i, o) {
                    return {
                        x: e1.number(t1.x, i.x, o),
                        y: e1.number(t1.y, i.y, o),
                        z: e1.number(t1.z, i.z, o),
                        azimuthal: e1.number(t1.azimuthal, i.azimuthal, o),
                        polar: e1.number(t1.polar, i.polar, o)
                    };
                }
                constructor(){
                    this.specification = e1.spec.light.position;
                }
            },
            color: new e1.DataConstantProperty(e1.spec.light.color),
            intensity: new e1.DataConstantProperty(e1.spec.light.intensity)
        }), w = "-transition";
        class T extends e1.Evented {
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(t1, i = {}) {
                if (!this._validate(e1.validateLight, t1, i)) for(const i in t1){
                    const o = t1[i];
                    e1.endsWith(i, w) ? this._transitionable.setTransition(i.slice(0, -w.length), o) : this._transitionable.setValue(i, o);
                }
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && e1.emitValidationErrors(this, t1.call(e1.validateStyle, e1.extend({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.spec
                })));
            }
            constructor(t1){
                super(), this._transitionable = new e1.Transitionable(b), this.setLight(t1), this._transitioning = this._transitionable.untransitioned();
            }
        }
        const E = new e1.Properties({
            source: new e1.DataConstantProperty(e1.spec.terrain.source),
            exaggeration: new e1.DataConstantProperty(e1.spec.terrain.exaggeration)
        }), C = "-transition";
        class I extends e1.Evented {
            get() {
                return this._transitionable.serialize();
            }
            set(t1) {
                for(const i in t1){
                    const o = t1[i];
                    e1.endsWith(i, C) ? this._transitionable.setTransition(i.slice(0, -C.length), o) : this._transitionable.setValue(i, o);
                }
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            constructor(t1, i){
                super(), this._transitionable = new e1.Transitionable(E), this.set(t1), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i;
            }
        }
        function M(t1, i, o, r) {
            const n = e1.smoothstep(45, 65, o), [a, s] = S(t1, r), l = e1.length(i);
            let c = 1 - Math.min(1, Math.exp((l - a) / (s - a) * -6));
            return c *= c * c, c = Math.min(1, 1.00747 * c), c * n * t1.alpha;
        }
        function S(e1, t1) {
            const i = .5 / Math.tan(.5 * t1);
            return [
                e1.range[0] + i,
                e1.range[1] + i
            ];
        }
        const z = new e1.Properties({
            range: new e1.DataConstantProperty(e1.spec.fog.range),
            color: new e1.DataConstantProperty(e1.spec.fog.color),
            "high-color": new e1.DataConstantProperty(e1.spec.fog["high-color"]),
            "space-color": new e1.DataConstantProperty(e1.spec.fog["space-color"]),
            "horizon-blend": new e1.DataConstantProperty(e1.spec.fog["horizon-blend"]),
            "star-intensity": new e1.DataConstantProperty(e1.spec.fog["star-intensity"])
        }), D = "-transition";
        class P extends e1.Evented {
            get state() {
                const t1 = this._transform, i = "globe" === t1.projection.name, o = e1.globeToMercatorTransition(t1.zoom), r = this.properties.get("range"), n = [
                    .5,
                    3
                ];
                return {
                    range: i ? [
                        e1.number(n[0], r[0], o),
                        e1.number(n[1], r[1], o)
                    ] : r,
                    horizonBlend: this.properties.get("horizon-blend"),
                    alpha: this.properties.get("color").a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i = {}) {
                if (!this._validate(e1.validateFog, t1, i)) {
                    for (const i of Object.keys(e1.spec.fog))t1 && void 0 === t1[i] && (t1[i] = e1.spec.fog[i].default);
                    for(const i in t1){
                        const o = t1[i];
                        e1.endsWith(i, D) ? this._transitionable.setTransition(i.slice(0, -D.length), o) : this._transitionable.setValue(i, o);
                    }
                }
            }
            getOpacity(t1) {
                if (!this._transform.projection.supportsFog) return 0;
                const i = this.properties && this.properties.get("color") || 1;
                return ("globe" === this._transform.projection.name ? 1 : e1.smoothstep(45, 65, t1)) * i.a;
            }
            getOpacityAtLatLng(t1, i) {
                return this._transform.projection.supportsFog ? function(t1, i, o) {
                    const r = e1.MercatorCoordinate.fromLngLat(i), n = o.elevation ? o.elevation.getAtPointOrZero(r) : 0, a = [
                        r.x,
                        r.y,
                        n
                    ];
                    return e1.transformMat4(a, a, o.mercatorFogMatrix), M(t1, a, o.pitch, o._fov);
                }(this.state, t1, i) : 0;
            }
            getFovAdjustedRange(e1) {
                return this._transform.projection.supportsFog ? S(this.state, e1) : [
                    0,
                    1
                ];
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && e1.emitValidationErrors(this, t1.call(e1.validateStyle, e1.extend({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.spec
                })));
            }
            constructor(t1, i){
                super(), this._transitionable = new e1.Transitionable(z), this.set(t1), this._transitioning = this._transitionable.untransitioned(), this._transform = i;
            }
        }
        class A {
            broadcast(t1, i, o) {
                e1.asyncAll(this.actors, (e1, o)=>{
                    e1.send(t1, i, o);
                }, o = o || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((e1)=>{
                    e1.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
            constructor(t1, i){
                this.workerPool = t1, this.actors = [], this.currentActor = 0, this.id = e1.uniqueId();
                const o = this.workerPool.acquire(this.id);
                for(let e1 = 0; e1 < o.length; e1++){
                    const t1 = new A.Actor(o[e1], i, this.id);
                    t1.name = `Worker ${e1}`, this.actors.push(t1);
                }
                this.ready = !1, this.broadcast("checkIfReady", null, ()=>{
                    this.ready = !0;
                });
            }
        }
        function L(t1, i, o) {
            return i * (e1.EXTENT / (t1.tileSize * Math.pow(2, o - t1.tileID.overscaledZ)));
        }
        A.Actor = e1.Actor;
        class R {
            static createFromScreenPoints(t1, i) {
                let o, r;
                if (t1 instanceof e1.pointGeometry || "number" == typeof t1[0]) {
                    const n = e1.pointGeometry.convert(t1);
                    o = [
                        e1.pointGeometry.convert(t1)
                    ], r = i.isPointAboveHorizon(n);
                } else {
                    const n = e1.pointGeometry.convert(t1[0]), a = e1.pointGeometry.convert(t1[1]);
                    o = [
                        n,
                        a
                    ], r = e1.polygonizeBounds(n, a).every((e1)=>i.isPointAboveHorizon(e1));
                }
                return new R(o, i.getCameraPoint(), r, i);
            }
            isPointQuery() {
                return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(t1) {
                return e1.polygonizeBounds(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t1);
            }
            bufferedCameraGeometry(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e1.pointGeometry(1, 1)) : this.screenBounds[1], r = e1.polygonizeBounds(i, o, 0, !1);
                return this.cameraPoint.y > o.y && (this.cameraPoint.x > i.x && this.cameraPoint.x < o.x ? r.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o.x ? r[2] = this.cameraPoint : this.cameraPoint.x <= i.x && (r[3] = this.cameraPoint)), e1.bufferConvexPolygon(r, t1);
            }
            bufferedCameraGeometryGlobe(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e1.pointGeometry(1, 1)) : this.screenBounds[1], r = e1.polygonizeBounds(i, o, t1), n = this.cameraPoint.clone();
                switch(3 * ((n.y > i.y) + (n.y > o.y)) + ((n.x > i.x) + (n.x > o.x))){
                    case 0:
                        r[0] = n, r[4] = n.clone();
                        break;
                    case 1:
                        r.splice(1, 0, n);
                        break;
                    case 2:
                        r[1] = n;
                        break;
                    case 3:
                        r.splice(4, 0, n);
                        break;
                    case 5:
                        r.splice(2, 0, n);
                        break;
                    case 6:
                        r[3] = n;
                        break;
                    case 7:
                        r.splice(3, 0, n);
                        break;
                    case 8:
                        r[2] = n;
                }
                return r;
            }
            containsTile(t1, i, o, r = 0) {
                const n = t1.queryPadding / i._pixelsPerMercatorPixel + 1, a = o ? this._bufferedCameraMercator(n, i) : this._bufferedScreenMercator(n, i);
                let s = t1.tileID.wrap + (a.unwrapped ? r : 0);
                const l = a.polygon.map((i)=>e1.getTilePoint(t1.tileTransform, i, s));
                if (!e1.polygonIntersectsBox(l, 0, 0, e1.EXTENT, e1.EXTENT)) return;
                s = t1.tileID.wrap + (this.screenGeometryMercator.unwrapped ? r : 0);
                const c = this.screenGeometryMercator.polygon.map((i)=>e1.getTileVec3(t1.tileTransform, i, s)), h = c.map((t1)=>new e1.pointGeometry(t1[0], t1[1])), u = i.getFreeCameraOptions().position || new e1.MercatorCoordinate(0, 0, 0), _ = e1.getTileVec3(t1.tileTransform, u, s), d = c.map((t1)=>{
                    const i = e1.sub(t1, t1, _);
                    return e1.normalize(i, i), new e1.Ray(_, i);
                }), p = L(t1, 1, i.zoom) * i._pixelsPerMercatorPixel;
                var m;
                return {
                    queryGeometry: this,
                    tilespaceGeometry: h,
                    tilespaceRays: d,
                    bufferedTilespaceGeometry: l,
                    bufferedTilespaceBounds: (m = e1.getBounds(l), m.min.x = e1.clamp(m.min.x, 0, e1.EXTENT), m.min.y = e1.clamp(m.min.y, 0, e1.EXTENT), m.max.x = e1.clamp(m.max.x, 0, e1.EXTENT), m.max.y = e1.clamp(m.max.y, 0, e1.EXTENT), m),
                    tile: t1,
                    tileID: t1.tileID,
                    pixelToTileUnitsFactor: p
                };
            }
            _bufferedScreenMercator(e1, t1) {
                const i = k(e1);
                if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e1), t1) : {
                        polygon: this.bufferedScreenGeometry(e1).map((e1)=>t1.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._screenRaycastCache[i] = o, o;
                }
            }
            _bufferedCameraMercator(e1, t1) {
                const i = k(e1);
                if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e1), t1) : {
                        polygon: this.bufferedCameraGeometry(e1).map((e1)=>t1.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._cameraRaycastCache[i] = o, o;
                }
            }
            _projectAndResample(t1, i) {
                const o = function(t1, i) {
                    const o = e1.multiply([], i.pixelMatrix, i.globeMatrix), r = [
                        0,
                        -e1.GLOBE_RADIUS,
                        0,
                        1
                    ], n = [
                        0,
                        e1.GLOBE_RADIUS,
                        0,
                        1
                    ], a = [
                        0,
                        0,
                        0,
                        1
                    ];
                    e1.transformMat4$1(r, r, o), e1.transformMat4$1(n, n, o), e1.transformMat4$1(a, a, o);
                    const s = new e1.pointGeometry(r[0] / r[3], r[1] / r[3]), l = new e1.pointGeometry(n[0] / n[3], n[1] / n[3]), c = e1.polygonContainsPoint(t1, s) && r[3] < a[3], h = e1.polygonContainsPoint(t1, l) && n[3] < a[3];
                    if (!c && !h) return null;
                    const u = function(e1, t1, i) {
                        for(let o = 1; o < e1.length; o++){
                            const r = B(t1.pointCoordinate3D(e1[o - 1]).x), n = B(t1.pointCoordinate3D(e1[o]).x);
                            if (i < 0) {
                                if (r < n) return {
                                    idx: o,
                                    t: -r / (n - 1 - r)
                                };
                            } else if (n < r) return {
                                idx: o,
                                t: (1 - r) / (n + 1 - r)
                            };
                        }
                        return null;
                    }(t1, i, c ? -1 : 1);
                    if (!u) return null;
                    const { idx: _, t: d } = u;
                    let p = _ > 1 ? O(t1.slice(0, _), i) : [], m = _ < t1.length ? O(t1.slice(_), i) : [];
                    p = p.map((t1)=>new e1.pointGeometry(B(t1.x), t1.y)), m = m.map((t1)=>new e1.pointGeometry(B(t1.x), t1.y));
                    const f = [
                        ...p
                    ];
                    0 === f.length && f.push(m[m.length - 1]);
                    const g = e1.number(f[f.length - 1].y, (0 === m.length ? p[0] : m[0]).y, d);
                    let v;
                    return v = c ? [
                        new e1.pointGeometry(0, g),
                        new e1.pointGeometry(0, 0),
                        new e1.pointGeometry(1, 0),
                        new e1.pointGeometry(1, g)
                    ] : [
                        new e1.pointGeometry(1, g),
                        new e1.pointGeometry(1, 1),
                        new e1.pointGeometry(0, 1),
                        new e1.pointGeometry(0, g)
                    ], f.push(...v), 0 === m.length ? f.push(p[0]) : f.push(...m), {
                        polygon: f.map((t1)=>new e1.MercatorCoordinate(t1.x, t1.y)),
                        unwrapped: !1
                    };
                }(t1, i);
                if (o) return o;
                const r = function(t1, i) {
                    let o = !1, r = -1 / 0, n = 0;
                    for(let e1 = 0; e1 < t1.length - 1; e1++)t1[e1].x > r && (r = t1[e1].x, n = e1);
                    for(let e1 = 0; e1 < t1.length - 1; e1++){
                        const i = (n + e1) % (t1.length - 1), r = t1[i], a = t1[i + 1];
                        Math.abs(r.x - a.x) > .5 && (r.x < a.x ? (r.x += 1, 0 === i && (t1[t1.length - 1].x += 1)) : (a.x += 1, i + 1 === t1.length - 1 && (t1[0].x += 1)), o = !0);
                    }
                    const a = e1.mercatorXfromLng(i.center.lng);
                    return o && a < Math.abs(a - 1) && t1.forEach((e1)=>{
                        e1.x -= 1;
                    }), {
                        polygon: t1,
                        unwrapped: o
                    };
                }(O(t1, i).map((t1)=>new e1.pointGeometry(B(t1.x), t1.y)), i);
                return {
                    polygon: r.polygon.map((t1)=>new e1.MercatorCoordinate(t1.x, t1.y)),
                    unwrapped: r.unwrapped
                };
            }
            constructor(e1, t1, i, o){
                this.screenBounds = e1, this.cameraPoint = t1, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, o);
            }
        }
        function O(t1, i) {
            return e1.resample(t1, (e1)=>{
                const t1 = i.pointCoordinate3D(e1);
                e1.x = t1.x, e1.y = t1.y;
            }, 1 / 256);
        }
        function B(e1) {
            return e1 < 0 ? 1 + e1 % 1 : e1 % 1;
        }
        function k(e1) {
            return 100 * e1 | 0;
        }
        function F(t1, i, o, r, n) {
            const a = function(o, r) {
                if (o) return n(o);
                if (r) {
                    const o = e1.pick(e1.extend(r, t1), [
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "mapbox_logo",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding"
                    ]);
                    r.vector_layers && (o.vectorLayers = r.vector_layers, o.vectorLayerIds = o.vectorLayers.map((e1)=>e1.id)), r.language_options && (o.languageOptions = r.language_options), r.language && r.language[r.id] && (o.language = r.language[r.id]), r.worldview_options && (o.worldviewOptions = r.worldview_options), r.worldview ? o.worldview = r.worldview[r.id] : r.worldview_default && (o.worldview = r.worldview_default), o.tiles = i.canonicalizeTileset(o, t1.url), n(null, o);
                }
            };
            return t1.url ? e1.getJSON(i.transformRequest(i.normalizeSourceURL(t1.url, null, o, r), e1.ResourceType.Source), a) : e1.exported.frame(()=>a(null, t1));
        }
        class U {
            validateBounds(e1) {
                return Array.isArray(e1) && 4 === e1.length ? [
                    Math.max(-180, e1[0]),
                    Math.max(-90, e1[1]),
                    Math.min(180, e1[2]),
                    Math.min(90, e1[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(t1) {
                const i = Math.pow(2, t1.z), o = Math.floor(e1.mercatorXfromLng(this.bounds.getWest()) * i), r = Math.floor(e1.mercatorYfromLat(this.bounds.getNorth()) * i), n = Math.ceil(e1.mercatorXfromLng(this.bounds.getEast()) * i), a = Math.ceil(e1.mercatorYfromLat(this.bounds.getSouth()) * i);
                return t1.x >= o && t1.x < n && t1.y >= r && t1.y < a;
            }
            constructor(t1, i, o){
                this.bounds = e1.LngLatBounds.convert(this.validateBounds(t1)), this.minzoom = i || 0, this.maxzoom = o || 24;
            }
        }
        class N {
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e1) {
                const t1 = this.context.gl;
                this.context.unbindVAO(), this.bind(), t1.bufferSubData(t1.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
            constructor(e1, t1, i){
                this.context = e1;
                const o = e1.gl;
                this.buffer = o.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), o.bufferData(o.ELEMENT_ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? o.DYNAMIC_DRAW : o.STATIC_DRAW), this.dynamicDraw || t1.destroy();
            }
        }
        const G = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class j {
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e1) {
                const t1 = this.context.gl;
                this.bind(), t1.bufferSubData(t1.ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            enableAttributes(e1, t1) {
                for(let i = 0; i < this.attributes.length; i++){
                    const o = t1.attributes[this.attributes[i].name];
                    void 0 !== o && e1.enableVertexAttribArray(o);
                }
            }
            setVertexAttribPointers(e1, t1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const r = this.attributes[o], n = t1.attributes[r.name];
                    void 0 !== n && e1.vertexAttribPointer(n, r.components, e1[G[r.type]], !1, this.itemSize, r.offset + this.itemSize * (i || 0));
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
            constructor(e1, t1, i, o){
                this.length = t1.length, this.attributes = i, this.itemSize = t1.bytesPerElement, this.dynamicDraw = o, this.context = e1;
                const r = e1.gl;
                this.buffer = r.createBuffer(), e1.bindVertexBuffer.set(this.buffer), r.bufferData(r.ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || t1.destroy();
            }
        }
        class Z {
            get() {
                return this.current;
            }
            set(e1) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
            constructor(e1){
                this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
        }
        class V extends Z {
            getDefault() {
                return e1.Color.transparent;
            }
            set(e1) {
                const t1 = this.current;
                (e1.r !== t1.r || e1.g !== t1.g || e1.b !== t1.b || e1.a !== t1.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class W extends Z {
            getDefault() {
                return 1;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
            }
        }
        class X extends Z {
            getDefault() {
                return 0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
            }
        }
        class q extends Z {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class $ extends Z {
            getDefault() {
                return !0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class H extends Z {
            getDefault() {
                return 255;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Y extends Z {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e1) {
                const t1 = this.current;
                (e1.func !== t1.func || e1.ref !== t1.ref || e1.mask !== t1.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
            }
        }
        class K extends Z {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.KEEP,
                    e1.KEEP,
                    e1.KEEP
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
            }
        }
        class J extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.STENCIL_TEST) : t1.disable(t1.STENCIL_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class Q extends Z {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class ee extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.DEPTH_TEST) : t1.disable(t1.DEPTH_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class te extends Z {
            getDefault() {
                return this.gl.LESS;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ie extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.BLEND) : t1.disable(t1.BLEND), this.current = e1, this.dirty = !1;
            }
        }
        class oe extends Z {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.ONE,
                    e1.ZERO
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || this.dirty) && (this.gl.blendFunc(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class re extends Z {
            getDefault() {
                return e1.Color.transparent;
            }
            set(e1) {
                const t1 = this.current;
                (e1.r !== t1.r || e1.g !== t1.g || e1.b !== t1.b || e1.a !== t1.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class ne extends Z {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.blendEquation(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ae extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.CULL_FACE) : t1.disable(t1.CULL_FACE), this.current = e1, this.dirty = !1;
            }
        }
        class se extends Z {
            getDefault() {
                return this.gl.BACK;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class le extends Z {
            getDefault() {
                return this.gl.CCW;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ce extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
            }
        }
        class he extends Z {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ue extends Z {
            getDefault() {
                const e1 = this.gl;
                return [
                    0,
                    0,
                    e1.drawingBufferWidth,
                    e1.drawingBufferHeight
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class _e extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindFramebuffer(t1.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class de extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindRenderbuffer(t1.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class pe extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindTexture(t1.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
            }
        }
        class me extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindBuffer(t1.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class fe extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                const t1 = this.gl;
                t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class ge extends Z {
            getDefault() {
                return null;
            }
            set(e1) {
                this.vao && (e1 !== this.current || this.dirty) && (this.vao.bindVertexArrayOES(e1), this.current = e1, this.dirty = !1);
            }
            constructor(e1){
                super(e1), this.vao = e1.extVertexArrayObject;
            }
        }
        class ve extends Z {
            getDefault() {
                return 4;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
            }
        }
        class xe extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class ye extends Z {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class be extends Z {
            getDefault() {
                return null;
            }
            constructor(e1, t1){
                super(e1), this.context = e1, this.parent = t1;
            }
        }
        class we extends be {
            setDirty() {
                this.dirty = !0;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0, t1.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class Te extends be {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferRenderbuffer(t1.FRAMEBUFFER, this.attachment(), t1.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Ee extends Te {
            attachment() {
                return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        class Ce {
            destroy() {
                const e1 = this.context.gl, t1 = this.colorAttachment.get();
                if (t1 && e1.deleteTexture(t1), this.depthAttachment) {
                    const t1 = this.depthAttachment.get();
                    t1 && e1.deleteRenderbuffer(t1);
                }
                e1.deleteFramebuffer(this.framebuffer);
            }
            constructor(e1, t1, i, o){
                this.context = e1, this.width = t1, this.height = i;
                const r = this.framebuffer = e1.gl.createFramebuffer();
                this.colorAttachment = new we(e1, r), o && (this.depthAttachment = new Te(e1, r));
            }
        }
        class Ie {
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.extVertexArrayObject && (this.bindVertexArrayOES.dirty = !0), this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e1, t1) {
                return new N(this, e1, t1);
            }
            createVertexBuffer(e1, t1, i) {
                return new j(this, e1, t1, i);
            }
            createRenderbuffer(e1, t1, i) {
                const o = this.gl, r = o.createRenderbuffer();
                return this.bindRenderbuffer.set(r), o.renderbufferStorage(o.RENDERBUFFER, e1, t1, i), this.bindRenderbuffer.set(null), r;
            }
            createFramebuffer(e1, t1, i) {
                return new Ce(this, e1, t1, i);
            }
            clear({ color: e1, depth: t1, stencil: i }) {
                const o = this.gl;
                let r = 0;
                e1 && (r |= o.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t1 && (r |= o.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t1), this.depthMask.set(!0)), void 0 !== i && (r |= o.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), o.clear(r);
            }
            setCullFace(e1) {
                !1 === e1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
            }
            setDepthMode(e1) {
                e1.func !== this.gl.ALWAYS || e1.mask ? (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e1) {
                e1.test.func !== this.gl.ALWAYS || e1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
                    e1.fail,
                    e1.depthFail,
                    e1.pass
                ]), this.stencilFunc.set({
                    func: e1.test.func,
                    ref: e1.ref,
                    mask: e1.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(i) {
                t1(i.blendFunction, e1.ColorMode.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(i.blendFunction), this.blendColor.set(i.blendColor)), this.colorMask.set(i.mask);
            }
            unbindVAO() {
                this.extVertexArrayObject && this.bindVertexArrayOES.set(null);
            }
            constructor(e1){
                this.gl = e1, this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object"), this.clearColor = new V(this), this.clearDepth = new W(this), this.clearStencil = new X(this), this.colorMask = new q(this), this.depthMask = new $(this), this.stencilMask = new H(this), this.stencilFunc = new Y(this), this.stencilOp = new K(this), this.stencilTest = new J(this), this.depthRange = new Q(this), this.depthTest = new ee(this), this.depthFunc = new te(this), this.blend = new ie(this), this.blendFunc = new oe(this), this.blendColor = new re(this), this.blendEquation = new ne(this), this.cullFace = new ae(this), this.cullFaceSide = new se(this), this.frontFace = new le(this), this.program = new ce(this), this.activeTexture = new he(this), this.viewport = new ue(this), this.bindFramebuffer = new _e(this), this.bindRenderbuffer = new de(this), this.bindTexture = new pe(this), this.bindVertexBuffer = new me(this), this.bindElementBuffer = new fe(this), this.bindVertexArrayOES = this.extVertexArrayObject && new ge(this), this.pixelStoreUnpack = new ve(this), this.pixelStoreUnpackPremultiplyAlpha = new xe(this), this.pixelStoreUnpackFlipY = new ye(this), this.extTextureFilterAnisotropic = e1.getExtension("EXT_texture_filter_anisotropic") || e1.getExtension("MOZ_EXT_texture_filter_anisotropic") || e1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.extTextureFilterAnisotropicForceOff = !1, this.extStandardDerivativesForceOff = !1, this.extTextureHalfFloat = e1.getExtension("OES_texture_half_float"), this.extTextureHalfFloat && (e1.getExtension("OES_texture_half_float_linear"), this.extRenderToTextureHalfFloat = e1.getExtension("EXT_color_buffer_half_float")), this.extStandardDerivatives = e1.getExtension("OES_standard_derivatives"), this.extTimerQuery = e1.getExtension("EXT_disjoint_timer_query"), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE);
            }
        }
        class Me extends e1.Evented {
            load() {
                this._loaded = !1, this.fire(new e1.Event("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = F(this._options, this.map._requestManager, null, null, (t1, i)=>{
                    this._tileJSONRequest = null, this._loaded = !0, t1 ? this.fire(new e1.ErrorEvent(t1)) : i && (e1.extend(this, i), i.bounds && (this.tileBounds = new U(i.bounds, this.minzoom, this.maxzoom)), e1.postTurnstileEvent(i.tiles), this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    })));
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            serialize() {
                return e1.extend({}, this._options);
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            loadTile(t1, i) {
                const o = e1.exported.devicePixelRatio >= 2, r = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), o, this.tileSize);
                t1.request = e1.getImage(this.map._requestManager.transformRequest(r, e1.ResourceType.Tile), (o, r, n, a)=>(delete t1.request, t1.aborted ? (t1.state = "unloaded", i(null)) : o ? (t1.state = "errored", i(o)) : r ? (this.map._refreshExpiredTiles && t1.setExpiryData({
                        cacheControl: n,
                        expires: a
                    }), t1.setTexture(r, this.map.painter), t1.state = "loaded", e1.cacheEntryPossiblyAdded(this.dispatcher), void i(null)) : i(null)));
            }
            static loadTileData(e1, t1, i) {
                e1.setTexture(t1, i);
            }
            static unloadTileData(e1, t1) {
                e1.texture && t1.saveTileTexture(e1.texture);
            }
            abortTile(e1, t1) {
                e1.request && (e1.request.cancel(), delete e1.request), t1();
            }
            unloadTile(e1, t1) {
                e1.texture && this.map.painter.saveTileTexture(e1.texture), t1();
            }
            hasTransition() {
                return !1;
            }
            constructor(t1, i, o, r){
                super(), this.id = t1, this.dispatcher = o, this.setEventedParent(r), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = e1.extend({
                    type: "raster"
                }, i), e1.extend(this, e1.pick(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
        }
        let Se;
        function ze(t1, i, o, r, n, a, s, l) {
            const c = [
                t1,
                o,
                n,
                i,
                r,
                a,
                1,
                1,
                1
            ], h = [
                s,
                l,
                1
            ], u = e1.adjoint([], c), [_, d, p] = e1.transformMat3(h, h, e1.transpose(u, u));
            return e1.multiply$1(c, [
                _,
                0,
                0,
                0,
                d,
                0,
                0,
                0,
                p
            ], c);
        }
        class De extends e1.Evented {
            load(t1, i) {
                this._loaded = i || !1, this.fire(new e1.Event("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, e1.getImage(this.map._requestManager.transformRequest(this.url, e1.ResourceType.Image), (i, o)=>{
                    if (this._loaded = !0, i) this.fire(new e1.ErrorEvent(i));
                    else if (o) {
                        const { HTMLImageElement: i } = e1.window;
                        this.image = o instanceof i ? e1.exported.getImageData(o) : o, this.width = this.image.width, this.height = this.image.height, t1 && (this.coordinates = t1), this._finishLoading();
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(e1) {
                return this.image && e1.url ? (this.options.url = e1.url, this.load(e1.coordinates, this._loaded), this) : this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new e1.Event("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove() {
                this.texture && this.texture.destroy();
            }
            setCoordinates(t1) {
                this.coordinates = t1, this._boundsArray = void 0;
                const i = t1.map(e1.MercatorCoordinate.fromLngLat);
                return this.tileID = function(t1) {
                    let i = 1 / 0, o = 1 / 0, r = -1 / 0, n = -1 / 0;
                    for (const e1 of t1)i = Math.min(i, e1.x), o = Math.min(o, e1.y), r = Math.max(r, e1.x), n = Math.max(n, e1.y);
                    const a = Math.max(r - i, n - o), s = Math.max(0, Math.floor(-Math.log(a) / Math.LN2)), l = Math.pow(2, s);
                    return new e1.CanonicalTileID(s, Math.floor((i + r) / 2 * l), Math.floor((o + n) / 2 * l));
                }(i), this.minzoom = this.maxzoom = this.tileID.z, this.fire(new e1.Event("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            _clear() {
                this._boundsArray = void 0;
            }
            _prepareData(t1) {
                for(const e1 in this.tiles){
                    const t1 = this.tiles[e1];
                    "loaded" !== t1.state && (t1.state = "loaded", t1.texture = this.texture);
                }
                if (this._boundsArray) return;
                const i = e1.tileTransform(this.tileID, this.map.transform.projection), [o, r, n, a] = this.coordinates.map((t1)=>{
                    const o = i.projection.project(t1[0], t1[1]);
                    return e1.getTilePoint(i, o)._round();
                });
                this.perspectiveTransform = function(t1, i, o, r, n, a, s, l, c, h) {
                    const u = ze(0, 0, t1, 0, 0, i, t1, i), _ = ze(o, r, n, a, s, l, c, h);
                    return e1.multiply$1(_, e1.adjoint(u, u), _), [
                        _[6] / _[8] * t1 / e1.EXTENT,
                        _[7] / _[8] * i / e1.EXTENT
                    ];
                }(this.width, this.height, o.x, o.y, r.x, r.y, a.x, a.y, n.x, n.y);
                const s = this._boundsArray = new e1.StructArrayLayout4i8;
                s.emplaceBack(o.x, o.y, 0, 0), s.emplaceBack(r.x, r.y, e1.EXTENT, 0), s.emplaceBack(a.x, a.y, 0, e1.EXTENT), s.emplaceBack(n.x, n.y, e1.EXTENT, e1.EXTENT), this.boundsBuffer && this.boundsBuffer.destroy(), this.boundsBuffer = t1.createVertexBuffer(s, e1.boundsAttributes.members), this.boundsSegments = e1.SegmentVector.simpleSegment(0, 0, 4, 2);
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || !this.image) return;
                const t1 = this.map.painter.context, i = t1.gl;
                this.texture ? this.texture.update(this.image) : (this.texture = new e1.Texture(t1, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE)), this._prepareData(t1);
            }
            loadTile(e1, t1) {
                this.tileID && this.tileID.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}, t1(null)) : (e1.state = "errored", t1(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            constructor(e1, t1, i, o){
                super(), this.id = e1, this.dispatcher = i, this.coordinates = t1.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(o), this.options = t1;
            }
        }
        const Pe = {
            vector: class extends e1.Evented {
                load(t1) {
                    this._loaded = !1, this.fire(new e1.Event("dataloading", {
                        dataType: "source"
                    }));
                    const i = this.language || this.map._language, o = this.worldview || this.map._worldview;
                    this._tileJSONRequest = F(this._options, this.map._requestManager, i, o, (r, n)=>{
                        this._tileJSONRequest = null, this._loaded = !0, r ? (i && console.warn(`Ensure that your requested language string is a valid BCP-47 code. Found: ${i}`), o && 2 !== o.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e1.ErrorEvent(r))) : n && (e1.extend(this, n), n.bounds && (this.tileBounds = new U(n.bounds, this.minzoom, this.maxzoom)), e1.postTurnstileEvent(n.tiles, this.map._requestManager._customAccessToken), this.fire(new e1.Event("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e1.Event("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }))), t1 && t1(r);
                    });
                }
                loaded() {
                    return this._loaded;
                }
                hasTile(e1) {
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                onAdd(e1) {
                    this.map = e1, this.load();
                }
                setSourceProperty(e1) {
                    this._tileJSONRequest && this._tileJSONRequest.cancel(), e1(), this.load(()=>{
                        const e1 = this.map.style._getSourceCaches(this.id);
                        for (const t1 of e1)t1.clearTiles();
                    });
                }
                setTiles(e1) {
                    return this.setSourceProperty(()=>{
                        this._options.tiles = e1;
                    }), this;
                }
                setUrl(e1) {
                    return this.setSourceProperty(()=>{
                        this.url = e1, this._options.url = e1;
                    }), this;
                }
                _setLanguage(e1) {
                    return e1 === this.language || this.setSourceProperty(()=>{
                        this.language = e1;
                    }), this;
                }
                _setWorldview(e1) {
                    return e1 === this.worldview ? this : this.worldviewOptions && e1 && !this.worldviewOptions[e1] ? (console.warn(`Vector tile source "${this.id}" does not support worldview "${e1}".`), this) : (this.setSourceProperty(()=>{
                        this.worldview = e1;
                    }), this);
                }
                onRemove() {
                    this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                }
                serialize() {
                    return e1.extend({}, this._options);
                }
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme)), r = {
                        request: this.map._requestManager.transformRequest(o, e1.ResourceType.Tile),
                        data: void 0,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        pixelRatio: e1.exported.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        isSymbolTile: t1.isSymbolTile
                    };
                    if (r.request.collectResourceTiming = this._collectResourceTiming, t1.actor && "expired" !== t1.state) "loading" === t1.state ? t1.reloadCallback = i : t1.request = t1.actor.send("reloadTile", r, n.bind(this));
                    else if (t1.actor = this._tileWorkers[o] = this._tileWorkers[o] || this.dispatcher.getActor(), this.dispatcher.ready) t1.request = t1.actor.send("loadTile", r, n.bind(this), void 0, !0);
                    else {
                        const i = e1.loadVectorTile.call({
                            deduped: this._deduped
                        }, r, (e1, i)=>{
                            e1 || !i ? n.call(this, e1) : (r.data = {
                                cacheControl: i.cacheControl,
                                expires: i.expires,
                                rawData: i.rawData.slice(0)
                            }, t1.actor && t1.actor.send("loadTile", r, n.bind(this), void 0, !0));
                        }, !0);
                        t1.request = {
                            cancel: i
                        };
                    }
                    function n(o, r) {
                        return delete t1.request, t1.aborted ? i(null) : o && 404 !== o.status ? i(o) : (r && r.resourceTiming && (t1.resourceTiming = r.resourceTiming), this.map._refreshExpiredTiles && r && t1.setExpiryData(r), t1.loadVectorData(r, this.map.painter), e1.cacheEntryPossiblyAdded(this.dispatcher), i(null), void (t1.reloadCallback && (this.loadTile(t1, t1.reloadCallback), t1.reloadCallback = null)));
                    }
                }
                abortTile(e1) {
                    e1.request && (e1.request.cancel(), delete e1.request), e1.actor && e1.actor.send("abortTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id
                    });
                }
                unloadTile(e1) {
                    e1.unloadVectorData(), e1.actor && e1.actor.send("removeTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id
                    });
                }
                hasTransition() {
                    return !1;
                }
                afterUpdate() {
                    this._tileWorkers = {};
                }
                constructor(t1, i, o, r){
                    if (super(), this.id = t1, this.dispatcher = o, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, e1.extend(this, e1.pick(i, [
                        "url",
                        "scheme",
                        "tileSize",
                        "promoteId"
                    ])), this._options = e1.extend({
                        type: "vector"
                    }, i), this._collectResourceTiming = i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                    this.setEventedParent(r), this._tileWorkers = {}, this._deduped = new e1.DedupedRequest;
                }
            },
            raster: Me,
            "raster-dem": class extends Me {
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    function r(e1, o) {
                        e1 && (t1.state = "errored", i(e1)), o && (t1.dem = o, t1.dem.onDeserialize(), t1.needsHillshadePrepare = !0, t1.needsDEMTextureUpload = !0, t1.state = "loaded", i(null));
                    }
                    t1.request = e1.getImage(this.map._requestManager.transformRequest(o, e1.ResourceType.Tile), (function(o, n, a, s) {
                        if (delete t1.request, t1.aborted) t1.state = "unloaded", i(null);
                        else if (o) t1.state = "errored", i(o);
                        else if (n) {
                            this.map._refreshExpiredTiles && t1.setExpiryData({
                                cacheControl: a,
                                expires: s
                            });
                            const i = e1.window.ImageBitmap && n instanceof e1.window.ImageBitmap && (null == Se && (Se = e1.window.OffscreenCanvas && new e1.window.OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof e1.window.createImageBitmap), Se), o = 1 - (n.width - e1.prevPowerOfTwo(n.width)) / 2;
                            o < 1 || t1.neighboringTiles || (t1.neighboringTiles = this._getNeighboringTiles(t1.tileID));
                            const l = i ? n : e1.exported.getImageData(n, o), c = {
                                uid: t1.uid,
                                coord: t1.tileID,
                                source: this.id,
                                rawImageData: l,
                                encoding: this.encoding,
                                padding: o
                            };
                            t1.actor && "expired" !== t1.state || (t1.actor = this.dispatcher.getActor(), t1.actor.send("loadDEMTile", c, r.bind(this), void 0, !0));
                        }
                    }).bind(this));
                }
                _getNeighboringTiles(t1) {
                    const i = t1.canonical, o = Math.pow(2, i.z), r = (i.x - 1 + o) % o, n = 0 === i.x ? t1.wrap - 1 : t1.wrap, a = (i.x + 1 + o) % o, s = i.x + 1 === o ? t1.wrap + 1 : t1.wrap, l = {};
                    return l[new e1.OverscaledTileID(t1.overscaledZ, n, i.z, r, i.y).key] = {
                        backfilled: !1
                    }, l[new e1.OverscaledTileID(t1.overscaledZ, s, i.z, a, i.y).key] = {
                        backfilled: !1
                    }, i.y > 0 && (l[new e1.OverscaledTileID(t1.overscaledZ, n, i.z, r, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e1.OverscaledTileID(t1.overscaledZ, t1.wrap, i.z, i.x, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e1.OverscaledTileID(t1.overscaledZ, s, i.z, a, i.y - 1).key] = {
                        backfilled: !1
                    }), i.y + 1 < o && (l[new e1.OverscaledTileID(t1.overscaledZ, n, i.z, r, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e1.OverscaledTileID(t1.overscaledZ, t1.wrap, i.z, i.x, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e1.OverscaledTileID(t1.overscaledZ, s, i.z, a, i.y + 1).key] = {
                        backfilled: !1
                    }), l;
                }
                unloadTile(e1) {
                    e1.demTexture && this.map.painter.saveTileTexture(e1.demTexture), e1.fbo && (e1.fbo.destroy(), delete e1.fbo), e1.dem && delete e1.dem, delete e1.neighboringTiles, e1.state = "unloaded";
                }
                constructor(t1, i, o, r){
                    super(t1, i, o, r), this.type = "raster-dem", this.maxzoom = 22, this._options = e1.extend({
                        type: "raster-dem"
                    }, i), this.encoding = i.encoding || "mapbox";
                }
            },
            geojson: class extends e1.Evented {
                onAdd(e1) {
                    this.map = e1, this.setData(this._data);
                }
                setData(e1) {
                    return this._data = e1, this._updateWorkerData(), this;
                }
                getClusterExpansionZoom(e1, t1) {
                    return this.actor.send("geojson.getClusterExpansionZoom", {
                        clusterId: e1,
                        source: this.id
                    }, t1), this;
                }
                getClusterChildren(e1, t1) {
                    return this.actor.send("geojson.getClusterChildren", {
                        clusterId: e1,
                        source: this.id
                    }, t1), this;
                }
                getClusterLeaves(e1, t1, i, o) {
                    return this.actor.send("geojson.getClusterLeaves", {
                        source: this.id,
                        clusterId: e1,
                        limit: t1,
                        offset: i
                    }, o), this;
                }
                _updateWorkerData() {
                    if (this._pendingLoad) return void (this._coalesce = !0);
                    this.fire(new e1.Event("dataloading", {
                        dataType: "source"
                    })), this._loaded = !1;
                    const t1 = e1.extend({}, this.workerOptions), i = this._data;
                    "string" == typeof i ? (t1.request = this.map._requestManager.transformRequest(e1.exported.resolveURL(i), e1.ResourceType.Source), t1.request.collectResourceTiming = this._collectResourceTiming) : t1.data = JSON.stringify(i), this._pendingLoad = this.actor.send(`${this.type}.loadData`, t1, (t1, i)=>{
                        if (this._loaded = !0, this._pendingLoad = null, t1) this.fire(new e1.ErrorEvent(t1));
                        else {
                            const t1 = {
                                dataType: "source",
                                sourceDataType: this._metadataFired ? "content" : "metadata"
                            };
                            this._collectResourceTiming && i && i.resourceTiming && i.resourceTiming[this.id] && (t1.resourceTiming = i.resourceTiming[this.id]), this.fire(new e1.Event("data", t1)), this._metadataFired = !0;
                        }
                        this._coalesce && (this._updateWorkerData(), this._coalesce = !1);
                    });
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(t1, i) {
                    const o = t1.actor ? "reloadTile" : "loadTile";
                    t1.actor = this.actor, t1.request = this.actor.send(o, {
                        type: this.type,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        pixelRatio: e1.exported.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId
                    }, (e1, r)=>(delete t1.request, t1.unloadVectorData(), t1.aborted ? i(null) : e1 ? i(e1) : (t1.loadVectorData(r, this.map.painter, "reloadTile" === o), i(null))), void 0, "loadTile" === o);
                }
                abortTile(e1) {
                    e1.request && (e1.request.cancel(), delete e1.request), e1.aborted = !0;
                }
                unloadTile(e1) {
                    e1.unloadVectorData(), this.actor.send("removeTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id
                    });
                }
                onRemove() {
                    this._pendingLoad && this._pendingLoad.cancel();
                }
                serialize() {
                    return e1.extend({}, this._options, {
                        type: this.type,
                        data: this._data
                    });
                }
                hasTransition() {
                    return !1;
                }
                constructor(t1, i, o, r){
                    super(), this.id = t1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = o.getActor(), this.setEventedParent(r), this._data = i.data, this._options = e1.extend({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                    const n = e1.EXTENT / this.tileSize;
                    this.workerOptions = e1.extend({
                        source: this.id,
                        cluster: i.cluster || !1,
                        geojsonVtOptions: {
                            buffer: (void 0 !== i.buffer ? i.buffer : 128) * n,
                            tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * n,
                            extent: e1.EXTENT,
                            maxZoom: this.maxzoom,
                            lineMetrics: i.lineMetrics || !1,
                            generateId: i.generateId || !1
                        },
                        superclusterOptions: {
                            maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                            minPoints: Math.max(2, i.clusterMinPoints || 2),
                            extent: e1.EXTENT,
                            radius: (void 0 !== i.clusterRadius ? i.clusterRadius : 50) * n,
                            log: !1,
                            generateId: i.generateId || !1
                        },
                        clusterProperties: i.clusterProperties,
                        filter: i.filter
                    }, i.workerOptions);
                }
            },
            video: class extends De {
                load() {
                    this._loaded = !1;
                    const t1 = this.options;
                    this.urls = [];
                    for (const i of t1.urls)this.urls.push(this.map._requestManager.transformRequest(i, e1.ResourceType.Source).url);
                    e1.getVideo(this.urls, (t1, i)=>{
                        this._loaded = !0, t1 ? this.fire(new e1.ErrorEvent(t1)) : i && (this.video = i, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading());
                    });
                }
                pause() {
                    this.video && this.video.pause();
                }
                play() {
                    this.video && this.video.play();
                }
                seek(t1) {
                    if (this.video) {
                        const i = this.video.seekable;
                        t1 < i.start(0) || t1 > i.end(0) ? this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = t1;
                    }
                }
                getVideo() {
                    return this.video;
                }
                onAdd(e1) {
                    this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                }
                prepare() {
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const t1 = this.map.painter.context, i = t1.gl;
                    this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new e1.Texture(t1, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t1);
                }
                serialize() {
                    return {
                        type: "video",
                        urls: this.urls,
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this.video && !this.video.paused;
                }
                constructor(e1, t1, i, o){
                    super(e1, t1, i, o), this.roundZoom = !0, this.type = "video", this.options = t1;
                }
            },
            image: De,
            canvas: class extends De {
                load() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof e1.window.HTMLCanvasElement ? this.options.canvas : e1.window.document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e1.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }
                getCanvas() {
                    return this.canvas;
                }
                onAdd(e1) {
                    this.map = e1, this.load(), this.canvas && this.animate && this.play();
                }
                onRemove() {
                    this.pause();
                }
                prepare() {
                    let t1 = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, t1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t1 = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const i = this.map.painter.context;
                    this.texture ? (t1 || this._playing) && this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new e1.Texture(i, this.canvas, i.gl.RGBA, {
                        premultiply: !0
                    }), this._prepareData(i);
                }
                serialize() {
                    return {
                        type: "canvas",
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this._playing;
                }
                _hasInvalidDimensions() {
                    for (const e1 of [
                        this.canvas.width,
                        this.canvas.height
                    ])if (isNaN(e1) || e1 <= 0) return !0;
                    return !1;
                }
                constructor(t1, i, o, r){
                    super(t1, i, o, r), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e1)=>!Array.isArray(e1) || 2 !== e1.length || e1.some((e1)=>"number" != typeof e1)) || this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${t1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${t1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${t1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof e1.window.HTMLCanvasElement || this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${t1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e1.ErrorEvent(new e1.ValidationError(`sources.${t1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
                }
            },
            custom: class extends e1.Evented {
                serialize() {
                    return e1.pick(this, [
                        "type",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution"
                    ]);
                }
                load() {
                    this._loaded = !0, this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                loaded() {
                    return this._loaded;
                }
                onAdd(t1) {
                    this._map = t1, this._loaded = !1, this.fire(new e1.Event("dataloading", {
                        dataType: "source"
                    })), this._implementation.onAdd && this._implementation.onAdd(t1), this.load();
                }
                onRemove(e1) {
                    this._implementation.onRemove && this._implementation.onRemove(e1);
                }
                hasTile(e1) {
                    if (this._implementation.hasTile) {
                        const { x: t1, y: i, z: o } = e1.canonical;
                        return this._implementation.hasTile({
                            x: t1,
                            y: i,
                            z: o
                        });
                    }
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                loadTile(t1, i) {
                    const { x: o, y: r, z: n } = t1.tileID.canonical, a = new e1.window.AbortController, s = this._implementation.loadTile({
                        x: o,
                        y: r,
                        z: n
                    }, {
                        signal: a.signal
                    });
                    if (!s) return this.loadTileData(t1, {
                        width: this.tileSize,
                        height: this.tileSize,
                        data: null
                    }), t1.state = "loaded", i(null);
                    s.cancel = ()=>a.abort(), t1.request = s.then((function(o) {
                        return delete t1.request, t1.aborted ? (t1.state = "unloaded", i(null)) : o ? function(t1) {
                            return t1 instanceof e1.window.ImageData || t1 instanceof e1.window.ImageBitmap || t1 instanceof e1.window.HTMLCanvasElement;
                        }(o) ? (this.loadTileData(t1, o), t1.state = "loaded", void i(null)) : (t1.state = "errored", i(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`))) : (this.loadTileData(t1, {
                            width: this.tileSize,
                            height: this.tileSize,
                            data: null
                        }), t1.state = "loaded", i(null));
                    }).bind(this)).catch((e1)=>{
                        20 !== e1.code && (t1.state = "errored", i(e1));
                    });
                }
                loadTileData(e1, t1) {
                    Me.loadTileData(e1, t1, this._map.painter);
                }
                unloadTileData(e1) {
                    Me.unloadTileData(e1, this._map.painter);
                }
                prepareTile(e1) {
                    if (!this._implementation.prepareTile) return null;
                    const { x: t1, y: i, z: o } = e1.tileID.canonical, r = this._implementation.prepareTile({
                        x: t1,
                        y: i,
                        z: o
                    });
                    return r ? (this.loadTileData(e1, r), e1.state = "loaded", r) : null;
                }
                unloadTile(e1, t1) {
                    if (this.unloadTileData(e1), this._implementation.unloadTile) {
                        const { x: t1, y: i, z: o } = e1.tileID.canonical;
                        this._implementation.unloadTile({
                            x: t1,
                            y: i,
                            z: o
                        });
                    }
                    t1();
                }
                abortTile(e1, t1) {
                    e1.request && e1.request.cancel && (e1.request.cancel(), delete e1.request), t1();
                }
                hasTransition() {
                    return !1;
                }
                _coveringTiles() {
                    return this._map.transform.coveringTiles({
                        tileSize: this.tileSize,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom,
                        roundZoom: this.roundZoom
                    }).map((e1)=>({
                            x: e1.canonical.x,
                            y: e1.canonical.y,
                            z: e1.canonical.z
                        }));
                }
                _update() {
                    this.fire(new e1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                constructor(t1, i, o, r){
                    super(), this.id = t1, this.type = "custom", this._dataType = "raster", this._dispatcher = o, this._implementation = i, this.setEventedParent(r), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new e1.ErrorEvent(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e1.ErrorEvent(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new U(this._implementation.bounds, this.minzoom, this.maxzoom)), i.update = this._update.bind(this), i.coveringTiles = this._coveringTiles.bind(this), e1.extend(this, e1.pick(i, [
                        "dataType",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution",
                        "minTileCacheSize",
                        "maxTileCacheSize"
                    ]));
                }
            }
        }, Ae = function(t1, i, o, r) {
            const n = new Pe[i.type](t1, i, o, r);
            if (n.id !== t1) throw new Error(`Expected Source id to be ${t1} instead of ${n.id}`);
            return e1.bindAll([
                "load",
                "abort",
                "unload",
                "serialize",
                "prepare"
            ], n), n;
        };
        function Le(t1, i) {
            const o = e1.identity([]);
            return e1.scale(o, o, [
                .5 * t1.width,
                .5 * -t1.height,
                1
            ]), e1.translate(o, o, [
                1,
                -1,
                0
            ]), e1.multiply(o, o, t1.calculateProjMatrix(i.toUnwrapped())), Float32Array.from(o);
        }
        function Re(e1, t1, i, o, r, n, a, s = !1) {
            const l = e1.tilesIn(o, a, s);
            l.sort(Be);
            const c = [];
            for (const o of l)c.push({
                wrappedTileID: o.tile.tileID.wrapped().key,
                queryResults: o.tile.queryRenderedFeatures(t1, i, e1._state, o, r, n, Le(e1.transform, o.tile.tileID), s)
            });
            const h = function(e1) {
                const t1 = {}, i = {};
                for (const o of e1){
                    const e1 = o.queryResults, r = o.wrappedTileID, n = i[r] = i[r] || {};
                    for(const i in e1){
                        const o = e1[i], r = n[i] = n[i] || {}, a = t1[i] = t1[i] || [];
                        for (const e1 of o)r[e1.featureIndex] || (r[e1.featureIndex] = !0, a.push(e1));
                    }
                }
                return t1;
            }(c);
            for(const t1 in h)h[t1].forEach((t1)=>{
                const i = t1.feature, o = i.layer;
                o && "background" !== o.type && "sky" !== o.type && (i.source = o.source, o["source-layer"] && (i.sourceLayer = o["source-layer"]), i.state = void 0 !== i.id ? e1.getFeatureState(o["source-layer"], i.id) : {});
            });
            return h;
        }
        function Oe(e1, t1) {
            const i = e1.getRenderableIds().map((t1)=>e1.getTileByID(t1)), o = [], r = {};
            for(let e1 = 0; e1 < i.length; e1++){
                const n = i[e1], a = n.tileID.canonical.key;
                r[a] || (r[a] = !0, n.querySourceFeatures(o, t1));
            }
            return o;
        }
        function Be(e1, t1) {
            const i = e1.tileID, o = t1.tileID;
            return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
        }
        function ke() {
            return null != gn.workerClass ? new gn.workerClass : new e1.window.Worker(gn.workerUrl);
        }
        const Fe = "mapboxgl_preloaded_worker_pool";
        class Ue {
            acquire(e1) {
                if (!this.workers) for(this.workers = []; this.workers.length < Ue.workerCount;)this.workers.push(new ke);
                return this.active[e1] = !0, this.workers.slice();
            }
            release(e1) {
                delete this.active[e1], 0 === this.numActive() && (this.workers.forEach((e1)=>{
                    e1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[Fe];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
            constructor(){
                this.active = {};
            }
        }
        let Ne;
        function Ge() {
            return Ne || (Ne = new Ue), Ne;
        }
        function je(t1, i) {
            const o = {};
            for(const e1 in t1)"ref" !== e1 && (o[e1] = t1[e1]);
            return e1.refProperties.forEach((e1)=>{
                e1 in i && (o[e1] = i[e1]);
            }), o;
        }
        function Ze(e1) {
            e1 = e1.slice();
            const t1 = Object.create(null);
            for(let i = 0; i < e1.length; i++)t1[e1[i].id] = e1[i];
            for(let i = 0; i < e1.length; i++)"ref" in e1[i] && (e1[i] = je(e1[i], t1[e1[i].ref]));
            return e1;
        }
        Ue.workerCount = 2;
        const Ve = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight",
            setTerrain: "setTerrain",
            setFog: "setFog",
            setProjection: "setProjection"
        };
        function We(e1, t1, i) {
            i.push({
                command: Ve.addSource,
                args: [
                    e1,
                    t1[e1]
                ]
            });
        }
        function Xe(e1, t1, i) {
            t1.push({
                command: Ve.removeSource,
                args: [
                    e1
                ]
            }), i[e1] = !0;
        }
        function qe(e1, t1, i, o) {
            Xe(e1, i, o), We(e1, t1, i);
        }
        function $e(e1, i, o) {
            let r;
            for(r in e1[o])if (e1[o].hasOwnProperty(r) && "data" !== r && !t1(e1[o][r], i[o][r])) return !1;
            for(r in i[o])if (i[o].hasOwnProperty(r) && "data" !== r && !t1(e1[o][r], i[o][r])) return !1;
            return !0;
        }
        function He(e1, i, o, r, n, a) {
            let s;
            for(s in i = i || {}, e1 = e1 || {})e1.hasOwnProperty(s) && (t1(e1[s], i[s]) || o.push({
                command: a,
                args: [
                    r,
                    s,
                    i[s],
                    n
                ]
            }));
            for(s in i)i.hasOwnProperty(s) && !e1.hasOwnProperty(s) && (t1(e1[s], i[s]) || o.push({
                command: a,
                args: [
                    r,
                    s,
                    i[s],
                    n
                ]
            }));
        }
        function Ye(e1) {
            return e1.id;
        }
        function Ke(e1, t1) {
            return e1[t1.id] = t1, e1;
        }
        class Je {
            reset(e1, t1) {
                this.points = e1 || [], this._distances = [
                    0
                ];
                for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(t1) {
                if (1 === this.points.length) return this.points[0];
                t1 = e1.clamp(t1, 0, 1);
                let i = 1, o = this._distances[i];
                const r = t1 * this.paddedLength + this.padding;
                for(; o < r && i < this._distances.length;)o = this._distances[++i];
                const n = i - 1, a = this._distances[n], s = o - a, l = s > 0 ? (r - a) / s : 0;
                return this.points[n].mult(1 - l).add(this.points[i].mult(l));
            }
            constructor(e1, t1){
                this.reset(e1, t1);
            }
        }
        class Qe {
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e1, t1, i, o, r) {
                this._forEachCell(t1, i, o, r, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t1), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(r);
            }
            insertCircle(e1, t1, i, o) {
                this._forEachCell(t1 - o, i - o, t1 + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t1), this.circles.push(i), this.circles.push(o);
            }
            _insertBoxCell(e1, t1, i, o, r, n) {
                this.boxCells[r].push(n);
            }
            _insertCircleCell(e1, t1, i, o, r, n) {
                this.circleCells[r].push(n);
            }
            _query(e1, t1, i, o, r, n) {
                if (i < 0 || e1 > this.width || o < 0 || t1 > this.height) return !r && [];
                const a = [];
                if (e1 <= 0 && t1 <= 0 && this.width <= i && this.height <= o) {
                    if (r) return !0;
                    for(let e1 = 0; e1 < this.boxKeys.length; e1++)a.push({
                        key: this.boxKeys[e1],
                        x1: this.bboxes[4 * e1],
                        y1: this.bboxes[4 * e1 + 1],
                        x2: this.bboxes[4 * e1 + 2],
                        y2: this.bboxes[4 * e1 + 3]
                    });
                    for(let e1 = 0; e1 < this.circleKeys.length; e1++){
                        const t1 = this.circles[3 * e1], i = this.circles[3 * e1 + 1], o = this.circles[3 * e1 + 2];
                        a.push({
                            key: this.circleKeys[e1],
                            x1: t1 - o,
                            y1: i - o,
                            x2: t1 + o,
                            y2: i + o
                        });
                    }
                    return n ? a.filter(n) : a;
                }
                return this._forEachCell(e1, t1, i, o, this._queryCell, a, {
                    hitTest: r,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, n), r ? a.length > 0 : a;
            }
            _queryCircle(e1, t1, i, o, r) {
                const n = e1 - i, a = e1 + i, s = t1 - i, l = t1 + i;
                if (a < 0 || n > this.width || l < 0 || s > this.height) return !o && [];
                const c = [];
                return this._forEachCell(n, s, a, l, this._queryCellCircle, c, {
                    hitTest: o,
                    circle: {
                        x: e1,
                        y: t1,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r), o ? c.length > 0 : c;
            }
            query(e1, t1, i, o, r) {
                return this._query(e1, t1, i, o, !1, r);
            }
            hitTest(e1, t1, i, o, r) {
                return this._query(e1, t1, i, o, !0, r);
            }
            hitTestCircle(e1, t1, i, o) {
                return this._queryCircle(e1, t1, i, !0, o);
            }
            _queryCell(e1, t1, i, o, r, n, a, s) {
                const l = a.seenUids, c = this.boxCells[r];
                if (null !== c) {
                    const r = this.bboxes;
                    for (const h of c)if (!l.box[h]) {
                        l.box[h] = !0;
                        const c = 4 * h;
                        if (e1 <= r[c + 2] && t1 <= r[c + 3] && i >= r[c + 0] && o >= r[c + 1] && (!s || s(this.boxKeys[h]))) {
                            if (a.hitTest) return n.push(!0), !0;
                            n.push({
                                key: this.boxKeys[h],
                                x1: r[c],
                                y1: r[c + 1],
                                x2: r[c + 2],
                                y2: r[c + 3]
                            });
                        }
                    }
                }
                const h = this.circleCells[r];
                if (null !== h) {
                    const r = this.circles;
                    for (const c of h)if (!l.circle[c]) {
                        l.circle[c] = !0;
                        const h = 3 * c;
                        if (this._circleAndRectCollide(r[h], r[h + 1], r[h + 2], e1, t1, i, o) && (!s || s(this.circleKeys[c]))) {
                            if (a.hitTest) return n.push(!0), !0;
                            {
                                const e1 = r[h], t1 = r[h + 1], i = r[h + 2];
                                n.push({
                                    key: this.circleKeys[c],
                                    x1: e1 - i,
                                    y1: t1 - i,
                                    x2: e1 + i,
                                    y2: t1 + i
                                });
                            }
                        }
                    }
                }
            }
            _queryCellCircle(e1, t1, i, o, r, n, a, s) {
                const l = a.circle, c = a.seenUids, h = this.boxCells[r];
                if (null !== h) {
                    const e1 = this.bboxes;
                    for (const t1 of h)if (!c.box[t1]) {
                        c.box[t1] = !0;
                        const i = 4 * t1;
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e1[i + 0], e1[i + 1], e1[i + 2], e1[i + 3]) && (!s || s(this.boxKeys[t1]))) return n.push(!0), !0;
                    }
                }
                const u = this.circleCells[r];
                if (null !== u) {
                    const e1 = this.circles;
                    for (const t1 of u)if (!c.circle[t1]) {
                        c.circle[t1] = !0;
                        const i = 3 * t1;
                        if (this._circlesCollide(e1[i], e1[i + 1], e1[i + 2], l.x, l.y, l.radius) && (!s || s(this.circleKeys[t1]))) return n.push(!0), !0;
                    }
                }
            }
            _forEachCell(e1, t1, i, o, r, n, a, s) {
                const l = this._convertToXCellCoord(e1), c = this._convertToYCellCoord(t1), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(o);
                for(let _ = l; _ <= h; _++)for(let l = c; l <= u; l++)if (r.call(this, e1, t1, i, o, this.xCellCount * l + _, n, a, s)) return;
            }
            _convertToXCellCoord(e1) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
            }
            _convertToYCellCoord(e1) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
            }
            _circlesCollide(e1, t1, i, o, r, n) {
                const a = o - e1, s = r - t1, l = i + n;
                return l * l > a * a + s * s;
            }
            _circleAndRectCollide(e1, t1, i, o, r, n, a) {
                const s = (n - o) / 2, l = Math.abs(e1 - (o + s));
                if (l > s + i) return !1;
                const c = (a - r) / 2, h = Math.abs(t1 - (r + c));
                if (h > c + i) return !1;
                if (l <= s || h <= c) return !0;
                const u = l - s, _ = h - c;
                return u * u + _ * _ <= i * i;
            }
            constructor(e1, t1, i){
                const o = this.boxCells = [], r = this.circleCells = [];
                this.xCellCount = Math.ceil(e1 / i), this.yCellCount = Math.ceil(t1 / i);
                for(let e1 = 0; e1 < this.xCellCount * this.yCellCount; e1++)o.push([]), r.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t1, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t1, this.boxUid = 0, this.circleUid = 0;
            }
        }
        const et = Math.tan(85 * Math.PI / 180);
        function tt(t1, i, o, r, n, a, s) {
            const l = e1.create();
            if (o) {
                if ("globe" === a.name) {
                    const t1 = e1.calculateGlobeLabelMatrix(n, i);
                    e1.multiply(l, l, t1);
                } else {
                    const t1 = v([], s);
                    l[0] = t1[0], l[1] = t1[1], l[4] = t1[2], l[5] = t1[3], r || e1.rotateZ(l, l, n.angle);
                }
            } else e1.multiply(l, n.labelPlaneMatrix, t1);
            return l;
        }
        function it(e1, t1, i, o, r, n, a) {
            const s = tt(e1, t1, i, o, r, n, a);
            return "globe" === n.name && i || (s[2] = s[6] = s[10] = s[14] = 0), s;
        }
        function ot(t1, i, o, r, n, a, s) {
            if (o) {
                if ("globe" === a.name) {
                    const l = tt(t1, i, o, r, n, a, s);
                    return e1.invert(l, l), e1.multiply(l, t1, l), l;
                }
                {
                    const i = e1.clone(t1), o = e1.identity([]);
                    return o[0] = s[0], o[1] = s[1], o[4] = s[2], o[5] = s[3], e1.multiply(i, i, o), r || e1.rotateZ(i, i, -n.angle), i;
                }
            }
            return n.glCoordMatrix;
        }
        function rt(t1, i, o = 0) {
            const r = [
                t1.x,
                t1.y,
                o,
                1
            ];
            o ? e1.transformMat4$1(r, r, i) : gt(r, r, i);
            const n = r[3];
            return {
                point: [
                    r[0] / n,
                    r[1] / n,
                    r[2] / n
                ],
                signedDistanceFromCamera: n
            };
        }
        function nt(t1, i) {
            const o = [
                t1[0],
                t1[1],
                t1[2],
                1
            ];
            e1.transformMat4$1(o, o, i);
            const r = o[3];
            return {
                point: [
                    o[0] / r,
                    o[1] / r,
                    o[2] / r
                ],
                signedDistanceFromCamera: r
            };
        }
        function at(e1, t1) {
            return Math.min(.5 + e1 / t1 * .5, 1.5);
        }
        function st(e1, t1) {
            const i = e1[0] / e1[3], o = e1[1] / e1[3];
            return i >= -t1[0] && i <= t1[0] && o >= -t1[1] && o <= t1[1];
        }
        function lt(t1, i, o, r, n, a, s, l, c, h) {
            const u = o.transform, _ = r ? t1.textSizeData : t1.iconSizeData, d = e1.evaluateSizeForZoom(_, o.transform.zoom), p = "globe" === u.projection.name, m = [
                256 / o.width * 2 + 1,
                256 / o.height * 2 + 1
            ], f = r ? t1.text.dynamicLayoutVertexArray : t1.icon.dynamicLayoutVertexArray;
            f.clear();
            let g = null;
            p && (g = r ? t1.text.globeExtVertexArray : t1.icon.globeExtVertexArray);
            const v = t1.lineVertexArray, x = r ? t1.text.placedSymbolArray : t1.icon.placedSymbolArray, y = o.transform.width / o.transform.height;
            let b = !1;
            for(let r = 0; r < x.length; r++){
                const p = x.get(r);
                if (p.writingMode !== e1.WritingMode.vertical || b || 0 !== r && x.get(r - 1).writingMode === e1.WritingMode.horizontal || (b = !0), (p.hidden || p.writingMode === e1.WritingMode.vertical) && !b) {
                    ft(p.numGlyphs, f);
                    continue;
                }
                b = !1;
                const w = new e1.pointGeometry(p.tileAnchorX, p.tileAnchorY), T = c ? c(w) : [
                    0,
                    0,
                    0
                ], E = u.projection.projectTilePoint(w.x, w.y, h.canonical), C = [
                    E.x + T[0],
                    E.y + T[1],
                    E.z + T[2]
                ], I = [
                    ...C,
                    1
                ];
                if (e1.transformMat4$1(I, I, i), !st(I, m)) {
                    ft(p.numGlyphs, f);
                    continue;
                }
                const M = at(o.transform.cameraToCenterDistance, I[3]), S = e1.evaluateSizeForFeature(_, d, p), z = s ? S / M : S * M, D = rt(new e1.pointGeometry(C[0], C[1]), n, C[2]);
                if (D.signedDistanceFromCamera <= 0) {
                    ft(p.numGlyphs, f);
                    continue;
                }
                let P = {};
                const A = s ? null : c, L = ut(p, z, !1, l, i, n, a, t1.glyphOffsetArray, v, f, g, D.point, w, P, y, A, u.projection, h, s);
                b = L.useVertical, A && L.needsFlipping && (P = {}), (L.notEnoughRoom || b || L.needsFlipping && ut(p, z, !0, l, i, n, a, t1.glyphOffsetArray, v, f, g, D.point, w, P, y, A, u.projection, h, s).notEnoughRoom) && ft(p.numGlyphs, f);
            }
            r ? (t1.text.dynamicLayoutVertexBuffer.updateData(f), g && t1.text.globeExtVertexBuffer.updateData(g)) : (t1.icon.dynamicLayoutVertexBuffer.updateData(f), g && t1.icon.globeExtVertexBuffer.updateData(g));
        }
        function ct(e1, t1, i, o, r, n, a, s, l, c, h, u, _, d, p, m) {
            const f = s.glyphStartIndex + s.numGlyphs, g = s.lineStartIndex, v = s.lineStartIndex + s.lineLength, x = t1.getoffsetX(s.glyphStartIndex), y = t1.getoffsetX(f - 1), b = pt(e1 * x, i, o, r, n, a, s.segment, g, v, l, c, h, u, _, !0, d, p, m);
            if (!b) return null;
            const w = pt(e1 * y, i, o, r, n, a, s.segment, g, v, l, c, h, u, _, !0, d, p, m);
            return w ? {
                first: b,
                last: w
            } : null;
        }
        function ht(t1, i, o, r) {
            return t1.writingMode === e1.WritingMode.horizontal && Math.abs(o.y - i.y) > Math.abs(o.x - i.x) * r ? {
                useVertical: !0
            } : t1.writingMode === e1.WritingMode.vertical ? i.y < o.y ? {
                needsFlipping: !0
            } : null : 0 !== t1.flipState && function(e1, t1, i) {
                const o = (t1.x - e1.x) * i;
                return 0 === o || Math.abs((t1.y - e1.y) / o) > et;
            }(i, o, r) ? 1 === t1.flipState ? {
                needsFlipping: !0
            } : null : i.x > o.x ? {
                needsFlipping: !0
            } : null;
        }
        function ut(t1, i, o, r, n, a, s, l, c, h, u, _, d, p, m, f, g, v, x) {
            const y = i / 24, b = t1.lineOffsetX * y, w = t1.lineOffsetY * y;
            let T;
            if (t1.numGlyphs > 1) {
                const i = t1.glyphStartIndex + t1.numGlyphs, n = t1.lineStartIndex, h = t1.lineStartIndex + t1.lineLength, u = ct(y, l, b, w, o, _, d, t1, c, a, p, f, !1, g, v, x);
                if (!u) return {
                    notEnoughRoom: !0
                };
                const E = nt(u.first.point, s).point, C = nt(u.last.point, s).point, I = new e1.pointGeometry(E[0], E[1]), M = new e1.pointGeometry(C[0], C[1]);
                if (r && !o) {
                    const e1 = ht(t1, I, M, m);
                    if (t1.flipState = e1 && e1.needsFlipping ? 1 : 2, e1) return e1;
                }
                T = [
                    u.first
                ];
                for(let e1 = t1.glyphStartIndex + 1; e1 < i - 1; e1++)T.push(pt(y * l.getoffsetX(e1), b, w, o, _, d, t1.segment, n, h, c, a, p, f, !1, !1, g, v, x));
                T.push(u.last);
            } else {
                if (r && !o) {
                    const i = rt(d, n).point, o = t1.lineStartIndex + t1.segment + 1, r = new e1.pointGeometry(c.getx(o), c.gety(o)), a = rt(r, n), s = a.signedDistanceFromCamera > 0 ? a.point : dt(d, r, i, 1, n, void 0, g, v.canonical), l = ht(t1, new e1.pointGeometry(i[0], i[1]), new e1.pointGeometry(s[0], s[1]), m);
                    if (t1.flipState = l && l.needsFlipping ? 1 : 2, l) return l;
                }
                const i = pt(y * l.getoffsetX(t1.glyphStartIndex), b, w, o, _, d, t1.segment, t1.lineStartIndex, t1.lineStartIndex + t1.lineLength, c, a, p, f, !1, !1, g, v, x);
                if (!i) return {
                    notEnoughRoom: !0
                };
                T = [
                    i
                ];
            }
            if (u) for (const t1 of T)e1.updateGlobeVertexNormal(u, h.length + 0, t1.up[0], t1.up[1], t1.up[2]), e1.updateGlobeVertexNormal(u, h.length + 1, t1.up[0], t1.up[1], t1.up[2]), e1.updateGlobeVertexNormal(u, h.length + 2, t1.up[0], t1.up[1], t1.up[2]), e1.updateGlobeVertexNormal(u, h.length + 3, t1.up[0], t1.up[1], t1.up[2]), e1.addDynamicAttributes(h, t1.point[0], t1.point[1], t1.point[2], t1.angle);
            else for (const t1 of T)e1.addDynamicAttributes(h, t1.point[0], t1.point[1], t1.point[2], t1.angle);
            return {};
        }
        function _t(t1, i, o, r, n) {
            const a = r.projectTilePoint(t1.x, t1.y, i);
            if (!n) return rt(a, o, a.z);
            const s = n(t1);
            return rt(new e1.pointGeometry(a.x + s[0], a.y + s[1]), o, a.z + s[2]);
        }
        function dt(t1, i, o, r, n, a, s, l) {
            const c = _t(t1.add(t1.sub(i)._unit()), l, n, s, a).point, h = e1.sub([], o, c);
            return e1.scaleAndAdd([], o, h, r / e1.length(h));
        }
        function pt(t1, i, o, r, n, a, s, l, c, h, u, _, d, p, m, f, g, v) {
            const x = r ? t1 - i : t1 + i;
            let y = x > 0 ? 1 : -1, b = 0;
            r && (y *= -1, b = Math.PI), y < 0 && (b += Math.PI);
            let w = y > 0 ? l + s : l + s + 1, T = n, E = n, C = 0, I = 0;
            const M = Math.abs(x), S = [], z = [];
            let D = a;
            const P = ()=>{
                const t1 = w - y;
                return 0 === C ? a : new e1.pointGeometry(h.getx(t1), h.gety(t1));
            }, A = ()=>dt(P(), D, E, M - C + 1, u, d, f, g.canonical);
            for(; C + I <= M;){
                if (w += y, w < l || w >= c) return null;
                if (E = T, S.push(T), p && z.push(D || P()), T = _[w], void 0 === T) {
                    D = new e1.pointGeometry(h.getx(w), h.gety(w));
                    const t1 = _t(D, g.canonical, u, f, d);
                    T = t1.signedDistanceFromCamera > 0 ? _[w] = t1.point : A();
                } else D = null;
                C += I, I = e1.distance(E, T);
            }
            D = D || new e1.pointGeometry(h.getx(w), h.gety(w));
            const L = P();
            m && d && (_[w] = T = void 0 === _[w] ? T : A(), I = e1.distance(E, T));
            const R = (M - C) / I, O = D.sub(L).mult(R)._add(L), B = e1.sub([], T, E), k = e1.scaleAndAdd([], E, B, R);
            let F = [
                0,
                0,
                1
            ], U = B[0], N = B[1];
            if (v && (F = f.upVector(g.canonical, O.x, O.y), 0 !== F[0] || 0 !== F[1] || 1 !== F[2])) {
                const t1 = [
                    1,
                    0,
                    0
                ], i = [
                    0,
                    1,
                    0
                ];
                t1[0] = F[2], t1[1] = 0, t1[2] = -F[0], e1.cross(i, F, t1), e1.normalize(t1, t1), e1.normalize(i, i), U = e1.dot(B, t1), N = e1.dot(B, i);
            }
            if (o) {
                const t1 = e1.cross([], F, B);
                e1.normalize(t1, t1), e1.scaleAndAdd(k, k, t1, o * y);
            }
            const G = b + Math.atan2(N, U);
            return S.push(k), p && z.push(O), {
                point: k,
                angle: G,
                path: S,
                tilePath: z,
                up: F
            };
        }
        const mt = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function ft(e1, t1) {
            for(let i = 0; i < e1; i++){
                const e1 = t1.length;
                t1.resize(e1 + 4), t1.float32.set(mt, 4 * e1);
            }
        }
        function gt(e1, t1, i) {
            const o = t1[0], r = t1[1];
            return e1[0] = i[0] * o + i[4] * r + i[12], e1[1] = i[1] * o + i[5] * r + i[13], e1[3] = i[3] * o + i[7] * r + i[15], e1;
        }
        const vt = 100;
        class xt {
            placeCollisionBox(e1, t1, i, o, r, n, a, s) {
                let l = i.projectedAnchorX, c = i.projectedAnchorY, h = i.projectedAnchorZ;
                const u = i.elevation, _ = i.tileID;
                if (u && _) {
                    const t1 = e1.getProjection().upVector(_.canonical, i.tileAnchorX, i.tileAnchorY), o = e1.getProjection().upVectorScale(_.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                    l += t1[0] * u * o, c += t1[1] * u * o, h += t1[2] * u * o;
                }
                const d = this.projectAndGetPerspectiveRatio(a, [
                    l,
                    c,
                    h
                ], i.tileID, "globe" === e1.projection.name || !!u || this.transform.pitch > 0, e1.getProjection()), p = n * d.perspectiveRatio, m = (i.x1 * t1 + o.x - i.padding) * p + d.point.x, f = (i.y1 * t1 + o.y - i.padding) * p + d.point.y, g = (i.x2 * t1 + o.x + i.padding) * p + d.point.x, v = (i.y2 * t1 + o.y + i.padding) * p + d.point.y, x = d.perspectiveRatio <= .55 || d.occluded;
                return !this.isInsideGrid(m, f, g, v) || !r && this.grid.hitTest(m, f, g, v, s) || x ? {
                    box: [],
                    offscreen: !1,
                    occluded: d.occluded
                } : {
                    box: [
                        m,
                        f,
                        g,
                        v
                    ],
                    offscreen: this.isOffscreen(m, f, g, v),
                    occluded: !1
                };
            }
            placeCollisionCircles(t1, i, o, r, n, a, s, l, c, h, u, _, d, p, m) {
                const f = [], g = this.transform.elevation, v = g ? g.getAtTileOffsetFunc(m, this.transform.center.lat, this.transform.worldSize, t1.getProjection()) : (e1)=>[
                        0,
                        0,
                        0
                    ], x = new e1.pointGeometry(o.tileAnchorX, o.tileAnchorY), y = t1.getProjection().projectTilePoint(o.tileAnchorX, o.tileAnchorY, m.canonical), b = v(x), w = [
                    y.x + b[0],
                    y.y + b[1],
                    y.z + b[2]
                ], T = "globe" === t1.projection.name, E = this.projectAndGetPerspectiveRatio(s, [
                    w[0],
                    w[1],
                    w[2]
                ], m, T || !!g || this.transform.pitch > 0, t1.getProjection()), { perspectiveRatio: C } = E, I = (u ? a / C : a * C) / e1.ONE_EM, M = rt(new e1.pointGeometry(w[0], w[1]), l, w[2]).point, S = E.signedDistanceFromCamera > 0 ? ct(I, n, o.lineOffsetX * I, o.lineOffsetY * I, !1, M, x, o, r, l, {}, g && !u ? v : null, u && !!g, t1.getProjection(), m, u) : null;
                let z = !1, D = !1, P = !0;
                if (S && !E.occluded) {
                    const t1 = .5 * d * C + p, o = new e1.pointGeometry(-100, -100), r = new e1.pointGeometry(this.screenRightBoundary, this.screenBottomBoundary), n = new Je, a = S.first, s = S.last;
                    let l = [];
                    for(let e1 = a.path.length - 1; e1 >= 1; e1--)l.push(a.path[e1]);
                    for(let e1 = 1; e1 < s.path.length; e1++)l.push(s.path[e1]);
                    const u = 2.5 * t1;
                    if (c) {
                        const e1 = l.map(g && !T ? (e1, t1)=>{
                            const i = v(t1 < a.path.length - 1 ? a.tilePath[a.path.length - 1 - t1] : s.tilePath[t1 - a.path.length + 2]);
                            return e1[2] = i[2], nt(e1, c);
                        } : (e1)=>nt(e1, c));
                        l = e1.some((e1)=>e1.signedDistanceFromCamera <= 0) ? [] : e1.map((e1)=>e1.point);
                    }
                    let m = [];
                    if (l.length > 0) {
                        const t1 = l.map((t1)=>new e1.pointGeometry(t1[0], t1[1]));
                        let i = 1 / 0, n = -1 / 0, a = 1 / 0, s = -1 / 0;
                        for(let e1 = 0; e1 < t1.length; e1++)i = Math.min(i, t1[e1].x), a = Math.min(a, t1[e1].y), n = Math.max(n, t1[e1].x), s = Math.max(s, t1[e1].y);
                        m = i >= o.x && n <= r.x && a >= o.y && s <= r.y ? [
                            t1
                        ] : n < o.x || i > r.x || s < o.y || a > r.y ? [] : e1.clipLine([
                            t1
                        ], o.x, o.y, r.x, r.y);
                    }
                    for (const e1 of m){
                        n.reset(e1, .25 * t1);
                        let o = 0;
                        o = n.length <= .5 * t1 ? 1 : Math.ceil(n.paddedLength / u) + 1;
                        for(let e1 = 0; e1 < o; e1++){
                            const r = e1 / Math.max(o - 1, 1), a = n.lerp(r), s = a.x + vt, l = a.y + vt;
                            f.push(s, l, t1, 0);
                            const c = s - t1, u = l - t1, d = s + t1, p = l + t1;
                            if (P = P && this.isOffscreen(c, u, d, p), D = D || this.isInsideGrid(c, u, d, p), !i && this.grid.hitTestCircle(s, l, t1, _) && (z = !0, !h)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: z,
                                occluded: !1
                            };
                        }
                    }
                }
                return {
                    circles: !h && z || !D ? [] : f,
                    offscreen: P,
                    collisionDetected: z,
                    occluded: E.occluded
                };
            }
            queryRenderedSymbols(t1) {
                if (0 === t1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let o = 1 / 0, r = 1 / 0, n = -1 / 0, a = -1 / 0;
                for (const s of t1){
                    const t1 = new e1.pointGeometry(s.x + vt, s.y + vt);
                    o = Math.min(o, t1.x), r = Math.min(r, t1.y), n = Math.max(n, t1.x), a = Math.max(a, t1.y), i.push(t1);
                }
                const s = this.grid.query(o, r, n, a).concat(this.ignoredGrid.query(o, r, n, a)), l = {}, c = {};
                for (const t1 of s){
                    const o = t1.key;
                    if (void 0 === l[o.bucketInstanceId] && (l[o.bucketInstanceId] = {}), l[o.bucketInstanceId][o.featureIndex]) continue;
                    const r = [
                        new e1.pointGeometry(t1.x1, t1.y1),
                        new e1.pointGeometry(t1.x2, t1.y1),
                        new e1.pointGeometry(t1.x2, t1.y2),
                        new e1.pointGeometry(t1.x1, t1.y2)
                    ];
                    e1.polygonIntersectsPolygon(i, r) && (l[o.bucketInstanceId][o.featureIndex] = !0, void 0 === c[o.bucketInstanceId] && (c[o.bucketInstanceId] = []), c[o.bucketInstanceId].push(o.featureIndex));
                }
                return c;
            }
            insertCollisionBox(e1, t1, i, o, r) {
                (t1 ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: r
                }, e1[0], e1[1], e1[2], e1[3]);
            }
            insertCollisionCircles(e1, t1, i, o, r) {
                const n = t1 ? this.ignoredGrid : this.grid, a = {
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: r
                };
                for(let t1 = 0; t1 < e1.length; t1 += 4)n.insertCircle(a, e1[t1], e1[t1 + 1], e1[t1 + 2]);
            }
            projectAndGetPerspectiveRatio(t1, i, o, r, n) {
                const a = [
                    i[0],
                    i[1],
                    i[2],
                    1
                ];
                let s = !1;
                if (i[2] || this.transform.pitch > 0) {
                    e1.transformMat4$1(a, a, t1);
                    const r = "globe" === n.name;
                    this.fogState && o && !r && (s = function(t1, i, o, r, n, a) {
                        const s = a.calculateFogTileMatrix(n), l = [
                            i,
                            o,
                            r
                        ];
                        return e1.transformMat4(l, l, s), M(t1, l, a.pitch, a._fov);
                    }(this.fogState, i[0], i[1], i[2], o.toUnwrapped(), this.transform) > .9);
                } else gt(a, a, t1);
                return {
                    point: new e1.pointGeometry((a[0] / a[3] + 1) / 2 * this.transform.width + vt, (-a[1] / a[3] + 1) / 2 * this.transform.height + vt),
                    perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(n) / a[3] * .5, 1.5),
                    signedDistanceFromCamera: a[3],
                    occluded: r && a[2] > a[3] || s
                };
            }
            isOffscreen(e1, t1, i, o) {
                return i < vt || e1 >= this.screenRightBoundary || o < vt || t1 > this.screenBottomBoundary;
            }
            isInsideGrid(e1, t1, i, o) {
                return i >= 0 && e1 < this.gridRightBoundary && o >= 0 && t1 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const t1 = e1.identity([]);
                return e1.translate(t1, t1, [
                    -100,
                    -100,
                    0
                ]), t1;
            }
            constructor(e1, t1, i = new Qe(e1.width + 200, e1.height + 200, 25), o = new Qe(e1.width + 200, e1.height + 200, 25)){
                this.transform = e1, this.grid = i, this.ignoredGrid = o, this.pitchfactor = Math.cos(e1._pitch) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + vt, this.screenBottomBoundary = e1.height + vt, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.fogState = t1;
            }
        }
        function yt(t1, i, o) {
            const r = i.createTileMatrix(t1, t1.worldSize, o.toUnwrapped());
            return e1.multiply(new Float32Array(16), t1.projMatrix, r);
        }
        function bt(e1, t1, i) {
            if (t1.projection.name === i.projection.name) return e1.projMatrix;
            const o = i.clone();
            return o.setProjection(t1.projection), yt(o, t1.getProjection(), e1);
        }
        function wt(e1, t1, i) {
            return t1.name === i.projection.name ? e1.projMatrix : yt(i, t1, e1);
        }
        class Tt {
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
            constructor(e1, t1, i, o){
                this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t1 : -t1))) : o && i ? 1 : 0, this.placed = i;
            }
        }
        class Et {
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
            constructor(e1, t1, i, o, r, n = !1){
                this.text = new Tt(e1 ? e1.text : null, t1, i, r), this.icon = new Tt(e1 ? e1.icon : null, t1, o, r), this.clipped = n;
            }
        }
        class Ct {
            constructor(e1, t1, i, o = !1){
                this.text = e1, this.icon = t1, this.skipFade = i, this.clipped = o;
            }
        }
        class It {
            constructor(){
                this.invProjMatrix = e1.create(), this.viewportMatrix = e1.create(), this.circles = [];
            }
        }
        class Mt {
            constructor(e1, t1, i, o, r){
                this.bucketInstanceId = e1, this.featureIndex = t1, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = r;
            }
        }
        class St {
            get(e1) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e1]) {
                    const t1 = ++this.maxGroupID;
                    this.collisionGroups[e1] = {
                        ID: t1,
                        predicate: (e1)=>e1.collisionGroupID === t1
                    };
                }
                return this.collisionGroups[e1];
            }
            constructor(e1){
                this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
            }
        }
        function zt(t1, i, o, r, n) {
            const { horizontalAlign: a, verticalAlign: s } = e1.getAnchorAlignment(t1), l = -(a - .5) * i, c = -(s - .5) * o, h = e1.evaluateVariableOffset(t1, r);
            return new e1.pointGeometry(l + h[0] * n, c + h[1] * n);
        }
        function Dt(t1, i, o, r, n) {
            const a = new e1.pointGeometry(t1, i);
            return o && a._rotate(r ? n : -n), a;
        }
        class Pt {
            getBucketParts(t1, i, o, r) {
                const n = o.getBucket(i), a = o.latestFeatureIndex;
                if (!n || !a || i.id !== n.layerIds[0]) return;
                const s = n.layers[0].layout, l = o.collisionBoxArray, c = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ), h = o.tileSize / e1.EXTENT, u = o.tileID.toUnwrapped();
                this.transform.setProjection(n.projection);
                const _ = (d = o.tileID, p = n.getProjection(), m = this.transform, p.name === this.projection ? m.calculateProjMatrix(d.toUnwrapped()) : yt(m, p, d));
                var d, p, m;
                const f = "map" === s.get("text-pitch-alignment"), g = "map" === s.get("text-rotation-alignment");
                i.compileFilter();
                const v = i.dynamicFilter(), x = i.dynamicFilterNeedsFeature(), y = this.transform.calculatePixelsToTileUnitsMatrix(o), b = it(_, o.tileID.canonical, f, g, this.transform, n.getProjection(), y);
                let w = null;
                if (f) {
                    const t1 = ot(_, o.tileID.canonical, f, g, this.transform, n.getProjection(), y);
                    w = e1.multiply([], this.transform.labelPlaneMatrix, t1);
                }
                let T = null;
                v && o.latestFeatureIndex && (T = {
                    unwrappedTileID: u,
                    dynamicFilter: v,
                    dynamicFilterNeedsFeature: x,
                    featureIndex: o.latestFeatureIndex
                }), this.retainedQueryData[n.bucketInstanceId] = new Mt(n.bucketInstanceId, a, n.sourceLayerIndex, n.index, o.tileID);
                const E = {
                    bucket: n,
                    layout: s,
                    posMatrix: _,
                    textLabelPlaneMatrix: b,
                    labelToScreenMatrix: w,
                    clippingData: T,
                    scale: c,
                    textPixelRatio: h,
                    holdingForFade: o.holdingForFade(),
                    collisionBoxArray: l,
                    partiallyEvaluatedTextSize: e1.evaluateSizeForZoom(n.textSizeData, this.transform.zoom),
                    partiallyEvaluatedIconSize: e1.evaluateSizeForZoom(n.iconSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(n.sourceID)
                };
                if (r) for (const e1 of n.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: o, symbolInstanceEnd: r } = e1;
                    t1.push({
                        sortKey: i,
                        symbolInstanceStart: o,
                        symbolInstanceEnd: r,
                        parameters: E
                    });
                }
                else t1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: n.symbolInstances.length,
                    parameters: E
                });
            }
            attemptAnchorPlacement(e1, t1, i, o, r, n, a, s, l, c, h, u, _, d, p, m, f, g) {
                const v = [
                    u.textOffset0,
                    u.textOffset1
                ], x = zt(e1, i, o, v, r), y = this.collisionIndex.placeCollisionBox(d, r, t1, Dt(x.x, x.y, n, a, this.transform.angle), h, s, l, c.predicate);
                if ((!m || 0 !== this.collisionIndex.placeCollisionBox(d, d.getSymbolInstanceIconSize(g, this.transform.zoom, _), m, Dt(x.x, x.y, n, a, this.transform.angle), h, s, l, c.predicate).box.length) && y.box.length > 0) {
                    let t1;
                    return this.prevPlacement && this.prevPlacement.variableOffsets[u.crossTileID] && this.prevPlacement.placements[u.crossTileID] && this.prevPlacement.placements[u.crossTileID].text && (t1 = this.prevPlacement.variableOffsets[u.crossTileID].anchor), this.variableOffsets[u.crossTileID] = {
                        textOffset: v,
                        width: i,
                        height: o,
                        anchor: e1,
                        textScale: r,
                        prevAnchor: t1
                    }, this.markUsedJustification(d, e1, u, p), d.allowVerticalPlacement && (this.markUsedOrientation(d, p, u), this.placedOrientations[u.crossTileID] = p), {
                        shift: x,
                        placedGlyphBoxes: y
                    };
                }
            }
            placeLayerBucketPart(t1, i, o, r) {
                const { bucket: n, layout: a, posMatrix: s, textLabelPlaneMatrix: l, labelToScreenMatrix: c, clippingData: h, textPixelRatio: u, holdingForFade: _, collisionBoxArray: d, partiallyEvaluatedTextSize: p, partiallyEvaluatedIconSize: m, collisionGroup: f } = t1.parameters, g = a.get("text-optional"), v = a.get("icon-optional"), x = a.get("text-allow-overlap"), y = a.get("icon-allow-overlap"), b = "map" === a.get("text-rotation-alignment"), w = "map" === a.get("text-pitch-alignment"), T = "none" !== a.get("icon-text-fit"), E = "viewport-y" === a.get("symbol-z-order");
                this.transform.setProjection(n.projection);
                let C = x && (y || !n.hasIconData() || v), I = y && (x || !n.hasTextData() || g);
                !n.collisionArrays && d && n.deserializeCollisionBoxes(d), o && r && n.updateCollisionDebugBuffers(this.transform.zoom, d);
                const M = (t1, r, d)=>{
                    if (h) {
                        const o = {
                            zoom: this.transform.zoom,
                            pitch: this.transform.pitch
                        };
                        let r = null;
                        if (h.dynamicFilterNeedsFeature) {
                            const e1 = this.retainedQueryData[n.bucketInstanceId];
                            r = h.featureIndex.loadFeature({
                                featureIndex: t1.featureIndex,
                                bucketIndex: e1.bucketIndex,
                                sourceLayerIndex: e1.sourceLayerIndex,
                                layoutVertexArrayOffset: 0
                            });
                        }
                        if (!(0, h.dynamicFilter)(o, r, this.retainedQueryData[n.bucketInstanceId].tileID.canonical, new e1.pointGeometry(t1.tileAnchorX, t1.tileAnchorY), this.transform.calculateDistanceTileData(h.unwrappedTileID))) return this.placements[t1.crossTileID] = new Ct(!1, !1, !1, !0), void (i[t1.crossTileID] = !0);
                    }
                    if (i[t1.crossTileID]) return;
                    if (_) return void (this.placements[t1.crossTileID] = new Ct(!1, !1, !1));
                    let E = !1, M = !1, S = !0, z = !1, D = !1, P = null, A = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, L = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, R = null, O = null, B = null, k = 0, F = 0, U = 0;
                    d.textFeatureIndex ? k = d.textFeatureIndex : t1.useRuntimeCollisionCircles && (k = t1.featureIndex), d.verticalTextFeatureIndex && (F = d.verticalTextFeatureIndex);
                    const N = (e1)=>{
                        e1.tileID = this.retainedQueryData[n.bucketInstanceId].tileID, (this.transform.elevation || e1.elevation) && (e1.elevation = this.transform.elevation ? this.transform.elevation.getAtTileOffset(this.retainedQueryData[n.bucketInstanceId].tileID, e1.tileAnchorX, e1.tileAnchorY) : 0);
                    }, G = d.textBox;
                    if (G) {
                        N(G);
                        const i = (i)=>{
                            let o = e1.WritingMode.horizontal;
                            if (n.allowVerticalPlacement && !i && this.prevPlacement) {
                                const e1 = this.prevPlacement.placedOrientations[t1.crossTileID];
                                e1 && (this.placedOrientations[t1.crossTileID] = e1, o = e1, this.markUsedOrientation(n, o, t1));
                            }
                            return o;
                        }, o = (i, o)=>{
                            if (n.allowVerticalPlacement && t1.numVerticalGlyphVertices > 0 && d.verticalTextBox) {
                                for (const t1 of n.writingModes)if (t1 === e1.WritingMode.vertical ? (A = o(), L = A) : A = i(), A && A.box && A.box.length) break;
                            } else A = i();
                        };
                        if (a.get("text-variable-anchor")) {
                            let l = a.get("text-variable-anchor");
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[t1.crossTileID]) {
                                const e1 = this.prevPlacement.variableOffsets[t1.crossTileID];
                                l.indexOf(e1.anchor) > 0 && (l = l.filter((t1)=>t1 !== e1.anchor), l.unshift(e1.anchor));
                            }
                            const c = (e1, i, o)=>{
                                const a = n.getSymbolInstanceTextSize(p, t1, this.transform.zoom, r), c = (e1.x2 - e1.x1) * a + 2 * e1.padding, h = (e1.y2 - e1.y1) * a + 2 * e1.padding, _ = T && !y ? i : null;
                                _ && N(_);
                                let d = {
                                    box: [],
                                    offscreen: !1,
                                    occluded: !1
                                };
                                const g = x ? 2 * l.length : l.length;
                                for(let i = 0; i < g; ++i){
                                    const g = this.attemptAnchorPlacement(l[i % l.length], e1, c, h, a, b, w, u, s, f, i >= l.length, t1, r, n, o, _, p, m);
                                    if (g && (d = g.placedGlyphBoxes, d && d.box && d.box.length)) {
                                        E = !0, P = g.shift;
                                        break;
                                    }
                                }
                                return d;
                            };
                            o(()=>c(G, d.iconBox, e1.WritingMode.horizontal), ()=>{
                                const i = d.verticalTextBox;
                                return i && N(i), n.allowVerticalPlacement && !(A && A.box && A.box.length) && t1.numVerticalGlyphVertices > 0 && i ? c(i, d.verticalIconBox, e1.WritingMode.vertical) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), A && (E = A.box, S = A.offscreen, z = A.occluded);
                            const h = i(A && A.box);
                            if (!E && this.prevPlacement) {
                                const e1 = this.prevPlacement.variableOffsets[t1.crossTileID];
                                e1 && (this.variableOffsets[t1.crossTileID] = e1, this.markUsedJustification(n, e1.anchor, t1, h));
                            }
                        } else {
                            const a = (i, o)=>{
                                const a = n.getSymbolInstanceTextSize(p, t1, this.transform.zoom, r), l = this.collisionIndex.placeCollisionBox(n, a, i, new e1.pointGeometry(0, 0), x, u, s, f.predicate);
                                return l && l.box && l.box.length && (this.markUsedOrientation(n, o, t1), this.placedOrientations[t1.crossTileID] = o), l;
                            };
                            o(()=>a(G, e1.WritingMode.horizontal), ()=>{
                                const i = d.verticalTextBox;
                                return n.allowVerticalPlacement && t1.numVerticalGlyphVertices > 0 && i ? (N(i), a(i, e1.WritingMode.vertical)) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), i(A && A.box && A.box.length);
                        }
                    }
                    if (R = A, E = R && R.box && R.box.length > 0, S = R && R.offscreen, z = R && R.occluded, t1.useRuntimeCollisionCircles) {
                        const i = n.text.placedSymbolArray.get(t1.centerJustifiedTextSymbolIndex >= 0 ? t1.centerJustifiedTextSymbolIndex : t1.verticalPlacedTextSymbolIndex), r = e1.evaluateSizeForFeature(n.textSizeData, p, i), h = a.get("text-padding");
                        O = this.collisionIndex.placeCollisionCircles(n, x, i, n.lineVertexArray, n.glyphOffsetArray, r, s, l, c, o, w, f.predicate, t1.collisionCircleDiameter * r / e1.ONE_EM, h, this.retainedQueryData[n.bucketInstanceId].tileID), E = x || O.circles.length > 0 && !O.collisionDetected, S = S && O.offscreen, z = O.occluded;
                    }
                    if (d.iconFeatureIndex && (U = d.iconFeatureIndex), d.iconBox) {
                        const t1 = (t1)=>{
                            N(t1);
                            const i = T && P ? Dt(P.x, P.y, b, w, this.transform.angle) : new e1.pointGeometry(0, 0), o = n.getSymbolInstanceIconSize(m, this.transform.zoom, r);
                            return this.collisionIndex.placeCollisionBox(n, o, t1, i, y, u, s, f.predicate);
                        };
                        L && L.box && L.box.length && d.verticalIconBox ? (B = t1(d.verticalIconBox), M = B.box.length > 0) : (B = t1(d.iconBox), M = B.box.length > 0), S = S && B.offscreen, D = B.occluded;
                    }
                    const j = g || 0 === t1.numHorizontalGlyphVertices && 0 === t1.numVerticalGlyphVertices, Z = v || 0 === t1.numIconVertices;
                    if (j || Z ? Z ? j || (M = M && E) : E = M && E : M = E = M && E, E && R && R.box && this.collisionIndex.insertCollisionBox(R.box, a.get("text-ignore-placement"), n.bucketInstanceId, L && L.box && F ? F : k, f.ID), M && B && this.collisionIndex.insertCollisionBox(B.box, a.get("icon-ignore-placement"), n.bucketInstanceId, U, f.ID), O && (E && this.collisionIndex.insertCollisionCircles(O.circles, a.get("text-ignore-placement"), n.bucketInstanceId, k, f.ID), o)) {
                        const e1 = n.bucketInstanceId;
                        let t1 = this.collisionCircleArrays[e1];
                        void 0 === t1 && (t1 = this.collisionCircleArrays[e1] = new It);
                        for(let e1 = 0; e1 < O.circles.length; e1 += 4)t1.circles.push(O.circles[e1 + 0]), t1.circles.push(O.circles[e1 + 1]), t1.circles.push(O.circles[e1 + 2]), t1.circles.push(O.collisionDetected ? 1 : 0);
                    }
                    const V = "globe" !== n.projection.name;
                    C = C && (V || !z), I = I && (V || !D), this.placements[t1.crossTileID] = new Ct(E || C, M || I, S || n.justReloaded), i[t1.crossTileID] = !0;
                };
                if (E) {
                    const e1 = n.getSortedSymbolIndexes(this.transform.angle);
                    for(let t1 = e1.length - 1; t1 >= 0; --t1){
                        const i = e1[t1];
                        M(n.symbolInstances.get(i), i, n.collisionArrays[i]);
                    }
                } else for(let e1 = t1.symbolInstanceStart; e1 < t1.symbolInstanceEnd; e1++)M(n.symbolInstances.get(e1), e1, n.collisionArrays[e1]);
                if (o && n.bucketInstanceId in this.collisionCircleArrays) {
                    const t1 = this.collisionCircleArrays[n.bucketInstanceId];
                    e1.invert(t1.invProjMatrix, s), t1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                n.justReloaded = !1;
            }
            markUsedJustification(t1, i, o, r) {
                let n;
                n = r === e1.WritingMode.vertical ? o.verticalPlacedTextSymbolIndex : ({
                    left: o.leftJustifiedTextSymbolIndex,
                    center: o.centerJustifiedTextSymbolIndex,
                    right: o.rightJustifiedTextSymbolIndex
                })[e1.getAnchorJustification(i)];
                const a = [
                    o.leftJustifiedTextSymbolIndex,
                    o.centerJustifiedTextSymbolIndex,
                    o.rightJustifiedTextSymbolIndex,
                    o.verticalPlacedTextSymbolIndex
                ];
                for (const e1 of a)e1 >= 0 && (t1.text.placedSymbolArray.get(e1).crossTileID = n >= 0 && e1 !== n ? 0 : o.crossTileID);
            }
            markUsedOrientation(t1, i, o) {
                const r = i === e1.WritingMode.horizontal || i === e1.WritingMode.horizontalOnly ? i : 0, n = i === e1.WritingMode.vertical ? i : 0, a = [
                    o.leftJustifiedTextSymbolIndex,
                    o.centerJustifiedTextSymbolIndex,
                    o.rightJustifiedTextSymbolIndex
                ];
                for (const e1 of a)t1.text.placedSymbolArray.get(e1).placedOrientation = r;
                o.verticalPlacedTextSymbolIndex && (t1.text.placedSymbolArray.get(o.verticalPlacedTextSymbolIndex).placedOrientation = n);
            }
            commit(e1) {
                this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t1 = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t1 ? t1.zoomAdjustment(this.transform.zoom) : 0;
                const o = t1 ? t1.symbolFadeChange(e1) : 1, r = t1 ? t1.opacities : {}, n = t1 ? t1.variableOffsets : {}, a = t1 ? t1.placedOrientations : {};
                for(const e1 in this.placements){
                    const t1 = this.placements[e1], n = r[e1];
                    n ? (this.opacities[e1] = new Et(n, o, t1.text, t1.icon, null, t1.clipped), i = i || t1.text !== n.text.placed || t1.icon !== n.icon.placed) : (this.opacities[e1] = new Et(null, o, t1.text, t1.icon, t1.skipFade, t1.clipped), i = i || t1.text || t1.icon);
                }
                for(const e1 in r){
                    const t1 = r[e1];
                    if (!this.opacities[e1]) {
                        const r = new Et(t1, o, !1, !1);
                        r.isHidden() || (this.opacities[e1] = r, i = i || t1.text.placed || t1.icon.placed);
                    }
                }
                for(const e1 in n)this.variableOffsets[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.variableOffsets[e1] = n[e1]);
                for(const e1 in a)this.placedOrientations[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.placedOrientations[e1] = a[e1]);
                i ? this.lastPlacementChangeTime = e1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t1 ? t1.lastPlacementChangeTime : e1);
            }
            updateLayerOpacities(e1, t1) {
                const i = {};
                for (const o of t1){
                    const t1 = o.getBucket(e1);
                    t1 && o.latestFeatureIndex && e1.id === t1.layerIds[0] && this.updateBucketOpacities(t1, i, o.collisionBoxArray);
                }
            }
            updateBucketOpacities(t1, i, o) {
                t1.hasTextData() && t1.text.opacityVertexArray.clear(), t1.hasIconData() && t1.icon.opacityVertexArray.clear(), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexArray.clear(), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexArray.clear();
                const r = t1.layers[0].layout, n = !!t1.layers[0].dynamicFilter(), a = new Et(null, 0, !1, !1, !0), s = r.get("text-allow-overlap"), l = r.get("icon-allow-overlap"), c = r.get("text-variable-anchor"), h = "map" === r.get("text-rotation-alignment"), u = "map" === r.get("text-pitch-alignment"), _ = "none" !== r.get("icon-text-fit"), d = new Et(null, 0, s && (l || !t1.hasIconData() || r.get("icon-optional")), l && (s || !t1.hasTextData() || r.get("text-optional")), !0);
                !t1.collisionArrays && o && (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) && t1.deserializeCollisionBoxes(o);
                const p = (e1, t1, i)=>{
                    for(let o = 0; o < t1 / 4; o++)e1.opacityVertexArray.emplaceBack(i);
                };
                let m = 0;
                for(let o = 0; o < t1.symbolInstances.length; o++){
                    const r = t1.symbolInstances.get(o), { numHorizontalGlyphVertices: s, numVerticalGlyphVertices: l, crossTileID: f } = r;
                    let g = this.opacities[f];
                    i[f] ? g = a : g || (g = d, this.opacities[f] = g), i[f] = !0;
                    const v = s > 0 || l > 0, x = r.numIconVertices > 0, y = this.placedOrientations[r.crossTileID], b = y === e1.WritingMode.vertical, w = y === e1.WritingMode.horizontal || y === e1.WritingMode.horizontalOnly;
                    if (!v && !x || g.isHidden() || m++, v) {
                        const e1 = Nt(g.text);
                        p(t1.text, s, b ? Gt : e1), p(t1.text, l, w ? Gt : e1);
                        const i = g.text.isHidden();
                        [
                            r.rightJustifiedTextSymbolIndex,
                            r.centerJustifiedTextSymbolIndex,
                            r.leftJustifiedTextSymbolIndex
                        ].forEach((e1)=>{
                            e1 >= 0 && (t1.text.placedSymbolArray.get(e1).hidden = i || b ? 1 : 0);
                        }), r.verticalPlacedTextSymbolIndex >= 0 && (t1.text.placedSymbolArray.get(r.verticalPlacedTextSymbolIndex).hidden = i || w ? 1 : 0);
                        const o = this.variableOffsets[r.crossTileID];
                        o && this.markUsedJustification(t1, o.anchor, r, y);
                        const n = this.placedOrientations[r.crossTileID];
                        n && (this.markUsedJustification(t1, "left", r, n), this.markUsedOrientation(t1, n, r));
                    }
                    if (x) {
                        const e1 = Nt(g.icon);
                        r.placedIconSymbolIndex >= 0 && (p(t1.icon, r.numIconVertices, b ? Gt : e1), t1.icon.placedSymbolArray.get(r.placedIconSymbolIndex).hidden = g.icon.isHidden()), r.verticalPlacedIconSymbolIndex >= 0 && (p(t1.icon, r.numVerticalIconVertices, w ? Gt : e1), t1.icon.placedSymbolArray.get(r.verticalPlacedIconSymbolIndex).hidden = g.icon.isHidden());
                    }
                    if (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) {
                        const i = t1.collisionArrays[o];
                        if (i) {
                            let o = new e1.pointGeometry(0, 0), r = !0;
                            if (i.textBox || i.verticalTextBox) {
                                if (c) {
                                    const e1 = this.variableOffsets[f];
                                    e1 ? (o = zt(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textScale), h && o._rotate(u ? this.transform.angle : -this.transform.angle)) : r = !1;
                                }
                                n && (r = !g.clipped), i.textBox && At(t1.textCollisionBox.collisionVertexArray, g.text.placed, !r || b, o.x, o.y), i.verticalTextBox && At(t1.textCollisionBox.collisionVertexArray, g.text.placed, !r || w, o.x, o.y);
                            }
                            const a = r && Boolean(!w && i.verticalIconBox);
                            i.iconBox && At(t1.iconCollisionBox.collisionVertexArray, g.icon.placed, a, _ ? o.x : 0, _ ? o.y : 0), i.verticalIconBox && At(t1.iconCollisionBox.collisionVertexArray, g.icon.placed, !a, _ ? o.x : 0, _ ? o.y : 0);
                        }
                    }
                }
                if (t1.fullyClipped = 0 === m, t1.sortFeatures(this.transform.angle), this.retainedQueryData[t1.bucketInstanceId] && (this.retainedQueryData[t1.bucketInstanceId].featureSortOrder = t1.featureSortOrder), t1.hasTextData() && t1.text.opacityVertexBuffer && t1.text.opacityVertexBuffer.updateData(t1.text.opacityVertexArray), t1.hasIconData() && t1.icon.opacityVertexBuffer && t1.icon.opacityVertexBuffer.updateData(t1.icon.opacityVertexArray), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexBuffer && t1.iconCollisionBox.collisionVertexBuffer.updateData(t1.iconCollisionBox.collisionVertexArray), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexBuffer && t1.textCollisionBox.collisionVertexBuffer.updateData(t1.textCollisionBox.collisionVertexArray), t1.bucketInstanceId in this.collisionCircleArrays) {
                    const e1 = this.collisionCircleArrays[t1.bucketInstanceId];
                    t1.placementInvProjMatrix = e1.invProjMatrix, t1.placementViewportMatrix = e1.viewportMatrix, t1.collisionCircleArray = e1.circles, delete this.collisionCircleArrays[t1.bucketInstanceId];
                }
            }
            symbolFadeChange(e1) {
                return 0 === this.fadeDuration ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e1) {
                return Math.max(0, (this.transform.zoom - e1) / 1.5);
            }
            hasTransitions(e1) {
                return this.stale || e1 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e1, t1) {
                const i = this.zoomAtLastRecencyCheck === t1 ? 1 - this.zoomAdjustment(t1) : 1;
                return this.zoomAtLastRecencyCheck = t1, this.commitTime + this.fadeDuration * i > e1;
            }
            setStale() {
                this.stale = !0;
            }
            constructor(e1, t1, i, o, r){
                this.transform = e1.clone(), this.projection = e1.projection.name, this.collisionIndex = new xt(this.transform, r), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t1, this.retainedQueryData = {}, this.collisionGroups = new St(i), this.collisionCircleArrays = {}, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {};
            }
        }
        function At(e1, t1, i, o, r) {
            e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0);
        }
        const Lt = Math.pow(2, 25), Rt = Math.pow(2, 24), Ot = Math.pow(2, 17), Bt = Math.pow(2, 16), kt = Math.pow(2, 9), Ft = Math.pow(2, 8), Ut = Math.pow(2, 1);
        function Nt(e1) {
            if (0 === e1.opacity && !e1.placed) return 0;
            if (1 === e1.opacity && e1.placed) return 4294967295;
            const t1 = e1.placed ? 1 : 0, i = Math.floor(127 * e1.opacity);
            return i * Lt + t1 * Rt + i * Ot + t1 * Bt + i * kt + t1 * Ft + i * Ut + t1;
        }
        const Gt = 0;
        class jt {
            continuePlacement(e1, t1, i, o, r) {
                const n = this._bucketParts;
                for(; this._currentTileIndex < e1.length;)if (t1.getBucketParts(n, o, e1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, r()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, n.sort((e1, t1)=>e1.sortKey - t1.sortKey)); this._currentPartIndex < n.length;){
                    const e1 = n[this._currentPartIndex];
                    if (t1.placeLayerBucketPart(e1, this._seenCrossTileIDs, i, 0 === e1.symbolInstanceStart), this._currentPartIndex++, r()) return !0;
                }
                return !1;
            }
            constructor(e1){
                this._sortAcrossTiles = "viewport-y" !== e1.layout.get("symbol-z-order") && void 0 !== e1.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
            }
        }
        class Zt {
            isDone() {
                return this._done;
            }
            continuePlacement(t1, i, o) {
                const r = e1.exported.now(), n = ()=>{
                    const t1 = e1.exported.now() - r;
                    return !this._forceFullPlacement && t1 > 2;
                };
                for(; this._currentPlacementIndex >= 0;){
                    const e1 = i[t1[this._currentPlacementIndex]], r = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === e1.type && (!e1.minzoom || e1.minzoom <= r) && (!e1.maxzoom || e1.maxzoom > r)) {
                        if (this._inProgressLayer || (this._inProgressLayer = new jt(e1)), this._inProgressLayer.continuePlacement(o[e1.source], this.placement, this._showCollisionBoxes, e1, n)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(e1) {
                return this.placement.commit(e1), this.placement;
            }
            constructor(e1, t1, i, o, r, n, a, s){
                this.placement = new Pt(e1, r, n, a, s), this._currentPlacementIndex = t1.length - 1, this._forceFullPlacement = i, this._showCollisionBoxes = o, this._done = !1;
            }
        }
        const Vt = 512 / e1.EXTENT / 2;
        class Wt {
            getScaledCoordinates(t1, i) {
                const o = Vt / Math.pow(2, i.canonical.z - this.tileID.canonical.z);
                return {
                    x: Math.floor((i.canonical.x * e1.EXTENT + t1.tileAnchorX) * o),
                    y: Math.floor((i.canonical.y * e1.EXTENT + t1.tileAnchorY) * o)
                };
            }
            findMatches(e1, t1, i) {
                const o = this.tileID.canonical.z < t1.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - t1.canonical.z);
                for(let r = 0; r < e1.length; r++){
                    const n = e1.get(r);
                    if (n.crossTileID) continue;
                    const a = this.indexedSymbolInstances[n.key];
                    if (!a) continue;
                    const s = this.getScaledCoordinates(n, t1);
                    for (const e1 of a)if (Math.abs(e1.coord.x - s.x) <= o && Math.abs(e1.coord.y - s.y) <= o && !i[e1.crossTileID]) {
                        i[e1.crossTileID] = !0, n.crossTileID = e1.crossTileID;
                        break;
                    }
                }
            }
            constructor(e1, t1, i){
                this.tileID = e1, this.indexedSymbolInstances = {}, this.bucketInstanceId = i;
                for(let i = 0; i < t1.length; i++){
                    const o = t1.get(i), r = o.key;
                    this.indexedSymbolInstances[r] || (this.indexedSymbolInstances[r] = []), this.indexedSymbolInstances[r].push({
                        crossTileID: o.crossTileID,
                        coord: this.getScaledCoordinates(o, e1)
                    });
                }
            }
        }
        class Xt {
            generate() {
                return ++this.maxCrossTileID;
            }
            constructor(){
                this.maxCrossTileID = 0;
            }
        }
        class qt {
            handleWrapJump(e1) {
                const t1 = Math.round((e1 - this.lng) / 360);
                if (0 !== t1) for(const e1 in this.indexes){
                    const i = this.indexes[e1], o = {};
                    for(const e1 in i){
                        const r = i[e1];
                        r.tileID = r.tileID.unwrapTo(r.tileID.wrap + t1), o[r.tileID.key] = r;
                    }
                    this.indexes[e1] = o;
                }
                this.lng = e1;
            }
            addBucket(e1, t1, i) {
                if (this.indexes[e1.overscaledZ] && this.indexes[e1.overscaledZ][e1.key]) {
                    if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t1.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
                }
                for(let e1 = 0; e1 < t1.symbolInstances.length; e1++)t1.symbolInstances.get(e1).crossTileID = 0;
                this.usedCrossTileIDs[e1.overscaledZ] || (this.usedCrossTileIDs[e1.overscaledZ] = {});
                const o = this.usedCrossTileIDs[e1.overscaledZ];
                for(const i in this.indexes){
                    const r = this.indexes[i];
                    if (Number(i) > e1.overscaledZ) for(const i in r){
                        const n = r[i];
                        n.tileID.isChildOf(e1) && n.findMatches(t1.symbolInstances, e1, o);
                    }
                    else {
                        const n = r[e1.scaledTo(Number(i)).key];
                        n && n.findMatches(t1.symbolInstances, e1, o);
                    }
                }
                for(let e1 = 0; e1 < t1.symbolInstances.length; e1++){
                    const r = t1.symbolInstances.get(e1);
                    r.crossTileID || (r.crossTileID = i.generate(), o[r.crossTileID] = !0);
                }
                return void 0 === this.indexes[e1.overscaledZ] && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new Wt(e1, t1.symbolInstances, t1.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e1, t1) {
                for(const i in t1.indexedSymbolInstances)for (const o of t1.indexedSymbolInstances[i])delete this.usedCrossTileIDs[e1][o.crossTileID];
            }
            removeStaleBuckets(e1) {
                let t1 = !1;
                for(const i in this.indexes){
                    const o = this.indexes[i];
                    for(const r in o)e1[o[r].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, o[r]), delete o[r], t1 = !0);
                }
                return t1;
            }
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
        }
        class $t {
            addLayer(e1, t1, i, o) {
                let r = this.layerIndexes[e1.id];
                void 0 === r && (r = this.layerIndexes[e1.id] = new qt);
                let n = !1;
                const a = {};
                "globe" !== o.name && r.handleWrapJump(i);
                for (const i of t1){
                    const t1 = i.getBucket(e1);
                    t1 && e1.id === t1.layerIds[0] && (t1.bucketInstanceId || (t1.bucketInstanceId = ++this.maxBucketInstanceId), r.addBucket(i.tileID, t1, this.crossTileIDs) && (n = !0), a[t1.bucketInstanceId] = !0);
                }
                return r.removeStaleBuckets(a) && (n = !0), n;
            }
            pruneUnusedLayers(e1) {
                const t1 = {};
                e1.forEach((e1)=>{
                    t1[e1] = !0;
                });
                for(const e1 in this.layerIndexes)t1[e1] || delete this.layerIndexes[e1];
            }
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Xt, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
        }
        const Ht = (t1, i)=>e1.emitValidationErrors(t1, i && i.filter((e1)=>"source.canvas" !== e1.identifier)), Yt = e1.pick(Ve, [
            "addLayer",
            "removeLayer",
            "setPaintProperty",
            "setLayoutProperty",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setTerrain",
            "setFog",
            "setProjection"
        ]), Kt = e1.pick(Ve, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), Jt = {
            version: 8,
            layers: [],
            sources: {}
        }, Qt = {
            fill: !0,
            line: !0,
            background: !0,
            hillshade: !0,
            raster: !0
        };
        class ei extends e1.Evented {
            loadURL(t1, i = {}) {
                this.fire(new e1.Event("dataloading", {
                    dataType: "style"
                }));
                const o = "boolean" == typeof i.validate ? i.validate : !e1.isMapboxURL(t1);
                t1 = this.map._requestManager.normalizeStyleURL(t1, i.accessToken);
                const r = this.map._requestManager.transformRequest(t1, e1.ResourceType.Style);
                this._request = e1.getJSON(r, (t1, i)=>{
                    this._request = null, t1 ? this.fire(new e1.ErrorEvent(t1)) : i && this._load(i, o);
                });
            }
            loadJSON(t1, i = {}) {
                this.fire(new e1.Event("dataloading", {
                    dataType: "style"
                })), this._request = e1.exported.frame(()=>{
                    this._request = null, this._load(t1, !1 !== i.validate);
                });
            }
            loadEmpty() {
                this.fire(new e1.Event("dataloading", {
                    dataType: "style"
                })), this._load(Jt, !1);
            }
            _updateLayerCount(e1, t1) {
                const i = t1 ? 1 : -1;
                e1.is3D() && (this._num3DLayers += i), "circle" === e1.type && (this._numCircleLayers += i), "symbol" === e1.type && (this._numSymbolLayers += i);
            }
            _load(t1, i) {
                if (i && Ht(this, e1.validateStyle(t1))) return;
                this._loaded = !0, this.stylesheet = e1.clone$1(t1), this._updateMapProjection();
                for(const e1 in t1.sources)this.addSource(e1, t1.sources[e1], {
                    validate: !1
                });
                this._changed = !1, t1.sprite ? this._loadSprite(t1.sprite) : (this.imageManager.setLoaded(!0), this.dispatcher.broadcast("spriteLoaded", !0)), this.glyphManager.setURL(t1.glyphs);
                const o = Ze(this.stylesheet.layers);
                this._order = o.map((e1)=>e1.id), this._layers = {}, this._serializedLayers = {};
                for (let t1 of o)t1 = e1.createStyleLayer(t1), t1.setEventedParent(this, {
                    layer: {
                        id: t1.id
                    }
                }), this._layers[t1.id] = t1, this._serializedLayers[t1.id] = t1.serialize(), this._updateLayerCount(t1, !0);
                this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order)), this.light = new T(this.stylesheet.light), this.stylesheet.terrain && !this.terrainSetForDrapingOnly() && this._createTerrain(this.stylesheet.terrain, 1), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this._updateDrapeFirstLayers(), this.fire(new e1.Event("data", {
                    dataType: "style"
                })), this.fire(new e1.Event("style.load"));
            }
            terrainSetForDrapingOnly() {
                return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            setProjection(e1) {
                e1 ? this.stylesheet.projection = e1 : delete this.stylesheet.projection, this._updateMapProjection();
            }
            applyProjectionUpdate() {
                this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? this.getTerrain() || this.stylesheet.terrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null));
            }
            _updateMapProjection() {
                this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.stylesheet.projection);
            }
            _loadSprite(t1) {
                this._spriteRequest = function(t1, i, o) {
                    let r, n, a;
                    const s = e1.exported.devicePixelRatio > 1 ? "@2x" : "";
                    let l = e1.getJSON(i.transformRequest(i.normalizeSpriteURL(t1, s, ".json"), e1.ResourceType.SpriteJSON), (e1, t1)=>{
                        l = null, a || (a = e1, r = t1, h());
                    }), c = e1.getImage(i.transformRequest(i.normalizeSpriteURL(t1, s, ".png"), e1.ResourceType.SpriteImage), (e1, t1)=>{
                        c = null, a || (a = e1, n = t1, h());
                    });
                    function h() {
                        if (a) o(a);
                        else if (r && n) {
                            const t1 = e1.exported.getImageData(n), i = {};
                            for(const o in r){
                                const { width: n, height: a, x: s, y: l, sdf: c, pixelRatio: h, stretchX: u, stretchY: _, content: d } = r[o], p = new e1.RGBAImage({
                                    width: n,
                                    height: a
                                });
                                e1.RGBAImage.copy(t1, p, {
                                    x: s,
                                    y: l
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: n,
                                    height: a
                                }), i[o] = {
                                    data: p,
                                    pixelRatio: h,
                                    sdf: c,
                                    stretchX: u,
                                    stretchY: _,
                                    content: d
                                };
                            }
                            o(null, i);
                        }
                    }
                    return {
                        cancel () {
                            l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                        }
                    };
                }(t1, this.map._requestManager, (t1, i)=>{
                    if (this._spriteRequest = null, t1) this.fire(new e1.ErrorEvent(t1));
                    else if (i) for(const e1 in i)this.imageManager.addImage(e1, i[e1]);
                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), this.dispatcher.broadcast("setImages", this._availableImages), this.dispatcher.broadcast("spriteLoaded", !0), this.fire(new e1.Event("data", {
                        dataType: "style"
                    }));
                });
            }
            _validateLayer(t1) {
                const i = this.getSource(t1.source);
                if (!i) return;
                const o = t1.sourceLayer;
                o && ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(o)) && this.fire(new e1.ErrorEvent(new Error(`Source layer "${o}" does not exist on source "${i.id}" as specified by style layer "${t1.id}"`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(const e1 in this._sourceCaches)if (!this._sourceCaches[e1].loaded()) return !1;
                return !!this.imageManager.isLoaded();
            }
            _serializeLayers(e1) {
                const t1 = [];
                for (const i of e1){
                    const e1 = this._layers[i];
                    "custom" !== e1.type && t1.push(e1.serialize());
                }
                return t1;
            }
            hasTransitions() {
                if (this.light && this.light.hasTransition()) return !0;
                if (this.fog && this.fog.hasTransition()) return !0;
                for(const e1 in this._sourceCaches)if (this._sourceCaches[e1].hasTransition()) return !0;
                for(const e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                return !1;
            }
            get order() {
                return this.map._optimizeForTerrain && this.terrain ? this._drapedFirstOrder : this._order;
            }
            isLayerDraped(e1) {
                return !!this.terrain && Qt[e1.type];
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }
            update(t1) {
                if (!this._loaded) return;
                const i = this._changed;
                if (this._changed) {
                    const e1 = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                    (e1.length || i.length) && this._updateWorkerLayers(e1, i);
                    for(const e1 in this._updatedSources){
                        const t1 = this._updatedSources[e1];
                        "reload" === t1 ? this._reloadSource(e1) : "clear" === t1 && this._clearSource(e1);
                    }
                    this._updateTilesForChangedImages();
                    for(const e1 in this._updatedPaintProps)this._layers[e1].updateTransitions(t1);
                    this.light.updateTransitions(t1), this.fog && this.fog.updateTransitions(t1), this._resetUpdates();
                }
                const o = {};
                for(const e1 in this._sourceCaches){
                    const t1 = this._sourceCaches[e1];
                    o[e1] = t1.used, t1.used = !1;
                }
                for (const e1 of this._order){
                    const i = this._layers[e1];
                    if (i.recalculate(t1, this._availableImages), !i.isHidden(t1.zoom)) {
                        const e1 = this._getLayerSourceCache(i);
                        e1 && (e1.used = !0);
                    }
                    const o = this.map.painter;
                    if (o) {
                        const e1 = i.getProgramIds();
                        if (!e1) continue;
                        const r = i.getProgramConfiguration(t1.zoom);
                        for (const t1 of e1)o.useProgram(t1, r);
                    }
                }
                for(const t1 in o){
                    const i = this._sourceCaches[t1];
                    o[t1] !== i.used && i.getSource().fire(new e1.Event("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: i.getSource().id
                    }));
                }
                this.light.recalculate(t1), this.terrain && this.terrain.recalculate(t1), this.fog && this.fog.recalculate(t1), this.z = t1.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), i && this.fire(new e1.Event("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const e1 = Object.keys(this._changedImages);
                if (e1.length) {
                    for(const t1 in this._sourceCaches)this._sourceCaches[t1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e1);
                    this._changedImages = {};
                }
            }
            _updateWorkerLayers(e1, t1) {
                this.dispatcher.broadcast("updateLayers", {
                    layers: this._serializeLayers(e1),
                    removedIds: t1
                });
            }
            _resetUpdates() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {};
            }
            setState(i) {
                if (this._checkLoaded(), Ht(this, e1.validateStyle(i))) return !1;
                (i = e1.clone$1(i)).layers = Ze(i.layers);
                const o = (function(e1, i) {
                    if (!e1) return [
                        {
                            command: Ve.setStyle,
                            args: [
                                i
                            ]
                        }
                    ];
                    let o = [];
                    try {
                        if (!t1(e1.version, i.version)) return [
                            {
                                command: Ve.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        t1(e1.center, i.center) || o.push({
                            command: Ve.setCenter,
                            args: [
                                i.center
                            ]
                        }), t1(e1.zoom, i.zoom) || o.push({
                            command: Ve.setZoom,
                            args: [
                                i.zoom
                            ]
                        }), t1(e1.bearing, i.bearing) || o.push({
                            command: Ve.setBearing,
                            args: [
                                i.bearing
                            ]
                        }), t1(e1.pitch, i.pitch) || o.push({
                            command: Ve.setPitch,
                            args: [
                                i.pitch
                            ]
                        }), t1(e1.sprite, i.sprite) || o.push({
                            command: Ve.setSprite,
                            args: [
                                i.sprite
                            ]
                        }), t1(e1.glyphs, i.glyphs) || o.push({
                            command: Ve.setGlyphs,
                            args: [
                                i.glyphs
                            ]
                        }), t1(e1.transition, i.transition) || o.push({
                            command: Ve.setTransition,
                            args: [
                                i.transition
                            ]
                        }), t1(e1.light, i.light) || o.push({
                            command: Ve.setLight,
                            args: [
                                i.light
                            ]
                        }), t1(e1.fog, i.fog) || o.push({
                            command: Ve.setFog,
                            args: [
                                i.fog
                            ]
                        }), t1(e1.projection, i.projection) || o.push({
                            command: Ve.setProjection,
                            args: [
                                i.projection
                            ]
                        });
                        const r = {}, n = [];
                        !function(e1, i, o, r) {
                            let n;
                            for(n in i = i || {}, e1 = e1 || {})e1.hasOwnProperty(n) && (i.hasOwnProperty(n) || Xe(n, o, r));
                            for(n in i)i.hasOwnProperty(n) && (e1.hasOwnProperty(n) ? t1(e1[n], i[n]) || ("geojson" === e1[n].type && "geojson" === i[n].type && $e(e1, i, n) ? o.push({
                                command: Ve.setGeoJSONSourceData,
                                args: [
                                    n,
                                    i[n].data
                                ]
                            }) : qe(n, i, o, r)) : We(n, i, o));
                        }(e1.sources, i.sources, n, r);
                        const a = [];
                        e1.layers && e1.layers.forEach((e1)=>{
                            e1.source && r[e1.source] ? o.push({
                                command: Ve.removeLayer,
                                args: [
                                    e1.id
                                ]
                            }) : a.push(e1);
                        });
                        let s = e1.terrain;
                        s && r[s.source] && (o.push({
                            command: Ve.setTerrain,
                            args: [
                                void 0
                            ]
                        }), s = void 0), o = o.concat(n), t1(s, i.terrain) || o.push({
                            command: Ve.setTerrain,
                            args: [
                                i.terrain
                            ]
                        }), function(e1, i, o) {
                            i = i || [];
                            const r = (e1 = e1 || []).map(Ye), n = i.map(Ye), a = e1.reduce(Ke, {}), s = i.reduce(Ke, {}), l = r.slice(), c = Object.create(null);
                            let h, u, _, d, p, m, f;
                            for(h = 0, u = 0; h < r.length; h++)_ = r[h], s.hasOwnProperty(_) ? u++ : (o.push({
                                command: Ve.removeLayer,
                                args: [
                                    _
                                ]
                            }), l.splice(l.indexOf(_, u), 1));
                            for(h = 0, u = 0; h < n.length; h++)_ = n[n.length - 1 - h], l[l.length - 1 - h] !== _ && (a.hasOwnProperty(_) ? (o.push({
                                command: Ve.removeLayer,
                                args: [
                                    _
                                ]
                            }), l.splice(l.lastIndexOf(_, l.length - u), 1)) : u++, m = l[l.length - h], o.push({
                                command: Ve.addLayer,
                                args: [
                                    s[_],
                                    m
                                ]
                            }), l.splice(l.length - h, 0, _), c[_] = !0);
                            for(h = 0; h < n.length; h++)if (_ = n[h], d = a[_], p = s[_], !c[_] && !t1(d, p)) {
                                if (t1(d.source, p.source) && t1(d["source-layer"], p["source-layer"]) && t1(d.type, p.type)) {
                                    for(f in He(d.layout, p.layout, o, _, null, Ve.setLayoutProperty), He(d.paint, p.paint, o, _, null, Ve.setPaintProperty), t1(d.filter, p.filter) || o.push({
                                        command: Ve.setFilter,
                                        args: [
                                            _,
                                            p.filter
                                        ]
                                    }), t1(d.minzoom, p.minzoom) && t1(d.maxzoom, p.maxzoom) || o.push({
                                        command: Ve.setLayerZoomRange,
                                        args: [
                                            _,
                                            p.minzoom,
                                            p.maxzoom
                                        ]
                                    }), d)d.hasOwnProperty(f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? He(d[f], p[f], o, _, f.slice(6), Ve.setPaintProperty) : t1(d[f], p[f]) || o.push({
                                        command: Ve.setLayerProperty,
                                        args: [
                                            _,
                                            f,
                                            p[f]
                                        ]
                                    }));
                                    for(f in p)p.hasOwnProperty(f) && !d.hasOwnProperty(f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? He(d[f], p[f], o, _, f.slice(6), Ve.setPaintProperty) : t1(d[f], p[f]) || o.push({
                                        command: Ve.setLayerProperty,
                                        args: [
                                            _,
                                            f,
                                            p[f]
                                        ]
                                    }));
                                } else o.push({
                                    command: Ve.removeLayer,
                                    args: [
                                        _
                                    ]
                                }), m = l[l.lastIndexOf(_) + 1], o.push({
                                    command: Ve.addLayer,
                                    args: [
                                        p,
                                        m
                                    ]
                                });
                            }
                        }(a, i.layers, o);
                    } catch (e1) {
                        console.warn("Unable to compute style diff:", e1), o = [
                            {
                                command: Ve.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                    }
                    return o;
                })(this.serialize(), i).filter((e1)=>!(e1.command in Kt));
                if (0 === o.length) return !1;
                const r = o.filter((e1)=>!(e1.command in Yt));
                if (r.length > 0) throw new Error(`Unimplemented: ${r.map((e1)=>e1.command).join(", ")}.`);
                return o.forEach((e1)=>{
                    "setTransition" !== e1.command && "setProjection" !== e1.command && this[e1.command].apply(this, e1.args);
                }), this.stylesheet = i, this._updateMapProjection(), !0;
            }
            addImage(t1, i) {
                return this.getImage(t1) ? this.fire(new e1.ErrorEvent(new Error("An image with this name already exists."))) : (this.imageManager.addImage(t1, i), this._afterImageUpdated(t1), this);
            }
            updateImage(e1, t1) {
                this.imageManager.updateImage(e1, t1);
            }
            getImage(e1) {
                return this.imageManager.getImage(e1);
            }
            removeImage(t1) {
                return this.getImage(t1) ? (this.imageManager.removeImage(t1), this._afterImageUpdated(t1), this) : this.fire(new e1.ErrorEvent(new Error("No image with this name exists.")));
            }
            _afterImageUpdated(t1) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[t1] = !0, this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new e1.Event("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this._availableImages.slice();
            }
            addSource(t1, i, o = {}) {
                if (this._checkLoaded(), void 0 !== this.getSource(t1)) throw new Error("There is already a source with this ID");
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(e1.validateSource, `sources.${t1}`, i, null, o)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const r = Ae(t1, i, this.dispatcher, this);
                r.setEventedParent(this, ()=>({
                        isSourceLoaded: this._isSourceCacheLoaded(t1),
                        source: r.serialize(),
                        sourceId: t1
                    }));
                const n = (i)=>{
                    const o = (i ? "symbol:" : "other:") + t1, n = this._sourceCaches[o] = new e1.SourceCache(o, r, i);
                    (i ? this._symbolSourceCaches : this._otherSourceCaches)[t1] = n, n.style = this, n.onAdd(this.map);
                };
                n(!1), "vector" !== i.type && "geojson" !== i.type || n(!0), r.onAdd && r.onAdd(this.map), this._changed = !0;
            }
            removeSource(t1) {
                this._checkLoaded();
                const i = this.getSource(t1);
                if (!i) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === t1) return this.fire(new e1.ErrorEvent(new Error(`Source "${t1}" cannot be removed while layer "${i}" is using it.`)));
                if (this.terrain && this.terrain.get().source === t1) return this.fire(new e1.ErrorEvent(new Error(`Source "${t1}" cannot be removed while terrain is using it.`)));
                const o = this._getSourceCaches(t1);
                for (const t1 of o)delete this._sourceCaches[t1.id], delete this._updatedSources[t1.id], t1.fire(new e1.Event("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: t1.getSource().id
                })), t1.setEventedParent(null), t1.clearTiles();
                return delete this._otherSourceCaches[t1], delete this._symbolSourceCaches[t1], i.setEventedParent(null), i.onRemove && i.onRemove(this.map), this._changed = !0, this;
            }
            setGeoJSONSourceData(e1, t1) {
                this._checkLoaded(), this.getSource(e1).setData(t1), this._changed = !0;
            }
            getSource(e1) {
                const t1 = this._getSourceCache(e1);
                return t1 && t1.getSource();
            }
            addLayer(t1, i, o = {}) {
                this._checkLoaded();
                const r = t1.id;
                if (this.getLayer(r)) return void this.fire(new e1.ErrorEvent(new Error(`Layer with id "${r}" already exists on this map`)));
                let n;
                if ("custom" === t1.type) {
                    if (Ht(this, e1.validateCustomStyleLayer(t1))) return;
                    n = e1.createStyleLayer(t1);
                } else {
                    if ("object" == typeof t1.source && (this.addSource(r, t1.source), t1 = e1.clone$1(t1), t1 = e1.extend(t1, {
                        source: r
                    })), this._validate(e1.validateLayer, `layers.${r}`, t1, {
                        arrayIndex: -1
                    }, o)) return;
                    n = e1.createStyleLayer(t1), this._validateLayer(n), n.setEventedParent(this, {
                        layer: {
                            id: r
                        }
                    }), this._serializedLayers[n.id] = n.serialize(), this._updateLayerCount(n, !0);
                }
                const a = i ? this._order.indexOf(i) : this._order.length;
                if (i && -1 === a) return void this.fire(new e1.ErrorEvent(new Error(`Layer with id "${i}" does not exist on this map.`)));
                this._order.splice(a, 0, r), this._layerOrderChanged = !0, this._layers[r] = n;
                const s = this._getLayerSourceCache(n);
                if (this._removedLayers[r] && n.source && s && "custom" !== n.type) {
                    const e1 = this._removedLayers[r];
                    delete this._removedLayers[r], e1.type !== n.type ? this._updatedSources[n.source] = "clear" : (this._updatedSources[n.source] = "reload", s.pause());
                }
                this._updateLayer(n), n.onAdd && n.onAdd(this.map), this._updateDrapeFirstLayers();
            }
            moveLayer(t1, i) {
                if (this._checkLoaded(), this._changed = !0, !this._layers[t1]) return void this.fire(new e1.ErrorEvent(new Error(`The layer '${t1}' does not exist in the map's style and cannot be moved.`)));
                if (t1 === i) return;
                const o = this._order.indexOf(t1);
                this._order.splice(o, 1);
                const r = i ? this._order.indexOf(i) : this._order.length;
                i && -1 === r ? this.fire(new e1.ErrorEvent(new Error(`Layer with id "${i}" does not exist on this map.`))) : (this._order.splice(r, 0, t1), this._layerOrderChanged = !0, this._updateDrapeFirstLayers());
            }
            removeLayer(t1) {
                this._checkLoaded();
                const i = this._layers[t1];
                if (!i) return void this.fire(new e1.ErrorEvent(new Error(`The layer '${t1}' does not exist in the map's style and cannot be removed.`)));
                i.setEventedParent(null), this._updateLayerCount(i, !1);
                const o = this._order.indexOf(t1);
                this._order.splice(o, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[t1] = i, delete this._layers[t1], delete this._serializedLayers[t1], delete this._updatedLayers[t1], delete this._updatedPaintProps[t1], i.onRemove && i.onRemove(this.map), this._updateDrapeFirstLayers();
            }
            getLayer(e1) {
                return this._layers[e1];
            }
            hasLayer(e1) {
                return e1 in this._layers;
            }
            hasLayerType(e1) {
                for(const t1 in this._layers)if (this._layers[t1].type === e1) return !0;
                return !1;
            }
            setLayerZoomRange(t1, i, o) {
                this._checkLoaded();
                const r = this.getLayer(t1);
                r ? r.minzoom === i && r.maxzoom === o || (null != i && (r.minzoom = i), null != o && (r.maxzoom = o), this._updateLayer(r)) : this.fire(new e1.ErrorEvent(new Error(`The layer '${t1}' does not exist in the map's style and cannot have zoom extent.`)));
            }
            setFilter(i, o, r = {}) {
                this._checkLoaded();
                const n = this.getLayer(i);
                if (n) {
                    if (!t1(n.filter, o)) return null == o ? (n.filter = void 0, void this._updateLayer(n)) : void (this._validate(e1.validateFilter, `layers.${n.id}.filter`, o, {
                        layerType: n.type
                    }, r) || (n.filter = e1.clone$1(o), this._updateLayer(n)));
                } else this.fire(new e1.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be filtered.`)));
            }
            getFilter(t1) {
                const i = this.getLayer(t1);
                return i && e1.clone$1(i.filter);
            }
            setLayoutProperty(i, o, r, n = {}) {
                this._checkLoaded();
                const a = this.getLayer(i);
                a ? t1(a.getLayoutProperty(o), r) || (a.setLayoutProperty(o, r, n), this._updateLayer(a)) : this.fire(new e1.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be styled.`)));
            }
            getLayoutProperty(t1, i) {
                const o = this.getLayer(t1);
                if (o) return o.getLayoutProperty(i);
                this.fire(new e1.ErrorEvent(new Error(`The layer '${t1}' does not exist in the map's style.`)));
            }
            setPaintProperty(i, o, r, n = {}) {
                this._checkLoaded();
                const a = this.getLayer(i);
                a ? t1(a.getPaintProperty(o), r) || (a.setPaintProperty(o, r, n) && this._updateLayer(a), this._changed = !0, this._updatedPaintProps[i] = !0) : this.fire(new e1.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be styled.`)));
            }
            getPaintProperty(e1, t1) {
                const i = this.getLayer(e1);
                return i && i.getPaintProperty(t1);
            }
            setFeatureState(t1, i) {
                this._checkLoaded();
                const o = t1.source, r = t1.sourceLayer, n = this.getSource(o);
                if (!n) return void this.fire(new e1.ErrorEvent(new Error(`The source '${o}' does not exist in the map's style.`)));
                const a = n.type;
                if ("geojson" === a && r) return void this.fire(new e1.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                if ("vector" === a && !r) return void this.fire(new e1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                void 0 === t1.id && this.fire(new e1.ErrorEvent(new Error("The feature id parameter must be provided.")));
                const s = this._getSourceCaches(o);
                for (const e1 of s)e1.setFeatureState(r, t1.id, i);
            }
            removeFeatureState(t1, i) {
                this._checkLoaded();
                const o = t1.source, r = this.getSource(o);
                if (!r) return void this.fire(new e1.ErrorEvent(new Error(`The source '${o}' does not exist in the map's style.`)));
                const n = r.type, a = "vector" === n ? t1.sourceLayer : void 0;
                if ("vector" === n && !a) return void this.fire(new e1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                if (i && "string" != typeof t1.id && "number" != typeof t1.id) return void this.fire(new e1.ErrorEvent(new Error("A feature id is required to remove its specific state property.")));
                const s = this._getSourceCaches(o);
                for (const e1 of s)e1.removeFeatureState(a, t1.id, i);
            }
            getFeatureState(t1) {
                this._checkLoaded();
                const i = t1.source, o = t1.sourceLayer, r = this.getSource(i);
                if (r) {
                    if ("vector" !== r.type || o) return void 0 === t1.id && this.fire(new e1.ErrorEvent(new Error("The feature id parameter must be provided."))), this._getSourceCaches(i)[0].getFeatureState(o, t1.id);
                    this.fire(new e1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                } else this.fire(new e1.ErrorEvent(new Error(`The source '${i}' does not exist in the map's style.`)));
            }
            getTransition() {
                return e1.extend({
                    duration: 300,
                    delay: 0
                }, this.stylesheet && this.stylesheet.transition);
            }
            serialize() {
                const t1 = {};
                for(const e1 in this._sourceCaches){
                    const i = this._sourceCaches[e1].getSource();
                    t1[i.id] || (t1[i.id] = i.serialize());
                }
                return e1.filterObject({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    light: this.stylesheet.light,
                    terrain: this.stylesheet.terrain,
                    fog: this.stylesheet.fog,
                    center: this.stylesheet.center,
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    projection: this.stylesheet.projection,
                    sources: t1,
                    layers: this._serializeLayers(this._order)
                }, (e1)=>void 0 !== e1);
            }
            _updateLayer(e1) {
                this._updatedLayers[e1.id] = !0;
                const t1 = this._getLayerSourceCache(e1);
                e1.source && !this._updatedSources[e1.source] && t1 && "raster" !== t1.getSource().type && (this._updatedSources[e1.source] = "reload", t1.pause()), this._changed = !0, e1.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e1) {
                const t1 = (e1)=>"fill-extrusion" === this._layers[e1].type, i = {}, o = [];
                for(let r = this._order.length - 1; r >= 0; r--){
                    const n = this._order[r];
                    if (t1(n)) {
                        i[n] = r;
                        for (const t1 of e1){
                            const e1 = t1[n];
                            if (e1) for (const t1 of e1)o.push(t1);
                        }
                    }
                }
                o.sort((e1, t1)=>t1.intersectionZ - e1.intersectionZ);
                const r = [];
                for(let n = this._order.length - 1; n >= 0; n--){
                    const a = this._order[n];
                    if (t1(a)) for(let e1 = o.length - 1; e1 >= 0; e1--){
                        const t1 = o[e1].feature;
                        if (i[t1.layer.id] < n) break;
                        r.push(t1), o.pop();
                    }
                    else for (const t1 of e1){
                        const e1 = t1[a];
                        if (e1) for (const t1 of e1)r.push(t1.feature);
                    }
                }
                return r;
            }
            queryRenderedFeatures(t1, i, o) {
                i && i.filter && this._validate(e1.validateFilter, "queryRenderedFeatures.filter", i.filter, null, i);
                const r = {};
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new e1.ErrorEvent(new Error("parameters.layers must be an Array."))), [];
                    for (const t1 of i.layers){
                        const i = this._layers[t1];
                        if (!i) return this.fire(new e1.ErrorEvent(new Error(`The layer '${t1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        r[i.source] = !0;
                    }
                }
                const n = [];
                i.availableImages = this._availableImages;
                const a = i && i.layers ? i.layers.some((e1)=>{
                    const t1 = this.getLayer(e1);
                    return t1 && t1.is3D();
                }) : this.has3DLayers(), s = R.createFromScreenPoints(t1, o);
                for(const e1 in this._sourceCaches){
                    const t1 = this._sourceCaches[e1].getSource().id;
                    i.layers && !r[t1] || n.push(Re(this._sourceCaches[e1], this._layers, this._serializedLayers, s, i, o, a, !!this.map._showQueryGeometry));
                }
                return this.placement && n.push(function(e1, t1, i, o, r, n, a) {
                    const s = {}, l = n.queryRenderedSymbols(o), c = [];
                    for (const e1 of Object.keys(l).map(Number))c.push(a[e1]);
                    c.sort(Be);
                    for (const i of c){
                        const o = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], t1, i.bucketIndex, i.sourceLayerIndex, r.filter, r.layers, r.availableImages, e1);
                        for(const e1 in o){
                            const t1 = s[e1] = s[e1] || [], r = o[e1];
                            r.sort((e1, t1)=>{
                                const o = i.featureSortOrder;
                                if (o) {
                                    const i = o.indexOf(e1.featureIndex);
                                    return o.indexOf(t1.featureIndex) - i;
                                }
                                return t1.featureIndex - e1.featureIndex;
                            });
                            for (const e1 of r)t1.push(e1);
                        }
                    }
                    for(const t1 in s)s[t1].forEach((o)=>{
                        const r = o.feature, n = i(e1[t1]).getFeatureState(r.layer["source-layer"], r.id);
                        r.source = r.layer.source, r.layer["source-layer"] && (r.sourceLayer = r.layer["source-layer"]), r.state = n;
                    });
                    return s;
                }(this._layers, this._serializedLayers, this._getLayerSourceCache.bind(this), s.screenGeometry, i, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(n);
            }
            querySourceFeatures(t1, i) {
                i && i.filter && this._validate(e1.validateFilter, "querySourceFeatures.filter", i.filter, null, i);
                const o = this._getSourceCaches(t1);
                let r = [];
                for (const e1 of o)r = r.concat(Oe(e1, i));
                return r;
            }
            addSourceType(e1, t1, i) {
                return ei.getSourceType(e1) ? i(new Error(`A source type called "${e1}" already exists.`)) : (ei.setSourceType(e1, t1), t1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: e1,
                    url: t1.workerSourceURL
                }, i) : i(null, null));
            }
            getLight() {
                return this.light.getLight();
            }
            setLight(e1, i = {}) {
                this._checkLoaded();
                const o = this.light.getLight();
                let r = !1;
                for(const i in e1)if (!t1(e1[i], o[i])) {
                    r = !0;
                    break;
                }
                if (!r) return;
                const n = this._setTransitionParameters({
                    duration: 300,
                    delay: 0
                });
                this.light.setLight(e1, i), this.light.updateTransitions(n);
            }
            getTerrain() {
                return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
            }
            setTerrainForDraping() {
                this.setTerrain({
                    source: "",
                    exaggeration: 0
                }, 0);
            }
            setTerrain(i, o = 1) {
                if (this._checkLoaded(), !i) return delete this.terrain, delete this.stylesheet.terrain, this.dispatcher.broadcast("enableTerrain", !1), this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
                if (1 === o) {
                    if ("object" == typeof i.source) {
                        const t1 = "terrain-dem-src";
                        this.addSource(t1, i.source), i = e1.clone$1(i), i = e1.extend(i, {
                            source: t1
                        });
                    }
                    if (this._validate(e1.validateTerrain, "terrain", i)) return;
                }
                if (!this.terrain || this.terrain && o !== this.terrain.drapeRenderMode) this._createTerrain(i, o);
                else {
                    const o = this.terrain, r = o.get();
                    for (const t1 of Object.keys(e1.spec.terrain))!i.hasOwnProperty(t1) && e1.spec.terrain[t1].default && (i[t1] = e1.spec.terrain[t1].default);
                    for(const e1 in i)if (!t1(i[e1], r[e1])) {
                        o.set(i), this.stylesheet.terrain = i;
                        const e1 = this._setTransitionParameters({
                            duration: 0
                        });
                        o.updateTransitions(e1);
                        break;
                    }
                }
                this._updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
            }
            _createFog(e1) {
                const t1 = this.fog = new P(e1, this.map.transform);
                this.stylesheet.fog = e1;
                const i = this._setTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _updateMarkersOpacity() {
                0 !== this.map._markers.length && this.map._requestDomTask(()=>{
                    for (const e1 of this.map._markers)e1._evaluateOpacity();
                });
            }
            getFog() {
                return this.fog ? this.fog.get() : null;
            }
            setFog(e1) {
                if (this._checkLoaded(), !e1) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = !0);
                if (this.fog) {
                    const i = this.fog, o = i.get();
                    0 === Object.keys(e1).length && i.set(e1);
                    for(const r in e1)if (!t1(e1[r], o[r])) {
                        i.set(e1), this.stylesheet.fog = e1;
                        const t1 = this._setTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(t1);
                        break;
                    }
                } else this._createFog(e1);
                this._markersNeedUpdate = !0;
            }
            _setTransitionParameters(t1) {
                return {
                    now: e1.exported.now(),
                    transition: e1.extend(t1, this.stylesheet.transition)
                };
            }
            _updateDrapeFirstLayers() {
                if (!this.map._optimizeForTerrain || !this.terrain) return;
                const e1 = this._order.filter((e1)=>this.isLayerDraped(this._layers[e1])), t1 = this._order.filter((e1)=>!this.isLayerDraped(this._layers[e1]));
                this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e1), this._drapedFirstOrder.push(...t1);
            }
            _createTerrain(e1, t1) {
                const i = this.terrain = new I(e1, t1);
                this.stylesheet.terrain = e1, this.dispatcher.broadcast("enableTerrain", !this.terrainSetForDrapingOnly()), this._force3DLayerUpdate();
                const o = this._setTransitionParameters({
                    duration: 0
                });
                i.updateTransitions(o);
            }
            _force3DLayerUpdate() {
                for(const e1 in this._layers){
                    const t1 = this._layers[e1];
                    "fill-extrusion" === t1.type && this._updateLayer(t1);
                }
            }
            _forceSymbolLayerUpdate() {
                for(const e1 in this._layers){
                    const t1 = this._layers[e1];
                    "symbol" === t1.type && this._updateLayer(t1);
                }
            }
            _validate(t1, i, o, r, n = {}) {
                return (!n || !1 !== n.validate) && Ht(this, t1.call(e1.validateStyle, e1.extend({
                    key: i,
                    style: this.serialize(),
                    value: o,
                    styleSpec: e1.spec
                }, r)));
            }
            _remove() {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e1.evented.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const e1 in this._layers)this._layers[e1].setEventedParent(null);
                for(const e1 in this._sourceCaches)this._sourceCaches[e1].clearTiles(), this._sourceCaches[e1].setEventedParent(null);
                this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove();
            }
            _clearSource(e1) {
                const t1 = this._getSourceCaches(e1);
                for (const e1 of t1)e1.clearTiles();
            }
            _reloadSource(e1) {
                const t1 = this._getSourceCaches(e1);
                for (const e1 of t1)e1.resume(), e1.reload();
            }
            _updateSources(e1) {
                for(const t1 in this._sourceCaches)this._sourceCaches[t1].update(e1);
            }
            _generateCollisionBoxes() {
                for(const e1 in this._sourceCaches){
                    const t1 = this._sourceCaches[e1];
                    t1.resume(), t1.reload();
                }
            }
            _updatePlacement(t1, i, o, r, n = !1) {
                let a = !1, s = !1;
                const l = {};
                for (const e1 of this._order){
                    const i = this._layers[e1];
                    if ("symbol" !== i.type) continue;
                    if (!l[i.source]) {
                        const e1 = this._getLayerSourceCache(i);
                        if (!e1) continue;
                        l[i.source] = e1.getRenderableIds(!0).map((t1)=>e1.getTileByID(t1)).sort((e1, t1)=>t1.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t1.tileID) ? -1 : 1));
                    }
                    const o = this.crossTileSymbolIndex.addLayer(i, l[i.source], t1.center.lng, t1.projection);
                    a = a || o;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), n = n || this._layerOrderChanged || 0 === o, this._layerOrderChanged && this.fire(new e1.Event("neworder")), (n || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(e1.exported.now(), t1.zoom)) && (this.pauseablePlacement = new Zt(t1, this._order, n, i, o, r, this.placement, this.fog && t1.projection.supportsFog ? this.fog.state : null), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e1.exported.now()), s = !0), a && this.pauseablePlacement.placement.setStale()), s || a) for (const e1 of this._order){
                    const t1 = this._layers[e1];
                    "symbol" === t1.type && this.placement.updateLayerOpacities(t1, l[t1.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(e1.exported.now());
            }
            _releaseSymbolFadeTiles() {
                for(const e1 in this._sourceCaches)this._sourceCaches[e1].releaseSymbolFadeTiles();
            }
            getImages(e1, t1, i) {
                this.imageManager.getImages(t1.icons, i), this._updateTilesForChangedImages();
                const o = (e1)=>{
                    e1 && e1.setDependencies(t1.tileID.key, t1.type, t1.icons);
                };
                o(this._otherSourceCaches[t1.source]), o(this._symbolSourceCaches[t1.source]);
            }
            getGlyphs(e1, t1, i) {
                this.glyphManager.getGlyphs(t1.stacks, i);
            }
            getResource(t1, i, o) {
                return e1.makeRequest(i, o);
            }
            _getSourceCache(e1) {
                return this._otherSourceCaches[e1];
            }
            _getLayerSourceCache(e1) {
                return "symbol" === e1.type ? this._symbolSourceCaches[e1.source] : this._otherSourceCaches[e1.source];
            }
            _getSourceCaches(e1) {
                const t1 = [];
                return this._otherSourceCaches[e1] && t1.push(this._otherSourceCaches[e1]), this._symbolSourceCaches[e1] && t1.push(this._symbolSourceCaches[e1]), t1;
            }
            _isSourceCacheLoaded(t1) {
                const i = this._getSourceCaches(t1);
                return 0 === i.length ? (this.fire(new e1.ErrorEvent(new Error(`There is no source with ID '${t1}'`))), !1) : i.every((e1)=>e1.loaded());
            }
            has3DLayers() {
                return this._num3DLayers > 0;
            }
            hasSymbolLayers() {
                return this._numSymbolLayers > 0;
            }
            hasCircleLayers() {
                return this._numCircleLayers > 0;
            }
            _clearWorkerCaches() {
                this.dispatcher.broadcast("clearCaches");
            }
            destroy() {
                this._clearWorkerCaches(), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
            constructor(t1, i = {}){
                super(), this.map = t1, this.dispatcher = new A(Ge(), this), this.imageManager = new y, this.imageManager.setEventedParent(this), this.glyphManager = new e1.GlyphManager(t1._requestManager, i.localFontFamily ? e1.LocalGlyphMode.all : i.localIdeographFontFamily ? e1.LocalGlyphMode.ideographs : e1.LocalGlyphMode.none, i.localFontFamily || i.localIdeographFontFamily), this.lineAtlas = new e1.LineAtlas(256, 512), this.crossTileSymbolIndex = new $t, this._layers = {}, this._num3DLayers = 0, this._numSymbolLayers = 0, this._numCircleLayers = 0, this._serializedLayers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this.zoomHistory = new e1.ZoomHistory, this._loaded = !1, this._availableImages = [], this._order = [], this._drapedFirstOrder = [], this._markersNeedUpdate = !1, this._resetUpdates(), this.dispatcher.broadcast("setReferrer", e1.getReferrer());
                const o = this;
                this._rtlTextPluginCallback = ei.registerForPluginStateChange((t1)=>{
                    o.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: t1.pluginStatus,
                        pluginURL: t1.pluginURL
                    }, (t1, i)=>{
                        if (e1.triggerPluginCompletionEvent(t1), i && i.every((e1)=>e1)) for(const e1 in o._sourceCaches){
                            const t1 = o._sourceCaches[e1], i = t1.getSource().type;
                            "vector" !== i && "geojson" !== i || t1.reload();
                        }
                    });
                }), this.on("data", (e1)=>{
                    if ("source" !== e1.dataType || "metadata" !== e1.sourceDataType) return;
                    const t1 = this.getSource(e1.sourceId);
                    if (t1 && t1.vectorLayerIds) for(const e1 in this._layers){
                        const i = this._layers[e1];
                        i.source === t1.id && this._validateLayer(i);
                    }
                });
            }
        }
        ei.getSourceType = function(e1) {
            return Pe[e1];
        }, ei.setSourceType = function(e1, t1) {
            Pe[e1] = t1;
        }, ei.registerForPluginStateChange = e1.registerForPluginStateChange;
        var ti = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#define EXTENT 8192.0\n#define HALF_PI PI/2.0\n#define QUARTER_PI PI/4.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0", ii = "attribute highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;varying highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", oi = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;\n#else\nuniform sampler2D u_dem;uniform sampler2D u_dem_prev;\n#endif\nuniform vec4 u_dem_unpack;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;uniform sampler2D u_depth;uniform vec2 u_depth_size_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float decodeElevation(vec4 v) {return dot(vec4(v.xyz*255.0,-1.0),u_dem_unpack);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture2D(u_dem,pos).a;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=decodeElevation(texture2D(u_dem,pos));\n#ifdef TERRAIN_DEM_NEAREST_FILTER\nreturn u_exaggeration*tl;\n#endif\nfloat tr=decodeElevation(texture2D(u_dem,pos+vec2(dd,0.0)));float bl=decodeElevation(texture2D(u_dem,pos+vec2(0.0,dd)));float br=decodeElevation(texture2D(u_dem,pos+vec2(dd,dd)));return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture2D(u_dem_prev,pos).a;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=decodeElevation(texture2D(u_dem_prev,pos));float tr=decodeElevation(texture2D(u_dem_prev,pos+vec2(dd,0.0)));float bl=decodeElevation(texture2D(u_dem_prev,pos+vec2(0.0,dd)));float br=decodeElevation(texture2D(u_dem_prev,pos+vec2(dd,dd)));return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {float nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {return currentElevation(apos);}\n#endif\nhighp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}bool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;float depth=unpack_depth(texture2D(u_depth,(coord.xy+1.0)*0.5));return coord.z > depth+0.0005;}float occlusionFade(vec4 frag) {vec3 coord=frag.xyz/frag.w;vec3 df=vec3(5.0*u_depth_size_inv,0.0);vec2 uv=0.5*coord.xy+0.5;vec4 depth=vec4(\nunpack_depth(texture2D(u_depth,uv-df.xz)),unpack_depth(texture2D(u_depth,uv+df.xz)),unpack_depth(texture2D(u_depth,uv-df.zy)),unpack_depth(texture2D(u_depth,uv+df.zy))\n);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z-0.001)-depth),0.0,1.0));}vec4 fourSample(vec2 pos,vec2 off) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nfloat tl=texture2D(u_dem,pos).a;float tr=texture2D(u_dem,pos+vec2(off.x,0.0)).a;float bl=texture2D(u_dem,pos+vec2(0.0,off.y)).a;float br=texture2D(u_dem,pos+off).a;\n#else\nvec4 demtl=vec4(texture2D(u_dem,pos).xyz*255.0,-1.0);float tl=dot(demtl,u_dem_unpack);vec4 demtr=vec4(texture2D(u_dem,pos+vec2(off.x,0.0)).xyz*255.0,-1.0);float tr=dot(demtr,u_dem_unpack);vec4 dembl=vec4(texture2D(u_dem,pos+vec2(0.0,off.y)).xyz*255.0,-1.0);float bl=dot(dembl,u_dem_unpack);vec4 dembr=vec4(texture2D(u_dem,pos+off).xyz*255.0,-1.0);float br=dot(dembr,u_dem_unpack);\n#endif\nreturn vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;vec4 bounds=vec4(d,vec2(1.0)-d);h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }bool isOccluded(vec4 frag) { return false; }float occlusionFade(vec4 frag) { return 1.0; }\n#endif", ri = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;varying vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", ni = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump float u_fog_temporal_offset;varying vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,opacity);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec3 fog_dither(vec3 color) {vec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif";
        let ai = {}, si = {};
        const li = [];
        di(ti, li), di(oi, li), di(ri, li), di(ni, li), ai = pi("", oi), si = pi(ni, ri);
        const ci = pi("\nhighp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}", "\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}const vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);//Normalized device coordinate that is not rendered."), hi = ti, ui = "\n#ifdef GL_ES\nprecision mediump float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif";
        var _i = {
            background: pi("uniform vec4 u_color;uniform float u_opacity;void main() {vec4 out_color=u_color;\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            backgroundPattern: pi("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 out_color=mix(color1,color2,u_mix);\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            circle: pi("varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\ngl_FragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nvarying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);vec4 world_center=vec4(pos,1);\n#else \nmat3 surface_vectors=mat3(1.0);float height=circle_elevation(circle_center);vec4 world_center=vec4(circle_center,height,1);\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);vec4 occlusion_world_center=vec4(circle_center,cantilevered_height,1);vec4 occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nvec4 occlusion_world_center=world_center;vec4 occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}"),
            clippingMask: pi("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: pi("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {gl_FragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nvarying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\nvec3 pos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),
            heatmapTexture: pi("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"),
            collisionBox: pi("varying float v_placed;varying float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);gl_FragColor =mix(red,blue,step(0.5,v_placed))*0.5;gl_FragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", "attribute vec3 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;attribute float a_size_scale;attribute vec2 a_padding;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*elevation(a_anchor_pos),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
            collisionCircle: pi("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos_2f;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: pi("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;\n#endif\nvarying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}"),
            fill: pi("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            fillOutline: pi("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            fillOutlinePattern: pi("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=mix(color1,color2,u_fade);\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            fillPattern: pi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 out_color=mix(color1,color2,u_fade);\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            fillExtrusion: pi("uniform lowp vec3 u_lightpos;varying vec4 v_color;\n#ifdef RENDER_SHADOWS\nvarying highp vec4 v_pos_light_view_0;varying highp vec4 v_pos_light_view_1;varying float v_depth;varying highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\nvoid main() {vec4 color=v_color;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);color.rgb=color.rgb*shade;\n#endif\n#ifdef RENDER_SHADOWS\ncolor.xyz=shadowed_color_normal(color.xyz,normalize(v_normal),v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;attribute vec4 a_pos_normal_ed;attribute vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nvarying vec4 v_color;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;varying highp vec4 v_pos_light_view_0;varying highp vec4 v_pos_light_view_1;varying highp vec3 v_normal;varying float v_depth;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);float c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);vec3 pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;vec3 pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nv_pos_light_view_0=u_light_matrix_0*vec4(pos,1);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1);v_normal=normal;v_depth=gl_Position.w;\n#endif\nfloat colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);directional*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\nv_color.rgb+=clamp(color.rgb*directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),
            fillExtrusionPattern: pi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 out_color=mix(color1,color2,u_fade);out_color=out_color*v_lighting;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec4 a_pos_normal_ed;attribute vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);float c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);vec3 p=vec3(pos_nx.xy,h);\n#else\nvec3 p=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);directional*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\nv_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}"),
            hillshadePrepare: pi("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nreturn texture2D(u_image,coord).a/4.0;\n#else\nvec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;\n#endif\n}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos);float f=getElevation(v_pos+vec2(epsilon.x,0));float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float h=getElevation(v_pos+vec2(0,epsilon.y));float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: pi("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;void main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef FOG\ngl_FragColor=fog_dither(fog_apply_premultiplied(gl_FragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            line: pi("uniform lowp float u_device_pixel_ratio;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;uniform float u_mix;uniform vec3 u_scale;varying vec2 v_tex_a;varying vec2 v_tex_b;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash_from\n#pragma mapbox: define lowp vec4 dash_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash_from\n#pragma mapbox: initialize lowp vec4 dash_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist_a=texture2D(u_dash_image,v_tex_a).a;float sdfdist_b=texture2D(u_dash_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfwidth=min(dash_from.z*u_scale.y,dash_to.z*u_scale.z);float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/sdfwidth;alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);\n#endif\n#ifdef RENDER_LINE_GRADIENT\nhighp vec4 out_color=texture2D(u_gradient_image,v_uv.xy);\n#else\nvec4 out_color=color;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {if (line_progress <=trim_end && line_progress >=trim_start) {out_color=vec4(0,0,0,0);}}\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef RENDER_LINE_ALPHA_DISCARD\nif (alpha < u_alpha_discard_threshold) {discard;}\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define EXTRUDE_SCALE 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nattribute highp vec4 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nattribute float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform mediump vec3 u_scale;varying vec2 v_tex_a;varying vec2 v_tex_b;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash_from\n#pragma mapbox: define lowp vec4 dash_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash_from\n#pragma mapbox: initialize lowp vec4 dash_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nfloat a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec4(a_uv_x,a_split_index*texel_height-half_texel_height,a_clip_start,a_clip_end);\n#else\nv_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;float scaleA=dash_from.z==0.0 ? 0.0 : tileZoomRatio/(dash_from.z*fromScale);float scaleB=dash_to.z==0.0 ? 0.0 : tileZoomRatio/(dash_to.z*toScale);float heightA=dash_from.y;float heightB=dash_to.y;v_tex_a=vec2(a_linesofar*scaleA/floorwidth,(-normal.y*heightA+dash_from.x+0.5)/u_texsize.y);v_tex_b=vec2(a_linesofar*scaleB/floorwidth,(-normal.y*heightB+dash_to.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),
            linePattern: pi("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_linesofar;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),
            raster: pi("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef FOG\nout_color=fog_dither(fog_apply(out_color,v_fog_pos));\n#endif\ngl_FragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {float w=1.0+dot(a_texture_pos,u_perspective_transform);gl_Position=u_matrix*vec4(a_pos*w,0,w);v_pos0=a_texture_pos/8192.0;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),
            symbolIcon: pi("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_pixeloffset;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);vec3 world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;float globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nvec3 world_pos=vec3(tile_anchor,0)+h;float globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);vec4 offsetProjected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\nvec4 offsetProjected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetProjected_point.xy/offsetProjected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);vec4 projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nvec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nv_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change))*projection_transition_fade;}"),
            symbolSDF: pi("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_pixeloffset;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);vec3 world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;float globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nvec3 world_pos=vec3(tile_anchor,0)+h;float globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);vec4 offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\nvec4 offsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);vec4 projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nvec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset);\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat gamma_scale=gl_Position.w;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity*projection_transition_fade);}"),
            symbolTextAndIcon: pi("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);vec3 world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;float globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nvec3 world_pos=vec3(tile_anchor,0)+h;float globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offset_projected_point=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projected_point.xy/projected_point.w;vec2 b=offset_projected_point.xy/offset_projected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);vec4 projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nvec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*font_scale);\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nv_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity*projection_transition_fade,is_sdf);}"),
            terrainRaster: pi("uniform sampler2D u_image0;varying vec2 v_pos0;\n#ifdef FOG\nvarying float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nvarying vec4 v_pos_light_view_0;varying vec4 v_pos_light_view_1;varying float v_depth;\n#endif\nvoid main() {vec4 color=texture2D(u_image0,v_pos0);\n#ifdef RENDER_SHADOWS\ncolor.xyz=shadowed_color(color.xyz,v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\ngl_FragColor=color;\n#ifdef TERRAIN_WIREFRAME\ngl_FragColor=vec4(1.0,0.0,0.0,0.8);\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_skirt_height;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;\n#ifdef FOG\nvarying float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;varying vec4 v_pos_light_view_0;varying vec4 v_pos_light_view_1;varying float v_depth;\n#endif\nconst float skirtOffset=24575.0;const float wireframeOffset=0.00015;void main() {v_pos0=a_texture_pos/8192.0;float skirt=float(a_pos.x >=skirtOffset);float elevation=elevation(a_texture_pos)-skirt*u_skirt_height;\n#ifdef TERRAIN_WIREFRAME\nelevation+=u_skirt_height*u_skirt_height*wireframeOffset;\n#endif\nvec2 decodedPos=a_pos-vec2(skirt*skirtOffset,0.0);gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);v_depth=gl_Position.w;\n#endif\n}"),
            terrainDepth: pi("#ifdef GL_ES\nprecision highp float;\n#endif\nvarying float v_depth;void main() {gl_FragColor=pack_depth(v_depth);}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying float v_depth;void main() {float elevation=elevation(a_texture_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}"),
            skybox: pi("\nvarying lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=textureCube(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);gl_FragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", ii),
            skyboxGradient: pi("varying highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture2D(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);gl_FragColor=color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", ii),
            skyboxCapture: pi("\nvarying highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;\n#ifdef GL_ES\nprecision highp float;\n#endif\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;gl_FragColor=vec4(color,1.0);}", "attribute highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;varying highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
            globeRaster: pi("uniform sampler2D u_image0;varying vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {\n#ifdef CUSTOM_ANTIALIASING\nvec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);vec3 dir=normalize(ray_dir);vec3 closest_point=dot(u_globe_pos,dir)*dir;float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture2D(u_image0,v_pos0);vec4 color=vec4(raster.rgb*antialias,raster.a*antialias);\n#else\nvec4 color=texture2D(u_image0,v_pos0);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color;\n#ifdef TERRAIN_WIREFRAME\ngl_FragColor=vec4(1.0,0.0,0.0,0.8);\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;\n#ifdef GLOBE_POLES\nattribute vec3 a_globe_pos;attribute vec2 a_uv;\n#else\nattribute vec2 a_pos;\n#endif\nvarying vec2 v_pos0;const float wireframeOffset=1e3;float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(QUARTER_PI+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idy=u_grid_matrix[1][2];float S=u_grid_matrix[2][2];vec3 latLng=u_grid_matrix*vec3(a_pos,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=a_pos[0]*S;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;\n#ifdef GLOBE_POLES\nvec3 up_vector=normalize(globe_pos)*u_tile_up_scale;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);\n#ifdef TERRAIN_WIREFRAME\nheight+=wireframeOffset;\n#endif\nglobe_pos+=up_vector*height;\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}"),
            globeAtmosphere: pi("uniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec3 u_start_color;uniform vec4 u_color;uniform vec4 u_space_color;uniform vec4 u_high_color;uniform float u_star_intensity;uniform float u_star_size;uniform float u_star_density;uniform float u_horizon_angle;uniform mat4 u_rotation_matrix;varying highp vec3 v_ray_dir;varying highp vec3 v_horizon_dir;highp float random(highp vec3 p) {p=fract(p*vec3(23.2342,97.1231,91.2342));p+=dot(p.zxy,p.yxz+123.1234);return fract(p.x*p.y);}float stars(vec3 p,float scale,vec2 offset) {vec2 uv_scale=(u_viewport/u_star_size)*scale;vec3 position=vec3(p.xy*uv_scale+offset*u_viewport,p.z);vec3 q=fract(position)-0.5;vec3 id=floor(position);float random_visibility=step(random(id),u_star_density);float circle=smoothstep(0.5+u_star_intensity,0.5,length(q));return circle*random_visibility;}void main() {highp vec3 dir=normalize(v_ray_dir);\n#ifdef PROJECTION_GLOBE_VIEW\nfloat globe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {discard;return;}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(dot(dir,horizon_dir)),0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;float closest_point_to_center=length(closest_point-u_globe_pos);float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));float horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nfloat horizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;vec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c =mix(color_stop_2,c2,t);float a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);vec2 uv=gl_FragCoord.xy/u_viewport-0.5;float aspect_ratio=u_viewport.x/u_viewport.y;vec4 uv_dir=vec4(normalize(vec3(uv.x*aspect_ratio,uv.y,1.0)),1.0);uv_dir=u_rotation_matrix*uv_dir;vec3 n=abs(uv_dir.xyz);vec2 uv_remap=(n.x > n.y && n.x > n.z) ? uv_dir.yz/uv_dir.x:\n(n.y > n.x && n.y > n.z) ? uv_dir.zx/uv_dir.y:\nuv_dir.xy/uv_dir.z;uv_remap.x/=aspect_ratio;vec3 D=vec3(uv_remap,1.0);highp float star_field=0.0;if (u_star_intensity > 0.0) {star_field+=stars(D,1.2,vec2(0.0,0.0));star_field+=stars(D,1.0,vec2(1.0,0.0));star_field+=stars(D,0.8,vec2(0.0,1.0));star_field+=stars(D,0.6,vec2(1.0,1.0));star_field*=(1.0-pow(t,0.25+(1.0-u_high_color.a)*0.75));c+=star_field*alpha_2;}c=dither(c,gl_FragCoord.xy+u_temporal_offset);gl_FragColor=vec4(c,a);}", "attribute vec3 a_pos;attribute vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;varying highp vec3 v_ray_dir;varying highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}")
        };
        function di(e1, t1) {
            const i = e1.replace(/\s*\/\/[^\n]*\n/g, "\n").split("\n");
            for (let e1 of i)if (e1 = e1.trim(), "#" === e1[0] && e1.includes("if") && !e1.includes("endif")) {
                e1 = e1.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
                const i = e1.split(" ");
                for (const e1 of i)t1.includes(e1) || t1.push(e1);
            }
        }
        function pi(e1, t1) {
            const i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, o = t1.match(/attribute (highp |mediump |lowp )?([\w]+) ([\w]+)/g), r = {}, n = [
                ...li
            ];
            return di(e1, n), di(t1, n), {
                fragmentSource: e1 = e1.replace(i, (e1, t1, i, o, n)=>(r[n] = !0, "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${n}\nvarying ${i} ${o} ${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = u_${n};\n#endif\n`)),
                vertexSource: t1 = t1.replace(i, (e1, t1, i, o, n)=>{
                    const a = "float" === o ? "vec2" : "vec4", s = n.match(/color/) ? "color" : a;
                    return r[n] ? "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nattribute ${i} ${a} a_${n};\nvarying ${i} ${o} ${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = a_${n};\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = unpack_mix_${s}(a_${n}, u_${n}_t);\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n` : "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nattribute ${i} ${a} a_${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = a_${n};\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = unpack_mix_${s}(a_${n}, u_${n}_t);\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n`;
                }),
                staticAttributes: o,
                usedDefines: n
            };
        }
        class mi {
            bind(e1, t1, i, o, r, n, a) {
                this.context = e1;
                let s = this.boundPaintVertexBuffers.length !== o.length;
                for(let e1 = 0; !s && e1 < o.length; e1++)this.boundPaintVertexBuffers[e1] !== o[e1] && (s = !0);
                let l = this.boundDynamicVertexBuffers.length !== a.length;
                for(let e1 = 0; !l && e1 < a.length; e1++)this.boundDynamicVertexBuffers[e1] !== a[e1] && (l = !0);
                if (!e1.extVertexArrayObject || !this.vao || this.boundProgram !== t1 || this.boundLayoutVertexBuffer !== i || s || l || this.boundIndexBuffer !== r || this.boundVertexOffset !== n) this.freshBind(t1, i, o, r, n, a);
                else {
                    e1.bindVertexArrayOES.set(this.vao);
                    for (const e1 of a)e1 && e1.bind();
                    r && r.dynamicDraw && r.bind();
                }
            }
            freshBind(e1, t1, i, o, r, n) {
                let a;
                const s = e1.numAttributes, l = this.context, c = l.gl;
                if (l.extVertexArrayObject) this.vao && this.destroy(), this.vao = l.extVertexArrayObject.createVertexArrayOES(), l.bindVertexArrayOES.set(this.vao), a = 0, this.boundProgram = e1, this.boundLayoutVertexBuffer = t1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = r, this.boundDynamicVertexBuffers = n;
                else {
                    a = l.currentNumAttributes || 0;
                    for(let e1 = s; e1 < a; e1++)c.disableVertexAttribArray(e1);
                }
                t1.enableAttributes(c, e1), t1.bind(), t1.setVertexAttribPointers(c, e1, r);
                for (const t1 of i)t1.enableAttributes(c, e1), t1.bind(), t1.setVertexAttribPointers(c, e1, r);
                for (const t1 of n)t1 && (t1.enableAttributes(c, e1), t1.bind(), t1.setVertexAttribPointers(c, e1, r));
                o && o.bind(), l.currentNumAttributes = s;
            }
            destroy() {
                this.vao && (this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao), this.vao = null);
            }
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
        }
        function fi(t1, i) {
            const o = Math.pow(2, i.canonical.z), r = i.canonical.y;
            return [
                new e1.MercatorCoordinate(0, r / o).toLngLat().lat,
                new e1.MercatorCoordinate(0, (r + 1) / o).toLngLat().lat
            ];
        }
        function gi(t1, i, o, r, n, a, s) {
            const l = t1.context, c = l.gl, h = o.fbo;
            if (!h) return;
            t1.prepareDrawTile();
            const u = t1.useProgram("hillshade");
            l.activeTexture.set(c.TEXTURE0), c.bindTexture(c.TEXTURE_2D, h.colorAttachment.get());
            const _ = ((e1, t1, i, o)=>{
                const r = i.paint.get("hillshade-shadow-color"), n = i.paint.get("hillshade-highlight-color"), a = i.paint.get("hillshade-accent-color");
                let s = i.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                "viewport" === i.paint.get("hillshade-illumination-anchor") && (s -= e1.transform.angle);
                const l = !e1.options.moving;
                return {
                    u_matrix: o || e1.transform.calculateProjMatrix(t1.tileID.toUnwrapped(), l),
                    u_image: 0,
                    u_latrange: fi(0, t1.tileID),
                    u_light: [
                        i.paint.get("hillshade-exaggeration"),
                        s
                    ],
                    u_shadow: r,
                    u_highlight: n,
                    u_accent: a
                };
            })(t1, o, r, t1.terrain ? i.projMatrix : null);
            t1.prepareDrawProgram(l, u, i.toUnwrapped());
            const { tileBoundsBuffer: d, tileBoundsIndexBuffer: p, tileBoundsSegments: m } = t1.getTileBoundsBuffers(o);
            u.draw(l, c.TRIANGLES, n, a, s, e1.CullFaceMode.disabled, _, r.id, d, p, m);
        }
        function vi(t1, i, o) {
            if (!i.needsDEMTextureUpload) return;
            const r = t1.context, n = r.gl;
            r.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || t1.getTileTexture(o.stride);
            const a = o.getPixels();
            i.demTexture ? i.demTexture.update(a, {
                premultiply: !1
            }) : i.demTexture = new e1.Texture(r, a, n.RGBA, {
                premultiply: !1
            }), i.needsDEMTextureUpload = !1;
        }
        function xi(t1, i, o, r, n, a) {
            const s = t1.context, l = s.gl;
            if (!i.dem) return;
            const c = i.dem;
            if (s.activeTexture.set(l.TEXTURE1), vi(t1, i, c), !i.demTexture) return;
            i.demTexture.bind(l.NEAREST, l.CLAMP_TO_EDGE);
            const h = c.dim;
            s.activeTexture.set(l.TEXTURE0);
            let u = i.fbo;
            if (!u) {
                const t1 = new e1.Texture(s, {
                    width: h,
                    height: h,
                    data: null
                }, l.RGBA);
                t1.bind(l.LINEAR, l.CLAMP_TO_EDGE), u = i.fbo = s.createFramebuffer(h, h, !0), u.colorAttachment.set(t1.texture);
            }
            s.bindFramebuffer.set(u.framebuffer), s.viewport.set([
                0,
                0,
                h,
                h
            ]);
            const { tileBoundsBuffer: _, tileBoundsIndexBuffer: d, tileBoundsSegments: p } = t1.getMercatorTileBoundsBuffers();
            t1.useProgram("hillshadePrepare").draw(s, l.TRIANGLES, r, n, a, e1.CullFaceMode.disabled, ((t1, i)=>{
                const o = i.stride, r = e1.create();
                return e1.ortho(r, 0, e1.EXTENT, -e1.EXTENT, 0, 0, 1), e1.translate(r, r, [
                    0,
                    -e1.EXTENT,
                    0
                ]), {
                    u_matrix: r,
                    u_image: 1,
                    u_dimension: [
                        o,
                        o
                    ],
                    u_zoom: t1.overscaledZ,
                    u_unpack: i.unpackVector
                };
            })(i.tileID, c), o.id, _, d, p), i.needsHillshadePrepare = !1;
        }
        const yi = (t1)=>({
                u_matrix: new e1.UniformMatrix4f(t1),
                u_image0: new e1.Uniform1i(t1),
                u_skirt_height: new e1.Uniform1f(t1)
            }), bi = (e1, t1)=>({
                u_matrix: e1,
                u_image0: 0,
                u_skirt_height: t1
            }), wi = (e1, t1, i, o, r, n, a, s, l, c, h, u, _, d)=>({
                u_proj_matrix: Float32Array.from(e1),
                u_globe_matrix: t1,
                u_normalize_matrix: Float32Array.from(o),
                u_merc_matrix: i,
                u_zoom_transition: r,
                u_merc_center: n,
                u_image0: 0,
                u_frustum_tl: a,
                u_frustum_tr: s,
                u_frustum_br: l,
                u_frustum_bl: c,
                u_globe_pos: h,
                u_globe_radius: u,
                u_viewport: _,
                u_grid_matrix: d ? Float32Array.from(d) : new Float32Array(9)
            });
        function Ti(e1, t1) {
            return null != e1 && null != t1 && !(!e1.hasData() || !t1.hasData()) && null != e1.demTexture && null != t1.demTexture && e1.tileID.key !== t1.tileID.key;
        }
        const Ei = new class {
            newMorphing(e1, t1, i, o, r) {
                if (e1 in this.operations) {
                    const t1 = this.operations[e1];
                    t1.to.tileID.key !== i.tileID.key && (t1.queued = i);
                } else this.operations[e1] = {
                    startTime: o,
                    phase: 0,
                    duration: r,
                    from: t1,
                    to: i,
                    queued: null
                };
            }
            getMorphValuesForProxy(e1) {
                if (!(e1 in this.operations)) return null;
                const t1 = this.operations[e1];
                return {
                    from: t1.from,
                    to: t1.to,
                    phase: t1.phase
                };
            }
            update(e1) {
                for(const t1 in this.operations){
                    const i = this.operations[t1];
                    for(i.phase = (e1 - i.startTime) / i.duration; i.phase >= 1 || !this._validOp(i);)if (!this._nextOp(i, e1)) {
                        delete this.operations[t1];
                        break;
                    }
                }
            }
            _nextOp(e1, t1) {
                return !!e1.queued && (e1.from = e1.to, e1.to = e1.queued, e1.queued = null, e1.phase = 0, e1.startTime = t1, !0);
            }
            _validOp(e1) {
                return e1.from.hasData() && e1.to.hasData();
            }
            constructor(){
                this.operations = {};
            }
        }, Ci = {
            0: null,
            1: "TERRAIN_VERTEX_MORPHING",
            2: "TERRAIN_WIREFRAME"
        };
        function Ii(e1, t1) {
            const i = 1 << e1.z;
            return !t1 && (0 === e1.x || e1.x === i - 1) || 0 === e1.y || e1.y === i - 1;
        }
        const Mi = (e1)=>({
                u_matrix: e1
            });
        function Si(t1, i, o, r, n) {
            if (n > 0) {
                const a = e1.exported.now(), s = (a - t1.timeAdded) / n, l = i ? (a - i.timeAdded) / n : -1, c = o.getSource(), h = r.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), u = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(t1.tileID.overscaledZ - h), _ = u && t1.refreshedUponExpiration ? 1 : e1.clamp(u ? s : 1 - l, 0, 1);
                return t1.refreshedUponExpiration && s >= 1 && (t1.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - _
                } : {
                    opacity: _,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        class zi extends e1.SourceCache {
            _loadTile(e1, t1) {
                e1.state = "loaded", t1(null);
            }
            constructor(e1){
                const t1 = {
                    type: "raster-dem",
                    maxzoom: e1.transform.maxZoom
                }, i = new A(Ge(), null), o = Ae("mock-dem", t1, i, e1.style);
                super("mock-dem", o, !1), o.setEventedParent(this), this._sourceLoaded = !0;
            }
        }
        class Di extends e1.SourceCache {
            update(t1, i, o) {
                if (t1.freezeTileCoverage) return;
                this.transform = t1;
                const r = t1.coveringTiles({
                    tileSize: this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled
                }).reduce((i, o)=>{
                    if (i[o.key] = "", !this._tiles[o.key]) {
                        const i = new e1.Tile(o, this._source.tileSize * o.overscaleFactor(), t1.tileZoom);
                        i.state = "loaded", this._tiles[o.key] = i;
                    }
                    return i;
                }, {});
                for(const e1 in this._tiles)e1 in r || (this.freeFBO(e1), this._tiles[e1].unloadVectorData(), delete this._tiles[e1]);
            }
            freeFBO(e1) {
                const t1 = this.proxyCachedFBO[e1];
                if (void 0 !== t1) {
                    const i = Object.values(t1);
                    this.renderCachePool.push(...i), delete this.proxyCachedFBO[e1];
                }
            }
            deallocRenderCache() {
                this.renderCache.forEach((e1)=>e1.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            constructor(e1){
                const t1 = Ae("proxy", {
                    type: "geojson",
                    maxzoom: e1.transform.maxZoom
                }, new A(Ge(), null), e1.style);
                super("proxy", t1, !1), t1.setEventedParent(this), this.map = this.getSource().map = e1, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
        }
        class Pi extends e1.OverscaledTileID {
            constructor(e1, t1, i){
                super(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y), this.proxyTileKey = t1, this.projMatrix = i;
            }
        }
        class Ai extends e1.Elevation {
            set style(e1) {
                e1.on("data", this._onStyleDataEvent.bind(this)), e1.on("neworder", this._checkRenderCacheEfficiency.bind(this)), this._style = e1, this._checkRenderCacheEfficiency();
            }
            update(t1, i, o) {
                if (t1 && t1.terrain) {
                    this._style !== t1 && (this.style = t1), this.enabled = !0;
                    const r = t1.terrain.properties;
                    this.sourceCache = 0 === t1.terrain.drapeRenderMode ? this._mockSourceCache : t1._getSourceCache(r.get("source")), this._exaggeration = r.get("exaggeration");
                    const n = ()=>{
                        this.sourceCache.used && e1.warnOnce(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                        const t1 = this.getScaledDemTileSize();
                        this.sourceCache.update(i, t1, !0), this.resetTileLookupCache(this.sourceCache.id);
                    };
                    this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, n(), this._initializing = !0), n(), i.updateElevation(!o), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i), this._emptyDEMTextureDirty = !0;
                } else this._disable();
            }
            resetTileLookupCache(e1) {
                this._findCoveringTileCache[e1] = {};
            }
            getScaledDemTileSize() {
                return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _checkRenderCacheEfficiency() {
                const t1 = this.renderCacheEfficiency(this._style);
                this._style.map._optimizeForTerrain || 100 !== t1.efficiency && e1.warnOnce(`Terrain render cache efficiency is not optimal (${t1.efficiency}%) and performance\n                may be affected negatively, consider placing all background, fill and line layers before layer\n                with id '${t1.firstUndrapedLayer}' or create a map using optimizeForTerrain: true option.`);
            }
            _onStyleDataEvent(e1) {
                e1.coord && "source" === e1.dataType ? this._clearRenderCacheForTile(e1.sourceCacheId, e1.coord) : "style" === e1.dataType && (this._invalidateRenderCache = !0);
            }
            _disable() {
                if (this.enabled && (this.enabled = !1, this._sharedDepthStencil = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for(const e1 in this._style._sourceCaches)this._style._sourceCaches[e1].usedForTerrain = !1;
            }
            destroy() {
                this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this._emptyDepthBufferTexture && this._emptyDepthBufferTexture.destroy(), this.pool.forEach((e1)=>e1.fb.destroy()), this.pool = [], this._depthFBO && (this._depthFBO.destroy(), this._depthFBO = void 0, this._depthTexture = void 0);
            }
            _source() {
                return this.enabled ? this.sourceCache : null;
            }
            exaggeration() {
                return this._exaggeration;
            }
            get visibleDemTiles() {
                return this._visibleDemTiles;
            }
            get drapeBufferSize() {
                const e1 = 2 * this.proxySourceCache.getSource().tileSize;
                return [
                    e1,
                    e1
                ];
            }
            set useVertexMorphing(e1) {
                this._useVertexMorphing = e1;
            }
            updateTileBinding(t1) {
                if (!this.enabled) return;
                this.prevTerrainTileForTile = this.terrainTileForTile;
                const i = this.proxySourceCache, o = this.painter.transform;
                this._initializing && (this._initializing = 0 === o._centerAltitude && -1 === this.getAtPointOrZero(e1.MercatorCoordinate.fromLngLat(o.center), -1), this._emptyDEMTextureDirty = !this._initializing);
                const r = this.proxyCoords = i.getIds().map((e1)=>{
                    const t1 = i.getTileByID(e1).tileID;
                    return t1.projMatrix = o.calculateProjMatrix(t1.toUnwrapped()), t1;
                });
                !function(t1, i) {
                    const o = i.transform.pointCoordinate(i.transform.getCameraPoint()), r = new e1.pointGeometry(o.x, o.y);
                    t1.sort((t1, i)=>{
                        if (i.overscaledZ - t1.overscaledZ) return i.overscaledZ - t1.overscaledZ;
                        const o = new e1.pointGeometry(t1.canonical.x + (1 << t1.canonical.z) * t1.wrap, t1.canonical.y), n = new e1.pointGeometry(i.canonical.x + (1 << i.canonical.z) * i.wrap, i.canonical.y), a = r.mult(1 << t1.canonical.z);
                        return a.x -= .5, a.y -= .5, a.distSqr(o) - a.distSqr(n);
                    });
                }(r, this.painter), this._previousZoom = o.zoom;
                const n = this.proxyToSource || {};
                this.proxyToSource = {}, r.forEach((e1)=>{
                    this.proxyToSource[e1.key] = {};
                }), this.terrainTileForTile = {};
                const a = this._style._sourceCaches;
                for(const e1 in a){
                    const i = a[e1];
                    if (!i.used) continue;
                    if (i !== this.sourceCache && this.resetTileLookupCache(i.id), this._setupProxiedCoordsForOrtho(i, t1[e1], n), i.usedForTerrain) continue;
                    const o = t1[e1];
                    i.getSource().reparseOverscaled && this._assignTerrainTiles(o);
                }
                this.proxiedCoords[i.id] = r.map((e1)=>new Pi(e1, e1.key, this.orthoMatrix)), this._assignTerrainTiles(r), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(n), this.renderingToTexture = !1, this._updateTimestamp = e1.exported.now();
                const s = {};
                this._visibleDemTiles = [];
                for (const e1 of this.proxyCoords){
                    const t1 = this.terrainTileForTile[e1.key];
                    if (!t1) continue;
                    const i = t1.tileID.key;
                    i in s || (this._visibleDemTiles.push(t1), s[i] = i);
                }
            }
            _assignTerrainTiles(e1) {
                this._initializing || e1.forEach((e1)=>{
                    if (this.terrainTileForTile[e1.key]) return;
                    const t1 = this._findTileCoveringTileID(e1, this.sourceCache);
                    t1 && (this.terrainTileForTile[e1.key] = t1);
                });
            }
            _prepareDEMTextures() {
                const e1 = this.painter.context, t1 = e1.gl;
                for(const i in this.terrainTileForTile){
                    const o = this.terrainTileForTile[i], r = o.dem;
                    !r || o.demTexture && !o.needsDEMTextureUpload || (e1.activeTexture.set(t1.TEXTURE1), vi(this.painter, o, r));
                }
            }
            _prepareDemTileUniforms(e1, t1, i, o) {
                if (!t1 || null == t1.demTexture) return !1;
                const r = e1.tileID.canonical, n = Math.pow(2, t1.tileID.canonical.z - r.z), a = o || "";
                return i[`u_dem_tl${a}`] = [
                    r.x * n % 1,
                    r.y * n % 1
                ], i[`u_dem_scale${a}`] = n, !0;
            }
            get emptyDEMTexture() {
                return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            get emptyDepthBufferTexture() {
                const t1 = this.painter.context, i = t1.gl;
                if (!this._emptyDepthBufferTexture) {
                    const o = new e1.RGBAImage({
                        width: 1,
                        height: 1
                    }, Uint8Array.of(255, 255, 255, 255));
                    this._emptyDepthBufferTexture = new e1.Texture(t1, o, i.RGBA, {
                        premultiply: !1
                    });
                }
                return this._emptyDepthBufferTexture;
            }
            _getLoadedAreaMinimum() {
                let e1 = 0;
                const t1 = this._visibleDemTiles.reduce((t1, i)=>{
                    if (!i.dem) return t1;
                    const o = i.dem.tree.minimums[0];
                    return o > 0 && e1++, t1 + o;
                }, 0);
                return e1 ? t1 / e1 : 0;
            }
            _updateEmptyDEMTexture() {
                const t1 = this.painter.context, i = t1.gl;
                t1.activeTexture.set(i.TEXTURE2);
                const o = this._getLoadedAreaMinimum(), r = new e1.RGBAImage({
                    width: 1,
                    height: 1
                }, new Uint8Array(e1.DEMData.pack(o, this.sourceCache.getSource().encoding)));
                this._emptyDEMTextureDirty = !1;
                let n = this._emptyDEMTexture;
                return n ? n.update(r, {
                    premultiply: !1
                }) : n = this._emptyDEMTexture = new e1.Texture(t1, r, i.RGBA, {
                    premultiply: !1
                }), n;
            }
            setupElevationDraw(t1, i, o) {
                const r = this.painter.context, n = r.gl, a = (s = this.sourceCache.getSource().encoding, {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_unpack: e1.DEMData.getUnpackVector(s),
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_exaggeration: 0,
                    u_tile_tl_up: [
                        0,
                        0,
                        1
                    ],
                    u_tile_tr_up: [
                        0,
                        0,
                        1
                    ],
                    u_tile_br_up: [
                        0,
                        0,
                        1
                    ],
                    u_tile_bl_up: [
                        0,
                        0,
                        1
                    ],
                    u_tile_up_scale: 1
                });
                var s;
                a.u_dem_size = this.sourceCache.getSource().tileSize, a.u_exaggeration = this.exaggeration();
                const l = this.painter.transform, c = l.projection, h = t1.tileID.canonical;
                a.u_tile_tl_up = c.upVector(h, 0, 0), a.u_tile_tr_up = c.upVector(h, e1.EXTENT, 0), a.u_tile_br_up = c.upVector(h, e1.EXTENT, e1.EXTENT), a.u_tile_bl_up = c.upVector(h, 0, e1.EXTENT), a.u_tile_up_scale = o && o.useDenormalizedUpVectorScale ? e1.GLOBE_METERS_TO_ECEF : c.upVectorScale(h, l.center.lat, l.worldSize).metersToTile;
                let u = null, _ = null, d = 1;
                if (o && o.morphing && this._useVertexMorphing) {
                    const e1 = o.morphing.srcDemTile, i = o.morphing.dstDemTile;
                    d = o.morphing.phase, e1 && i && (this._prepareDemTileUniforms(t1, e1, a, "_prev") && (_ = e1), this._prepareDemTileUniforms(t1, i, a) && (u = i));
                }
                if (_ && u ? (r.activeTexture.set(n.TEXTURE2), u.demTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE, n.NEAREST), r.activeTexture.set(n.TEXTURE4), _.demTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE, n.NEAREST), a.u_dem_lerp = d) : (u = this.terrainTileForTile[t1.tileID.key], r.activeTexture.set(n.TEXTURE2), (this._prepareDemTileUniforms(t1, u, a) ? u.demTexture : this.emptyDEMTexture).bind(n.NEAREST, n.CLAMP_TO_EDGE)), r.activeTexture.set(n.TEXTURE3), o && o.useDepthForOcclusion ? (this._depthTexture && this._depthTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE), this._depthFBO && (a.u_depth_size_inv = [
                    1 / this._depthFBO.width,
                    1 / this._depthFBO.height
                ])) : (this.emptyDepthBufferTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE), a.u_depth_size_inv = [
                    1,
                    1
                ]), o && o.useMeterToDem && u) {
                    const t1 = (1 << u.tileID.canonical.z) * e1.mercatorZfromAltitude(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                    a.u_meter_to_dem = t1;
                }
                o && o.labelPlaneMatrixInv && (a.u_label_plane_matrix_inv = o.labelPlaneMatrixInv), i.setTerrainUniformValues(r, a);
            }
            renderToBackBuffer(t1) {
                const i = this.painter, o = this.painter.context;
                0 !== t1.length && (o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), i.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(t1, i, o, r, n) {
                    if ("globe" === t1.transform.projection.name) !function(t1, i, o, r, n) {
                        const a = t1.context, s = a.gl;
                        let l, c;
                        const h = t1.options.showTerrainWireframe ? 2 : 0, u = t1.transform, _ = e1.globeUseCustomAntiAliasing(t1, a, u), d = (e1, i)=>{
                            if (c === e1) return;
                            const o = [
                                Ci[e1],
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            _ && o.push("CUSTOM_ANTIALIASING"), i && o.push(Ci[h]), l = t1.useProgram("globeRaster", null, o), c = e1;
                        }, p = t1.colorModeForRenderPass(), m = new e1.DepthMode(s.LEQUAL, e1.DepthMode.ReadWrite, t1.depthRangeFor3D);
                        Ei.update(n);
                        const f = e1.calculateGlobeMercatorMatrix(u), g = [
                            e1.mercatorXfromLng(u.center.lng),
                            e1.mercatorYfromLat(u.center.lat)
                        ], v = h ? [
                            !1,
                            !0
                        ] : [
                            !1
                        ], x = t1.globeSharedBuffers, y = [
                            u.width * e1.exported.devicePixelRatio,
                            u.height * e1.exported.devicePixelRatio
                        ], b = Float32Array.from(u.globeMatrix), w = {
                            useDenormalizedUpVectorScale: !0
                        };
                        if (v.forEach((h)=>{
                            c = -1;
                            const _ = h ? s.LINES : s.TRIANGLES;
                            for (const c of r){
                                const r = o.getTile(c), v = e1.StencilMode.disabled, T = i.prevTerrainTileForTile[c.key], E = i.terrainTileForTile[c.key];
                                Ti(T, E) && Ei.newMorphing(c.key, T, E, n, 250), a.activeTexture.set(s.TEXTURE0), r.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                                const C = Ei.getMorphValuesForProxy(c.key), I = C ? 1 : 0;
                                C && e1.extend$1(w, {
                                    morphing: {
                                        srcDemTile: C.from,
                                        dstDemTile: C.to,
                                        phase: e1.easeCubicInOut(C.phase)
                                    }
                                });
                                const M = e1.tileCornersToBounds(c.canonical), S = e1.getLatitudinalLod(M.getCenter().lat), z = e1.getGridMatrix(c.canonical, M, S), D = e1.globeNormalizeECEF(e1.globeTileBounds(c.canonical)), P = wi(u.projMatrix, b, f, D, e1.globeToMercatorTransition(u.zoom), g, u.frustumCorners.TL, u.frustumCorners.TR, u.frustumCorners.BR, u.frustumCorners.BL, u.globeCenterInViewSpace, u.globeRadius, y, z);
                                if (d(I, h), i.setupElevationDraw(r, l, w), t1.prepareDrawProgram(a, l, c.toUnwrapped()), x) {
                                    const [i, o, r] = h ? x.getWirefameBuffers(t1.context, S) : x.getGridBuffers(S);
                                    l.draw(a, _, m, v, p, e1.CullFaceMode.backCCW, P, "globe_raster", i, o, r);
                                }
                            }
                        }), x) {
                            const n = [
                                "GLOBE_POLES",
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            _ && n.push("CUSTOM_ANTIALIASING"), l = t1.useProgram("globeRaster", null, n);
                            for (const n of r){
                                const { x: r, y: c, z: h } = n.canonical, _ = 0 === c, d = c === (1 << h) - 1, [f, v, b, T] = x.getPoleBuffers(h);
                                if (T && (_ || d)) {
                                    const c = o.getTile(n);
                                    a.activeTexture.set(s.TEXTURE0), c.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                                    let x = e1.globePoleMatrixForTile(h, r, u);
                                    const E = e1.globeNormalizeECEF(e1.globeTileBounds(n.canonical)), C = (t1, i)=>t1.draw(a, s.TRIANGLES, m, e1.StencilMode.disabled, p, e1.CullFaceMode.disabled, wi(u.projMatrix, x, x, E, 0, g, u.frustumCorners.TL, u.frustumCorners.TR, u.frustumCorners.BR, u.frustumCorners.BL, u.globeCenterInViewSpace, u.globeRadius, y), "globe_pole_raster", i, b, T);
                                    i.setupElevationDraw(c, l, w), t1.prepareDrawProgram(a, l, n.toUnwrapped()), _ && C(l, f), d && (x = e1.scale(e1.create(), x, [
                                        1,
                                        -1,
                                        1
                                    ]), C(l, v));
                                }
                            }
                        }
                    }(t1, i, o, r, n);
                    else {
                        const a = t1.context, s = a.gl;
                        let l, c;
                        const h = t1.options.showTerrainWireframe ? 2 : 0, u = (e1, i)=>{
                            if (c === e1) return;
                            const o = [
                                Ci[e1]
                            ];
                            i && o.push(Ci[h]), l = t1.useProgram("terrainRaster", null, o), c = e1;
                        }, _ = t1.colorModeForRenderPass(), d = new e1.DepthMode(s.LEQUAL, e1.DepthMode.ReadWrite, t1.depthRangeFor3D);
                        Ei.update(n);
                        const p = t1.transform, m = 6 * Math.pow(1.5, 22 - p.zoom) * i.exaggeration();
                        (h ? [
                            !1,
                            !0
                        ] : [
                            !1
                        ]).forEach((h)=>{
                            c = -1;
                            const f = h ? s.LINES : s.TRIANGLES, [g, v] = h ? i.getWirefameBuffer() : [
                                i.gridIndexBuffer,
                                i.gridSegments
                            ];
                            for (const c of r){
                                const r = o.getTile(c), x = e1.StencilMode.disabled, y = i.prevTerrainTileForTile[c.key], b = i.terrainTileForTile[c.key];
                                Ti(y, b) && Ei.newMorphing(c.key, y, b, n, 250), a.activeTexture.set(s.TEXTURE0), r.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE, s.LINEAR_MIPMAP_NEAREST);
                                const w = Ei.getMorphValuesForProxy(c.key), T = w ? 1 : 0;
                                let E;
                                w && (E = {
                                    morphing: {
                                        srcDemTile: w.from,
                                        dstDemTile: w.to,
                                        phase: e1.easeCubicInOut(w.phase)
                                    }
                                });
                                const C = bi(c.projMatrix, Ii(c.canonical, p.renderWorldCopies) ? m / 10 : m);
                                u(T, h), i.setupElevationDraw(r, l, E), t1.prepareDrawProgram(a, l, c.toUnwrapped()), l.draw(a, f, d, x, _, e1.CullFaceMode.backCCW, C, "terrain_raster", i.gridBuffer, g, v);
                            }
                        });
                    }
                }(i, this, this.proxySourceCache, t1, this._updateTimestamp), this.renderingToTexture = !0, i.gpuTimingDeferredRenderEnd(), t1.splice(0, t1.length));
            }
            renderBatch(t1) {
                if (0 === this._drapedRenderBatches.length) return t1 + 1;
                this.renderingToTexture = !0;
                const i = this.painter, o = this.painter.context, r = this.proxySourceCache, n = this.proxiedCoords[r.id], a = this._drapedRenderBatches.shift(), s = [], l = i.style.order;
                let c = 0;
                for (const h of n){
                    const n = r.getTileByID(h.proxyTileKey), u = r.proxyCachedFBO[h.key] ? r.proxyCachedFBO[h.key][t1] : void 0, _ = void 0 !== u ? r.renderCache[u] : this.pool[c++], d = void 0 !== u;
                    if (n.texture = _.tex, d && !_.dirty) {
                        s.push(n.tileID);
                        continue;
                    }
                    let p;
                    o.bindFramebuffer.set(_.fb.framebuffer), this.renderedToTile = !1, _.dirty && (o.clear({
                        color: e1.Color.transparent,
                        stencil: 0
                    }), _.dirty = !1);
                    for(let e1 = a.start; e1 <= a.end; ++e1){
                        const t1 = i.style._layers[l[e1]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const r = i.style._getLayerSourceCache(t1), n = r ? this.proxyToSource[h.key][r.id] : [
                            h
                        ];
                        if (!n) continue;
                        const a = n;
                        o.viewport.set([
                            0,
                            0,
                            _.fb.width,
                            _.fb.height
                        ]), p !== (r ? r.id : null) && (this._setupStencil(_, n, t1, r), p = r ? r.id : null), i.renderLayer(i, r, t1, a);
                    }
                    this.renderedToTile ? (_.dirty = !0, s.push(n.tileID)) : d || --c, 5 === c && (c = 0, this.renderToBackBuffer(s));
                }
                return this.renderToBackBuffer(s), this.renderingToTexture = !1, o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), a.end + 1;
            }
            postRender() {}
            renderCacheEfficiency(e1) {
                const t1 = e1.order.length;
                if (0 === t1) return {
                    efficiency: 100
                };
                let i, o = 0, r = 0, n = !1;
                for(let a = 0; a < t1; ++a){
                    const t1 = e1._layers[e1.order[a]];
                    this._style.isLayerDraped(t1) ? (n && ++o, ++r) : n || (n = !0, i = t1.id);
                }
                return 0 === r ? {
                    efficiency: 100
                } : {
                    efficiency: 100 * (1 - o / r),
                    firstUndrapedLayer: i
                };
            }
            getMinElevationBelowMSL() {
                let e1 = 0;
                return this._visibleDemTiles.filter((e1)=>e1.dem).forEach((t1)=>{
                    e1 = Math.min(e1, t1.dem.tree.minimums[0]);
                }), 0 === e1 ? e1 : (e1 - 30) * this._exaggeration;
            }
            raycast(e1, t1, i) {
                if (!this._visibleDemTiles) return null;
                const o = this._visibleDemTiles.filter((e1)=>e1.dem).map((o)=>{
                    const r = o.tileID, n = 1 << r.overscaledZ, { x: a, y: s } = r.canonical, l = a / n, c = (a + 1) / n, h = s / n, u = (s + 1) / n;
                    return {
                        minx: l,
                        miny: h,
                        maxx: c,
                        maxy: u,
                        t: o.dem.tree.raycastRoot(l, h, c, u, e1, t1, i),
                        tile: o
                    };
                });
                o.sort((e1, t1)=>(null !== e1.t ? e1.t : Number.MAX_VALUE) - (null !== t1.t ? t1.t : Number.MAX_VALUE));
                for (const r of o){
                    if (null == r.t) return null;
                    const o = r.tile.dem.tree.raycast(r.minx, r.miny, r.maxx, r.maxy, e1, t1, i);
                    if (null != o) return o;
                }
                return null;
            }
            _createFBO() {
                const t1 = this.painter.context, i = t1.gl, o = this.drapeBufferSize;
                t1.activeTexture.set(i.TEXTURE0);
                const r = new e1.Texture(t1, {
                    width: o[0],
                    height: o[1],
                    data: null
                }, i.RGBA);
                r.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                const n = t1.createFramebuffer(o[0], o[1], !1);
                return n.colorAttachment.set(r.texture), n.depthAttachment = new Ee(t1, n.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t1.createRenderbuffer(t1.gl.DEPTH_STENCIL, o[0], o[1]), this._stencilRef = 0, n.depthAttachment.set(this._sharedDepthStencil), t1.clear({
                    stencil: 0
                })) : n.depthAttachment.set(this._sharedDepthStencil), t1.extTextureFilterAnisotropic && !t1.extTextureFilterAnisotropicForceOff && i.texParameterf(i.TEXTURE_2D, t1.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t1.extTextureFilterAnisotropicMax), {
                    fb: n,
                    tex: r,
                    dirty: !1
                };
            }
            _initFBOPool() {
                for(; this.pool.length < Math.min(5, this.proxyCoords.length);)this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
                if (this._style.light && this._style.light.hasTransition()) return !0;
                for(const e1 in this._style._sourceCaches)if (this._style._sourceCaches[e1].hasTransition()) return !0;
                return this._style.order.some((e1)=>{
                    const t1 = this._style._layers[e1], i = t1.isHidden(this.painter.transform.zoom), o = t1.getCrossfadeParameters(), r = !!o && 1 !== o.t, n = t1.hasTransition();
                    return "custom" !== t1.type && !i && (r || n);
                });
            }
            _clearRasterFadeFromRenderCache() {
                let e1 = !1;
                for(const t1 in this._style._sourceCaches)if (this._style._sourceCaches[t1]._source instanceof Me) {
                    e1 = !0;
                    break;
                }
                if (e1) for(let e1 = 0; e1 < this._style.order.length; ++e1){
                    const t1 = this._style._layers[this._style.order[e1]], i = t1.isHidden(this.painter.transform.zoom), o = this._style._getLayerSourceCache(t1);
                    if ("raster" !== t1.type || i || !o) continue;
                    const r = t1.paint.get("raster-fade-duration");
                    for (const e1 of this.proxyCoords){
                        const t1 = this.proxyToSource[e1.key][o.id];
                        if (t1) for (const e1 of t1){
                            const t1 = Si(o.getTile(e1), o.findLoadedParent(e1, 0), o, this.painter.transform, r);
                            (1 !== t1.opacity || 0 !== t1.mix) && this._clearRenderCacheForTile(o.id, e1);
                        }
                    }
                }
            }
            _setupDrapedRenderBatches() {
                const e1 = this._style.order, t1 = e1.length;
                if (0 === t1) return;
                const i = [];
                let o, r = 0, n = this._style._layers[e1[r]];
                for(; !this._style.isLayerDraped(n) && n.isHidden(this.painter.transform.zoom) && ++r < t1;)n = this._style._layers[e1[r]];
                for(; r < t1; ++r){
                    const t1 = this._style._layers[e1[r]];
                    t1.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(t1) ? void 0 === o && (o = r) : void 0 !== o && (i.push({
                        start: o,
                        end: r - 1
                    }), o = void 0));
                }
                void 0 !== o && i.push({
                    start: o,
                    end: r - 1
                }), this._drapedRenderBatches = i;
            }
            _setupRenderCache(e1) {
                const t1 = this.proxySourceCache;
                if (this._shouldDisableRenderCache() || this._invalidateRenderCache) {
                    if (this._invalidateRenderCache = !1, t1.renderCache.length > t1.renderCachePool.length) {
                        const e1 = Object.values(t1.proxyCachedFBO);
                        t1.proxyCachedFBO = {};
                        for(let i = 0; i < e1.length; ++i){
                            const o = Object.values(e1[i]);
                            t1.renderCachePool.push(...o);
                        }
                    }
                    return;
                }
                this._clearRasterFadeFromRenderCache();
                const i = this.proxyCoords, o = this._tilesDirty;
                for(let r = i.length - 1; r >= 0; r--){
                    const n = i[r];
                    if (t1.getTileByID(n.key), void 0 !== t1.proxyCachedFBO[n.key]) {
                        const i = e1[n.key], r = this.proxyToSource[n.key];
                        let a = 0;
                        for(const e1 in r){
                            const t1 = r[e1], n = i[e1];
                            if (!n || n.length !== t1.length || t1.some((t1, i)=>t1 !== n[i] || o[e1] && o[e1].hasOwnProperty(t1.key))) {
                                a = -1;
                                break;
                            }
                            ++a;
                        }
                        for(const e1 in t1.proxyCachedFBO[n.key])t1.renderCache[t1.proxyCachedFBO[n.key][e1]].dirty = a < 0 || a !== Object.values(i).length;
                    }
                }
                const r = [
                    ...this._drapedRenderBatches
                ];
                r.sort((e1, t1)=>t1.end - t1.start - (e1.end - e1.start));
                for (const e1 of r)for (const o of i){
                    if (t1.proxyCachedFBO[o.key]) continue;
                    let i = t1.renderCachePool.pop();
                    void 0 === i && t1.renderCache.length < 50 && (i = t1.renderCache.length, t1.renderCache.push(this._createFBO())), void 0 !== i && (t1.proxyCachedFBO[o.key] = {}, t1.proxyCachedFBO[o.key][e1.start] = i, t1.renderCache[i].dirty = !0);
                }
                this._tilesDirty = {};
            }
            _setupStencil(e1, t1, i, o) {
                if (!o || !this._sourceTilesOverlap[o.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
                const r = this.painter.context, n = r.gl;
                if (t1.length <= 1) return void (this._overlapStencilType = !1);
                let a;
                if (i.isTileClipped()) a = t1.length, this._overlapStencilMode.test = {
                    func: n.EQUAL,
                    mask: 255
                }, this._overlapStencilType = "Clip";
                else {
                    if (!(t1[0].overscaledZ > t1[t1.length - 1].overscaledZ)) return void (this._overlapStencilType = !1);
                    a = 1, this._overlapStencilMode.test = {
                        func: n.GREATER,
                        mask: 255
                    }, this._overlapStencilType = "Mask";
                }
                this._stencilRef + a > 255 && (r.clear({
                    stencil: 0
                }), this._stencilRef = 0), this._stencilRef += a, this._overlapStencilMode.ref = this._stencilRef, i.isTileClipped() && this._renderTileClippingMasks(t1, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
                return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            stencilModeForRTTOverlap(t1) {
                return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[t1.key]), this._overlapStencilMode) : e1.StencilMode.disabled;
            }
            _renderTileClippingMasks(t1, i) {
                const o = this.painter, r = this.painter.context, n = r.gl;
                o._tileClippingMaskIDs = {}, r.setColorMode(e1.ColorMode.disabled), r.setDepthMode(e1.DepthMode.disabled);
                const a = o.useProgram("clippingMask");
                for (const s of t1){
                    const t1 = o._tileClippingMaskIDs[s.key] = --i;
                    a.draw(r, n.TRIANGLES, e1.DepthMode.disabled, new e1.StencilMode({
                        func: n.ALWAYS,
                        mask: 0
                    }, t1, 255, n.KEEP, n.KEEP, n.REPLACE), e1.ColorMode.disabled, e1.CullFaceMode.disabled, Mi(s.projMatrix), "$clipping", o.tileExtentBuffer, o.quadTriangleIndexBuffer, o.tileExtentSegments);
                }
            }
            pointCoordinate(t1) {
                const i = this.painter.transform;
                if (t1.x < 0 || t1.x > i.width || t1.y < 0 || t1.y > i.height) return null;
                const o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e1.transformMat4$1(o, o, i.pixelMatrixInverse), e1.scale$1(o, o, 1 / o[3]), o[0] /= i.worldSize, o[1] /= i.worldSize;
                const r = i._camera.position, n = e1.mercatorZfromAltitude(1, i.center.lat), a = [
                    r[0],
                    r[1],
                    r[2] / n,
                    0
                ], s = e1.subtract([], o.slice(0, 3), a);
                e1.normalize(s, s);
                const l = this.raycast(a, s, this._exaggeration);
                return null !== l && l ? (e1.scaleAndAdd(a, a, s, l), a[3] = a[2], a[2] *= n, a) : null;
            }
            drawDepth() {
                const t1 = this.painter, i = t1.context, o = this.proxySourceCache, r = Math.ceil(t1.width), n = Math.ceil(t1.height);
                if (!this._depthFBO || this._depthFBO.width === r && this._depthFBO.height === n || (this._depthFBO.destroy(), this._depthFBO = void 0, this._depthTexture = void 0), !this._depthFBO) {
                    const t1 = i.gl, o = i.createFramebuffer(r, n, !0);
                    i.activeTexture.set(t1.TEXTURE0);
                    const a = new e1.Texture(i, {
                        width: r,
                        height: n,
                        data: null
                    }, t1.RGBA);
                    a.bind(t1.NEAREST, t1.CLAMP_TO_EDGE), o.colorAttachment.set(a.texture);
                    const s = i.createRenderbuffer(i.gl.DEPTH_COMPONENT16, r, n);
                    o.depthAttachment.set(s), this._depthFBO = o, this._depthTexture = a;
                }
                i.bindFramebuffer.set(this._depthFBO.framebuffer), i.viewport.set([
                    0,
                    0,
                    r,
                    n
                ]), function(t1, i, o, r) {
                    if ("globe" === t1.transform.projection.name) return;
                    const n = t1.context, a = n.gl;
                    n.clear({
                        depth: 1
                    });
                    const s = t1.useProgram("terrainDepth"), l = new e1.DepthMode(a.LESS, e1.DepthMode.ReadWrite, t1.depthRangeFor3D);
                    for (const t1 of r){
                        const r = o.getTile(t1), c = bi(t1.projMatrix, 0);
                        i.setupElevationDraw(r, s), s.draw(n, a.TRIANGLES, l, e1.StencilMode.disabled, e1.ColorMode.unblended, e1.CullFaceMode.backCCW, c, "terrain_depth", i.gridBuffer, i.gridIndexBuffer, i.gridNoSkirtSegments);
                    }
                }(t1, this, o, this.proxyCoords);
            }
            _setupProxiedCoordsForOrtho(e1, t1, i) {
                if (e1.getSource() instanceof De) return this._setupProxiedCoordsForImageSource(e1, t1, i);
                this._findCoveringTileCache[e1.id] = this._findCoveringTileCache[e1.id] || {};
                const o = this.proxiedCoords[e1.id] = [], r = this.proxyCoords;
                for(let t1 = 0; t1 < r.length; t1++){
                    const n = r[t1], a = this._findTileCoveringTileID(n, e1);
                    if (a) {
                        const t1 = this._createProxiedId(n, a, i[n.key] && i[n.key][e1.id]);
                        o.push(t1), this.proxyToSource[n.key][e1.id] = [
                            t1
                        ];
                    }
                }
                let n = !1;
                for(let r = 0; r < t1.length; r++){
                    const a = e1.getTile(t1[r]);
                    if (!a || !a.hasData()) continue;
                    const s = this._findTileCoveringTileID(a.tileID, this.proxySourceCache);
                    if (s && s.tileID.canonical.z !== a.tileID.canonical.z) {
                        const t1 = this.proxyToSource[s.tileID.key][e1.id], r = this._createProxiedId(s.tileID, a, i[s.tileID.key] && i[s.tileID.key][e1.id]);
                        t1 ? t1.splice(t1.length - 1, 0, r) : this.proxyToSource[s.tileID.key][e1.id] = [
                            r
                        ], o.push(r), n = !0;
                    }
                }
                this._sourceTilesOverlap[e1.id] = n;
            }
            _setupProxiedCoordsForImageSource(t1, i, o) {
                if (!t1.getSource().loaded()) return;
                const r = this.proxiedCoords[t1.id] = [], n = this.proxyCoords, a = t1.getSource(), s = new e1.pointGeometry(a.tileID.x, a.tileID.y)._div(1 << a.tileID.z), l = a.coordinates.map(e1.MercatorCoordinate.fromLngLat).reduce((e1, t1)=>(e1.min.x = Math.min(e1.min.x, t1.x - s.x), e1.min.y = Math.min(e1.min.y, t1.y - s.y), e1.max.x = Math.max(e1.max.x, t1.x - s.x), e1.max.y = Math.max(e1.max.y, t1.y - s.y), e1), {
                    min: new e1.pointGeometry(Number.MAX_VALUE, Number.MAX_VALUE),
                    max: new e1.pointGeometry(-Number.MAX_VALUE, -Number.MAX_VALUE)
                }), c = (t1, i)=>{
                    const o = t1.wrap + t1.canonical.x / (1 << t1.canonical.z), r = t1.canonical.y / (1 << t1.canonical.z), n = e1.EXTENT / (1 << t1.canonical.z), a = i.wrap + i.canonical.x / (1 << i.canonical.z), s = i.canonical.y / (1 << i.canonical.z);
                    return o + n < a + l.min.x || o > a + l.max.x || r + n < s + l.min.y || r > s + l.max.y;
                };
                for(let e1 = 0; e1 < n.length; e1++){
                    const a = n[e1];
                    for(let e1 = 0; e1 < i.length; e1++){
                        const n = t1.getTile(i[e1]);
                        if (!n || !n.hasData()) continue;
                        if (c(a, n.tileID)) continue;
                        const s = this._createProxiedId(a, n, o[a.key] && o[a.key][t1.id]), l = this.proxyToSource[a.key][t1.id];
                        l ? l.push(s) : this.proxyToSource[a.key][t1.id] = [
                            s
                        ], r.push(s);
                    }
                }
            }
            _createProxiedId(t1, i, o) {
                let r = this.orthoMatrix;
                if (o) {
                    const e1 = o.find((e1)=>e1.key === i.tileID.key);
                    if (e1) return e1;
                }
                if (i.tileID.key !== t1.key) {
                    const o = t1.canonical.z - i.tileID.canonical.z;
                    let n, a, s;
                    r = e1.create();
                    const l = i.tileID.wrap - t1.wrap << t1.overscaledZ;
                    o > 0 ? (n = e1.EXTENT >> o, a = n * ((i.tileID.canonical.x << o) - t1.canonical.x + l), s = n * ((i.tileID.canonical.y << o) - t1.canonical.y)) : (n = e1.EXTENT << -o, a = e1.EXTENT * (i.tileID.canonical.x - (t1.canonical.x + l << -o)), s = e1.EXTENT * (i.tileID.canonical.y - (t1.canonical.y << -o))), e1.ortho(r, 0, n, 0, n, 0, 1), e1.translate(r, r, [
                        a,
                        s,
                        0
                    ]);
                }
                return new Pi(i.tileID, t1.key, r);
            }
            _findTileCoveringTileID(t1, i) {
                let o = i.getTile(t1);
                if (o && o.hasData()) return o;
                const r = this._findCoveringTileCache[i.id], n = r[t1.key];
                if (o = n ? i.getTileByID(n) : null, o && o.hasData() || null === n) return o;
                let a = o ? o.tileID : t1, s = a.overscaledZ;
                const l = i.getSource().minzoom, c = [];
                if (!n) {
                    const r = i.getSource().maxzoom;
                    if (t1.canonical.z >= r) {
                        const o = t1.canonical.z - r;
                        i.getSource().reparseOverscaled ? (s = Math.max(t1.canonical.z + 2, i.transform.tileZoom), a = new e1.OverscaledTileID(s, t1.wrap, r, t1.canonical.x >> o, t1.canonical.y >> o)) : 0 !== o && (s = r, a = new e1.OverscaledTileID(s, t1.wrap, r, t1.canonical.x >> o, t1.canonical.y >> o));
                    }
                    a.key !== t1.key && (c.push(a.key), o = i.getTile(a));
                }
                const h = (e1)=>{
                    c.forEach((t1)=>{
                        r[t1] = e1;
                    }), c.length = 0;
                };
                for(s -= 1; s >= l && (!o || !o.hasData()); s--){
                    o && h(o.tileID.key);
                    const e1 = a.calculateScaledKey(s);
                    if (o = i.getTileByID(e1), o && o.hasData()) break;
                    const t1 = r[e1];
                    if (null === t1) break;
                    void 0 === t1 ? c.push(e1) : o = i.getTileByID(t1);
                }
                return h(o ? o.tileID.key : null), o && o.hasData() ? o : null;
            }
            findDEMTileFor(e1) {
                return this.enabled ? this._findTileCoveringTileID(e1, this.sourceCache) : null;
            }
            prepareDrawTile() {
                this.renderedToTile = !0;
            }
            _clearRenderCacheForTile(e1, t1) {
                let i = this._tilesDirty[e1];
                i || (i = this._tilesDirty[e1] = {}), i[t1.key] = !0;
            }
            getWirefameBuffer() {
                if (!this.wireframeSegments) {
                    const t1 = function(t1) {
                        let i = 0;
                        const o = new e1.StructArrayLayout2ui4, r = 131;
                        for(let e1 = 1; e1 < 129; e1++){
                            for(let t1 = 1; t1 < 129; t1++)i = e1 * r + t1, o.emplaceBack(i, i + 1), o.emplaceBack(i, i + r), o.emplaceBack(i + 1, i + r), 128 === e1 && o.emplaceBack(i + r, i + r + 1);
                            o.emplaceBack(i + 1, i + 1 + r);
                        }
                        return o;
                    }();
                    this.wireframeIndexBuffer = this.painter.context.createIndexBuffer(t1), this.wireframeSegments = e1.SegmentVector.simpleSegment(0, 0, this.gridBuffer.length, t1.length);
                }
                return [
                    this.wireframeIndexBuffer,
                    this.wireframeSegments
                ];
            }
            constructor(t1, i){
                super(), this.painter = t1, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
                const [o, r, n] = function(t1) {
                    const i = new e1.StructArrayLayout4i8, o = new e1.StructArrayLayout3ui6, r = 131;
                    i.reserve(17161), o.reserve(33800);
                    const n = e1.EXTENT / 128, a = e1.EXTENT + n / 2, s = a + n;
                    for(let t1 = -n; t1 < s; t1 += n)for(let o = -n; o < s; o += n){
                        const r = o < 0 || o > a || t1 < 0 || t1 > a ? 24575 : 0, n = e1.clamp(Math.round(o), 0, e1.EXTENT), s = e1.clamp(Math.round(t1), 0, e1.EXTENT);
                        i.emplaceBack(n + r, s, n, s);
                    }
                    const l = (e1, t1)=>{
                        const i = t1 * r + e1;
                        o.emplaceBack(i + 1, i, i + r), o.emplaceBack(i + r, i + r + 1, i + 1);
                    };
                    for(let e1 = 1; e1 < 129; e1++)for(let t1 = 1; t1 < 129; t1++)l(t1, e1);
                    return [
                        0,
                        129
                    ].forEach((e1)=>{
                        for(let t1 = 0; t1 < 130; t1++)l(t1, e1), l(e1, t1);
                    }), [
                        i,
                        o,
                        32768
                    ];
                }(), a = t1.context;
                this.gridBuffer = a.createVertexBuffer(o, e1.boundsAttributes.members), this.gridIndexBuffer = a.createIndexBuffer(r), this.gridSegments = e1.SegmentVector.simpleSegment(0, 0, o.length, r.length), this.gridNoSkirtSegments = e1.SegmentVector.simpleSegment(0, 0, o.length, n), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new Di(i.map), this.orthoMatrix = e1.create(), e1.ortho(this.orthoMatrix, 0, e1.EXTENT, 0, e1.EXTENT, 0, 1);
                const s = a.gl;
                this._overlapStencilMode = new e1.StencilMode({
                    func: s.GEQUAL,
                    mask: 255
                }, 0, 255, s.KEEP, s.KEEP, s.REPLACE), this._previousZoom = t1.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new zi(i.map);
            }
        }
        class Li {
            static cacheKey(e1, t1, i, o) {
                let r = `${t1}${o ? o.cacheKey : ""}`;
                for (const t1 of i)e1.usedDefines.includes(t1) && (r += `/${t1}`);
                return r;
            }
            setTerrainUniformValues(e1, t1) {
                if (!this.terrainUniforms) return;
                const i = this.terrainUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t1)i[e1].set(this.program, e1, t1[e1]);
                }
            }
            setFogUniformValues(e1, t1) {
                if (!this.fogUniforms) return;
                const i = this.fogUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t1)i[e1].set(this.program, e1, t1[e1]);
                }
            }
            draw(e1, t1, i, o, r, n, a, s, l, c, h, u, _, d, p) {
                const m = e1.gl;
                if (this.failedToCreate) return;
                e1.program.set(this.program), e1.setDepthMode(i), e1.setStencilMode(o), e1.setColorMode(r), e1.setCullFace(n);
                for (const e1 of Object.keys(this.fixedUniforms))this.fixedUniforms[e1].set(this.program, e1, a[e1]);
                d && d.setUniforms(this.program, e1, this.binderUniforms, u, {
                    zoom: _
                });
                const f = {
                    [m.LINES]: 2,
                    [m.TRIANGLES]: 3,
                    [m.LINE_STRIP]: 1
                }[t1];
                for (const i of h.get()){
                    const o = i.vaos || (i.vaos = {});
                    (o[s] || (o[s] = new mi)).bind(e1, this, l, d ? d.getPaintVertexBuffers() : [], c, i.vertexOffset, p || []), m.drawElements(t1, i.primitiveLength * f, m.UNSIGNED_SHORT, i.primitiveOffset * f * 2);
                }
            }
            constructor(t1, i, o, r, n, a){
                const s = t1.gl;
                this.program = s.createProgram();
                const l = function(e1) {
                    const t1 = [];
                    for(let i = 0; i < e1.length; i++){
                        if (null === e1[i]) continue;
                        const o = e1[i].split(" ");
                        t1.push(o.pop());
                    }
                    return t1;
                }(o.staticAttributes), c = r ? r.getBinderAttributes() : [], h = l.concat(c);
                let u = r ? r.defines() : [];
                u = u.concat(a.map((e1)=>`#define ${e1}`));
                const _ = u.concat(t1.extStandardDerivatives ? "#extension GL_OES_standard_derivatives : enable\n".concat(ui) : ui, ui, hi, ci.fragmentSource, si.fragmentSource, o.fragmentSource).join("\n"), d = u.concat("\n#ifdef GL_ES\nprecision highp float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif", hi, ci.vertexSource, si.vertexSource, ai.vertexSource, o.vertexSource).join("\n"), p = s.createShader(s.FRAGMENT_SHADER);
                if (s.isContextLost()) return void (this.failedToCreate = !0);
                s.shaderSource(p, _), s.compileShader(p), s.attachShader(this.program, p);
                const m = s.createShader(s.VERTEX_SHADER);
                if (s.isContextLost()) this.failedToCreate = !0;
                else {
                    s.shaderSource(m, d), s.compileShader(m), s.attachShader(this.program, m), this.attributes = {}, this.numAttributes = h.length;
                    for(let e1 = 0; e1 < this.numAttributes; e1++)h[e1] && (s.bindAttribLocation(this.program, e1, h[e1]), this.attributes[h[e1]] = e1);
                    s.linkProgram(this.program), s.deleteShader(m), s.deleteShader(p), this.fixedUniforms = n(t1), this.binderUniforms = r ? r.getUniforms(t1) : [], -1 !== a.indexOf("TERRAIN") && (this.terrainUniforms = ((t1)=>({
                            u_dem: new e1.Uniform1i(t1),
                            u_dem_prev: new e1.Uniform1i(t1),
                            u_dem_unpack: new e1.Uniform4f(t1),
                            u_dem_tl: new e1.Uniform2f(t1),
                            u_dem_scale: new e1.Uniform1f(t1),
                            u_dem_tl_prev: new e1.Uniform2f(t1),
                            u_dem_scale_prev: new e1.Uniform1f(t1),
                            u_dem_size: new e1.Uniform1f(t1),
                            u_dem_lerp: new e1.Uniform1f(t1),
                            u_exaggeration: new e1.Uniform1f(t1),
                            u_depth: new e1.Uniform1i(t1),
                            u_depth_size_inv: new e1.Uniform2f(t1),
                            u_meter_to_dem: new e1.Uniform1f(t1),
                            u_label_plane_matrix_inv: new e1.UniformMatrix4f(t1),
                            u_tile_tl_up: new e1.Uniform3f(t1),
                            u_tile_tr_up: new e1.Uniform3f(t1),
                            u_tile_br_up: new e1.Uniform3f(t1),
                            u_tile_bl_up: new e1.Uniform3f(t1),
                            u_tile_up_scale: new e1.Uniform1f(t1)
                        }))(t1)), -1 !== a.indexOf("FOG") && (this.fogUniforms = ((t1)=>({
                            u_fog_matrix: new e1.UniformMatrix4f(t1),
                            u_fog_range: new e1.Uniform2f(t1),
                            u_fog_color: new e1.Uniform4f(t1),
                            u_fog_horizon_blend: new e1.Uniform1f(t1),
                            u_fog_temporal_offset: new e1.Uniform1f(t1),
                            u_frustum_tl: new e1.Uniform3f(t1),
                            u_frustum_tr: new e1.Uniform3f(t1),
                            u_frustum_br: new e1.Uniform3f(t1),
                            u_frustum_bl: new e1.Uniform3f(t1),
                            u_globe_pos: new e1.Uniform3f(t1),
                            u_globe_radius: new e1.Uniform1f(t1),
                            u_globe_transition: new e1.Uniform1f(t1),
                            u_is_globe: new e1.Uniform1i(t1),
                            u_viewport: new e1.Uniform2f(t1)
                        }))(t1));
                }
            }
        }
        function Ri(e1, t1, i) {
            const o = 1 / L(i, 1, t1.transform.tileZoom), r = Math.pow(2, i.tileID.overscaledZ), n = i.tileSize * Math.pow(2, t1.transform.tileZoom) / r, a = n * (i.tileID.canonical.x + i.tileID.wrap * r), s = n * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture.size,
                u_scale: [
                    o,
                    e1.fromScale,
                    e1.toScale
                ],
                u_fade: e1.t,
                u_pixel_coord_upper: [
                    a >> 16,
                    s >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & a,
                    65535 & s
                ]
            };
        }
        const Oi = e1.create(), Bi = (t1, i, o, r, n, a, s, l, c, h, u)=>{
            const _ = i.style.light, d = _.properties.get("position"), p = [
                d.x,
                d.y,
                d.z
            ], m = e1.create$1();
            "viewport" === _.properties.get("anchor") && (e1.fromRotation(m, -i.transform.angle), e1.transformMat3(p, p, m));
            const f = _.properties.get("color"), g = i.transform, v = {
                u_matrix: t1,
                u_lightpos: p,
                u_lightintensity: _.properties.get("intensity"),
                u_lightcolor: [
                    f.r,
                    f.g,
                    f.b
                ],
                u_vertical_gradient: +o,
                u_opacity: r,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: Oi,
                u_merc_center: [
                    0,
                    0
                ],
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_height_lift: 0,
                u_ao: n,
                u_edge_radius: a
            };
            return "globe" === g.projection.name && (v.u_tile_id = [
                s.canonical.x,
                s.canonical.y,
                1 << s.canonical.z
            ], v.u_zoom_transition = c, v.u_inv_rot_matrix = u, v.u_merc_center = h, v.u_up_dir = g.projection.upVector(new e1.CanonicalTileID(0, 0, 0), h[0] * e1.EXTENT, h[1] * e1.EXTENT), v.u_height_lift = l), v;
        }, ki = (t1, i, o, r, n, a, s, l, c, h, u, _, d)=>{
            const p = Bi(t1, i, o, r, n, a, s, h, u, _, d), m = {
                u_height_factor: -Math.pow(2, s.overscaledZ) / c.tileSize / 8
            };
            return e1.extend(p, Ri(l, i, c), m);
        }, Fi = (e1)=>({
                u_matrix: e1
            }), Ui = (t1, i, o, r)=>e1.extend(Fi(t1), Ri(o, i, r)), Ni = (e1, t1)=>({
                u_matrix: e1,
                u_world: t1
            }), Gi = (t1, i, o, r, n)=>e1.extend(Ui(t1, i, o, r), {
                u_world: n
            }), ji = e1.create(), Zi = (t1, i, o, r, n, a)=>{
            const s = t1.transform, l = "globe" === s.projection.name;
            let c;
            if ("map" === a.paint.get("circle-pitch-alignment")) {
                if (l) {
                    const t1 = e1.globePixelsToTileUnits(s.zoom, i.canonical) * s._pixelsPerMercatorPixel;
                    c = Float32Array.from([
                        t1,
                        0,
                        0,
                        t1
                    ]);
                } else c = s.calculatePixelsToTileUnitsMatrix(o);
            } else c = new Float32Array([
                s.pixelsToGLUnits[0],
                0,
                0,
                s.pixelsToGLUnits[1]
            ]);
            const h = {
                u_camera_to_center_distance: s.cameraToCenterDistance,
                u_matrix: t1.translatePosMatrix(i.projMatrix, o, a.paint.get("circle-translate"), a.paint.get("circle-translate-anchor")),
                u_device_pixel_ratio: e1.exported.devicePixelRatio,
                u_extrude_scale: c,
                u_inv_rot_matrix: ji,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (l) {
                h.u_inv_rot_matrix = r, h.u_merc_center = n, h.u_tile_id = [
                    i.canonical.x,
                    i.canonical.y,
                    1 << i.canonical.z
                ], h.u_zoom_transition = e1.globeToMercatorTransition(s.zoom);
                const t1 = n[0] * e1.EXTENT, o = n[1] * e1.EXTENT;
                h.u_up_dir = s.projection.upVector(new e1.CanonicalTileID(0, 0, 0), t1, o);
            }
            return h;
        }, Vi = (e1)=>{
            const t1 = [];
            return "map" === e1.paint.get("circle-pitch-alignment") && t1.push("PITCH_WITH_MAP"), "map" === e1.paint.get("circle-pitch-scale") && t1.push("SCALE_WITH_MAP"), t1;
        }, Wi = (t1, i, o, r)=>{
            const n = e1.EXTENT / o.tileSize;
            return {
                u_matrix: t1,
                u_camera_to_center_distance: i.getCameraToCenterDistance(r),
                u_extrude_scale: [
                    i.pixelsToGLUnits[0] / n,
                    i.pixelsToGLUnits[1] / n
                ]
            };
        }, Xi = (e1, t1, i = 1)=>({
                u_matrix: e1,
                u_color: t1,
                u_overlay: 0,
                u_overlay_scale: i
            }), qi = e1.create(), $i = (t1, i, o, r, n, a, s)=>{
            const l = t1.transform, c = "globe" === l.projection.name, h = c ? e1.globePixelsToTileUnits(l.zoom, i.canonical) * l._pixelsPerMercatorPixel : L(o, 1, a), u = {
                u_matrix: i.projMatrix,
                u_extrude_scale: h,
                u_intensity: s,
                u_inv_rot_matrix: qi,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (c) {
                u.u_inv_rot_matrix = r, u.u_merc_center = n, u.u_tile_id = [
                    i.canonical.x,
                    i.canonical.y,
                    1 << i.canonical.z
                ], u.u_zoom_transition = e1.globeToMercatorTransition(l.zoom);
                const t1 = n[0] * e1.EXTENT, o = n[1] * e1.EXTENT;
                u.u_up_dir = l.projection.upVector(new e1.CanonicalTileID(0, 0, 0), t1, o);
            }
            return u;
        }, Hi = (e1, t1, i, o, r, n, a, s)=>{
            const l = e1.transform, c = l.calculatePixelsToTileUnitsMatrix(t1), h = {
                u_matrix: Ji(e1, t1, i, r),
                u_pixels_to_tile_units: c,
                u_device_pixel_ratio: a,
                u_units_to_pixels: [
                    1 / l.pixelsToGLUnits[0],
                    1 / l.pixelsToGLUnits[1]
                ],
                u_dash_image: 0,
                u_gradient_image: 1,
                u_image_height: n,
                u_texsize: [
                    0,
                    0
                ],
                u_scale: [
                    0,
                    0,
                    0
                ],
                u_mix: 0,
                u_alpha_discard_threshold: 0,
                u_trim_offset: s
            };
            if (Qi(i)) {
                const i = Ki(t1, e1.transform);
                h.u_texsize = t1.lineAtlasTexture.size, h.u_scale = [
                    i,
                    o.fromScale,
                    o.toScale
                ], h.u_mix = o.t;
            }
            return h;
        }, Yi = (e1, t1, i, o, r, n)=>{
            const a = e1.transform, s = Ki(t1, a);
            return {
                u_matrix: Ji(e1, t1, i, r),
                u_texsize: t1.imageAtlasTexture.size,
                u_pixels_to_tile_units: a.calculatePixelsToTileUnitsMatrix(t1),
                u_device_pixel_ratio: n,
                u_image: 0,
                u_scale: [
                    s,
                    o.fromScale,
                    o.toScale
                ],
                u_fade: o.t,
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ],
                u_alpha_discard_threshold: 0
            };
        };
        function Ki(e1, t1) {
            return 1 / L(e1, 1, t1.tileZoom);
        }
        function Ji(e1, t1, i, o) {
            return e1.translatePosMatrix(o || t1.tileID.projMatrix, t1, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        function Qi(e1) {
            const t1 = e1.paint.get("line-dasharray").value;
            return t1.value || "constant" !== t1.kind;
        }
        const eo = (e1, t1, i, o, r, n)=>{
            var a, s;
            return {
                u_matrix: e1,
                u_tl_parent: t1,
                u_scale_parent: i,
                u_fade_t: o.mix,
                u_opacity: o.opacity * r.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: r.paint.get("raster-brightness-min"),
                u_brightness_high: r.paint.get("raster-brightness-max"),
                u_saturation_factor: (s = r.paint.get("raster-saturation"), s > 0 ? 1 - 1 / (1.001 - s) : -s),
                u_contrast_factor: (a = r.paint.get("raster-contrast"), a > 0 ? 1 / (1 - a) : 1 + a),
                u_spin_weights: to(r.paint.get("raster-hue-rotate")),
                u_perspective_transform: n
            };
        };
        function to(e1) {
            e1 *= Math.PI / 180;
            const t1 = Math.sin(e1), i = Math.cos(e1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t1 - i + 1) / 3,
                (Math.sqrt(3) * t1 - i + 1) / 3
            ];
        }
        const io = e1.create(), oo = (t1, i, o, r, n, a, s, l, c, h, u, _, d, p, m, f)=>{
            const g = n.transform, v = {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: i ? i.uSizeT : 0,
                u_size: i ? i.uSize : 0,
                u_camera_to_center_distance: g.cameraToCenterDistance,
                u_rotate_symbol: +o,
                u_aspect_ratio: g.width / g.height,
                u_fade_change: n.options.fadeDuration ? n.symbolFadeChange : 1,
                u_matrix: a,
                u_label_plane_matrix: s,
                u_coord_matrix: l,
                u_is_text: +c,
                u_pitch_with_map: +r,
                u_texsize: h,
                u_texture: 0,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: io,
                u_merc_center: [
                    0,
                    0
                ],
                u_camera_forward: [
                    0,
                    0,
                    0
                ],
                u_ecef_origin: [
                    0,
                    0,
                    0
                ],
                u_tile_matrix: io,
                u_up_vector: [
                    0,
                    -1,
                    0
                ]
            };
            return "globe" === f.name && (v.u_tile_id = [
                u.canonical.x,
                u.canonical.y,
                1 << u.canonical.z
            ], v.u_zoom_transition = _, v.u_inv_rot_matrix = p, v.u_merc_center = d, v.u_camera_forward = g._camera.forward(), v.u_ecef_origin = e1.globeECEFOrigin(g.globeMatrix, u.toUnwrapped()), v.u_tile_matrix = Float32Array.from(g.globeMatrix), v.u_up_vector = m), v;
        }, ro = (t1, i, o, r, n, a, s, l, c, h, u, _, d, p, m, f, g)=>e1.extend(oo(t1, i, o, r, n, a, s, l, c, h, _, d, p, m, f, g), {
                u_gamma_scale: r ? n.transform.cameraToCenterDistance * Math.cos(n.terrain ? 0 : n.transform._pitch) : 1,
                u_device_pixel_ratio: e1.exported.devicePixelRatio,
                u_is_halo: +u
            }), no = (t1, i, o, r, n, a, s, l, c, h, u, _, d, p, m, f)=>e1.extend(ro(t1, i, o, r, n, a, s, l, !0, c, !0, u, _, d, p, m, f), {
                u_texsize_icon: h,
                u_texture_icon: 1
            }), ao = (e1, t1, i)=>({
                u_matrix: e1,
                u_opacity: t1,
                u_color: i
            }), so = (t1, i, o, r, n, a)=>e1.extend(function(e1, t1, i, o) {
                const r = i.imageManager.getPattern(e1.from.toString()), n = i.imageManager.getPattern(e1.to.toString()), { width: a, height: s } = i.imageManager.getPixelSize(), l = Math.pow(2, o.tileID.overscaledZ), c = o.tileSize * Math.pow(2, i.transform.tileZoom) / l, h = c * (o.tileID.canonical.x + o.tileID.wrap * l), u = c * o.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: r.tl,
                    u_pattern_br_a: r.br,
                    u_pattern_tl_b: n.tl,
                    u_pattern_br_b: n.br,
                    u_texsize: [
                        a,
                        s
                    ],
                    u_mix: t1.t,
                    u_pattern_size_a: r.displaySize,
                    u_pattern_size_b: n.displaySize,
                    u_scale_a: t1.fromScale,
                    u_scale_b: t1.toScale,
                    u_tile_units_to_pixels: 1 / L(o, 1, i.transform.tileZoom),
                    u_pixel_coord_upper: [
                        h >> 16,
                        u >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & h,
                        65535 & u
                    ]
                };
            }(r, a, o, n), {
                u_matrix: t1,
                u_opacity: i
            }), lo = {
            fillExtrusion: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_lightpos: new e1.Uniform3f(t1),
                    u_lightintensity: new e1.Uniform1f(t1),
                    u_lightcolor: new e1.Uniform3f(t1),
                    u_vertical_gradient: new e1.Uniform1f(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_edge_radius: new e1.Uniform1f(t1),
                    u_ao: new e1.Uniform2f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_up_dir: new e1.Uniform3f(t1),
                    u_height_lift: new e1.Uniform1f(t1)
                }),
            fillExtrusionPattern: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_lightpos: new e1.Uniform3f(t1),
                    u_lightintensity: new e1.Uniform1f(t1),
                    u_lightcolor: new e1.Uniform3f(t1),
                    u_vertical_gradient: new e1.Uniform1f(t1),
                    u_height_factor: new e1.Uniform1f(t1),
                    u_edge_radius: new e1.Uniform1f(t1),
                    u_ao: new e1.Uniform2f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_up_dir: new e1.Uniform3f(t1),
                    u_height_lift: new e1.Uniform1f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_pixel_coord_upper: new e1.Uniform2f(t1),
                    u_pixel_coord_lower: new e1.Uniform2f(t1),
                    u_scale: new e1.Uniform3f(t1),
                    u_fade: new e1.Uniform1f(t1),
                    u_opacity: new e1.Uniform1f(t1)
                }),
            fill: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1)
                }),
            fillPattern: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_pixel_coord_upper: new e1.Uniform2f(t1),
                    u_pixel_coord_lower: new e1.Uniform2f(t1),
                    u_scale: new e1.Uniform3f(t1),
                    u_fade: new e1.Uniform1f(t1)
                }),
            fillOutline: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_world: new e1.Uniform2f(t1)
                }),
            fillOutlinePattern: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_world: new e1.Uniform2f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_pixel_coord_upper: new e1.Uniform2f(t1),
                    u_pixel_coord_lower: new e1.Uniform2f(t1),
                    u_scale: new e1.Uniform3f(t1),
                    u_fade: new e1.Uniform1f(t1)
                }),
            circle: (t1)=>({
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_extrude_scale: new e1.UniformMatrix2f(t1),
                    u_device_pixel_ratio: new e1.Uniform1f(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_up_dir: new e1.Uniform3f(t1)
                }),
            collisionBox: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_extrude_scale: new e1.Uniform2f(t1)
                }),
            collisionCircle: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_inv_matrix: new e1.UniformMatrix4f(t1),
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_viewport_size: new e1.Uniform2f(t1)
                }),
            debug: (t1)=>({
                    u_color: new e1.UniformColor(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_overlay: new e1.Uniform1i(t1),
                    u_overlay_scale: new e1.Uniform1f(t1)
                }),
            clippingMask: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1)
                }),
            heatmap: (t1)=>({
                    u_extrude_scale: new e1.Uniform1f(t1),
                    u_intensity: new e1.Uniform1f(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_up_dir: new e1.Uniform3f(t1)
                }),
            heatmapTexture: (t1)=>({
                    u_image: new e1.Uniform1i(t1),
                    u_color_ramp: new e1.Uniform1i(t1),
                    u_opacity: new e1.Uniform1f(t1)
                }),
            hillshade: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_latrange: new e1.Uniform2f(t1),
                    u_light: new e1.Uniform2f(t1),
                    u_shadow: new e1.UniformColor(t1),
                    u_highlight: new e1.UniformColor(t1),
                    u_accent: new e1.UniformColor(t1)
                }),
            hillshadePrepare: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_dimension: new e1.Uniform2f(t1),
                    u_zoom: new e1.Uniform1f(t1),
                    u_unpack: new e1.Uniform4f(t1)
                }),
            line: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_pixels_to_tile_units: new e1.UniformMatrix2f(t1),
                    u_device_pixel_ratio: new e1.Uniform1f(t1),
                    u_units_to_pixels: new e1.Uniform2f(t1),
                    u_dash_image: new e1.Uniform1i(t1),
                    u_gradient_image: new e1.Uniform1i(t1),
                    u_image_height: new e1.Uniform1f(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_scale: new e1.Uniform3f(t1),
                    u_mix: new e1.Uniform1f(t1),
                    u_alpha_discard_threshold: new e1.Uniform1f(t1),
                    u_trim_offset: new e1.Uniform2f(t1)
                }),
            linePattern: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_pixels_to_tile_units: new e1.UniformMatrix2f(t1),
                    u_device_pixel_ratio: new e1.Uniform1f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_units_to_pixels: new e1.Uniform2f(t1),
                    u_scale: new e1.Uniform3f(t1),
                    u_fade: new e1.Uniform1f(t1),
                    u_alpha_discard_threshold: new e1.Uniform1f(t1)
                }),
            raster: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_tl_parent: new e1.Uniform2f(t1),
                    u_scale_parent: new e1.Uniform1f(t1),
                    u_fade_t: new e1.Uniform1f(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_image0: new e1.Uniform1i(t1),
                    u_image1: new e1.Uniform1i(t1),
                    u_brightness_low: new e1.Uniform1f(t1),
                    u_brightness_high: new e1.Uniform1f(t1),
                    u_saturation_factor: new e1.Uniform1f(t1),
                    u_contrast_factor: new e1.Uniform1f(t1),
                    u_spin_weights: new e1.Uniform3f(t1),
                    u_perspective_transform: new e1.Uniform2f(t1)
                }),
            symbolIcon: (t1)=>({
                    u_is_size_zoom_constant: new e1.Uniform1i(t1),
                    u_is_size_feature_constant: new e1.Uniform1i(t1),
                    u_size_t: new e1.Uniform1f(t1),
                    u_size: new e1.Uniform1f(t1),
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_rotate_symbol: new e1.Uniform1i(t1),
                    u_aspect_ratio: new e1.Uniform1f(t1),
                    u_fade_change: new e1.Uniform1f(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_label_plane_matrix: new e1.UniformMatrix4f(t1),
                    u_coord_matrix: new e1.UniformMatrix4f(t1),
                    u_is_text: new e1.Uniform1i(t1),
                    u_pitch_with_map: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_camera_forward: new e1.Uniform3f(t1),
                    u_tile_matrix: new e1.UniformMatrix4f(t1),
                    u_up_vector: new e1.Uniform3f(t1),
                    u_ecef_origin: new e1.Uniform3f(t1),
                    u_texture: new e1.Uniform1i(t1)
                }),
            symbolSDF: (t1)=>({
                    u_is_size_zoom_constant: new e1.Uniform1i(t1),
                    u_is_size_feature_constant: new e1.Uniform1i(t1),
                    u_size_t: new e1.Uniform1f(t1),
                    u_size: new e1.Uniform1f(t1),
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_rotate_symbol: new e1.Uniform1i(t1),
                    u_aspect_ratio: new e1.Uniform1f(t1),
                    u_fade_change: new e1.Uniform1f(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_label_plane_matrix: new e1.UniformMatrix4f(t1),
                    u_coord_matrix: new e1.UniformMatrix4f(t1),
                    u_is_text: new e1.Uniform1i(t1),
                    u_pitch_with_map: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_texture: new e1.Uniform1i(t1),
                    u_gamma_scale: new e1.Uniform1f(t1),
                    u_device_pixel_ratio: new e1.Uniform1f(t1),
                    u_tile_id: new e1.Uniform3f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_inv_rot_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_camera_forward: new e1.Uniform3f(t1),
                    u_tile_matrix: new e1.UniformMatrix4f(t1),
                    u_up_vector: new e1.Uniform3f(t1),
                    u_ecef_origin: new e1.Uniform3f(t1),
                    u_is_halo: new e1.Uniform1i(t1)
                }),
            symbolTextAndIcon: (t1)=>({
                    u_is_size_zoom_constant: new e1.Uniform1i(t1),
                    u_is_size_feature_constant: new e1.Uniform1i(t1),
                    u_size_t: new e1.Uniform1f(t1),
                    u_size: new e1.Uniform1f(t1),
                    u_camera_to_center_distance: new e1.Uniform1f(t1),
                    u_rotate_symbol: new e1.Uniform1i(t1),
                    u_aspect_ratio: new e1.Uniform1f(t1),
                    u_fade_change: new e1.Uniform1f(t1),
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_label_plane_matrix: new e1.UniformMatrix4f(t1),
                    u_coord_matrix: new e1.UniformMatrix4f(t1),
                    u_is_text: new e1.Uniform1i(t1),
                    u_pitch_with_map: new e1.Uniform1i(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_texsize_icon: new e1.Uniform2f(t1),
                    u_texture: new e1.Uniform1i(t1),
                    u_texture_icon: new e1.Uniform1i(t1),
                    u_gamma_scale: new e1.Uniform1f(t1),
                    u_device_pixel_ratio: new e1.Uniform1f(t1),
                    u_is_halo: new e1.Uniform1i(t1)
                }),
            background: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_color: new e1.UniformColor(t1)
                }),
            backgroundPattern: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_image: new e1.Uniform1i(t1),
                    u_pattern_tl_a: new e1.Uniform2f(t1),
                    u_pattern_br_a: new e1.Uniform2f(t1),
                    u_pattern_tl_b: new e1.Uniform2f(t1),
                    u_pattern_br_b: new e1.Uniform2f(t1),
                    u_texsize: new e1.Uniform2f(t1),
                    u_mix: new e1.Uniform1f(t1),
                    u_pattern_size_a: new e1.Uniform2f(t1),
                    u_pattern_size_b: new e1.Uniform2f(t1),
                    u_scale_a: new e1.Uniform1f(t1),
                    u_scale_b: new e1.Uniform1f(t1),
                    u_pixel_coord_upper: new e1.Uniform2f(t1),
                    u_pixel_coord_lower: new e1.Uniform2f(t1),
                    u_tile_units_to_pixels: new e1.Uniform1f(t1)
                }),
            terrainRaster: yi,
            terrainDepth: yi,
            skybox: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_sun_direction: new e1.Uniform3f(t1),
                    u_cubemap: new e1.Uniform1i(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_temporal_offset: new e1.Uniform1f(t1)
                }),
            skyboxGradient: (t1)=>({
                    u_matrix: new e1.UniformMatrix4f(t1),
                    u_color_ramp: new e1.Uniform1i(t1),
                    u_center_direction: new e1.Uniform3f(t1),
                    u_radius: new e1.Uniform1f(t1),
                    u_opacity: new e1.Uniform1f(t1),
                    u_temporal_offset: new e1.Uniform1f(t1)
                }),
            skyboxCapture: (t1)=>({
                    u_matrix_3f: new e1.UniformMatrix3f(t1),
                    u_sun_direction: new e1.Uniform3f(t1),
                    u_sun_intensity: new e1.Uniform1f(t1),
                    u_color_tint_r: new e1.Uniform4f(t1),
                    u_color_tint_m: new e1.Uniform4f(t1),
                    u_luminance: new e1.Uniform1f(t1)
                }),
            globeRaster: (t1)=>({
                    u_proj_matrix: new e1.UniformMatrix4f(t1),
                    u_globe_matrix: new e1.UniformMatrix4f(t1),
                    u_normalize_matrix: new e1.UniformMatrix4f(t1),
                    u_merc_matrix: new e1.UniformMatrix4f(t1),
                    u_zoom_transition: new e1.Uniform1f(t1),
                    u_merc_center: new e1.Uniform2f(t1),
                    u_image0: new e1.Uniform1i(t1),
                    u_grid_matrix: new e1.UniformMatrix3f(t1),
                    u_frustum_tl: new e1.Uniform3f(t1),
                    u_frustum_tr: new e1.Uniform3f(t1),
                    u_frustum_br: new e1.Uniform3f(t1),
                    u_frustum_bl: new e1.Uniform3f(t1),
                    u_globe_pos: new e1.Uniform3f(t1),
                    u_globe_radius: new e1.Uniform1f(t1),
                    u_viewport: new e1.Uniform2f(t1)
                }),
            globeAtmosphere: (t1)=>({
                    u_frustum_tl: new e1.Uniform3f(t1),
                    u_frustum_tr: new e1.Uniform3f(t1),
                    u_frustum_br: new e1.Uniform3f(t1),
                    u_frustum_bl: new e1.Uniform3f(t1),
                    u_horizon: new e1.Uniform1f(t1),
                    u_transition: new e1.Uniform1f(t1),
                    u_fadeout_range: new e1.Uniform1f(t1),
                    u_color: new e1.Uniform4f(t1),
                    u_high_color: new e1.Uniform4f(t1),
                    u_space_color: new e1.Uniform4f(t1),
                    u_star_intensity: new e1.Uniform1f(t1),
                    u_star_density: new e1.Uniform1f(t1),
                    u_star_size: new e1.Uniform1f(t1),
                    u_temporal_offset: new e1.Uniform1f(t1),
                    u_horizon_angle: new e1.Uniform1f(t1),
                    u_rotation_matrix: new e1.UniformMatrix4f(t1)
                })
        };
        let co;
        function ho(t1, i, o, r, n, a, s) {
            const l = t1.context, c = l.gl, h = t1.transform, u = t1.useProgram("collisionBox"), _ = [];
            let d = 0, p = 0;
            for(let m = 0; m < r.length; m++){
                const f = r[m], g = i.getTile(f), v = g.getBucket(o);
                if (!v) continue;
                const x = bt(f, v, h);
                let y = x;
                0 === n[0] && 0 === n[1] || (y = t1.translatePosMatrix(x, g, n, a));
                const b = s ? v.textCollisionBox : v.iconCollisionBox, w = v.collisionCircleArray;
                if (w.length > 0) {
                    const t1 = e1.create(), i = y;
                    e1.mul(t1, v.placementInvProjMatrix, h.glCoordMatrix), e1.mul(t1, t1, v.placementViewportMatrix), _.push({
                        circleArray: w,
                        circleOffset: p,
                        transform: i,
                        invTransform: t1,
                        projection: v.getProjection()
                    }), d += w.length / 4, p = d;
                }
                b && (t1.terrain && t1.terrain.setupElevationDraw(g, u), u.draw(l, c.LINES, e1.DepthMode.disabled, e1.StencilMode.disabled, t1.colorModeForRenderPass(), e1.CullFaceMode.disabled, Wi(y, h, g, v.getProjection()), o.id, b.layoutVertexBuffer, b.indexBuffer, b.segments, null, h.zoom, null, [
                    b.collisionVertexBuffer,
                    b.collisionVertexBufferExt
                ]));
            }
            if (!s || !_.length) return;
            const m = t1.useProgram("collisionCircle"), f = new e1.StructArrayLayout2f1f2i16;
            f.resize(4 * d), f._trim();
            let g = 0;
            for (const e1 of _)for(let t1 = 0; t1 < e1.circleArray.length / 4; t1++){
                const i = 4 * t1, o = e1.circleArray[i + 0], r = e1.circleArray[i + 1], n = e1.circleArray[i + 2], a = e1.circleArray[i + 3];
                f.emplace(g++, o, r, n, a, 0), f.emplace(g++, o, r, n, a, 1), f.emplace(g++, o, r, n, a, 2), f.emplace(g++, o, r, n, a, 3);
            }
            (!co || co.length < 2 * d) && (co = function(t1) {
                const i = 2 * t1, o = new e1.StructArrayLayout3ui6;
                o.resize(i), o._trim();
                for(let e1 = 0; e1 < i; e1++){
                    const t1 = 6 * e1;
                    o.uint16[t1 + 0] = 4 * e1 + 0, o.uint16[t1 + 1] = 4 * e1 + 1, o.uint16[t1 + 2] = 4 * e1 + 2, o.uint16[t1 + 3] = 4 * e1 + 2, o.uint16[t1 + 4] = 4 * e1 + 3, o.uint16[t1 + 5] = 4 * e1 + 0;
                }
                return o;
            }(d));
            const v = l.createIndexBuffer(co, !0), x = l.createVertexBuffer(f, e1.collisionCircleLayout.members, !0);
            for (const i of _){
                const r = {
                    u_matrix: i.transform,
                    u_inv_matrix: i.invTransform,
                    u_camera_to_center_distance: (y = h).getCameraToCenterDistance(i.projection),
                    u_viewport_size: [
                        y.width,
                        y.height
                    ]
                };
                m.draw(l, c.TRIANGLES, e1.DepthMode.disabled, e1.StencilMode.disabled, t1.colorModeForRenderPass(), e1.CullFaceMode.disabled, r, o.id, x, v, e1.SegmentVector.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, h.zoom);
            }
            var y;
            x.destroy(), v.destroy();
        }
        const uo = e1.create();
        function _o(t1, i, o, r, n, a) {
            const { horizontalAlign: s, verticalAlign: l } = e1.getAnchorAlignment(t1), c = -(s - .5) * i, h = -(l - .5) * o, u = e1.evaluateVariableOffset(t1, r);
            return new e1.pointGeometry((c / n + u[0]) * a, (h / n + u[1]) * a);
        }
        function po(t1, i, o, r, n, a, s, l, c, h, u) {
            const _ = t1.text.placedSymbolArray, d = t1.text.dynamicLayoutVertexArray, p = t1.icon.dynamicLayoutVertexArray, m = {}, f = wt(l, t1.getProjection(), a), g = a.elevation, v = t1.getProjection().upVectorScale(l.canonical, a.center.lat, a.worldSize);
            d.clear();
            for(let p = 0; p < _.length; p++){
                const x = _.get(p), y = t1.allowVerticalPlacement && !x.placedOrientation, b = x.hidden || !x.crossTileID || y ? null : r[x.crossTileID];
                if (b) {
                    const r = new e1.pointGeometry(x.tileAnchorX, x.tileAnchorY), _ = t1.getProjection().upVector(l.canonical, r.x, r.y), p = g ? g.getAtTileOffset(l, r.x, r.y) : 0, y = nt([
                        x.projectedAnchorX + p * _[0] * v.metersToTile,
                        x.projectedAnchorY + p * _[1] * v.metersToTile,
                        x.projectedAnchorZ + p * _[2] * v.metersToTile
                    ], o ? f : s), w = at(a.getCameraToCenterDistance(t1.getProjection()), y.signedDistanceFromCamera);
                    let T = n.evaluateSizeForFeature(t1.textSizeData, h, x) * w / e1.ONE_EM;
                    o && (T *= t1.tilePixelRatio / c);
                    const { width: E, height: C, anchor: I, textOffset: M, textScale: S } = b, z = _o(I, E, C, M, S, T);
                    let D;
                    if (o) {
                        const e1 = r.add(z), { x: i, y: o, z: n } = t1.getProjection().projectTilePoint(e1.x, e1.y, l.canonical);
                        D = nt([
                            i + p * _[0] * v.metersToTile,
                            o + p * _[1] * v.metersToTile,
                            n + p * _[2] * v.metersToTile
                        ], s).point;
                    } else {
                        const e1 = i ? z.rotate(-a.angle) : z;
                        D = [
                            y.point[0] + e1.x,
                            y.point[1] + e1.y,
                            0
                        ];
                    }
                    const P = t1.allowVerticalPlacement && x.placedOrientation === e1.WritingMode.vertical ? Math.PI / 2 : 0;
                    for(let t1 = 0; t1 < x.numGlyphs; t1++)e1.addDynamicAttributes(d, D[0], D[1], D[2], P);
                    u && x.associatedIconIndex >= 0 && (m[x.associatedIconIndex] = {
                        shiftedAnchor: D,
                        angle: P
                    });
                } else ft(x.numGlyphs, d);
            }
            if (u) {
                p.clear();
                const i = t1.icon.placedSymbolArray;
                for(let t1 = 0; t1 < i.length; t1++){
                    const o = i.get(t1);
                    if (o.hidden) ft(o.numGlyphs, p);
                    else {
                        const i = m[t1];
                        if (i) for(let t1 = 0; t1 < o.numGlyphs; t1++)e1.addDynamicAttributes(p, i.shiftedAnchor[0], i.shiftedAnchor[1], i.shiftedAnchor[2], i.angle);
                        else ft(o.numGlyphs, p);
                    }
                }
                t1.icon.dynamicLayoutVertexBuffer.updateData(p);
            }
            t1.text.dynamicLayoutVertexBuffer.updateData(d);
        }
        function mo(e1, t1, i) {
            return i.iconsInText && t1 ? "symbolTextAndIcon" : e1 ? "symbolSDF" : "symbolIcon";
        }
        function fo(t1, i, o, r, n, a, s, l, c, h, u, _) {
            const d = t1.context, p = d.gl, m = t1.transform, f = "map" === l, g = "map" === c, v = f && "point" !== o.layout.get("symbol-placement"), x = f && !g && !v, y = void 0 !== o.layout.get("symbol-sort-key").constantOr(1);
            let b = !1;
            const w = t1.depthModeForSublayer(0, e1.DepthMode.ReadOnly), T = [
                e1.mercatorXfromLng(m.center.lng),
                e1.mercatorYfromLat(m.center.lat)
            ], E = o.layout.get("text-variable-anchor"), C = "globe" === m.projection.name, I = [], M = [
                0,
                -1,
                0
            ];
            let S = M;
            !C && !m.mercatorFromTransition || f || (S = function(t1) {
                const i = t1._camera.getWorldToCamera(t1.worldSize, 1), o = e1.multiply([], i, t1.globeMatrix);
                e1.invert(o, o);
                const r = [
                    0,
                    0,
                    0
                ], n = [
                    0,
                    1,
                    0,
                    0
                ];
                return e1.transformMat4$1(n, n, o), r[0] = n[0], r[1] = n[1], r[2] = n[2], e1.normalize(r, r), r;
            }(m));
            for (const l of r){
                const r = i.getTile(l), c = r.getBucket(o);
                if (!c) continue;
                if ("mercator" === c.projection.name && C) continue;
                const u = n ? c.text : c.icon;
                if (!u || c.fullyClipped || !u.segments.get().length) continue;
                const _ = u.programConfigurations.get(o.id), d = n || c.sdfIcons, w = n ? c.textSizeData : c.iconSizeData, z = g || 0 !== m.pitch, D = e1.evaluateSizeForZoom(w, m.zoom);
                let P, A, L, R, O = [
                    0,
                    0
                ], B = null;
                if (n) {
                    if (A = r.glyphAtlasTexture, L = p.LINEAR, P = r.glyphAtlasTexture.size, c.iconsInText) {
                        O = r.imageAtlasTexture.size, B = r.imageAtlasTexture;
                        const e1 = "composite" === w.kind || "camera" === w.kind;
                        R = z || t1.options.rotating || t1.options.zooming || e1 ? p.LINEAR : p.NEAREST;
                    }
                } else {
                    const e1 = 1 !== o.layout.get("icon-size").constantOr(0) || c.iconsNeedLinear;
                    A = r.imageAtlasTexture, L = d || t1.options.rotating || t1.options.zooming || e1 || z ? p.LINEAR : p.NEAREST, P = r.imageAtlasTexture.size;
                }
                const k = "globe" === c.projection.name, F = k ? S : M, U = k ? e1.globeToMercatorTransition(m.zoom) : 0, N = wt(l, c.getProjection(), m), G = m.calculatePixelsToTileUnitsMatrix(r), j = tt(N, r.tileID.canonical, g, f, m, c.getProjection(), G), Z = t1.terrain && g && v ? e1.invert(e1.create(), j) : uo, V = ot(N, r.tileID.canonical, g, f, m, c.getProjection(), G), W = E && c.hasTextData(), X = "none" !== o.layout.get("icon-text-fit") && W && c.hasIconData();
                if (v) {
                    const e1 = m.elevation, i = e1 ? e1.getAtTileOffsetFunc(l, m.center.lat, m.worldSize, c.getProjection()) : (e1)=>[
                            0,
                            0,
                            0
                        ], o = it(N, r.tileID.canonical, g, f, m, c.getProjection(), G);
                    lt(c, N, t1, n, o, V, g, h, i, l);
                }
                const q = v || n && E || X, $ = t1.translatePosMatrix(N, r, a, s), H = q ? uo : j, Y = t1.translatePosMatrix(V, r, a, s, !0), K = c.getProjection().createInversionMatrix(m, l.canonical), J = [];
                t1.terrain && g && J.push("PITCH_WITH_MAP_TERRAIN"), k && J.push("PROJECTION_GLOBE_VIEW"), q && J.push("PROJECTED_POS_ON_VIEWPORT");
                const Q = d && 0 !== o.paint.get(n ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let ee;
                ee = d ? c.iconsInText ? no(w.kind, D, x, g, t1, $, H, Y, P, O, l, U, T, K, F, c.getProjection()) : ro(w.kind, D, x, g, t1, $, H, Y, n, P, !0, l, U, T, K, F, c.getProjection()) : oo(w.kind, D, x, g, t1, $, H, Y, n, P, l, U, T, K, F, c.getProjection());
                const te = {
                    program: t1.useProgram(mo(d, n, c), _, J),
                    buffers: u,
                    uniformValues: ee,
                    atlasTexture: A,
                    atlasTextureIcon: B,
                    atlasInterpolation: L,
                    atlasInterpolationIcon: R,
                    isSDF: d,
                    hasHalo: Q,
                    tile: r,
                    labelPlaneMatrixInv: Z
                };
                if (y && c.canOverlap) {
                    b = !0;
                    const t1 = u.segments.get();
                    for (const i of t1)I.push({
                        segments: new e1.SegmentVector([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: te
                    });
                } else I.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: te
                });
            }
            b && I.sort((e1, t1)=>e1.sortKey - t1.sortKey);
            for (const e1 of I){
                const i = e1.state;
                if (t1.terrain && t1.terrain.setupElevationDraw(i.tile, i.program, {
                    useDepthForOcclusion: !C,
                    labelPlaneMatrixInv: i.labelPlaneMatrixInv
                }), d.activeTexture.set(p.TEXTURE0), i.atlasTexture.bind(i.atlasInterpolation, p.CLAMP_TO_EDGE), i.atlasTextureIcon && (d.activeTexture.set(p.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, p.CLAMP_TO_EDGE)), i.isSDF) {
                    const r = i.uniformValues;
                    i.hasHalo && (r.u_is_halo = 1, go(i.buffers, e1.segments, o, t1, i.program, w, u, _, r)), r.u_is_halo = 0;
                }
                go(i.buffers, e1.segments, o, t1, i.program, w, u, _, i.uniformValues);
            }
        }
        function go(t1, i, o, r, n, a, s, l, c) {
            const h = r.context, u = [
                t1.dynamicLayoutVertexBuffer,
                t1.opacityVertexBuffer,
                t1.globeExtVertexBuffer
            ];
            n.draw(h, h.gl.TRIANGLES, a, s, l, e1.CullFaceMode.disabled, c, o.id, t1.layoutVertexBuffer, t1.indexBuffer, i, o.paint, r.transform.zoom, t1.programConfigurations.get(o.id), u);
        }
        function vo(t1, i, o, r, n, a, s) {
            const l = t1.context.gl, c = o.paint.get("fill-pattern"), h = c && c.constantOr(1), u = o.getCrossfadeParameters();
            let _, d, p, m, f;
            s ? (d = h && !o.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", _ = l.LINES) : (d = h ? "fillPattern" : "fill", _ = l.TRIANGLES);
            for (const g of r){
                const r = i.getTile(g);
                if (h && !r.patternsLoaded()) continue;
                const v = r.getBucket(o);
                if (!v) continue;
                t1.prepareDrawTile();
                const x = v.programConfigurations.get(o.id), y = t1.useProgram(d, x);
                h && (t1.context.activeTexture.set(l.TEXTURE0), r.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), x.updatePaintBuffers(u));
                const b = c.constantOr(null);
                if (b && r.imageAtlas) {
                    const e1 = r.imageAtlas, t1 = e1.patternPositions[b.to.toString()], i = e1.patternPositions[b.from.toString()];
                    t1 && i && x.setConstantPatternPositions(t1, i);
                }
                const w = t1.translatePosMatrix(g.projMatrix, r, o.paint.get("fill-translate"), o.paint.get("fill-translate-anchor"));
                if (s) {
                    m = v.indexBuffer2, f = v.segments2;
                    const e1 = t1.terrain && t1.terrain.renderingToTexture ? t1.terrain.drapeBufferSize : [
                        l.drawingBufferWidth,
                        l.drawingBufferHeight
                    ];
                    p = "fillOutlinePattern" === d && h ? Gi(w, t1, u, r, e1) : Ni(w, e1);
                } else m = v.indexBuffer, f = v.segments, p = h ? Ui(w, t1, u, r) : Fi(w);
                t1.prepareDrawProgram(t1.context, y, g.toUnwrapped()), y.draw(t1.context, _, n, t1.stencilModeForClipping(g), a, e1.CullFaceMode.disabled, p, o.id, v.layoutVertexBuffer, m, f, o.paint, t1.transform.zoom, x);
            }
        }
        function xo(t1, i, o, r, n, a, s) {
            const l = t1.context, c = l.gl, h = t1.transform, u = o.paint.get("fill-extrusion-pattern"), _ = u.constantOr(1), d = o.getCrossfadeParameters(), p = o.paint.get("fill-extrusion-opacity"), m = [
                o.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                o.paint.get("fill-extrusion-ambient-occlusion-radius")
            ], f = o.layout.get("fill-extrusion-edge-radius"), g = "globe" === h.projection.name ? e1.fillExtrusionHeightLift() : 0, v = "globe" === h.projection.name, x = v ? e1.globeToMercatorTransition(h.zoom) : 0, y = [
                e1.mercatorXfromLng(h.center.lng),
                e1.mercatorYfromLat(h.center.lat)
            ], b = [];
            v && (b.push("PROJECTION_GLOBE_VIEW"), t1.style.terrainSetForDrapingOnly() && b.push("TERRAIN")), m[0] > 0 && b.push("FAUX_AO");
            for (const w of r){
                const r = i.getTile(w), T = r.getBucket(o);
                if (!T || T.projection.name !== h.projection.name) continue;
                const E = T.programConfigurations.get(o.id), C = t1.useProgram(_ ? "fillExtrusionPattern" : "fillExtrusion", E, b);
                if (t1.terrain) {
                    const e1 = t1.terrain;
                    if (t1.style.terrainSetForDrapingOnly()) e1.setupElevationDraw(r, C, {
                        useMeterToDem: !0
                    });
                    else {
                        if (!T.enableTerrain) continue;
                        if (e1.setupElevationDraw(r, C, {
                            useMeterToDem: !0
                        }), yo(l, i, w, T, o, e1), !T.centroidVertexBuffer) {
                            const e1 = C.attributes.a_centroid_pos;
                            void 0 !== e1 && c.vertexAttrib2f(e1, 0, 0);
                        }
                    }
                }
                _ && (t1.context.activeTexture.set(c.TEXTURE0), r.imageAtlasTexture.bind(c.LINEAR, c.CLAMP_TO_EDGE), E.updatePaintBuffers(d));
                const I = u.constantOr(null);
                if (I && r.imageAtlas) {
                    const e1 = r.imageAtlas, t1 = e1.patternPositions[I.to.toString()], i = e1.patternPositions[I.from.toString()];
                    t1 && i && E.setConstantPatternPositions(t1, i);
                }
                const M = t1.translatePosMatrix(w.projMatrix, r, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), S = h.projection.createInversionMatrix(h, w.canonical), z = o.paint.get("fill-extrusion-vertical-gradient"), D = _ ? ki(M, t1, z, p, m, f, w, d, r, g, x, y, S) : Bi(M, t1, z, p, m, f, w, g, x, y, S);
                t1.prepareDrawProgram(l, C, w.toUnwrapped());
                const P = [];
                t1.terrain && P.push(T.centroidVertexBuffer), v && P.push(T.layoutVertexExtBuffer), C.draw(l, l.gl.TRIANGLES, n, a, s, e1.CullFaceMode.backCCW, D, o.id, T.layoutVertexBuffer, T.indexBuffer, T.segments, o.paint, t1.transform.zoom, E, P);
            }
        }
        function yo(t1, i, o, r, n, a) {
            const s = [
                (t1)=>{
                    let i = t1.canonical.x - 1, o = t1.wrap;
                    return i < 0 && (i = (1 << t1.canonical.z) - 1, o--), new e1.OverscaledTileID(t1.overscaledZ, o, t1.canonical.z, i, t1.canonical.y);
                },
                (t1)=>{
                    let i = t1.canonical.x + 1, o = t1.wrap;
                    return i === 1 << t1.canonical.z && (i = 0, o++), new e1.OverscaledTileID(t1.overscaledZ, o, t1.canonical.z, i, t1.canonical.y);
                },
                (t1)=>new e1.OverscaledTileID(t1.overscaledZ, t1.wrap, t1.canonical.z, t1.canonical.x, (0 === t1.canonical.y ? 1 << t1.canonical.z : t1.canonical.y) - 1),
                (t1)=>new e1.OverscaledTileID(t1.overscaledZ, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y === (1 << t1.canonical.z) - 1 ? 0 : t1.canonical.y + 1)
            ], l = (e1)=>{
                const t1 = i.getSource().minzoom, o = (e1)=>{
                    const t1 = i.getTileByID(e1);
                    if (t1 && t1.hasData()) return t1.getBucket(n);
                }, r = [
                    0,
                    -1,
                    1
                ];
                for (const i of r){
                    if (e1.overscaledZ + i < t1) continue;
                    const r = o(e1.calculateScaledKey(e1.overscaledZ + i));
                    if (r) return r;
                }
            }, c = [
                0,
                0,
                0
            ], h = (t1, i)=>(c[0] = Math.min(t1.min.y, i.min.y), c[1] = Math.max(t1.max.y, i.max.y), c[2] = e1.EXTENT - i.min.x > t1.max.x ? i.min.x - e1.EXTENT : t1.max.x, c), u = (t1, i)=>(c[0] = Math.min(t1.min.x, i.min.x), c[1] = Math.max(t1.max.x, i.max.x), c[2] = e1.EXTENT - i.min.y > t1.max.y ? i.min.y - e1.EXTENT : t1.max.y, c), _ = [
                (e1, t1)=>h(e1, t1),
                (e1, t1)=>h(t1, e1),
                (e1, t1)=>u(e1, t1),
                (e1, t1)=>u(t1, e1)
            ], d = new e1.pointGeometry(0, 0);
            let p, m, f;
            const g = (t1, i, r, n, s)=>{
                const l = [
                    [
                        n ? r : t1,
                        n ? t1 : r,
                        0
                    ],
                    [
                        n ? r : i,
                        n ? i : r,
                        0
                    ]
                ], c = s < 0 ? e1.EXTENT + s : s, h = [
                    n ? c : (t1 + i) / 2,
                    n ? (t1 + i) / 2 : c,
                    0
                ];
                return 0 === r && s < 0 || 0 !== r && s > 0 ? a.getForTilePoints(f, [
                    h
                ], !0, m) : l.push(h), a.getForTilePoints(o, l, !0, p), Math.max(l[0][2], l[1][2], h[2]) / a.exaggeration();
            };
            for(let t1 = 0; t1 < 4; t1++){
                const i = (t1 < 2 ? 1 : 5) - t1, n = r.borders[t1];
                if (0 === n.length) continue;
                const c = f = s[t1](o), h = l(c);
                if (!(h && h instanceof e1.FillExtrusionBucket && h.enableTerrain)) continue;
                if (r.borderDoneWithNeighborZ[t1] === h.canonical.z && h.borderDoneWithNeighborZ[i] === r.canonical.z) continue;
                if (m = a.findDEMTileFor(c), !m || !m.dem) continue;
                if (!p) {
                    const e1 = a.findDEMTileFor(o);
                    if (!e1 || !e1.dem) return;
                    p = e1;
                }
                const u = h.borders[i];
                let v = 0;
                const x = h.borderDoneWithNeighborZ[i] !== r.canonical.z;
                if (r.canonical.z === h.canonical.z) {
                    for(let o = 0; o < n.length; o++){
                        const a = r.featuresOnBorder[n[o]], s = a.borders[t1];
                        let l;
                        for(; v < u.length && (l = h.featuresOnBorder[u[v]], !(l.borders[i][1] > s[0] + 3));)x && h.encodeCentroid(void 0, l, !1), v++;
                        if (l && v < u.length) {
                            const o = v;
                            let n = 0;
                            for(; !(l.borders[i][0] > s[1] - 3) && (n++, ++v !== u.length);)l = h.featuresOnBorder[u[v]];
                            if (l = h.featuresOnBorder[u[o]], a.intersectsCount() > 1 || l.intersectsCount() > 1 || 1 !== n) {
                                1 !== n && (v = o), r.encodeCentroid(void 0, a, !1), x && h.encodeCentroid(void 0, l, !1);
                                continue;
                            }
                            const c = _[t1](a, l), p = t1 % 2 ? e1.EXTENT - 1 : 0;
                            d.x = g(c[0], Math.min(e1.EXTENT - 1, c[1]), p, t1 < 2, c[2]), d.y = 0, r.encodeCentroid(d, a, !1), x && h.encodeCentroid(d, l, !1);
                        } else r.encodeCentroid(void 0, a, !1);
                    }
                    r.borderDoneWithNeighborZ[t1] = h.canonical.z, r.needsCentroidUpdate = !0, x && (h.borderDoneWithNeighborZ[i] = r.canonical.z, h.needsCentroidUpdate = !0);
                } else {
                    for (const e1 of n)r.encodeCentroid(void 0, r.featuresOnBorder[e1], !1);
                    if (x) {
                        for (const e1 of u)h.encodeCentroid(void 0, h.featuresOnBorder[e1], !1);
                        h.borderDoneWithNeighborZ[i] = r.canonical.z, h.needsCentroidUpdate = !0;
                    }
                    r.borderDoneWithNeighborZ[t1] = h.canonical.z, r.needsCentroidUpdate = !0;
                }
            }
            (r.needsCentroidUpdate || !r.centroidVertexBuffer && 0 !== r.centroidVertexArray.length) && r.uploadCentroid(t1);
        }
        const bo = new e1.Color(1, 0, 0, 1), wo = new e1.Color(0, 1, 0, 1), To = new e1.Color(0, 0, 1, 1), Eo = new e1.Color(1, 0, 1, 1), Co = new e1.Color(0, 1, 1, 1);
        function Io(t1, i, o) {
            const r = t1.context, n = t1.transform, a = r.gl, s = "globe" === n.projection.name, l = s ? [
                "PROJECTION_GLOBE_VIEW"
            ] : null;
            let c = o.projMatrix;
            if (s && e1.globeToMercatorTransition(n.zoom) > 0) {
                const t1 = e1.transitionTileAABBinECEF(o.canonical, n), i = e1.globeDenormalizeECEF(t1);
                c = e1.multiply(new Float32Array(16), n.globeMatrix, i), e1.multiply(c, n.projMatrix, c);
            }
            const h = t1.useProgram("debug", null, l), u = i.getTileByID(o.key);
            t1.terrain && t1.terrain.setupElevationDraw(u, h);
            const _ = e1.DepthMode.disabled, d = e1.StencilMode.disabled, p = t1.colorModeForRenderPass(), m = "$debug";
            r.activeTexture.set(a.TEXTURE0), t1.emptyTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), s ? u._makeGlobeTileDebugBuffers(t1.context, n) : u._makeDebugTileBoundsBuffers(t1.context, n.projection);
            const f = u._tileDebugBuffer || t1.debugBuffer, g = u._tileDebugIndexBuffer || t1.debugIndexBuffer, v = u._tileDebugSegments || t1.debugSegments;
            h.draw(r, a.LINE_STRIP, _, d, p, e1.CullFaceMode.disabled, Xi(c, e1.Color.red), m, f, g, v, null, null, null, [
                u._globeTileDebugBorderBuffer
            ]);
            const x = u.latestRawTileData, y = Math.floor((x && x.byteLength || 0) / 1024), b = i.getTile(o).tileSize, w = 512 / Math.min(b, 512) * (o.overscaledZ / n.zoom) * .5;
            let T = o.canonical.toString();
            o.overscaledZ !== o.canonical.z && (T += ` => ${o.overscaledZ}`), T += ` ${y}kb`, function(e1, t1) {
                e1.initDebugOverlayCanvas();
                const i = e1.debugOverlayCanvas, o = e1.context.gl, r = e1.debugOverlayCanvas.getContext("2d");
                r.clearRect(0, 0, i.width, i.height), r.shadowColor = "white", r.shadowBlur = 2, r.lineWidth = 1.5, r.strokeStyle = "white", r.textBaseline = "top", r.font = "bold 36px Open Sans, sans-serif", r.fillText(t1, 5, 5), r.strokeText(t1, 5, 5), e1.debugOverlayTexture.update(i), e1.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            }(t1, T);
            const E = u._tileDebugTextBuffer || t1.debugBuffer, C = u._tileDebugTextIndexBuffer || t1.quadTriangleIndexBuffer, I = u._tileDebugTextSegments || t1.debugSegments;
            h.draw(r, a.TRIANGLES, _, d, e1.ColorMode.alphaBlended, e1.CullFaceMode.disabled, Xi(c, e1.Color.transparent, w), m, E, C, I, null, null, null, [
                u._globeTileDebugTextBuffer
            ]);
        }
        function Mo(e1, t1, i, o) {
            zo(e1, 0, t1 + i / 2, e1.transform.width, i, o);
        }
        function So(e1, t1, i, o) {
            zo(e1, t1 - i / 2, 0, i, e1.transform.height, o);
        }
        function zo(t1, i, o, r, n, a) {
            const s = t1.context, l = s.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(i * e1.exported.devicePixelRatio, o * e1.exported.devicePixelRatio, r * e1.exported.devicePixelRatio, n * e1.exported.devicePixelRatio), s.clear({
                color: a
            }), l.disable(l.SCISSOR_TEST);
        }
        const Do = e1.createLayout([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), { members: Po } = Do;
        function Ao(e1, t1, i, o) {
            e1.emplaceBack(t1, i, o);
        }
        class Lo {
            constructor(t1){
                this.vertexArray = new e1.StructArrayLayout3f12, this.indices = new e1.StructArrayLayout3ui6, Ao(this.vertexArray, -1, -1, 1), Ao(this.vertexArray, 1, -1, 1), Ao(this.vertexArray, -1, 1, 1), Ao(this.vertexArray, 1, 1, 1), Ao(this.vertexArray, -1, -1, -1), Ao(this.vertexArray, 1, -1, -1), Ao(this.vertexArray, -1, 1, -1), Ao(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, Po), this.indexBuffer = t1.createIndexBuffer(this.indices), this.segment = e1.SegmentVector.simpleSegment(0, 0, 36, 12);
            }
        }
        function Ro(t1, i, o, r, n, a) {
            const s = t1.gl, l = i.paint.get("sky-atmosphere-color"), c = i.paint.get("sky-atmosphere-halo-color"), h = i.paint.get("sky-atmosphere-sun-intensity"), u = ((e1, t1, i, o, r)=>({
                    u_matrix_3f: e1,
                    u_sun_direction: t1,
                    u_sun_intensity: i,
                    u_color_tint_r: [
                        o.r,
                        o.g,
                        o.b,
                        o.a
                    ],
                    u_color_tint_m: [
                        r.r,
                        r.g,
                        r.b,
                        r.a
                    ],
                    u_luminance: 5e-5
                }))(e1.fromMat4(e1.create$1(), r), n, h, l, c);
            s.framebufferTexture2D(s.FRAMEBUFFER, s.COLOR_ATTACHMENT0, s.TEXTURE_CUBE_MAP_POSITIVE_X + a, i.skyboxTexture, 0), o.draw(t1, s.TRIANGLES, e1.DepthMode.disabled, e1.StencilMode.disabled, e1.ColorMode.unblended, e1.CullFaceMode.frontCW, u, "skyboxCapture", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
        }
        const Oo = e1.createLayout([
            {
                type: "Float32",
                name: "a_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]);
        class Bo {
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
            constructor(t1){
                const i = new e1.StructArrayLayout5f20;
                i.emplaceBack(-1, 1, 1, 0, 0), i.emplaceBack(1, 1, 1, 1, 0), i.emplaceBack(1, -1, 1, 1, 1), i.emplaceBack(-1, -1, 1, 0, 1);
                const o = new e1.StructArrayLayout3ui6;
                o.emplaceBack(0, 1, 2), o.emplaceBack(2, 3, 0), this.vertexBuffer = t1.createVertexBuffer(i, Oo.members), this.indexBuffer = t1.createIndexBuffer(o), this.segments = e1.SegmentVector.simpleSegment(0, 0, 4, 2);
            }
        }
        const ko = {
            symbol: function(t1, i, o, r, n) {
                if ("translucent" !== t1.renderPass) return;
                const a = e1.StencilMode.disabled, s = t1.colorModeForRenderPass();
                o.layout.get("text-variable-anchor") && function(t1, i, o, r, n, a, s) {
                    const l = i.transform, c = "map" === n, h = "map" === a;
                    for (const i of t1){
                        const t1 = r.getTile(i), n = t1.getBucket(o);
                        if (!n || !n.text || !n.text.segments.get().length) continue;
                        const a = e1.evaluateSizeForZoom(n.textSizeData, l.zoom), u = wt(i, n.getProjection(), l), _ = l.calculatePixelsToTileUnitsMatrix(t1), d = tt(u, t1.tileID.canonical, h, c, l, n.getProjection(), _), p = "none" !== o.layout.get("icon-text-fit") && n.hasIconData();
                        if (a) {
                            const o = Math.pow(2, l.zoom - t1.tileID.overscaledZ);
                            po(n, c, h, s, e1.symbolSize, l, d, i, o, a, p);
                        }
                    }
                }(r, t1, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), n), 0 !== o.paint.get("icon-opacity").constantOr(1) && fo(t1, i, o, r, !1, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), o.layout.get("icon-rotation-alignment"), o.layout.get("icon-pitch-alignment"), o.layout.get("icon-keep-upright"), a, s), 0 !== o.paint.get("text-opacity").constantOr(1) && fo(t1, i, o, r, !0, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), o.layout.get("text-keep-upright"), a, s), i.map.showCollisionBoxes && (ho(t1, i, o, r, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), !0), ho(t1, i, o, r, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(t1, i, o, r) {
                if ("translucent" !== t1.renderPass) return;
                const n = o.paint.get("circle-opacity"), a = o.paint.get("circle-stroke-width"), s = o.paint.get("circle-stroke-opacity"), l = void 0 !== o.layout.get("circle-sort-key").constantOr(1);
                if (0 === n.constantOr(1) && (0 === a.constantOr(1) || 0 === s.constantOr(1))) return;
                const c = t1.context, h = c.gl, u = t1.transform, _ = t1.depthModeForSublayer(0, e1.DepthMode.ReadOnly), d = e1.StencilMode.disabled, p = t1.colorModeForRenderPass(), m = "globe" === u.projection.name, f = [
                    e1.mercatorXfromLng(u.center.lng),
                    e1.mercatorYfromLat(u.center.lat)
                ], g = [];
                for(let n = 0; n < r.length; n++){
                    const a = r[n], s = i.getTile(a), c = s.getBucket(o);
                    if (!c || c.projection.name !== u.projection.name) continue;
                    const h = c.programConfigurations.get(o.id), _ = Vi(o);
                    m && _.push("PROJECTION_GLOBE_VIEW");
                    const d = t1.useProgram("circle", h, _), p = c.layoutVertexBuffer, v = c.globeExtVertexBuffer, x = c.indexBuffer, y = u.projection.createInversionMatrix(u, a.canonical), b = {
                        programConfiguration: h,
                        program: d,
                        layoutVertexBuffer: p,
                        globeExtVertexBuffer: v,
                        indexBuffer: x,
                        uniformValues: Zi(t1, a, s, y, f, o),
                        tile: s
                    };
                    if (l) {
                        const t1 = c.segments.get();
                        for (const i of t1)g.push({
                            segments: new e1.SegmentVector([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: b
                        });
                    } else g.push({
                        segments: c.segments,
                        sortKey: 0,
                        state: b
                    });
                }
                l && g.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                const v = {
                    useDepthForOcclusion: !m
                };
                for (const i of g){
                    const { programConfiguration: r, program: n, layoutVertexBuffer: a, globeExtVertexBuffer: s, indexBuffer: l, uniformValues: m, tile: f } = i.state, g = i.segments;
                    t1.terrain && t1.terrain.setupElevationDraw(f, n, v), t1.prepareDrawProgram(c, n, f.tileID.toUnwrapped()), n.draw(c, h.TRIANGLES, _, d, p, e1.CullFaceMode.disabled, m, o.id, a, l, g, o.paint, u.zoom, r, [
                        s
                    ]);
                }
            },
            heatmap: function(t1, i, o, r) {
                if (0 !== o.paint.get("heatmap-opacity")) {
                    if ("offscreen" === t1.renderPass) {
                        const n = t1.context, a = n.gl, s = e1.StencilMode.disabled, l = new e1.ColorMode([
                            a.ONE,
                            a.ONE
                        ], e1.Color.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(e1, t1, i, o) {
                            const r = e1.gl, n = t1.width * o, a = t1.height * o;
                            e1.activeTexture.set(r.TEXTURE1), e1.viewport.set([
                                0,
                                0,
                                n,
                                a
                            ]);
                            let s = i.heatmapFbo;
                            if (!s || s && (s.width !== n || s.height !== a)) {
                                s && s.destroy();
                                const t1 = r.createTexture();
                                r.bindTexture(r.TEXTURE_2D, t1), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), s = i.heatmapFbo = e1.createFramebuffer(n, a, !1), function(e1, t1, i, o, r, n) {
                                    const a = e1.gl;
                                    a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, r, n, 0, a.RGBA, e1.extRenderToTextureHalfFloat ? e1.extTextureHalfFloat.HALF_FLOAT_OES : a.UNSIGNED_BYTE, null), o.colorAttachment.set(i);
                                }(e1, 0, t1, s, n, a);
                            } else r.bindTexture(r.TEXTURE_2D, s.colorAttachment.get()), e1.bindFramebuffer.set(s.framebuffer);
                        }(n, t1, o, "globe" === t1.transform.projection.name ? .5 : .25), n.clear({
                            color: e1.Color.transparent
                        });
                        const c = t1.transform, h = "globe" === c.projection.name, u = h ? [
                            "PROJECTION_GLOBE_VIEW"
                        ] : null, _ = h ? e1.CullFaceMode.frontCCW : e1.CullFaceMode.disabled, d = [
                            e1.mercatorXfromLng(c.center.lng),
                            e1.mercatorYfromLat(c.center.lat)
                        ];
                        for(let p = 0; p < r.length; p++){
                            const m = r[p];
                            if (i.hasRenderableParent(m)) continue;
                            const f = i.getTile(m), g = f.getBucket(o);
                            if (!g || g.projection.name !== c.projection.name) continue;
                            const v = g.programConfigurations.get(o.id), x = t1.useProgram("heatmap", v, u), { zoom: y } = t1.transform;
                            t1.terrain && t1.terrain.setupElevationDraw(f, x), t1.prepareDrawProgram(n, x, m.toUnwrapped());
                            const b = c.projection.createInversionMatrix(c, m.canonical);
                            x.draw(n, a.TRIANGLES, e1.DepthMode.disabled, s, l, _, $i(t1, m, f, b, d, y, o.paint.get("heatmap-intensity")), o.id, g.layoutVertexBuffer, g.indexBuffer, g.segments, o.paint, t1.transform.zoom, v, h ? [
                                g.globeExtVertexBuffer
                            ] : null);
                        }
                        n.viewport.set([
                            0,
                            0,
                            t1.width,
                            t1.height
                        ]);
                    } else "translucent" === t1.renderPass && (t1.context.setColorMode(t1.colorModeForRenderPass()), function(t1, i) {
                        const o = t1.context, r = o.gl, n = i.heatmapFbo;
                        if (!n) return;
                        o.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, n.colorAttachment.get()), o.activeTexture.set(r.TEXTURE1);
                        let a = i.colorRampTexture;
                        a || (a = i.colorRampTexture = new e1.Texture(o, i.colorRamp, r.RGBA)), a.bind(r.LINEAR, r.CLAMP_TO_EDGE), t1.useProgram("heatmapTexture").draw(o, r.TRIANGLES, e1.DepthMode.disabled, e1.StencilMode.disabled, t1.colorModeForRenderPass(), e1.CullFaceMode.disabled, ((e1, t1, i, o)=>({
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: t1.paint.get("heatmap-opacity")
                            }))(0, i), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom);
                    }(t1, o));
                }
            },
            line: function(t1, i, o, r) {
                if ("translucent" !== t1.renderPass) return;
                const n = o.paint.get("line-opacity"), a = o.paint.get("line-width");
                if (0 === n.constantOr(1) || 0 === a.constantOr(1)) return;
                const s = t1.depthModeForSublayer(0, e1.DepthMode.ReadOnly), l = t1.colorModeForRenderPass(), c = t1.terrain && t1.terrain.renderingToTexture ? 1 : e1.exported.devicePixelRatio, h = o.paint.get("line-dasharray"), u = h.constantOr(1), _ = o.layout.get("line-cap"), d = o.paint.get("line-pattern"), p = d.constantOr(1), m = o.paint.get("line-gradient"), f = o.getCrossfadeParameters(), g = p ? "linePattern" : "line", v = t1.context, x = v.gl, y = ((e1)=>{
                    const t1 = [];
                    Qi(e1) && t1.push("RENDER_LINE_DASH"), e1.paint.get("line-gradient") && t1.push("RENDER_LINE_GRADIENT");
                    const i = e1.paint.get("line-trim-offset");
                    0 === i[0] && 0 === i[1] || t1.push("RENDER_LINE_TRIM_OFFSET");
                    const o = e1.paint.get("line-pattern").constantOr(1), r = 1 !== e1.paint.get("line-opacity").constantOr(1);
                    return !o && r && t1.push("RENDER_LINE_ALPHA_DISCARD"), t1;
                })(o);
                let b = y.includes("RENDER_LINE_ALPHA_DISCARD");
                t1.terrain && t1.terrain.clipOrMaskOverlapStencilType() && (b = !1);
                for (const n of r){
                    const r = i.getTile(n);
                    if (p && !r.patternsLoaded()) continue;
                    const a = r.getBucket(o);
                    if (!a) continue;
                    t1.prepareDrawTile();
                    const w = a.programConfigurations.get(o.id), T = t1.useProgram(g, w, y), E = d.constantOr(null);
                    if (E && r.imageAtlas) {
                        const e1 = r.imageAtlas, t1 = e1.patternPositions[E.to.toString()], i = e1.patternPositions[E.from.toString()];
                        t1 && i && w.setConstantPatternPositions(t1, i);
                    }
                    const C = h.constantOr(null), I = _.constantOr(null);
                    if (!p && C && I && r.lineAtlas) {
                        const e1 = r.lineAtlas, t1 = e1.getDash(C.to, I), i = e1.getDash(C.from, I);
                        t1 && i && w.setConstantPatternPositions(t1, i);
                    }
                    let [M, S] = o.paint.get("line-trim-offset");
                    if ("round" === I || "square" === I) {
                        const e1 = 1;
                        M !== S && (0 === M && (M -= e1), 1 === S && (S += e1));
                    }
                    const z = t1.terrain ? n.projMatrix : null, D = p ? Yi(t1, r, o, f, z, c) : Hi(t1, r, o, f, z, a.lineClipsArray.length, c, [
                        M,
                        S
                    ]);
                    if (m) {
                        const r = a.gradients[o.id];
                        let s = r.texture;
                        if (o.gradientVersion !== r.version) {
                            let l = 256;
                            if (o.stepInterpolant) {
                                const o = i.getSource().maxzoom, r = n.canonical.z === o ? Math.ceil(1 << t1.transform.maxZoom - n.canonical.z) : 1;
                                l = e1.clamp(e1.nextPowerOfTwo(a.maxLineLength / e1.EXTENT * 1024 * r), 256, v.maxTextureSize);
                            }
                            r.gradient = e1.renderColorRamp({
                                expression: o.gradientExpression(),
                                evaluationKey: "lineProgress",
                                resolution: l,
                                image: r.gradient || void 0,
                                clips: a.lineClipsArray
                            }), r.texture ? r.texture.update(r.gradient) : r.texture = new e1.Texture(v, r.gradient, x.RGBA), r.version = o.gradientVersion, s = r.texture;
                        }
                        v.activeTexture.set(x.TEXTURE1), s.bind(o.stepInterpolant ? x.NEAREST : x.LINEAR, x.CLAMP_TO_EDGE);
                    }
                    u && (v.activeTexture.set(x.TEXTURE0), r.lineAtlasTexture.bind(x.LINEAR, x.REPEAT), w.updatePaintBuffers(f)), p && (v.activeTexture.set(x.TEXTURE0), r.imageAtlasTexture.bind(x.LINEAR, x.CLAMP_TO_EDGE), w.updatePaintBuffers(f)), t1.prepareDrawProgram(v, T, n.toUnwrapped());
                    const P = (i)=>{
                        T.draw(v, x.TRIANGLES, s, i, l, e1.CullFaceMode.disabled, D, o.id, a.layoutVertexBuffer, a.indexBuffer, a.segments, o.paint, t1.transform.zoom, w, [
                            a.layoutVertexBuffer2
                        ]);
                    };
                    if (b) {
                        const i = t1.stencilModeForClipping(n).ref;
                        0 === i && t1.terrain && v.clear({
                            stencil: 0
                        });
                        const o = {
                            func: x.EQUAL,
                            mask: 255
                        };
                        D.u_alpha_discard_threshold = .8, P(new e1.StencilMode(o, i, 255, x.KEEP, x.KEEP, x.INVERT)), D.u_alpha_discard_threshold = 0, P(new e1.StencilMode(o, i, 255, x.KEEP, x.KEEP, x.KEEP));
                    } else P(t1.stencilModeForClipping(n));
                }
                b && (t1.resetStencilClippingMasks(), t1.terrain && v.clear({
                    stencil: 0
                }));
            },
            fill: function(t1, i, o, r) {
                const n = o.paint.get("fill-color"), a = o.paint.get("fill-opacity");
                if (0 === a.constantOr(1)) return;
                const s = t1.colorModeForRenderPass(), l = o.paint.get("fill-pattern"), c = t1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === n.constantOr(e1.Color.transparent).a && 1 === a.constantOr(0) ? "opaque" : "translucent";
                if (t1.renderPass === c) {
                    const n = t1.depthModeForSublayer(1, "opaque" === t1.renderPass ? e1.DepthMode.ReadWrite : e1.DepthMode.ReadOnly);
                    vo(t1, i, o, r, n, s, !1);
                }
                if ("translucent" === t1.renderPass && o.paint.get("fill-antialias")) {
                    const n = t1.depthModeForSublayer(o.getPaintProperty("fill-outline-color") ? 2 : 0, e1.DepthMode.ReadOnly);
                    vo(t1, i, o, r, n, s, !0);
                }
            },
            "fill-extrusion": function(t1, i, o, r) {
                const n = o.paint.get("fill-extrusion-opacity");
                if (0 !== n && "translucent" === t1.renderPass) {
                    const a = new e1.DepthMode(t1.context.gl.LEQUAL, e1.DepthMode.ReadWrite, t1.depthRangeFor3D);
                    if (1 !== n || o.paint.get("fill-extrusion-pattern").constantOr(1)) xo(t1, i, o, r, a, e1.StencilMode.disabled, e1.ColorMode.disabled), xo(t1, i, o, r, a, t1.stencilModeFor3D(), t1.colorModeForRenderPass()), t1.resetStencilClippingMasks();
                    else {
                        const n = t1.colorModeForRenderPass();
                        xo(t1, i, o, r, a, e1.StencilMode.disabled, n);
                    }
                }
            },
            hillshade: function(t1, i, o, r) {
                if ("offscreen" !== t1.renderPass && "translucent" !== t1.renderPass) return;
                const n = t1.context, a = t1.depthModeForSublayer(0, e1.DepthMode.ReadOnly), s = t1.colorModeForRenderPass(), l = t1.terrain && t1.terrain.renderingToTexture, [c, h] = "translucent" !== t1.renderPass || l ? [
                    {},
                    r
                ] : t1.stencilConfigForOverlap(r);
                for (const r of h){
                    const n = i.getTile(r);
                    if (n.needsHillshadePrepare && "offscreen" === t1.renderPass) xi(t1, n, o, a, e1.StencilMode.disabled, s);
                    else if ("translucent" === t1.renderPass) {
                        const e1 = l && t1.terrain ? t1.terrain.stencilModeForRTTOverlap(r) : c[r.overscaledZ];
                        gi(t1, r, n, o, a, e1, s);
                    }
                }
                n.viewport.set([
                    0,
                    0,
                    t1.width,
                    t1.height
                ]), t1.resetStencilClippingMasks();
            },
            raster: function(t1, i, o, r, n, a) {
                if ("translucent" !== t1.renderPass) return;
                if (0 === o.paint.get("raster-opacity")) return;
                if (!r.length) return;
                const s = t1.context, l = s.gl, c = i.getSource(), h = t1.useProgram("raster"), u = t1.colorModeForRenderPass(), _ = t1.terrain && t1.terrain.renderingToTexture, [d, p] = c instanceof De || _ ? [
                    {},
                    r
                ] : t1.stencilConfigForOverlap(r), m = p[p.length - 1].overscaledZ, f = !t1.options.moving;
                for (const r of p){
                    const n = _ ? e1.DepthMode.disabled : t1.depthModeForSublayer(r.overscaledZ - m, 1 === o.paint.get("raster-opacity") ? e1.DepthMode.ReadWrite : e1.DepthMode.ReadOnly, l.LESS), p = r.toUnwrapped(), g = i.getTile(r);
                    if (_ && (!g || !g.hasData())) continue;
                    const v = _ ? r.projMatrix : t1.transform.calculateProjMatrix(p, f), x = t1.terrain && _ ? t1.terrain.stencilModeForRTTOverlap(r) : d[r.overscaledZ], y = a ? 0 : o.paint.get("raster-fade-duration");
                    g.registerFadeDuration(y);
                    const b = i.findLoadedParent(r, 0), w = Si(g, b, i, t1.transform, y);
                    let T, E;
                    t1.terrain && t1.terrain.prepareDrawTile();
                    const C = "nearest" === o.paint.get("raster-resampling") ? l.NEAREST : l.LINEAR;
                    s.activeTexture.set(l.TEXTURE0), g.texture.bind(C, l.CLAMP_TO_EDGE), s.activeTexture.set(l.TEXTURE1), b ? (b.texture.bind(C, l.CLAMP_TO_EDGE), T = Math.pow(2, b.tileID.overscaledZ - g.tileID.overscaledZ), E = [
                        g.tileID.canonical.x * T % 1,
                        g.tileID.canonical.y * T % 1
                    ]) : g.texture.bind(C, l.CLAMP_TO_EDGE);
                    const I = eo(v, E || [
                        0,
                        0
                    ], T || 1, w, o, c instanceof De ? c.perspectiveTransform : [
                        0,
                        0
                    ]);
                    if (t1.prepareDrawProgram(s, h, p), c instanceof De) c.boundsBuffer && c.boundsSegments && h.draw(s, l.TRIANGLES, n, e1.StencilMode.disabled, u, e1.CullFaceMode.disabled, I, o.id, c.boundsBuffer, t1.quadTriangleIndexBuffer, c.boundsSegments);
                    else {
                        const { tileBoundsBuffer: i, tileBoundsIndexBuffer: r, tileBoundsSegments: a } = t1.getTileBoundsBuffers(g);
                        h.draw(s, l.TRIANGLES, n, x, u, e1.CullFaceMode.disabled, I, o.id, i, r, a);
                    }
                }
                t1.resetStencilClippingMasks();
            },
            background: function(t1, i, o, r) {
                const n = o.paint.get("background-color"), a = o.paint.get("background-opacity");
                if (0 === a) return;
                const s = t1.context, l = s.gl, c = t1.transform, h = c.tileSize, u = o.paint.get("background-pattern");
                if (t1.isPatternMissing(u)) return;
                const _ = !u && 1 === n.a && 1 === a && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (t1.renderPass !== _) return;
                const d = e1.StencilMode.disabled, p = t1.depthModeForSublayer(0, "opaque" === _ ? e1.DepthMode.ReadWrite : e1.DepthMode.ReadOnly), m = t1.colorModeForRenderPass(), f = t1.useProgram(u ? "backgroundPattern" : "background");
                let g, v = r;
                v || (g = t1.getBackgroundTiles(), v = Object.values(g).map((e1)=>e1.tileID)), u && (s.activeTexture.set(l.TEXTURE0), t1.imageManager.bind(t1.context));
                const x = o.getCrossfadeParameters();
                for (const _ of v){
                    const v = _.toUnwrapped(), y = r ? _.projMatrix : t1.transform.calculateProjMatrix(v);
                    t1.prepareDrawTile();
                    const b = i ? i.getTile(_) : g ? g[_.key] : new e1.Tile(_, h, c.zoom, t1), w = u ? so(y, a, t1, u, {
                        tileID: _,
                        tileSize: h
                    }, x) : ao(y, a, n);
                    t1.prepareDrawProgram(s, f, v);
                    const { tileBoundsBuffer: T, tileBoundsIndexBuffer: E, tileBoundsSegments: C } = t1.getTileBoundsBuffers(b);
                    f.draw(s, l.TRIANGLES, p, d, m, e1.CullFaceMode.disabled, w, o.id, T, E, C);
                }
            },
            sky: function(t1, i, o) {
                const r = t1.transform, n = "mercator" === r.projection.name || "globe" === r.projection.name ? 1 : e1.smoothstep(7, 8, r.zoom), a = o.paint.get("sky-opacity") * n;
                if (0 === a) return;
                const s = t1.context, l = o.paint.get("sky-type"), c = new e1.DepthMode(s.gl.LEQUAL, e1.DepthMode.ReadOnly, [
                    0,
                    1
                ]), h = t1.frameCounter / 1e3 % 1;
                "atmosphere" === l ? "offscreen" === t1.renderPass ? o.needsSkyboxCapture(t1) && (function(t1, i, o, r) {
                    const n = t1.context, a = n.gl;
                    let s = i.skyboxFbo;
                    if (!s) {
                        s = i.skyboxFbo = n.createFramebuffer(32, 32, !1), i.skyboxGeometry = new Lo(n), i.skyboxTexture = n.gl.createTexture(), a.bindTexture(a.TEXTURE_CUBE_MAP, i.skyboxTexture), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_MIN_FILTER, a.LINEAR), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_MAG_FILTER, a.LINEAR);
                        for(let e1 = 0; e1 < 6; ++e1)a.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + e1, 0, a.RGBA, 32, 32, 0, a.RGBA, a.UNSIGNED_BYTE, null);
                    }
                    n.bindFramebuffer.set(s.framebuffer), n.viewport.set([
                        0,
                        0,
                        32,
                        32
                    ]);
                    const l = i.getCenter(t1, !0), c = t1.useProgram("skyboxCapture"), h = new Float64Array(16);
                    e1.identity(h), e1.rotateY(h, h, .5 * -Math.PI), Ro(n, i, c, h, l, 0), e1.identity(h), e1.rotateY(h, h, .5 * Math.PI), Ro(n, i, c, h, l, 1), e1.identity(h), e1.rotateX(h, h, .5 * -Math.PI), Ro(n, i, c, h, l, 2), e1.identity(h), e1.rotateX(h, h, .5 * Math.PI), Ro(n, i, c, h, l, 3), e1.identity(h), Ro(n, i, c, h, l, 4), e1.identity(h), e1.rotateY(h, h, Math.PI), Ro(n, i, c, h, l, 5), n.viewport.set([
                        0,
                        0,
                        t1.width,
                        t1.height
                    ]);
                }(t1, o), o.markSkyboxValid(t1)) : "sky" === t1.renderPass && function(t1, i, o, r, n) {
                    const a = t1.context, s = a.gl, l = t1.transform, c = t1.useProgram("skybox");
                    a.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_CUBE_MAP, i.skyboxTexture);
                    const h = ((e1, t1, i, o, r)=>({
                            u_matrix: e1,
                            u_sun_direction: t1,
                            u_cubemap: 0,
                            u_opacity: o,
                            u_temporal_offset: r
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), 0, r, n);
                    t1.prepareDrawProgram(a, c), c.draw(a, s.TRIANGLES, o, e1.StencilMode.disabled, t1.colorModeForRenderPass(), e1.CullFaceMode.backCW, h, "skybox", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, o, c, a, h) : "gradient" === l && "sky" === t1.renderPass && function(t1, i, o, r, n) {
                    const a = t1.context, s = a.gl, l = t1.transform, c = t1.useProgram("skyboxGradient");
                    i.skyboxGeometry || (i.skyboxGeometry = new Lo(a)), a.activeTexture.set(s.TEXTURE0);
                    let h = i.colorRampTexture;
                    h || (h = i.colorRampTexture = new e1.Texture(a, i.colorRamp, s.RGBA)), h.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                    const u = ((t1, i, o, r, n)=>({
                            u_matrix: t1,
                            u_color_ramp: 0,
                            u_center_direction: i,
                            u_radius: e1.degToRad(o),
                            u_opacity: r,
                            u_temporal_offset: n
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), i.paint.get("sky-gradient-radius"), r, n);
                    t1.prepareDrawProgram(a, c), c.draw(a, s.TRIANGLES, o, e1.StencilMode.disabled, t1.colorModeForRenderPass(), e1.CullFaceMode.backCW, u, "skyboxGradient", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, o, c, a, h);
            },
            debug: function(e1, t1, i) {
                for(let o = 0; o < i.length; o++)Io(e1, t1, i[o]);
            },
            custom: function(t1, i, o) {
                const r = t1.context, n = o.implementation;
                if (t1.transform.projection.unsupportedLayers && t1.transform.projection.unsupportedLayers.includes("custom")) e1.warnOnce("Custom layers are not yet supported with non-mercator projections. Use mercator to enable custom layers.");
                else if ("offscreen" === t1.renderPass) {
                    const e1 = n.prerender;
                    e1 && (t1.setCustomLayerDefaults(), r.setColorMode(t1.colorModeForRenderPass()), e1.call(n, r.gl, t1.transform.customLayerMatrix()), r.setDirty(), t1.setBaseState());
                } else if ("translucent" === t1.renderPass) {
                    t1.setCustomLayerDefaults(), r.setColorMode(t1.colorModeForRenderPass()), r.setStencilMode(e1.StencilMode.disabled);
                    const i = "3d" === n.renderingMode ? new e1.DepthMode(t1.context.gl.LEQUAL, e1.DepthMode.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, e1.DepthMode.ReadOnly);
                    r.setDepthMode(i), n.render(r.gl, t1.transform.customLayerMatrix()), r.setDirty(), t1.setBaseState(), r.bindFramebuffer.set(null);
                }
            }
        };
        class Fo {
            updateTerrain(e1, t1) {
                const i = !!e1 && !!e1.terrain && this.transform.projection.supportsTerrain;
                if (!(i || this._terrain && this._terrain.enabled)) return;
                this._terrain || (this._terrain = new Ai(this, e1));
                const o = this._terrain;
                this.transform.elevation = i ? o : null, o.update(e1, this.transform, t1);
            }
            _updateFog(e1) {
                const t1 = e1.fog;
                if (!t1 || "globe" === this.transform.projection.name || t1.getOpacity(this.transform.pitch) < 1 || t1.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
                const [i, o] = t1.getFovAdjustedRange(this.transform._fov);
                if (i > o) return void (this.transform.fogCullDistSq = null);
                const r = i + .78 * (o - i);
                this.transform.fogCullDistSq = r * r;
            }
            get terrain() {
                return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled ? this._terrain : null;
            }
            resize(t1, i) {
                if (this.width = t1 * e1.exported.devicePixelRatio, this.height = i * e1.exported.devicePixelRatio, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e1 of this.style.order)this.style._layers[e1].resize();
            }
            setup() {
                const t1 = this.context, i = new e1.StructArrayLayout2i4;
                i.emplaceBack(0, 0), i.emplaceBack(e1.EXTENT, 0), i.emplaceBack(0, e1.EXTENT), i.emplaceBack(e1.EXTENT, e1.EXTENT), this.tileExtentBuffer = t1.createVertexBuffer(i, e1.posAttributes.members), this.tileExtentSegments = e1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const o = new e1.StructArrayLayout2i4;
                o.emplaceBack(0, 0), o.emplaceBack(e1.EXTENT, 0), o.emplaceBack(0, e1.EXTENT), o.emplaceBack(e1.EXTENT, e1.EXTENT), this.debugBuffer = t1.createVertexBuffer(o, e1.posAttributes.members), this.debugSegments = e1.SegmentVector.simpleSegment(0, 0, 4, 5);
                const r = new e1.StructArrayLayout2i4;
                r.emplaceBack(-1, -1), r.emplaceBack(1, -1), r.emplaceBack(-1, 1), r.emplaceBack(1, 1), this.viewportBuffer = t1.createVertexBuffer(r, e1.posAttributes.members), this.viewportSegments = e1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const n = new e1.StructArrayLayout4i8;
                n.emplaceBack(0, 0, 0, 0), n.emplaceBack(e1.EXTENT, 0, e1.EXTENT, 0), n.emplaceBack(0, e1.EXTENT, 0, e1.EXTENT), n.emplaceBack(e1.EXTENT, e1.EXTENT, e1.EXTENT, e1.EXTENT), this.mercatorBoundsBuffer = t1.createVertexBuffer(n, e1.boundsAttributes.members), this.mercatorBoundsSegments = e1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const a = new e1.StructArrayLayout3ui6;
                a.emplaceBack(0, 1, 2), a.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t1.createIndexBuffer(a);
                const s = new e1.StructArrayLayout1ui2;
                for (const e1 of [
                    0,
                    1,
                    3,
                    2,
                    0
                ])s.emplaceBack(e1);
                this.debugIndexBuffer = t1.createIndexBuffer(s), this.emptyTexture = new e1.Texture(t1, new e1.RGBAImage({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0)), t1.gl.RGBA), this.identityMat = e1.create();
                const l = this.context.gl;
                this.stencilClearMode = new e1.StencilMode({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(e1.window.performance.now()), this.atmosphereBuffer = new Bo(this.context);
            }
            getMercatorTileBoundsBuffers() {
                return {
                    tileBoundsBuffer: this.mercatorBoundsBuffer,
                    tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
                    tileBoundsSegments: this.mercatorBoundsSegments
                };
            }
            getTileBoundsBuffers(e1) {
                return e1._makeTileBoundsBuffers(this.context, this.transform.projection), e1._tileBoundsBuffer ? {
                    tileBoundsBuffer: e1._tileBoundsBuffer,
                    tileBoundsIndexBuffer: e1._tileBoundsIndexBuffer,
                    tileBoundsSegments: e1._tileBoundsSegments
                } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
                const t1 = this.context, i = t1.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.useProgram("clippingMask").draw(t1, i.TRIANGLES, e1.DepthMode.disabled, this.stencilClearMode, e1.ColorMode.disabled, e1.CullFaceMode.disabled, Mi(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
                this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
            }
            _renderTileClippingMasks(t1, i, o) {
                if (!i || this.currentStencilSource === i.id || !t1.isTileClipped() || !o || 0 === o.length) return;
                if (this._tileClippingMaskIDs && !this.terrain) {
                    let e1 = !1;
                    for (const t1 of o)if (void 0 === this._tileClippingMaskIDs[t1.key]) {
                        e1 = !0;
                        break;
                    }
                    if (!e1) return;
                }
                this.currentStencilSource = i.id;
                const r = this.context, n = r.gl;
                this.nextStencilID + o.length > 256 && this.clearStencil(), r.setColorMode(e1.ColorMode.disabled), r.setDepthMode(e1.DepthMode.disabled);
                const a = this.useProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const t1 of o){
                    const o = i.getTile(t1), s = this._tileClippingMaskIDs[t1.key] = this.nextStencilID++, { tileBoundsBuffer: l, tileBoundsIndexBuffer: c, tileBoundsSegments: h } = this.getTileBoundsBuffers(o);
                    a.draw(r, n.TRIANGLES, e1.DepthMode.disabled, new e1.StencilMode({
                        func: n.ALWAYS,
                        mask: 0
                    }, s, 255, n.KEEP, n.KEEP, n.REPLACE), e1.ColorMode.disabled, e1.CullFaceMode.disabled, Mi(t1.projMatrix), "$clipping", l, c, h);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const t1 = this.nextStencilID++, i = this.context.gl;
                return new e1.StencilMode({
                    func: i.NOTEQUAL,
                    mask: 255
                }, t1, 255, i.KEEP, i.KEEP, i.REPLACE);
            }
            stencilModeForClipping(t1) {
                if (this.terrain) return this.terrain.stencilModeForRTTOverlap(t1);
                const i = this.context.gl;
                return new e1.StencilMode({
                    func: i.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[t1.key], 0, i.KEEP, i.KEEP, i.REPLACE);
            }
            stencilConfigForOverlap(t1) {
                const i = this.context.gl, o = t1.sort((e1, t1)=>t1.overscaledZ - e1.overscaledZ), r = o[o.length - 1].overscaledZ, n = o[0].overscaledZ - r + 1;
                if (n > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + n > 256 && this.clearStencil();
                    const t1 = {};
                    for(let o = 0; o < n; o++)t1[o + r] = new e1.StencilMode({
                        func: i.GEQUAL,
                        mask: 255
                    }, o + this.nextStencilID, 255, i.KEEP, i.KEEP, i.REPLACE);
                    return this.nextStencilID += n, [
                        t1,
                        o
                    ];
                }
                return [
                    {
                        [r]: e1.StencilMode.disabled
                    },
                    o
                ];
            }
            colorModeForRenderPass() {
                const t1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new e1.ColorMode([
                        t1.CONSTANT_COLOR,
                        t1.ONE
                    ], new e1.Color(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? e1.ColorMode.unblended : e1.ColorMode.alphaBlended;
            }
            depthModeForSublayer(t1, i, o) {
                if (!this.opaquePassEnabledForLayer()) return e1.DepthMode.disabled;
                const r = 1 - ((1 + this.currentLayer) * this.numSublayers + t1) * this.depthEpsilon;
                return new e1.DepthMode(o || this.context.gl.LEQUAL, i, [
                    r,
                    r
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(t1, i) {
                this.style = t1, this.options = i, this.lineAtlas = t1.lineAtlas, this.imageManager = t1.imageManager, this.glyphManager = t1.glyphManager, this.symbolFadeChange = t1.placement.symbolFadeChange(e1.exported.now()), this.imageManager.beginFrame();
                const o = this.style.order, r = this.style._sourceCaches;
                for(const e1 in r){
                    const t1 = r[e1];
                    t1.used && t1.prepare(this.context);
                }
                const n = {}, a = {}, s = {};
                for(const e1 in r){
                    const t1 = r[e1];
                    n[e1] = t1.getVisibleCoordinates(), a[e1] = n[e1].slice().reverse(), s[e1] = t1.getVisibleCoordinates(!0).reverse();
                }
                this.opaquePassCutoff = 1 / 0;
                for(let e1 = 0; e1 < o.length; e1++)if (this.style._layers[o[e1]].is3D()) {
                    this.opaquePassCutoff = e1;
                    break;
                }
                if (this.terrain && (this.terrain.updateTileBinding(s), this.opaquePassCutoff = 0), "globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e1.GlobeSharedBuffers(this.context)), e1.isMapAuthenticated(this.context.gl)) {
                    this.renderPass = "offscreen";
                    for (const e1 of o){
                        const i = this.style._layers[e1], o = t1._getLayerSourceCache(i);
                        if (!i.hasOffscreenPass() || i.isHidden(this.transform.zoom)) continue;
                        const r = o ? a[o.id] : void 0;
                        ("custom" === i.type || i.isSky() || r && r.length) && this.renderLayer(this, o, i, r);
                    }
                    if (this.depthRangeFor3D = [
                        0,
                        1 - (t1.order.length + 2) * this.numSublayers * this.depthEpsilon
                    ], this.terrain && (this.style.hasSymbolLayers() || this.style.hasCircleLayers()) && this.terrain.drawDepth(), this.context.bindFramebuffer.set(null), this.context.viewport.set([
                        0,
                        0,
                        this.width,
                        this.height
                    ]), this.context.clear({
                        color: i.showOverdrawInspector ? e1.Color.black : e1.Color.transparent,
                        depth: 1
                    }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", !this.terrain) for(this.currentLayer = o.length - 1; this.currentLayer >= 0; this.currentLayer--){
                        const e1 = this.style._layers[o[this.currentLayer]], i = t1._getLayerSourceCache(e1);
                        if (e1.isSky()) continue;
                        const r = i ? a[i.id] : void 0;
                        this._renderTileClippingMasks(e1, i, r), this.renderLayer(this, i, e1, r);
                    }
                    if (this.style.fog && this.transform.projection.supportsFog && function(t1, i) {
                        const o = t1.context, r = o.gl, n = t1.transform, a = new e1.DepthMode(r.LEQUAL, e1.DepthMode.ReadOnly, [
                            0,
                            1
                        ]), s = t1.useProgram("globeAtmosphere", null, "globe" === n.projection.name ? [
                            "PROJECTION_GLOBE_VIEW",
                            "FOG"
                        ] : [
                            "FOG"
                        ]), l = e1.globeToMercatorTransition(n.zoom), c = i.properties.get("color").toArray01(), h = i.properties.get("high-color").toArray01(), u = i.properties.get("space-color").toArray01PremultipliedAlpha(), _ = e1.identity$1([]);
                        e1.rotateY$1(_, _, -e1.degToRad(n._center.lng)), e1.rotateX$1(_, _, e1.degToRad(n._center.lat)), e1.rotateZ$1(_, _, n.angle), e1.rotateX$1(_, _, -n._pitch);
                        const d = e1.fromQuat(new Float32Array(16), _), p = e1.mapValue(i.properties.get("star-intensity"), 0, 1, 0, .25), m = 5e-4, f = e1.mapValue(i.properties.get("horizon-blend"), 0, 1, m, .25), g = e1.globeUseCustomAntiAliasing(t1, o, n) && f === m ? n.worldSize / (2 * Math.PI * 1.025) - 1 : n.globeRadius, v = t1.frameCounter / 1e3 % 1, x = e1.length(n.globeCenterInViewSpace), y = Math.sqrt(Math.pow(x, 2) - Math.pow(g, 2)), b = Math.acos(y / x), w = ((t1, i, o, r, n, a, s, l, c, h, u, _, d, p)=>({
                                u_frustum_tl: t1,
                                u_frustum_tr: i,
                                u_frustum_br: o,
                                u_frustum_bl: r,
                                u_horizon: n,
                                u_transition: a,
                                u_fadeout_range: s,
                                u_color: l,
                                u_high_color: c,
                                u_space_color: h,
                                u_star_intensity: u,
                                u_star_size: 5 * e1.exported.devicePixelRatio,
                                u_star_density: 0,
                                u_temporal_offset: _,
                                u_horizon_angle: d,
                                u_rotation_matrix: p
                            }))(n.frustumCorners.TL, n.frustumCorners.TR, n.frustumCorners.BR, n.frustumCorners.BL, n.frustumCorners.horizon, l, f, c, h, u, p, v, b, d);
                        t1.prepareDrawProgram(o, s);
                        const T = t1.atmosphereBuffer;
                        T && s.draw(o, r.TRIANGLES, a, e1.StencilMode.disabled, e1.ColorMode.alphaBlended, e1.CullFaceMode.backCW, w, "skybox", T.vertexBuffer, T.indexBuffer, T.segments);
                    }(this, this.style.fog), this.renderPass = "sky", (e1.globeToMercatorTransition(this.transform.zoom) > 0 || "globe" !== this.transform.projection.name) && this.transform.isHorizonVisible()) for(this.currentLayer = 0; this.currentLayer < o.length; this.currentLayer++){
                        const e1 = this.style._layers[o[this.currentLayer]], i = t1._getLayerSourceCache(e1);
                        e1.isSky() && this.renderLayer(this, i, e1, i ? a[i.id] : void 0);
                    }
                    for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < o.length;){
                        const e1 = this.style._layers[o[this.currentLayer]], i = t1._getLayerSourceCache(e1);
                        if (e1.isSky()) {
                            ++this.currentLayer;
                            continue;
                        }
                        if (this.terrain && this.style.isLayerDraped(e1)) {
                            if (e1.isHidden(this.transform.zoom)) {
                                ++this.currentLayer;
                                continue;
                            }
                            this.currentLayer = this.terrain.renderBatch(this.currentLayer);
                            continue;
                        }
                        const r = i ? ("symbol" === e1.type ? s : a)[i.id] : void 0;
                        this._renderTileClippingMasks(e1, i, i ? n[i.id] : void 0), this.renderLayer(this, i, e1, r), ++this.currentLayer;
                    }
                    if (this.terrain && this.terrain.postRender(), this.options.showTileBoundaries || this.options.showQueryGeometry) {
                        let i = null;
                        e1.values(this.style._layers).forEach((e1)=>{
                            const o = t1._getLayerSourceCache(e1);
                            o && !e1.isHidden(this.transform.zoom) && (!i || i.getSource().maxzoom < o.getSource().maxzoom) && (i = o);
                        }), i && this.options.showTileBoundaries && ko.debug(this, i, i.getVisibleCoordinates());
                    }
                    this.options.showPadding && function(e1) {
                        const t1 = e1.transform.padding;
                        Mo(e1, e1.transform.height - (t1.top || 0), 3, bo), Mo(e1, t1.bottom || 0, 3, wo), So(e1, t1.left || 0, 3, To), So(e1, e1.transform.width - (t1.right || 0), 3, Eo);
                        const i = e1.transform.centerPoint;
                        !function(e1, t1, i, o) {
                            zo(e1, t1 - 1, i - 10, 2, 20, o), zo(e1, t1 - 10, i - 1, 20, 2, o);
                        }(e1, i.x, e1.transform.height - i.y, Co);
                    }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(e1.window.performance.now()), this.saveCanvasCopy());
                }
            }
            renderLayer(e1, t1, i, o) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || o && o.length) && (this.id = i.id, this.gpuTimingStart(i), e1.transform.projection.unsupportedLayers && e1.transform.projection.unsupportedLayers.includes(i.type) || ko[i.type](e1, t1, i, o, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
            }
            gpuTimingStart(e1) {
                if (!this.options.gpuTiming) return;
                const t1 = this.context.extTimerQuery;
                let i = this.gpuTimers[e1.id];
                i || (i = this.gpuTimers[e1.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: t1.createQueryEXT()
                }), i.calls++, t1.beginQueryEXT(t1.TIME_ELAPSED_EXT, i.query);
            }
            gpuTimingDeferredRenderStart() {
                if (this.options.gpuTimingDeferredRender) {
                    const e1 = this.context.extTimerQuery, t1 = e1.createQueryEXT();
                    this.deferredRenderGpuTimeQueries.push(t1), e1.beginQueryEXT(e1.TIME_ELAPSED_EXT, t1);
                }
            }
            gpuTimingDeferredRenderEnd() {
                if (!this.options.gpuTimingDeferredRender) return;
                const e1 = this.context.extTimerQuery;
                e1.endQueryEXT(e1.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
                if (!this.options.gpuTiming) return;
                const e1 = this.context.extTimerQuery;
                e1.endQueryEXT(e1.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const e1 = this.gpuTimers;
                return this.gpuTimers = {}, e1;
            }
            collectDeferredRenderGpuQueries() {
                const e1 = this.deferredRenderGpuTimeQueries;
                return this.deferredRenderGpuTimeQueries = [], e1;
            }
            queryGpuTimers(e1) {
                const t1 = {};
                for(const i in e1){
                    const o = e1[i], r = this.context.extTimerQuery, n = r.getQueryObjectEXT(o.query, r.QUERY_RESULT_EXT) / 1e6;
                    r.deleteQueryEXT(o.query), t1[i] = n;
                }
                return t1;
            }
            queryGpuTimeDeferredRender(e1) {
                if (!this.options.gpuTimingDeferredRender) return 0;
                const t1 = this.context.extTimerQuery;
                let i = 0;
                for (const o of e1)i += t1.getQueryObjectEXT(o, t1.QUERY_RESULT_EXT) / 1e6, t1.deleteQueryEXT(o);
                return i;
            }
            translatePosMatrix(t1, i, o, r, n) {
                if (!o[0] && !o[1]) return t1;
                const a = n ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
                if (a) {
                    const e1 = Math.sin(a), t1 = Math.cos(a);
                    o = [
                        o[0] * t1 - o[1] * e1,
                        o[0] * e1 + o[1] * t1
                    ];
                }
                const s = [
                    n ? o[0] : L(i, o[0], this.transform.zoom),
                    n ? o[1] : L(i, o[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return e1.translate(l, t1, s), l;
            }
            saveTileTexture(e1) {
                const t1 = this._tileTextures[e1.size[0]];
                t1 ? t1.push(e1) : this._tileTextures[e1.size[0]] = [
                    e1
                ];
            }
            getTileTexture(e1) {
                const t1 = this._tileTextures[e1];
                return t1 && t1.length > 0 ? t1.pop() : null;
            }
            isPatternMissing(e1) {
                if (!e1) return !1;
                if (!e1.from || !e1.to) return !0;
                const t1 = this.imageManager.getPattern(e1.from.toString()), i = this.imageManager.getPattern(e1.to.toString());
                return !t1 || !i;
            }
            currentGlobalDefines() {
                const e1 = this.terrain && this.terrain.renderingToTexture, t1 = this.style && this.style.fog, i = [];
                return this.terrain && !this.terrain.renderingToTexture && i.push("TERRAIN"), t1 && !e1 && 0 !== t1.getOpacity(this.transform.pitch) && i.push("FOG"), e1 && i.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && i.push("OVERDRAW_INSPECTOR"), i;
            }
            useProgram(e1, t1, i) {
                this.cache = this.cache || {};
                const o = i || [], r = this.currentGlobalDefines().concat(o), n = Li.cacheKey(_i[e1], e1, r, t1);
                return this.cache[n] || (this.cache[n] = new Li(this.context, e1, _i[e1], t1, lo[e1], r)), this.cache[n];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e1 = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e1.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = e1.window.document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e1.Texture(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                this._terrain && this._terrain.destroy(), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this.atmosphereBuffer && this.atmosphereBuffer.destroy();
            }
            prepareDrawTile() {
                this.terrain && this.terrain.prepareDrawTile();
            }
            prepareDrawProgram(t1, i, o) {
                if (this.terrain && this.terrain.renderingToTexture) return;
                const r = this.style.fog;
                if (r) {
                    const n = r.getOpacity(this.transform.pitch), a = ((t1, i, o, r, n, a, s, l, c, h, u)=>{
                        const _ = t1.transform, d = i.properties.get("color").toArray01();
                        d[3] = r;
                        const p = t1.frameCounter / 1e3 % 1;
                        return {
                            u_fog_matrix: o ? _.calculateFogTileMatrix(o) : t1.identityMat,
                            u_fog_range: i.getFovAdjustedRange(_._fov),
                            u_fog_color: d,
                            u_fog_horizon_blend: i.properties.get("horizon-blend"),
                            u_fog_temporal_offset: p,
                            u_frustum_tl: n,
                            u_frustum_tr: a,
                            u_frustum_br: s,
                            u_frustum_bl: l,
                            u_globe_pos: c,
                            u_globe_radius: h,
                            u_viewport: u,
                            u_globe_transition: e1.globeToMercatorTransition(_.zoom),
                            u_is_globe: +("globe" === _.projection.name)
                        };
                    })(this, r, o, n, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [
                        this.transform.width * e1.exported.devicePixelRatio,
                        this.transform.height * e1.exported.devicePixelRatio
                    ]);
                    i.setFogUniformValues(t1, a);
                }
            }
            setTileLoadedFlag(e1) {
                this.tileLoaded = e1;
            }
            saveCanvasCopy() {
                this.frameCopies.push(this.canvasCopy()), this.tileLoaded = !1;
            }
            canvasCopy() {
                const e1 = this.context.gl, t1 = e1.createTexture();
                return e1.bindTexture(e1.TEXTURE_2D, t1), e1.copyTexImage2D(e1.TEXTURE_2D, 0, e1.RGBA, 0, 0, e1.drawingBufferWidth, e1.drawingBufferHeight, 0), t1;
            }
            getCanvasCopiesAndTimestamps() {
                return {
                    canvasCopies: this.frameCopies,
                    timeStamps: this.loadTimeStamps
                };
            }
            averageElevationNeedsEasing() {
                if (!this.transform._elevation) return !1;
                const e1 = this.style && this.style.fog;
                return !!e1 && 0 !== e1.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
                const t1 = this._backgroundTiles, i = this._backgroundTiles = {}, o = this.transform.coveringTiles({
                    tileSize: 512
                });
                for (const r of o)i[r.key] = t1[r.key] || new e1.Tile(r, 512, this.transform.tileZoom, this);
                return i;
            }
            clearBackgroundTiles() {
                this._backgroundTiles = {};
            }
            constructor(t1, i){
                this.context = new Ie(t1), this.transform = i, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.setup(), this.numSublayers = e1.SourceCache.maxUnderzooming + e1.SourceCache.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new $t, this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {};
            }
        }
        class Uo {
            interpolate(t1, i, o) {
                return null != i.top && null != t1.top && (this.top = e1.number(t1.top, i.top, o)), null != i.bottom && null != t1.bottom && (this.bottom = e1.number(t1.bottom, i.bottom, o)), null != i.left && null != t1.left && (this.left = e1.number(t1.left, i.left, o)), null != i.right && null != t1.right && (this.right = e1.number(t1.right, i.right, o)), this;
            }
            getCenter(t1, i) {
                const o = e1.clamp((this.left + t1 - this.right) / 2, 0, t1), r = e1.clamp((this.top + i - this.bottom) / 2, 0, i);
                return new e1.pointGeometry(o, r);
            }
            equals(e1) {
                return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
            }
            clone() {
                return new Uo(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
            constructor(e1 = 0, t1 = 0, i = 0, o = 0){
                if (isNaN(e1) || e1 < 0 || isNaN(t1) || t1 < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e1, this.bottom = t1, this.left = i, this.right = o;
            }
        }
        function No(t1, i) {
            const o = e1.getColumn(t1, 3);
            e1.fromQuat(t1, i), e1.setColumn(t1, 3, o);
        }
        function Go(t1, i) {
            const o = e1.identity$1([]);
            return e1.rotateZ$1(o, o, -i), e1.rotateX$1(o, o, -t1), o;
        }
        function jo(t1, i) {
            const o = [
                t1[0],
                t1[1],
                0
            ], r = [
                i[0],
                i[1],
                0
            ];
            if (e1.length(o) >= 1e-15) {
                const t1 = e1.normalize([], o);
                e1.scale$2(r, t1, e1.dot(r, t1)), i[0] = r[0], i[1] = r[1];
            }
            const n = e1.cross([], i, t1);
            if (e1.len(n) < 1e-15) return null;
            const a = Math.atan2(-n[1], n[0]);
            return Go(Math.atan2(Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]), -t1[2]), a);
        }
        class Zo {
            get position() {
                return this._position;
            }
            set position(t1) {
                if (t1) {
                    const i = t1 instanceof e1.MercatorCoordinate ? t1 : new e1.MercatorCoordinate(t1[0], t1[1], t1[2]);
                    this._renderWorldCopies && (i.x = e1.wrap(i.x, 0, 1)), this._position = i;
                } else this._position = null;
            }
            lookAtPoint(t1, i) {
                if (this.orientation = null, !this.position) return;
                const o = this._elevation ? this._elevation.getAtPointOrZero(e1.MercatorCoordinate.fromLngLat(t1)) : 0, r = this.position, n = e1.MercatorCoordinate.fromLngLat(t1, o), a = [
                    n.x - r.x,
                    n.y - r.y,
                    n.z - r.z
                ];
                i || (i = [
                    0,
                    0,
                    1
                ]), i[2] = Math.abs(i[2]), this.orientation = jo(a, i);
            }
            setPitchBearing(t1, i) {
                this.orientation = Go(e1.degToRad(t1), e1.degToRad(-i));
            }
            constructor(e1, t1){
                this.position = e1, this.orientation = t1;
            }
        }
        class Vo {
            get mercatorPosition() {
                const t1 = this.position;
                return new e1.MercatorCoordinate(t1[0], t1[1], t1[2]);
            }
            get position() {
                const t1 = e1.getColumn(this._transform, 3);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            set position(t1) {
                var i;
                t1 && e1.setColumn(this._transform, 3, [
                    (i = t1)[0],
                    i[1],
                    i[2],
                    1
                ]);
            }
            get orientation() {
                return this._orientation;
            }
            set orientation(t1) {
                this._orientation = t1 || e1.identity$1([]), t1 && No(this._transform, this._orientation);
            }
            getPitchBearing() {
                const e1 = this.forward(), t1 = this.right();
                return {
                    bearing: Math.atan2(-t1[1], t1[0]),
                    pitch: Math.atan2(Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]), -e1[2])
                };
            }
            setPitchBearing(e1, t1) {
                this._orientation = Go(e1, t1), No(this._transform, this._orientation);
            }
            forward() {
                const t1 = e1.getColumn(this._transform, 2);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            up() {
                const t1 = e1.getColumn(this._transform, 1);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            right() {
                const t1 = e1.getColumn(this._transform, 0);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            getCameraToWorld(t1, i) {
                const o = new Float64Array(16);
                return e1.invert(o, this.getWorldToCamera(t1, i)), o;
            }
            getWorldToCameraPosition(t1, i, o) {
                const r = this.position;
                e1.scale$2(r, r, -t1);
                const n = new Float64Array(16);
                return e1.fromScaling(n, [
                    o,
                    o,
                    o
                ]), e1.translate(n, n, r), n[10] *= i, n;
            }
            getWorldToCamera(t1, i) {
                const o = new Float64Array(16), r = new Float64Array(4), n = this.position;
                return e1.conjugate(r, this._orientation), e1.scale$2(n, n, -t1), e1.fromQuat(o, r), e1.translate(o, o, n), o[1] *= -1, o[5] *= -1, o[9] *= -1, o[13] *= -1, o[8] *= i, o[9] *= i, o[10] *= i, o[11] *= i, o;
            }
            getCameraToClipPerspective(t1, i, o, r) {
                const n = new Float64Array(16);
                return e1.perspective(n, t1, i, o, r), n;
            }
            getDistanceToElevation(t1) {
                const i = 0 === t1 ? 0 : e1.mercatorZfromAltitude(t1, this.position[1]), o = this.forward();
                return (i - this.position[2]) / o[2];
            }
            clone() {
                return new Vo([
                    ...this.position
                ], [
                    ...this.orientation
                ]);
            }
            constructor(t1, i){
                this._transform = e1.identity([]), this.orientation = i, this.position = t1;
            }
        }
        function Wo(t1, i) {
            const o = qo(t1.projection, t1.zoom, t1.width, t1.height), r = function(t1, i, o, r, n) {
                const a = new e1.LngLat(o.lng - 180 * $o, o.lat), s = new e1.LngLat(o.lng + 180 * $o, o.lat), l = t1.project(a.lng, a.lat), c = t1.project(s.lng, s.lat), h = -Math.atan2(c.y - l.y, c.x - l.x), u = e1.MercatorCoordinate.fromLngLat(o);
                u.y = e1.clamp(u.y, -0.999975, .999975);
                const _ = u.toLngLat(), d = t1.project(_.lng, _.lat), p = e1.MercatorCoordinate.fromLngLat(_);
                p.x += $o;
                const m = p.toLngLat(), f = t1.project(m.lng, m.lat), g = Yo(f.x - d.x, f.y - d.y, h), v = e1.MercatorCoordinate.fromLngLat(_);
                v.y += $o;
                const x = v.toLngLat(), y = t1.project(x.lng, x.lat), b = Yo(y.x - d.x, y.y - d.y, h), w = Math.abs(g.x) / Math.abs(b.y), T = e1.identity([]);
                e1.rotateZ(T, T, -h * (1 - (n ? 0 : r)));
                const E = e1.identity([]);
                return e1.scale(E, E, [
                    1,
                    1 - (1 - w) * r,
                    1
                ]), E[4] = -b.x / b.y * r, e1.rotateZ(E, E, h), e1.multiply(E, T, E), E;
            }(t1.projection, 0, t1.center, o, i), n = Xo(t1);
            return e1.scale(r, r, [
                n,
                n,
                1
            ]), r;
        }
        function Xo(t1) {
            const i = t1.projection, o = qo(t1.projection, t1.zoom, t1.width, t1.height), r = Ho(i, t1.center), n = Ho(i, e1.LngLat.convert(i.center));
            return Math.pow(2, r * o + (1 - o) * n);
        }
        function qo(t1, i, o, r, n = 1 / 0) {
            const a = t1.range;
            if (!a) return 0;
            const s = Math.min(n, Math.max(o, r)), l = Math.log(s / 1024) / Math.LN2;
            return e1.smoothstep(a[0] + l, a[1] + l, i);
        }
        const $o = 1 / 4e4;
        function Ho(t1, i) {
            const o = e1.clamp(i.lat, -e1.MAX_MERCATOR_LATITUDE, e1.MAX_MERCATOR_LATITUDE), r = new e1.LngLat(i.lng - 180 * $o, o), n = new e1.LngLat(i.lng + 180 * $o, o), a = t1.project(r.lng, o), s = t1.project(n.lng, o), l = e1.MercatorCoordinate.fromLngLat(r), c = e1.MercatorCoordinate.fromLngLat(n), h = s.x - a.x, u = s.y - a.y, _ = c.x - l.x, d = c.y - l.y, p = Math.sqrt((_ * _ + d * d) / (h * h + u * u));
            return Math.log(p) / Math.LN2;
        }
        function Yo(e1, t1, i) {
            const o = Math.cos(i), r = Math.sin(i);
            return {
                x: e1 * o - t1 * r,
                y: e1 * r + t1 * o
            };
        }
        class Ko {
            clone() {
                const e1 = new Ko(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection());
                return e1._elevation = this._elevation, e1._centerAltitude = this._centerAltitude, e1._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e1.tileSize = this.tileSize, e1.width = this.width, e1.height = this.height, e1.cameraElevationReference = this.cameraElevationReference, e1._center = this._center, e1._setZoom(this.zoom), e1._seaLevelZoom = this._seaLevelZoom, e1.angle = this.angle, e1._fov = this._fov, e1._pitch = this._pitch, e1._nearZ = this._nearZ, e1._farZ = this._farZ, e1._averageElevation = this._averageElevation, e1._unmodified = this._unmodified, e1._edgeInsets = this._edgeInsets.clone(), e1._camera = this._camera.clone(), e1._calcMatrices(), e1.freezeTileCoverage = this.freezeTileCoverage, e1.frustumCorners = this.frustumCorners, e1;
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(e1) {
                this._elevation !== e1 && (this._elevation = e1, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            updateElevation(e1) {
                const t1 = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
                (null == this._seaLevelZoom || t1) && this._updateCameraOnTerrain(), (e1 || t1) && this._constrainCameraAltitude(), this._calcMatrices();
            }
            getProjection() {
                return e1.pick(this.projection, [
                    "name",
                    "center",
                    "parallels"
                ]);
            }
            setProjection(i) {
                this.projectionOptions = i || {
                    name: "mercator"
                };
                const o = this.projection ? this.getProjection() : void 0;
                this.projection = e1.getProjection(this.projectionOptions);
                const r = !t1(o, this.getProjection());
                return r && this._calcMatrices(), this.mercatorFromTransition = !1, r;
            }
            setMercatorFromTransition() {
                const t1 = this.projection.name;
                this.mercatorFromTransition = !0, this.projectionOptions = {
                    name: "mercator"
                }, this.projection = e1.getProjection({
                    name: "mercator"
                });
                const i = t1 !== this.projection.name;
                return i && this._calcMatrices(), i;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(e1) {
                this._minZoom !== e1 && (this._minZoom = e1, this.zoom = Math.max(this.zoom, e1));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(e1) {
                this._maxZoom !== e1 && (this._maxZoom = e1, this.zoom = Math.min(this.zoom, e1));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(e1) {
                this._minPitch !== e1 && (this._minPitch = e1, this.pitch = Math.max(this.pitch, e1));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(e1) {
                this._maxPitch !== e1 && (this._maxPitch = e1, this.pitch = Math.min(this.pitch, e1));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e1) {
                void 0 === e1 ? e1 = !0 : null === e1 && (e1 = !1), this._renderWorldCopies = e1;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get cameraWorldSize() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get pixelsPerMeter() {
                return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
                return e1.mercatorZfromAltitude(this.center.lat, this.cameraWorldSize);
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new e1.pointGeometry(this.width, this.height);
            }
            get bearing() {
                return e1.wrap(this.rotation, -180, 180);
            }
            set bearing(e1) {
                this.rotation = e1;
            }
            get rotation() {
                return -this.angle / Math.PI * 180;
            }
            set rotation(t1) {
                const i = -t1 * Math.PI / 180;
                var o;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = (o = new e1.ARRAY_TYPE(4), e1.ARRAY_TYPE != Float32Array && (o[1] = 0, o[2] = 0), o[0] = 1, o[3] = 1, o), function(e1, t1, i) {
                    var o = t1[0], r = t1[1], n = t1[2], a = t1[3], s = Math.sin(i), l = Math.cos(i);
                    e1[0] = o * l + n * s, e1[1] = r * l + a * s, e1[2] = o * -s + n * l, e1[3] = r * -s + a * l;
                }(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(t1) {
                const i = e1.clamp(t1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            set fov(e1) {
                e1 = Math.max(.01, Math.min(60, e1)), this._fov !== e1 && (this._unmodified = !1, this._fov = e1 / 180 * Math.PI, this._calcMatrices());
            }
            get averageElevation() {
                return this._averageElevation;
            }
            set averageElevation(e1) {
                this._averageElevation = e1, this._calcFogMatrices(), this._distanceTileDataCache = {};
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(e1) {
                const t1 = Math.min(Math.max(e1, this.minZoom), this.maxZoom);
                this._zoom !== t1 && (this._unmodified = !1, this._setZoom(t1), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e1) {
                this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom;
            }
            _updateCameraOnTerrain() {
                if (!this._elevation || !this._elevation.isDataAvailableAtPoint(this.locationCoordinate(this.center))) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
                const e1 = this._elevation;
                this._centerAltitude = e1.getAtPointOrZero(this.locationCoordinate(this.center)), this._centerAltitudeValidForExaggeration = e1.exaggeration(), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
                void 0 !== this._centerAltitudeValidForExaggeration && (this._seaLevelZoom = this._zoomFromMercatorZ((this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize));
            }
            sampleAverageElevation() {
                if (!this._elevation) return 0;
                const t1 = this._elevation, i = [
                    [
                        .5,
                        .2
                    ],
                    [
                        .3,
                        .5
                    ],
                    [
                        .5,
                        .5
                    ],
                    [
                        .7,
                        .5
                    ],
                    [
                        .5,
                        .8
                    ]
                ], o = this.horizonLineFromTop();
                let r = 0, n = 0;
                for(let a = 0; a < i.length; a++){
                    const s = new e1.pointGeometry(i[a][0] * this.width, o + i[a][1] * (this.height - o)), l = t1.pointCoordinate(s);
                    if (!l) continue;
                    const c = 1 / Math.hypot(l[0] - this._camera.position[0], l[1] - this._camera.position[1]);
                    r += l[3] * c, n += c;
                }
                return 0 === n ? NaN : r / n;
            }
            get center() {
                return this._center;
            }
            set center(e1) {
                e1.lat === this._center.lat && e1.lng === this._center.lng || (this._unmodified = !1, this._center = e1, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
                if (null == this._seaLevelZoom || !this._elevation) return;
                const e1 = this._seaLevelZoom, t1 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i = this.pixelsPerMeter / this.worldSize * t1, o = this._mercatorZfromZoom(e1), r = this._mercatorZfromZoom(this._maxZoom), n = Math.max(o - i, r);
                this._setZoom(this._zoomFromMercatorZ(n));
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(e1) {
                this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
            }
            computeZoomRelativeTo(t1) {
                const i = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t1.toAltitude()));
                let o;
                o = t1.z < this._camera.position[2] ? [
                    i.x,
                    i.y,
                    i.z
                ] : [
                    t1.x,
                    t1.y,
                    t1.z
                ];
                const r = e1.length(e1.sub([], this._camera.position, o));
                return e1.clamp(this._zoomFromMercatorZ(r), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(t1) {
                if (!this.height) return;
                if (!t1.position && !t1.orientation) return;
                this._updateCameraState();
                let i = !1;
                if (t1.orientation && !e1.exactEquals(t1.orientation, this._camera.orientation) && (i = this._setCameraOrientation(t1.orientation)), t1.position) {
                    const o = [
                        t1.position.x,
                        t1.position.y,
                        t1.position.z
                    ];
                    e1.exactEquals$1(o, this._camera.position) || (this._setCameraPosition(o), i = !0);
                }
                i && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
                this._updateCameraState();
                const t1 = this._camera.position, i = new Zo;
                return i.position = new e1.MercatorCoordinate(t1[0], t1[1], t1[2]), i.orientation = this._camera.orientation, i._elevation = this.elevation, i._renderWorldCopies = this.renderWorldCopies, i;
            }
            _setCameraOrientation(t1) {
                if (!e1.length$1(t1)) return !1;
                e1.normalize$1(t1, t1);
                const i = e1.transformQuat([], [
                    0,
                    0,
                    -1
                ], t1), o = e1.transformQuat([], [
                    0,
                    -1,
                    0
                ], t1);
                if (o[2] < 0) return !1;
                const r = jo(i, o);
                return !!r && (this._camera.orientation = r, !0);
            }
            _setCameraPosition(t1) {
                const i = this.zoomScale(this.minZoom) * this.tileSize, o = this.zoomScale(this.maxZoom) * this.tileSize, r = this.cameraToCenterDistance;
                t1[2] = e1.clamp(t1[2], r / o, r / i), this._camera.position = t1;
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
                return this._fov * (.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e1) {
                return this._edgeInsets.equals(e1);
            }
            interpolatePadding(e1, t1, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e1, t1, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e1) {
                const t1 = (e1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e1.tileSize));
                return Math.max(0, t1);
            }
            getVisibleUnwrappedCoordinates(t1) {
                const i = [
                    new e1.UnwrappedTileID(0, t1)
                ];
                if (this.renderWorldCopies) {
                    const o = this.pointCoordinate(new e1.pointGeometry(0, 0)), r = this.pointCoordinate(new e1.pointGeometry(this.width, 0)), n = this.pointCoordinate(new e1.pointGeometry(this.width, this.height)), a = this.pointCoordinate(new e1.pointGeometry(0, this.height)), s = Math.floor(Math.min(o.x, r.x, n.x, a.x)), l = Math.floor(Math.max(o.x, r.x, n.x, a.x)), c = 1;
                    for(let o = s - c; o <= l + c; o++)0 !== o && i.push(new e1.UnwrappedTileID(o, t1));
                }
                return i;
            }
            coveringTiles(t1) {
                let i = this.coveringZoomLevel(t1);
                const o = i, r = this.elevation && !t1.isTerrainDEM, n = "mercator" === this.projection.name;
                if (void 0 !== t1.minzoom && i < t1.minzoom) return [];
                void 0 !== t1.maxzoom && i > t1.maxzoom && (i = t1.maxzoom);
                const a = this.locationCoordinate(this.center), s = this.center.lat, l = 1 << i, c = [
                    l * a.x,
                    l * a.y,
                    0
                ], h = "globe" === this.projection.name, u = !h, _ = e1.Frustum.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i, u), d = h ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), p = l * e1.mercatorZfromAltitude(1, this.center.lat), m = this._camera.position[2] / e1.mercatorZfromAltitude(1, this.center.lat), f = [
                    l * d.x,
                    l * d.y,
                    m * (u ? 1 : p)
                ], g = this.cameraToCenterDistance / t1.tileSize * (t1.roundZoom ? 1 : .502), v = this.pitch <= 60 && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace ? i : 0, x = t1.isTerrainDEM && this._elevation ? 1e4 * this._elevation.exaggeration() : this._centerAltitude, y = t1.isTerrainDEM ? -x : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, b = this.projection.isReprojectedInTileSpace ? Xo(this) : 1, w = (t1)=>{
                    const i = 1 / 4e4, o = new e1.MercatorCoordinate(t1.x + i, t1.y, t1.z), r = new e1.MercatorCoordinate(t1.x, t1.y + i, t1.z), n = t1.toLngLat(), a = o.toLngLat(), s = r.toLngLat(), l = this.locationCoordinate(n), c = this.locationCoordinate(a), h = this.locationCoordinate(s), u = Math.hypot(c.x - l.x, c.y - l.y), _ = Math.hypot(h.x - l.x, h.y - l.y);
                    return Math.sqrt(u * _) * b / i;
                }, T = (t1)=>{
                    const i = x, o = y;
                    return {
                        aabb: e1.tileAABB(this, l, 0, 0, 0, t1, o, i, this.projection),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        minZ: o,
                        maxZ: i,
                        wrap: t1,
                        fullyVisible: !1
                    };
                }, E = [];
                let C = [];
                const I = i, M = t1.reparseOverscaled ? o : i, S = (e1)=>e1 * e1, z = S((m - this._centerAltitude) * p), D = (e1)=>{
                    if (!this._elevation || !e1.tileID || !n) return;
                    const t1 = this._elevation.getMinMaxForTile(e1.tileID), i = e1.aabb;
                    t1 ? (i.min[2] = t1.min, i.max[2] = t1.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e1.shouldSplit = P(e1), e1.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = this._centerAltitude));
                }, P = (t1)=>{
                    if (t1.zoom < v) return !0;
                    if (t1.zoom === I) return !1;
                    if (null != t1.shouldSplit) return t1.shouldSplit;
                    const i = t1.aabb.distanceX(f), n = t1.aabb.distanceY(f);
                    let a = z, l = 1;
                    if (h) {
                        a = S(t1.aabb.distanceZ(f));
                        const i = Math.pow(2, t1.zoom), o = e1.latFromMercatorY((t1.y + 1) / i), r = e1.latFromMercatorY(t1.y / i), n = Math.min(Math.max(s, o), r), c = e1.circumferenceAtLatitude(n) / e1.circumferenceAtLatitude(s);
                        if (l = n === s ? 1 / Math.max(1, this._mercatorScaleRatio - .3) : Math.min(1, c / this._mercatorScaleRatio), this.zoom <= e1.GLOBE_ZOOM_THRESHOLD_MIN && t1.zoom === I - 1 && c >= .9) return !0;
                    } else if (r && (a = S(t1.aabb.distanceZ(f) * p)), this.projection.isReprojectedInTileSpace && o <= 5) {
                        const i = Math.pow(2, t1.zoom), o = w(new e1.MercatorCoordinate((t1.x + .5) / i, (t1.y + .5) / i));
                        l = o > .85 ? 1 : o;
                    }
                    const c = i * i + n * n + a;
                    return c < S((1 << I - t1.zoom) * g * l * ((e1, t1)=>{
                        if (t1 * S(.707) < e1) return 1;
                        const i = Math.sqrt(t1 / e1);
                        return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
                    })(Math.max(a, z), c));
                };
                if (this.renderWorldCopies) for(let e1 = 1; e1 <= 3; e1++)E.push(T(-e1)), E.push(T(e1));
                for(E.push(T(0)); E.length > 0;){
                    const o = E.pop(), a = o.x, s = o.y;
                    let u = o.fullyVisible;
                    if (!u) {
                        const e1 = o.aabb.intersects(_);
                        if (0 === e1) continue;
                        u = 2 === e1;
                    }
                    if (o.zoom !== I && P(o)) for(let t1 = 0; t1 < 4; t1++){
                        const i = (a << 1) + t1 % 2, c = (s << 1) + (t1 >> 1), _ = {
                            aabb: n ? o.aabb.quadrant(t1) : e1.tileAABB(this, l, o.zoom + 1, i, c, o.wrap, o.minZ, o.maxZ, this.projection),
                            zoom: o.zoom + 1,
                            x: i,
                            y: c,
                            wrap: o.wrap,
                            fullyVisible: u,
                            tileID: void 0,
                            shouldSplit: void 0,
                            minZ: o.minZ,
                            maxZ: o.maxZ
                        };
                        r && !h && (_.tileID = new e1.OverscaledTileID(o.zoom + 1 === I ? M : o.zoom + 1, o.wrap, o.zoom + 1, i, c), D(_)), E.push(_);
                    }
                    else {
                        const r = o.zoom === I ? M : o.zoom;
                        if (t1.minzoom && t1.minzoom > r) continue;
                        const n = c[0] - (.5 + a + (o.wrap << o.zoom)) * (1 << i - o.zoom), l = c[1] - .5 - s, h = o.tileID ? o.tileID : new e1.OverscaledTileID(r, o.wrap, o.zoom, a, s);
                        C.push({
                            tileID: h,
                            distanceSq: n * n + l * l
                        });
                    }
                }
                if (this.fogCullDistSq) {
                    const i = this.fogCullDistSq, o = this.horizonLineFromTop();
                    C = C.filter((r)=>{
                        const n = [
                            0,
                            0,
                            0,
                            1
                        ], a = [
                            e1.EXTENT,
                            e1.EXTENT,
                            0,
                            1
                        ], s = this.calculateFogTileMatrix(r.tileID.toUnwrapped());
                        e1.transformMat4$1(n, n, s), e1.transformMat4$1(a, a, s);
                        const l = e1.getAABBPointSquareDist(n, a);
                        if (0 === l) return !0;
                        let c = !1;
                        const h = this._elevation;
                        if (h && l > i && 0 !== o) {
                            const i = this.calculateProjMatrix(r.tileID.toUnwrapped());
                            let n;
                            t1.isTerrainDEM || (n = h.getMinMaxForTile(r.tileID)), n || (n = {
                                min: y,
                                max: x
                            });
                            const a = e1.furthestTileCorner(this.rotation), s = [
                                a[0] * e1.EXTENT,
                                a[1] * e1.EXTENT,
                                n.max
                            ];
                            e1.transformMat4(s, s, i), c = (1 - s[1]) * this.height * .5 < o;
                        }
                        return l < i || c;
                    });
                }
                return C.sort((e1, t1)=>e1.distanceSq - t1.distanceSq).map((e1)=>e1.tileID);
            }
            resize(e1, t1) {
                this.width = e1, this.height = t1, this.pixelsToGLUnits = [
                    2 / e1,
                    -2 / t1
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(e1) {
                return Math.pow(2, e1);
            }
            scaleZoom(e1) {
                return Math.log(e1) / Math.LN2;
            }
            project(t1) {
                const i = e1.clamp(t1.lat, -e1.MAX_MERCATOR_LATITUDE, e1.MAX_MERCATOR_LATITUDE), o = this.projection.project(t1.lng, i);
                return new e1.pointGeometry(o.x * this.worldSize, o.y * this.worldSize);
            }
            unproject(e1) {
                return this.projection.unproject(e1.x / this.worldSize, e1.y / this.worldSize);
            }
            get point() {
                return this.project(this.center);
            }
            setLocationAtPoint(t1, i) {
                let o, r;
                const n = this.centerPoint;
                if ("globe" === this.projection.name) {
                    const e1 = this.worldSize;
                    o = (i.x - n.x) / e1, r = (i.y - n.y) / e1;
                } else {
                    const e1 = this.pointCoordinate(i), t1 = this.pointCoordinate(n);
                    o = e1.x - t1.x, r = e1.y - t1.y;
                }
                const a = this.locationCoordinate(t1);
                this.setLocation(new e1.MercatorCoordinate(a.x - o, a.y - r));
            }
            setLocation(e1) {
                this.center = this.coordinateLocation(e1), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e1) {
                return this.projection.locationPoint(this, e1);
            }
            locationPoint3D(e1) {
                return this.projection.locationPoint(this, e1, !0);
            }
            pointLocation(e1) {
                return this.coordinateLocation(this.pointCoordinate(e1));
            }
            pointLocation3D(e1) {
                return this.coordinateLocation(this.pointCoordinate3D(e1));
            }
            locationCoordinate(t1, i) {
                const o = i ? e1.mercatorZfromAltitude(i, t1.lat) : void 0, r = this.projection.project(t1.lng, t1.lat);
                return new e1.MercatorCoordinate(r.x, r.y, o);
            }
            coordinateLocation(e1) {
                return this.projection.unproject(e1.x, e1.y);
            }
            pointRayIntersection(t1, i) {
                const o = null != i ? i : this._centerAltitude, r = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], n = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e1.transformMat4$1(r, r, this.pixelMatrixInverse), e1.transformMat4$1(n, n, this.pixelMatrixInverse);
                const a = n[3];
                e1.scale$1(r, r, 1 / r[3]), e1.scale$1(n, n, 1 / a);
                const s = r[2], l = n[2];
                return {
                    p0: r,
                    p1: n,
                    t: s === l ? 0 : (o - s) / (l - s)
                };
            }
            screenPointToMercatorRay(t1) {
                const i = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                return e1.transformMat4$1(i, i, this.pixelMatrixInverse), e1.transformMat4$1(o, o, this.pixelMatrixInverse), e1.scale$1(i, i, 1 / i[3]), e1.scale$1(o, o, 1 / o[3]), i[2] = e1.mercatorZfromAltitude(i[2], this._center.lat) * this.worldSize, o[2] = e1.mercatorZfromAltitude(o[2], this._center.lat) * this.worldSize, e1.scale$1(i, i, 1 / this.worldSize), e1.scale$1(o, o, 1 / this.worldSize), new e1.Ray([
                    i[0],
                    i[1],
                    i[2]
                ], e1.normalize([], e1.sub([], o, i)));
            }
            rayIntersectionCoordinate(t1) {
                const { p0: i, p1: o, t: r } = t1, n = e1.mercatorZfromAltitude(i[2], this._center.lat), a = e1.mercatorZfromAltitude(o[2], this._center.lat);
                return new e1.MercatorCoordinate(e1.number(i[0], o[0], r) / this.worldSize, e1.number(i[1], o[1], r) / this.worldSize, e1.number(n, a, r));
            }
            pointCoordinate(e1, t1 = this._centerAltitude) {
                return this.projection.pointCoordinate(this, e1.x, e1.y, t1);
            }
            pointCoordinate3D(t1) {
                if (!this.elevation) return this.pointCoordinate(t1);
                let i = this.projection.pointCoordinate3D(this, t1.x, t1.y);
                if (i) return new e1.MercatorCoordinate(i[0], i[1], i[2]);
                let o = 0, r = this.horizonLineFromTop();
                if (t1.y > r) return this.pointCoordinate(t1);
                const n = .02 * r, a = t1.clone();
                for(let t1 = 0; t1 < 10 && r - o > n; t1++){
                    a.y = e1.number(o, r, .66);
                    const t1 = this.projection.pointCoordinate3D(this, a.x, a.y);
                    t1 ? (r = a.y, i = t1) : o = a.y;
                }
                return i ? new e1.MercatorCoordinate(i[0], i[1], i[2]) : this.pointCoordinate(t1);
            }
            isPointAboveHorizon(e1) {
                return this.projection.isPointAboveHorizon(this, e1);
            }
            _coordinatePoint(t1, i) {
                const o = i && this.elevation ? this.elevation.getAtPointOrZero(t1, this._centerAltitude) : this._centerAltitude, r = [
                    t1.x * this.worldSize,
                    t1.y * this.worldSize,
                    o + t1.toAltitude(),
                    1
                ];
                return e1.transformMat4$1(r, r, this.pixelMatrix), r[3] > 0 ? new e1.pointGeometry(r[0] / r[3], r[1] / r[3]) : new e1.pointGeometry(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBounds(t1, i) {
                const o = new e1.pointGeometry(this._edgeInsets.left, this._edgeInsets.top), r = new e1.pointGeometry(this.width - this._edgeInsets.right, this._edgeInsets.top), n = new e1.pointGeometry(this.width - this._edgeInsets.right, this.height - this._edgeInsets.bottom), a = new e1.pointGeometry(this._edgeInsets.left, this.height - this._edgeInsets.bottom);
                let s = this.pointCoordinate(o, t1), l = this.pointCoordinate(r, t1);
                const c = this.pointCoordinate(n, i), h = this.pointCoordinate(a, i), u = (e1, t1)=>(t1.y - e1.y) / (t1.x - e1.x);
                return s.y > 1 && l.y >= 0 ? s = new e1.MercatorCoordinate((1 - h.y) / u(h, s) + h.x, 1) : s.y < 0 && l.y <= 1 && (s = new e1.MercatorCoordinate(-h.y / u(h, s) + h.x, 0)), l.y > 1 && s.y >= 0 ? l = new e1.MercatorCoordinate((1 - c.y) / u(c, l) + c.x, 1) : l.y < 0 && s.y <= 1 && (l = new e1.MercatorCoordinate(-c.y / u(c, l) + c.x, 0)), (new e1.LngLatBounds).extend(this.coordinateLocation(s)).extend(this.coordinateLocation(l)).extend(this.coordinateLocation(h)).extend(this.coordinateLocation(c));
            }
            _getBounds3D() {
                const e1 = this.elevation;
                if (!e1.visibleDemTiles.length) return this._getBounds(0, 0);
                const t1 = e1.visibleDemTiles.reduce((e1, t1)=>{
                    if (t1.dem) {
                        const i = t1.dem.tree;
                        e1.min = Math.min(e1.min, i.minimums[0]), e1.max = Math.max(e1.max, i.maximums[0]);
                    }
                    return e1;
                }, {
                    min: Number.MAX_VALUE,
                    max: 0
                });
                return this._getBounds(t1.min * e1.exaggeration(), t1.max * e1.exaggeration());
            }
            getBounds() {
                return this._terrainEnabled() ? this._getBounds3D() : this._getBounds(0, 0);
            }
            horizonLineFromTop(e1 = !0) {
                const t1 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) + this.centerOffset.y, i = this.height / 2 - t1 * (1 - this._horizonShift);
                return e1 ? Math.max(0, i) : i;
            }
            getMaxBounds() {
                return this.maxBounds;
            }
            setMaxBounds(t1) {
                this.maxBounds = t1, this.minLat = -e1.MAX_MERCATOR_LATITUDE, this.maxLat = e1.MAX_MERCATOR_LATITUDE, this.minLng = -180, this.maxLng = 180, t1 && (this.minLat = t1.getSouth(), this.maxLat = t1.getNorth(), this.minLng = t1.getWest(), this.maxLng = t1.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e1.mercatorXfromLng(this.minLng) * this.tileSize, this.worldMaxX = e1.mercatorXfromLng(this.maxLng) * this.tileSize, this.worldMinY = e1.mercatorYfromLat(this.maxLat) * this.tileSize, this.worldMaxY = e1.mercatorYfromLat(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e1, t1) {
                return this.projection.createTileMatrix(this, t1, e1);
            }
            calculateDistanceTileData(t1) {
                const i = t1.key, o = this._distanceTileDataCache;
                if (o[i]) return o[i];
                const r = t1.canonical, n = 1 / this.height, a = this.cameraWorldSize / this.zoomScale(r.z), s = (r.x + Math.pow(2, r.z) * t1.wrap) * a, l = r.y * a, c = this.point, h = this.angle, u = Math.sin(-h), _ = -Math.cos(-h);
                return o[i] = {
                    bearing: [
                        u,
                        _
                    ],
                    center: [
                        (c.x - s) * n,
                        (c.y - l) * n
                    ],
                    scale: a / e1.EXTENT * n
                }, o[i];
            }
            calculateFogTileMatrix(t1) {
                const i = t1.key, o = this._fogTileMatrixCache;
                if (o[i]) return o[i];
                const r = this.projection.createTileMatrix(this, this.cameraWorldSize, t1);
                return e1.multiply(r, this.worldToFogMatrix, r), o[i] = new Float32Array(r), o[i];
            }
            calculateProjMatrix(t1, i = !1) {
                const o = t1.key, r = i ? this._alignedProjMatrixCache : this._projMatrixCache;
                if (r[o]) return r[o];
                const n = this.calculatePosMatrix(t1, this.worldSize);
                return e1.multiply(n, this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : i ? this.alignedProjMatrix : this.projMatrix, n), r[o] = new Float32Array(n), r[o];
            }
            calculatePixelsToTileUnitsMatrix(t1) {
                const i = t1.tileID.key, o = this._pixelsToTileUnitsCache;
                if (o[i]) return o[i];
                const r = function(t1, i) {
                    const { scale: o } = t1.tileTransform, r = o * e1.EXTENT / (t1.tileSize * Math.pow(2, i.zoom - t1.tileID.overscaledZ + t1.tileID.canonical.z));
                    var n, a, s, l, c, h, u, _;
                    return n = new Float32Array(4), l = (a = i.inverseAdjustmentMatrix)[1], c = a[2], h = a[3], _ = (s = [
                        r,
                        r
                    ])[1], n[0] = a[0] * (u = s[0]), n[1] = l * u, n[2] = c * _, n[3] = h * _, n;
                }(t1, this);
                return o[i] = r, o[i];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            recenterOnTerrain() {
                if (!this._elevation || "globe" === this.projection.name) return;
                const t1 = this._elevation;
                this._updateCameraState();
                const i = e1.mercatorZfromAltitude(1, this._center.lat) * this.worldSize, o = this._computeCameraPosition(i), r = this._camera.forward(), n = e1.mercatorZfromAltitude(1, this._center.lat);
                o[2] /= n, r[2] /= n, e1.normalize(r, r);
                const a = t1.raycast(o, r, t1.exaggeration());
                if (a) {
                    const t1 = e1.scaleAndAdd([], o, r, a), i = new e1.MercatorCoordinate(t1[0], t1[1], e1.mercatorZfromAltitude(t1[2], e1.latFromMercatorY(t1[1]))), s = (i.z + e1.length([
                        i.x - o[0],
                        i.y - o[1],
                        i.z - o[2] * n
                    ])) * this._pixelsPerMercatorPixel;
                    this._seaLevelZoom = this._zoomFromMercatorZ(s), this._centerAltitude = i.toAltitude(), this._center = this.coordinateLocation(i), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
                }
            }
            _constrainCameraAltitude() {
                if (!this._elevation) return;
                const t1 = this._elevation;
                this._updateCameraState();
                const i = e1.mercatorZfromAltitude(1, this._center.lat) * this.worldSize, o = this._computeCameraPosition(i), r = t1.getAtPointOrZero(new e1.MercatorCoordinate(...o)), n = this._minimumHeightOverTerrain() * Math.cos(e1.degToRad(this._maxPitch)), a = this._camera.position[2] - this.pixelsPerMeter / this.worldSize * r;
                if (a < n) {
                    const t1 = this.locationCoordinate(this._center, this._centerAltitude), i = [
                        t1.x - o[0],
                        t1.y - o[1],
                        t1.z - o[2]
                    ], r = e1.length(i);
                    i[2] -= (n - a) / this._pixelsPerMercatorPixel;
                    const s = e1.length(i);
                    if (0 === s) return;
                    e1.scale$2(i, i, r / s * this._pixelsPerMercatorPixel), this._camera.position = [
                        t1.x - i[0],
                        t1.y - i[1],
                        t1.z * this._pixelsPerMercatorPixel - i[2]
                    ], this._camera.orientation = jo(i, this._camera.up()), this._updateStateFromCamera();
                }
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const t1 = "globe" === this.projection.name || this.mercatorFromTransition;
                if (this.projection.isReprojectedInTileSpace || t1) {
                    const i = this.center;
                    return i.lat = e1.clamp(i.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !t1) && (i.lng = e1.clamp(i.lng, this.minLng, this.maxLng)), this.center = i, void (this._constraining = !1);
                }
                const i = this._unmodified, { x: o, y: r } = this.point;
                let n = 0, a = o, s = r;
                const l = this.width / 2, c = this.height / 2, h = this.worldMinY * this.scale, u = this.worldMaxY * this.scale;
                if (r - c < h && (s = h + c), r + c > u && (s = u - c), u - h < this.height && (n = Math.max(n, this.height / (u - h)), s = (u + h) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                    const e1 = this.worldMinX * this.scale, t1 = this.worldMaxX * this.scale, i = this.worldSize / 2 - (e1 + t1) / 2;
                    a = (o + i + this.worldSize) % this.worldSize - i, a - l < e1 && (a = e1 + l), a + l > t1 && (a = t1 - l), t1 - e1 < this.width && (n = Math.max(n, this.width / (t1 - e1)), a = (t1 + e1) / 2);
                }
                a === o && s === r || (this.center = this.unproject(new e1.pointGeometry(a, s))), n && (this.zoom += this.scaleZoom(n)), this._constrainCameraAltitude(), this._unmodified = i, this._constraining = !1;
            }
            _minZoomForBounds() {
                let e1 = Math.max(0, this.scaleZoom(this.height / (this.worldMaxY - this.worldMinY)));
                return this.maxBounds && (e1 = Math.max(e1, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e1;
            }
            _maxCameraBoundsDistance() {
                return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
                if (!this.height) return;
                const t1 = this.centerOffset, i = this.pixelsPerMeter;
                "globe" === this.projection.name && (this._mercatorScaleRatio = e1.mercatorZfromAltitude(1, this.center.lat) / e1.mercatorZfromAltitude(1, e1.GLOBE_SCALE_MATCH_LATITUDE));
                const o = qo(this.projection, this.zoom, this.width, this.height, 1024);
                this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, o), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
                const r = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? i : 1), n = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
                n[8] = 2 * -t1.x / this.width, n[9] = 2 * t1.y / this.height;
                let a = e1.mul([], n, r);
                if (this.projection.isReprojectedInTileSpace) {
                    const t1 = this.locationCoordinate(this.center), i = e1.identity([]);
                    e1.translate(i, i, [
                        t1.x * this.worldSize,
                        t1.y * this.worldSize,
                        0
                    ]), e1.multiply(i, i, Wo(this)), e1.translate(i, i, [
                        -t1.x * this.worldSize,
                        -t1.y * this.worldSize,
                        0
                    ]), e1.multiply(a, a, i), this.inverseAdjustmentMatrix = function(e1) {
                        const t1 = Wo(e1, !0);
                        return v([], [
                            t1[0],
                            t1[1],
                            t1[4],
                            t1[5]
                        ]);
                    }(this);
                } else this.inverseAdjustmentMatrix = [
                    1,
                    0,
                    0,
                    1
                ];
                this.mercatorMatrix = e1.scale([], a, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize / i,
                    1
                ]), this.projMatrix = a, this.invProjMatrix = e1.invert(new Float64Array(16), this.projMatrix);
                const s = e1.invert([], n);
                this.frustumCorners = e1.FrustumCorners.fromInvProjectionMatrix(s, this.horizonLineFromTop(), this.height);
                const l = new Float32Array(16);
                e1.identity(l), e1.scale(l, l, [
                    1,
                    -1,
                    1
                ]), e1.rotateX(l, l, this._pitch), e1.rotateZ(l, l, this.angle);
                const c = e1.perspective(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ), h = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
                c[8] = 2 * -t1.x / this.width, c[9] = 2 * (t1.y + h) / this.height, this.skyboxMatrix = e1.multiply(l, c, l);
                const u = this.point, _ = u.x, d = u.y, p = this.width % 2 / 2, m = this.height % 2 / 2, f = Math.cos(this.angle), g = Math.sin(this.angle), x = _ - Math.round(_) + f * p + g * m, y = d - Math.round(d) + f * m + g * p, b = new Float64Array(a);
                if (e1.translate(b, b, [
                    x > .5 ? x - 1 : x,
                    y > .5 ? y - 1 : y,
                    0
                ]), this.alignedProjMatrix = b, a = e1.create(), e1.scale(a, a, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), e1.translate(a, a, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = a, a = e1.create(), e1.scale(a, a, [
                    1,
                    -1,
                    1
                ]), e1.translate(a, a, [
                    -1,
                    -1,
                    0
                ]), e1.scale(a, a, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = a, this.pixelMatrix = e1.multiply(new Float64Array(16), this.labelPlaneMatrix, this.projMatrix), this._calcFogMatrices(), this._distanceTileDataCache = {}, a = e1.invert(new Float64Array(16), this.pixelMatrix), !a) throw new Error("failed to invert matrix");
                if (this.pixelMatrixInverse = a, "globe" === this.projection.name || this.mercatorFromTransition) {
                    this.globeMatrix = e1.calculateGlobeMatrix(this);
                    const t1 = [
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ];
                    this.globeCenterInViewSpace = e1.transformMat4(t1, t1, r), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
                } else this.globeMatrix = a;
                this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {};
            }
            _calcFogMatrices() {
                this._fogTileMatrixCache = {};
                const t1 = this.cameraWorldSize, i = this.cameraPixelsPerMeter, o = this._camera.position, r = 1 / this.height / this._pixelsPerMercatorPixel, n = [
                    t1,
                    t1,
                    i
                ];
                e1.scale$2(n, n, r), e1.scale$2(o, o, -1), e1.multiply$2(o, o, n);
                const a = e1.create();
                e1.translate(a, a, o), e1.scale(a, a, n), this.mercatorFogMatrix = a, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t1, i, r);
            }
            _computeCameraPosition(e1) {
                const t1 = (e1 = e1 || this.pixelsPerMeter) / this.pixelsPerMeter, i = this._camera.forward(), o = this.point, r = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t1 - e1 / this.worldSize * this._centerAltitude;
                return [
                    o.x / this.worldSize - i[0] * r,
                    o.y / this.worldSize - i[1] * r,
                    e1 / this.worldSize * this._centerAltitude - i[2] * r
                ];
            }
            _updateCameraState() {
                this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(t1) {
                const i = this._maxCameraBoundsDistance() * Math.cos(this._pitch), o = t1[2];
                let r = 1;
                o > 0 && (r = Math.min((i - this._camera.position[2]) / o, 1)), this._camera.position = e1.scaleAndAdd([], this._camera.position, t1, r), this._updateStateFromCamera(), this.projection.wrap && (this.center = this.center.wrap());
            }
            _updateStateFromCamera() {
                const t1 = this._camera.position, i = this._camera.forward(), { pitch: o, bearing: r } = this._camera.getPitchBearing(), n = e1.mercatorZfromAltitude(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, a = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e1.degToRad(this._maxPitch)), s = Math.max((t1[2] - n) / Math.cos(o), a), l = this._zoomFromMercatorZ(s);
                e1.scaleAndAdd(t1, t1, i, s), this._pitch = e1.clamp(o, e1.degToRad(this.minPitch), e1.degToRad(this.maxPitch)), this.angle = e1.wrap(r, -Math.PI, Math.PI), this._setZoom(e1.clamp(l, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new e1.MercatorCoordinate(t1[0], t1[1], t1[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e1) {
                return Math.pow(2, e1) * this.tileSize;
            }
            _mercatorZfromZoom(e1) {
                return this.cameraToCenterDistance / this._worldSizeFromZoom(e1);
            }
            _minimumHeightOverTerrain() {
                const e1 = Math.min((null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom) + 2, this._maxZoom);
                return this._mercatorZfromZoom(e1);
            }
            _zoomFromMercatorZ(e1) {
                return this.scaleZoom(this.cameraToCenterDistance / (e1 * this.tileSize));
            }
            _terrainEnabled() {
                return !(!this._elevation || !this.projection.supportsTerrain && (e1.warnOnce("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(t1, i) {
                const o = Math.min(t1.x, i.x), r = Math.max(t1.x, i.x), n = Math.min(t1.y, i.y), a = Math.max(t1.y, i.y);
                if (n < this.horizonLineFromTop(!1)) return !0;
                if ("mercator" !== this.projection.name) return !1;
                const s = [
                    new e1.pointGeometry(o, n),
                    new e1.pointGeometry(r, a),
                    new e1.pointGeometry(o, a),
                    new e1.pointGeometry(r, n)
                ], l = this.renderWorldCopies ? -3 : 0, c = this.renderWorldCopies ? 4 : 1;
                for (const e1 of s){
                    const t1 = this.pointRayIntersection(e1);
                    if (t1.t < 0) return !0;
                    const i = this.rayIntersectionCoordinate(t1);
                    if (i.x < l || i.y < 0 || i.x > c || i.y > 1) return !0;
                }
                return !1;
            }
            isHorizonVisible() {
                return this.pitch + e1.radToDeg(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e1.pointGeometry(0, 0), new e1.pointGeometry(this.width, this.height));
            }
            zoomDeltaToMovement(t1, i) {
                const o = e1.length(e1.sub([], this._camera.position, t1)), r = this._zoomFromMercatorZ(o) + i;
                return o - this._mercatorZfromZoom(r);
            }
            getCameraPoint() {
                if ("globe" === this.projection.name) {
                    const t1 = function(t1, i) {
                        const o = [
                            t1[0],
                            t1[1],
                            t1[2],
                            1
                        ];
                        e1.transformMat4$1(o, o, i);
                        const r = Math.max(o[3], 1e-6);
                        return [
                            o[0] / r,
                            o[1] / r,
                            o[2] / r,
                            r
                        ];
                    }([
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ], this.pixelMatrix);
                    return new e1.pointGeometry(t1[0], t1[1]);
                }
                {
                    const t1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                    return this.centerPoint.add(new e1.pointGeometry(0, t1));
                }
            }
            getCameraToCenterDistance(e1) {
                const t1 = qo(e1, this.zoom, this.width, this.height, 1024), i = e1.pixelSpaceConversion(this.center.lat, this.worldSize, t1);
                return .5 / Math.tan(.5 * this._fov) * this.height * i;
            }
            constructor(t1, i, o, r, n, a, s){
                this.tileSize = 512, this._renderWorldCopies = void 0 === n || n, this._minZoom = t1 || 0, this._maxZoom = i || 22, this._minPitch = null == o ? 0 : o, this._maxPitch = null == r ? 60 : r, this.setProjection(a), this.setMaxBounds(s), this.width = 0, this.height = 0, this._center = new e1.LngLat(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = !0, this._edgeInsets = new Uo, this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new Vo, this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [
                    0,
                    0,
                    0
                ], this._horizonShift = .1;
            }
        }
        function Jo(e1, t1) {
            let i = !1, o = null;
            const r = ()=>{
                o = null, i && (e1(), o = setTimeout(r, t1), i = !1);
            };
            return ()=>(i = !0, o || r(), o);
        }
        class Qo {
            addTo(t1) {
                return this._map = t1, e1.window.addEventListener("hashchange", this._onHashChange, !1), t1.on("moveend", this._updateHash), this;
            }
            remove() {
                return this._map ? (this._map.off("moveend", this._updateHash), e1.window.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
                const t1 = this._map;
                if (!t1) return "";
                const i = er(t1);
                if (this._hashName) {
                    const t1 = this._hashName;
                    let o = !1;
                    const r = e1.window.location.hash.slice(1).split("&").map((e1)=>{
                        const r = e1.split("=")[0];
                        return r === t1 ? (o = !0, `${r}=${i}`) : e1;
                    }).filter((e1)=>e1);
                    return o || r.push(`${t1}=${i}`), `#${r.join("&")}`;
                }
                return `#${i}`;
            }
            _getCurrentHash() {
                const t1 = e1.window.location.hash.replace("#", "");
                if (this._hashName) {
                    let e1;
                    return t1.split("&").map((e1)=>e1.split("=")).forEach((t1)=>{
                        t1[0] === this._hashName && (e1 = t1);
                    }), (e1 && e1[1] || "").split("/");
                }
                return t1.split("/");
            }
            _onHashChange() {
                const e1 = this._map;
                if (!e1) return !1;
                const t1 = this._getCurrentHash();
                if (t1.length >= 3 && !t1.some((e1)=>isNaN(e1))) {
                    const i = e1.dragRotate.isEnabled() && e1.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : e1.getBearing();
                    return e1.jumpTo({
                        center: [
                            +t1[2],
                            +t1[1]
                        ],
                        zoom: +t1[0],
                        bearing: i,
                        pitch: +(t1[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                const t1 = e1.window.location.href.replace(/(#.+)?$/, this.getHashString());
                e1.window.history.replaceState(e1.window.history.state, null, t1);
            }
            constructor(t1){
                this._hashName = t1 && encodeURIComponent(t1), e1.bindAll([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = Jo(this._updateHashUnthrottled.bind(this), 300);
            }
        }
        function er(e1, t1) {
            const i = e1.getCenter(), o = Math.round(100 * e1.getZoom()) / 100, r = Math.ceil((o * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), n = Math.pow(10, r), a = Math.round(i.lng * n) / n, s = Math.round(i.lat * n) / n, l = e1.getBearing(), c = e1.getPitch();
            let h = t1 ? `/${a}/${s}/${o}` : `${o}/${s}/${a}`;
            return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += `/${Math.round(c)}`), h;
        }
        const tr = {
            linearity: .3,
            easing: e1.bezier(0, 0, .3, 1)
        }, ir = e1.extend({
            deceleration: 2500,
            maxSpeed: 1400
        }, tr), or = e1.extend({
            deceleration: 20,
            maxSpeed: 1400
        }, tr), rr = e1.extend({
            deceleration: 1e3,
            maxSpeed: 360
        }, tr), nr = e1.extend({
            deceleration: 1e3,
            maxSpeed: 90
        }, tr);
        class ar {
            clear() {
                this._inertiaBuffer = [];
            }
            record(t1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: e1.exported.now(),
                    settings: t1
                });
            }
            _drainInertiaBuffer() {
                const t1 = this._inertiaBuffer, i = e1.exported.now();
                for(; t1.length > 0 && i - t1[0].time > 160;)t1.shift();
            }
            _onMoveEnd(t1) {
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new e1.pointGeometry(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e1 } of this._inertiaBuffer)i.zoom += e1.zoomDelta || 0, i.bearing += e1.bearingDelta || 0, i.pitch += e1.pitchDelta || 0, e1.panDelta && i.pan._add(e1.panDelta), e1.around && (i.around = e1.around), e1.pinchAround && (i.pinchAround = e1.pinchAround);
                const o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r = {};
                if (i.pan.mag()) {
                    const n = lr(i.pan.mag(), o, e1.extend({}, ir, t1 || {}));
                    r.offset = i.pan.mult(n.amount / i.pan.mag()), r.center = this._map.transform.center, sr(r, n);
                }
                if (i.zoom) {
                    const e1 = lr(i.zoom, o, or);
                    r.zoom = this._map.transform.zoom + e1.amount, sr(r, e1);
                }
                if (i.bearing) {
                    const t1 = lr(i.bearing, o, rr);
                    r.bearing = this._map.transform.bearing + e1.clamp(t1.amount, -179, 179), sr(r, t1);
                }
                if (i.pitch) {
                    const e1 = lr(i.pitch, o, nr);
                    r.pitch = this._map.transform.pitch + e1.amount, sr(r, e1);
                }
                if (r.zoom || r.bearing) {
                    const e1 = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    r.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
                }
                return this.clear(), r.noMoveStart = !0, r;
            }
            constructor(e1){
                this._map = e1, this.clear();
            }
        }
        function sr(e1, t1) {
            (!e1.duration || e1.duration < t1.duration) && (e1.duration = t1.duration, e1.easing = t1.easing);
        }
        function lr(t1, i, o) {
            const { maxSpeed: r, linearity: n, deceleration: a } = o, s = e1.clamp(t1 * n / (i / 1e3), -r, r), l = Math.abs(s) / (a * n);
            return {
                easing: o.easing,
                duration: 1e3 * l,
                amount: s * (l / 2)
            };
        }
        class cr extends e1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o, r = {}){
                const n = p(i.getCanvasContainer(), o), a = i.unproject(n);
                super(t1, e1.extend({
                    point: n,
                    lngLat: a,
                    originalEvent: o
                }, r)), this._defaultPrevented = !1, this.target = i;
            }
        }
        class hr extends e1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o){
                const r = "touchend" === t1 ? o.changedTouches : o.touches, n = m(i.getCanvasContainer(), r), a = n.map((e1)=>i.unproject(e1)), s = n.reduce((e1, t1, i, o)=>e1.add(t1.div(o.length)), new e1.pointGeometry(0, 0));
                super(t1, {
                    points: n,
                    point: s,
                    lngLats: a,
                    lngLat: i.unproject(s),
                    originalEvent: o
                }), this._defaultPrevented = !1;
            }
        }
        class ur extends e1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t1, i){
                super(e1, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class _r {
            reset() {
                this._mousedownPos = void 0;
            }
            wheel(e1) {
                return this._firePreventable(new ur(e1.type, this._map, e1));
            }
            mousedown(e1, t1) {
                return this._mousedownPos = t1, this._firePreventable(new cr(e1.type, this._map, e1));
            }
            mouseup(e1) {
                this._map.fire(new cr(e1.type, this._map, e1));
            }
            preclick(t1) {
                const i = e1.extend({}, t1);
                i.type = "preclick", this._map.fire(new cr(i.type, this._map, i));
            }
            click(e1, t1) {
                this._mousedownPos && this._mousedownPos.dist(t1) >= this._clickTolerance || (this.preclick(e1), this._map.fire(new cr(e1.type, this._map, e1)));
            }
            dblclick(e1) {
                return this._firePreventable(new cr(e1.type, this._map, e1));
            }
            mouseover(e1) {
                this._map.fire(new cr(e1.type, this._map, e1));
            }
            mouseout(e1) {
                this._map.fire(new cr(e1.type, this._map, e1));
            }
            touchstart(e1) {
                return this._firePreventable(new hr(e1.type, this._map, e1));
            }
            touchmove(e1) {
                this._map.fire(new hr(e1.type, this._map, e1));
            }
            touchend(e1) {
                this._map.fire(new hr(e1.type, this._map, e1));
            }
            touchcancel(e1) {
                this._map.fire(new hr(e1.type, this._map, e1));
            }
            _firePreventable(e1) {
                if (this._map.fire(e1), e1.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
            constructor(e1, t1){
                this._map = e1, this._clickTolerance = t1.clickTolerance;
            }
        }
        class dr {
            reset() {
                this._delayContextMenu = !1, this._contextMenuEvent = void 0;
            }
            mousemove(e1) {
                this._map.fire(new cr(e1.type, this._map, e1));
            }
            mousedown() {
                this._delayContextMenu = !0;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new cr("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e1) {
                this._delayContextMenu ? this._contextMenuEvent = e1 : this._map.fire(new cr(e1.type, this._map, e1)), this._map.listens("contextmenu") && e1.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
            constructor(e1){
                this._map = e1;
            }
        }
        class pr {
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e1, t1) {
                this.isEnabled() && e1.shiftKey && 0 === e1.button && (h(), this._startPos = this._lastPos = t1, this._active = !0);
            }
            mousemoveWindow(e1, t1) {
                if (!this._active) return;
                const i = t1;
                if (this._lastPos.equals(i) || !this._box && i.dist(this._startPos) < this._clickTolerance) return;
                const o = this._startPos;
                this._lastPos = i, this._box || (this._box = n("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e1));
                const r = Math.min(o.x, i.x), a = Math.max(o.x, i.x), s = Math.min(o.y, i.y), l = Math.max(o.y, i.y);
                this._map._requestDomTask(()=>{
                    this._box && (this._box.style.transform = `translate(${r}px,${s}px)`, this._box.style.width = a - r + "px", this._box.style.height = l - s + "px");
                });
            }
            mouseupWindow(t1, i) {
                if (!this._active) return;
                if (0 !== t1.button) return;
                const o = this._startPos, r = i;
                if (this.reset(), d(), o.x !== r.x || o.y !== r.y) return this._map.fire(new e1.Event("boxzoomend", {
                    originalEvent: t1
                })), {
                    cameraAnimation: (e1)=>e1.fitScreenCoordinates(o, r, this._map.getBearing(), {
                            linear: !1
                        })
                };
                this._fireEvent("boxzoomcancel", t1);
            }
            keydown(e1) {
                this._active && 27 === e1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e1));
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), u(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(t1, i) {
                return this._map.fire(new e1.Event(t1, {
                    originalEvent: i
                }));
            }
            constructor(e1, t1){
                this._map = e1, this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t1.clickTolerance || 1;
            }
        }
        function mr(e1, t1) {
            const i = {};
            for(let o = 0; o < e1.length; o++)i[e1[o].identifier] = t1[o];
            return i;
        }
        class fr {
            reset() {
                this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
            }
            touchstart(t1, i, o) {
                (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = t1.timeStamp), o.length === this.numTouches && (this.centroid = function(t1) {
                    const i = new e1.pointGeometry(0, 0);
                    for (const e1 of t1)i._add(e1);
                    return i.div(t1.length);
                }(i), this.touches = mr(o, i)));
            }
            touchmove(e1, t1, i) {
                if (this.aborted || !this.centroid) return;
                const o = mr(i, t1);
                for(const e1 in this.touches){
                    const t1 = this.touches[e1], i = o[e1];
                    (!i || i.dist(t1) > 30) && (this.aborted = !0);
                }
            }
            touchend(e1, t1, i) {
                if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e1 = !this.aborted && this.centroid;
                    if (this.reset(), e1) return e1;
                }
            }
            constructor(e1){
                this.reset(), this.numTouches = e1.numTouches;
            }
        }
        class gr {
            reset() {
                this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e1, t1, i) {
                this.singleTap.touchstart(e1, t1, i);
            }
            touchmove(e1, t1, i) {
                this.singleTap.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                const o = this.singleTap.touchend(e1, t1, i);
                if (o) {
                    const t1 = e1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(o) < 30;
                    if (t1 && i || this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
                }
            }
            constructor(e1){
                this.singleTap = new fr(e1), this.numTaps = e1.numTaps, this.reset();
            }
        }
        class vr {
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e1, t1, i) {
                this._zoomIn.touchstart(e1, t1, i), this._zoomOut.touchstart(e1, t1, i);
            }
            touchmove(e1, t1, i) {
                this._zoomIn.touchmove(e1, t1, i), this._zoomOut.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                const o = this._zoomIn.touchend(e1, t1, i), r = this._zoomOut.touchend(e1, t1, i);
                return o ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() + 1,
                            around: t1.unproject(o)
                        }, {
                            originalEvent: e1
                        })
                }) : r ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() - 1,
                            around: t1.unproject(r)
                        }, {
                            originalEvent: e1
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this._zoomIn = new gr({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new gr({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
        }
        const xr = {
            0: 1,
            2: 2
        };
        class yr {
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e1, t1) {
                return !1;
            }
            _move(e1, t1) {
                return {};
            }
            mousedown(e1, t1) {
                if (this._lastPoint) return;
                const i = f(e1);
                this._correctButton(e1, i) && (this._lastPoint = t1, this._eventButton = i);
            }
            mousemoveWindow(e1, t1) {
                const i = this._lastPoint;
                if (i) {
                    if (e1.preventDefault(), null != this._eventButton && function(e1, t1) {
                        const i = xr[t1];
                        return void 0 === e1.buttons || (e1.buttons & i) !== i;
                    }(e1, this._eventButton)) this.reset();
                    else if (this._moved || !(t1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t1, this._move(i, t1);
                }
            }
            mouseupWindow(e1) {
                this._lastPoint && f(e1) === this._eventButton && (this._moved && d(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(e1){
                this.reset(), this._clickTolerance = e1.clickTolerance || 1;
            }
        }
        class br extends yr {
            mousedown(e1, t1) {
                super.mousedown(e1, t1), this._lastPoint && (this._active = !0);
            }
            _correctButton(e1, t1) {
                return 0 === t1 && !e1.ctrlKey;
            }
            _move(e1, t1) {
                return {
                    around: t1,
                    panDelta: t1.sub(e1)
                };
            }
        }
        class wr extends yr {
            _correctButton(e1, t1) {
                return 0 === t1 && e1.ctrlKey || 2 === t1;
            }
            _move(e1, t1) {
                const i = .8 * (t1.x - e1.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(e1) {
                e1.preventDefault();
            }
        }
        class Tr extends yr {
            _correctButton(e1, t1) {
                return 0 === t1 && e1.ctrlKey || 2 === t1;
            }
            _move(e1, t1) {
                const i = -0.5 * (t1.y - e1.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(e1) {
                e1.preventDefault();
            }
        }
        class Er {
            reset() {
                this._active = !1, this._touches = {}, this._sum = new e1.pointGeometry(0, 0);
            }
            touchstart(e1, t1, i) {
                return this._calculateTransform(e1, t1, i);
            }
            touchmove(t1, i, o) {
                if (this._active && !(o.length < this._minTouches)) {
                    if (this._map._cooperativeGestures && !this._map.isMoving()) {
                        if (1 === o.length && !e1.isFullscreen()) return void this._showTouchPanBlockerAlert();
                        "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                    }
                    return t1.cancelable && t1.preventDefault(), this._calculateTransform(t1, i, o);
                }
            }
            touchend(e1, t1, i) {
                this._calculateTransform(e1, t1, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(t1, i, o) {
                o.length > 0 && (this._active = !0);
                const r = mr(o, i), n = new e1.pointGeometry(0, 0), a = new e1.pointGeometry(0, 0);
                let s = 0;
                for(const e1 in r){
                    const t1 = r[e1], i = this._touches[e1];
                    i && (n._add(t1), a._add(t1.sub(i)), s++, r[e1] = t1);
                }
                if (this._touches = r, s < this._minTouches || !a.mag()) return;
                const l = a.div(s);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: n.div(s),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
                this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            _addTouchPanBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = n("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "null");
                }, 500);
            }
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i.clickTolerance || 1, this.reset(), e1.bindAll([
                    "_addTouchPanBlocker",
                    "_showTouchPanBlockerAlert"
                ], this);
            }
        }
        class Cr {
            reset() {
                this._active = !1, this._firstTwoTouches = void 0;
            }
            _start(e1) {}
            _move(e1, t1, i) {
                return {};
            }
            touchstart(e1, t1, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t1[0],
                    t1[1]
                ]));
            }
            touchmove(e1, t1, i) {
                const o = this._firstTwoTouches;
                if (!o) return;
                e1.preventDefault();
                const [r, n] = o, a = Ir(i, t1, r), s = Ir(i, t1, n);
                if (!a || !s) return;
                const l = this._aroundCenter ? null : a.add(s).div(2);
                return this._move([
                    a,
                    s
                ], l, e1);
            }
            touchend(e1, t1, i) {
                if (!this._firstTwoTouches) return;
                const [o, r] = this._firstTwoTouches, n = Ir(i, t1, o), a = Ir(i, t1, r);
                n && a || (this._active && d(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e1) {
                this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this.reset();
            }
        }
        function Ir(e1, t1, i) {
            for(let o = 0; o < e1.length; o++)if (e1[o].identifier === i) return t1[o];
        }
        function Mr(e1, t1) {
            return Math.log(e1 / t1) / Math.LN2;
        }
        class Sr extends Cr {
            reset() {
                super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e1) {
                this._startDistance = this._distance = e1[0].dist(e1[1]);
            }
            _move(e1, t1) {
                const i = this._distance;
                if (this._distance = e1[0].dist(e1[1]), this._active || !(Math.abs(Mr(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Mr(this._distance, i),
                    pinchAround: t1
                };
            }
        }
        function zr(e1, t1) {
            return 180 * e1.angleWith(t1) / Math.PI;
        }
        class Dr extends Cr {
            reset() {
                super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e1) {
                this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
            }
            _move(e1, t1) {
                const i = this._vector;
                if (this._vector = e1[0].sub(e1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                    bearingDelta: zr(this._vector, i),
                    pinchAround: t1
                };
            }
            _isBelowThreshold(e1) {
                this._minDiameter = Math.min(this._minDiameter, e1.mag());
                const t1 = 25 / (Math.PI * this._minDiameter) * 360, i = zr(e1, this._startVector);
                return Math.abs(i) < t1;
            }
        }
        function Pr(e1) {
            return Math.abs(e1.y) > Math.abs(e1.x);
        }
        class Ar extends Cr {
            reset() {
                super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e1) {
                this._lastPoints = e1, Pr(e1[0].sub(e1[1])) && (this._valid = !1);
            }
            _move(e1, t1, i) {
                const o = this._lastPoints;
                if (!o) return;
                const r = e1[0].sub(o[0]), n = e1[1].sub(o[1]);
                return this._map._cooperativeGestures && i.touches.length < 3 || (this._valid = this.gestureBeginsVertically(r, n, i.timeStamp), !this._valid) ? void 0 : (this._lastPoints = e1, this._active = !0, {
                    pitchDelta: (r.y + n.y) / 2 * -0.5
                });
            }
            gestureBeginsVertically(e1, t1, i) {
                if (void 0 !== this._valid) return this._valid;
                const o = e1.mag() >= 2, r = t1.mag() >= 2;
                if (!o && !r) return;
                if (!o || !r) return null == this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const n = e1.y > 0 == t1.y > 0;
                return Pr(e1) && Pr(t1) && n;
            }
            constructor(e1){
                super(), this._map = e1;
            }
        }
        const Lr = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class Rr {
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            keydown(e1) {
                if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
                let t1 = 0, i = 0, o = 0, r = 0, n = 0;
                switch(e1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t1 = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t1 = -1;
                        break;
                    case 37:
                        e1.shiftKey ? i = -1 : (e1.preventDefault(), r = -1);
                        break;
                    case 39:
                        e1.shiftKey ? i = 1 : (e1.preventDefault(), r = 1);
                        break;
                    case 38:
                        e1.shiftKey ? o = 1 : (e1.preventDefault(), n = -1);
                        break;
                    case 40:
                        e1.shiftKey ? o = -1 : (e1.preventDefault(), n = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, o = 0), {
                    cameraAnimation: (a)=>{
                        const s = a.getZoom();
                        a.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: Or,
                            zoom: t1 ? Math.round(s) + t1 * (e1.shiftKey ? 2 : 1) : s,
                            bearing: a.getBearing() + i * this._bearingStep,
                            pitch: a.getPitch() + o * this._pitchStep,
                            offset: [
                                -r * this._panStep,
                                -n * this._panStep
                            ],
                            center: a.getCenter()
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
            constructor(){
                const e1 = Lr;
                this._panStep = e1.panStep, this._bearingStep = e1.bearingStep, this._pitchStep = e1.pitchStep, this._rotationDisabled = !1;
            }
        }
        function Or(e1) {
            return e1 * (2 - e1);
        }
        const Br = 4.000244140625;
        class kr {
            setZoomRate(e1) {
                this._defaultZoomRate = e1;
            }
            setWheelZoomRate(e1) {
                this._wheelZoomRate = e1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e1) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
                this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(t1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!(t1.ctrlKey || t1.metaKey || this.isZooming() || e1.isFullscreen())) return void this._showBlockerAlert();
                    "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                let i = t1.deltaMode === e1.window.WheelEvent.DOM_DELTA_LINE ? 40 * t1.deltaY : t1.deltaY;
                const o = e1.exported.now(), r = o - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = o, 0 !== i && i % Br == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : r > 400 ? (this._type = null, this._lastValue = i, this._timeout = setTimeout(this._onTimeout, 40, t1)) : this._type || (this._type = Math.abs(r * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), t1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = t1, this._delta -= i, this._active || this._start(t1)), t1.preventDefault();
            }
            _onTimeout(e1) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e1);
            }
            _start(e1) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const t1 = p(this._el, e1);
                this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t1, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const t1 = this._map.transform, i = ()=>t1._terrainEnabled() && this._aroundCoord ? t1.computeZoomRelativeTo(this._aroundCoord) : t1.zoom;
                if (0 !== this._delta) {
                    const e1 = "wheel" === this._type && Math.abs(this._delta) > Br ? this._wheelZoomRate : this._defaultZoomRate;
                    let o = 2 / (1 + Math.exp(-Math.abs(this._delta * e1)));
                    this._delta < 0 && 0 !== o && (o = 1 / o);
                    const r = i(), n = Math.pow(2, r), a = "number" == typeof this._targetZoom ? t1.zoomScale(this._targetZoom) : n;
                    this._targetZoom = Math.min(t1.maxZoom, Math.max(t1.minZoom, t1.scaleZoom(a * o))), "wheel" === this._type && (this._startZoom = r, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                const o = "number" == typeof this._targetZoom ? this._targetZoom : i(), r = this._startZoom, n = this._easing;
                let a, s = !1;
                if ("wheel" === this._type && r && n) {
                    const t1 = Math.min((e1.exported.now() - this._lastWheelEventTime) / 200, 1), i = n(t1);
                    a = e1.number(r, o, i), t1 < 1 ? this._frameId || (this._frameId = !0) : s = !0;
                } else a = o, s = !0;
                return this._active = !0, s && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200)), {
                    noInertia: !0,
                    needsRenderFrame: !s,
                    zoomDelta: a - i(),
                    around: this._aroundPoint,
                    aroundCoord: this._aroundCoord,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(t1) {
                let i = e1.ease;
                if (this._prevEase) {
                    const t1 = this._prevEase, o = (e1.exported.now() - t1.start) / t1.duration, r = t1.easing(o + .01) - t1.easing(o), n = .27 / Math.sqrt(r * r + 1e-4) * .01, a = Math.sqrt(.0729 - n * n);
                    i = e1.bezier(n, a, .25, 1);
                }
                return this._prevEase = {
                    start: e1.exported.now(),
                    duration: t1,
                    easing: i
                }, i;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            _addScrollZoomBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = n("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(e1.window.navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "null");
                }, 200);
            }
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._handler = i, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222, e1.bindAll([
                    "_onTimeout",
                    "_addScrollZoomBlocker",
                    "_showBlockerAlert"
                ], this);
            }
        }
        class Fr {
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
            constructor(e1, t1){
                this._clickZoom = e1, this._tapZoom = t1;
            }
        }
        class Ur {
            reset() {
                this._active = !1;
            }
            blur() {
                this.reset();
            }
            dblclick(e1, t1) {
                return e1.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (e1.shiftKey ? -1 : 1),
                            around: i.unproject(t1)
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this.reset();
            }
        }
        class Nr {
            reset() {
                this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e1, t1, i) {
                this._swipePoint || (this._tapTime && e1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e1, t1, i));
            }
            touchmove(e1, t1, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const o = t1[0], r = o.y - this._swipePoint.y;
                        return this._swipePoint = o, e1.preventDefault(), this._active = !0, {
                            zoomDelta: r / 128
                        };
                    }
                } else this._tap.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e1, t1, i) && (this._tapTime = e1.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this._tap = new gr({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
        }
        class Gr {
            enable(e1) {
                this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
            constructor(e1, t1, i){
                this._el = e1, this._mousePan = t1, this._touchPan = i;
            }
        }
        class jr {
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
            constructor(e1, t1, i){
                this._pitchWithRotate = e1.pitchWithRotate, this._mouseRotate = t1, this._mousePitch = i;
            }
        }
        class Zr {
            enable(e1) {
                this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
            constructor(e1, t1, i, o){
                this._el = e1, this._touchZoom = t1, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
            }
        }
        const Vr = (e1)=>e1.zoom || e1.drag || e1.pitch || e1.rotate;
        class Wr extends e1.Event {
        }
        class Xr {
            setup(t1, i) {
                const o = e1.sub([], i, t1);
                this.radius = e1.length(o[2] < 0 ? e1.div([], o, this.constants) : [
                    o[0],
                    o[1],
                    0
                ]);
            }
            projectRay(t1) {
                e1.div(t1, t1, this.constants), e1.normalize(t1, t1), e1.mul$1(t1, t1, this.constants);
                const i = e1.scale$2([], t1, this.radius);
                if (i[2] > 0) {
                    const t1 = e1.scale$2([], [
                        0,
                        0,
                        1
                    ], e1.dot(i, [
                        0,
                        0,
                        1
                    ])), o = e1.scale$2([], e1.normalize([], [
                        i[0],
                        i[1],
                        0
                    ]), this.radius), r = e1.add([], i, e1.scale$2([], e1.sub([], e1.add([], o, t1), i), 2));
                    i[0] = r[0], i[1] = r[1];
                }
                return i;
            }
            constructor(){
                this.constants = [
                    1,
                    1,
                    .01
                ], this.radius = 0;
            }
        }
        function qr(e1) {
            return e1.panDelta && e1.panDelta.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta;
        }
        class $r {
            destroy() {
                for (const [t1, i, o] of this._listeners)t1.removeEventListener(i, t1 === e1.window.document ? this.handleWindowEvent : this.handleEvent, o);
            }
            _addDefaultHandlers(e1) {
                const t1 = this._map, i = t1.getCanvasContainer();
                this._add("mapEvent", new _r(t1, e1));
                const o = t1.boxZoom = new pr(t1, e1);
                this._add("boxZoom", o);
                const r = new vr, n = new Ur;
                t1.doubleClickZoom = new Fr(n, r), this._add("tapZoom", r), this._add("clickZoom", n);
                const a = new Nr;
                this._add("tapDragZoom", a);
                const s = t1.touchPitch = new Ar(t1);
                this._add("touchPitch", s);
                const l = new wr(e1), c = new Tr(e1);
                t1.dragRotate = new jr(e1, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new br(e1), u = new Er(t1, e1);
                t1.dragPan = new Gr(i, h, u), this._add("mousePan", h), this._add("touchPan", u, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const _ = new Dr, d = new Sr;
                t1.touchZoomRotate = new Zr(i, d, _, a), this._add("touchRotate", _, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", d, [
                    "touchPan",
                    "touchRotate"
                ]), this._add("blockableMapEvent", new dr(t1));
                const p = t1.scrollZoom = new kr(t1, this);
                this._add("scrollZoom", p, [
                    "mousePan"
                ]);
                const m = t1.keyboard = new Rr;
                this._add("keyboard", m);
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])e1.interactive && e1[i] && t1[i].enable(e1[i]);
            }
            _add(e1, t1, i) {
                this._handlers.push({
                    handlerName: e1,
                    handler: t1,
                    allowed: i
                }), this._handlersById[e1] = t1;
            }
            stop(e1) {
                if (!this._updatingCamera) {
                    for (const { handler: e1 } of this._handlers)e1.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [];
                }
            }
            isActive() {
                for (const { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return !!Vr(this._eventsInProgress) || this.isZooming();
            }
            _blockedByActive(e1, t1, i) {
                for(const o in e1)if (o !== i && (!t1 || t1.indexOf(o) < 0)) return !0;
                return !1;
            }
            handleWindowEvent(e1) {
                this.handleEvent(e1, `${e1.type}Window`);
            }
            _getMapTouches(e1) {
                const t1 = [];
                for (const i of e1)this._el.contains(i.target) && t1.push(i);
                return t1;
            }
            handleEvent(e1, t1) {
                this._updatingCamera = !0;
                const i = "renderFrame" === e1.type, o = i ? void 0 : e1, r = {
                    needsRenderFrame: !1
                }, n = {}, a = {}, s = e1.touches ? this._getMapTouches(e1.touches) : void 0, l = s ? m(this._el, s) : i ? void 0 : p(this._el, e1);
                for (const { handlerName: i, handler: c, allowed: h } of this._handlers){
                    if (!c.isEnabled()) continue;
                    let u;
                    this._blockedByActive(a, h, i) ? c.reset() : c[t1 || e1.type] && (u = c[t1 || e1.type](e1, l, s), this.mergeHandlerResult(r, n, u, i, o), u && u.needsRenderFrame && this._triggerRenderFrame()), (u || c.isActive()) && (a[i] = c);
                }
                const c = {};
                for(const e1 in this._previousActiveHandlers)a[e1] || (c[e1] = o);
                this._previousActiveHandlers = a, (Object.keys(c).length || qr(r)) && (this._changes.push([
                    r,
                    n,
                    c
                ]), this._triggerRenderFrame()), (Object.keys(a).length || qr(r)) && this._map._stop(!0), this._updatingCamera = !1;
                const { cameraAnimation: h } = r;
                h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
            }
            mergeHandlerResult(t1, i, o, r, n) {
                if (!o) return;
                e1.extend(t1, o);
                const a = {
                    handlerName: r,
                    originalEvent: o.originalEvent || n
                };
                void 0 !== o.zoomDelta && (i.zoom = a), void 0 !== o.panDelta && (i.drag = a), void 0 !== o.pitchDelta && (i.pitch = a), void 0 !== o.bearingDelta && (i.rotate = a);
            }
            _applyChanges() {
                const t1 = {}, i = {}, o = {};
                for (const [r, n, a] of this._changes)r.panDelta && (t1.panDelta = (t1.panDelta || new e1.pointGeometry(0, 0))._add(r.panDelta)), r.zoomDelta && (t1.zoomDelta = (t1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (t1.bearingDelta = (t1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (t1.pitchDelta = (t1.pitchDelta || 0) + r.pitchDelta), void 0 !== r.around && (t1.around = r.around), void 0 !== r.aroundCoord && (t1.aroundCoord = r.aroundCoord), void 0 !== r.pinchAround && (t1.pinchAround = r.pinchAround), r.noInertia && (t1.noInertia = r.noInertia), e1.extend(i, n), e1.extend(o, a);
                this._updateMapTransform(t1, i, o), this._changes = [];
            }
            _updateMapTransform(t1, i, o) {
                const r = this._map, n = r.transform, a = (e1)=>[
                        e1.x,
                        e1.y,
                        e1.z
                    ];
                if (((e1)=>{
                    const t1 = this._eventsInProgress.drag;
                    return t1 && !this._handlersById[t1.handlerName].isActive();
                })() && !qr(t1)) {
                    const e1 = n.zoom;
                    n.cameraElevationReference = "sea", n.recenterOnTerrain(), n.cameraElevationReference = "ground", e1 !== n.zoom && this._map._update(!0);
                }
                if (!qr(t1)) return void this._fireEvents(i, o, !0);
                let { panDelta: s, zoomDelta: l, bearingDelta: c, pitchDelta: h, around: u, aroundCoord: _, pinchAround: d } = t1;
                void 0 !== d && (u = d), ((e1)=>i.drag && !this._eventsInProgress.drag)() && u && (this._dragOrigin = a(n.pointCoordinate3D(u)), this._trackingEllipsoid.setup(n._camera.position, this._dragOrigin)), n.cameraElevationReference = "sea", r._stop(!0), u = u || r.transform.centerPoint, c && (n.bearing += c), h && (n.pitch += h), n._updateCameraState();
                const p = [
                    0,
                    0,
                    0
                ];
                if (s) {
                    if ("mercator" === n.projection.name) {
                        const e1 = this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(u).dir), t1 = this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(u.sub(s)).dir);
                        p[0] = t1[0] - e1[0], p[1] = t1[1] - e1[1];
                    } else {
                        const t1 = n.pointCoordinate(u);
                        if ("globe" === n.projection.name) {
                            s = s.rotate(-n.angle);
                            const i = n._pixelsPerMercatorPixel / n.worldSize;
                            p[0] = -s.x * e1.mercatorScale(e1.latFromMercatorY(t1.y)) * i, p[1] = -s.y * e1.mercatorScale(n.center.lat) * i;
                        } else {
                            const e1 = n.pointCoordinate(u.sub(s));
                            t1 && e1 && (p[0] = e1.x - t1.x, p[1] = e1.y - t1.y);
                        }
                    }
                }
                const m = n.zoom, f = [
                    0,
                    0,
                    0
                ];
                if (l) {
                    const t1 = a(_ || n.pointCoordinate3D(u)), i = {
                        dir: e1.normalize([], e1.sub([], t1, n._camera.position))
                    };
                    if (i.dir[2] < 0) {
                        const o = n.zoomDeltaToMovement(t1, l);
                        e1.scale$2(f, i.dir, o);
                    }
                }
                const g = e1.add(p, p, f);
                n._translateCameraConstrained(g), l && Math.abs(n.zoom - m) > 1e-4 && n.recenterOnTerrain(), n.cameraElevationReference = "ground", this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(i, o, !0);
            }
            _fireEvents(t1, i, o) {
                const r = Vr(this._eventsInProgress), n = Vr(t1), a = {};
                for(const e1 in t1){
                    const { originalEvent: i } = t1[e1];
                    this._eventsInProgress[e1] || (a[`${e1}start`] = i), this._eventsInProgress[e1] = t1[e1];
                }
                !r && n && this._fireEvent("movestart", n.originalEvent);
                for(const e1 in a)this._fireEvent(e1, a[e1]);
                n && this._fireEvent("move", n.originalEvent);
                for(const e1 in t1){
                    const { originalEvent: i } = t1[e1];
                    this._fireEvent(e1, i);
                }
                const s = {};
                let l;
                for(const e1 in this._eventsInProgress){
                    const { handlerName: t1, originalEvent: o } = this._eventsInProgress[e1];
                    this._handlersById[t1].isActive() || (delete this._eventsInProgress[e1], l = i[t1] || o, s[`${e1}end`] = l);
                }
                for(const e1 in s)this._fireEvent(e1, s[e1]);
                const c = Vr(this._eventsInProgress);
                if (o && (r || n) && !c) {
                    this._updatingCamera = !0;
                    const t1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e1)=>0 !== e1 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
                    t1 ? (i(t1.bearing || this._map.getBearing()) && (t1.bearing = 0), this._map.easeTo(t1, {
                        originalEvent: l
                    })) : (this._map.fire(new e1.Event("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(t1, i) {
                this._map.fire(new e1.Event(t1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
                    this._frameId = void 0, this.handleEvent(new Wr("renderFrame", {
                        timeStamp: e1
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
            constructor(t1, i){
                this._map = t1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new ar(t1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new Xr, this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i), e1.bindAll([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const o = this._el;
                this._listeners = [
                    [
                        o,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        o,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "touchend",
                        void 0
                    ],
                    [
                        o,
                        "touchcancel",
                        void 0
                    ],
                    [
                        o,
                        "mousedown",
                        void 0
                    ],
                    [
                        o,
                        "mousemove",
                        void 0
                    ],
                    [
                        o,
                        "mouseup",
                        void 0
                    ],
                    [
                        e1.window.document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        e1.window.document,
                        "mouseup",
                        void 0
                    ],
                    [
                        o,
                        "mouseover",
                        void 0
                    ],
                    [
                        o,
                        "mouseout",
                        void 0
                    ],
                    [
                        o,
                        "dblclick",
                        void 0
                    ],
                    [
                        o,
                        "click",
                        void 0
                    ],
                    [
                        o,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        o,
                        "keyup",
                        void 0
                    ],
                    [
                        o,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "contextmenu",
                        void 0
                    ],
                    [
                        e1.window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [t1, i, o] of this._listeners)t1.addEventListener(i, t1 === e1.window.document ? this.handleWindowEvent : this.handleEvent, o);
            }
        }
        const Hr = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class Yr extends e1.Evented {
            getCenter() {
                return new e1.LngLat(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e1, t1) {
                return this.jumpTo({
                    center: e1
                }, t1);
            }
            panBy(t1, i, o) {
                return t1 = e1.pointGeometry.convert(t1).mult(-1), this.panTo(this.transform.center, e1.extend({
                    offset: t1
                }, i), o);
            }
            panTo(t1, i, o) {
                return this.easeTo(e1.extend({
                    center: t1
                }, i), o);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e1, t1) {
                return this.jumpTo({
                    zoom: e1
                }, t1), this;
            }
            zoomTo(t1, i, o) {
                return this.easeTo(e1.extend({
                    zoom: t1
                }, i), o);
            }
            zoomIn(e1, t1) {
                return this.zoomTo(this.getZoom() + 1, e1, t1), this;
            }
            zoomOut(e1, t1) {
                return this.zoomTo(this.getZoom() - 1, e1, t1), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e1, t1) {
                return this.jumpTo({
                    bearing: e1
                }, t1), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e1, t1) {
                return this.jumpTo({
                    padding: e1
                }, t1), this;
            }
            rotateTo(t1, i, o) {
                return this.easeTo(e1.extend({
                    bearing: t1
                }, i), o);
            }
            resetNorth(t1, i) {
                return this.rotateTo(0, e1.extend({
                    duration: 1e3
                }, t1), i), this;
            }
            resetNorthPitch(t1, i) {
                return this.easeTo(e1.extend({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, t1), i), this;
            }
            snapToNorth(e1, t1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t1) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e1, t1) {
                return this.jumpTo({
                    pitch: e1
                }, t1), this;
            }
            cameraForBounds(t1, i) {
                "globe" === this.transform.projection.name && e1.warnOnce('Globe projection does not support cameraForBounds API, this API may behave unexpectedly."'), t1 = e1.LngLatBounds.convert(t1);
                const o = i && i.bearing || 0;
                return this._cameraForBoxAndBearing(t1.getNorthWest(), t1.getSouthEast(), o, i);
            }
            _extendCameraOptions(t1) {
                const i = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (t1 = e1.extend({
                    padding: i,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, t1)).padding) {
                    const e1 = t1.padding;
                    t1.padding = {
                        top: e1,
                        bottom: e1,
                        right: e1,
                        left: e1
                    };
                }
                return t1.padding = e1.extend(i, t1.padding), t1;
            }
            _cameraForBoxAndBearing(t1, i, o, r) {
                const n = this._extendCameraOptions(r), a = this.transform, s = a.padding, l = a.project(e1.LngLat.convert(t1)), c = a.project(e1.LngLat.convert(i)), h = new e1.pointGeometry(l.x, c.y), u = new e1.pointGeometry(c.x, l.y), _ = -e1.degToRad(o), d = l.rotate(_), p = c.rotate(_), m = h.rotate(_), f = u.rotate(_), g = new e1.pointGeometry(Math.max(d.x, p.x, m.x, f.x), Math.max(d.y, p.y, m.y, f.y)), v = new e1.pointGeometry(Math.min(d.x, p.x, m.x, f.x), Math.min(d.y, p.y, m.y, f.y)), x = g.sub(v), y = (a.width - ((s.left || 0) + (s.right || 0) + n.padding.left + n.padding.right)) / x.x, b = (a.height - ((s.top || 0) + (s.bottom || 0) + n.padding.top + n.padding.bottom)) / x.y;
                if (b < 0 || y < 0) return void e1.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                const w = Math.min(a.scaleZoom(a.scale * Math.min(y, b)), n.maxZoom), T = "number" == typeof n.offset.x && "number" == typeof n.offset.y ? new e1.pointGeometry(n.offset.x, n.offset.y) : e1.pointGeometry.convert(n.offset), E = new e1.pointGeometry((n.padding.left - n.padding.right) / 2, (n.padding.top - n.padding.bottom) / 2).rotate(o * Math.PI / 180), C = T.add(E).mult(a.scale / a.zoomScale(w));
                return {
                    center: a.unproject(l.add(c).div(2).sub(C)),
                    zoom: w,
                    bearing: o
                };
            }
            _cameraForBox(t1, i, o, r, n) {
                const a = this._extendCameraOptions(n);
                o = o || 0, r = r || 0, t1 = e1.LngLat.convert(t1), i = e1.LngLat.convert(i);
                const s = this.transform.clone();
                s.padding = a.padding;
                const l = this.getFreeCameraOptions(), c = new e1.LngLat(.5 * (t1.lng + i.lng), .5 * (t1.lat + i.lat)), h = .5 * (o + r);
                if (s._camera.position[2] < e1.mercatorZfromAltitude(h, c.lat)) return void e1.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                l.lookAtPoint(c), s.setFreeCameraOptions(l);
                const u = e1.MercatorCoordinate.fromLngLat(t1), _ = e1.MercatorCoordinate.fromLngLat(i), d = s.pointRayIntersection(s.centerPoint, h), p = [
                    (m = s.rayIntersectionCoordinate(d)).x,
                    m.y,
                    m.z
                ];
                var m;
                const f = s.screenPointToMercatorRay(s.centerPoint), g = "globe" !== s.projection.name;
                let v, x = 0;
                do {
                    const t1 = Math.floor(s.zoom), i = 1 << t1, n = Math.min(i * u.x, i * _.x), a = Math.min(i * u.y, i * _.y), l = Math.max(i * u.x, i * _.x), c = Math.max(i * u.y, i * _.y), h = new e1.Aabb([
                        n,
                        a,
                        o
                    ], [
                        l,
                        c,
                        r
                    ]), d = e1.Frustum.fromInvProjectionMatrix(s.invProjMatrix, s.worldSize, t1, g);
                    if (2 !== h.intersects(d)) {
                        v && (s._camera.position = e1.scaleAndAdd([], s._camera.position, f.dir, -v), s._updateStateFromCamera());
                        break;
                    }
                    const m = e1.sub([], s._camera.position, p);
                    v = .5 * e1.length(m), s._camera.position = e1.scaleAndAdd([], s._camera.position, f.dir, v);
                    try {
                        s._updateStateFromCamera();
                    } catch (t1) {
                        return void e1.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                    }
                }while (++x < 10);
                return {
                    center: s.center,
                    zoom: s.zoom,
                    bearing: s.bearing,
                    pitch: s.pitch
                };
            }
            fitBounds(t1, i, o) {
                return "globe" === this.transform.projection.name && e1.warnOnce("Globe projection does not support fitBounds API, this API may behave unexpectedly."), this._fitInternal(this.cameraForBounds(t1, i), i, o);
            }
            _raycastElevationBox(t1, i) {
                const o = this.transform.elevation;
                if (!o) return;
                const r = new e1.pointGeometry(t1.x, i.y), n = new e1.pointGeometry(i.x, t1.y), a = o.pointCoordinate(t1);
                if (!a) return;
                const s = o.pointCoordinate(i);
                if (!s) return;
                const l = o.pointCoordinate(r);
                if (!l) return;
                const c = o.pointCoordinate(n);
                if (!c) return;
                const h = new e1.MercatorCoordinate(a[0], a[1]).toLngLat(), u = new e1.MercatorCoordinate(s[0], s[1]).toLngLat(), _ = new e1.MercatorCoordinate(l[0], l[1]).toLngLat(), d = new e1.MercatorCoordinate(c[0], c[1]).toLngLat(), p = Math.min(h.lng, Math.min(u.lng, Math.min(_.lng, d.lng))), m = Math.min(h.lat, Math.min(u.lat, Math.min(_.lat, d.lat))), f = Math.max(h.lng, Math.max(u.lng, Math.max(_.lng, d.lng))), g = Math.max(h.lat, Math.max(u.lat, Math.max(_.lat, d.lat))), v = Math.min(a[3], Math.min(s[3], Math.min(l[3], c[3]))), x = Math.max(a[3], Math.max(s[3], Math.max(l[3], c[3])));
                return {
                    minLngLat: new e1.LngLat(p, m),
                    maxLngLat: new e1.LngLat(f, g),
                    minAltitude: v,
                    maxAltitude: x
                };
            }
            fitScreenCoordinates(t1, i, o, r, n) {
                let a, s, l, c;
                "globe" === this.transform.projection.name && e1.warnOnce("Globe projection does not support fitScreenCoordinates API, this API may behave unexpectedly.");
                const h = e1.pointGeometry.convert(t1), u = e1.pointGeometry.convert(i), _ = this._raycastElevationBox(h, u);
                if (_) a = _.minLngLat, s = _.maxLngLat, l = _.minAltitude, c = _.maxAltitude;
                else {
                    if (this.transform.anyCornerOffEdge(h, u)) return this;
                    a = this.transform.pointLocation(h), s = this.transform.pointLocation(u);
                }
                return this._fitInternal(0 === this.transform.pitch ? this._cameraForBoxAndBearing(this.transform.pointLocation(e1.pointGeometry.convert(t1)), this.transform.pointLocation(e1.pointGeometry.convert(i)), o, r) : this._cameraForBox(a, s, l, c, r), r, n);
            }
            _fitInternal(t1, i, o) {
                return t1 ? (delete (i = e1.extend(t1, i)).padding, i.linear ? this.easeTo(i, o) : this.flyTo(i, o)) : this;
            }
            jumpTo(t1, i) {
                this.stop();
                const o = t1.preloadOnly ? this.transform.clone() : this.transform;
                let r = !1, n = !1, a = !1;
                return "zoom" in t1 && o.zoom !== +t1.zoom && (r = !0, o.zoom = +t1.zoom), void 0 !== t1.center && (o.center = e1.LngLat.convert(t1.center)), "bearing" in t1 && o.bearing !== +t1.bearing && (n = !0, o.bearing = +t1.bearing), "pitch" in t1 && o.pitch !== +t1.pitch && (a = !0, o.pitch = +t1.pitch), null == t1.padding || o.isPaddingEqual(t1.padding) || (o.padding = t1.padding), t1.preloadOnly ? (this._preloadTiles(o), this) : (this.fire(new e1.Event("movestart", i)).fire(new e1.Event("move", i)), r && this.fire(new e1.Event("zoomstart", i)).fire(new e1.Event("zoom", i)).fire(new e1.Event("zoomend", i)), n && this.fire(new e1.Event("rotatestart", i)).fire(new e1.Event("rotate", i)).fire(new e1.Event("rotateend", i)), a && this.fire(new e1.Event("pitchstart", i)).fire(new e1.Event("pitch", i)).fire(new e1.Event("pitchend", i)), this.fire(new e1.Event("moveend", i)));
            }
            getFreeCameraOptions() {
                return this.transform.projection.supportsFreeCamera || e1.warnOnce(Hr), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(t1, i) {
                const o = this.transform;
                if (!o.projection.supportsFreeCamera) return e1.warnOnce(Hr), this;
                this.stop();
                const r = o.zoom, n = o.pitch, a = o.bearing;
                o.setFreeCameraOptions(t1);
                const s = r !== o.zoom, l = n !== o.pitch, c = a !== o.bearing;
                return this.fire(new e1.Event("movestart", i)).fire(new e1.Event("move", i)), s && this.fire(new e1.Event("zoomstart", i)).fire(new e1.Event("zoom", i)).fire(new e1.Event("zoomend", i)), c && this.fire(new e1.Event("rotatestart", i)).fire(new e1.Event("rotate", i)).fire(new e1.Event("rotateend", i)), l && this.fire(new e1.Event("pitchstart", i)).fire(new e1.Event("pitch", i)).fire(new e1.Event("pitchend", i)), this.fire(new e1.Event("moveend", i)), this;
            }
            easeTo(t1, i) {
                this._stop(!1, t1.easeId), (!1 === (t1 = e1.extend({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: e1.ease
                }, t1)).animate || !t1.essential && e1.exported.prefersReducedMotion) && (t1.duration = 0);
                const o = this.transform, r = this.getZoom(), n = this.getBearing(), a = this.getPitch(), s = this.getPadding(), l = "zoom" in t1 ? +t1.zoom : r, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, n) : n, h = "pitch" in t1 ? +t1.pitch : a, u = "padding" in t1 ? t1.padding : o.padding, _ = e1.pointGeometry.convert(t1.offset);
                let d, p, m;
                if ("globe" === o.projection.name) {
                    const i = e1.MercatorCoordinate.fromLngLat(o.center), r = _.rotate(-o.angle);
                    i.x += r.x / o.worldSize, i.y += r.y / o.worldSize;
                    const n = i.toLngLat(), a = e1.LngLat.convert(t1.center || n);
                    this._normalizeCenter(a), d = o.centerPoint.add(r), p = new e1.pointGeometry(i.x, i.y).mult(o.worldSize), m = new e1.pointGeometry(e1.mercatorXfromLng(a.lng), e1.mercatorYfromLat(a.lat)).mult(o.worldSize).sub(p);
                } else {
                    d = o.centerPoint.add(_);
                    const i = o.pointLocation(d), r = e1.LngLat.convert(t1.center || i);
                    this._normalizeCenter(r), p = o.project(i), m = o.project(r).sub(p);
                }
                const f = o.zoomScale(l - r);
                let g, v;
                t1.around && (g = e1.LngLat.convert(t1.around), v = o.locationPoint(g));
                const x = this._zooming || l !== r, y = this._rotating || n !== c, b = this._pitching || h !== a, w = !o.isPaddingEqual(u), T = (o)=>(T)=>{
                        if (x && (o.zoom = e1.number(r, l, T)), y && (o.bearing = e1.number(n, c, T)), b && (o.pitch = e1.number(a, h, T)), w && (o.interpolatePadding(s, u, T), d = o.centerPoint.add(_)), g) o.setLocationAtPoint(g, v);
                        else {
                            const e1 = o.zoomScale(o.zoom - r), t1 = l > r ? Math.min(2, f) : Math.max(.5, f), i = Math.pow(t1, 1 - T), n = o.unproject(p.add(m.mult(T * i)).mult(e1));
                            o.setLocationAtPoint(o.renderWorldCopies ? n.wrap() : n, d);
                        }
                        return t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e1 = this._emulate(T, t1.duration, o);
                    return this._preloadTiles(e1), this;
                }
                const E = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = x, this._rotating = y, this._pitching = b, this._padding = w, this._easeId = t1.easeId, this._prepareEase(i, t1.noMoveStart, E), this._ease(T(o), (e1)=>{
                    o.recenterOnTerrain(), this._afterEase(i, e1);
                }, t1), this;
            }
            _prepareEase(t1, i, o = {}) {
                this._moving = !0, this.transform.cameraElevationReference = "sea", i || o.moving || this.fire(new e1.Event("movestart", t1)), this._zooming && !o.zooming && this.fire(new e1.Event("zoomstart", t1)), this._rotating && !o.rotating && this.fire(new e1.Event("rotatestart", t1)), this._pitching && !o.pitching && this.fire(new e1.Event("pitchstart", t1));
            }
            _fireMoveEvents(t1) {
                this.fire(new e1.Event("move", t1)), this._zooming && this.fire(new e1.Event("zoom", t1)), this._rotating && this.fire(new e1.Event("rotate", t1)), this._pitching && this.fire(new e1.Event("pitch", t1));
            }
            _afterEase(t1, i) {
                if (this._easeId && i && this._easeId === i) return;
                this._easeId = void 0, this.transform.cameraElevationReference = "ground";
                const o = this._zooming, r = this._rotating, n = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, o && this.fire(new e1.Event("zoomend", t1)), r && this.fire(new e1.Event("rotateend", t1)), n && this.fire(new e1.Event("pitchend", t1)), this.fire(new e1.Event("moveend", t1));
            }
            flyTo(t1, i) {
                if (!t1.essential && e1.exported.prefersReducedMotion) {
                    const o = e1.pick(t1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around"
                    ]);
                    return this.jumpTo(o, i);
                }
                this.stop(), t1 = e1.extend({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: e1.ease
                }, t1);
                const o = this.transform, r = this.getZoom(), n = this.getBearing(), a = this.getPitch(), s = this.getPadding(), l = "zoom" in t1 ? e1.clamp(+t1.zoom, o.minZoom, o.maxZoom) : r, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, n) : n, h = "pitch" in t1 ? +t1.pitch : a, u = "padding" in t1 ? t1.padding : o.padding, _ = o.zoomScale(l - r), d = e1.pointGeometry.convert(t1.offset);
                let p = o.centerPoint.add(d);
                const m = o.pointLocation(p), f = e1.LngLat.convert(t1.center || m);
                this._normalizeCenter(f);
                const g = o.project(m), v = o.project(f).sub(g);
                let x = t1.curve;
                const y = Math.max(o.width, o.height), b = y / _, w = v.mag();
                if ("minZoom" in t1) {
                    const i = e1.clamp(Math.min(t1.minZoom, r, l), o.minZoom, o.maxZoom), n = y / o.zoomScale(i - r);
                    x = Math.sqrt(n / w * 2);
                }
                const T = x * x;
                function E(e1) {
                    const t1 = (b * b - y * y + (e1 ? -1 : 1) * T * T * w * w) / (2 * (e1 ? b : y) * T * w);
                    return Math.log(Math.sqrt(t1 * t1 + 1) - t1);
                }
                function C(e1) {
                    return (Math.exp(e1) - Math.exp(-e1)) / 2;
                }
                function I(e1) {
                    return (Math.exp(e1) + Math.exp(-e1)) / 2;
                }
                const M = E(0);
                let S = function(e1) {
                    return I(M) / I(M + x * e1);
                }, z = function(e1) {
                    var t1;
                    return y * ((I(M) * (C(t1 = M + x * e1) / I(t1)) - C(M)) / T) / w;
                }, D = (E(1) - M) / x;
                if (Math.abs(w) < 1e-6 || !isFinite(D)) {
                    if (Math.abs(y - b) < 1e-6) return this.easeTo(t1, i);
                    const e1 = b < y ? -1 : 1;
                    D = Math.abs(Math.log(b / y)) / x, z = function() {
                        return 0;
                    }, S = function(t1) {
                        return Math.exp(e1 * x * t1);
                    };
                }
                t1.duration = "duration" in t1 ? +t1.duration : 1e3 * D / ("screenSpeed" in t1 ? +t1.screenSpeed / x : +t1.speed), t1.maxDuration && t1.duration > t1.maxDuration && (t1.duration = 0);
                const P = n !== c, A = h !== a, L = !o.isPaddingEqual(u), R = (o)=>(_)=>{
                        const m = _ * D, x = 1 / S(m);
                        o.zoom = 1 === _ ? l : r + o.scaleZoom(x), P && (o.bearing = e1.number(n, c, _)), A && (o.pitch = e1.number(a, h, _)), L && (o.interpolatePadding(s, u, _), p = o.centerPoint.add(d));
                        const y = 1 === _ ? f : o.unproject(g.add(v.mult(z(m))).mult(x));
                        return o.setLocationAtPoint(o.renderWorldCopies ? y.wrap() : y, p), o._updateCameraOnTerrain(), t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e1 = this._emulate(R, t1.duration, o);
                    return this._preloadTiles(e1), this;
                }
                return this._zooming = !0, this._rotating = P, this._pitching = A, this._padding = L, this._prepareEase(i, !1), this._ease(R(o), ()=>this._afterEase(i), t1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(e1, t1) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                    const e1 = this._onEaseEnd;
                    this._onEaseEnd = void 0, e1.call(this, t1);
                }
                if (!e1) {
                    const e1 = this.handlers;
                    e1 && e1.stop(!1);
                }
                return this;
            }
            _ease(t1, i, o) {
                !1 === o.animate || 0 === o.duration ? (t1(1), i()) : (this._easeStart = e1.exported.now(), this._easeOptions = o, this._onEaseFrame = t1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const t1 = Math.min((e1.exported.now() - this._easeStart) / this._easeOptions.duration, 1), i = this._onEaseFrame;
                i && i(this._easeOptions.easing(t1)), t1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(t1, i) {
                t1 = e1.wrap(t1, -180, 180);
                const o = Math.abs(t1 - i);
                return Math.abs(t1 - 360 - i) < o && (t1 -= 360), Math.abs(t1 + 360 - i) < o && (t1 += 360), t1;
            }
            _normalizeCenter(e1) {
                const t1 = this.transform;
                if (!t1.renderWorldCopies || t1.maxBounds) return;
                const i = e1.lng - t1.center.lng;
                e1.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            _emulate(e1, t1, i) {
                const o = Math.ceil(15 * t1 / 1e3), r = [], n = e1(i.clone());
                for(let e1 = 0; e1 <= o; e1++){
                    const t1 = n(e1 / o);
                    r.push(t1.clone());
                }
                return r;
            }
            constructor(t1, i){
                super(), this._moving = !1, this._zooming = !1, this.transform = t1, this._bearingSnap = i.bearingSnap, e1.bindAll([
                    "_renderFrameCallback"
                ], this);
            }
        }
        class Kr {
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e1) {
                const t1 = this.options && this.options.compact;
                return this._map = e1, this._container = n("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = n("button", "mapboxgl-ctrl-attrib-button", this._container), n("span", "mapboxgl-ctrl-icon", this._compactButton).setAttribute("aria-hidden", "true"), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = n("div", "mapboxgl-ctrl-attrib-inner", this._container), this._innerContainer.setAttribute("role", "list"), t1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(e1, t1) {
                const i = this._map._getUIString(`AttributionControl.${t1}`);
                e1.setAttribute("aria-label", i), e1.removeAttribute("title"), e1.firstElementChild && e1.firstElementChild.setAttribute("title", i);
            }
            _toggleAttribution() {
                this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
                let t1 = this._editLink;
                t1 || (t1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                const i = [
                    {
                        key: "owner",
                        value: this.styleOwner
                    },
                    {
                        key: "id",
                        value: this.styleId
                    },
                    {
                        key: "access_token",
                        value: this._map._requestManager._customAccessToken || e1.config.ACCESS_TOKEN
                    }
                ];
                if (t1) {
                    const o = i.reduce((e1, t1, o)=>(t1.value && (e1 += `${t1.key}=${t1.value}${o < i.length - 1 ? "&" : ""}`), e1), "?");
                    t1.href = `${e1.config.FEEDBACK_URL}/${o}#${er(this._map, !0)}`, t1.rel = "noopener nofollow", this._setElementTitle(t1, "MapFeedback");
                }
            }
            _updateData(e1) {
                !e1 || "metadata" !== e1.sourceDataType && "visibility" !== e1.sourceDataType && "style" !== e1.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e1 = [];
                if (this._map.style.stylesheet) {
                    const e1 = this._map.style.stylesheet;
                    this.styleOwner = e1.owner, this.styleId = e1.id;
                }
                const t1 = this._map.style._sourceCaches;
                for(const i in t1){
                    const o = t1[i];
                    if (o.used) {
                        const t1 = o.getSource();
                        t1.attribution && e1.indexOf(t1.attribution) < 0 && e1.push(t1.attribution);
                    }
                }
                e1.sort((e1, t1)=>e1.length - t1.length), e1 = e1.filter((t1, i)=>{
                    for(let o = i + 1; o < e1.length; o++)if (e1[o].indexOf(t1) >= 0) return !1;
                    return !0;
                }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = [
                    ...this.options.customAttribution,
                    ...e1
                ] : e1.unshift(this.options.customAttribution));
                const i = e1.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e1.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
            constructor(t1 = {}){
                this.options = t1, e1.bindAll([
                    "_toggleAttribution",
                    "_updateEditLink",
                    "_updateData",
                    "_updateCompact"
                ], this);
            }
        }
        class Jr {
            onAdd(e1) {
                this._map = e1, this._container = n("div", "mapboxgl-ctrl");
                const t1 = n("a", "mapboxgl-ctrl-logo");
                return t1.target = "_blank", t1.rel = "noopener nofollow", t1.href = "https://www.mapbox.com/", t1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            _updateLogo(e1) {
                e1 && "metadata" !== e1.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
                if (!this._map.style) return !0;
                const e1 = this._map.style._sourceCaches;
                if (0 === Object.entries(e1).length) return !0;
                for(const t1 in e1){
                    const i = e1[t1].getSource();
                    if (i.hasOwnProperty("mapbox_logo") && !i.mapbox_logo) return !1;
                }
                return !0;
            }
            _updateCompact() {
                const e1 = this._container.children;
                if (e1.length) {
                    const t1 = e1[0];
                    this._map.getCanvasContainer().offsetWidth < 250 ? t1.classList.add("mapboxgl-compact") : t1.classList.remove("mapboxgl-compact");
                }
            }
            constructor(){
                e1.bindAll([
                    "_updateLogo",
                    "_updateCompact"
                ], this);
            }
        }
        class Qr {
            add(e1) {
                const t1 = ++this._id;
                return this._queue.push({
                    callback: e1,
                    id: t1,
                    cancelled: !1
                }), t1;
            }
            remove(e1) {
                const t1 = this._currentlyRunning, i = t1 ? this._queue.concat(t1) : this._queue;
                for (const t1 of i)if (t1.id === e1) return void (t1.cancelled = !0);
            }
            run(e1 = 0) {
                const t1 = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t1)if (!i.cancelled && (i.callback(e1), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
        }
        function en(t1, i, o) {
            if (t1 = new e1.LngLat(t1.lng, t1.lat), i) {
                const r = new e1.LngLat(t1.lng - 360, t1.lat), n = new e1.LngLat(t1.lng + 360, t1.lat), a = 360 * Math.ceil(Math.abs(t1.lng - o.center.lng) / 360), s = o.locationPoint(t1).distSqr(i), l = i.x < 0 || i.y < 0 || i.x > o.width || i.y > o.height;
                o.locationPoint(r).distSqr(i) < s && (l || Math.abs(r.lng - o.center.lng) < a) ? t1 = r : o.locationPoint(n).distSqr(i) < s && (l || Math.abs(n.lng - o.center.lng) < a) && (t1 = n);
            }
            for(; Math.abs(t1.lng - o.center.lng) > 180;){
                const e1 = o.locationPoint(t1);
                if (e1.x >= 0 && e1.y >= 0 && e1.x <= o.width && e1.y <= o.height) break;
                t1.lng > o.center.lng ? t1.lng -= 360 : t1.lng += 360;
            }
            return t1;
        }
        const tn = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        class on extends e1.Evented {
            addTo(e1) {
                return e1 === this._map || (this.remove(), this._map = e1, e1.getCanvasContainer().appendChild(this._element), e1.on("move", this._updateMoving), e1.on("moveend", this._update), e1.on("remove", this._clearFadeTimer), e1._addMarker(this), this.setDraggable(this._draggable), this._update(), e1.on("click", this._onMapClick)), this;
            }
            remove() {
                const e1 = this._map;
                return e1 && (e1.off("click", this._onMapClick), e1.off("move", this._updateMoving), e1.off("moveend", this._update), e1.off("mousedown", this._addDragHandler), e1.off("touchstart", this._addDragHandler), e1.off("mouseup", this._onUp), e1.off("touchend", this._onUp), e1.off("mousemove", this._onMove), e1.off("touchmove", this._onMove), e1.off("remove", this._clearFadeTimer), e1._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(t1) {
                return this._lngLat = e1.LngLat.convert(t1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(e1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e1) {
                    if (!("offset" in e1.options)) {
                        const t1 = 38.1, i = 13.5, o = Math.sqrt(Math.pow(i, 2) / 2);
                        e1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t1
                            ],
                            "bottom-left": [
                                o,
                                -1 * (t1 - i + o)
                            ],
                            "bottom-right": [
                                -o,
                                -1 * (t1 - i + o)
                            ],
                            left: [
                                i,
                                -1 * (t1 - i)
                            ],
                            right: [
                                -i,
                                -1 * (t1 - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e1, e1._marker = this, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
                }
                return this;
            }
            _onKeyPress(e1) {
                const t1 = e1.code, i = e1.charCode || e1.keyCode;
                "Space" !== t1 && "Enter" !== t1 && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(e1) {
                const t1 = e1.originalEvent.target, i = this._element;
                this._popup && (t1 === i || i.contains(t1)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e1 = this._popup;
                return e1 ? (e1.isOpen() ? (e1.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e1.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
                const e1 = this._map;
                if (!e1) return !1;
                const t1 = e1.unproject(this._pos), i = e1.getFreeCameraOptions();
                if (!i.position) return !1;
                const o = i.position.toLngLat();
                return o.distanceTo(t1) < .9 * o.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
                const t1 = this._map;
                if (!t1) return;
                const i = this._pos;
                if (!i || i.x < 0 || i.x > t1.transform.width || i.y < 0 || i.y > t1.transform.height) return void this._clearFadeTimer();
                const o = t1.unproject(i);
                let r;
                t1._showingGlobe() && e1.isLngLatBehindGlobe(t1.transform, this._lngLat) ? r = 0 : (r = 1 - t1._queryFogOpacity(o), t1.transform._terrainEnabled() && t1.getTerrain() && this._behindTerrain() && (r *= .2)), this._element.style.opacity = `${r}`, this._element.style.pointerEvents = r > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(r), this._fadeTimer = null;
            }
            _clearFadeTimer() {
                this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
                const e1 = this._pos;
                if (!e1 || !this._map) return;
                const t1 = this._offset.mult(this._scale);
                this._element.style.transform = `\n            translate(${e1.x}px,${e1.y}px)\n            ${tn[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t1.x}px,${t1.y}px)\n        `;
            }
            _calculateXYTransform() {
                const t1 = this._pos, i = this._map, o = this.getPitchAlignment();
                if (!i || !t1 || "map" !== o) return "";
                if (!i._showingGlobe()) {
                    const e1 = i.getPitch();
                    return e1 ? `rotateX(${e1}deg)` : "";
                }
                const r = e1.radToDeg(e1.globeTiltAtLngLat(i.transform, this._lngLat)), n = t1.sub(e1.globeCenterToScreenPoint(i.transform)), a = Math.abs(n.x) + Math.abs(n.y);
                if (0 === a) return "";
                const s = r / a;
                return `rotateX(${-n.y * s}deg) rotateY(${n.x * s}deg)`;
            }
            _calculateZTransform() {
                const t1 = this._pos, i = this._map;
                if (!i || !t1) return "";
                let o = 0;
                const r = this.getRotationAlignment();
                if ("map" === r) {
                    if (i._showingGlobe()) {
                        const t1 = i.project(new e1.LngLat(this._lngLat.lng, this._lngLat.lat + .001)), r = i.project(new e1.LngLat(this._lngLat.lng, this._lngLat.lat - .001)).sub(t1);
                        o = e1.radToDeg(Math.atan2(r.y, r.x)) - 90;
                    } else o = -i.getBearing();
                } else if ("horizon" === r) {
                    const r = e1.smoothstep(4, 6, i.getZoom()), n = e1.globeCenterToScreenPoint(i.transform);
                    n.y += r * i.transform.height;
                    const a = t1.sub(n), s = e1.radToDeg(Math.atan2(a.y, a.x));
                    o = (s > 90 ? s - 270 : s + 90) * (1 - r);
                }
                return o += this._rotation, o ? `rotateZ(${o}deg)` : "";
            }
            _update(t1) {
                e1.window.cancelAnimationFrame(this._updateFrameId);
                const i = this._map;
                i && (i.transform.renderWorldCopies && (this._lngLat = en(this._lngLat, this._pos, i.transform)), this._pos = i.project(this._lngLat), !0 === t1 ? this._updateFrameId = e1.window.requestAnimationFrame(()=>{
                    this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
                }) : this._pos = this._pos.round(), i._requestDomTask(()=>{
                    this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (i._showingGlobe() || i.getTerrain() || i.getFog()) && !this._fadeTimer && (this._fadeTimer = setTimeout(this._evaluateOpacity.bind(this), 60)));
                }));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(t1) {
                return this._offset = e1.pointGeometry.convert(t1), this._update(), this;
            }
            _onMove(t1) {
                const i = this._map;
                if (i) {
                    if (!this._isDragging) {
                        const e1 = this._clickTolerance || i._clickTolerance;
                        this._isDragging = t1.point.dist(this._pointerdownPos) >= e1;
                    }
                    this._isDragging && (this._pos = t1.point.sub(this._positionDelta), this._lngLat = i.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e1.Event("dragstart"))), this.fire(new e1.Event("drag")));
                }
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
                const t1 = this._map;
                t1 && (t1.off("mousemove", this._onMove), t1.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e1.Event("dragend")), this._state = "inactive";
            }
            _addDragHandler(e1) {
                const t1 = this._map;
                t1 && this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(this._pos), this._pointerdownPos = e1.point, this._state = "pending", t1.on("mousemove", this._onMove), t1.on("touchmove", this._onMove), t1.once("mouseup", this._onUp), t1.once("touchend", this._onUp));
            }
            setDraggable(e1) {
                this._draggable = !!e1;
                const t1 = this._map;
                return t1 && (e1 ? (t1.on("mousedown", this._addDragHandler), t1.on("touchstart", this._addDragHandler)) : (t1.off("mousedown", this._addDragHandler), t1.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e1) {
                return this._rotation = e1 || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e1) {
                return this._rotationAlignment = e1 || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e1) {
                return this._pitchAlignment = e1 || "auto", this._update(), this;
            }
            getPitchAlignment() {
                return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            constructor(t1, i){
                if (super(), (t1 instanceof e1.window.HTMLElement || i) && (t1 = e1.extend({
                    element: t1
                }, i)), e1.bindAll([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress",
                    "_clearFadeTimer"
                ], this), this._anchor = t1 && t1.anchor || "center", this._color = t1 && t1.color || "#3FB1CE", this._scale = t1 && t1.scale || 1, this._draggable = t1 && t1.draggable || !1, this._clickTolerance = t1 && t1.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = t1 && t1.rotation || 0, this._rotationAlignment = t1 && t1.rotationAlignment || "auto", this._pitchAlignment = t1 && t1.pitchAlignment && t1.pitchAlignment || "auto", this._updateMoving = ()=>this._update(!0), t1 && t1.element) this._element = t1.element, this._offset = e1.pointGeometry.convert(t1 && t1.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = n("div");
                    const i = 41, o = 27, r = a("svg", {
                        display: "block",
                        height: i * this._scale + "px",
                        width: o * this._scale + "px",
                        viewBox: `0 0 ${o} ${i}`
                    }, this._element), s = a("radialGradient", {
                        id: "shadowGradient"
                    }, a("defs", {}, r));
                    a("stop", {
                        offset: "10%",
                        "stop-opacity": .4
                    }, s), a("stop", {
                        offset: "100%",
                        "stop-opacity": .05
                    }, s), a("ellipse", {
                        cx: 13.5,
                        cy: 34.8,
                        rx: 10.5,
                        ry: 5.25,
                        fill: "url(#shadowGradient)"
                    }, r), a("path", {
                        fill: this._color,
                        d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
                    }, r), a("path", {
                        opacity: .25,
                        d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
                    }, r), a("circle", {
                        fill: "white",
                        cx: 13.5,
                        cy: 13.5,
                        r: 5.5
                    }, r), this._offset = e1.pointGeometry.convert(t1 && t1.offset || [
                        0,
                        -14
                    ]);
                }
                this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e1)=>{
                    e1.preventDefault();
                }), this._element.addEventListener("mousedown", (e1)=>{
                    e1.preventDefault();
                });
                const o = this._element.classList;
                for(const e1 in tn)o.remove(`mapboxgl-marker-anchor-${e1}`);
                o.add(`mapboxgl-marker-anchor-${this._anchor}`), this._popup = null;
            }
        }
        class rn {
            getValue(t1) {
                if (t1 <= this._startTime) return this._start;
                if (t1 >= this._endTime) return this._end;
                const i = e1.easeCubicInOut((t1 - this._startTime) / (this._endTime - this._startTime));
                return this._start * (1 - i) + this._end * i;
            }
            isEasing(e1) {
                return e1 >= this._startTime && e1 <= this._endTime;
            }
            jumpTo(e1) {
                this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e1, this._end = e1;
            }
            easeTo(e1, t1, i) {
                this._start = this.getValue(t1), this._end = e1, this._startTime = t1, this._endTime = t1 + i;
            }
            constructor(e1){
                this.jumpTo(e1);
            }
        }
        const nn = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox logo",
            "Map.Title": "Map",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
            "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map",
            "TouchPanBlocker.Message": "Use two fingers to move the map"
        }, an = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 85,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            optimizeForTerrain: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            minTileCacheSize: null,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            localFontFamily: null,
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            crossSourceCollisions: !0
        };
        function sn(e1) {
            e1.parentNode && e1.parentNode.removeChild(e1);
        }
        const ln = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class cn {
            down(e1, t1) {
                this.mouseRotate.mousedown(e1, t1), this.mousePitch && this.mousePitch.mousedown(e1, t1), h();
            }
            move(e1, t1) {
                const i = this.map, o = this.mouseRotate.mousemoveWindow(e1, t1), r = o && o.bearingDelta;
                if (r && i.setBearing(i.getBearing() + r), this.mousePitch) {
                    const o = this.mousePitch.mousemoveWindow(e1, t1), r = o && o.pitchDelta;
                    r && i.setPitch(i.getPitch() + r);
                }
            }
            off() {
                const e1 = this.element;
                e1.removeEventListener("mousedown", this.mousedown), e1.removeEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), e1.removeEventListener("touchmove", this.touchmove), e1.removeEventListener("touchend", this.touchend), e1.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                u(), e1.window.removeEventListener("mousemove", this.mousemove), e1.window.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(t1) {
                this.down(e1.extend({}, t1, {
                    ctrlKey: !0,
                    preventDefault: ()=>t1.preventDefault()
                }), p(this.element, t1)), e1.window.addEventListener("mousemove", this.mousemove), e1.window.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e1) {
                this.move(e1, p(this.element, e1));
            }
            mouseup(e1) {
                this.mouseRotate.mouseupWindow(e1), this.mousePitch && this.mousePitch.mouseupWindow(e1), this.offTemp();
            }
            touchstart(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = m(this.element, e1.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }, this._startPos));
            }
            touchmove(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._lastPos = m(this.element, e1.targetTouches)[0], this.move({
                    preventDefault: ()=>e1.preventDefault()
                }, this._lastPos));
            }
            touchend(e1) {
                0 === e1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
            constructor(t1, i, o = !1){
                this._clickTolerance = 10, this.element = i, this.mouseRotate = new wr({
                    clickTolerance: t1.dragRotate._mouseRotate._clickTolerance
                }), this.map = t1, o && (this.mousePitch = new Tr({
                    clickTolerance: t1.dragRotate._mousePitch._clickTolerance
                })), e1.bindAll([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), i.addEventListener("mousedown", this.mousedown), i.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener("touchmove", this.touchmove), i.addEventListener("touchend", this.touchend), i.addEventListener("touchcancel", this.reset);
            }
        }
        const hn = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0,
            showUserHeading: !1
        }, un = {
            maxWidth: 100,
            unit: "metric"
        };
        function _n(e1, t1, i) {
            const o = dn(t1), r = o / t1, n = {
                kilometer: "km",
                meter: "m",
                mile: "mi",
                foot: "ft",
                "nautical-mile": "nm"
            }[i];
            this._map._requestDomTask(()=>{
                this._container.style.width = e1 * r + "px", this._container.innerHTML = `${o}&nbsp;${n}`;
            });
        }
        function dn(e1) {
            const t1 = Math.pow(10, `${Math.floor(e1)}`.length - 1);
            let i = e1 / t1;
            return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e1) {
                const t1 = Math.pow(10, Math.ceil(-Math.log(e1) / Math.LN10));
                return Math.round(e1 * t1) / t1;
            }(i), t1 * i;
        }
        const pn = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, mn = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function fn(t1 = new e1.pointGeometry(0, 0), i = "bottom") {
            if ("number" == typeof t1) {
                const o = Math.round(Math.sqrt(.5 * Math.pow(t1, 2)));
                switch(i){
                    case "top":
                        return new e1.pointGeometry(0, t1);
                    case "top-left":
                        return new e1.pointGeometry(o, o);
                    case "top-right":
                        return new e1.pointGeometry(-o, o);
                    case "bottom":
                        return new e1.pointGeometry(0, -t1);
                    case "bottom-left":
                        return new e1.pointGeometry(o, -o);
                    case "bottom-right":
                        return new e1.pointGeometry(-o, -o);
                    case "left":
                        return new e1.pointGeometry(t1, 0);
                    case "right":
                        return new e1.pointGeometry(-t1, 0);
                }
                return new e1.pointGeometry(0, 0);
            }
            return t1 instanceof e1.pointGeometry || Array.isArray(t1) ? e1.pointGeometry.convert(t1) : e1.pointGeometry.convert(t1[i] || [
                0,
                0
            ]);
        }
        const gn = {
            version: e1.version,
            supported: i,
            setRTLTextPlugin: e1.setRTLTextPlugin,
            getRTLTextPluginStatus: e1.getRTLTextPluginStatus,
            Map: class extends Yr {
                _getMapId() {
                    return this._mapId;
                }
                addControl(t1, i) {
                    if (void 0 === i && (i = t1.getDefaultPosition ? t1.getDefaultPosition() : "top-right"), !t1 || !t1.onAdd) return this.fire(new e1.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const o = t1.onAdd(this);
                    this._controls.push(t1);
                    const r = this._controlPositions[i];
                    return -1 !== i.indexOf("bottom") ? r.insertBefore(o, r.firstChild) : r.appendChild(o), this;
                }
                removeControl(t1) {
                    if (!t1 || !t1.onRemove) return this.fire(new e1.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = this._controls.indexOf(t1);
                    return i > -1 && this._controls.splice(i, 1), t1.onRemove(this), this;
                }
                hasControl(e1) {
                    return this._controls.indexOf(e1) > -1;
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                resize(t1) {
                    if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
                    this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
                    const i = !this._moving;
                    return i && this.fire(new e1.Event("movestart", t1)).fire(new e1.Event("move", t1)), this.fire(new e1.Event("resize", t1)), i && this.fire(new e1.Event("moveend", t1)), this;
                }
                getBounds() {
                    return "globe" === this.transform.projection.name && e1.warnOnce('Globe projection does not support getBounds API, this API may behave unexpectedly."'), this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds() || null;
                }
                setMaxBounds(t1) {
                    return this.transform.setMaxBounds(e1.LngLatBounds.convert(t1)), this._update();
                }
                setMinZoom(t1) {
                    if ((t1 = null == t1 ? -2 : t1) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 ? this.setZoom(t1) : this.fire(new e1.Event("zoomstart")).fire(new e1.Event("zoom")).fire(new e1.Event("zoomend")), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(t1) {
                    if ((t1 = null == t1 ? 22 : t1) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 ? this.setZoom(t1) : this.fire(new e1.Event("zoomstart")).fire(new e1.Event("zoom")).fire(new e1.Event("zoomend")), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(t1) {
                    if ((t1 = null == t1 ? 0 : t1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 ? this.setPitch(t1) : this.fire(new e1.Event("pitchstart")).fire(new e1.Event("pitch")).fire(new e1.Event("pitchend")), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(t1) {
                    if ((t1 = null == t1 ? 85 : t1) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 ? this.setPitch(t1) : this.fire(new e1.Event("pitchstart")).fire(new e1.Event("pitch")).fire(new e1.Event("pitchend")), this;
                    throw new Error("maxPitch must be greater than or equal to minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(e1) {
                    return this.transform.renderWorldCopies = e1, this._update();
                }
                getLanguage() {
                    return this._language;
                }
                setLanguage(t1) {
                    if (this._language = "auto" === t1 ? e1.window.navigator.language : t1, this.style) for(const e1 in this.style._sourceCaches){
                        const t1 = this.style._sourceCaches[e1]._source;
                        t1._setLanguage && t1._setLanguage(this._language);
                    }
                    for (const e1 of this._controls)e1._setLanguage && e1._setLanguage(this._language);
                    return this;
                }
                getWorldview() {
                    return this._worldview;
                }
                setWorldview(e1) {
                    if (this._worldview = e1, this.style) for(const t1 in this.style._sourceCaches){
                        const i = this.style._sourceCaches[t1]._source;
                        i._setWorldview && i._setWorldview(e1);
                    }
                    return this;
                }
                getProjection() {
                    return this.transform.mercatorFromTransition ? {
                        name: "globe",
                        center: [
                            0,
                            0
                        ]
                    } : this.transform.getProjection();
                }
                _showingGlobe() {
                    return "globe" === this.transform.projection.name;
                }
                setProjection(e1) {
                    return this._lazyInitEmptyStyle(), e1 ? "string" == typeof e1 && (e1 = {
                        name: e1
                    }) : e1 = null, this._useExplicitProjection = !!e1, this._prioritizeAndUpdateProjection(e1, this.style.stylesheet ? this.style.stylesheet.projection : null);
                }
                _updateProjectionTransition() {
                    if ("globe" !== this.getProjection().name) return;
                    const t1 = this.transform, i = t1.projection.name;
                    let o;
                    "globe" === i && t1.zoom >= e1.GLOBE_ZOOM_THRESHOLD_MAX ? (t1.setMercatorFromTransition(), o = !0) : "mercator" === i && t1.zoom < e1.GLOBE_ZOOM_THRESHOLD_MAX && (t1.setProjection({
                        name: "globe"
                    }), o = !0), o && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate());
                }
                _prioritizeAndUpdateProjection(e1, t1) {
                    return this._updateProjection(e1 || t1 || {
                        name: "mercator"
                    });
                }
                _updateProjection(t1) {
                    let i;
                    if (i = "globe" === t1.name && this.transform.zoom >= e1.GLOBE_ZOOM_THRESHOLD_MAX ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t1), this.style.applyProjectionUpdate(), i) {
                        this.painter.clearBackgroundTiles();
                        for(const e1 in this.style._sourceCaches)this.style._sourceCaches[e1].clearTiles();
                        this._update(!0);
                    }
                    return this;
                }
                project(t1) {
                    return this.transform.locationPoint3D(e1.LngLat.convert(t1));
                }
                unproject(t1) {
                    return this.transform.pointLocation3D(e1.pointGeometry.convert(t1));
                }
                isMoving() {
                    return this._moving || this.handlers && this.handlers.isMoving() || !1;
                }
                isZooming() {
                    return this._zooming || this.handlers && this.handlers.isZooming() || !1;
                }
                isRotating() {
                    return this._rotating || this.handlers && this.handlers.isRotating() || !1;
                }
                _createDelegatedListener(e1, t1, i) {
                    if ("mouseenter" === e1 || "mouseover" === e1) {
                        let o = !1;
                        const r = (r)=>{
                            const n = t1.filter((e1)=>this.getLayer(e1)), a = n.length ? this.queryRenderedFeatures(r.point, {
                                layers: n
                            }) : [];
                            a.length ? o || (o = !0, i.call(this, new cr(e1, this, r.originalEvent, {
                                features: a
                            }))) : o = !1;
                        }, n = ()=>{
                            o = !1;
                        };
                        return {
                            layers: new Set(t1),
                            listener: i,
                            delegates: {
                                mousemove: r,
                                mouseout: n
                            }
                        };
                    }
                    if ("mouseleave" === e1 || "mouseout" === e1) {
                        let o = !1;
                        const r = (r)=>{
                            const n = t1.filter((e1)=>this.getLayer(e1));
                            (n.length ? this.queryRenderedFeatures(r.point, {
                                layers: n
                            }) : []).length ? o = !0 : o && (o = !1, i.call(this, new cr(e1, this, r.originalEvent)));
                        }, n = (t1)=>{
                            o && (o = !1, i.call(this, new cr(e1, this, t1.originalEvent)));
                        };
                        return {
                            layers: new Set(t1),
                            listener: i,
                            delegates: {
                                mousemove: r,
                                mouseout: n
                            }
                        };
                    }
                    {
                        const o = (e1)=>{
                            const o = t1.filter((e1)=>this.getLayer(e1)), r = o.length ? this.queryRenderedFeatures(e1.point, {
                                layers: o
                            }) : [];
                            r.length && (e1.features = r, i.call(this, e1), delete e1.features);
                        };
                        return {
                            layers: new Set(t1),
                            listener: i,
                            delegates: {
                                [e1]: o
                            }
                        };
                    }
                }
                on(e1, t1, i) {
                    if (void 0 === i) return super.on(e1, t1);
                    Array.isArray(t1) || (t1 = [
                        t1
                    ]);
                    const o = this._createDelegatedListener(e1, t1, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e1] = this._delegatedListeners[e1] || [], this._delegatedListeners[e1].push(o);
                    for(const e1 in o.delegates)this.on(e1, o.delegates[e1]);
                    return this;
                }
                once(e1, t1, i) {
                    if (void 0 === i) return super.once(e1, t1);
                    Array.isArray(t1) || (t1 = [
                        t1
                    ]);
                    const o = this._createDelegatedListener(e1, t1, i);
                    for(const e1 in o.delegates)this.once(e1, o.delegates[e1]);
                    return this;
                }
                off(e1, t1, i) {
                    if (void 0 === i) return super.off(e1, t1);
                    t1 = new Set(Array.isArray(t1) ? t1 : [
                        t1
                    ]);
                    const o = (e1, t1)=>{
                        if (e1.size !== t1.size) return !1;
                        for (const i of e1)if (!t1.has(i)) return !1;
                        return !0;
                    }, r = this._delegatedListeners ? this._delegatedListeners[e1] : void 0;
                    return r && ((e1)=>{
                        for(let r = 0; r < e1.length; r++){
                            const n = e1[r];
                            if (n.listener === i && o(n.layers, t1)) {
                                for(const e1 in n.delegates)this.off(e1, n.delegates[e1]);
                                return e1.splice(r, 1), this;
                            }
                        }
                    })(r), this;
                }
                queryRenderedFeatures(t1, i) {
                    return this.style ? (void 0 !== i || void 0 === t1 || t1 instanceof e1.pointGeometry || Array.isArray(t1) || (i = t1, t1 = void 0), this.style.queryRenderedFeatures(t1 = t1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ], i = i || {}, this.transform)) : [];
                }
                querySourceFeatures(e1, t1) {
                    return this.style.querySourceFeatures(e1, t1);
                }
                queryTerrainElevation(t1, i) {
                    const o = this.transform.elevation;
                    return o ? (i = e1.extend({}, {
                        exaggerated: !0
                    }, i), o.getAtPoint(e1.MercatorCoordinate.fromLngLat(t1), null, i.exaggerated)) : null;
                }
                setStyle(t1, i) {
                    return !1 !== (i = e1.extend({}, {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        localFontFamily: this._localFontFamily
                    }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && i.localFontFamily === this._localFontFamily && this.style && t1 ? (this._diffStyle(t1, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._localFontFamily = i.localFontFamily, this._updateStyle(t1, i));
                }
                _getUIString(e1) {
                    const t1 = this._locale[e1];
                    if (null == t1) throw new Error(`Missing UI string '${e1}'`);
                    return t1;
                }
                _updateStyle(e1, t1) {
                    return this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), e1 && (this.style = new ei(this, t1 || {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), "string" == typeof e1 ? this.style.loadURL(e1) : this.style.loadJSON(e1)), this._updateTerrain(), this;
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new ei(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                _diffStyle(t1, i) {
                    if ("string" == typeof t1) {
                        const o = this._requestManager.normalizeStyleURL(t1), r = this._requestManager.transformRequest(o, e1.ResourceType.Style);
                        e1.getJSON(r, (t1, o)=>{
                            t1 ? this.fire(new e1.ErrorEvent(t1)) : o && this._updateDiff(o, i);
                        });
                    } else "object" == typeof t1 && this._updateDiff(t1, i);
                }
                _updateDiff(t1, i) {
                    try {
                        this.style.setState(t1) && this._update(!0);
                    } catch (o) {
                        e1.warnOnce(`Unable to perform style diff: ${o.message || o.error || o}.  Rebuilding the style from scratch.`), this._updateStyle(t1, i);
                    }
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : (e1.warnOnce("There is no style added to the map."), !1);
                }
                addSource(e1, t1) {
                    return this._lazyInitEmptyStyle(), this.style.addSource(e1, t1), this._update(!0);
                }
                isSourceLoaded(e1) {
                    return !!this.style && this.style._isSourceCacheLoaded(e1);
                }
                areTilesLoaded() {
                    const e1 = this.style && this.style._sourceCaches;
                    for(const t1 in e1){
                        const i = e1[t1]._tiles;
                        for(const e1 in i){
                            const t1 = i[e1];
                            if ("loaded" !== t1.state && "errored" !== t1.state) return !1;
                        }
                    }
                    return !0;
                }
                addSourceType(e1, t1, i) {
                    this._lazyInitEmptyStyle(), this.style.addSourceType(e1, t1, i);
                }
                removeSource(e1) {
                    return this.style.removeSource(e1), this._updateTerrain(), this._update(!0);
                }
                getSource(e1) {
                    return this.style.getSource(e1);
                }
                addImage(t1, i, { pixelRatio: o = 1, sdf: r = !1, stretchX: n, stretchY: a, content: s } = {}) {
                    if (this._lazyInitEmptyStyle(), i instanceof e1.window.HTMLImageElement || e1.window.ImageBitmap && i instanceof e1.window.ImageBitmap) {
                        const { width: l, height: c, data: h } = e1.exported.getImageData(i);
                        this.style.addImage(t1, {
                            data: new e1.RGBAImage({
                                width: l,
                                height: c
                            }, h),
                            pixelRatio: o,
                            stretchX: n,
                            stretchY: a,
                            content: s,
                            sdf: r,
                            version: 0
                        });
                    } else if (void 0 === i.width || void 0 === i.height) this.fire(new e1.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    else {
                        const { width: l, height: c } = i, h = i;
                        this.style.addImage(t1, {
                            data: new e1.RGBAImage({
                                width: l,
                                height: c
                            }, new Uint8Array(h.data)),
                            pixelRatio: o,
                            stretchX: n,
                            stretchY: a,
                            content: s,
                            sdf: r,
                            version: 0,
                            userImage: h
                        }), h.onAdd && h.onAdd(this, t1);
                    }
                }
                updateImage(t1, i) {
                    const o = this.style.getImage(t1);
                    if (!o) return void this.fire(new e1.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const r = i instanceof e1.window.HTMLImageElement || e1.window.ImageBitmap && i instanceof e1.window.ImageBitmap ? e1.exported.getImageData(i) : i, { width: n, height: a } = r;
                    void 0 !== n && void 0 !== a ? n === o.data.width && a === o.data.height ? (o.data.replace(r.data, !(i instanceof e1.window.HTMLImageElement || e1.window.ImageBitmap && i instanceof e1.window.ImageBitmap)), this.style.updateImage(t1, o)) : this.fire(new e1.ErrorEvent(new Error(`The width and height of the updated image (${n}, ${a})\n                must be that same as the previous version of the image\n                (${o.data.width}, ${o.data.height})`))) : this.fire(new e1.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                }
                hasImage(t1) {
                    return t1 ? !!this.style.getImage(t1) : (this.fire(new e1.ErrorEvent(new Error("Missing required image id"))), !1);
                }
                removeImage(e1) {
                    this.style.removeImage(e1);
                }
                loadImage(t1, i) {
                    e1.getImage(this._requestManager.transformRequest(t1, e1.ResourceType.Image), (t1, o)=>{
                        i(t1, o instanceof e1.window.HTMLImageElement ? e1.exported.getImageData(o) : o);
                    });
                }
                listImages() {
                    return this.style.listImages();
                }
                addLayer(e1, t1) {
                    return this._lazyInitEmptyStyle(), this.style.addLayer(e1, t1), this._update(!0);
                }
                moveLayer(e1, t1) {
                    return this.style.moveLayer(e1, t1), this._update(!0);
                }
                removeLayer(e1) {
                    return this.style.removeLayer(e1), this._update(!0);
                }
                getLayer(e1) {
                    return this.style.getLayer(e1);
                }
                setLayerZoomRange(e1, t1, i) {
                    return this.style.setLayerZoomRange(e1, t1, i), this._update(!0);
                }
                setFilter(e1, t1, i = {}) {
                    return this.style.setFilter(e1, t1, i), this._update(!0);
                }
                getFilter(e1) {
                    return this.style.getFilter(e1);
                }
                setPaintProperty(e1, t1, i, o = {}) {
                    return this.style.setPaintProperty(e1, t1, i, o), this._update(!0);
                }
                getPaintProperty(e1, t1) {
                    return this.style.getPaintProperty(e1, t1);
                }
                setLayoutProperty(e1, t1, i, o = {}) {
                    return this.style.setLayoutProperty(e1, t1, i, o), this._update(!0);
                }
                getLayoutProperty(e1, t1) {
                    return this.style.getLayoutProperty(e1, t1);
                }
                setLight(e1, t1 = {}) {
                    return this._lazyInitEmptyStyle(), this.style.setLight(e1, t1), this._update(!0);
                }
                getLight() {
                    return this.style.getLight();
                }
                setTerrain(e1) {
                    return this._lazyInitEmptyStyle(), !e1 && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e1), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
                }
                getTerrain() {
                    return this.style ? this.style.getTerrain() : null;
                }
                setFog(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setFog(e1), this._update(!0);
                }
                getFog() {
                    return this.style ? this.style.getFog() : null;
                }
                _queryFogOpacity(t1) {
                    return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e1.LngLat.convert(t1), this.transform) : 0;
                }
                setFeatureState(e1, t1) {
                    return this.style.setFeatureState(e1, t1), this._update();
                }
                removeFeatureState(e1, t1) {
                    return this.style.removeFeatureState(e1, t1), this._update();
                }
                getFeatureState(e1) {
                    return this.style.getFeatureState(e1);
                }
                _updateContainerDimensions() {
                    if (!this._container) return;
                    const t1 = this._container.getBoundingClientRect().width || 400, i = this._container.getBoundingClientRect().height || 300;
                    let o, r, n, a = this._container;
                    for(; a && (!r || !n);){
                        const t1 = e1.window.getComputedStyle(a).transform;
                        t1 && "none" !== t1 && (o = t1.match(/matrix.*\((.+)\)/)[1].split(", "), o[0] && "0" !== o[0] && "1" !== o[0] && (r = o[0]), o[3] && "0" !== o[3] && "1" !== o[3] && (n = o[3])), a = a.parentElement;
                    }
                    this._containerWidth = r ? Math.abs(t1 / r) : t1, this._containerHeight = n ? Math.abs(i / n) : i;
                }
                _detectMissingCSS() {
                    "rgb(250, 128, 114)" !== e1.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e1.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                }
                _setupContainer() {
                    const e1 = this._container;
                    e1.classList.add("mapboxgl-map"), (this._missingCSSCanary = n("div", "mapboxgl-canary", e1)).style.visibility = "hidden", this._detectMissingCSS();
                    const t1 = this._canvasContainer = n("div", "mapboxgl-canvas-container", e1);
                    this._interactive && t1.classList.add("mapboxgl-interactive"), this._canvas = n("canvas", "mapboxgl-canvas", t1), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
                    const i = this._controlContainer = n("div", "mapboxgl-control-container", e1), o = this._controlPositions = {};
                    [
                        "top-left",
                        "top-right",
                        "bottom-left",
                        "bottom-right"
                    ].forEach((e1)=>{
                        o[e1] = n("div", `mapboxgl-ctrl-${e1}`, i);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _resizeCanvas(t1, i) {
                    const o = e1.exported.devicePixelRatio || 1;
                    this._canvas.width = o * Math.ceil(t1), this._canvas.height = o * Math.ceil(i), this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${i}px`;
                }
                _addMarker(e1) {
                    this._markers.push(e1);
                }
                _removeMarker(e1) {
                    const t1 = this._markers.indexOf(e1);
                    -1 !== t1 && this._markers.splice(t1, 1);
                }
                _setupPainter() {
                    const t1 = e1.extend({}, i.webGLContextAttributes, {
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }), o = this._canvas.getContext("webgl", t1) || this._canvas.getContext("experimental-webgl", t1);
                    o ? (e1.storeAuthState(o, !0), this.painter = new Fo(o, this.transform), this.on("data", (e1)=>{
                        "source" === e1.dataType && this.painter.setTileLoadedFlag(!0);
                    }), e1.exported$1.testSupport(o)) : this.fire(new e1.ErrorEvent(new Error("Failed to initialize WebGL")));
                }
                _contextLost(t1) {
                    t1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e1.Event("webglcontextlost", {
                        originalEvent: t1
                    }));
                }
                _contextRestored(t1) {
                    this._setupPainter(), this.resize(), this._update(), this.fire(new e1.Event("webglcontextrestored", {
                        originalEvent: t1
                    }));
                }
                _onMapScroll(e1) {
                    if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                _update(e1) {
                    return this.style ? (this._styleDirty = this._styleDirty || e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(e1) {
                    return this._update(), this._renderTaskQueue.add(e1);
                }
                _cancelRenderFrame(e1) {
                    this._renderTaskQueue.remove(e1);
                }
                _requestDomTask(e1) {
                    !this.loaded() || this.loaded() && !this.isMoving() ? e1() : this._domRenderTaskQueue.add(e1);
                }
                _render(t1) {
                    let i;
                    const o = this.painter.context.extTimerQuery, r = e1.exported.now();
                    if (this.listens("gpu-timing-frame") && (i = o.createQueryEXT(), o.beginQueryEXT(o.TIME_ELAPSED_EXT, i)), this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(t1), this._domRenderTaskQueue.run(t1), this._removed) return;
                    this._updateProjectionTransition();
                    let n = !1;
                    const a = this._isInitialLoad ? 0 : this._fadeDuration;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const t1 = this.transform.zoom, i = this.transform.pitch, o = e1.exported.now();
                        this.style.zoomHistory.update(t1, o);
                        const r = new e1.EvaluationParameters(t1, {
                            now: o,
                            fadeDuration: a,
                            pitch: i,
                            zoomHistory: this.style.zoomHistory,
                            transition: this.style.getTransition()
                        }), s = r.crossFadingFactor();
                        1 === s && s === this._crossFadingFactor || (n = !0, this._crossFadingFactor = s), this.style.update(r);
                    }
                    this.style && this.style.fog && this.style.fog.hasTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
                    let s = !1;
                    if (this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), s = this._updateAverageElevation(r), this.style._updateSources(this.transform), this._forceMarkerUpdate()) : s = this._updateAverageElevation(r), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, a, this._crossSourceCollisions), this.style && this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showTerrainWireframe: this.showTerrainWireframe,
                        showOverdrawInspector: this._showOverdrawInspector,
                        showQueryGeometry: !!this._showQueryGeometry,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: a,
                        isInitialLoad: this._isInitialLoad,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer"),
                        gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                        speedIndexTiming: this.speedIndexTiming
                    }), this.fire(new e1.Event("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new e1.Event("load"))), this.style && (this.style.hasTransitions() || n) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), i) {
                        const t1 = e1.exported.now() - r;
                        o.endQueryEXT(o.TIME_ELAPSED_EXT, i), setTimeout(()=>{
                            const n = o.getQueryObjectEXT(i, o.QUERY_RESULT_EXT) / 1e6;
                            o.deleteQueryEXT(i), this.fire(new e1.Event("gpu-timing-frame", {
                                cpuTime: t1,
                                gpuTime: n
                            })), e1.window.performance.mark("frame-gpu", {
                                startTime: r,
                                detail: {
                                    gpuTime: n
                                }
                            });
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const t1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimers(t1);
                            this.fire(new e1.Event("gpu-timing-layer", {
                                layerTimes: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-deferred-render")) {
                        const t1 = this.painter.collectDeferredRenderGpuQueries();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimeDeferredRender(t1);
                            this.fire(new e1.Event("gpu-timing-deferred-render", {
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    const l = this._sourcesDirty || this._styleDirty || this._placementDirty || s;
                    if (l || this._repaint) this.triggerRepaint();
                    else {
                        const t1 = !this.isMoving() && this.loaded();
                        if (t1 && (s = this._updateAverageElevation(r, !0)), s) this.triggerRepaint();
                        else if (this._triggerFrame(!1), t1 && (this.fire(new e1.Event("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                            const t1 = this._calculateSpeedIndex();
                            this.fire(new e1.Event("speedindexcompleted", {
                                speedIndex: t1
                            })), this.speedIndexTiming = !1;
                        }
                    }
                    !this._loaded || this._fullyLoaded || l || (this._fullyLoaded = !0, this._authenticate());
                }
                _forceMarkerUpdate() {
                    for (const e1 of this._markers)e1._update();
                }
                _updateAverageElevation(e1, t1 = !1) {
                    const i = (e1)=>(this.transform.averageElevation = e1, this._update(!1), !0);
                    if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
                    if ((t1 || e1 - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e1)) {
                        const t1 = this.transform.averageElevation;
                        let o = this.transform.sampleAverageElevation(), r = !1;
                        this.transform.elevation && (r = this.transform.elevation.exaggeration() !== this._averageElevationExaggeration, this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(o) ? o = 0 : this._averageElevationLastSampledAt = e1;
                        const n = Math.abs(t1 - o);
                        if (n > 1) {
                            if (this._isInitialLoad || r) return this._averageElevation.jumpTo(o), i(o);
                            this._averageElevation.easeTo(o, e1, 300);
                        } else if (n > 1e-4) return this._averageElevation.jumpTo(o), i(o);
                    }
                    return !!this._averageElevation.isEasing(e1) && i(this._averageElevation.getValue(e1));
                }
                _authenticate() {
                    e1.getMapSessionAPI(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t1)=>{
                        if (t1 && (t1.message === e1.AUTH_ERR_MSG || 401 === t1.status)) {
                            const t1 = this.painter.context.gl;
                            e1.storeAuthState(t1, !1), this._logoControl instanceof Jr && this._logoControl._updateLogo(), t1 && t1.clear(t1.DEPTH_BUFFER_BIT | t1.COLOR_BUFFER_BIT | t1.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e1.ErrorEvent(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                        }
                    }), e1.postMapLoadEvent(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, ()=>{});
                }
                _updateTerrain() {
                    this.painter.updateTerrain(this.style, this.isMoving() || this.isRotating() || this.isZooming());
                }
                _calculateSpeedIndex() {
                    const e1 = this.painter.canvasCopy(), t1 = this.painter.getCanvasCopiesAndTimestamps();
                    t1.timeStamps.push(performance.now());
                    const i = this.painter.context.gl, o = i.createFramebuffer();
                    function r(e1) {
                        i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e1, 0);
                        const t1 = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                        return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t1), t1;
                    }
                    return i.bindFramebuffer(i.FRAMEBUFFER, o), this._canvasPixelComparison(r(e1), t1.canvasCopies.map(r), t1.timeStamps);
                }
                _canvasPixelComparison(e1, t1, i) {
                    let o = i[1] - i[0];
                    const r = e1.length / 4;
                    for(let n = 0; n < t1.length; n++){
                        const a = t1[n];
                        let s = 0;
                        for(let t1 = 0; t1 < a.length; t1 += 4)a[t1] === e1[t1] && a[t1 + 1] === e1[t1 + 1] && a[t1 + 2] === e1[t1 + 2] && a[t1 + 3] === e1[t1 + 3] && (s += 1);
                        o += (i[n + 2] - i[n + 1]) * (1 - s / r);
                    }
                    return o;
                }
                remove() {
                    this._hash && this._hash.remove();
                    for (const e1 of this._controls)e1.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), void 0 !== e1.window && (e1.window.removeEventListener("resize", this._onWindowResize, !1), e1.window.removeEventListener("orientationchange", this._onWindowResize, !1), e1.window.removeEventListener("webkitfullscreenchange", this._onWindowResize, !1), e1.window.removeEventListener("online", this._onWindowOnline, !1));
                    const t1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    t1 && t1.loseContext(), sn(this._canvasContainer), sn(this._controlContainer), sn(this._missingCSSCanary), this._container.classList.remove("mapboxgl-map"), e1.removeAuthState(this.painter.context.gl), this._removed = !0, this.fire(new e1.Event("remove"));
                }
                triggerRepaint() {
                    this._triggerFrame(!0);
                }
                _triggerFrame(t1) {
                    this._renderNextFrame = this._renderNextFrame || t1, this.style && !this._frame && (this._frame = e1.exported.frame((e1)=>{
                        const t1 = !!this._renderNextFrame;
                        this._frame = null, this._renderNextFrame = null, t1 && this._render(e1);
                    }));
                }
                _preloadTiles(t1) {
                    const i = this.style ? Object.values(this.style._sourceCaches) : [];
                    return e1.asyncAll(i, (e1, i)=>e1._preloadTiles(t1, i), ()=>{
                        this.triggerRepaint();
                    }), this;
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(e1) {
                    this._trackResize && this.resize({
                        originalEvent: e1
                    })._update();
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(e1) {
                    this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
                }
                get showTerrainWireframe() {
                    return !!this._showTerrainWireframe;
                }
                set showTerrainWireframe(e1) {
                    this._showTerrainWireframe !== e1 && (this._showTerrainWireframe = e1, this._update());
                }
                get speedIndexTiming() {
                    return !!this._speedIndexTiming;
                }
                set speedIndexTiming(e1) {
                    this._speedIndexTiming !== e1 && (this._speedIndexTiming = e1, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(e1) {
                    this._showPadding !== e1 && (this._showPadding = e1, this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(e1) {
                    this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 ? this.style._generateCollisionBoxes() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(e1) {
                    this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(e1) {
                    this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(e1) {
                    this._vertices = e1, this._update();
                }
                _setCacheLimits(t1, i) {
                    e1.setCacheLimits(t1, i);
                }
                get version() {
                    return e1.version;
                }
                constructor(t1){
                    if (null != (t1 = e1.extend({}, an, t1)).minZoom && null != t1.maxZoom && t1.minZoom > t1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != t1.minPitch && null != t1.maxPitch && t1.minPitch > t1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != t1.minPitch && t1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != t1.maxPitch && t1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1.antialias && e1.isSafariWithAntialiasingBug(e1.window) && (t1.antialias = !1, e1.warnOnce("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new Ko(t1.minZoom, t1.maxZoom, t1.minPitch, t1.maxPitch, t1.renderWorldCopies), t1), this._interactive = t1.interactive, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t1.preserveDrawingBuffer, this._antialias = t1.antialias, this._trackResize = t1.trackResize, this._bearingSnap = t1.bearingSnap, this._refreshExpiredTiles = t1.refreshExpiredTiles, this._fadeDuration = t1.fadeDuration, this._isInitialLoad = !0, this._crossSourceCollisions = t1.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = t1.collectResourceTiming, this._optimizeForTerrain = t1.optimizeForTerrain, this._language = "auto" === t1.language ? e1.window.navigator.language : t1.language, this._worldview = t1.worldview, this._renderTaskQueue = new Qr, this._domRenderTaskQueue = new Qr, this._controls = [], this._markers = [], this._mapId = e1.uniqueId(), this._locale = e1.extend({}, nn, t1.locale), this._clickTolerance = t1.clickTolerance, this._cooperativeGestures = t1.cooperativeGestures, this._containerWidth = 0, this._containerHeight = 0, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new rn(0), this._useExplicitProjection = !1, this._requestManager = new e1.RequestManager(t1.transformRequest, t1.accessToken, t1.testMode), this._silenceAuthErrors = !!t1.testMode, "string" == typeof t1.container) {
                        if (this._container = e1.window.document.getElementById(t1.container), !this._container) throw new Error(`Container '${t1.container}' not found.`);
                    } else {
                        if (!(t1.container instanceof e1.window.HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = t1.container;
                    }
                    if (this._container.childNodes.length > 0 && e1.warnOnce("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t1.maxBounds && this.setMaxBounds(t1.maxBounds), e1.bindAll([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), void 0 !== e1.window && (e1.window.addEventListener("online", this._onWindowOnline, !1), e1.window.addEventListener("resize", this._onWindowResize, !1), e1.window.addEventListener("orientationchange", this._onWindowResize, !1), e1.window.addEventListener("webkitfullscreenchange", this._onWindowResize, !1)), this.handlers = new $r(this, t1), this._localFontFamily = t1.localFontFamily, this._localIdeographFontFamily = t1.localIdeographFontFamily, t1.style && this.setStyle(t1.style, {
                        localFontFamily: this._localFontFamily,
                        localIdeographFontFamily: this._localIdeographFontFamily
                    }), t1.projection && this.setProjection(t1.projection), this._hash = t1.hash && new Qo("string" == typeof t1.hash && t1.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                        center: t1.center,
                        zoom: t1.zoom,
                        bearing: t1.bearing,
                        pitch: t1.pitch
                    }), t1.bounds && (this.resize(), this.fitBounds(t1.bounds, e1.extend({}, t1.fitBoundsOptions, {
                        duration: 0
                    })))), this.resize(), t1.attributionControl && this.addControl(new Kr({
                        customAttribution: t1.customAttribution
                    })), this._logoControl = new Jr, this.addControl(this._logoControl, t1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet);
                    }), this.on("data", (t1)=>{
                        this._update("style" === t1.dataType), this.fire(new e1.Event(`${t1.dataType}data`, t1));
                    }), this.on("dataloading", (t1)=>{
                        this.fire(new e1.Event(`${t1.dataType}dataloading`, t1));
                    });
                }
            },
            NavigationControl: class {
                _updateZoomButtons() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t1 = e1.getZoom(), i = t1 === e1.getMaxZoom(), o = t1 === e1.getMinZoom();
                    this._zoomInButton.disabled = i, this._zoomOutButton.disabled = o, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", o.toString());
                }
                _rotateCompassArrow() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e1.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${e1.transform.pitch}deg) rotateZ(${e1.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e1.transform.angle * (180 / Math.PI)}deg)`;
                    e1._requestDomTask(()=>{
                        this._compassIcon && (this._compassIcon.style.transform = t1);
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e1.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e1.on("pitch", this._rotateCompassArrow), e1.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new cn(e1, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    const e1 = this._map;
                    e1 && (this._container.remove(), this.options.showZoom && e1.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e1.off("pitch", this._rotateCompassArrow), e1.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
                }
                _createButton(e1, t1) {
                    const i = n("button", e1, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e1, t1) {
                    if (!this._map) return;
                    const i = this._map._getUIString(`NavigationControl.${t1}`);
                    e1.setAttribute("aria-label", i), e1.firstElementChild && e1.firstElementChild.setAttribute("title", i);
                }
                constructor(t1){
                    this.options = e1.extend({}, ln, t1), this._container = n("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.options.showZoom && (e1.bindAll([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e1)=>{
                        this._map && this._map.zoomIn({}, {
                            originalEvent: e1
                        });
                    }), n("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e1)=>{
                        this._map && this._map.zoomOut({}, {
                            originalEvent: e1
                        });
                    }), n("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e1.bindAll([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e1)=>{
                        const t1 = this._map;
                        t1 && (this.options.visualizePitch ? t1.resetNorthPitch({}, {
                            originalEvent: e1
                        }) : t1.resetNorth({}, {
                            originalEvent: e1
                        }));
                    }), this._compassIcon = n("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
            },
            GeolocateControl: class extends e1.Evented {
                onAdd(e1) {
                    return this._map = e1, this._container = n("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
                }
                onRemove() {
                    void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
                }
                _checkGeolocationSupport(t1) {
                    void 0 !== this._supportsGeolocation ? t1(this._supportsGeolocation) : void 0 !== e1.window.navigator.permissions ? e1.window.navigator.permissions.query({
                        name: "geolocation"
                    }).then((e1)=>{
                        this._supportsGeolocation = "denied" !== e1.state, t1(this._supportsGeolocation);
                    }) : (this._supportsGeolocation = !!this.options.geolocation, t1(this._supportsGeolocation));
                }
                _isOutOfMapMaxBounds(e1) {
                    const t1 = this._map.getMaxBounds(), i = e1.coords;
                    return !!t1 && (i.longitude < t1.getWest() || i.longitude > t1.getEast() || i.latitude < t1.getSouth() || i.latitude > t1.getNorth());
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "ACTIVE_LOCK":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                            break;
                        case "BACKGROUND":
                            this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                    }
                }
                _onSuccess(t1) {
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(t1)) return this._setErrorState(), this.fire(new e1.Event("outofmaxbounds", t1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = t1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t1), this.options.showUserLocation && this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"), this.fire(new e1.Event("geolocate", t1)), this._finish();
                    }
                }
                _updateCamera(t1) {
                    const i = new e1.LngLat(t1.coords.longitude, t1.coords.latitude), o = t1.coords.accuracy, r = this._map.getBearing(), n = e1.extend({
                        bearing: r
                    }, this.options.fitBoundsOptions);
                    this._map.fitBounds(i.toBounds(o), n, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(t1) {
                    if (t1) {
                        const i = new e1.LngLat(t1.coords.longitude, t1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = t1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const t1 = this._map.transform, i = e1.mercatorZfromAltitude(1, t1._center.lat) * t1.worldSize, o = Math.ceil(2 * this._accuracy * i);
                    this._circleElement.style.width = `${o}px`, this._circleElement.style.height = `${o}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _updateMarkerRotation() {
                    this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._dotElement.classList.add("mapboxgl-user-location-show-heading")) : (this._dotElement.classList.remove("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
                }
                _onError(t1) {
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === t1.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === t1.code && this._noTimeout) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("mapboxgl-user-location-dot-stale"), this.fire(new e1.Event("error", t1)), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _setupUI(t1) {
                    if (this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this._geolocateButton = n("button", "mapboxgl-ctrl-geolocate", this._container), n("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === t1) {
                        e1.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
                        const t1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                        this._geolocateButton.disabled = !0, this._geolocateButton.setAttribute("aria-label", t1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t1);
                    } else {
                        const e1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                        this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1);
                    }
                    this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = n("div", "mapboxgl-user-location"), this._dotElement.appendChild(n("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(n("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new on({
                        element: this._dotElement,
                        rotationAlignment: "map",
                        pitchAlignment: "map"
                    }), this._circleElement = n("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new on({
                        element: this._circleElement,
                        pitchAlignment: "map"
                    }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (t1)=>{
                        t1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t1.originalEvent && "resize" === t1.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new e1.Event("trackuserlocationend")));
                    });
                }
                _onDeviceOrientation(e1) {
                    this._userLocationDotMarker && (e1.webkitCompassHeading ? this._heading = e1.webkitCompassHeading : !0 === e1.absolute && (this._heading = -1 * e1.alpha), this._updateMarkerRotationThrottled());
                }
                trigger() {
                    if (!this._setup) return e1.warnOnce("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._watchState = "WAITING_ACTIVE", this.fire(new e1.Event("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                this._numberOfWatches--, this._noTimeout = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e1.Event("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e1.Event("trackuserlocationstart"));
                        }
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_LOCK":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                break;
                            case "BACKGROUND":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                break;
                            case "BACKGROUND_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let e1;
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e1 = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, this._noTimeout = !0) : (e1 = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e1), this.options.showUserHeading && this._addDeviceOrientationListener();
                        }
                    } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                    return !0;
                }
                _addDeviceOrientationListener() {
                    const t1 = ()=>{
                        e1.window.addEventListener("ondeviceorientationabsolute" in e1.window ? "deviceorientationabsolute" : "deviceorientation", this._onDeviceOrientation);
                    };
                    void 0 !== e1.window.DeviceMotionEvent && "function" == typeof e1.window.DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((e1)=>{
                        "granted" === e1 && t1();
                    }).catch(console.error) : t1();
                }
                _clearWatch() {
                    this.options.geolocation.clearWatch(this._geolocationWatchID), e1.window.removeEventListener("deviceorientation", this._onDeviceOrientation), e1.window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
                constructor(t1){
                    super(), this.options = e1.extend({
                        geolocation: e1.window.navigator.geolocation
                    }, hn, t1), e1.bindAll([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker",
                        "_updateMarkerRotation",
                        "_onDeviceOrientation"
                    ], this), this._updateMarkerRotationThrottled = Jo(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
                }
            },
            AttributionControl: Kr,
            ScaleControl: class {
                getDefaultPosition() {
                    return "bottom-left";
                }
                _update() {
                    const e1 = this.options.maxWidth || 100, t1 = this._map, i = t1._containerHeight / 2, o = t1._containerWidth / 2 - e1 / 2, r = t1.unproject([
                        o,
                        i
                    ]), n = t1.unproject([
                        o + e1,
                        i
                    ]), a = r.distanceTo(n);
                    if ("imperial" === this.options.unit) {
                        const t1 = 3.2808 * a;
                        t1 > 5280 ? this._setScale(e1, t1 / 5280, "mile") : this._setScale(e1, t1, "foot");
                    } else "nautical" === this.options.unit ? this._setScale(e1, a / 1852, "nautical-mile") : a >= 1e3 ? this._setScale(e1, a / 1e3, "kilometer") : this._setScale(e1, a, "meter");
                }
                _setScale(e1, t1, i) {
                    const o = dn(t1), r = o / t1;
                    this._map._requestDomTask(()=>{
                        this._container.style.width = e1 * r + "px", this._container.innerHTML = "nautical-mile" !== i ? new Intl.NumberFormat(this._language, {
                            style: "unit",
                            unitDisplay: "narrow",
                            unit: i
                        }).format(o) : `${o}&nbsp;nm`;
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this._language = e1.getLanguage(), this._container = n("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e1.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
                }
                onRemove() {
                    this._container.remove(), this._map.off("move", this._update), this._map = void 0;
                }
                _setLanguage(e1) {
                    this._language = e1, this._update();
                }
                setUnit(e1) {
                    this.options.unit = e1, this._update();
                }
                constructor(t1){
                    this.options = e1.extend({}, un, t1), function() {
                        try {
                            return new Intl.NumberFormat("en", {
                                style: "unit",
                                unitDisplay: "narrow",
                                unit: "meter"
                            }), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }() || (this._setScale = _n.bind(this)), e1.bindAll([
                        "_update",
                        "_setScale",
                        "setUnit"
                    ], this);
                }
            },
            FullscreenControl: class {
                onAdd(t1) {
                    return this._map = t1, this._container || (this._container = this._map.getContainer()), this._controlContainer = n("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e1.warnOnce("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    this._controlContainer.remove(), this._map = null, e1.window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !(!e1.window.document.fullscreenEnabled && !e1.window.document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const t1 = this._fullscreenButton = n("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                    n("span", "mapboxgl-ctrl-icon", t1).setAttribute("aria-hidden", "true"), t1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), e1.window.document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const e1 = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", e1), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e1);
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (e1.window.document.fullscreenElement || e1.window.document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? e1.window.document.exitFullscreen ? e1.window.document.exitFullscreen() : e1.window.document.webkitCancelFullScreen && e1.window.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
                constructor(t1){
                    this._fullscreen = !1, t1 && t1.container && (t1.container instanceof e1.window.HTMLElement ? this._container = t1.container : e1.warnOnce("Full screen control 'container' must be a DOM element.")), e1.bindAll([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in e1.window.document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in e1.window.document && (this._fullscreenchange = "webkitfullscreenchange");
                }
            },
            Popup: class extends e1.Evented {
                addTo(t1) {
                    return this._map && this.remove(), this._map = t1, this.options.closeOnClick && t1.on("preclick", this._onClose), this.options.closeOnMove && t1.on("move", this._onClose), t1.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (t1.on("mousemove", this._onMouseEvent), t1.on("mouseup", this._onMouseEvent), t1._canvasContainer.classList.add("mapboxgl-track-pointer")) : t1.on("move", this._update), this.fire(new e1.Event("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
                    const t1 = this._map;
                    return t1 && (t1.off("move", this._update), t1.off("move", this._onClose), t1.off("preclick", this._onClose), t1.off("click", this._onClose), t1.off("remove", this.remove), t1.off("mousemove", this._onMouseEvent), t1.off("mouseup", this._onMouseEvent), t1.off("drag", this._onMouseEvent), this._map = void 0), this.fire(new e1.Event("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(t1) {
                    this._lngLat = e1.LngLat.convert(t1), this._pos = null, this._trackPointer = !1, this._update();
                    const i = this._map;
                    return i && (i.on("move", this._update), i.off("mousemove", this._onMouseEvent), i._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                }
                trackPointer() {
                    this._trackPointer = !0, this._pos = null, this._update();
                    const e1 = this._map;
                    return e1 && (e1.off("move", this._update), e1.on("mousemove", this._onMouseEvent), e1.on("drag", this._onMouseEvent), e1._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(t1) {
                    return this.setDOMContent(e1.window.document.createTextNode(t1));
                }
                setHTML(t1) {
                    const i = e1.window.document.createDocumentFragment(), o = e1.window.document.createElement("body");
                    let r;
                    for(o.innerHTML = t1; r = o.firstChild, r;)i.appendChild(r);
                    return this.setDOMContent(i);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(e1) {
                    return this.options.maxWidth = e1, this._update(), this;
                }
                setDOMContent(e1) {
                    let t1 = this._content;
                    if (t1) for(; t1.hasChildNodes();)t1.firstChild && t1.removeChild(t1.firstChild);
                    else t1 = this._content = n("div", "mapboxgl-popup-content", this._container || void 0);
                    if (t1.appendChild(e1), this.options.closeButton) {
                        const e1 = this._closeButton = n("button", "mapboxgl-popup-close-button", t1);
                        e1.type = "button", e1.setAttribute("aria-label", "Close popup"), e1.setAttribute("aria-hidden", "true"), e1.innerHTML = "&#215;", e1.addEventListener("click", this._onClose);
                    }
                    return this._update(), this._focusFirstElement(), this;
                }
                addClassName(e1) {
                    return this._classList.add(e1), this._updateClassList(), this;
                }
                removeClassName(e1) {
                    return this._classList.delete(e1), this._updateClassList(), this;
                }
                setOffset(e1) {
                    return this.options.offset = e1, this._update(), this;
                }
                toggleClassName(e1) {
                    let t1;
                    return this._classList.delete(e1) ? t1 = !1 : (this._classList.add(e1), t1 = !0), this._updateClassList(), t1;
                }
                _onMouseEvent(e1) {
                    this._update(e1.point);
                }
                _getAnchor(e1) {
                    if (this.options.anchor) return this.options.anchor;
                    const t1 = this._map, i = this._container, o = this._pos;
                    if (!t1 || !i || !o) return "bottom";
                    const r = i.offsetWidth, n = i.offsetHeight, a = o.x < r / 2, s = o.x > t1.transform.width - r / 2;
                    if (o.y + e1 < n) return a ? "top-left" : s ? "top-right" : "top";
                    if (o.y > t1.transform.height - n) {
                        if (a) return "bottom-left";
                        if (s) return "bottom-right";
                    }
                    return a ? "left" : s ? "right" : "bottom";
                }
                _updateClassList() {
                    const e1 = this._container;
                    if (!e1) return;
                    const t1 = [
                        ...this._classList
                    ];
                    t1.push("mapboxgl-popup"), this._anchor && t1.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t1.push("mapboxgl-popup-track-pointer"), e1.className = t1.join(" ");
                }
                _update(t1) {
                    const i = this._map, o = this._content;
                    if (!i || !this._lngLat && !this._trackPointer || !o) return;
                    let r = this._container;
                    if (r || (r = this._container = n("div", "mapboxgl-popup", i.getContainer()), this._tip = n("div", "mapboxgl-popup-tip", r), r.appendChild(o)), this.options.maxWidth && r.style.maxWidth !== this.options.maxWidth && (r.style.maxWidth = this.options.maxWidth), i.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = en(this._lngLat, this._pos, i.transform)), !this._trackPointer || t1) {
                        const e1 = this._pos = this._trackPointer && t1 ? t1 : i.project(this._lngLat), o = fn(this.options.offset), r = this._anchor = this._getAnchor(o.y), n = fn(this.options.offset, r), a = e1.add(n).round();
                        i._requestDomTask(()=>{
                            this._container && r && (this._container.style.transform = `${tn[r]} translate(${a.x}px,${a.y}px)`);
                        });
                    }
                    if (!this._marker && i._showingGlobe()) {
                        const t1 = e1.isLngLatBehindGlobe(i.transform, this._lngLat) ? 0 : 1;
                        this._setOpacity(t1);
                    }
                    this._updateClassList();
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const e1 = this._container.querySelector(mn);
                    e1 && e1.focus();
                }
                _onClose() {
                    this.remove();
                }
                _setOpacity(e1) {
                    this._container && (this._container.style.opacity = `${e1}`), this._content && (this._content.style.pointerEvents = e1 ? "auto" : "none");
                }
                constructor(t1){
                    super(), this.options = e1.extend(Object.create(pn), t1), e1.bindAll([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseEvent"
                    ], this), this._classList = new Set(t1 && t1.className ? t1.className.trim().split(/\s+/) : []);
                }
            },
            Marker: on,
            Style: ei,
            LngLat: e1.LngLat,
            LngLatBounds: e1.LngLatBounds,
            Point: e1.pointGeometry,
            MercatorCoordinate: e1.MercatorCoordinate,
            FreeCameraOptions: Zo,
            Evented: e1.Evented,
            config: e1.config,
            prewarm: function() {
                Ge().acquire(Fe);
            },
            clearPrewarmedResources: function() {
                const e1 = Ne;
                e1 && (e1.isPreloaded() && 1 === e1.numActive() ? (e1.release(Fe), Ne = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },
            get accessToken () {
                return e1.config.ACCESS_TOKEN;
            },
            set accessToken (t){
                e1.config.ACCESS_TOKEN = t;
            },
            get baseApiUrl () {
                return e1.config.API_URL;
            },
            set baseApiUrl (t){
                e1.config.API_URL = t;
            },
            get workerCount () {
                return Ue.workerCount;
            },
            set workerCount (e){
                Ue.workerCount = e;
            },
            get maxParallelImageRequests () {
                return e1.config.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (t){
                e1.config.MAX_PARALLEL_IMAGE_REQUESTS = t;
            },
            clearStorage (t1) {
                e1.clearTileCache(t1);
            },
            workerUrl: "",
            workerClass: null,
            setNow: e1.exported.setNow,
            restoreNow: e1.exported.restoreNow
        };
        return gn;
    });
    //
    var mapboxgl$1 = mapboxgl;
    return mapboxgl$1;
});


var $813da6cac3b1f5f5$exports = {};
/**
 * Create a new [Mapbox GL JS plugin](https://www.mapbox.com/blog/build-mapbox-gl-js-plugins/) that
 * modifies the layers of the map style to use the `text-field` that matches the browser language.
 * As of Mapbox GL Language v1.0.0, this plugin no longer supports token values (e.g. `{name}`). v1.0+ expects the `text-field`
 * property of a style to use an [expression](https://docs.mapbox.com/mapbox-gl-js/style-spec/expressions/) of the form `['get', 'name_en']` or `['get', 'name']`; these expressions can be nested. Note that `get` expressions used as inputs to other expressions may not be handled by this plugin. For example:
 * ```
 * ["match",
 *   ["get", "name"],
 *   "California",
 *   "Golden State",
 *   ["coalesce",
 *     ["get", "name_en"],
 *     ["get", "name"]
 *   ]
 * ]
 * ```
 * Only styles based on [Mapbox v8 styles](https://docs.mapbox.com/help/troubleshooting/streets-v8-migration-guide/) are supported.
 *
 * @constructor
 * @param {object} options - Options to configure the plugin.
 * @param {string[]} [options.supportedLanguages] - List of supported languages
 * @param {Function} [options.languageTransform] - Custom style transformation to apply
 * @param {RegExp} [options.languageField=/^name_/] - RegExp to match if a text-field is a language field
 * @param {Function} [options.getLanguageField] - Given a language choose the field in the vector tiles
 * @param {string} [options.languageSource] - Name of the source that contains the different languages.
 * @param {string} [options.defaultLanguage] - Name of the default language to initialize style after loading.
 * @param {string[]} [options.excludedLayerIds] - Name of the layers that should be excluded from translation.
 */ function $813da6cac3b1f5f5$var$MapboxLanguage(options) {
    options = Object.assign({}, options);
    if (!(this instanceof $813da6cac3b1f5f5$var$MapboxLanguage)) throw new Error('MapboxLanguage needs to be called with the new keyword');
    this.setLanguage = this.setLanguage.bind(this);
    this._initialStyleUpdate = this._initialStyleUpdate.bind(this);
    this._defaultLanguage = options.defaultLanguage;
    this._isLanguageField = options.languageField || /^name_/;
    this._getLanguageField = options.getLanguageField || function nameField(language) {
        return language === 'mul' ? 'name' : `name_${language}`;
    };
    this._languageSource = options.languageSource || null;
    this._languageTransform = options.languageTransform;
    this._excludedLayerIds = options.excludedLayerIds || [];
    this.supportedLanguages = options.supportedLanguages || [
        'ar',
        'de',
        'en',
        'es',
        'fr',
        'it',
        'ja',
        'ko',
        'mul',
        'pt',
        'ru',
        'vi',
        'zh-Hans',
        'zh-Hant'
    ];
}
const $813da6cac3b1f5f5$var$isTokenField = /^\{name/;
function $813da6cac3b1f5f5$var$isFlatExpressionField(isLangField, property) {
    const isGetExpression = Array.isArray(property) && property[0] === 'get';
    if (isGetExpression && $813da6cac3b1f5f5$var$isTokenField.test(property[1])) console.warn('This plugin no longer supports the use of token syntax (e.g. {name}). Please use a get expression. See https://docs.mapbox.com/mapbox-gl-js/style-spec/expressions/ for more details.');
    return isGetExpression && isLangField.test(property[1]);
}
function $813da6cac3b1f5f5$var$adaptNestedExpressionField(isLangField, property, languageFieldName) {
    if (Array.isArray(property)) {
        for(let i = 1; i < property.length; i++)if (Array.isArray(property[i])) {
            if ($813da6cac3b1f5f5$var$isFlatExpressionField(isLangField, property[i])) property[i][1] = languageFieldName;
            $813da6cac3b1f5f5$var$adaptNestedExpressionField(isLangField, property[i], languageFieldName);
        }
    }
}
function $813da6cac3b1f5f5$var$adaptPropertyLanguage(isLangField, property, languageFieldName) {
    if ($813da6cac3b1f5f5$var$isFlatExpressionField(isLangField, property)) property[1] = languageFieldName;
    $813da6cac3b1f5f5$var$adaptNestedExpressionField(isLangField, property, languageFieldName);
    // handle special case of bare ['get', 'name'] expression by wrapping it in a coalesce statement
    if (property[0] === 'get' && property[1] === 'name') {
        const defaultProp = property.slice();
        const adaptedProp = [
            'get',
            languageFieldName
        ];
        property = [
            'coalesce',
            adaptedProp,
            defaultProp
        ];
    }
    return property;
}
function $813da6cac3b1f5f5$var$changeLayerTextProperty(isLangField, layer, languageFieldName, excludedLayerIds) {
    if (layer.layout && layer.layout['text-field'] && excludedLayerIds.indexOf(layer.id) === -1) return Object.assign({}, layer, {
        layout: Object.assign({}, layer.layout, {
            'text-field': $813da6cac3b1f5f5$var$adaptPropertyLanguage(isLangField, layer.layout['text-field'], languageFieldName)
        })
    });
    return layer;
}
function $813da6cac3b1f5f5$var$findStreetsSource(style) {
    const sources = Object.keys(style.sources).filter((sourceName)=>{
        const url = style.sources[sourceName].url;
        // the source URL can reference the source version or the style version
        // this check and the error forces users to migrate to styles using source version 8
        return url && url.indexOf('mapbox.mapbox-streets-v8') > -1 || /mapbox-streets-v[1-9][1-9]/.test(url);
    });
    if (!sources.length) throw new Error('If using MapboxLanguage with a Mapbox style, the style must be based on vector tile version 8, e.g. "streets-v11"');
    return sources[0];
}
/**
 * Explicitly change the language for a style.
 * @param {object} style - Mapbox GL style to modify
 * @param {string} language - The language iso code
 * @returns {object} the modified style
 */ $813da6cac3b1f5f5$var$MapboxLanguage.prototype.setLanguage = function(style, language) {
    if (this.supportedLanguages.indexOf(language) < 0) throw new Error(`Language ${language} is not supported`);
    const streetsSource = this._languageSource || $813da6cac3b1f5f5$var$findStreetsSource(style);
    if (!streetsSource) return style;
    const field = this._getLanguageField(language);
    const isLangField = this._isLanguageField;
    const excludedLayerIds = this._excludedLayerIds;
    const changedLayers = style.layers.map((layer)=>{
        if (layer.source === streetsSource) return $813da6cac3b1f5f5$var$changeLayerTextProperty(isLangField, layer, field, excludedLayerIds);
        return layer;
    });
    const languageStyle = Object.assign({}, style, {
        layers: changedLayers
    });
    return this._languageTransform ? this._languageTransform(languageStyle, language) : languageStyle;
};
$813da6cac3b1f5f5$var$MapboxLanguage.prototype._initialStyleUpdate = function() {
    const style = this._map.getStyle();
    const language = this._defaultLanguage || $813da6cac3b1f5f5$var$browserLanguage(this.supportedLanguages);
    this._map.setStyle(this.setLanguage(style, language));
};
function $813da6cac3b1f5f5$var$browserLanguage(supportedLanguages) {
    const language = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage;
    const parts = language && language.split('-');
    let languageCode = language;
    if (parts.length > 1) languageCode = parts[0];
    if (supportedLanguages.indexOf(languageCode) > -1) return languageCode;
    return null;
}
$813da6cac3b1f5f5$var$MapboxLanguage.prototype.onAdd = function(map) {
    this._map = map;
    this._map.on('style.load', this._initialStyleUpdate);
    this._container = document.createElement('div');
    return this._container;
};
$813da6cac3b1f5f5$var$MapboxLanguage.prototype.onRemove = function() {
    this._map.off('style.load', this._initialStyleUpdate);
    this._map = undefined;
};
if (typeof $813da6cac3b1f5f5$exports !== 'undefined') $813da6cac3b1f5f5$exports = $813da6cac3b1f5f5$var$MapboxLanguage;
else window.MapboxLanguage = $813da6cac3b1f5f5$var$MapboxLanguage;


var $b239a1ddeb05fb73$exports = {};
$b239a1ddeb05fb73$exports = JSON.parse("[[\"NS27-CC33-TE20\",0,0,238,40],[\"EW16-NE3-TE17\",238,0,229,40],[\"NS24-NE6-CC1\",467,0,214,40],[\"EW21-CC22\",681,0,168,40],[\"NS25-EW13\",0,40,167,40],[\"NS26-EW14\",167,40,167,40],[\"EW12-DT14\",334,40,166,40],[\"NE12-CC13\",500,40,163,40],[\"NS17-CC15\",663,40,163,40],[\"CC10-DT26\",0,80,162,40],[\"CC34-DT16\",162,80,162,40],[\"NS21-DT11\",324,80,159,40],[\"NS22-TE14\",483,80,159,40],[\"DT10-TE11\",642,80,156,40],[\"NS1-EW24\",0,120,154,40],[\"EW2-DT32\",0,160,152,40],[\"DT35-CG1\",0,200,150,40],[\"NE1-CC29\",0,240,150,40],[\"CC4-DT15\",0,280,148,40],[\"CC19-DT9\",0,320,148,40],[\"CC17-TE9\",0,360,147,40],[\"NE4-DT19\",0,400,147,40],[\"NE7-DT12\",0,440,147,40],[\"NE16-STC\",0,480,147,40],[\"NE17-PTC\",0,520,147,40],[\"EW8-CC9\",0,560,142,40],[\"NS4-BP1\",0,600,135,40],[\"DT1-BP6\",0,640,133,40],[\"NS9-TE2\",0,680,132,40],[\"EW4-CG\",0,720,127,40],[\"EW10\",0,760,90,40],[\"EW15\",0,800,90,40],[\"EW17\",154,120,90,40],[\"EW18\",244,120,90,40],[\"EW19\",334,120,90,40],[\"EW20\",424,120,90,40],[\"EW22\",514,120,90,40],[\"EW23\",604,120,90,40],[\"EW26\",694,120,90,40],[\"EW25\",154,160,90,40],[\"EW27\",244,160,90,40],[\"EW28\",334,160,90,40],[\"EW29\",424,160,90,40],[\"EW30\",514,160,90,40],[\"EW31\",604,160,90,40],[\"EW32\",694,160,90,40],[\"EW33\",154,200,90,40],[\"EW11\",244,200,88,40],[\"CC12\",332,200,86,40],[\"CC14\",418,200,86,40],[\"CC20\",504,200,86,40],[\"CC16\",590,200,86,40],[\"CC21\",676,200,86,40],[\"CC23\",762,200,86,40],[\"CC24\",154,240,86,40],[\"CC25\",154,280,86,40],[\"CC26\",154,320,86,40],[\"CC27\",154,360,86,40],[\"CC28\",154,400,86,40],[\"CC30\",154,440,86,40],[\"CC31\",154,480,86,40],[\"CC32\",154,520,86,40],[\"BP10\",154,560,84,40],[\"BP12\",154,600,84,40],[\"BP13\",154,640,84,40],[\"CC11\",154,680,84,40],[\"NE10\",154,720,84,40],[\"NE13\",154,760,84,40],[\"NE14\",154,800,84,40],[\"NE15\",240,240,84,40],[\"NE18\",324,240,84,40],[\"NS10\",408,240,84,40],[\"NS12\",492,240,84,40],[\"NS13\",576,240,84,40],[\"NS14\",660,240,84,40],[\"NS15\",744,240,84,40],[\"NS16\",240,280,84,40],[\"NS18\",324,280,84,40],[\"NS19\",408,280,84,40],[\"NS20\",492,280,84,40],[\"NS23\",576,280,84,40],[\"NS28\",660,280,84,40],[\"BP11\",744,280,83,40],[\"DT13\",240,320,83,40],[\"DT17\",240,360,83,40],[\"DT18\",240,400,83,40],[\"DT20\",240,440,83,40],[\"DT21\",240,480,83,40],[\"DT22\",240,520,83,40],[\"DT23\",240,560,83,40],[\"DT24\",240,600,83,40],[\"DT25\",240,640,83,40],[\"DT27\",240,680,83,40],[\"DT28\",240,720,83,40],[\"DT29\",240,760,83,40],[\"DT30\",240,800,83,40],[\"DT31\",323,320,83,40],[\"DT33\",406,320,83,40],[\"DT34\",489,320,83,40],[\"NE11\",572,320,83,40],[\"NS11\",655,320,83,40],[\"TE12\",738,320,82,40],[\"TE13\",323,360,82,40],[\"TE15\",405,360,82,40],[\"TE16\",487,360,82,40],[\"TE18\",569,360,82,40],[\"TE19\",651,360,82,40],[\"TE22\",733,360,82,40],[\"TE23\",323,400,82,40],[\"TE24\",323,440,82,40],[\"TE25\",323,480,82,40],[\"TE26\",323,520,82,40],[\"TE27\",323,560,82,40],[\"TE28\",323,600,82,40],[\"TE29\",323,640,82,40],[\"EW1\",323,680,76,40],[\"EW3\",323,720,76,40],[\"EW5\",323,760,76,40],[\"EW6\",323,800,76,40],[\"EW7\",405,400,76,40],[\"EW9\",481,400,76,40],[\"PW1\",557,400,76,40],[\"PW2\",633,400,76,40],[\"PW3\",709,400,76,40],[\"PW4\",405,440,76,40],[\"PW5\",481,440,76,40],[\"PW6\",557,440,76,40],[\"PW7\",633,440,76,40],[\"SW1\",709,440,76,40],[\"SW2\",405,480,76,40],[\"SW3\",405,520,76,40],[\"SW4\",405,560,76,40],[\"SW5\",405,600,76,40],[\"SW6\",405,640,76,40],[\"SW7\",405,680,76,40],[\"SW8\",405,720,76,40],[\"CG2\",405,760,74,40],[\"CC3\",405,800,72,40],[\"CC2\",481,480,72,40],[\"CC5\",553,480,72,40],[\"CC7\",625,480,72,40],[\"CC6\",697,480,72,40],[\"CC8\",769,480,72,40],[\"BP2\",481,520,71,40],[\"BP3\",481,560,71,40],[\"BP4\",481,600,71,40],[\"BP5\",481,640,71,40],[\"BP7\",481,680,71,40],[\"BP8\",481,720,71,40],[\"BP9\",481,760,71,40],[\"NE5\",481,800,71,40],[\"NE8\",552,520,71,40],[\"NE9\",623,520,71,40],[\"NS2\",694,520,71,40],[\"NS3\",765,520,71,40],[\"NS5\",552,560,71,40],[\"NS7\",623,560,71,40],[\"NS8\",694,560,71,40],[\"DT2\",765,560,70,40],[\"DT3\",552,600,70,40],[\"DT4\",552,640,70,40],[\"DT5\",552,680,70,40],[\"DT6\",552,720,70,40],[\"DT7\",552,760,70,40],[\"DT8\",552,800,70,40],[\"PE1\",622,600,70,40],[\"PE2\",692,600,70,40],[\"PE3\",762,600,70,40],[\"PE4\",622,640,70,40],[\"PE5\",692,640,70,40],[\"PE6\",762,640,70,40],[\"PE7\",622,680,70,40],[\"SE1\",622,720,70,40],[\"SE2\",622,760,70,40],[\"SE3\",622,800,70,40],[\"SE4\",692,680,70,40],[\"SE5\",762,680,70,40],[\"TE1\",784,120,68,40],[\"TE3\",784,160,68,40],[\"TE4\",692,720,68,40],[\"TE5\",760,720,68,40],[\"TE6\",692,760,68,40],[\"TE7\",692,800,68,40],[\"TE8\",760,760,68,40],[\"green-purple-brown\",798,80,50,16],[\"red-purple-yellow\",798,96,50,16],[\"red-yellow-brown\",90,760,50,16],[\"blue-brown\",90,776,36,16],[\"blue-gray\",90,792,36,16],[\"blue-green\",90,808,36,16],[\"green-blue\",90,824,36,16],[\"green-green\",815,360,36,16],[\"green-yellow\",815,376,36,16],[\"purple-blue\",785,400,36,16],[\"purple-gray\",785,416,36,16],[\"purple-yellow\",785,440,36,16],[\"red-blue\",785,456,36,16],[\"red-brown\",760,800,36,16],[\"red-gray\",760,816,36,16],[\"red-green\",760,832,36,16],[\"red-yellow\",796,800,36,16],[\"yellow-blue\",796,816,36,16],[\"yellow-brown\",796,832,36,16],[\"blue\",826,40,21,16],[\"brown\",826,56,21,16],[\"gray\",133,640,21,16],[\"green\",133,656,21,16],[\"purple\",132,680,21,16],[\"red\",132,696,21,16],[\"yellow\",127,720,21,16]]");


const $10efe41c7f1c1349$var$$ = (id)=>document.getElementById(id);
const $10efe41c7f1c1349$var$$home = $10efe41c7f1c1349$var$$('home');
const $10efe41c7f1c1349$var$$btnCloseHome = $10efe41c7f1c1349$var$$('btn-close-home');
const $10efe41c7f1c1349$var$$station = $10efe41c7f1c1349$var$$('station');
const $10efe41c7f1c1349$var$$search = $10efe41c7f1c1349$var$$('search');
const $10efe41c7f1c1349$var$$searchField = $10efe41c7f1c1349$var$$('search-field');
const $10efe41c7f1c1349$var$$searchCancel = $10efe41c7f1c1349$var$$('search-cancel');
const $10efe41c7f1c1349$var$$searchResults = $10efe41c7f1c1349$var$$('search-results');
const $10efe41c7f1c1349$var$$crowdedTiming = $10efe41c7f1c1349$var$$('crowded-timing');
$10efe41c7f1c1349$var$$btnCloseHome.onclick = (e)=>{
    e.preventDefault();
    localStorage['railrouter-sg:about'] = 1;
    $10efe41c7f1c1349$var$$home.classList.remove('open');
};
if (!localStorage['railrouter-sg:about']) $10efe41c7f1c1349$var$$home.classList.add('open');
$10efe41c7f1c1349$var$$('logo').onclick = ()=>{
    $10efe41c7f1c1349$var$$home.classList.toggle('open');
};
let $10efe41c7f1c1349$var$fuse;
let $10efe41c7f1c1349$var$stationsData;
const $10efe41c7f1c1349$var$exitsData = {};

const $10efe41c7f1c1349$var$geojsonFetch = fetch((parcelRequire("4uHIT")));
(0, (/*@__PURE__*/$parcel$interopDefault($512f0610cec951ce$exports))).accessToken = 'pk.eyJ1IjoiY2hlZWF1biIsImEiOiJja2NydG83cWMwaGJsMnBqdjR5aHc3MzdlIn0.YGTZpi7JQMquEOv9E8K_bg';
const $10efe41c7f1c1349$var$center = [
    103.8475,
    1.3011
];
const $10efe41c7f1c1349$var$lowerLat = 1.23, $10efe41c7f1c1349$var$upperLat = 1.475, $10efe41c7f1c1349$var$lowerLong = 103.59, $10efe41c7f1c1349$var$upperLong = 104.05;
const $10efe41c7f1c1349$var$bounds = [
    $10efe41c7f1c1349$var$lowerLong,
    $10efe41c7f1c1349$var$lowerLat,
    $10efe41c7f1c1349$var$upperLong,
    $10efe41c7f1c1349$var$upperLat
];
(0, (/*@__PURE__*/$parcel$interopDefault($512f0610cec951ce$exports))).setRTLTextPlugin('https://wipfli.github.io/maplibre-gl-complex-text/dist/maplibre-gl-complex-text.js', false);
const $10efe41c7f1c1349$var$map = window.$map = new (0, (/*@__PURE__*/$parcel$interopDefault($512f0610cec951ce$exports))).Map({
    container: 'map',
    // style: 'mapbox://styles/cheeaun/clagddy23000y14saafbh02a8/draft',
    style: 'mapbox://styles/cheeaun/clagddy23000y14saafbh02a8',
    center: $10efe41c7f1c1349$var$center,
    bounds: $10efe41c7f1c1349$var$bounds,
    renderWorldCopies: false,
    boxZoom: false,
    bearingSnap: 15,
    // localIdeographFontFamily:
    //   '"InaiMathi", "Tamil Sangam MN", "Nirmala UI", Latha, Bamini ,Roboto, Noto, "Noto Sans Tamil", sans-serif',
    transformRequest: (url, resourceType)=>{
        if (resourceType === 'Glyphs') {
            const match = url.match(/(\d+)-(\d+)\.pbf/);
            if (match) {
                const start = parseInt(match[1], 10);
                const end = parseInt(match[2], 10);
                const encodedRangeStarts = [
                    63488,
                    63232,
                    62976,
                    62720,
                    62464,
                    62208,
                    61952,
                    61696,
                    61440,
                    61184,
                    60928,
                    60672,
                    60416,
                    60160,
                    59904,
                    59648,
                    59392,
                    59136,
                    58880,
                    58624,
                    58368,
                    58112,
                    57856,
                    57600,
                    3072,
                    2816,
                    2560,
                    2304,
                    10240,
                    10752
                ];
                if (encodedRangeStarts.includes(start)) return {
                    url: `https://wipfli.github.io/pgf-glyph-ranges/font/NotoSansMultiscript-Regular-v1/${start}-${end}.pbf`
                };
            }
        }
        return undefined;
    }
});
const $10efe41c7f1c1349$var$mapCanvas = $10efe41c7f1c1349$var$map.getCanvas();
const $10efe41c7f1c1349$var$supportedLanguages = [
    'ar',
    'de',
    'en',
    'es',
    'fr',
    'it',
    'ja',
    'ko',
    'mul',
    'pt',
    'ru',
    'vi',
    'zh-Hans',
    'zh-Hant'
];
function $10efe41c7f1c1349$var$browserLanguage() {
    const language = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage;
    const parts = language && language.split('-');
    let languageCode = language;
    if (parts.length > 1) languageCode = parts[0];
    if ($10efe41c7f1c1349$var$supportedLanguages.indexOf(languageCode) > -1) return languageCode;
    const closestLanguageCode = $10efe41c7f1c1349$var$supportedLanguages.find((l)=>{
        return l.startsWith(languageCode);
    });
    if (closestLanguageCode) return closestLanguageCode;
    return null;
}
$10efe41c7f1c1349$var$map.addControl(new (0, (/*@__PURE__*/$parcel$interopDefault($813da6cac3b1f5f5$exports)))({
    defaultLanguage: $10efe41c7f1c1349$var$browserLanguage()
}));
$10efe41c7f1c1349$var$map.addControl(new (0, (/*@__PURE__*/$parcel$interopDefault($512f0610cec951ce$exports))).GeolocateControl({
    positionOptions: {
        enableHighAccuracy: true
    },
    trackUserLocation: true
}), 'bottom-right');
const $10efe41c7f1c1349$var$mapLoaded = new Promise((res)=>{
    $10efe41c7f1c1349$var$map.once('load', ()=>{
        console.timeStamp('Map load');
        res();
    });
});
const $10efe41c7f1c1349$var$lineColors = {
    orangered: '#d42e12',
    mediumseagreen: '#009645',
    orange: '#fa9e0d',
    saddlebrown: '#9D5B25',
    darkmagenta: '#9900aa',
    darkslateblue: '#005ec4',
    gray: '#748477'
};
const $10efe41c7f1c1349$var$lineColorsExpression = [
    'match',
    [
        'get',
        'line_color'
    ],
    ...Object.keys($10efe41c7f1c1349$var$lineColors).map((c)=>[
            c,
            $10efe41c7f1c1349$var$lineColors[c]
        ]).flat(),
    '#748477'
];
function $10efe41c7f1c1349$var$formatArriveTime(str) {
    if (/\d/.test(str)) return str + ' min' + (str == '1' ? '' : 's');
    return str;
}
const $10efe41c7f1c1349$var$origTitle = document.title;
let $10efe41c7f1c1349$var$currentStation;
const $10efe41c7f1c1349$var$stationView = {
    mount: (feature)=>{
        // set title
        const { properties: properties, geometry: geometry } = feature;
        const { name: name, 'name_zh-Hans': name_zh_Hans, name_ta: name_ta, station_codes: station_codes, station_colors: station_colors, wikipedia_slug: wikipedia_slug } = properties;
        document.title = `${name} / ${name_zh_Hans} / ${name_ta} (${station_codes}) \u{2013} RailRouter SG`;
        $10efe41c7f1c1349$var$$station.classList.remove('min');
        const zoom = $10efe41c7f1c1349$var$map.getZoom();
        const isScreenLarge = window.innerWidth >= 640;
        const padding = isScreenLarge ? {
            left: 320
        } : {
            bottom: window.innerHeight / 2
        };
        if (zoom <= 13) $10efe41c7f1c1349$var$map.jumpTo({
            center: geometry.coordinates,
            zoom: 16.5,
            pitch: 70,
            padding: padding
        });
        else $10efe41c7f1c1349$var$map.easeTo({
            center: geometry.coordinates,
            zoom: 16.5,
            pitch: 70,
            padding: padding,
            duration: 500
        });
        if (station_codes === $10efe41c7f1c1349$var$currentStation) return;
        $10efe41c7f1c1349$var$currentStation = station_codes;
        $10efe41c7f1c1349$var$$station.innerHTML = `
      <header>
        <span class="pill">
          ${station_codes.split('-').map((c, i)=>`<span class="${station_colors.split('-')[i]}">${c.replace(/^([a-z]+)/i, '$1 ')}</span>`).join('')}
        </span>
        <h2>
          ${name}<br>
          <span lang="zh" class="ib">${name_zh_Hans}</span>&nbsp;&nbsp;&nbsp;
          <span lang="ta" class="ib">${name_ta}</span>
        </h2>
      </header>
      <div class="scrollable">
        ${''}
        <div class="exits"></div>
        <div class="wikipedia"></div>
      </div>
      `;
        $10efe41c7f1c1349$var$$station.classList.add('open');
        // arrivalTimes.mount(name);
        $10efe41c7f1c1349$var$stationsExits.mount($10efe41c7f1c1349$var$exitsData[station_codes], feature);
        $10efe41c7f1c1349$var$wikipedia.mount(wikipedia_slug);
    },
    unmount: ()=>{
        document.title = $10efe41c7f1c1349$var$origTitle;
        $10efe41c7f1c1349$var$currentStation = null;
        $10efe41c7f1c1349$var$$station.classList.remove('open');
        $10efe41c7f1c1349$var$$station.classList.remove('min');
        const zoom = $10efe41c7f1c1349$var$map.getZoom();
        const isScreenLarge = window.innerWidth >= 800;
        $10efe41c7f1c1349$var$map.easeTo({
            zoom: zoom - 1,
            pitch: 0,
            bearing: 0,
            padding: isScreenLarge ? {
                left: 0
            } : {
                bottom: 0
            },
            duration: 500
        });
    }
};
let $10efe41c7f1c1349$var$arrivalTimeout;
const $10efe41c7f1c1349$var$arrivalTimes = {
    render: (name)=>{
        const $arrivals = $10efe41c7f1c1349$var$$station.querySelector('.arrivals');
        fetch(`https://connectv3.smrt.wwprojects.com/smrt/api/train_arrival_time_by_id/?station=${encodeURIComponent(name)}`).then((res)=>res.json()).then(({ results: results })=>{
            if (!results.length) throw new Error('No results');
            const html = results.filter((result, pos, arr)=>{
                // Filter weird destination names
                if (/do not board/i.test(result.next_train_destination)) return false;
                return arr.findIndex((r)=>r.next_train_destination == result.next_train_destination) == pos;
            }).map((result)=>{
                let arrow = "\u21E2";
                const isWeirdName = /do not board/i.test(result.next_train_destination);
                if (result.next_train_destination == result.mrt) arrow = "\u21E0";
                let dest = result.next_train_destination;
                if (isWeirdName) {
                    if (/do not board/i.test(result.subseq_train_destination)) {
                        // Weird name again
                        dest = result.mrt;
                        arrow = "\u21E0";
                    } else dest = result.subseq_train_destination;
                }
                return `<tr>
              <td>${arrow} ${dest}</td>
              <td>${result.next_train_arr}</td>
              <td>${$10efe41c7f1c1349$var$formatArriveTime(result.subseq_train_arr)}</td>
            </tr>`;
            }).join('');
            $arrivals.innerHTML = `<h3>Arrival times</h3>
        <table>
          <tbody>
            ${html}
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3">
                <small>Arrival times powered by <a href="https://www.smrttrains.com.sg/" target="_blank">SMRT Trains Ltd.</a></small>
              </td>
            </tr>
          </tfoot>
        </table>`;
        }).catch((e)=>{
            $arrivals.innerHTML = `<h3>Arrival times</h3>
          <p>No arrival times available</p>`;
        });
    },
    mount: (name)=>{
        clearTimeout($10efe41c7f1c1349$var$arrivalTimeout);
        $10efe41c7f1c1349$var$arrivalTimes.render(name);
        $10efe41c7f1c1349$var$arrivalTimeout = setTimeout(()=>{
            requestAnimationFrame(()=>{
                $10efe41c7f1c1349$var$arrivalTimes.render(name);
            });
        }, 30000); // every 30 seconds
    },
    unmount: ()=>{
        clearTimeout($10efe41c7f1c1349$var$arrivalTimeout);
    }
};
const $10efe41c7f1c1349$var$wikipedia = {
    mount: (slug)=>{
        const $wikipedia = $10efe41c7f1c1349$var$$station.querySelector('.wikipedia');
        fetch(`https://en.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(slug)}`).then((res)=>res.json()).then((res)=>{
            const { content_urls: { desktop: { page: page } }, extract_html: extract_html, thumbnail: thumbnail, originalimage: originalimage } = res;
            const imageSource = (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.source) || (originalimage === null || originalimage === void 0 ? void 0 : originalimage.source) || '';
            const imageWidth = (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.width) || (originalimage === null || originalimage === void 0 ? void 0 : originalimage.width) || '';
            const imageHeight = (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.height) || (originalimage === null || originalimage === void 0 ? void 0 : originalimage.height) || '';
            const imgHtml = imageSource ? `<img src="${imageSource}" width="${imageWidth}" height="${imageHeight}" style="aspect-ratio: ${imageWidth} / ${imageHeight}" alt="">` : '';
            const html = `<div>
          ${imgHtml}
          <div class="extract">${extract_html}</div>
          <div class="more"><a href="${page}" target="_blank">Read more on Wikipedia</a></div>
        </div>`;
            $wikipedia.innerHTML = html;
        });
    }
};
const $10efe41c7f1c1349$var$stationsExits = {
    onExitClick: (e)=>{
        const $exit = e.target.closest('.exit-btn');
        if (!$exit) return;
        const coords = $exit.dataset.coords.split(',').map(parseFloat);
        const angle = $exit.dataset.angle;
        $10efe41c7f1c1349$var$map.flyTo({
            center: coords,
            zoom: 20,
            bearing: angle
        });
    },
    mount: (exits, feature)=>{
        const $exits = $10efe41c7f1c1349$var$$station.querySelector('.exits');
        const sortedExits = exits.sort((a, b)=>{
            if (isNaN(a.properties.name)) {
                if (a.properties.name < b.properties.name) return -1;
                if (a.properties.name > b.properties.name) return 1;
                return 0;
            }
            return a.properties.name - b.properties.name;
        });
        const { coordinates: stationCoords } = feature.geometry;
        const hasDups = sortedExits.some((exit, i)=>{
            var _sortedExits_;
            return exit.properties.name == ((_sortedExits_ = sortedExits[i + 1]) === null || _sortedExits_ === void 0 ? void 0 : _sortedExits_.properties.name);
        });
        // check missing exits by comparing total exits to last exit number, only for numbered exits
        const hasMissingExits = !isNaN(sortedExits[0].properties.name) && sortedExits.length < sortedExits[sortedExits.length - 1].properties.name;
        const html = sortedExits.map(({ properties: { name: name }, geometry: { coordinates: coordinates } })=>{
            // angle between stationCoords and coordinates, relative to north, in degrees
            const angle = Math.atan2(stationCoords[0] - coordinates[0], stationCoords[1] - coordinates[1]);
            const angleDeg = angle * 180 / Math.PI;
            return `
          <button type="button" data-coords="${coordinates.join(',')}" data-angle="${angleDeg}" class="exit-btn">${name}</button>
        `;
        }).join('');
        $exits.innerHTML = `<h3>${exits.length} Exit${exits.length === 1 ? '' : 's'}</h3>
      <div class="exits-container">
      ${html}
      </div>
      ${hasDups ? '<p class="note"><small>Note: The data unfortunately contains duplicated exits. Please check your surroundings before proceeding.</small></p>' : ''}
      ${hasMissingExits ? '<p class="note"><small>Note: The data unfortunately contains missing exits. They could also be under construction or not opened yet.</small></p>' : ''}
      `;
        $10efe41c7f1c1349$var$$station.addEventListener('click', $10efe41c7f1c1349$var$stationsExits.onExitClick);
    },
    unmount: ()=>{
        $10efe41c7f1c1349$var$$station.removeEventListener('click', $10efe41c7f1c1349$var$stationsExits.onExitClick);
    }
};
// format HH:MM for startTime and endTime
const $10efe41c7f1c1349$var$formatTime = (datetime, showAMPM = false)=>{
    const date = new Date(datetime);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    const strTime = `${hours}:${minutes}${showAMPM ? ampm : ''}`;
    return strTime;
};




(async ()=>{
    await $10efe41c7f1c1349$var$mapLoaded;
    const layers = $10efe41c7f1c1349$var$map.getStyle().layers;
    // console.log(layers);
    const labelLayerId = layers.find((l)=>l.type === 'symbol' && l.layout['text-field']).id;
    const data = await $10efe41c7f1c1349$var$geojsonFetch.then((res)=>res.json());
    const exitsFeatures = data.features.filter((f)=>{
        return f.properties.stop_type === 'entrance';
    });
    // Group entrances by station_codes
    exitsFeatures.forEach((f)=>{
        const { properties: { station_codes: station_codes } } = f;
        if (!$10efe41c7f1c1349$var$exitsData[station_codes]) $10efe41c7f1c1349$var$exitsData[station_codes] = [];
        $10efe41c7f1c1349$var$exitsData[station_codes].push(f);
    });
    $10efe41c7f1c1349$var$map.addSource('rail', {
        type: 'geojson',
        data: data,
        buffer: 0
    });
    // LINES
    $10efe41c7f1c1349$var$map.addLayer({
        id: 'lines-case',
        source: 'rail',
        filter: [
            '==',
            [
                'geometry-type'
            ],
            'LineString'
        ],
        type: 'line',
        minzoom: 11,
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-width': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                10,
                1,
                22,
                30
            ],
            'line-color': $10efe41c7f1c1349$var$lineColorsExpression,
            'line-opacity': 0.25,
            'line-blur': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                10,
                0,
                22,
                14
            ]
        }
    }, 'building-extrusion');
    $10efe41c7f1c1349$var$map.addLayer({
        id: 'lines',
        source: 'rail',
        filter: [
            '==',
            [
                'geometry-type'
            ],
            'LineString'
        ],
        type: 'line',
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-width': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                0,
                1,
                22,
                2
            ],
            'line-color': $10efe41c7f1c1349$var$lineColorsExpression
        }
    }, labelLayerId);
    $10efe41c7f1c1349$var$map.addLayer({
        id: 'lines-label',
        source: 'rail',
        filter: [
            '==',
            [
                'geometry-type'
            ],
            'LineString'
        ],
        type: 'symbol',
        minzoom: 13,
        layout: {
            'symbol-placement': 'line',
            'text-field': [
                'get',
                'name'
            ],
            'text-font': [
                'DIN Pro Medium',
                'Arial Unicode MS Regular'
            ],
            'text-letter-spacing': 0.1,
            'text-size': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                13,
                12,
                22,
                16
            ],
            'text-pitch-alignment': 'viewport',
            'text-rotation-alignment': 'map',
            'text-max-angle': 30,
            'text-padding': 1
        },
        paint: {
            'text-color': $10efe41c7f1c1349$var$lineColorsExpression,
            'text-halo-blur': 1,
            'text-halo-color': '#fff',
            'text-halo-width': 2
        }
    });
    // EXITS
    $10efe41c7f1c1349$var$map.addLayer({
        id: 'exits',
        source: 'rail',
        filter: [
            '==',
            [
                'get',
                'stop_type'
            ],
            'entrance'
        ],
        type: 'symbol',
        minzoom: 14,
        layout: {
            'icon-image': 'exit',
            'icon-size': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                14,
                0.25,
                17,
                0.6
            ],
            'icon-allow-overlap': true
        }
    });
    $10efe41c7f1c1349$var$map.addLayer({
        id: 'exits-label',
        source: 'rail',
        filter: [
            '==',
            [
                'get',
                'stop_type'
            ],
            'entrance'
        ],
        type: 'symbol',
        minzoom: 14,
        layout: {
            'text-field': [
                'get',
                'name'
            ],
            'text-font': [
                'DIN Pro Medium',
                'Arial Unicode MS Regular'
            ],
            'text-size': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                14,
                5,
                17,
                13
            ],
            'text-ignore-placement': true,
            'text-allow-overlap': true
        },
        paint: {
            'text-color': '#000',
            'text-translate-anchor': 'viewport',
            'text-translate': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                14,
                [
                    'literal',
                    [
                        0,
                        1
                    ]
                ],
                16,
                [
                    'literal',
                    [
                        0,
                        2
                    ]
                ]
            ]
        }
    });
    // STATIONS
    $10efe41c7f1c1349$var$map.addLayer({
        id: 'stations-point',
        source: 'rail',
        filter: [
            '==',
            [
                'get',
                'stop_type'
            ],
            'station'
        ],
        type: 'symbol',
        minzoom: 10,
        maxzoom: 14,
        layout: {
            'icon-image': [
                'get',
                'station_colors'
            ],
            'icon-size': [
                'interpolate',
                [
                    'exponential',
                    2
                ],
                [
                    'zoom'
                ],
                10,
                0.2,
                14,
                1
            ],
            'icon-allow-overlap': true
        }
    });
    $10efe41c7f1c1349$var$map.addLayer({
        id: 'stations-point-label',
        source: 'rail',
        filter: [
            'all',
            [
                '==',
                [
                    'get',
                    'stop_type'
                ],
                'station'
            ],
            [
                'in',
                '-',
                [
                    'get',
                    'station_codes'
                ]
            ]
        ],
        type: 'symbol',
        minzoom: 10,
        maxzoom: 13,
        layout: {
            'symbol-avoid-edges': true,
            'text-field': [
                'get',
                'name'
            ],
            'text-size': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                10,
                10,
                13,
                12
            ],
            'text-font': [
                'DIN Pro Medium',
                'Arial Unicode MS Regular'
            ],
            'text-variable-anchor': [
                'left',
                'right'
            ],
            'text-radial-offset': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                10,
                [
                    '*',
                    0.25,
                    [
                        'get',
                        'network_count'
                    ]
                ],
                13,
                [
                    '*',
                    0.5,
                    [
                        'get',
                        'network_count'
                    ]
                ]
            ],
            'text-max-width': 20,
            'text-optional': true
        },
        paint: {
            'text-color': 'rgba(0,0,0,.5)',
            'text-halo-color': 'rgba(255,255,255,.5)',
            'text-halo-width': 1,
            'text-halo-blur': 1
        }
    });
    $10efe41c7f1c1349$var$map.addLayer({
        id: 'stations-label-non-en',
        source: 'rail',
        filter: [
            '==',
            [
                'get',
                'stop_type'
            ],
            'station'
        ],
        type: 'symbol',
        minzoom: 13,
        layout: {
            'text-field': [
                'format',
                [
                    'get',
                    'name_zh-Hans'
                ],
                {},
                '\n',
                {},
                [
                    'get',
                    'name_ta'
                ],
                {
                }
            ],
            'text-size': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                13,
                12,
                16,
                16
            ],
            'text-font': [
                'DIN Pro Medium',
                'Arial Unicode MS Regular'
            ],
            'text-anchor': 'top',
            'text-offset': [
                0,
                0.8
            ],
            'text-max-width': 20,
            'text-optional': true
        },
        paint: {
            'text-halo-color': '#fff',
            'text-halo-width': 2,
            'text-halo-blur': 1
        }
    });
    $10efe41c7f1c1349$var$map.addLayer({
        id: 'stations-label',
        source: 'rail',
        filter: [
            '==',
            [
                'get',
                'stop_type'
            ],
            'station'
        ],
        type: 'symbol',
        minzoom: 13,
        layout: {
            'text-field': [
                'get',
                'name'
            ],
            'text-size': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                13,
                12,
                16,
                16
            ],
            'text-font': [
                'DIN Pro Medium',
                'Arial Unicode MS Regular'
            ],
            'text-anchor': 'bottom',
            'text-offset': [
                0,
                -0.8
            ],
            'text-max-width': 20,
            // 'text-allow-overlap': true,
            'icon-image': [
                'get',
                'station_codes'
            ],
            'icon-size': [
                'interpolate',
                [
                    'linear'
                ],
                [
                    'zoom'
                ],
                13,
                0.3,
                15,
                0.5
            ],
            'icon-ignore-placement': true,
            'icon-allow-overlap': true
        },
        paint: {
            'text-halo-color': '#fff',
            'text-halo-width': 2,
            'text-halo-blur': 1
        }
    });
    // STATION BUILDINGS
    $10efe41c7f1c1349$var$map.addLayer({
        id: 'buildings-underground',
        source: 'rail',
        filter: [
            'all',
            [
                '==',
                [
                    'get',
                    'type'
                ],
                'subway'
            ],
            [
                '==',
                [
                    'get',
                    'underground'
                ],
                true
            ]
        ],
        type: 'fill',
        minzoom: 14,
        paint: {
            'fill-antialias': false,
            'fill-color': 'hsla(6, 63%, 60%, 0.3)',
            'fill-outline-color': '#d96659'
        }
    }, 'building-extrusion');
    $10efe41c7f1c1349$var$map.addLayer({
        id: 'buildings-aboveground',
        source: 'rail',
        filter: [
            'all',
            [
                '==',
                [
                    'get',
                    'type'
                ],
                'subway'
            ],
            [
                '==',
                [
                    'get',
                    'underground'
                ],
                false
            ]
        ],
        type: 'fill-extrusion',
        minzoom: 14,
        paint: {
            'fill-extrusion-color': '#d96659',
            'fill-extrusion-height': 20,
            'fill-extrusion-opacity': 0.3
        }
    }, 'building-extrusion');
    // const handleSource = (e) => {
    //   if (e.sourceId !== 'rail' || e.sourceDataType === 'metadata') return;
    //   map.off('sourcedata', handleSource);
    //   const lineFeatures = map.querySourceFeatures('rail', {
    //     filter: ['==', ['geometry-type'], 'LineString'],
    //   });
    //   const linesBounds = {};
    //   lineFeatures.forEach((l) => {
    //     const {
    //       properties: { name },
    //       geometry: { type, coordinates },
    //     } = l;
    //     if (!linesBounds[name]) linesBounds[name] = new mapboxgl.LngLatBounds();
    //     coordinates.flat(type === 'LineString' ? 0 : 1).forEach((c) => {
    //       linesBounds[name].extend(c);
    //     });
    //   });
    //   console.log(lineFeatures, linesBounds);
    // };
    // map.on('sourcedata', handleSource);
    $10efe41c7f1c1349$var$map.on('click', 'stations-label', (e)=>{
        location.hash = `stations/${e.features[0].properties.name}`;
    // stationView.mount(e.features[0]);
    });
    // Handle onhashchange
    const onHashChange = ()=>{
        // hash looks like this "stations/[NAME]", get the NAME, find it in the geojson and show it
        const name = decodeURIComponent(location.hash.split('/')[1] || '');
        const stationData = name && data.features.find((f)=>{
            const { name: fName, station_codes: station_codes } = f.properties;
            const hasName = (fName || '').toLowerCase() === name.toLowerCase();
            if (hasName) return true;
            // Also works if "stations/[CODE]" e.g. "stations/NS1"
            const codes = station_codes.split('-');
            // Array.includes but case-insensitive
            return codes.some((c)=>c.toLowerCase() === name.toLowerCase());
        });
        if (stationData) $10efe41c7f1c1349$var$stationView.mount(stationData);
        else $10efe41c7f1c1349$var$stationView.unmount();
    };
    window.addEventListener('hashchange', onHashChange);
    requestAnimationFrame(onHashChange);
    document.querySelector('.sheet-close').onclick = (e)=>{
        e.preventDefault();
        location.hash = '';
    // stationView.unmount();
    };
    $10efe41c7f1c1349$var$map.on('movestart', (e)=>{
        if (!e.originalEvent) return; // Not initiated by humans
        if (!$10efe41c7f1c1349$var$currentStation) return;
        $10efe41c7f1c1349$var$$station.classList.add('min');
    });
    $10efe41c7f1c1349$var$$station.onclick = (e)=>{
        if ($10efe41c7f1c1349$var$$station.classList.contains('min')) {
            e.preventDefault();
            e.stopPropagation();
            $10efe41c7f1c1349$var$$station.classList.remove('min');
        }
    };
    $10efe41c7f1c1349$var$map.on('mouseenter', 'stations-label', ()=>{
        $10efe41c7f1c1349$var$mapCanvas.style.cursor = 'pointer';
    });
    $10efe41c7f1c1349$var$map.on('mouseleave', 'stations-label', ()=>{
        $10efe41c7f1c1349$var$mapCanvas.style.cursor = '';
    });
    setTimeout(()=>{
        $10efe41c7f1c1349$var$map.loadImage((parcelRequire("hPrdo")), (e, img)=>{
            $10efe41c7f1c1349$var$map.addImage('exit', img);
        });
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d', {
            willReadFrequently: true
        });
        $10efe41c7f1c1349$var$map.loadImage((parcelRequire("LhvME")), (e, img)=>{
            if (!img) return;
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            (0, (/*@__PURE__*/$parcel$interopDefault($b239a1ddeb05fb73$exports))).forEach((s)=>{
                const [code, ...args] = s;
                const imageData = ctx.getImageData(...args);
                $10efe41c7f1c1349$var$map.addImage(code, imageData);
            });
        });
        $10efe41c7f1c1349$var$stationsData = data.features.filter((f)=>{
            return f.properties.stop_type === 'station';
        });
        $10efe41c7f1c1349$var$fuse = new (0, $a986e50c62b713b0$export$2e2bcd8739ae039)($10efe41c7f1c1349$var$stationsData, {
            distance: 5,
            includeMatches: true,
            keys: [
                'properties.name',
                'properties.name_zh-Hans',
                'properties.name_ta',
                {
                    name: 'station_codes',
                    getFn: (obj)=>{
                        return obj.properties.station_codes.split('-');
                    },
                    weight: 0.5
                }
            ]
        });
        $10efe41c7f1c1349$var$map.addSource('walks', {
            type: 'geojson',
            data: (parcelRequire("kLkjS")),
            buffer: 0
        });
        $10efe41c7f1c1349$var$map.addLayer({
            id: 'walks-case',
            source: 'walks',
            filter: [
                '==',
                [
                    'geometry-type'
                ],
                'LineString'
            ],
            type: 'line',
            minzoom: 14,
            layout: {
                'line-cap': 'round',
                'line-join': 'round'
            },
            paint: {
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    15,
                    3,
                    22,
                    15
                ],
                'line-color': 'rgba(255, 255, 255, .75)'
            }
        }, 'building-extrusion');
        $10efe41c7f1c1349$var$map.addLayer({
            id: 'walks',
            source: 'walks',
            filter: [
                '==',
                [
                    'geometry-type'
                ],
                'LineString'
            ],
            type: 'line',
            minzoom: 14,
            layout: {
                'line-cap': 'round',
                'line-join': 'round'
            },
            paint: {
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    15,
                    1,
                    22,
                    5
                ],
                'line-color': 'skyblue',
                'line-dasharray': [
                    0.5,
                    2
                ]
            }
        }, 'building-extrusion');
        $10efe41c7f1c1349$var$map.addLayer({
            id: 'walks-label',
            source: 'walks',
            filter: [
                '==',
                [
                    'geometry-type'
                ],
                'Point'
            ],
            type: 'symbol',
            minzoom: 15.5,
            layout: {
                'text-field': [
                    'concat',
                    [
                        'get',
                        'duration_min'
                    ],
                    ' mins'
                ],
                'text-font': [
                    'DIN Pro Medium',
                    'Arial Unicode MS Regular'
                ],
                'text-size': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    15,
                    12,
                    22,
                    16
                ],
                'text-anchor': 'top',
                'text-offset': [
                    0,
                    0.8
                ],
                'icon-image': 'walk',
                'icon-size': 0.5
            },
            paint: {
                'text-color': 'dodgerblue',
                'text-halo-color': 'rgba(255,255,255,.75)',
                'text-halo-width': 2,
                'icon-halo-color': 'rgba(255,255,255,.75)',
                'icon-halo-width': 2
            }
        }, 'exits-label');
        $10efe41c7f1c1349$var$map.on('mouseenter', 'walks-label', ()=>{
            $10efe41c7f1c1349$var$mapCanvas.style.cursor = 'pointer';
        });
        $10efe41c7f1c1349$var$map.on('mouseleave', 'walks-label', ()=>{
            $10efe41c7f1c1349$var$mapCanvas.style.cursor = '';
        });
        $10efe41c7f1c1349$var$map.on('click', 'walks-label', (e)=>{
            const f = e.features[0];
            const { duration_min: duration_min, station_codes_1: station_codes_1, station_codes_2: station_codes_2, exit_name_1: exit_name_1, exit_name_2: exit_name_2 } = f.properties;
            const station1 = $10efe41c7f1c1349$var$stationsData.find((d)=>d.properties.station_codes === station_codes_1);
            const station2 = $10efe41c7f1c1349$var$stationsData.find((d)=>d.properties.station_codes === station_codes_2);
            alert(`${duration_min}-min walk between ${station1.properties.name} (Exit ${exit_name_1}) and ${station2.properties.name} (Exit ${exit_name_2})`);
        });
        $10efe41c7f1c1349$var$map.loadImage((parcelRequire("kAdE5")), (e, img)=>{
            $10efe41c7f1c1349$var$map.addImage('walk', img);
        });
    }, 300);
    let markers = [];
    $10efe41c7f1c1349$var$map.on('zoomend', ()=>{
        const zoom = $10efe41c7f1c1349$var$map.getZoom();
        const large = zoom >= 12;
        const larger = zoom >= 15;
        markers.forEach((m)=>{
            m.getElement().classList.toggle('large', large);
            m.getElement().classList.toggle('larger', larger);
            m.getElement().style.cursor = zoom >= 13 ? 'pointer' : '';
        });
    });
    const renderCrowd = ()=>{
        markers.forEach((m)=>{
            m.remove();
        });
        fetch('https://sg-rail-crowd.cheeaun.workers.dev/').then((res)=>res.json()).then((results)=>{
            const zoom = $10efe41c7f1c1349$var$map.getZoom();
            const large = zoom >= 12;
            const larger = zoom >= 15;
            const crowdedData = [];
            results.data.forEach((r)=>{
                const { station: station, crowdLevel: crowdLevel } = r;
                if (!crowdLevel || crowdLevel !== 'h' && crowdLevel !== 'm') return;
                const f = data.features.find((f)=>f.properties.station_codes.split('-').includes(station));
                if (!f) return;
                crowdedData.push(r);
                // const markerCrowdLabel = Math.random() < 0.5 ? 'h' : 'm';
                const markerCrowdLabel = crowdLevel;
                const el = document.createElement('div');
                const width = 50;
                const height = 50;
                el.className = `crowd-marker crowd-marker-${markerCrowdLabel} ${large ? 'large' : ''} ${larger ? 'larger' : ''}`;
                el.style.width = `${width}px`;
                el.style.height = `${height}px`;
                // Add markers to the map.
                const marker = new (0, (/*@__PURE__*/$parcel$interopDefault($512f0610cec951ce$exports))).Marker(el).setLngLat(f.geometry.coordinates).addTo($10efe41c7f1c1349$var$map);
                markers.push(marker);
            });
            if (crowdedData.length) {
                const startTime = $10efe41c7f1c1349$var$formatTime(crowdedData[0].startTime);
                const endTime = $10efe41c7f1c1349$var$formatTime(crowdedData[0].endTime);
                console.log({
                    startTime: startTime,
                    endTime: endTime
                });
                console.table(crowdedData.map((d)=>({
                        station: d.station,
                        crowdLevel: d.crowdLevel
                    })));
            }
            if (results.data.length) $10efe41c7f1c1349$var$$crowdedTiming.innerHTML = `Crowded time interval: <b>${$10efe41c7f1c1349$var$formatTime(results.data[0].startTime)} - ${$10efe41c7f1c1349$var$formatTime(results.data[0].endTime, true)}</b>`;
            else $10efe41c7f1c1349$var$$crowdedTiming.innerHTML = 'Crowded time interval: N/A';
        }).catch((e)=>{
            $10efe41c7f1c1349$var$$crowdedTiming.innerHTML = 'Crowded time interval: N/A';
        }).finally(()=>{
            setTimeout(()=>{
                requestAnimationFrame(renderCrowd);
            }, 60000); // 1 minute
        });
    };
    renderCrowd();
})();
class $10efe41c7f1c1349$var$SearchControl {
    onAdd(map) {
        this._map = map;
        const container = document.createElement('div');
        container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        container.innerHTML = `
      <button class="mapboxgl-ctrl-emoji" type="button">
        <span>\u{1F50D}</span>
      </button>
    `;
        container.querySelector('button').onclick = this.options.onClick;
        this._container = container;
        return this._container;
    }
    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
    constructor(options){
        (0, $8903e050be105bd4$export$71511d61b312f219)(this, "options", {
            onClick: ()=>{}
        });
        Object.assign(this.options, options);
    }
}
function $10efe41c7f1c1349$var$focusSearchField() {
    $10efe41c7f1c1349$var$$search.hidden = false;
    $10efe41c7f1c1349$var$$searchField.focus();
    setTimeout(()=>{
        $10efe41c7f1c1349$var$$searchField.focus();
    }, 1500);
}
$10efe41c7f1c1349$var$map.addControl(new $10efe41c7f1c1349$var$SearchControl({
    onClick: $10efe41c7f1c1349$var$focusSearchField
}), 'bottom-right');
document.onkeydown = (e)=>{
    if (/(input|textarea|select)/i.test(e.target.tagName)) return;
    if (e.code.toLowerCase() === 'slash' || e.key === '/' || e.keyCode === 191 || e.which === 191) {
        e.preventDefault();
        $10efe41c7f1c1349$var$focusSearchField();
    }
};
$10efe41c7f1c1349$var$$searchField.oninput = ()=>{
    if (!$10efe41c7f1c1349$var$fuse) return;
    const value = $10efe41c7f1c1349$var$$searchField.value.trim();
    const results = $10efe41c7f1c1349$var$fuse.search(value);
    $10efe41c7f1c1349$var$$searchResults.innerHTML = results.slice(0, 10).map((r)=>{
        const { item: { properties: properties }, matches: matches } = r;
        const firstNameMatch = matches.find((m)=>/name/i.test(m.key));
        const { name: stationName, station_codes: station_codes, station_colors: station_colors } = properties;
        const name = properties[firstNameMatch ? firstNameMatch.key.replace(/.+\./, '') : 'name'];
        const html = `<li data-codes="${station_codes}" tabindex="-1">
      <a href="#stations/${stationName}">
        <span class="pill mini">
          ${station_codes.split('-').map((c, i)=>`<span class="${station_colors.split('-')[i]}">${c.replace(/^([a-z]+)/i, '$1 ')}</span>`).join('')}
        </span>
        ${name}
      </a>
    </li>`;
        return html;
    }).join('');
};
$10efe41c7f1c1349$var$$searchField.onkeydown = (e)=>{
    // Enter
    if (e.code.toLowerCase() === 'enter' || e.keyCode === 13 || e.which === 13) {
        var _$searchResults_querySelector;
        $10efe41c7f1c1349$var$$searchField.blur();
        (_$searchResults_querySelector = $10efe41c7f1c1349$var$$searchResults.querySelector('a')) === null || _$searchResults_querySelector === void 0 ? void 0 : _$searchResults_querySelector.click();
    }
};
$10efe41c7f1c1349$var$$searchCancel.onclick = ()=>{
    $10efe41c7f1c1349$var$$search.hidden = true;
    $10efe41c7f1c1349$var$$searchField.value = '';
};
$10efe41c7f1c1349$var$$searchResults.onclick = (e)=>{
    // const { target } = e;
    // if (target.tagName.toLowerCase() !== 'li') return;
    // const { codes } = target.dataset;
    // const feature = stationsData.find(
    //   (d) => d.properties.station_codes === codes,
    // );
    // stationView.mount(feature);
    $10efe41c7f1c1349$var$$search.hidden = true;
    $10efe41c7f1c1349$var$$searchField.value = '';
    document.body.scrollTo(0, 0);
};
var $8352b50ae41812f6$exports = {};
$8352b50ae41812f6$exports = $parcel$resolve("hmE4i");


if ('serviceWorker' in navigator) window.addEventListener('load', function() {
    navigator.serviceWorker.register($8352b50ae41812f6$exports);
});
$10efe41c7f1c1349$var$map.addControl(new (0, (/*@__PURE__*/$parcel$interopDefault($512f0610cec951ce$exports))).NavigationControl({
    showZoom: false,
    visualizePitch: true
}), 'bottom-right');


//# sourceMappingURL=railrouter-sg.febf9706.js.map
